import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
};

export type AiInvoicePrediction = {
  __typename?: 'AIInvoicePrediction';
  /** Job Task Descriptions */
  jobTaskDescriptions: Array<Scalars['String']['output']>;
  /** Job Task Descriptions */
  lineSuggestions: Array<DraftInvoiceLine>;
};

export type AiInvoicePredictionInputType = {
  /** Cause from case agreements */
  caseAgreementCause: Scalars['String']['input'];
  /** Further Action from case agreement */
  caseAgreementFurtherAction: Scalars['String']['input'];
  /** Other from case agreement */
  caseAgreementOther: Scalars['String']['input'];
  /** Scope from case agreement */
  caseAgreementScope: Scalars['String']['input'];
  /** Work Completed from case agreement */
  caseAgreementWorkCompleted: Scalars['String']['input'];
  /** ERPno of case */
  caseErpNo: Scalars['String']['input'];
  /** Id of case */
  caseId: Scalars['String']['input'];
  /** Name of damage cause */
  damageCauseName: Scalars['String']['input'];
  /** Damage description */
  damageDescription: Scalars['String']['input'];
  /** Is there driven distance */
  distance: Scalars['Boolean']['input'];
  /** Comments from driving slips */
  drivingSlipComments: Scalars['String']['input'];
  /** ERPNo of invoice */
  invoiceERPNo: Scalars['String']['input'];
  /** Job Task descriptions and Id */
  invoiceLinesInfo: Array<InputMaybe<InvoiceLinesInfoInputType>>;
  /** Job Task descriptions on the invoice lines */
  invoiceLinesJobTaskDescription: Array<InputMaybe<Scalars['String']['input']>>;
  /** Profitability of the Invoice */
  profitability: Scalars['Float']['input'];
  /** Code of screening template */
  screeningTemplateCode: Scalars['String']['input'];
  /** Id of screening template */
  screeningTemplateId: Scalars['String']['input'];
  /** Name of screening template */
  screeningTemplateName: Scalars['String']['input'];
  /** Is it urgent */
  urgent: Scalars['Boolean']['input'];
};

export type Apv = {
  __typename?: 'APV';
  /** Id of associated category */
  damageCategory: DamageCategory;
  /** Id of associated cause */
  damageCause: DamageCause;
  /** Unique id of apv */
  id: Scalars['String']['output'];
  /** Url to file location */
  url: Scalars['String']['output'];
};

export type ApvInput = {
  /** Id of associated category */
  damageCategory: Scalars['String']['input'];
  /** Id of associated cause */
  damageCause: Scalars['String']['input'];
};

export type AdditionalDayInput = {
  /** Date of the additional day */
  date: Scalars['Date']['input'];
  /** Estimated hours for the additional day */
  estimate: Scalars['Decimal']['input'];
};

export type Address = {
  __typename?: 'Address';
  /** Address line */
  addressLine: Maybe<Scalars['String']['output']>;
  /** Optional alternative address line */
  addressLineAlt: Maybe<Scalars['String']['output']>;
  /** City */
  city: Scalars['String']['output'];
  /** Country */
  country: Scalars['String']['output'];
  /** Apartment floor and door */
  floor: Maybe<Scalars['String']['output']>;
  /** House number */
  houseNumber: Scalars['String']['output'];
  /** Postal code */
  postalCode: Scalars['String']['output'];
  /** Road name */
  road: Scalars['String']['output'];
};

export type AddressInput = {
  /** Address */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Alternative address line */
  addressLineAlt?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: Scalars['String']['input'];
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Apartment floor and door */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** House Number */
  houseNumber: Scalars['String']['input'];
  /** Postal code */
  postalCode: Scalars['String']['input'];
  /** Road name */
  road: Scalars['String']['input'];
};

export type AddressSimple = {
  __typename?: 'AddressSimple';
  /** Address line */
  addressLine: Maybe<Scalars['String']['output']>;
  /** Optional alternative address line */
  addressLineAlt: Maybe<Scalars['String']['output']>;
  /** City */
  city: Scalars['String']['output'];
  /** Country */
  country: Scalars['String']['output'];
  /** Postal code */
  postalCode: Scalars['String']['output'];
};

export type AirMeassurementDetails = {
  __typename?: 'AirMeassurementDetails';
  /** Relative humidity inside (percentage) */
  relativeHumidityInside: Scalars['Float']['output'];
  /** Relative humidity outside (percentage) */
  relativeHumidityOutside: Scalars['Float']['output'];
  /** Temperature inside (celcius) */
  temperatureInside: Scalars['Float']['output'];
  /** Temperature outside (celcius) */
  temperatureOutside: Scalars['Float']['output'];
  /** Water amount inside (g/m3) */
  waterAmountInside: Scalars['Float']['output'];
  /** Water amount outside (g/m3) */
  waterAmountOutside: Scalars['Float']['output'];
};

export type AirMeassurementDetailsInput = {
  /** Relative humidity inside (percentage) */
  relativeHumidityInside: Scalars['Float']['input'];
  /** Relative humidity outside (percentage) */
  relativeHumidityOutside: Scalars['Float']['input'];
  /** Temperature inside (celcius) */
  temperatureInside: Scalars['Float']['input'];
  /** Temperature outside (celcius) */
  temperatureOutside: Scalars['Float']['input'];
  /** Water amount inside (g/m3) */
  waterAmountInside: Scalars['Float']['input'];
  /** Water amount outside (g/m3) */
  waterAmountOutside: Scalars['Float']['input'];
};

export type Answer = {
  __typename?: 'Answer';
  /** Answer given */
  answer: Scalars['String']['output'];
  /** Id of question */
  question: Scalars['String']['output'];
  /** The question */
  title: Scalars['String']['output'];
};

export type AnswerInput = {
  /** Answer given */
  answer: Scalars['String']['input'];
  /** Id of question */
  question: Scalars['String']['input'];
};

export type Assesment = {
  __typename?: 'Assesment';
  /** The marked field in the table */
  color: AssesmentColor;
  /** id corresponding to the table number */
  comment: Scalars['String']['output'];
  /** Deviation noted in the specific assesment */
  deviation: Maybe<Deviation>;
  /** id corresponding to the table number */
  id: Scalars['Int']['output'];
};

export enum AssesmentColor {
  Green = 'GREEN',
  NonSelected = 'NON_SELECTED',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type AssesmentInput = {
  /** The marked field in the table */
  color: AssesmentColor;
  /** id corresponding to the table number */
  comment: Scalars['String']['input'];
  /** Deviation noted in the specific assesment */
  deviation?: InputMaybe<DeviationInput>;
  /** id corresponding to the table number */
  id: Scalars['Int']['input'];
};

export type Assortment = {
  __typename?: 'Assortment';
  /** description */
  description: Scalars['String']['output'];
  /** item no */
  no: Scalars['String']['output'];
  /** Type of assortment */
  type: Scalars['String']['output'];
  /** Base unit of messure */
  uom: Scalars['String']['output'];
};

export type BcSettings = {
  __typename?: 'BCSettings';
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** BC password */
  password: Scalars['String']['output'];
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
  /** BC username */
  username: Scalars['String']['output'];
};

export type BcSettingsInput = {
  /** BC password */
  password: Scalars['String']['input'];
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
  /** BC username */
  username: Scalars['String']['input'];
};

export type BoolKvp = {
  __typename?: 'BoolKVP';
  /** KVP key */
  key: Scalars['String']['output'];
  /** KVP value */
  value: Scalars['Boolean']['output'];
};

export type BoolWithComment = {
  __typename?: 'BoolWithComment';
  /** Value set comment */
  comment: Maybe<Scalars['String']['output']>;
  /** Timestamp of when value was last set */
  timestamp: Maybe<Scalars['DateTime']['output']>;
  /** Boolean value */
  value: Scalars['Boolean']['output'];
};

export type BoolWithCommentInput = {
  /** Called back comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Actual boolean value */
  value: Scalars['Boolean']['input'];
};

export type BusinessArea = {
  __typename?: 'BusinessArea';
  /** Id of business area */
  id: Scalars['String']['output'];
  /** Name of business area */
  name: Scalars['String']['output'];
};

export type BusinessAreaInputType = {
  /** Name of business area */
  name: Scalars['String']['input'];
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  /** Optional unique driving slip id */
  drivingSlip: Maybe<DrivingSlip>;
  /** Calendar event time range */
  isAllDay: Scalars['Boolean']['output'];
  /** Unique calendar reference id */
  referenceId: Scalars['String']['output'];
  /** Indicates if calendar event was created through 5C */
  systemCreatedEvent: Scalars['Boolean']['output'];
  /** Calendar event time range */
  timeRange: DateTimeRange;
  /** Calendar event title */
  title: Scalars['String']['output'];
  /** Type of calendar event */
  type: CalendarEventType;
};

export type CalendarEventInput = {
  /** Optional unique driving slip id */
  drivingSlip?: InputMaybe<Scalars['String']['input']>;
  /** Is all day event? */
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Calendar event time range */
  timeRange: DateTimeRangeInput;
  /** Calendar event title */
  title: Scalars['String']['input'];
  /** Type of calendar event */
  type: CalendarEventType;
};

export enum CalendarEventType {
  DrivingSlip = 'DRIVING_SLIP',
  Education = 'EDUCATION',
  OnCall = 'ON_CALL',
  SickLeave = 'SICK_LEAVE',
  Sleep = 'SLEEP',
  Unknown = 'UNKNOWN',
  Vacation = 'VACATION'
}

export type Car = {
  __typename?: 'Car';
  /** Department car is attached to */
  department: Maybe<Scalars['String']['output']>;
  /** Email of car */
  email: Scalars['String']['output'];
  /** Unique id of car */
  id: Scalars['String']['output'];
  /** Name of car */
  name: Scalars['String']['output'];
};

export type CarCalendar = {
  __typename?: 'CarCalendar';
  /** Car */
  car: Car;
  /** Car calendar events */
  events: Array<CalendarEvent>;
};

export type Case = {
  __typename?: 'Case';
  /** Status of active  (always empty if user lacks permissions) */
  activeInvoiceStatus: Maybe<InvoiceStatus>;
  /** Active movables on case */
  activeMovables: Scalars['Boolean']['output'];
  /** Open purchase documents on case */
  activePurchaseDocuments: Scalars['Boolean']['output'];
  /** Active requisitions on case */
  activeRequisitions: Scalars['Boolean']['output'];
  /** Case advisor details */
  adviser: Maybe<CompanyContact>;
  /** Alternative contact */
  alternativeContact: Maybe<Person>;
  /** Area responsible manager attached to case */
  areaResponsible: Maybe<User>;
  arrived: Scalars['Boolean']['output'];
  arrivedDate: Maybe<Scalars['DateTime']['output']>;
  /** Case ready for billing */
  billingReady: Scalars['Boolean']['output'];
  /** List of case agreements */
  caseAgreements: Array<CaseAgreement>;
  caseAsbestosReports: Maybe<CaseAsbestosReports>;
  /** Default screening template on case */
  caseDefaultScreeningTemplate: Scalars['String']['output'];
  /** List of draft case items usage */
  caseDraftItemsUsage: Array<CaseDraftUsageLine>;
  caseEconomics: Maybe<CaseEconomicsOverview>;
  /** List of case emails */
  caseEmails: Array<CaseEmail>;
  /** List of case machine usages */
  caseMachineUsages: Array<CaseMachineUsage>;
  /** Case manager attached to case */
  caseManager: Maybe<User>;
  /** List of casemanager favorite entries */
  caseManagerFavorite: Maybe<CaseFavorite>;
  caseReports: Maybe<CaseReports>;
  /** Case change log */
  changes: Array<CaseChange>;
  /** Timestamp of when the case was created */
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp of when the case was created */
  createdAtDKString: Scalars['String']['output'];
  /** User who created the case */
  createdBy: Maybe<User>;
  dailyReportSent: Scalars['Boolean']['output'];
  /** Case damage details */
  damage: Damage;
  /** Case debitor details */
  debitor: Debitor;
  /** Indicates if there should be a delay in ScalePoint for the case */
  delayScalepoint: Maybe<Scalars['Boolean']['output']>;
  /** Distance from ssg location to damage address */
  distance: Maybe<Scalars['String']['output']>;
  /** List of document file names and thumbnails */
  documents: Array<EsdhFile>;
  /** The driving slips series associated with the case */
  drivingSlipSeries: Array<DrivingSlipSeries>;
  /** ERP reference id */
  erpId: Scalars['String']['output'];
  /** ERP reference no */
  erpNo: Scalars['String']['output'];
  fixedPriceOnCase: Scalars['Decimal']['output'];
  /** Unique id of case */
  id: Scalars['String']['output'];
  /** Important info on the case */
  importantInfo: Maybe<Scalars['String']['output']>;
  /** List of invoices related to case (always empty if user lacks permissions) */
  invoices: Array<DraftInvoice>;
  /** The tasks associated with the task */
  jobs: Maybe<Array<Job>>;
  /** Whether notifications regarding machines on the case should be sent */
  machineNotification: Maybe<Scalars['Boolean']['output']>;
  /** Bool indicating if case have active Machines */
  machineOnCase: Scalars['Boolean']['output'];
  /** Movables assiciated with the task */
  movables: Array<Movable>;
  openMovables: Scalars['Boolean']['output'];
  openTimeRegistrations: Scalars['Boolean']['output'];
  /** Case policy holder details */
  policyHolder: Contact;
  /** Indicates if there is a possibility of asbestos on the case */
  possibilityOfAsbestos: Maybe<Scalars['Boolean']['output']>;
  /** Project manager attached to case */
  projectManager: Maybe<User>;
  /** List of projectmanager favorite entries */
  projectManagerFavorite: Maybe<CaseFavorite>;
  /** Case referer details */
  referrer: Maybe<CompanyContact>;
  /** ReportSent */
  reportSent: Scalars['Boolean']['output'];
  /** Case requisitioner details */
  requisitioner: Requisitioner;
  /** Requisition of the case */
  requisitions: Array<Requisition>;
  /** Risk evaluation answers */
  riskEvaluationAnswers: Maybe<Array<RiskEvaluationAnswers>>;
  /** Optional comment for risk evaluation */
  riskEvaluationComment: Maybe<Scalars['String']['output']>;
  scalePointErrorMessage: Maybe<Scalars['String']['output']>;
  scalePointId: Maybe<Scalars['String']['output']>;
  scalePointMergeInfo: Maybe<ScalePointMergeInfo>;
  scalePointStatus: ScalePointStatus;
  scalePointUrl: Maybe<Scalars['String']['output']>;
  /** The screening of the case */
  screenings: Array<Screening>;
  /** Requisition from fire department */
  skafor: Scalars['Boolean']['output'];
  /** SSG department that is responsible for the case */
  ssgDepartment: Department;
  /** SSG location that is responsible for the case */
  ssgLocation: Location;
  /** Case status */
  status: CaseStatus;
  /** Whether time registration is allowed on the case */
  timeRegistration: Maybe<Scalars['Boolean']['output']>;
  /** Case track */
  track: Scalars['Int']['output'];
  /** Timestamp of when the case was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** List of user favorite entries */
  userFavorite: Maybe<CaseFavorite>;
  /** Case change version number */
  version: Scalars['Int']['output'];
  /** Case visitation details */
  visitation: Visitation;
  /** Case work complete */
  workComplete: Scalars['Boolean']['output'];
};


export type CaseCaseEconomicsArgs = {
  include: Scalars['Boolean']['input'];
};

export type CaseAgreement = {
  __typename?: 'CaseAgreement';
  /** Agreement category */
  category: CaseAgreementCategory;
  /** Agreement content */
  content: Scalars['String']['output'];
  /** Unique id of driving slip series */
  seriesId: Maybe<Scalars['String']['output']>;
  /** Whether case agreement should be sent to ScalePoint */
  shouldSaveInScalePoint: Scalars['Boolean']['output'];
  /** Timestamp of when agreement was created */
  timestamp: Scalars['DateTime']['output'];
  /** User who created agreement */
  user: User;
};

export enum CaseAgreementCategory {
  Cause = 'CAUSE',
  FurtherAction = 'FURTHER_ACTION',
  Other = 'OTHER',
  Private = 'PRIVATE',
  Scope = 'SCOPE',
  WorkCompleted = 'WORK_COMPLETED'
}

export type CaseAgreementInput = {
  /** Agreement category */
  category: CaseAgreementCategory;
  /** Agreement content */
  content: Scalars['String']['input'];
  /** Unique id of driving slip series */
  seriesId?: InputMaybe<Scalars['String']['input']>;
  /** Whether case agreement should be sent to ScalePoint */
  shouldSaveInScalePoint: Scalars['Boolean']['input'];
};

export type CaseAgreementMigrationInput = {
  /** Agreement category */
  category: CaseAgreementCategory;
  /** Agreement content */
  content: Scalars['String']['input'];
  /** Unique id of driving slip series */
  seriesId?: InputMaybe<Scalars['String']['input']>;
  /** Whether case agreement should be sent to ScalePoint */
  shouldSaveInScalePoint: Scalars['Boolean']['input'];
  /** Timestamp of when agreement was created */
  timestamp: Scalars['DateTime']['input'];
  /** User who created agreement */
  user: Scalars['String']['input'];
};

export type CaseAsbestosReports = {
  __typename?: 'CaseAsbestosReports';
  /** Report on the case organization. Required when handling dangerous materials such as asbestos. */
  caseOrganizationFormData: Maybe<CaseOrganizationFormData>;
  /** Deviation report form data populated by the user. */
  deviationReportFormData: Maybe<DeviationReportFormData>;
  /** End evaluation report used to evaluation how the asbestos case was handled. */
  endevaluationReportFormData: Maybe<EndevaluationReportFormData>;
  /** Inspection report form data populated by the user. */
  inspectionAssesmentFormData: Maybe<InspectionAssesmentFormData>;
  /** Report stating details about the waste generated. */
  noticeOfConstructionWasteFormData: Maybe<NoticeOfConstructionwasteFormData>;
};

export type CaseChange = {
  __typename?: 'CaseChange';
  /** Value after */
  after: CaseChangeDifference;
  /** Value before */
  before: CaseChangeDifference;
  /** Time of change */
  timestamp: Scalars['DateTime']['output'];
  /** User who performed the change */
  user: Maybe<User>;
};

export type CaseChangeDifference = {
  __typename?: 'CaseChangeDifference';
  /** Alternative contact person */
  alternativeContact: Maybe<Person>;
  /** Area responsible manager attached to case */
  areaResponsible: Maybe<User>;
  /** If case billing ready */
  billingReady: Maybe<Scalars['Boolean']['output']>;
  /** List of case emails */
  caseEmails: Maybe<Array<CaseEmail>>;
  /** List of case machine usages */
  caseMachineUsages: Maybe<Array<CaseMachineUsage>>;
  /** Case manager attached to case */
  caseManager: Maybe<User>;
  /** Case damage details */
  damage: Maybe<Damage>;
  /** Case debitor details */
  debitor: Maybe<Debitor>;
  /** The driving slip changed on case */
  drivingSlips: Maybe<DrivingSlip>;
  /** Name of files */
  fileNames: Maybe<Scalars['String']['output']>;
  /** Important info on case */
  importantInfo: Maybe<Scalars['String']['output']>;
  /** Case policy holder details */
  policyHolder: Maybe<Contact>;
  /** Project manager attached to case */
  projectManager: Maybe<User>;
  /** Case report sent status */
  reportSent: Maybe<Scalars['Boolean']['output']>;
  /** Case requisitioner details */
  requisitioner: Maybe<Requisitioner>;
  /** Risk evaluation answers */
  riskEvaluationAnswers: Maybe<Array<RiskEvaluationAnswers>>;
  /** ScalePoint Id */
  scalePointId: Maybe<Scalars['String']['output']>;
  /** ScalePoint Merge Info */
  scalePointMergeInfo: Maybe<ScalePointMergeInfo>;
  /** ScalePoint Number */
  scalePointNumber: Maybe<Scalars['String']['output']>;
  /** ScalePoint Status */
  scalePointStatus: Maybe<ScalePointStatus>;
  /** ScalePoint Url */
  scalePointUrl: Maybe<Scalars['String']['output']>;
  /** Requisition from fire department */
  skafor: Maybe<Scalars['Boolean']['output']>;
  /** SSG department that is responsible for the case */
  ssgDepartment: Maybe<Department>;
  /** SSG location that is responsible for the case */
  ssgLocation: Maybe<Location>;
  /** Case status */
  status: Maybe<CaseStatus>;
  /** Case track */
  track: Maybe<Scalars['Int']['output']>;
  /** Case visitation details */
  visitation: Maybe<Visitation>;
  /** Case work complete status */
  workComplete: Maybe<Scalars['Boolean']['output']>;
};

export type CaseDraftUsageLine = {
  __typename?: 'CaseDraftUsageLine';
  /** Date of posting */
  date: Scalars['Date']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** ERP system reference id */
  erpId: Scalars['String']['output'];
  /** ERP system reference key */
  erpKey: Scalars['String']['output'];
  /** item category code */
  itemCategoryCode: Scalars['String']['output'];
  /** Posted By Username */
  postedBy: Scalars['String']['output'];
  /** Usage line quantity */
  quantity: Scalars['Decimal']['output'];
  /** Usage line title */
  title: Scalars['String']['output'];
  /** Usage line type */
  type: Maybe<UsageLineType>;
  /** item unit of measure */
  unitOfMeasureCode: Scalars['String']['output'];
};

export type CaseEconomicSpecType = {
  __typename?: 'CaseEconomicSpecType';
  /** hours Cost */
  cost: Array<CaseEconomicsSpecKvt>;
  /** Hours posted sales */
  sale: Array<CaseEconomicsSpecKvt>;
};

export type CaseEconomicsOverview = {
  __typename?: 'CaseEconomicsOverview';
  /** Cost estimate */
  costEstimate: Scalars['Decimal']['output'];
  /** costTotal */
  costTotal: Scalars['Decimal']['output'];
  /** coverageRatio */
  coverageRatio: Scalars['Decimal']['output'];
  /** deltaNotInvoiced */
  deltaNotInvoiced: Scalars['Decimal']['output'];
  /** Hours available on case */
  getHoursAvailable: Scalars['Decimal']['output'];
  /** Get hours used on case */
  getHoursUsed: Scalars['Decimal']['output'];
  /** invoicedTotal */
  invoicedTotal: Scalars['Decimal']['output'];
  /** JobNo */
  jobNo: Scalars['String']['output'];
  /** percentageOfCompletion */
  percentageOfCompletion: Scalars['Decimal']['output'];
  /** profit */
  profit: Scalars['Decimal']['output'];
  /** quote */
  quote: Scalars['Decimal']['output'];
  /** salesTotal */
  salesTotal: Scalars['Decimal']['output'];
  /** screening */
  screening: Scalars['Decimal']['output'];
  /** totalContractAmountLCY */
  totalContractAmountLCY: Scalars['Decimal']['output'];
  /** SSG Price / WIP Limit */
  wipLimit: Scalars['Decimal']['output'];
};

export type CaseEconomicsSpecKvt = {
  __typename?: 'CaseEconomicsSpecKVT';
  /** name of keyvaluepair */
  name: Scalars['String']['output'];
  /** Case economics value object */
  value: Scalars['Decimal']['output'];
};

export type CaseEmail = {
  __typename?: 'CaseEmail';
  /** List of email attachments */
  attachments: Array<Scalars['String']['output']>;
  /** Email content */
  content: Scalars['String']['output'];
  /** List of email receivers */
  receivers: Array<Scalars['String']['output']>;
  /** Timestamp of when email was created */
  timestamp: Scalars['DateTime']['output'];
};

export type CaseFavorite = {
  __typename?: 'CaseFavorite';
  /** Favorite active status */
  active: Scalars['Boolean']['output'];
  /** Color code set by user */
  color: Maybe<Scalars['String']['output']>;
  /** Unique user id */
  user: Scalars['String']['output'];
};

export type CaseInput = {
  /** Case advisor details */
  adviser?: InputMaybe<CompanyContactInput>;
  /** Alternative Contact */
  alternativeContact?: InputMaybe<PersonInput>;
  /** Area responsible manager attached to case */
  areaResponsible?: InputMaybe<Scalars['String']['input']>;
  /** Case manager attached to case */
  caseManager?: InputMaybe<Scalars['String']['input']>;
  /** Case damage details */
  damage: DamageInput;
  /** Case debitor details */
  debitor: DebitorInput;
  /** Indicates if there should be a delay in ScalePoint for the case */
  delayScalepoint?: InputMaybe<Scalars['Boolean']['input']>;
  /** Important info on case */
  importantInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether notifications regarding machines on the case should be sent */
  machineNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case policy holder details */
  policyHolder: ContactInput;
  /** Indicates if there is a possibility of asbestos on the case */
  possibilityOfAsbestos?: InputMaybe<Scalars['Boolean']['input']>;
  /** Project manager attached to case */
  projectManager?: InputMaybe<Scalars['String']['input']>;
  /** Case referrer details */
  referrer?: InputMaybe<CompanyContactInput>;
  /** Report sent */
  reportSent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case requisitioner details */
  requisitioner: RequisitionerInput;
  /** Risk evaluation answers */
  riskEvaluationAnswers?: InputMaybe<Array<RiskEvaluationAnswerInput>>;
  /** Optional comment for risk evaluation */
  riskEvaluationComment?: InputMaybe<Scalars['String']['input']>;
  /** Requisition from fire department */
  skafor: Scalars['Boolean']['input'];
  /** SSG department that is responsible for the case */
  ssgDepartment: Scalars['String']['input'];
  /** SSG location that is responsible for the case */
  ssgLocation: Scalars['String']['input'];
  /** Whether time registration is allowed on the case */
  timeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case track */
  track?: InputMaybe<Scalars['Int']['input']>;
  /** Case visitation details */
  visitation: VisitationInput;
};

export type CaseInvoiceApprovalInfo = {
  __typename?: 'CaseInvoiceApprovalInfo';
  /** Case object */
  case: Case;
  /** Invoice that should be approved or rejected by manager */
  invoiceToApprove: DraftInvoice;
};

export type CaseMachineNotificaton = {
  __typename?: 'CaseMachineNotificaton';
  /** Case object */
  case: Case;
  /** The days limit causing notification */
  days: Scalars['Int']['output'];
  /** Is it last warning? */
  lastWarning: Scalars['Boolean']['output'];
  /** Machine to notify */
  machines: Array<Machine>;
};

export type CaseMachineUsage = {
  __typename?: 'CaseMachineUsage';
  /** Meter reading at end time */
  endMeterReading: Maybe<Scalars['Decimal']['output']>;
  /** End time */
  endTime: Maybe<Scalars['DateTime']['output']>;
  /** Machine identifier */
  machine: Scalars['String']['output'];
  /** Meter reading at start time */
  startMeterReading: Scalars['Decimal']['output'];
  /** Start time */
  startTime: Scalars['DateTime']['output'];
};

export type CaseMigration = {
  arrived?: InputMaybe<Scalars['Boolean']['input']>;
  arrivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt: Scalars['DateTime']['input'];
  createdBy: Scalars['String']['input'];
  erpNo: Scalars['String']['input'];
};

export type CaseOrganizationFormData = {
  __typename?: 'CaseOrganizationFormData';
  /** list of all the workers in the case organization */
  caseOrganizationWorkers: Maybe<Array<Maybe<CaseOrganizationWorker>>>;
};

export type CaseOrganizationFormDataInput = {
  /** list of all the workers in the case organization */
  caseOrganizationWorkers?: InputMaybe<Array<InputMaybe<CaseOrganizationWorkerInput>>>;
};

export type CaseOrganizationWorker = {
  __typename?: 'CaseOrganizationWorker';
  /** date of recieving the necessary instructions */
  date: Maybe<Scalars['Date']['output']>;
  /** Index determines the ordering of the table */
  index: Scalars['Int']['output'];
  /** Name of the instructor that gave the onsite instructions */
  instructor: Scalars['String']['output'];
  /** name of the worker */
  name: Scalars['String']['output'];
  /** phone number of the worker */
  phonenumber: Scalars['String']['output'];
  /** signature of the person that made the report */
  signature: Maybe<Signature>;
  /** Job title of the worker in this case organization */
  title: Scalars['String']['output'];
};

export type CaseOrganizationWorkerInput = {
  /** date of recieving the necessary instructions */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Index determines the ordering of the table */
  index: Scalars['Int']['input'];
  /** Name of the instructor that gave the onsite instructions */
  instructor: Scalars['String']['input'];
  /** name of the worker */
  name: Scalars['String']['input'];
  /** phone number of the worker */
  phonenumber: Scalars['String']['input'];
  /** signature of the person that made the report */
  signature?: InputMaybe<SignatureInputType>;
  /** Job title of the worker in this case organization */
  title: Scalars['String']['input'];
};

export enum CasePriority {
  LossOfBusinessEarningCapacity = 'LOSS_OF_BUSINESS_EARNING_CAPACITY',
  ResidentialArea = 'RESIDENTIAL_AREA',
  SocialImpact = 'SOCIAL_IMPACT'
}

export type CaseReports = {
  __typename?: 'CaseReports';
  /** Indooor climate report form data populated by the user */
  indoorClimateReportFormData: Maybe<IndoorClimateReportFormData>;
  /** Inspection report form data populated by the user */
  inspectionMovablesReportFormData: Maybe<InspectionReportFormData>;
  /** Inspection report form data populated by the user */
  inspectionReportFormData: Maybe<InspectionReportFormData>;
  /** Moisture report form data populated by the user */
  moistureReportFormData: Maybe<MoistureReportFormData>;
  /** Moisture TRYG report form data populated by the user */
  moistureTrygReportFormData: Maybe<MoistureTrygReportFormData>;
};

export enum CaseStatus {
  AppliedClosed = 'APPLIED_CLOSED',
  Closed = 'CLOSED',
  Open = 'OPEN',
  Null = '_NULL_'
}

export type CaseUsage = {
  __typename?: 'CaseUsage';
  /** Case driving usage */
  driving: Array<CaseUsageLine>;
  /** Case items usage */
  items: Array<CaseUsageLine>;
  /** Case machines usage */
  machines: Array<CaseUsageLine>;
  /** Case movables usage */
  movables: Array<CaseUsageLine>;
  /** Case person/time usage */
  persons: Array<CaseUsageLine>;
  /** Case subcontracts usage */
  subcontracts: Array<CaseUsageLine>;
  /** Case substitute usage */
  substitute: Array<CaseUsageLine>;
  /** Case trash usage */
  trash: Array<CaseUsageLine>;
  /** Case vehicle expenses usage */
  vehicleExpenses: Array<CaseUsageLine>;
};

export type CaseUsageLine = {
  __typename?: 'CaseUsageLine';
  /** Usage line attachments */
  attachments: Array<Scalars['String']['output']>;
  /** ERP system reference id */
  erpId: Scalars['String']['output'];
  /** ERP system reference key */
  erpKey: Scalars['String']['output'];
  /** Usage line cost per unit */
  lineCost: Scalars['Decimal']['output'];
  /** Original date of posting */
  originalPostingDate: Scalars['String']['output'];
  /** Date of posting */
  postingDate: Scalars['String']['output'];
  /** Usage line quantity */
  quantity: Scalars['Decimal']['output'];
  /** Name of ressource */
  ressourceName: Scalars['String']['output'];
  /** Is substitute usage */
  substitute: Maybe<Scalars['Boolean']['output']>;
  /** Usage line title */
  title: Scalars['String']['output'];
  /** Usage line total cost */
  totalCost: Scalars['Decimal']['output'];
  /** Usage line unit */
  unit: Scalars['String']['output'];
  /** Is vehicle expense usage */
  vehicleExpense: Maybe<Scalars['Boolean']['output']>;
};

export type Catalog = {
  __typename?: 'Catalog';
  /** Addressse affiliated with catalog */
  addresses: Array<CatalogAddress>;
  /** Catalog changed by */
  changedBy: Scalars['String']['output'];
  /** Catalog Change log */
  changes: Array<CatalogChange>;
  /** Hours contact number can be reached */
  contactHours: Maybe<Scalars['String']['output']>;
  /** Contact number for the Catalog */
  contactNumber: Maybe<Scalars['String']['output']>;
  /** Contacs attached to catalog */
  contacts: Array<CatalogContact>;
  /** Craftsmen attached to catalog */
  craftsmen: Array<CatalogCraftsman>;
  /** Timestamp of when the catalog was created */
  createdAt: Scalars['DateTime']['output'];
  /** Customer */
  customer: CatalogCustomer;
  /** Catalog debitor details */
  debitor: Maybe<Debitor>;
  /** Is catalog debitor verified */
  debitorVerified: Scalars['Boolean']['output'];
  /** Description for catalog */
  description: Maybe<Scalars['String']['output']>;
  /** List of document file names and thumbnails */
  documents: Array<EsdhFile>;
  /** Unique id of catalog */
  id: Scalars['String']['output'];
  /** Property number for catalog */
  propertyNumber: Scalars['String']['output'];
  /** Is sms service used for Catalog */
  smsService: Scalars['Boolean']['output'];
  /** SGGAccountable for catalog */
  ssgAccountable: Maybe<Scalars['String']['output']>;
  /** Timed messages attached to catalog */
  timedMessages: Array<TimedMessage>;
  /** Timestamp of when the catalog was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Is catalog verified */
  verified: Scalars['Boolean']['output'];
  /** Version for catalog */
  version: Scalars['Int']['output'];
};

export type CatalogAddress = {
  __typename?: 'CatalogAddress';
  /** Address line */
  addressLine: Scalars['String']['output'];
  /** City for address */
  city: Scalars['String']['output'];
  /** Comment for address */
  comment: Scalars['String']['output'];
  /** End number for address number range */
  endNumber: Scalars['String']['output'];
  /** House numbers can be Both, Equal or Odd */
  houseNumbers: HouseNumbers;
  /** Start number for address number range */
  startNumber: Scalars['String']['output'];
  /** zipCode for address */
  zipCode: Scalars['String']['output'];
};

export type CatalogAddressInput = {
  /** Address line for catalog address */
  addressLine: Scalars['String']['input'];
  /** City for catalog address */
  city: Scalars['String']['input'];
  /** Comment for catalog address */
  comment: Scalars['String']['input'];
  /** End number for catalog address */
  endNumber: Scalars['String']['input'];
  /** House numbers for catalog address */
  houseNumbers: HouseNumbers;
  /** Start number for catalog address */
  startNumber: Scalars['String']['input'];
  /** Zip code for catalog address */
  zipCode: Scalars['String']['input'];
};

export type CatalogBatchInput = {
  /** Addresses for catalog */
  addresses?: InputMaybe<Array<CatalogAddressInput>>;
  /** Catalog changed by */
  changedBy: Scalars['String']['input'];
  /** Contact hours for contact number to be reached */
  contactHours?: InputMaybe<Scalars['String']['input']>;
  /** Contact number for catalog */
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  /** Customer for catalog */
  customer: Scalars['String']['input'];
  /** Debitor number for catalog */
  debitor?: InputMaybe<Scalars['String']['input']>;
  /** Is catalog debitor verified */
  debitorVerified: Scalars['Boolean']['input'];
  /** Description of catalog */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Unique id of catalog */
  id: Scalars['String']['input'];
  /** Property number for catalog */
  propertyNumber: Scalars['String']['input'];
  /** Is sms service enabled for catalog */
  smsService: Scalars['Boolean']['input'];
  /** SSGAccountable for catalog */
  ssgAccountable?: InputMaybe<Scalars['String']['input']>;
  /** Is catalog verified */
  verified: Scalars['Boolean']['input'];
};

export type CatalogChange = {
  __typename?: 'CatalogChange';
  /** Value after */
  after: CatalogChangeDifference;
  /** Value before */
  before: CatalogChangeDifference;
  /** Changed by */
  changedBy: Maybe<Scalars['String']['output']>;
  /** Time of change */
  timestamp: Scalars['DateTime']['output'];
  /** User who performed the change */
  user: User;
};

export type CatalogChangeDifference = {
  __typename?: 'CatalogChangeDifference';
  addresses: Maybe<Array<CatalogAddress>>;
  changedBy: Maybe<Scalars['String']['output']>;
  contactHours: Maybe<Scalars['String']['output']>;
  contactNumber: Maybe<Scalars['String']['output']>;
  contacts: Maybe<CatalogContactChangeDifference>;
  craftsmen: Maybe<CatalogCraftsmanChangeDifference>;
  customer: Maybe<CatalogCustomer>;
  /** Catalog debitor details */
  debitor: Maybe<Debitor>;
  /** Is catalog debitor verified */
  debitorVerified: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  filenames: Maybe<Scalars['String']['output']>;
  propertyNumber: Maybe<Scalars['String']['output']>;
  smsService: Maybe<Scalars['Boolean']['output']>;
  ssgAccountable: Maybe<Scalars['String']['output']>;
  timedMessages: Maybe<TimedMessageChangeDifference>;
  /** Is catalog verified */
  verified: Scalars['Boolean']['output'];
};

export type CatalogContact = {
  __typename?: 'CatalogContact';
  /** Is contact active */
  active: Scalars['Boolean']['output'];
  /** Catalog ids */
  catalogIds: Array<Scalars['String']['output']>;
  /** Catalogs that uses contact */
  catalogs: Maybe<Array<Catalog>>;
  /** Contact changed by */
  changedBy: Scalars['String']['output'];
  /** Catalog contact Change log */
  changes: Array<CatalogContactChange>;
  /** Contact name */
  contactName: Scalars['String']['output'];
  /** Contact collection type */
  contactType: CatalogContacts;
  /** Timestamp of when the catalog contact was created */
  createdAt: Scalars['DateTime']['output'];
  /** Customer */
  customer: CatalogCustomer;
  /** Contact email */
  email: Maybe<Scalars['String']['output']>;
  /** Is contact global */
  global: Scalars['Boolean']['output'];
  /** Global type for contact */
  globalType: CatalogGlobalType;
  /** Id for catalog contact */
  id: Scalars['String']['output'];
  /** Informations for Contacts */
  informations: Array<Maybe<CatalogPhoneInformation>>;
  /** Contact type */
  type: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the catalog contact was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Version for catalog contact */
  version: Scalars['Int']['output'];
};

export type CatalogContactChange = {
  __typename?: 'CatalogContactChange';
  /** Value after */
  after: CatalogContactChangeDifference;
  /** Value before */
  before: CatalogContactChangeDifference;
  /** Changed by */
  changedBy: Maybe<Scalars['String']['output']>;
  /** Time of change */
  timestamp: Scalars['DateTime']['output'];
  /** User who performed the change */
  user: User;
};

export type CatalogContactChangeDifference = {
  __typename?: 'CatalogContactChangeDifference';
  /** Is contact active */
  active: Maybe<Scalars['Boolean']['output']>;
  catalogs: Maybe<Array<Catalog>>;
  changedBy: Maybe<Scalars['String']['output']>;
  /** Contact name */
  contactName: Maybe<Scalars['String']['output']>;
  contactType: Maybe<CatalogContacts>;
  customer: Maybe<CatalogCustomer>;
  /** Contact email */
  email: Maybe<Scalars['String']['output']>;
  /** Is contact global */
  global: Maybe<Scalars['Boolean']['output']>;
  /** Global type for contact */
  globalType: Maybe<CatalogGlobalType>;
  /** Informations for Contacts */
  informations: Maybe<Array<CatalogPhoneInformation>>;
  type: Maybe<Scalars['String']['output']>;
};

export type CatalogContactInput = {
  /** Is catalog contact active */
  active: Scalars['Boolean']['input'];
  /** Catalogs that uses contact */
  catalogs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contact changed by */
  changedBy: Scalars['String']['input'];
  /** Name for contact */
  contactName: Scalars['String']['input'];
  /** Contact collection type */
  contactType: CatalogContacts;
  /** Customer name for contact */
  customer: Scalars['String']['input'];
  /** Email for contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Is catalog contact global */
  global: Scalars['Boolean']['input'];
  /** Global type for contact */
  globalType: CatalogGlobalType;
  /** Informations for Contact */
  informations: Array<InputMaybe<CatalogPhoneInformationInput>>;
  /** Contact type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum CatalogContacts {
  ClosedContacts = 'CLOSED_CONTACTS',
  ClosedContactsMailContacts = 'CLOSED_CONTACTS_MAIL_CONTACTS',
  MailContacts = 'MAIL_CONTACTS',
  OpenContacts = 'OPEN_CONTACTS',
  OpenContactsClosedContacts = 'OPEN_CONTACTS_CLOSED_CONTACTS',
  OpenContactsClosedContactsMailContacts = 'OPEN_CONTACTS_CLOSED_CONTACTS_MAIL_CONTACTS',
  OpenContactsMailContacts = 'OPEN_CONTACTS_MAIL_CONTACTS'
}

export type CatalogCraftsman = {
  __typename?: 'CatalogCraftsman';
  /** Is contact active */
  active: Scalars['Boolean']['output'];
  /** Catalog ids */
  catalogIds: Array<Scalars['String']['output']>;
  /** Catalogs that uses craftsman */
  catalogs: Maybe<Array<Catalog>>;
  /** Craftsman changed by */
  changedBy: Scalars['String']['output'];
  /** Catalog craftsman Change log */
  changes: Array<CatalogCraftsmanChange>;
  /** Craftsman name */
  contactName: Scalars['String']['output'];
  /** Timestamp of when the catalog craftsman was created */
  createdAt: Scalars['DateTime']['output'];
  /** Customer */
  customer: CatalogCustomer;
  /** Craftsman email */
  email: Maybe<Scalars['String']['output']>;
  /** Is contact global */
  global: Scalars['Boolean']['output'];
  /** Global type for craftsman */
  globalType: CatalogGlobalType;
  /** Id for catalog call contact */
  id: Scalars['String']['output'];
  /** Informations for Craftsman */
  informations: Array<CatalogPhoneInformation>;
  /** Craftsman priority */
  priority: Scalars['String']['output'];
  /** Craftsman type */
  type: Scalars['String']['output'];
  /** Timestamp of when the catalog craftsman was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Version for catalog craftsman */
  version: Scalars['Int']['output'];
};

export type CatalogCraftsmanChange = {
  __typename?: 'CatalogCraftsmanChange';
  /** Value after */
  after: CatalogCraftsmanChangeDifference;
  /** Value before */
  before: CatalogCraftsmanChangeDifference;
  /** Changed by */
  changedBy: Maybe<Scalars['String']['output']>;
  /** Time of change */
  timestamp: Scalars['DateTime']['output'];
  /** User who performed the change */
  user: User;
};

export type CatalogCraftsmanChangeDifference = {
  __typename?: 'CatalogCraftsmanChangeDifference';
  /** Is call contact active */
  active: Maybe<Scalars['Boolean']['output']>;
  catalogs: Maybe<Array<Catalog>>;
  changedBy: Maybe<Scalars['String']['output']>;
  /** Call contact name */
  contactName: Maybe<Scalars['String']['output']>;
  customer: Maybe<CatalogCustomer>;
  /** Call contact email */
  email: Maybe<Scalars['String']['output']>;
  /** Is call contact global */
  global: Maybe<Scalars['Boolean']['output']>;
  /** Global type for craftsman */
  globalType: Maybe<CatalogGlobalType>;
  /** Informations for Craftsman */
  informations: Maybe<Array<CatalogPhoneInformation>>;
  /** Priority for call contact */
  priority: Maybe<Scalars['String']['output']>;
  /** Type for call contact */
  type: Maybe<Scalars['String']['output']>;
};

export type CatalogCraftsmanInput = {
  /** Is catalog contact active */
  active: Scalars['Boolean']['input'];
  /** Catalogs that uses craftsman */
  catalogs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Craftsman changed by */
  changedBy: Scalars['String']['input'];
  /** Craftsman name */
  contactName: Scalars['String']['input'];
  /** Customer name for contact */
  customer: Scalars['String']['input'];
  /** Email for Craftsman */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Is catalog contact global */
  global: Scalars['Boolean']['input'];
  /** Global type for Craftsman */
  globalType: CatalogGlobalType;
  /** Informations for Craftsman */
  informations: Array<InputMaybe<CatalogPhoneInformationInput>>;
  /** Craftsman priority */
  priority: Scalars['String']['input'];
  /** Craftsman type */
  type: Scalars['String']['input'];
};

export type CatalogCustomer = {
  __typename?: 'CatalogCustomer';
  /** Id of catalog customer */
  id: Scalars['String']['output'];
  /** Name of catalog customer */
  name: Scalars['String']['output'];
  /** AD user */
  user: Maybe<User>;
  /** AD users connected to the customer */
  users: Array<User>;
};

export type CatalogCustomerInputType = {
  /** Ids of ad Users */
  adUsers: Array<Scalars['String']['input']>;
  /** Named alias for customer */
  name: Scalars['String']['input'];
};

export enum CatalogGlobalType {
  CatalogsGlobal = 'CATALOGS_GLOBAL',
  CustomerGlobal = 'CUSTOMER_GLOBAL',
  NotGlobal = 'NOT_GLOBAL'
}

export type CatalogInput = {
  /** Addresses for catalog */
  addresses?: InputMaybe<Array<CatalogAddressInput>>;
  /** Catalog changed by */
  changedBy: Scalars['String']['input'];
  /** Contact hours for contact number to be reached */
  contactHours?: InputMaybe<Scalars['String']['input']>;
  /** Contact number for catalog */
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  /** Customer for catalog */
  customer: Scalars['String']['input'];
  /** Debitor number for catalog */
  debitor?: InputMaybe<Scalars['String']['input']>;
  /** Is catalog debitor verified */
  debitorVerified: Scalars['Boolean']['input'];
  /** Description of catalog */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Property number for catalog */
  propertyNumber: Scalars['String']['input'];
  /** Is sms service enabled for catalog */
  smsService: Scalars['Boolean']['input'];
  /** SSGAccountable for catalog */
  ssgAccountable?: InputMaybe<Scalars['String']['input']>;
  /** Is catalog verified */
  verified: Scalars['Boolean']['input'];
};

export type CatalogNotification = {
  __typename?: 'CatalogNotification';
  /** VerificationType */
  debitorVerification: Scalars['Boolean']['output'];
  /** Email */
  email: Scalars['String']['output'];
};

export type CatalogNotificationInput = {
  /** If debitor verify or regular */
  debitorVerification: Scalars['Boolean']['input'];
  /** Email to notify */
  email: Scalars['String']['input'];
};

export type CatalogNotificationSetting = {
  __typename?: 'CatalogNotificationSetting';
  /** Debitor veridy notifications */
  debitorVerifyNotifications: Array<CatalogNotification>;
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
  /** Verify notifications */
  verifyNotifications: Array<CatalogNotification>;
};

export type CatalogNotificationSettingInput = {
  /** Notifications */
  notifications: Array<CatalogNotificationInput>;
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
};

export type CatalogPhoneInformation = {
  __typename?: 'CatalogPhoneInformation';
  /** Information phone number */
  phoneNumber: Scalars['String']['output'];
  /** Remark for information */
  remark: Maybe<Scalars['String']['output']>;
};

export type CatalogPhoneInformationInput = {
  /** Phonenumber for information */
  phoneNumber: Scalars['String']['input'];
  /** Remark for information */
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type CloseOppertunityCode = {
  __typename?: 'CloseOppertunityCode';
  /** Code */
  code: Scalars['String']['output'];
  /** description */
  description: Scalars['String']['output'];
  /** Type */
  type: Scalars['String']['output'];
};

export type CollectionItem = {
  __typename?: 'CollectionItem';
  /** Id of collection item */
  id: Scalars['String']['output'];
  /** Name of collection item */
  name: Scalars['String']['output'];
  /** Type of collection item */
  type: CollectionItemType;
};

export type CollectionItemInputType = {
  /** Name of collection item */
  name: Scalars['String']['input'];
  /** Type of collection item */
  type: CollectionItemType;
};

export enum CollectionItemType {
  AccessCondition = 'ACCESS_CONDITION',
  CatalogCraftsmenPriority = 'CATALOG_CRAFTSMEN_PRIORITY',
  CatalogCraftsmenType = 'CATALOG_CRAFTSMEN_TYPE',
  DamageBoxDescription = 'DAMAGE_BOX_DESCRIPTION',
  DamageBoxRequesterRelationship = 'DAMAGE_BOX_REQUESTER_RELATIONSHIP',
  DamageContactsRole = 'DAMAGE_CONTACTS_ROLE',
  NotCaseRelatedWork = 'NOT_CASE_RELATED_WORK',
  VisitationDescriptionAwait = 'VISITATION_DESCRIPTION_AWAIT',
  VisitationDescriptionCallBack = 'VISITATION_DESCRIPTION_CALL_BACK'
}

export type CompanyContact = {
  __typename?: 'CompanyContact';
  /** Comment on person */
  comment: Maybe<Scalars['String']['output']>;
  /** Name of company */
  companyName: Maybe<Scalars['String']['output']>;
  /** Main phone number of company */
  companyPhone: Maybe<Scalars['String']['output']>;
  /** Person email address */
  email: Scalars['String']['output'];
  /** Name of person */
  name: Scalars['String']['output'];
  /** Optional person phone number */
  phone: Scalars['String']['output'];
};

export type CompanyContactInput = {
  /** Comment on person */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Name of company */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Main phone number of company */
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  /** Person email address */
  email: Scalars['String']['input'];
  /** Name of person */
  name: Scalars['String']['input'];
  /** Optional person phone number */
  phone: Scalars['String']['input'];
};

export type Contact = {
  __typename?: 'Contact';
  /** Contact address information */
  address: Address;
  /** Comment on person */
  comment: Maybe<Scalars['String']['output']>;
  /** Person email address */
  email: Scalars['String']['output'];
  /** Name of person */
  name: Scalars['String']['output'];
  /** Optional person phone number */
  phone: Scalars['String']['output'];
};

export type ContactInput = {
  /** Contact address information */
  address: AddressInput;
  /** Comment on person */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Person email address */
  email: Scalars['String']['input'];
  /** Name of person */
  name: Scalars['String']['input'];
  /** Optional person phone number */
  phone: Scalars['String']['input'];
};

export type Damage = {
  __typename?: 'Damage';
  /** Access conditions */
  accessConditions: Scalars['String']['output'];
  /** BusinessArea for damage */
  businessArea: BusinessArea;
  /** Damage category */
  category: DamageCategory;
  /** Cause behind damage */
  cause: DamageCause;
  /** Damage location contact information */
  contact: Contact;
  /** contacts for damage */
  contacts: Array<DamageContact>;
  /** Date of damage */
  date: Scalars['Date']['output'];
  /** Description of damage */
  description: Scalars['String']['output'];
};

export type DamageCategory = {
  __typename?: 'DamageCategory';
  /** Id of damage category */
  id: Scalars['String']['output'];
  /** Name of damage category */
  name: Scalars['String']['output'];
};

export type DamageCategoryInputType = {
  /** Name of damage category */
  name: Scalars['String']['input'];
};

export type DamageCause = {
  __typename?: 'DamageCause';
  /** Id of associated business area */
  businessArea: BusinessArea;
  /** Id of associated category */
  category: DamageCategory;
  /** Departments associated to damage cause */
  departments: Maybe<Array<Maybe<Department>>>;
  /** Id of damage cause */
  id: Scalars['String']['output'];
  /** Name of damage cause */
  name: Scalars['String']['output'];
  /** Track for damage cause */
  track: Scalars['Int']['output'];
  /** Is damage cause urgent */
  urgent: Scalars['Boolean']['output'];
};

export type DamageCauseInputType = {
  /** Id of business area */
  businessArea: Scalars['String']['input'];
  /** Id of category */
  category: Scalars['String']['input'];
  /** Departments associated to damage cause */
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of damage cause */
  name: Scalars['String']['input'];
  /** Track for damage cause */
  track: Scalars['Int']['input'];
  /** Is damage cause urgent */
  urgent: Scalars['Boolean']['input'];
};

export type DamageContact = {
  __typename?: 'DamageContact';
  /** Email of damage contact */
  email: Maybe<Scalars['String']['output']>;
  /** Name of damage contact */
  name: Scalars['String']['output'];
  /** Phone number of damage contact */
  phone: Maybe<Scalars['String']['output']>;
  /** Role of damage contact */
  role: Scalars['String']['output'];
};

export type DamageContactInput = {
  /** Email for damage contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Name for damage contact */
  name: Scalars['String']['input'];
  /** Phone number for damage contact */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Role for damage contact */
  role: Scalars['String']['input'];
};

export type DamageInput = {
  /** Access conditions */
  accessConditions?: InputMaybe<Scalars['String']['input']>;
  /** BusinessArea for damage */
  businessArea: Scalars['String']['input'];
  /** Damage category */
  category: Scalars['String']['input'];
  /** Cause behind damage */
  cause: Scalars['String']['input'];
  /** Damage location contact information */
  contact: ContactInput;
  /** Contacts for damage */
  contacts?: InputMaybe<Array<DamageContactInput>>;
  /** Date of damage */
  date: Scalars['Date']['input'];
  /** Description of damage */
  description: Scalars['String']['input'];
};

export type DateRangeInput = {
  /** From date */
  from: Scalars['Date']['input'];
  /** To date */
  to: Scalars['Date']['input'];
};

export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  /** From date */
  from: Scalars['DateTime']['output'];
  /** To date */
  to: Scalars['DateTime']['output'];
};

export type DateTimeRangeInput = {
  /** From date */
  from: Scalars['DateTime']['input'];
  /** To date */
  to: Scalars['DateTime']['input'];
};

export type Debitor = {
  __typename?: 'Debitor';
  /** Indicates if customer should pay for actual kilometers driven */
  actualKilometers: Scalars['Boolean']['output'];
  /** Debitor address */
  address: Maybe<AddressSimple>;
  /** Allow Invoicing Without ReqNo */
  allowInvoicingWithoutReqNo: Scalars['Boolean']['output'];
  /** Assortmentcode of debitor */
  assortmentCode: Maybe<Scalars['String']['output']>;
  /** Optional company attention text */
  attention: Maybe<Scalars['String']['output']>;
  /** Indicates if debitor has automatic invoicing enabled for track one cases (null if unknown) */
  automaticTrackOneInvoicing: Maybe<Scalars['Boolean']['output']>;
  /** Debitor billing address */
  billingAddress: Maybe<Address>;
  /** Debitor is blocked */
  blocked: Scalars['Boolean']['output'];
  /** If cases for debitor can be of call center type */
  callCenterActive: Scalars['Boolean']['output'];
  /** Company identifier */
  company: Scalars['String']['output'];
  /** If cases for debitor should have a check "Create in ECB" by default */
  createInECB: Scalars['Boolean']['output'];
  /** CVR number */
  cvrNumber: Scalars['String']['output'];
  /** Group debitor is a member of */
  debitorGroup: Maybe<Scalars['String']['output']>;
  /** ERP system id for debitor */
  debitorId: Scalars['String']['output'];
  /** Default screening template for debitor */
  defaultScreeningTemplate: Maybe<Scalars['String']['output']>;
  /** Debitor email */
  email: Maybe<Scalars['String']['output']>;
  /** Environment Fee Percentage */
  environmentFeePercentage: Scalars['Decimal']['output'];
  /** Optional excess amount */
  excess: Maybe<Scalars['Decimal']['output']>;
  /** Debitor GLN */
  gln: Maybe<Scalars['String']['output']>;
  /** ERP system id for debitor */
  id: Scalars['String']['output'];
  /** Max Environment Fee Amount */
  maxEnvironmentFeeAmount: Scalars['Decimal']['output'];
  /** Max Supply Fee Amount */
  maxSupplyFeeAmount: Maybe<Scalars['Decimal']['output']>;
  /** Debitor phone number */
  phone: Maybe<Scalars['String']['output']>;
  /** Insurance police number */
  policeNumber: Scalars['String']['output'];
  /** Indicates if customer is priority */
  priorityCustomer: Scalars['Boolean']['output'];
  /** Sales Perseon Code */
  salesPersonCode: Scalars['String']['output'];
  /** Sales Perseon Name */
  salesPersonName: Scalars['String']['output'];
  /** Debitor shipping address */
  shippingAddress: Maybe<DebitorShipmentAddress>;
  /** Supply fee start date for debitor */
  supplyFeeDateFrom: Maybe<Scalars['Date']['output']>;
  /** Supply fee end date for debitor */
  supplyFeeDateTo: Maybe<Scalars['Date']['output']>;
  /** Supply Fee Percentage */
  supplyFeePercentage: Scalars['Decimal']['output'];
  /** Type of customer */
  type: DebitorType;
  /** If debitor is unknown or to be created */
  unknown: Scalars['Boolean']['output'];
};

export type DebitorBase = {
  __typename?: 'DebitorBase';
  /** Indicates if customer should pay for actual kilometers driven */
  actualKilometers: Scalars['Boolean']['output'];
  /** Debitor address */
  address: Maybe<AddressSimple>;
  /** Allow Invoicing Without ReqNo */
  allowInvoicingWithoutReqNo: Scalars['Boolean']['output'];
  /** Assortmentcode of debitor */
  assortmentCode: Maybe<Scalars['String']['output']>;
  /** Indicates if debitor has automatic invoicing enabled for track one cases (null if unknown) */
  automaticTrackOneInvoicing: Maybe<Scalars['Boolean']['output']>;
  /** If cases for debitor can be of call center type */
  callCenterActive: Scalars['Boolean']['output'];
  /** Company identifier */
  company: Scalars['String']['output'];
  /** If cases for debitor should have a check "Create in ECB" by default */
  createInECB: Scalars['Boolean']['output'];
  /** Group debitor is a member of */
  debitorGroup: Maybe<Scalars['String']['output']>;
  /** ERP system id for debitor */
  debitorId: Scalars['String']['output'];
  /** Default screening template for debitor */
  defaultScreeningTemplate: Maybe<Scalars['String']['output']>;
  /** Debitor email */
  email: Maybe<Scalars['String']['output']>;
  /** Environment Fee Percentage */
  environmentFeePercentage: Scalars['Decimal']['output'];
  /** Debitor GLN */
  gln: Maybe<Scalars['String']['output']>;
  /** ERP system id for debitor */
  id: Scalars['String']['output'];
  /** Max Environment Fee Amount */
  maxEnvironmentFeeAmount: Scalars['Decimal']['output'];
  /** Max Supply Fee Amount */
  maxSupplyFeeAmount: Maybe<Scalars['Decimal']['output']>;
  /** Debitor phone number */
  phone: Maybe<Scalars['String']['output']>;
  /** Indicates if customer is priority */
  priorityCustomer: Scalars['Boolean']['output'];
  /** Sales Perseon Code */
  salesPersonCode: Scalars['String']['output'];
  /** Sales Perseon Name */
  salesPersonName: Scalars['String']['output'];
  /** Supply fee start date for debitor */
  supplyFeeDateFrom: Maybe<Scalars['Date']['output']>;
  /** Supply fee end date for debitor */
  supplyFeeDateTo: Maybe<Scalars['Date']['output']>;
  /** Supply Fee Percentage */
  supplyFeePercentage: Scalars['Decimal']['output'];
  /** Type of customer */
  type: DebitorType;
};

export type DebitorDelayScalepointConnection = {
  __typename?: 'DebitorDelayScalepointConnection';
  /** Damage causes associated to debitor delay scalepoint connection */
  damageCauses: Array<DamageCause>;
  /** Case debitor details */
  debitor: Debitor;
  /** Unique id of the debitor delay scalepoint connection */
  id: Scalars['String']['output'];
  /** User who last edited the case */
  lastEditedBy: User;
};

export type DebitorInput = {
  /** Optional company attention text */
  attention?: InputMaybe<Scalars['String']['input']>;
  /** Customer billing address */
  billingAddress?: InputMaybe<AddressInput>;
  /** Company identifier */
  company: Scalars['String']['input'];
  /** CVR number */
  cvrNumber: Scalars['String']['input'];
  /** Debitor identifier */
  debitorId: Scalars['String']['input'];
  /** Optional excess amount */
  excess?: InputMaybe<Scalars['Decimal']['input']>;
  /** Insurance police number */
  policeNumber: Scalars['String']['input'];
  /** ERP reference code for selected shipping address */
  shippingAddressReference?: InputMaybe<Scalars['String']['input']>;
  /** Type of customer */
  type: DebitorType;
};

export type DebitorShipmentAddress = {
  __typename?: 'DebitorShipmentAddress';
  /** Shipping address */
  address: AddressSimple;
  /** GLN for debitor shipping address */
  gln: Scalars['String']['output'];
  /** ERP reference no for debitor shipping address */
  id: Scalars['String']['output'];
  /** Name of debitor */
  name: Scalars['String']['output'];
};

export enum DebitorType {
  Agriculture = 'AGRICULTURE',
  Business = 'BUSINESS',
  Private = 'PRIVATE',
  Unknown = 'UNKNOWN'
}

export type DebitorsWithGroups = {
  __typename?: 'DebitorsWithGroups';
  /** Debitor groups */
  debitorGroups: Maybe<Array<Scalars['String']['output']>>;
  /** Debitors */
  debitors: Maybe<Array<Debitor>>;
};

export type Department = {
  __typename?: 'Department';
  /** Department number */
  departmentNumber: Scalars['Int']['output'];
  /** Unique id for department */
  id: Scalars['String']['output'];
  /** Location which movables location is attached to */
  location: Location;
  /** Department name */
  name: Scalars['String']['output'];
  /** The Operation Managers of the department */
  operationManagers: Array<User>;
  /** Requisitions of the department */
  requisitions: Array<Requisition>;
};

export type DepartmentInputType = {
  /** Department number */
  departmentNumber: Scalars['Int']['input'];
  /** Id of the associated Location */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** Name for department */
  name: Scalars['String']['input'];
  /** Emails of the Operation Managers */
  operationManagers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Deviation = {
  __typename?: 'Deviation';
  /** What action was taken after the deviation */
  action: Scalars['String']['output'];
  /** The date where the action was taken */
  actionDate: Maybe<Scalars['Date']['output']>;
  /** Name of the responsible for action being taken */
  actionResponsible: Scalars['String']['output'];
  /** The cause of the deviation */
  cause: Scalars['String']['output'];
  /** Description of the deviation */
  description: Scalars['String']['output'];
  /** if the deviation report stems from an evaluation report, the related question category is entered here. */
  relatedEvaluationCategory: Maybe<Scalars['String']['output']>;
  /** if the deviation report stems from an evaluation report, the related question is entered here. */
  relatedEvaluationQuestion: Maybe<Scalars['String']['output']>;
  /** The date the report was created */
  reportDate: Scalars['Date']['output'];
  /** The severity level expressed as a color */
  severityLevel: DeviationColor;
};

export enum DeviationColor {
  NonSelected = 'NON_SELECTED',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type DeviationInput = {
  /** What action was taken after the deviation */
  action: Scalars['String']['input'];
  /** The date where the action was taken */
  actionDate?: InputMaybe<Scalars['Date']['input']>;
  /** Name of the responsible for action being taken */
  actionResponsible: Scalars['String']['input'];
  /** The cause of the deviation */
  cause: Scalars['String']['input'];
  /** Description of the deviation */
  description: Scalars['String']['input'];
  /** if the deviation report stems from an evaluation report, the related question category is entered here. */
  relatedEvaluationCategory?: InputMaybe<Scalars['String']['input']>;
  /** if the deviation report stems from an evaluation report, the related question is entered here. */
  relatedEvaluationQuestion?: InputMaybe<Scalars['String']['input']>;
  /** The date the report was created */
  reportDate: Scalars['Date']['input'];
  /** The severity level expressed as a color */
  severityLevel: DeviationColor;
};

export type DeviationReportFormData = {
  __typename?: 'DeviationReportFormData';
  /** Contains the information about the deviation */
  deviation: Deviation;
};

export type DeviationReportFormDataInput = {
  /** Contains the information about the deviation */
  deviation: DeviationInput;
};

export type DistanceRetriever = {
  __typename?: 'DistanceRetriever';
  /** Distance between addresses */
  distance: Scalars['String']['output'];
  /** Duration of travel */
  duration: Scalars['String']['output'];
};

export type DraftInvoice = {
  __typename?: 'DraftInvoice';
  /** Invoice attachments */
  attachments: Array<EsdhFile>;
  /** Reference no invoice */
  caseErpNo: Scalars['String']['output'];
  /** Category of invoice */
  category: InvoiceCategory;
  /** User who created the invoice draft */
  createdBy: Maybe<User>;
  /** Reference no invoice */
  erpReferenceNo: Scalars['String']['output'];
  /** Exclude In the enviromental fee */
  excludeInEnvFee: Maybe<Scalars['Boolean']['output']>;
  /** Exclude in the supply fee */
  excludeInSupplyFee: Maybe<Scalars['Boolean']['output']>;
  /** Determines whether draft lines have been suggested for this invoice */
  hasSuggestedLines: Scalars['Boolean']['output'];
  /** Description to put on the invoice */
  invoiceDescription: Scalars['String']['output'];
  /** End date of the invoicing period */
  invoiceEndDate: Scalars['Date']['output'];
  /** Date the invoice is posted */
  invoicePostingDate: Scalars['Date']['output'];
  /** Start date of the invoicing period */
  invoiceStartDate: Scalars['Date']['output'];
  /** Invoice lines */
  lines: Array<DraftInvoiceLine>;
  /** Rejection reason from manager */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** List of screening ERP reference numbers */
  screeningERPReferenceNoList: Maybe<Array<Scalars['String']['output']>>;
  /** Invoice status */
  status: InvoiceStatus;
  /** Invoice validation rule bypasses */
  validationRuleBypasses: Array<ValidationRuleBypass>;
};

export type DraftInvoiceLine = {
  __typename?: 'DraftInvoiceLine';
  /** If allow attach document checkbox should be shown */
  allowAttachDocument: Scalars['Boolean']['output'];
  /** Tells ERP system to attach document for subcontractor lines */
  attachDocument: Maybe<Scalars['Boolean']['output']>;
  /** Case number */
  caseNo: Scalars['String']['output'];
  /** Created by */
  createdBy: Scalars['String']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Document number (planningline reference) */
  documentNo: Scalars['String']['output'];
  /** ERP Reference Task */
  erpReferenceTask: Scalars['String']['output'];
  /** Exclude in Environmental Fee */
  excludeInEnvFee: Maybe<Scalars['Boolean']['output']>;
  /** Exclude in Supply Fee */
  excludeInSupplyFee: Maybe<Scalars['Boolean']['output']>;
  /** Line amount */
  lineAmount: Maybe<Scalars['Decimal']['output']>;
  /** Line Type */
  lineType: Scalars['String']['output'];
  /** New price of unit */
  newUnitPrice: Maybe<Scalars['Decimal']['output']>;
  /** Unique identifier */
  no: Scalars['String']['output'];
  /** Planning date */
  planningDate: Scalars['Date']['output'];
  /** Quantity */
  quantity: Maybe<Scalars['Decimal']['output']>;
  /** Quote Line Id */
  quoteLineId: Scalars['String']['output'];
  /** Screening line */
  screeningLine: Scalars['Boolean']['output'];
  /** Screening Line Id */
  screeningLineId: Scalars['String']['output'];
  /** Screening Line position no */
  screeningLinePosition: Maybe<Scalars['String']['output']>;
  /** Screening line help text */
  screeningLinePositionText: Scalars['String']['output'];
  /** Name of screening this line belongs to */
  screeningTitle: Scalars['String']['output'];
  /** Sort index */
  sortIndex: Scalars['Int']['output'];
  /** System Id */
  systemId: Scalars['String']['output'];
  /** Type */
  type: Scalars['String']['output'];
  /** Cost of unit */
  unitCost: Maybe<Scalars['Decimal']['output']>;
  /** Unit of measure */
  unitOfMeasure: Scalars['String']['output'];
  /** Price of unit */
  unitPrice: Maybe<Scalars['Decimal']['output']>;
  /** Work type code */
  workTypeCode: Scalars['String']['output'];
};

export type DraftInvoiceLineInputType = {
  /** Tells ERP system to attach document for subcontractor lines */
  attachDocument?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case number */
  caseNo: Scalars['String']['input'];
  /** Created by */
  createdBy: Scalars['String']['input'];
  /** Description */
  description: Scalars['String']['input'];
  /** Document number used to indicate groupings of lines */
  documentNo: Scalars['String']['input'];
  /** Exclude in Environmental Fee */
  excludeInEnvFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exclude in Supply Fee */
  excludeInSupplyFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Price of new unit */
  newUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** Unique identifier of item/resource. Will be null if type is Text */
  no?: InputMaybe<Scalars['String']['input']>;
  /** Planning date */
  planningDate: Scalars['Date']['input'];
  /** Quantity */
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  /** Sort index */
  sortIndex: Scalars['Int']['input'];
  /** System id */
  systemId?: InputMaybe<Scalars['String']['input']>;
  /** Task number */
  taskNo: Scalars['String']['input'];
  /** Type of line i.e. Resource, Item,Text, etc. */
  type: Scalars['String']['input'];
  /** Unit of measure */
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  /** Work type code */
  workTypeCode: Scalars['String']['input'];
};

export type DraftInvoiceLineType = {
  __typename?: 'DraftInvoiceLineType';
  /** Unique id of the type */
  id: Scalars['Int']['output'];
  /** Name of the type */
  name: Scalars['String']['output'];
};

export type DriverCarInput = {
  /** Car for driver */
  car: Scalars['String']['input'];
  /** Driver */
  driver: Scalars['String']['input'];
};

export type DrivingSlip = {
  __typename?: 'DrivingSlip';
  /** Star driven KM */
  actualDrivenKM: Maybe<Scalars['Decimal']['output']>;
  /** Car added to the drivingslip */
  car: Maybe<Vehicle>;
  /** Case which driving slip is related to */
  case: Case;
  /** Category of driving slip */
  category: Maybe<Scalars['String']['output']>;
  /** Driving slip change log */
  changes: Array<DrivingSlipChange>;
  /** Optional comment for the driver */
  comment: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the driving slip was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time of driving slip deadline */
  deadline: Maybe<Scalars['DateTime']['output']>;
  /** Department of driving slip */
  department: Department;
  /** Driver who is responsible for the driving slip visit */
  driver: Maybe<User>;
  /** Date and time of when driving has started */
  drivingStarted: Maybe<Scalars['DateTime']['output']>;
  /** Date and time where driving slip is planned to be/was completed */
  end: Scalars['DateTime']['output'];
  /** Estimated hours to complete driving slip */
  estimatedHours: Maybe<Scalars['Decimal']['output']>;
  /** Event ReferenceId. Null if not put in calendar */
  eventReferenceId: Maybe<Scalars['String']['output']>;
  /** Indicates if picture of facade has been taken */
  facadePictureTaken: Maybe<Scalars['Boolean']['output']>;
  /** Driving slip lasts half a day */
  halfDay: Scalars['Boolean']['output'];
  /** Unique id of driving slip */
  id: Scalars['String']['output'];
  /** Location of driving slip */
  location: Location;
  /** Driving slip lock state */
  locked: Scalars['Boolean']['output'];
  /** Materials added to the drivingslip */
  materials: Array<Vehicle>;
  /** Indicates that no material was used/registered by person carrying out the driving slip */
  noMaterialUsed: Scalars['Boolean']['output'];
  /** Indicates that no waste was used/registered by person carrying out the driving slip */
  noWasteUsed: Scalars['Boolean']['output'];
  /** Driver on slip is passenger */
  passenger: Scalars['Boolean']['output'];
  /** Message for planner indicating the resources assigned */
  plannerMessage: Maybe<Scalars['String']['output']>;
  /** Questionnaire to be completed for the driving slip */
  questionnaire: Maybe<DrivingSlipQuestionnaireType>;
  /** Questionnaire completion status */
  questionnaireCompletionStatus: QuestionnaireCompletionStatus;
  /** Requisition of the drivingSlip */
  requisitions: Array<Requisition>;
  /** Risk evaluation status */
  riskEvaluationStatus: RiskEvaluationStatus;
  /** Driving slip series id */
  series: Scalars['String']['output'];
  /** Star driven KM */
  starDrivenKM: Maybe<Scalars['Decimal']['output']>;
  /** Date and time where driving slip is planned to be/was started */
  start: Scalars['DateTime']['output'];
  /** Driving slip status */
  status: DrivingSlipStatus;
  /** Timestamp of when the catelog was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Indicates if driving slip was marked as urgent */
  urgent: Scalars['Boolean']['output'];
  /** Driving slip change version number */
  version: Scalars['Int']['output'];
};

export type DrivingSlipCategory = {
  __typename?: 'DrivingSlipCategory';
  /** Category code */
  code: Scalars['String']['output'];
  /** Category ERP tasks to be used as filter */
  erpReferenceTasks: Array<Scalars['String']['output']>;
  /** Category name */
  name: Scalars['String']['output'];
};

export type DrivingSlipCategoryMapping = {
  __typename?: 'DrivingSlipCategoryMapping';
  /** Id of associated category */
  damageCategoryId: Scalars['String']['output'];
  /** Id of associated cause */
  damageCauseId: Scalars['String']['output'];
  /** driving slip category */
  drivingSlipCategory: Scalars['String']['output'];
};

export type DrivingSlipCategoryMappingInput = {
  /** Id of associated category */
  damageCategoryId: Scalars['String']['input'];
  /** Id of associated cause */
  damageCauseId: Scalars['String']['input'];
  /** Id of associated driving slip category */
  drivingSlipCategory: Scalars['String']['input'];
};

export type DrivingSlipCategoryMappingSettings = {
  __typename?: 'DrivingSlipCategoryMappingSettings';
  /** Drivingslip CategoryMappings */
  drivingSlipCategoryMappings: Array<DrivingSlipCategoryMapping>;
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
};

export type DrivingSlipCategoryMappingSettingsInput = {
  /** Drivingslip Category mappings */
  drivingSlipCategoryMappings: Array<DrivingSlipCategoryMappingInput>;
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
};

export type DrivingSlipChange = {
  __typename?: 'DrivingSlipChange';
  /** Value after */
  after: DrivingSlipChangeDifference;
  /** Value before */
  before: DrivingSlipChangeDifference;
  /** Time of change */
  timestamp: Scalars['DateTime']['output'];
  /** User who performed the change */
  user: User;
};

export type DrivingSlipChangeDifference = {
  __typename?: 'DrivingSlipChangeDifference';
  /** Car used for the driving slip visit */
  car: Maybe<Vehicle>;
  /** Comment for driving slip */
  comment: Maybe<Scalars['String']['output']>;
  /** Driver who is responsible for the driving slip visit */
  driver: Maybe<User>;
  /** Date and time where driving slip is planned to be/was completed */
  end: Maybe<Scalars['DateTime']['output']>;
  /** Event id in outlook */
  eventReferenceId: Maybe<Scalars['String']['output']>;
  /** File changes for driving slip */
  fileNames: Maybe<Scalars['String']['output']>;
  /** Driving slip lock state */
  locked: Maybe<Scalars['Boolean']['output']>;
  /** Materials used for the driving slip visit */
  materials: Maybe<Array<Vehicle>>;
  /** Date and time where driving slip is planned to be/was started */
  start: Maybe<Scalars['DateTime']['output']>;
  /** Driving slip status */
  status: Maybe<DrivingSlipStatus>;
  /** Indicates if driving slip was marked as urgent */
  urgent: Maybe<Scalars['Boolean']['output']>;
};

export type DrivingSlipHelperInput = {
  /** Additional days to copy input driving slip to */
  additionalDays: Array<AdditionalDayInput>;
  /** Additional drivers to copy input driving slip to */
  additionalDrivers: Array<Scalars['String']['input']>;
  /** Additional drivers to copy input driving slip to */
  driverCars: Array<DriverCarInput>;
  /** Indicates if driving slip should be added to users calendar immediately and set as planned */
  immediatelyPlan: Scalars['Boolean']['input'];
  /** Driving slip input object */
  input: DrivingSlipInput;
};

export type DrivingSlipInput = {
  /** Car used for driving slip visit */
  car?: InputMaybe<Scalars['String']['input']>;
  /** Category of driving slip */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Comment for driver */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Date and time of driving slip deadline */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** Department of driving slip */
  department: Scalars['String']['input'];
  /** Driver who is responsible for the driving slip visit */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** Date and time where driving slip is planned to be completed by */
  end: Scalars['DateTime']['input'];
  /** Estimated hours to complete driving slip */
  estimatedHours?: InputMaybe<Scalars['Decimal']['input']>;
  /** Indicates if picture of facade has been taken */
  facadePictureTaken?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if driving slip lasts half a day */
  halfDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location of driving slip */
  location: Scalars['String']['input'];
  /** Materials on the drivingslip */
  materials?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Indicates if driver is passenger */
  passenger?: InputMaybe<Scalars['Boolean']['input']>;
  /** Message for Planner */
  plannerMessage?: InputMaybe<Scalars['String']['input']>;
  /** Driving slip series which this driving slip is attached to (omit for new series) */
  series?: InputMaybe<Scalars['String']['input']>;
  /** Date and time where driving slip is planned for */
  start: Scalars['DateTime']['input'];
  /** Indicates if driving slip was marked as urgent */
  urgent: Scalars['Boolean']['input'];
};

export type DrivingSlipQuestionnaireInputType = {
  /** Id of the source questionnaire template */
  sourceTemplateId: Scalars['String']['input'];
  /** Version of the source questionnaire template */
  sourceTemplateVersion: Scalars['Int']['input'];
  /** Driving slip questionnaire template to create */
  template: DrivingSlipQuestionnaireTemplateInput;
};

export type DrivingSlipQuestionnaireTemplate = {
  __typename?: 'DrivingSlipQuestionnaireTemplate';
  /** Questionnaire damage causes */
  damageCauses: Array<Scalars['String']['output']>;
  /** Questionnaire damage causes */
  drivingSlipCategories: Array<Scalars['String']['output']>;
  /** Questionnaire label */
  label: Scalars['String']['output'];
  /** Questionnaire sections */
  sections: Array<QuestionnaireSection>;
};

export type DrivingSlipQuestionnaireTemplateInput = {
  /** Questionnaire damage causes */
  damageCauses: Array<Scalars['String']['input']>;
  /** Questionnaire driving slip categories */
  drivingSlipCategories: Array<Scalars['String']['input']>;
  /** Questionnaire label */
  label: Scalars['String']['input'];
  /** Questionnaire sections */
  sections: Array<QuestionnaireSectionInputType>;
};

export type DrivingSlipQuestionnaireType = {
  __typename?: 'DrivingSlipQuestionnaireType';
  /** Unique Id of template */
  id: Scalars['String']['output'];
  /** Id of the source questionnaire template it is based on */
  sourceTemplateId: Scalars['String']['output'];
  /** Version of the source questionnaire template it is based on */
  sourceTemplateVersion: Scalars['Int']['output'];
  /** Driving slip questionnaire template */
  template: DrivingSlipQuestionnaireTemplate;
  /** Last modified */
  updatedAt: Scalars['DateTime']['output'];
};

export type DrivingSlipSeries = {
  __typename?: 'DrivingSlipSeries';
  /** Driving slip series completed status */
  completed: Scalars['Boolean']['output'];
  /** Driving slips on series */
  drivingSlips: Array<DrivingSlip>;
  /** Unique id of driving slip series */
  id: Scalars['String']['output'];
};

export enum DrivingSlipStatus {
  Arrived = 'ARRIVED',
  Completed = 'COMPLETED',
  ConvertedToRequisition = 'CONVERTED_TO_REQUISITION',
  Obsolete = 'OBSOLETE',
  OnHold = 'ON_HOLD',
  Planned = 'PLANNED',
  Started = 'STARTED',
  Unplanned = 'UNPLANNED',
  Null = '_NULL_'
}

export type EsdhFile = {
  __typename?: 'ESDHFile';
  /** File comments from ESDH */
  comments: Maybe<Scalars['String']['output']>;
  /** File created */
  created: Scalars['DateTime']['output'];
  /** File extension */
  extension: Scalars['String']['output'];
  /** File extension */
  fileId: Scalars['String']['output'];
  /** File grouping key */
  groupingKey: Scalars['String']['output'];
  /** File metadata from ESDH */
  metadata: Array<StringKvp>;
  /** File name */
  name: Scalars['String']['output'];
  /** File thumbnail URL */
  thumbnail: Scalars['String']['output'];
  /** File url from ESDH */
  url: Scalars['String']['output'];
};

export type EmptyReturn = {
  __typename?: 'EmptyReturn';
  /** This value is not used for anything. */
  _: Scalars['String']['output'];
};

export type EndevaluationReportFormData = {
  __typename?: 'EndevaluationReportFormData';
  /** List of deviation objects to create deviation reports */
  deviations: Maybe<Array<Deviation>>;
  /** List of evaluation categories with questions */
  evaluationCategories: Maybe<Array<EvaluationCategories>>;
  /** signature of the person that made the report */
  signature: Maybe<Signature>;
};

export type EndevaluationReportFormDataInput = {
  /** List of deviation objects to create deviation reports */
  deviations?: InputMaybe<Array<DeviationInput>>;
  /** List of evaluation categories with questions */
  evaluationCategories?: InputMaybe<Array<EvaluationCategoriesInput>>;
  /** signature of the person that made the report */
  signature?: InputMaybe<SignatureInputType>;
};

export type Evaluation = {
  __typename?: 'Evaluation';
  /** the answer to the evaluation question */
  answer: EvaluationEnum;
  /** index for determining order in the report */
  index: Scalars['Int']['output'];
  /** evaluation question within a certain category */
  question: Scalars['String']['output'];
  /** remark for when an evaluation is marked as not relevant  */
  remark: Scalars['String']['output'];
};

export type EvaluationCategories = {
  __typename?: 'EvaluationCategories';
  /** List of evaluations in this category */
  evaluations: Maybe<Array<Maybe<Evaluation>>>;
  /** Index determines the ordering of the table */
  index: Scalars['Int']['output'];
  /** Title of the category */
  title: Scalars['String']['output'];
};

export type EvaluationCategoriesInput = {
  /** List of evaluations in this category */
  evaluations?: InputMaybe<Array<InputMaybe<EvaluationInput>>>;
  /** Index determines the ordering of the table */
  index: Scalars['Int']['input'];
  /** Title of the category */
  title: Scalars['String']['input'];
};

export enum EvaluationEnum {
  No = 'NO',
  NotRelevant = 'NOT_RELEVANT',
  NotSelected = 'NOT_SELECTED',
  Yes = 'YES'
}

export type EvaluationInput = {
  /** the answer to the evaluation question */
  answer: EvaluationEnum;
  /** index for determining order in the report */
  index: Scalars['Int']['input'];
  /** evaluation question within a certain category */
  question: Scalars['String']['input'];
  /** remark for when an evaluation is marked as not relevant  */
  remark: Scalars['String']['input'];
};

export type FalckDehumidifierReportFormDataInput = {
  /** Optional email that will receive a copy of the report */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  /** Ids of the dehumidifiers assigned to this deal */
  dehumidifierNumbers: Array<Scalars['String']['input']>;
  /** Image of the customers signature */
  signature?: InputMaybe<ReportFileInput>;
  /** Falck subscription number of the customer */
  subscriptionNumber: Scalars['String']['input'];
};

export enum FileActionType {
  Add = 'ADD',
  Remove = 'REMOVE',
  Update = 'UPDATE'
}

export type FileFilterInput = {
  /** Name of filter e.g. name */
  filterName: Scalars['String']['input'];
  /** What the filter should look for e.g. a specific file name */
  filterQuery: Scalars['String']['input'];
};

export type FileInput = {
  /** File data */
  fileData: Array<Scalars['Byte']['input']>;
  /** File metadata */
  fileMetadata?: InputMaybe<Array<FileMetadataInput>>;
  /** Name of file */
  filename: Scalars['String']['input'];
};

/** Metadata fields that can be set in Sharepoint. */
export enum FileMetadataField {
  /** Comments */
  Comments = 'Comments',
  /** Document type */
  DocumentType = 'DocumentType',
  /** Indicates if picture is of facade */
  IsFacadePicture = 'IsFacadePicture',
  /** Name of the questionnaire section */
  QuestionnaireSection = 'QuestionnaireSection',
  /** Name of the report */
  ReportName = 'ReportName',
  /** Name of the report section */
  ReportSection = 'ReportSection'
}

export type FileMetadataInput = {
  /** KVP key */
  key: FileMetadataField;
  /** KVP value */
  value: Scalars['String']['input'];
};

export type FileRetriever = {
  __typename?: 'FileRetriever';
  /** File data as byte array */
  fileData: Array<Scalars['Byte']['output']>;
  /** File data as base64 */
  fileDataBase64: Scalars['String']['output'];
  /** File name */
  filename: Scalars['String']['output'];
};

export type FloorMoistureReportFormData = {
  __typename?: 'FloorMoistureReportFormData';
  /** Floorplan image info */
  floorplanImage: Maybe<ReportFile>;
  /** Moisture meassurements */
  moistureMeassurements: Maybe<Array<MoistureMeassurement>>;
  /** Floor Name */
  name: Scalars['String']['output'];
  /** Report observations */
  observations: MoistureReportObservations;
  /** List of other relevant images */
  otherImages: Maybe<Array<ReportFile>>;
};

export type FloorMoistureReportFormDataInput = {
  /** Floorplan image info */
  floorplanImage?: InputMaybe<ReportFileInput>;
  /** Moisture meassurements */
  moistureMeassurements?: InputMaybe<Array<MoistureMeassurementInput>>;
  /** Floor Name */
  name: Scalars['String']['input'];
  /** Report observations */
  observations: MoistureReportObservationsInput;
  /** List of other relevant images */
  otherImages?: InputMaybe<Array<ReportFileInput>>;
};

export type FloorMoistureTrygReportFormData = {
  __typename?: 'FloorMoistureTrygReportFormData';
  /** Air meassurements */
  airMeassurements: AirMeassurementDetails;
  /** Damage cause description */
  damageCause: Maybe<Scalars['String']['output']>;
  /** Damage description */
  damageDescription: Maybe<Scalars['String']['output']>;
  /** Damage description image info */
  damageDescriptionImage: Maybe<Array<ReportFile>>;
  /** Damage drawing image info */
  damageDrawingImage: Maybe<ReportFile>;
  /** Floorplan image info */
  floorplanImage: Maybe<ReportFile>;
  /** Description of relation between damage cause and moisture */
  moistureDamageCause: Maybe<Scalars['String']['output']>;
  /** Moisture meassurements */
  moistureMeassurements: Maybe<Array<TrygMoistureMeassurement>>;
  /** Multiple damage causes description */
  multipleDamageCauses: Maybe<Scalars['String']['output']>;
  /** Name of floor */
  name: Maybe<Scalars['String']['output']>;
  /** List of other relevant images */
  otherImages: Maybe<Array<ReportFile>>;
  /** Recommendations (if any) */
  recommendations: Maybe<Scalars['String']['output']>;
  /** Urgent actions (if any) */
  urgentActions: Maybe<Scalars['String']['output']>;
};

export type FloorMoistureTrygReportFormDataInput = {
  /** Air meassurements */
  airMeassurements: AirMeassurementDetailsInput;
  /** Damage cause description */
  damageCause?: InputMaybe<Scalars['String']['input']>;
  /** Damage description */
  damageDescription?: InputMaybe<Scalars['String']['input']>;
  /** Damage description image info */
  damageDescriptionImage?: InputMaybe<Array<ReportFileInput>>;
  /** Damage drawing image info */
  damageDrawingImage?: InputMaybe<ReportFileInput>;
  /** Floorplan image info */
  floorplanImage?: InputMaybe<ReportFileInput>;
  /** Description of relation between damage cause and moisture */
  moistureDamageCause?: InputMaybe<Scalars['String']['input']>;
  /** Moisture meassurements */
  moistureMeassurements?: InputMaybe<Array<TrygMoistureMeassurementInput>>;
  /** Multiple damage causes description */
  multipleDamageCauses?: InputMaybe<Scalars['String']['input']>;
  /** Name of floor */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of other relevant images */
  otherImages?: InputMaybe<Array<ReportFileInput>>;
  /** Recommendations (if any) */
  recommendations?: InputMaybe<Scalars['String']['input']>;
  /** Urgent actions (if any) */
  urgentActions?: InputMaybe<Scalars['String']['input']>;
};

export type Gdpr = {
  __typename?: 'GDPR';
  /** Unique id of gdpr accept */
  id: Scalars['String']['output'];
  /** Timestamp of acceptance */
  timestamp: Scalars['DateTime']['output'];
  /** User who accepted GDPR */
  userId: User;
};

export type GdprInputType = {
  /** Timestamp of acceptance */
  timestamp: Scalars['DateTime']['input'];
  /** User who accepted GDPR */
  userId: Scalars['String']['input'];
};

export type GeoCoordinateInput = {
  /** Coordinate latitude */
  latitude: Scalars['Float']['input'];
  /** Coordinate longtitude */
  longitude: Scalars['Float']['input'];
};

export type GroupPermission = {
  __typename?: 'GroupPermission';
  /** Limited damage categories this group can pick from */
  groupDamageCategories: Array<Scalars['String']['output']>;
  /** Limited damage causes this group can pick from */
  groupDamageCauses: Array<Scalars['String']['output']>;
  /** Limited debitor groups this group can pick from */
  groupDebitorGroups: Array<Scalars['String']['output']>;
  /** Limited debitors this group can pick from */
  groupDebitors: Array<GroupPermissionListItem>;
  /** Limited departments this group can pick from */
  groupDepartments: Array<Scalars['String']['output']>;
  /** Limited locations this group can pick from */
  groupLocations: Array<Scalars['String']['output']>;
  /** Unique id of AD permission group */
  groupPermissionId: Scalars['String']['output'];
  /** Group permissions */
  groupPermissions: Array<Permissions>;
  /** Limeted departments this group can make requisitions for */
  groupRequisitionDepartments: Array<Scalars['String']['output']>;
  /** Unique id of group permission */
  id: Scalars['String']['output'];
  /** AD permission group is New */
  isNew: Scalars['Boolean']['output'];
  /** Unique name of AD permission group */
  name: Scalars['String']['output'];
  /** AD group can only see cases they have made or are assigned to */
  ownCasesOnly: Maybe<Scalars['Boolean']['output']>;
};

export type GroupPermissionInputListItemType = {
  /** List item label */
  label: Scalars['String']['input'];
  /** List item value */
  value: Scalars['String']['input'];
};

export type GroupPermissionInputType = {
  /** Id of AD group permission */
  adGroupPermissionId: Scalars['String']['input'];
  /** Limited damage categories this group can pick from */
  groupDamageCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Limited damage causes this group can pick from */
  groupDamageCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Limited debitor groups this group can pick from */
  groupDebitorGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Limited debitors this group can pick from */
  groupDebitors?: InputMaybe<Array<GroupPermissionInputListItemType>>;
  /** Limited departments this group can pick from */
  groupDepartments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Limited locations this group can pick from */
  groupLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Id of group permission */
  groupPermissionId: Scalars['String']['input'];
  /** String list of 5C permissions in AD group permission */
  groupPermissions: Array<Permissions>;
  /** Limited departments this group can make requisitions for */
  groupRequisitionDepartments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Name of AD group permission */
  name: Scalars['String']['input'];
  /** AD group can only see cases they have made or are assigned to */
  ownCasesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupPermissionListItem = {
  __typename?: 'GroupPermissionListItem';
  /** List item label */
  label: Scalars['String']['output'];
  /** List item value */
  value: Scalars['String']['output'];
};

export enum HouseNumbers {
  Both = 'BOTH',
  Equal = 'EQUAL',
  Odd = 'ODD'
}

export type In4moDamageMapping = {
  __typename?: 'In4moDamageMapping';
  /** Damage Cause */
  damageCause: Scalars['String']['output'];
  /** Damage Type */
  damageType: In4moDamageType;
  /** Task Type */
  taskType: In4moTaskType;
};

export type In4moDamageMappingInput = {
  /** Damage Cause */
  damageCause: Scalars['String']['input'];
  /** Damage Type */
  damageType: In4moDamageType;
  /** Task Type */
  taskType: In4moTaskType;
};

export enum In4moDamageType {
  Boat = 'BOAT',
  Fire = 'FIRE',
  NatureEvent = 'NATURE_EVENT',
  Other = 'OTHER',
  Theft = 'THEFT',
  Water = 'WATER'
}

export type In4moDebitorMapping = {
  __typename?: 'In4moDebitorMapping';
  /** Debitor mapping */
  debitor: Scalars['String']['output'];
  /** Insurance company name */
  insuranceCompany: Scalars['String']['output'];
};

export type In4moDebitorMappingInput = {
  /** Debitor mapping */
  debitor: Scalars['String']['input'];
  /** Insurance company name */
  insuranceCompany: Scalars['String']['input'];
};

export type In4moSettings = {
  __typename?: 'In4moSettings';
  /** In4mo damageMappings */
  damageMappings: Array<In4moDamageMapping>;
  /** In4mo debitorMappings */
  debitorMappings: Array<In4moDebitorMapping>;
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** In4mo password */
  password: Scalars['String']['output'];
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
  /** In4mo username */
  username: Scalars['String']['output'];
};

export type In4moSettingsInput = {
  /** In4mo damage mappings */
  damageMappings: Array<In4moDamageMappingInput>;
  /** In4mo debitor mappings */
  debitorMappings: Array<In4moDebitorMappingInput>;
  /** In4mo password */
  password: Scalars['String']['input'];
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
  /** In4mo username */
  username: Scalars['String']['input'];
};

export enum In4moTaskType {
  BrickWork = 'BRICK_WORK',
  BurglaryInspection = 'BURGLARY_INSPECTION',
  Carpentry = 'CARPENTRY',
  Clearance = 'CLEARANCE',
  ContentHandling = 'CONTENT_HANDLING',
  ContentInspection = 'CONTENT_INSPECTION',
  Demolition = 'DEMOLITION',
  Drying = 'DRYING',
  ElectricalWork = 'ELECTRICAL_WORK',
  ExternalAppraiser = 'EXTERNAL_APPRAISER',
  FireCleaning = 'FIRE_CLEANING',
  FireInspection = 'FIRE_INSPECTION',
  FirstAid = 'FIRST_AID',
  Flooring = 'FLOORING',
  GeneralInspection = 'GENERAL_INSPECTION',
  GlassWork = 'GLASS_WORK',
  HouseConstruction = 'HOUSE_CONSTRUCTION',
  LockSmithing = 'LOCK_SMITHING',
  NatureEventInspection = 'NATURE_EVENT_INSPECTION',
  OtherCleaning = 'OTHER_CLEANING',
  Painting = 'PAINTING',
  Plumbing = 'PLUMBING',
  PlumbingIndoors = 'PLUMBING_INDOORS',
  PlumbingOutdoors = 'PLUMBING_OUTDOORS',
  ProjectManagement = 'PROJECT_MANAGEMENT',
  ProspectingSewer = 'PROSPECTING_SEWER',
  ProspectingVvs = 'PROSPECTING_VVS',
  Roofing = 'ROOFING',
  SteelWork = 'STEEL_WORK',
  TakstInspection = 'TAKST_INSPECTION',
  Tiling = 'TILING',
  WaterInspection = 'WATER_INSPECTION'
}

export type IndoorClimateMeassurement = {
  __typename?: 'IndoorClimateMeassurement';
  /** Calculated value */
  calculatedValue: Maybe<Scalars['String']['output']>;
  /** Construction */
  construction: Maybe<Scalars['String']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Instrument */
  instrument: Maybe<Scalars['String']['output']>;
  /** Material */
  material: Maybe<Scalars['String']['output']>;
  /** Reference value */
  referenceValue: Maybe<Scalars['String']['output']>;
  /** Room */
  room: Maybe<Scalars['String']['output']>;
  /** Value */
  value: Maybe<Scalars['String']['output']>;
};

export type IndoorClimateMeassurementInput = {
  /** Calculated value */
  calculatedValue?: InputMaybe<Scalars['String']['input']>;
  /** Construction */
  construction?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Instrument */
  instrument?: InputMaybe<Scalars['String']['input']>;
  /** Material */
  material?: InputMaybe<Scalars['String']['input']>;
  /** Reference value */
  referenceValue?: InputMaybe<Scalars['String']['input']>;
  /** Room */
  room?: InputMaybe<Scalars['String']['input']>;
  /** Value */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IndoorClimateReportFormData = {
  __typename?: 'IndoorClimateReportFormData';
  /** Assessment and conclusion */
  assessmentAndConclusion: Maybe<Scalars['String']['output']>;
  /** Information about what has happened until now */
  backgroundStory: Maybe<Scalars['String']['output']>;
  /** Year of the building being built */
  buildYear: Maybe<Scalars['String']['output']>;
  /** Indicates if the report has been created or not */
  created: Scalars['Boolean']['output'];
  /** Daily users of the building */
  dailyUsers: Maybe<Scalars['String']['output']>;
  /** Famage image info */
  facadeImage: Maybe<ReportFile>;
  /** Floorplan image info */
  floorplanImage: Maybe<ReportFile>;
  /** Meassurements of indoor climate */
  indoorClimateMeassurements: Maybe<Array<IndoorClimateMeassurement>>;
  /** Date of damage */
  inspectionDate: Maybe<Scalars['Date']['output']>;
  /** Observations */
  observations: Maybe<Scalars['String']['output']>;
  /** List of other relevant images */
  otherImages: Maybe<Array<ReportFile>>;
  /** Other participants on the scene */
  participants: Maybe<Scalars['String']['output']>;
  /** Purpose of the report */
  purpose: Maybe<Scalars['String']['output']>;
  /** Refer to appendix for the data log */
  showDataLog: Maybe<Scalars['Boolean']['output']>;
  /** Refer to appendix for lab answers */
  showLabAnswers: Scalars['Boolean']['output'];
  /** Square meters of the area */
  squareMeters: Maybe<Scalars['String']['output']>;
  /** Suggested action plan */
  suggestedActionPlan: Maybe<Scalars['String']['output']>;
};

export type IndoorClimateReportFormDataInput = {
  /** Assessment and conclusion */
  assessmentAndConclusion?: InputMaybe<Scalars['String']['input']>;
  /** Information about what has happened until now */
  backgroundStory?: InputMaybe<Scalars['String']['input']>;
  /** The year it was build */
  buildYear?: InputMaybe<Scalars['String']['input']>;
  /** Daily users of the building */
  dailyUsers?: InputMaybe<Scalars['String']['input']>;
  /** Famage image info */
  facadeImage?: InputMaybe<ReportFileInput>;
  /** Floorplan image info */
  floorplanImage?: InputMaybe<ReportFileInput>;
  /** Indoor climate meassurements */
  indoorClimateMeassurements?: InputMaybe<Array<IndoorClimateMeassurementInput>>;
  /** Date of inspection */
  inspectionDate?: InputMaybe<Scalars['Date']['input']>;
  /** Observations about the site */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** List of other relevant images */
  otherImages?: InputMaybe<Array<ReportFileInput>>;
  /** Other participants on the scene */
  participants?: InputMaybe<Scalars['String']['input']>;
  /** Information about the purpose of the report */
  purpose?: InputMaybe<Scalars['String']['input']>;
  /** Refer to appendix for data log */
  showDataLog?: InputMaybe<Scalars['Boolean']['input']>;
  /** Refer to appendix for lab answers */
  showLabAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Square meters of the area being tested */
  squareMeters?: InputMaybe<Scalars['String']['input']>;
  /** Suggested action plan */
  suggestedActionPlan?: InputMaybe<Scalars['String']['input']>;
};

export type InputField = {
  __typename?: 'InputField';
  /** Key of input field */
  key: Scalars['String']['output'];
  /** Input field permissions */
  permissions: Array<Permissions>;
  /** Input field is required */
  required: Scalars['Boolean']['output'];
};

export type InputFieldInput = {
  /** Inputfield key */
  key: Scalars['String']['input'];
  /** Inputfield permissions */
  permissionsList: Array<Permissions>;
  /** Is the inputfield/section required */
  required: Scalars['Boolean']['input'];
};

export type InspectionAssesmentFormData = {
  __typename?: 'InspectionAssesmentFormData';
  /** list of all the assesments for the report */
  assesments: Maybe<Array<Assesment>>;
  /** list of all the assesments for the report */
  signatures: Maybe<Array<Maybe<Signature>>>;
};

export type InspectionAssesmentFormDataInput = {
  /** list of all the assesments for the report */
  assesments?: InputMaybe<Array<AssesmentInput>>;
  /** list of all the assesments for the report */
  signatures?: InputMaybe<Array<InputMaybe<SignatureInputType>>>;
};

export type InspectionReportFormData = {
  __typename?: 'InspectionReportFormData';
  /** Assessment and conclusion */
  assessmentAndConclusion: Maybe<Scalars['String']['output']>;
  /** Information about what has happened until now */
  backgroundStory: Maybe<Scalars['String']['output']>;
  /** Any other comments from inspection */
  comments: Maybe<Scalars['String']['output']>;
  /** Indicates if the report has been created or not */
  created: Scalars['Boolean']['output'];
  /** Famage image info */
  facadeImage: Maybe<ReportFile>;
  /** Floorplan image info */
  floorplanImage: Maybe<ReportFile>;
  /** Observations about the site */
  observations: Maybe<Scalars['String']['output']>;
  /** List of other relevant images */
  otherImages: Maybe<Array<ReportFile>>;
  /** Suggested action plan */
  suggestedActionPlan: Maybe<Scalars['String']['output']>;
};

export type InspectionReportFormDataInput = {
  /** Assessment and conclusion */
  assessmentAndConclusion?: InputMaybe<Scalars['String']['input']>;
  /** Information about what has happened until now */
  backgroundStory?: InputMaybe<Scalars['String']['input']>;
  /** Any other comments from inspection */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Famage image info */
  facadeImage?: InputMaybe<ReportFileInput>;
  /** Floorplan image info */
  floorplanImage?: InputMaybe<ReportFileInput>;
  /** Observations about the site */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** List of other relevant images */
  otherImages?: InputMaybe<Array<ReportFileInput>>;
  /** Suggested action plan */
  suggestedActionPlan?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceCategory {
  Account = 'ACCOUNT',
  Final = 'FINAL',
  Screening = 'SCREENING',
  Sub = 'SUB',
  TrackOne = 'TRACK_ONE'
}

export type InvoiceHeader = {
  __typename?: 'InvoiceHeader';
  /** identifier of custoner */
  customerNo: Maybe<Scalars['String']['output']>;
  /** Unique id of affilitated case */
  jobNo: Maybe<Scalars['String']['output']>;
  /** Unique id of invoice */
  no: Maybe<Scalars['String']['output']>;
  /** Order number */
  orderNo: Scalars['String']['output'];
  /** Payment terms */
  paymentTerms: Maybe<Scalars['String']['output']>;
  /** Sales person of invoice */
  salesPerson: Maybe<Scalars['String']['output']>;
};

export type InvoiceLinesInfoInputType = {
  /** Description of invoice line */
  description: Scalars['String']['input'];
  /** Id of invoice line */
  id: Scalars['String']['input'];
};

export type InvoiceReasonCode = {
  __typename?: 'InvoiceReasonCode';
  /** Id of invoice reason code */
  id: Scalars['String']['output'];
  /** Name of invoice reason code */
  name: Scalars['String']['output'];
};

export type InvoiceReasonCodeInputType = {
  /** Name of invoice reason code */
  name: Scalars['String']['input'];
};

export type InvoiceSettings = {
  __typename?: 'InvoiceSettings';
  /** Prefixes for debitor groups that have automatic invoicing enabled */
  automaticInvoiceGroupPrefixes: Array<Scalars['String']['output']>;
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** isAmountBelow amount for invoice validation */
  isAmountBelowAmount: Scalars['Int']['output'];
  /** For setting minimum hourly rate on case */
  minHourlyRate: Scalars['Int']['output'];
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
};

export type InvoiceSettingsInput = {
  /** Prefixes for debitor groups that have automatic invoicing enabled */
  automaticInvoiceGroupPrefixes: Array<Scalars['String']['input']>;
  /** isAmountBelow amount for invoice validation */
  isAmountBelowAmount: Scalars['Int']['input'];
  /** For setting minimum hourly rate on case */
  minHourlyRate: Scalars['Int']['input'];
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
};

export enum InvoiceStatus {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Draft = 'DRAFT',
  Posted = 'POSTED',
  Rejected = 'REJECTED'
}

export type Item = {
  __typename?: 'Item';
  /** Base unit of messure */
  baseUOM: Scalars['String']['output'];
  /** description */
  description: Scalars['String']['output'];
  /** ERP job filter code */
  filterCode: Scalars['String']['output'];
  /** Item category code */
  itemCategoryCode: Scalars['String']['output'];
  /** ERP job task number */
  jobTask: Scalars['String']['output'];
  /** item no */
  no: Scalars['String']['output'];
  /** line type */
  type: Scalars['String']['output'];
  /** Unit of measure */
  unitOfMeasure: Scalars['String']['output'];
};

export type Job = {
  __typename?: 'Job';
  /** The user responsible for the task */
  assignedTo: Maybe<User>;
  /** The case the task belongs to */
  case: Maybe<Case>;
  /** Whether the task is completed */
  completed: Scalars['Boolean']['output'];
  /** Timestamp of when the case was created */
  createdAt: Scalars['DateTime']['output'];
  /** Deadline of the case task */
  deadline: Scalars['DateTime']['output'];
  /** Description of the case task */
  description: Scalars['String']['output'];
  /** Unique id of case */
  id: Scalars['String']['output'];
  /** The location responsible to the task */
  location: Maybe<Location>;
  /** The movable responsible to the task */
  movable: Maybe<Movable>;
  /** Source of task */
  source: JobSource;
  /** Type of case task */
  type: JobType;
  /** Timestamp of when the case was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type JobInput = {
  /** Optional id of the user assigned to the task */
  assignedToId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the associated case */
  caseId?: InputMaybe<Scalars['String']['input']>;
  /** Deadline of the case task */
  deadline: Scalars['DateTime']['input'];
  /** Description of the case task */
  description: Scalars['String']['input'];
  /** Optional id of the location assigned to the task */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional id of the movable assigned to the task */
  movableId?: InputMaybe<Scalars['String']['input']>;
  /** Type of case task */
  type: JobType;
};

export type JobLedgerEntry = {
  __typename?: 'JobLedgerEntry';
  /** Actual amount */
  actual: Scalars['Decimal']['output'];
  /** Bold formatting */
  bold: Scalars['Boolean']['output'];
  /** Expected amount */
  expected: Maybe<Scalars['Decimal']['output']>;
  /** Indentation level */
  indentation: Scalars['Int']['output'];
};

export type JobLedgerEntrySummary = {
  __typename?: 'JobLedgerEntrySummary';
  /** Gross profit details */
  grossProfit: JobLedgerEntry;
  /** Gross profit percentage details */
  grossProfitPct: JobLedgerEntry;
  /** IGVA amount details */
  igvaAmount: JobLedgerEntry;
  /** Invoiced amount details */
  invoicedAmount: JobLedgerEntry;
  /** Job number */
  jobNo: Scalars['String']['output'];
  /** Machine cost details */
  machine: JobLedgerEntry;
  /** Material cost details */
  material: JobLedgerEntry;
  /** Personnel cost details */
  personel: JobLedgerEntry;
  /** Storage costs details */
  storageCosts: JobLedgerEntry;
  /** Subcontractor cost details */
  subcontractor: JobLedgerEntry;
  /** Substitute cost details */
  substitute: JobLedgerEntry;
  /** Total cost details */
  totalCost: JobLedgerEntry;
  /** Total revenue details */
  totalRevenue: JobLedgerEntry;
  /** Vehicle expenses details */
  vehicleExpenses: JobLedgerEntry;
};

export enum JobSource {
  In_4Mo = 'IN_4_MO',
  Scalepoint = 'SCALEPOINT',
  Ssg_5C = 'SSG_5_C'
}

export type JobTask = {
  __typename?: 'JobTask';
  /** Description */
  description: Scalars['String']['output'];
  /** case no */
  erpRefrenceNo: Scalars['String']['output'];
  /** Exclude In the enviromental fee */
  excludeInEnvFee: Maybe<Scalars['Boolean']['output']>;
  /** Exclude in the supply fee */
  excludeInSupplyFee: Maybe<Scalars['Boolean']['output']>;
  /** JobTask No */
  jobTaskNo: Scalars['String']['output'];
  /** Price of the JobTask */
  price: Scalars['Decimal']['output'];
  /** Work type for the job task */
  workTypeCode: Scalars['String']['output'];
};

export enum JobType {
  Case = 'CASE',
  General = 'GENERAL',
  Movable = 'MOVABLE'
}

export type Location = {
  __typename?: 'Location';
  /** Address of location */
  address: Address;
  /** Attached postal codes on location */
  attachedPostalCodes: Array<Scalars['String']['output']>;
  /** Input string to resolve attached postal codes */
  attachedPostalCodesInputString: Scalars['String']['output'];
  /** Email attached to location */
  email: Scalars['String']['output'];
  /** Unique id of location */
  id: Scalars['String']['output'];
  /** Whether the location can contain movables */
  movables: Scalars['Boolean']['output'];
  /** Name of location */
  name: Scalars['String']['output'];
};

export type LocationInputType = {
  /** Address of location */
  address: AddressInput;
  /** Attached postal codes on location */
  attachedPostalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Input string to resolve attached postal codes */
  attachedPostalCodesInputString?: InputMaybe<Scalars['String']['input']>;
  /** Email attached to location */
  email: Scalars['String']['input'];
  /** Whether the location can contain movables */
  movables: Scalars['Boolean']['input'];
  /** name of location */
  name: Scalars['String']['input'];
};

export type Machine = {
  __typename?: 'Machine';
  /** bool to determine if machine is active */
  active: Scalars['Boolean']['output'];
  /** Is the machine blocked */
  blocked: Scalars['Boolean']['output'];
  /** Consumption */
  consumption: Scalars['Decimal']['output'];
  /** Average consumption */
  consumptionAverage: Scalars['Decimal']['output'];
  /** Factor for date to kwh conversion */
  consumptionFactor: Scalars['Decimal']['output'];
  /** Whether the type is days, kwh */
  consumptionType: MachineConsumptionType;
  /** end of machineUsage */
  dateEnd: Scalars['Date']['output'];
  /** Start of machineUsage */
  dateStart: Scalars['Date']['output'];
  /** Marks that machine has been discontinued */
  discontinued: Scalars['Boolean']['output'];
  /** Case number if case */
  eRPCaseReference: Maybe<Scalars['String']['output']>;
  /** location number if location */
  eRPLocationReference: Maybe<Scalars['String']['output']>;
  /** Does the machine require specific education */
  educationPrerequisit: Maybe<Array<Scalars['String']['output']>>;
  /** BC identifier */
  erpReferenceNo: Scalars['String']['output'];
  /** Hibernation state */
  hibernate: Scalars['Boolean']['output'];
  /** Hibernation state */
  hibernationReason: Scalars['String']['output'];
  /** machines model number */
  modelNumber: Scalars['String']['output'];
  /** Name of machine */
  name: Scalars['String']['output'];
  /** Original location of machine */
  originLocation: Scalars['String']['output'];
  /** Current placement of machine */
  placement: Scalars['String']['output'];
  /** Where the machine has been placed, e.g. Basement, 1st floor bedroom etc. */
  placementDescription: Maybe<Scalars['String']['output']>;
  /** Reservation by ressource */
  reservationByRessource: Maybe<Scalars['String']['output']>;
  /** reservation description */
  reservationDescription: Maybe<Scalars['String']['output']>;
  /** Reservation End */
  reservationEnd: Maybe<Scalars['DateTime']['output']>;
  /** reservation on Case */
  reservationOnCase: Maybe<Scalars['String']['output']>;
  /** Reservation Start */
  reservationStart: Maybe<Scalars['DateTime']['output']>;
  /** Date of next service */
  serviceDate: Scalars['DateTime']['output'];
  /** Start time */
  startTime: Scalars['String']['output'];
  /** Ressource type/allocation Type */
  type: Scalars['String']['output'];
  /** Unavailable reason */
  unavailableReason: Scalars['String']['output'];
  /** Unit of measure */
  unitOfMeasure: Scalars['String']['output'];
  /** The total consumption after machine has been used */
  usageMeterEnd: Scalars['Decimal']['output'];
  /** Name of user */
  userName: Scalars['String']['output'];
};

export type MachineCaseOverview = {
  __typename?: 'MachineCaseOverview';
  /** End of machineUsage */
  dateEnd: Scalars['String']['output'];
  /** Start of usage of machine */
  dateStart: Scalars['String']['output'];
  /** Days active of machine */
  daysActive: Scalars['String']['output'];
  /** Machine name */
  machine: Scalars['String']['output'];
  /** Usages of machine */
  usage: Scalars['String']['output'];
};

export enum MachineConsumptionType {
  Days = 'DAYS',
  Hours = 'HOURS',
  Kwh = 'KWH',
  None = 'NONE'
}

export type MachineInput = {
  /** allocation type - job or location */
  allocationType: Scalars['String']['input'];
  /** Consumption */
  consumption: Scalars['Decimal']['input'];
  /** case ref */
  erpCaseReference: Scalars['String']['input'];
  /** location ref */
  erpLocationReference: Scalars['String']['input'];
  /** ERP reference no */
  erpReferenceNo: Scalars['String']['input'];
  /** Hibernation state */
  hibernate: Scalars['Boolean']['input'];
  /** Hibernation reason */
  hibernationReason: Scalars['String']['input'];
  /** Where the machine has been placed, e.g. Basement, 1st floor bedroom etc. */
  placementDescription?: InputMaybe<Scalars['String']['input']>;
  /** Reserved ny ressource */
  reservationByRessource?: InputMaybe<Scalars['String']['input']>;
  /** Reservation description */
  reservationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Reservation end date */
  reservationEnd?: InputMaybe<Scalars['String']['input']>;
  /** Reserved to Case */
  reservationOnCase?: InputMaybe<Scalars['String']['input']>;
  /** Reservation start date */
  reservationStart?: InputMaybe<Scalars['String']['input']>;
  /** Start date of machine usage. Format: (yyyy-MM-dd) */
  startingDate: Scalars['String']['input'];
  /** Start time of machine usage. Format: (HH:mm:ss) */
  startingTime: Scalars['String']['input'];
  /** Unavailable Reason */
  unavailableReason: Scalars['String']['input'];
};

export type MachineLocation = {
  __typename?: 'MachineLocation';
  /** address line */
  address: Scalars['String']['output'];
  /** City */
  city: Scalars['String']['output'];
  /** Contact person */
  contact: Scalars['String']['output'];
  /** Identifier of location */
  locationCode: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Post code */
  postCode: Scalars['String']['output'];
  /** True if location is unavaliable */
  unavaliable: Scalars['Boolean']['output'];
};

export type MachineNotification = {
  __typename?: 'MachineNotification';
  /** Is active */
  active: Scalars['Boolean']['output'];
  /** Days for trigger */
  days: Scalars['Int']['output'];
};

export type MachineNotificationInput = {
  /** Is active */
  active: Scalars['Boolean']['input'];
  /** Days for warning */
  days: Scalars['Int']['input'];
};

export type MachineNotificationSetting = {
  __typename?: 'MachineNotificationSetting';
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** Machine notifications */
  machineNotifications: Array<MachineNotification>;
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
};

export type MachineNotificationSettingInput = {
  /** Machine notifications */
  machineNotifications: Array<MachineNotificationInput>;
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
};

export enum MachineStatus {
  All = 'ALL',
  Available = 'AVAILABLE',
  Deployed = 'DEPLOYED'
}

export type MoistureMeassurement = {
  __typename?: 'MoistureMeassurement';
  /** Construction */
  construction: Maybe<Scalars['String']['output']>;
  /** Control date */
  controlDate: Maybe<Scalars['String']['output']>;
  /** Control value */
  controlValue: Maybe<Scalars['String']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Expected final value */
  expectedFinalValue: Maybe<Scalars['String']['output']>;
  /** Material */
  material: Maybe<Scalars['String']['output']>;
  /** Method */
  method: Maybe<Scalars['String']['output']>;
  /** Reference date */
  referenceDate: Maybe<Scalars['String']['output']>;
  /** Reference value */
  referenceValue: Maybe<Scalars['String']['output']>;
  /** Value */
  value: Scalars['String']['output'];
};

export type MoistureMeassurementInput = {
  /** Construction */
  construction?: InputMaybe<Scalars['String']['input']>;
  /** Control date */
  controlDate?: InputMaybe<Scalars['String']['input']>;
  /** Control value */
  controlValue?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Expected final value */
  expectedFinalValue?: InputMaybe<Scalars['String']['input']>;
  /** Material */
  material?: InputMaybe<Scalars['String']['input']>;
  /** Method */
  method?: InputMaybe<Scalars['String']['input']>;
  /** Reference date */
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  /** Reference value */
  referenceValue?: InputMaybe<Scalars['String']['input']>;
  /** Value */
  value: Scalars['String']['input'];
};

export type MoistureReportFormData = {
  __typename?: 'MoistureReportFormData';
  /** Conclusions */
  conclusion: Scalars['String']['output'];
  /** Damage site contacts */
  contacts: Scalars['String']['output'];
  /** Indicates if the report has been created or not */
  created: Scalars['Boolean']['output'];
  /** Damage cause description */
  damageCause: Scalars['String']['output'];
  /** Images of damage cause */
  damageCauseImages: Maybe<Array<ReportFile>>;
  /** Famage image info */
  facadeImage: Maybe<ReportFile>;
  /** Gulvfugt info */
  floorReport: Array<FloorMoistureReportFormData>;
  /** Date of damage */
  inspectionDate: Scalars['Date']['output'];
  /** Reason for no regression */
  regres: Maybe<Scalars['String']['output']>;
  /** Damage scope */
  scope: Scalars['String']['output'];
};

export type MoistureReportFormDataInput = {
  /** Conclusions */
  conclusion?: InputMaybe<Scalars['String']['input']>;
  /** Damage site contacts */
  contacts: Scalars['String']['input'];
  /** Damage cause description */
  damageCause: Scalars['String']['input'];
  /** Images of damage cause */
  damageCauseImages?: InputMaybe<Array<ReportFileInput>>;
  /** Famage image info */
  facadeImage?: InputMaybe<ReportFileInput>;
  /** Floor Moisture Report */
  floorMoistureReportFormDataInput?: InputMaybe<Array<FloorMoistureReportFormDataInput>>;
  /** Date of inspection */
  inspectionDate: Scalars['Date']['input'];
  /** Reason for no regression */
  regres?: InputMaybe<Scalars['String']['input']>;
  /** Damage scope */
  scope: Scalars['String']['input'];
};

export type MoistureReportObservations = {
  __typename?: 'MoistureReportObservations';
  /** Ceiling observations */
  ceiling: Maybe<Scalars['String']['output']>;
  /** Construction observations */
  construction: Maybe<Scalars['String']['output']>;
  /** Floor contact information */
  contacts: Maybe<Scalars['String']['output']>;
  /** Floor observations */
  floor: Maybe<Scalars['String']['output']>;
  /** Movables observations */
  movables: Maybe<Scalars['String']['output']>;
  /** Recommendations */
  recommendations: Scalars['String']['output'];
  /** Describes where the damage is */
  roomOrApartment: Scalars['String']['output'];
  /** Observed scope of damage */
  scope: Scalars['String']['output'];
  /** Walls observations */
  walls: Maybe<Scalars['String']['output']>;
};

export type MoistureReportObservationsInput = {
  /** Ceiling observations */
  ceiling?: InputMaybe<Scalars['String']['input']>;
  /** Construction observations */
  construction?: InputMaybe<Scalars['String']['input']>;
  /** Floor contact information */
  contacts?: InputMaybe<Scalars['String']['input']>;
  /** Floor observations */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** Movables observations */
  movables?: InputMaybe<Scalars['String']['input']>;
  /** Recommendations */
  recommendations: Scalars['String']['input'];
  /** Describes where the damage is */
  roomOrApartment: Scalars['String']['input'];
  /** Observed scope of damage */
  scope: Scalars['String']['input'];
  /** Walls observations */
  walls?: InputMaybe<Scalars['String']['input']>;
};

export type MoistureTrygReportFormData = {
  __typename?: 'MoistureTrygReportFormData';
  /** Indicates if the report has been created or not */
  created: Scalars['Boolean']['output'];
  /** Famage image info */
  facadeImage: Maybe<ReportFile>;
  /** Gulvfugt info */
  floorReport: Maybe<Array<FloorMoistureTrygReportFormData>>;
  /** Date of damage */
  inspectionDate: Maybe<Scalars['Date']['output']>;
};

export type MoistureTrygReportFormDataInput = {
  /** Famage image info */
  facadeImage?: InputMaybe<ReportFileInput>;
  /** Floor Moisture Tryg Report */
  floorMoistureTrygReportData?: InputMaybe<Array<FloorMoistureTrygReportFormDataInput>>;
  /** Date of inspection */
  inspectionDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Movable = {
  __typename?: 'Movable';
  /** Case which movable is attached to */
  case: Case;
  /** Movable change log */
  changes: Array<MovableChange>;
  /** Movable completed indicator */
  completed: Scalars['Boolean']['output'];
  /** Timestamp of when the movable was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of movable */
  description: Scalars['String']['output'];
  /** Unique id of movable */
  id: Scalars['String']['output'];
  /** Movable placement */
  placement: MovablesLocation;
  /** Reference to original movable */
  referenceId: Maybe<Scalars['String']['output']>;
  /** Movable status */
  status: Scalars['String']['output'];
  /** Timestamp of when the movable was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Movable change version number */
  version: Scalars['Int']['output'];
  /** Movable volume in m3 */
  volume: Scalars['Decimal']['output'];
};

export type MovableChange = {
  __typename?: 'MovableChange';
  /** Value after */
  after: MovableChangeDifference;
  /** Value before */
  before: MovableChangeDifference;
  /** Time of change */
  timestamp: Scalars['DateTime']['output'];
  /** User who performed the change */
  user: User;
};

export type MovableChangeDifference = {
  __typename?: 'MovableChangeDifference';
  /** Movable completed indicator */
  completed: Maybe<Scalars['Boolean']['output']>;
  /** Description of movable */
  description: Maybe<Scalars['String']['output']>;
  /** Movable placement */
  placement: Maybe<MovablesLocation>;
  /** Movable status */
  status: Maybe<Scalars['String']['output']>;
  /** Movable volume in m3 */
  volume: Maybe<Scalars['Decimal']['output']>;
};

export type MovableInput = {
  /** Case which movable is attached to */
  case: Scalars['String']['input'];
  /** Description of movable */
  description: Scalars['String']['input'];
  /** Unique id of movable */
  id: Scalars['String']['input'];
  /** Movable placement */
  placement: Scalars['String']['input'];
  /** Movable status */
  status: Scalars['String']['input'];
  /** Movable volume in m3 */
  volume: Scalars['Decimal']['input'];
};

export type MovableSearchFiltersInputType = {
  case: Scalars['String']['input'];
  debitors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludeTotalCount: Scalars['Boolean']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyCompleted: Scalars['Boolean']['input'];
  status: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MovablesLocation = {
  __typename?: 'MovablesLocation';
  /** Accumulated location volume in m3 */
  accVolume: Scalars['Decimal']['output'];
  /** Unique id of movables location */
  id: Scalars['String']['output'];
  /** Location which movables location is attached to */
  location: Location;
  /** Name of movables location */
  name: Scalars['String']['output'];
  /** Movable location volume in m3 */
  volume: Scalars['Decimal']['output'];
};

export type MovablesLocationInputType = {
  /** Id of the associated Location */
  locationId: Scalars['String']['input'];
  /** Name of movables location */
  name: Scalars['String']['input'];
  /** Movable location volume in m3 */
  volume: Scalars['Decimal']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addADUserToADUsers: Maybe<Array<Maybe<CatalogCustomer>>>;
  addCarOrMaterials: DrivingSlip;
  addCaseFileToDrivingSlip: EsdhFile;
  addCaseFilesToDrivingSlip: Array<EsdhFile>;
  addCatalogToContact: CatalogContact;
  addCatalogToCraftsman: CatalogCraftsman;
  addCatalogToTimedMessage: TimedMessage;
  addRemoveUsersToAllCatalogCustomers: Scalars['String']['output'];
  appendTimeTrackingSupplement: TimeTrackingDay;
  approveInvoice: DraftInvoice;
  caseUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  casesGDPRCompliant: Array<Case>;
  catalogContactUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  catalogCraftsmenUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  catalogUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  changeCarOnCalendarEvent: CalendarEvent;
  changeLabelAndStatusMovable: Movable;
  changeOfferStatus: Maybe<Scalars['String']['output']>;
  changeUserOnCalendarEvent: CalendarEvent;
  checkMovable: Maybe<Movable>;
  clearCacheByPrefix: Maybe<Scalars['String']['output']>;
  closeCases: Array<Case>;
  completeDrivingSlips: Array<DrivingSlip>;
  /** Create APV */
  createAPV: Apv;
  createBusinessArea: BusinessArea;
  createCarCalendarEvent: CalendarEvent;
  /** Create a case */
  createCase: Case;
  createCaseAgreement: Case;
  createCaseAgreementsFromQuestionnaire: Case;
  createCaseDraftItemUsage: Maybe<Array<CaseDraftUsageLine>>;
  /** Creates an inspection report for assessing the environment before starting work. */
  createCaseOrganizationReport: Maybe<EsdhFile>;
  createCaseRequisition: Requisition;
  createCatalog: Catalog;
  createCatalogContact: CatalogContact;
  createCatalogContacts: Array<CatalogContact>;
  createCatalogCraftsman: CatalogCraftsman;
  createCatalogCraftsmen: Array<CatalogCraftsman>;
  createCatalogCustomer: CatalogCustomer;
  createCatalogs: Array<Catalog>;
  createCollectionItem: CollectionItem;
  createDamageCategory: DamageCategory;
  createDamageCause: DamageCause;
  /** Create damage report for case */
  createDamageReport: EsdhFile;
  /** create a Debitor */
  createDebitor: DebitorBase;
  /** create a Debitor Delay Scalepoint Connection */
  createDebitorDelayScalepointConnection: DebitorDelayScalepointConnection;
  createDepartment: Department;
  createDepartmentRequisition: Requisition;
  /** Creates an evalutation report on the handling of asbestos aswell as a deviation report if any deviations occured */
  createDeviationReport: Maybe<EsdhFile>;
  createDrivingSlip: Array<DrivingSlip>;
  createDrivingSlipRequisition: Requisition;
  /** Creates an evalutation report on the handling of asbestos aswell as a deviation report if any deviations occured */
  createEndevaluationReport: Maybe<EsdhFile>;
  /** Create Falck dehumidifier report for case */
  createFalckDehumidifierReport: EsdhFile;
  createGDPRAccept: Gdpr;
  createGroupPermission: GroupPermission;
  /** Create indoor climate report */
  createIndoorClimateReport: Maybe<EsdhFile>;
  createInputfield: Maybe<InputField>;
  /** Creates an inspection report for assessing the environment before starting work. */
  createInspectionAssesmentReport: Maybe<EsdhFile>;
  /** Create inspection report for case */
  createInspectionMovablesReport: Maybe<EsdhFile>;
  /** Create inspection report for case */
  createInspectionReport: Maybe<EsdhFile>;
  createInvoice: DraftInvoice;
  createInvoiceReasonCode: InvoiceReasonCode;
  /** Create a case task */
  createJob: Job;
  /** Creates a labor supervision report for asbestos cases */
  createLaborSupervisionReport: Maybe<EsdhFile>;
  createLocation: Maybe<Location>;
  /** Create moisture report for case */
  createMoistureReport: Maybe<EsdhFile>;
  /** Create V2 moisture report for case */
  createMoistureReportV2: Maybe<EsdhFile>;
  /** Create moisture report for case */
  createMoistureTrygReport: Maybe<EsdhFile>;
  createMovable: Movable;
  createMovablesLocations: Array<MovablesLocation>;
  /** Creates a notice of construction waste, that is used to notify about upcomming handling of construction waste */
  createNoticeOfConstructionwasteReport: Maybe<EsdhFile>;
  createNotificationConfig: Maybe<NotificationConfig>;
  createNotificationItem: Maybe<NotificationItem>;
  /** Create visitation question */
  createQuestion: VisitationQuestion;
  /** Create questionnaire template */
  createQuestionnaireTemplate: QuestionnaireTemplate;
  createRiskEvaluationCategory: RiskEvaluationCategory;
  createRiskEvaluationQuestion: RiskEvaluationQuestion;
  createScreening: Maybe<EmptyReturn>;
  /** Create a screening position text */
  createScreeningPositionText: ScreeningPositionText;
  createSetting: Maybe<Settings>;
  createTimeTracking: TimeTracking;
  createTimeTrackingDay: TimeTrackingDay;
  createTimedMessage: TimedMessage;
  createUserCalendarEvent: CalendarEvent;
  dailyReportSent: Scalars['String']['output'];
  deleteAPV: Maybe<EmptyReturn>;
  deleteBusinessArea: Maybe<EmptyReturn>;
  deleteCarCalendarEvent: Maybe<DrivingSlip>;
  deleteCase: Maybe<Case>;
  deleteCaseFile: Maybe<EmptyReturn>;
  deleteCatalog: Maybe<EmptyReturn>;
  deleteCatalogContact: Maybe<EmptyReturn>;
  deleteCatalogCraftsman: Scalars['String']['output'];
  deleteCatalogCustomer: Maybe<EmptyReturn>;
  deleteCatalogFile: Maybe<EmptyReturn>;
  deleteCollectionItem: Maybe<EmptyReturn>;
  deleteDamageCategory: Maybe<EmptyReturn>;
  deleteDamageCause: Maybe<EmptyReturn>;
  /** delete a Debitor Delay Scalepoint Connection */
  deleteDebitorDelayScalepointConnection: Scalars['String']['output'];
  deleteDepartment: Maybe<EmptyReturn>;
  deleteDrivingSlip: Maybe<EmptyReturn>;
  deleteDrivingSlipFile: Maybe<EmptyReturn>;
  deleteGDPRAccept: Maybe<EmptyReturn>;
  deleteGroupPermission: Maybe<EmptyReturn>;
  deleteInputField: Maybe<EmptyReturn>;
  deleteInvoice: Maybe<EmptyReturn>;
  deleteInvoiceAdmin: Scalars['String']['output'];
  deleteInvoiceFile: Maybe<EmptyReturn>;
  deleteInvoiceReasonCode: Scalars['String']['output'];
  deleteItemUsage: Maybe<Array<CaseDraftUsageLine>>;
  deleteLocation: Maybe<EmptyReturn>;
  deleteMovablesLocation: Maybe<EmptyReturn>;
  deleteMovablesLocations: Array<Scalars['String']['output']>;
  deleteNotificationConfig: Maybe<EmptyReturn>;
  deleteQuestion: Maybe<EmptyReturn>;
  /** Create questionnaire template */
  deleteQuestionnaireTemplates: Maybe<EmptyReturn>;
  deleteRiskEvaluationCategory: Maybe<EmptyReturn>;
  deleteRiskEvaluationQuestion: Maybe<EmptyReturn>;
  deleteScreening: Maybe<EmptyReturn>;
  deleteScreeningPositionText: Maybe<EmptyReturn>;
  deleteSetting: Maybe<EmptyReturn>;
  deleteTimeTracking: Maybe<EmptyReturn>;
  deleteTimeTrackingDay: Maybe<Scalars['String']['output']>;
  deleteTimeTrackingDayEntry: Maybe<TimeTrackingDay>;
  deleteTimeTrackingEntrySupplement: Maybe<TimeTrackingDay>;
  deleteTimedMessage: Scalars['String']['output'];
  deleteUserCalendarEvent: Maybe<DrivingSlip>;
  departmentUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  deteleJob: Maybe<EmptyReturn>;
  drivingSlipUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  /** edit a Debitor Delay Scalepoint Connection */
  editDebitorDelayScalepointConnection: DebitorDelayScalepointConnection;
  fakeNotify: Scalars['String']['output'];
  favoriteCase: Case;
  gdprUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  generateMovableIdList: Array<Scalars['String']['output']>;
  handleOffer: Offer;
  jobUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  lockCaseBasedOnInvoiceStatus: Maybe<Scalars['String']['output']>;
  lockDrivingSlip: DrivingSlip;
  logCaseFileChange: Maybe<EmptyReturn>;
  logCatalogFileChange: Maybe<EmptyReturn>;
  logDrivingSlipFileChange: Maybe<EmptyReturn>;
  machineReserve: Maybe<Machine>;
  makeOfferBillable: Maybe<Scalars['String']['output']>;
  mergeCases: Case;
  migrateCaseAgreements: Maybe<EmptyReturn>;
  migrateDrivingSlips: Maybe<EmptyReturn>;
  migrateMovablesLocations: Maybe<Scalars['String']['output']>;
  migrationCreateMovable: Movable;
  modifyDrivingSlipFileMetadata: EsdhFile;
  movablesUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  moveMachine: Maybe<Machine>;
  moveMachines: Array<Machine>;
  /** Open an invoice for editing by setting the status to Draft */
  openInvoiceForEditing: DraftInvoice;
  openRejectedDay: Array<TimeTracking>;
  openRejectedTimeTrackingDay: TimeTrackingDay;
  overrideInvoiceDates: Maybe<EmptyReturn>;
  queueUploadDrivingSlipFile: Maybe<EmptyReturn>;
  queueUploadDrivingSlipFiles: Maybe<EmptyReturn>;
  rejectCaseClosing: Case;
  rejectInvoice: DraftInvoice;
  removeCar: DrivingSlip;
  removeMaterial: DrivingSlip;
  removeUserCaseFilter: User;
  removeUserDrivingSlipFilter: User;
  removeUserDrivingSlipOverviewFilter: User;
  removeUserJobFilter: User;
  removeUserMachineFilter: User;
  removeUserMaterialFilter: User;
  removeUserMovableFilter: User;
  removeUserSanitizerFilter: User;
  removeUserVehicleFilter: User;
  reopenTimeTrackingDay: Maybe<TimeTrackingDay>;
  requestInvoiceApproval: DraftInvoice;
  requisitionUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  resetCaseFileCache: Maybe<EmptyReturn>;
  samplePriceForInvoiceLine: SamplePriceResult;
  saveScalePointCase: Maybe<Scalars['String']['output']>;
  sendCaseEmail: Maybe<EmptyReturn>;
  setCostEstimate: Scalars['Decimal']['output'];
  setDrivingSlipDrivingStarted: DrivingSlip;
  setDrivingSlipFacadePictureTaken: DrivingSlip;
  setDrivingSlipNoMaterialUsed: DrivingSlip;
  setDrivingSlipNoWasteUsed: DrivingSlip;
  setDrivingSlipQuestionnaire: DrivingSlip;
  setDrivingSlipQuestionnaireCompletionStatus: DrivingSlip;
  setDrivingSlipRiskEvaluationStatus: DrivingSlip;
  setDrivingSlipStatus: DrivingSlip;
  setHoursAvailable: Scalars['Decimal']['output'];
  setInvoiceReasonCodes: DraftInvoice;
  setSSGPrice: Scalars['Decimal']['output'];
  setUserCaseFilter: User;
  setUserDefaultLanguage: User;
  setUserDrivingSlipFilter: User;
  setUserDrivingSlipOverviewFilter: User;
  setUserJobFilter: User;
  setUserMachineFilter: User;
  setUserMaterialFilter: User;
  setUserMovableFilter: User;
  setUserPlannerHelpText: User;
  setUserProxy: User;
  setUserSanitizerFilter: User;
  setUserVehicleFilter: User;
  submitDay: Maybe<TimeTracking>;
  submitTimeTrackingDay: Maybe<TimeTrackingDay>;
  suggestInvoiceLines: Maybe<Array<DraftInvoiceLine>>;
  /** Test mutation: checks asbestos risk for a given address via Datafordeler */
  testAsbestosRisk: Maybe<Scalars['Boolean']['output']>;
  testKMCase: Scalars['String']['output'];
  timeTrackingDayUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  timeTrackingUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  timedMessageUpdateObjectUserId: Maybe<Scalars['String']['output']>;
  unlockScreening: Maybe<EmptyReturn>;
  /** Update APV */
  updateAPV: Apv;
  updateAllMoveable: Maybe<Scalars['String']['output']>;
  updateBusinessArea: BusinessArea;
  updateBusinessAreasCases: Maybe<Scalars['String']['output']>;
  updateCarCalendarEvent: CalendarEvent;
  updateCase: Case;
  updateCaseRiskEvaluationAnswers: Case;
  updateCaseTasksBasedOnWIP: Maybe<Scalars['String']['output']>;
  updateCasesInBc: Maybe<Scalars['String']['output']>;
  updateCasesWithBrokenDepartments: Maybe<Scalars['String']['output']>;
  updateCatalog: Catalog;
  updateCatalogContact: CatalogContact;
  updateCatalogCraftsman: CatalogCraftsman;
  updateCatalogCustomer: CatalogCustomer;
  /** Must contain all properties on object - properties not included will be overridden by the type's default value */
  updateCatalogs: Array<Catalog>;
  updateCollectionItem: CollectionItem;
  updateDamageAddress: Maybe<Scalars['String']['output']>;
  updateDamageCategory: DamageCategory;
  updateDamageCause: DamageCause;
  updateDebitor: Maybe<Scalars['String']['output']>;
  updateDepartment: Department;
  updateDepartmentsOnCases: Maybe<Scalars['String']['output']>;
  updateDrivingSlip: Array<DrivingSlip>;
  updateGDPRAccept: Gdpr;
  updateGroupPermission: GroupPermission;
  updateInputField: Maybe<InputField>;
  updateInvoice: DraftInvoice;
  updateInvoiceReasonCode: InvoiceReasonCode;
  /** Update a case task */
  updateJob: Maybe<Job>;
  updateLocation: Maybe<Location>;
  updateLocationAndDepartment: Maybe<Scalars['String']['output']>;
  updateLocationAndDepartmentSlagelse: Scalars['String']['output'];
  updateMovable: Movable;
  updateMovablesLocation: MovablesLocation;
  updateNotificationConfig: Maybe<NotificationConfig>;
  updatePictureComment: Maybe<EmptyReturn>;
  updatePoliceNumber: Maybe<Scalars['String']['output']>;
  /** Update visitation question */
  updateQuestion: VisitationQuestion;
  /** Update questionnaire template */
  updateQuestionnaireTemplate: QuestionnaireTemplate;
  updateRiskEvaluationCategory: RiskEvaluationCategory;
  updateRiskEvaluationQuestion: RiskEvaluationQuestion;
  updateScreening: Maybe<EmptyReturn>;
  updateScreeningInvoice: DraftInvoice;
  /** Update a screening position text */
  updateScreeningPositionText: Maybe<ScreeningPositionText>;
  updateSetting: Maybe<Settings>;
  updateTimeTracking: TimeTracking;
  updateTimeTrackingDayEntry: TimeTrackingDay;
  updateTimedMessage: TimedMessage;
  updateTimedMessages: TimedMessage;
  updateUserCalendarEvent: CalendarEvent;
  updateUserInformationFromAd: Maybe<User>;
  updateUserInformationFromAdAllUsers: Maybe<Scalars['String']['output']>;
  updateUserInformationFromAdById: Maybe<User>;
  uploadCaseFile: EsdhFile;
  uploadCaseFiles: Array<EsdhFile>;
  uploadCatalogFile: EsdhFile;
  uploadCatalogFiles: Array<EsdhFile>;
  uploadDrivingSlipFile: EsdhFile;
  uploadDrivingSlipFiles: Array<EsdhFile>;
  uploadFileToScalePoint: Maybe<Scalars['String']['output']>;
  uploadInvoiceFiles: Array<EsdhFile>;
  validateInvoice: Array<ValidationResultKvp>;
};


export type MutationAddCarOrMaterialsArgs = {
  car?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCaseFileToDrivingSlipArgs = {
  caseFolder: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  seriesFolder: Scalars['String']['input'];
};


export type MutationAddCaseFilesToDrivingSlipArgs = {
  caseFolder: Scalars['String']['input'];
  filenames: Array<Scalars['String']['input']>;
  seriesFolder: Scalars['String']['input'];
};


export type MutationAddCatalogToContactArgs = {
  catalogId: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};


export type MutationAddCatalogToCraftsmanArgs = {
  catalogId: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  craftsmanId: Scalars['String']['input'];
};


export type MutationAddCatalogToTimedMessageArgs = {
  catalogId: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  timedMessageId: Scalars['String']['input'];
};


export type MutationAddRemoveUsersToAllCatalogCustomersArgs = {
  adUsers: Array<Scalars['String']['input']>;
  add: Scalars['Boolean']['input'];
};


export type MutationAppendTimeTrackingSupplementArgs = {
  timeTrackingDayId: Scalars['String']['input'];
  timeTrackingEntryId: Scalars['String']['input'];
  timeTrackingSupplement: TimeTrackingSupplementUpdateInputType;
};


export type MutationApproveInvoiceArgs = {
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
};


export type MutationCaseUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCasesGdprCompliantArgs = {
  caseIds: Array<Scalars['String']['input']>;
};


export type MutationCatalogContactUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCatalogCraftsmenUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCatalogUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeCarOnCalendarEventArgs = {
  carId: Scalars['String']['input'];
  event: CalendarEventInput;
  originalCarId: Scalars['String']['input'];
  originalEventId: Scalars['String']['input'];
};


export type MutationChangeLabelAndStatusMovableArgs = {
  newMovableId: Scalars['String']['input'];
  newStatus: Scalars['String']['input'];
  oldMovableId: Scalars['String']['input'];
};


export type MutationChangeOfferStatusArgs = {
  action: SalesHeaderEnum;
  caseERPReferenceNo: Scalars['String']['input'];
  offerERPReferenceNo: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};


export type MutationChangeUserOnCalendarEventArgs = {
  event: CalendarEventInput;
  originalEventId: Scalars['String']['input'];
  originalUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCheckMovableArgs = {
  id: Scalars['String']['input'];
};


export type MutationClearCacheByPrefixArgs = {
  prefix: Scalars['String']['input'];
};


export type MutationCloseCasesArgs = {
  erpNos: Array<Scalars['String']['input']>;
};


export type MutationCompleteDrivingSlipsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationCreateApvArgs = {
  apv: ApvInput;
  file: FileInput;
};


export type MutationCreateBusinessAreaArgs = {
  business: BusinessAreaInputType;
};


export type MutationCreateCarCalendarEventArgs = {
  carId: Scalars['String']['input'];
  event: CalendarEventInput;
};


export type MutationCreateCaseArgs = {
  case: CaseInput;
  drivingSlip?: InputMaybe<DrivingSlipHelperInput>;
  migrationInput?: InputMaybe<CaseMigration>;
  saveInScalePoint: Scalars['Boolean']['input'];
};


export type MutationCreateCaseAgreementArgs = {
  caseAgreement: CaseAgreementInput;
  id: Scalars['String']['input'];
};


export type MutationCreateCaseAgreementsFromQuestionnaireArgs = {
  id: Scalars['String']['input'];
  newCaseAgreements: Array<CaseAgreementInput>;
  seriesId?: InputMaybe<Scalars['String']['input']>;
  trackTwoOptionSelected: Scalars['Boolean']['input'];
};


export type MutationCreateCaseDraftItemUsageArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
  itemDescription: Scalars['String']['input'];
  itemERPReferenceNo: Scalars['String']['input'];
  jobTaskERPReferenceNo: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  unitOfMeasureCode: Scalars['String']['input'];
};


export type MutationCreateCaseOrganizationReportArgs = {
  caseId: Scalars['String']['input'];
  formData: CaseOrganizationFormDataInput;
  onlySave: Scalars['Boolean']['input'];
};


export type MutationCreateCaseRequisitionArgs = {
  caseId: Scalars['String']['input'];
  requisition: RequisitionInput;
  shouldSendEmail: Scalars['Boolean']['input'];
};


export type MutationCreateCatalogArgs = {
  catalog: CatalogInput;
};


export type MutationCreateCatalogContactArgs = {
  catalogContact: CatalogContactInput;
};


export type MutationCreateCatalogContactsArgs = {
  catalogContacts: Array<CatalogContactInput>;
};


export type MutationCreateCatalogCraftsmanArgs = {
  catalogCraftsman: CatalogCraftsmanInput;
};


export type MutationCreateCatalogCraftsmenArgs = {
  catalogCraftsmen: Array<CatalogCraftsmanInput>;
};


export type MutationCreateCatalogCustomerArgs = {
  catalogCustomer: CatalogCustomerInputType;
};


export type MutationCreateCatalogsArgs = {
  catalogs: Array<CatalogInput>;
};


export type MutationCreateCollectionItemArgs = {
  collectionItem: CollectionItemInputType;
};


export type MutationCreateDamageCategoryArgs = {
  damageCategory: DamageCategoryInputType;
};


export type MutationCreateDamageCauseArgs = {
  damageCause: DamageCauseInputType;
};


export type MutationCreateDamageReportArgs = {
  caseId: Scalars['String']['input'];
};


export type MutationCreateDebitorArgs = {
  baseDebitor: DebitorInput;
};


export type MutationCreateDebitorDelayScalepointConnectionArgs = {
  damageCauseIds: Array<Scalars['String']['input']>;
  debitorId: Scalars['String']['input'];
};


export type MutationCreateDepartmentArgs = {
  department: DepartmentInputType;
};


export type MutationCreateDepartmentRequisitionArgs = {
  departmentId: Scalars['String']['input'];
  requisition: RequisitionInput;
  shouldSendEmail: Scalars['Boolean']['input'];
};


export type MutationCreateDeviationReportArgs = {
  caseId: Scalars['String']['input'];
  formData: DeviationReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
};


export type MutationCreateDrivingSlipArgs = {
  caseId: Scalars['String']['input'];
  drivingSlip: DrivingSlipHelperInput;
};


export type MutationCreateDrivingSlipRequisitionArgs = {
  drivingSlipId: Scalars['String']['input'];
  requisition: RequisitionInput;
  shouldSendEmail: Scalars['Boolean']['input'];
};


export type MutationCreateEndevaluationReportArgs = {
  caseId: Scalars['String']['input'];
  formData: EndevaluationReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
};


export type MutationCreateFalckDehumidifierReportArgs = {
  caseId: Scalars['String']['input'];
  formData: FalckDehumidifierReportFormDataInput;
};


export type MutationCreateGdprAcceptArgs = {
  gdpr: GdprInputType;
};


export type MutationCreateGroupPermissionArgs = {
  groupPermission: GroupPermissionInputType;
  groupPermissionsList: Array<Permissions>;
};


export type MutationCreateIndoorClimateReportArgs = {
  caseId: Scalars['String']['input'];
  formData: IndoorClimateReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
  reportFormat: ReportFormatType;
};


export type MutationCreateInputfieldArgs = {
  inputField: InputFieldInput;
};


export type MutationCreateInspectionAssesmentReportArgs = {
  caseId: Scalars['String']['input'];
  formData: InspectionAssesmentFormDataInput;
  onlySave: Scalars['Boolean']['input'];
};


export type MutationCreateInspectionMovablesReportArgs = {
  caseId: Scalars['String']['input'];
  formData: InspectionReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
};


export type MutationCreateInspectionReportArgs = {
  caseId: Scalars['String']['input'];
  formData: InspectionReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
};


export type MutationCreateInvoiceArgs = {
  caseId: Scalars['String']['input'];
  category: InvoiceCategory;
};


export type MutationCreateInvoiceReasonCodeArgs = {
  invoiceReasonCode: InvoiceReasonCodeInputType;
};


export type MutationCreateJobArgs = {
  job: JobInput;
};


export type MutationCreateLaborSupervisionReportArgs = {
  caseId: Scalars['String']['input'];
};


export type MutationCreateLocationArgs = {
  location: LocationInputType;
};


export type MutationCreateMoistureReportArgs = {
  caseId: Scalars['String']['input'];
  floorsToInclude?: InputMaybe<Array<Scalars['String']['input']>>;
  formData: MoistureReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
  reportFormat: ReportFormatType;
};


export type MutationCreateMoistureReportV2Args = {
  caseId: Scalars['String']['input'];
  floorsToInclude?: InputMaybe<Array<Scalars['String']['input']>>;
  formData: MoistureReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
  reportFormat: ReportFormatType;
};


export type MutationCreateMoistureTrygReportArgs = {
  caseId: Scalars['String']['input'];
  floorsToInclude?: InputMaybe<Array<Scalars['String']['input']>>;
  formData: MoistureTrygReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
  reportFormat: ReportFormatType;
};


export type MutationCreateMovableArgs = {
  movable: MovableInput;
};


export type MutationCreateMovablesLocationsArgs = {
  movablesLocations: Array<MovablesLocationInputType>;
};


export type MutationCreateNoticeOfConstructionwasteReportArgs = {
  caseId: Scalars['String']['input'];
  formData: NoticeOfConstructionwasteFormDataInput;
  onlySave: Scalars['Boolean']['input'];
};


export type MutationCreateNotificationConfigArgs = {
  config: NotificationConfigInputType;
};


export type MutationCreateNotificationItemArgs = {
  configItem: NotificationItemInputType;
};


export type MutationCreateQuestionArgs = {
  question: VisitationQuestionInput;
};


export type MutationCreateQuestionnaireTemplateArgs = {
  questionnaireTemplate: QuestionnaireTemplateInput;
};


export type MutationCreateRiskEvaluationCategoryArgs = {
  riskEvaluationCategory: RiskEvaluationCategoryInput;
};


export type MutationCreateRiskEvaluationQuestionArgs = {
  riskEvaluationQuestion: RiskEvaluationQuestionInput;
};


export type MutationCreateScreeningArgs = {
  caseId: Scalars['String']['input'];
  lines: Array<ScreeningLineInputType>;
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
  wipAmount: Scalars['Decimal']['input'];
};


export type MutationCreateScreeningPositionTextArgs = {
  screeningPositionText: ScreeningPositionTextInput;
};


export type MutationCreateSettingArgs = {
  bcSetting?: InputMaybe<BcSettingsInput>;
  catalogNotificationSetting?: InputMaybe<CatalogNotificationSettingInput>;
  drivingSlipCategoryMappingSetting?: InputMaybe<DrivingSlipCategoryMappingSettingsInput>;
  in4moSetting?: InputMaybe<In4moSettingsInput>;
  invoiceSetting?: InputMaybe<InvoiceSettingsInput>;
  machineNotificationSetting?: InputMaybe<MachineNotificationSettingInput>;
  smsSetting?: InputMaybe<SmsSettingsInput>;
  smtpSetting?: InputMaybe<SmtpSettingsInput>;
  spSetting?: InputMaybe<SpSettingsInput>;
};


export type MutationCreateTimeTrackingArgs = {
  timeTracking: TimeTrackingInputType;
};


export type MutationCreateTimeTrackingDayArgs = {
  timeTrackingDay: TimeTrackingDayInputType;
  timeTrackingEntry: TimeTrackingEntryInputType;
};


export type MutationCreateTimedMessageArgs = {
  timedMessage: TimedMessageInput;
};


export type MutationCreateUserCalendarEventArgs = {
  event: CalendarEventInput;
  userId: Scalars['String']['input'];
};


export type MutationDailyReportSentArgs = {
  caseId: Scalars['String']['input'];
};


export type MutationDeleteApvArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBusinessAreaArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCarCalendarEventArgs = {
  carId: Scalars['String']['input'];
  drivingSlipId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};


export type MutationDeleteCaseArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCaseFileArgs = {
  fileName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
};


export type MutationDeleteCatalogArgs = {
  changedBy: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteCatalogContactArgs = {
  changedBy: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteCatalogCraftsmanArgs = {
  changedBy: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteCatalogCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCatalogFileArgs = {
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCollectionItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDamageCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDamageCauseArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDebitorDelayScalepointConnectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDrivingSlipArgs = {
  caseId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteDrivingSlipFileArgs = {
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationDeleteGdprAcceptArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteGroupPermissionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteInputFieldArgs = {
  key: Scalars['String']['input'];
};


export type MutationDeleteInvoiceArgs = {
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
};


export type MutationDeleteInvoiceAdminArgs = {
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
};


export type MutationDeleteInvoiceFileArgs = {
  caseNo: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  invoiceNo: Scalars['String']['input'];
};


export type MutationDeleteInvoiceReasonCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteItemUsageArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
  itemERPReferenceNo: Scalars['String']['input'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMovablesLocationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMovablesLocationsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteNotificationConfigArgs = {
  trigger: NotificationTrigger;
};


export type MutationDeleteQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteQuestionnaireTemplatesArgs = {
  questionnaireTemplateIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteRiskEvaluationCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRiskEvaluationQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteScreeningArgs = {
  caseId: Scalars['String']['input'];
  screeningERPReferenceNo: Scalars['String']['input'];
  wipAmount: Scalars['Decimal']['input'];
};


export type MutationDeleteScreeningPositionTextArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSettingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTimeTrackingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTimeTrackingDayArgs = {
  dayId: Scalars['String']['input'];
};


export type MutationDeleteTimeTrackingDayEntryArgs = {
  dayId: Scalars['String']['input'];
  entryId: Scalars['String']['input'];
};


export type MutationDeleteTimeTrackingEntrySupplementArgs = {
  dayId: Scalars['String']['input'];
  entryId: Scalars['String']['input'];
  supplementId: Scalars['String']['input'];
};


export type MutationDeleteTimedMessageArgs = {
  changedBy: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteUserCalendarEventArgs = {
  drivingSlipId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDepartmentUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
};


export type MutationDeteleJobArgs = {
  id: Scalars['String']['input'];
};


export type MutationDrivingSlipUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditDebitorDelayScalepointConnectionArgs = {
  damageCauseIds: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationFakeNotifyArgs = {
  id: Scalars['String']['input'];
  isDebitorChange: Scalars['Boolean']['input'];
};


export type MutationFavoriteCaseArgs = {
  active: Scalars['Boolean']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationGdprUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateMovableIdListArgs = {
  count: Scalars['Int']['input'];
};


export type MutationHandleOfferArgs = {
  caseId: Scalars['String']['input'];
  offer: OfferInput;
  offerERPReferenceNo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationJobUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
};


export type MutationLockDrivingSlipArgs = {
  id: Scalars['String']['input'];
};


export type MutationLogCaseFileChangeArgs = {
  action: FileActionType;
  case: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};


export type MutationLogCatalogFileChangeArgs = {
  action: FileActionType;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  changedBy: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  globalFile: Scalars['Boolean']['input'];
};


export type MutationLogDrivingSlipFileChangeArgs = {
  action: FileActionType;
  filename: Scalars['String']['input'];
  series: Scalars['String']['input'];
};


export type MutationMachineReserveArgs = {
  machineInput: MachineInput;
};


export type MutationMakeOfferBillableArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
  offerERPReferenceNo: Scalars['String']['input'];
};


export type MutationMergeCasesArgs = {
  duplicateCaseId: Scalars['String']['input'];
  primaryCaseId: Scalars['String']['input'];
  shouldCloseDuplicateCase: Scalars['Boolean']['input'];
};


export type MutationMigrateCaseAgreementsArgs = {
  caseAgreements: Array<CaseAgreementMigrationInput>;
  erpNo: Scalars['String']['input'];
};


export type MutationMigrateDrivingSlipsArgs = {
  drivingSlips: Array<DrivingSlipInput>;
  erpNo: Scalars['String']['input'];
};


export type MutationMigrateMovablesLocationsArgs = {
  locationStrings: Array<Scalars['String']['input']>;
};


export type MutationMigrationCreateMovableArgs = {
  movable: MovableInput;
};


export type MutationModifyDrivingSlipFileMetadataArgs = {
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  metadata: Array<FileMetadataInput>;
};


export type MutationMovablesUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMoveMachineArgs = {
  caseERPreferenceNo: Scalars['String']['input'];
  machineInput: MachineInput;
};


export type MutationMoveMachinesArgs = {
  erpCaseReference?: InputMaybe<Scalars['String']['input']>;
  erpLocationReference?: InputMaybe<Scalars['String']['input']>;
  erpReferenceNumbers: Array<Scalars['String']['input']>;
};


export type MutationOpenInvoiceForEditingArgs = {
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
};


export type MutationOpenRejectedDayArgs = {
  date: Scalars['Date']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationOpenRejectedTimeTrackingDayArgs = {
  date: Scalars['Date']['input'];
  dayId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationOverrideInvoiceDatesArgs = {
  caseId: Scalars['String']['input'];
  documentDate: Scalars['Date']['input'];
  fromDate: Scalars['Date']['input'];
  invoiceERPReference: Scalars['String']['input'];
  toDate: Scalars['Date']['input'];
};


export type MutationQueueUploadDrivingSlipFileArgs = {
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  file: Array<Scalars['Byte']['input']>;
  fileName: Scalars['String']['input'];
  metadata?: InputMaybe<Array<FileMetadataInput>>;
};


export type MutationQueueUploadDrivingSlipFilesArgs = {
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  files: Array<FileInput>;
};


export type MutationRejectCaseClosingArgs = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  rejectionComment: Scalars['String']['input'];
};


export type MutationRejectInvoiceArgs = {
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveCarArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveMaterialArgs = {
  id: Scalars['String']['input'];
  material: Scalars['String']['input'];
};


export type MutationRemoveUserCaseFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationRemoveUserDrivingSlipFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationRemoveUserDrivingSlipOverviewFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationRemoveUserJobFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationRemoveUserMachineFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationRemoveUserMaterialFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationRemoveUserMovableFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationRemoveUserSanitizerFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationRemoveUserVehicleFilterArgs = {
  filterKey: Scalars['String']['input'];
};


export type MutationReopenTimeTrackingDayArgs = {
  timeTrackingDay: TimeTrackingDayInputType;
};


export type MutationRequestInvoiceApprovalArgs = {
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
};


export type MutationRequisitionUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
};


export type MutationResetCaseFileCacheArgs = {
  caseNo: Scalars['String']['input'];
};


export type MutationSamplePriceForInvoiceLineArgs = {
  invoiceLine: DraftInvoiceLineInputType;
};


export type MutationSaveScalePointCaseArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type MutationSendCaseEmailArgs = {
  attachements?: InputMaybe<Array<Scalars['String']['input']>>;
  bcc: Array<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
  cc: Array<Scalars['String']['input']>;
  includeCaseAgreements: Scalars['Boolean']['input'];
  quote: Scalars['Boolean']['input'];
  receivers: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};


export type MutationSetCostEstimateArgs = {
  erpNo: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
};


export type MutationSetDrivingSlipDrivingStartedArgs = {
  carNumber?: InputMaybe<Scalars['String']['input']>;
  drivingStarted: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  locationCoordinates?: InputMaybe<GeoCoordinateInput>;
  passenger?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetDrivingSlipFacadePictureTakenArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetDrivingSlipNoMaterialUsedArgs = {
  id: Scalars['String']['input'];
  noMaterialUsed: Scalars['Boolean']['input'];
};


export type MutationSetDrivingSlipNoWasteUsedArgs = {
  id: Scalars['String']['input'];
  noWasteUsed: Scalars['Boolean']['input'];
};


export type MutationSetDrivingSlipQuestionnaireArgs = {
  id: Scalars['String']['input'];
  questionnaire: DrivingSlipQuestionnaireInputType;
};


export type MutationSetDrivingSlipQuestionnaireCompletionStatusArgs = {
  id: Scalars['String']['input'];
  questionnaireCompletionStatus: QuestionnaireCompletionStatus;
};


export type MutationSetDrivingSlipRiskEvaluationStatusArgs = {
  id: Scalars['String']['input'];
  riskEvaluationStatus: RiskEvaluationStatus;
};


export type MutationSetDrivingSlipStatusArgs = {
  applyDrivingCost?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  locationCoordinates?: InputMaybe<GeoCoordinateInput>;
  status: DrivingSlipStatus;
};


export type MutationSetHoursAvailableArgs = {
  erpNo: Scalars['String']['input'];
  hoursAvailable: Scalars['Decimal']['input'];
};


export type MutationSetInvoiceReasonCodesArgs = {
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  validationRuleBypasses: Array<ValidationRuleBypassInput>;
};


export type MutationSetSsgPriceArgs = {
  erpNo: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
};


export type MutationSetUserCaseFilterArgs = {
  filter: UserCaseFilterInput;
};


export type MutationSetUserDefaultLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationSetUserDrivingSlipFilterArgs = {
  filter: UserDrivingSlipFilterInput;
};


export type MutationSetUserDrivingSlipOverviewFilterArgs = {
  filter: UserDrivingSlipOverviewFilterInput;
};


export type MutationSetUserJobFilterArgs = {
  filter: UserJobFilterInput;
};


export type MutationSetUserMachineFilterArgs = {
  filter: UserMachineFilterInput;
};


export type MutationSetUserMaterialFilterArgs = {
  filter: UserVehicleFilterInput;
};


export type MutationSetUserMovableFilterArgs = {
  filter: UserMovableFilterInput;
};


export type MutationSetUserPlannerHelpTextArgs = {
  helpText: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationSetUserProxyArgs = {
  myAdUserName: Scalars['String']['input'];
  proxyAdUserName?: InputMaybe<Scalars['String']['input']>;
  proxySetByAdUserName: Scalars['String']['input'];
};


export type MutationSetUserSanitizerFilterArgs = {
  filter: UserSanitizerFilterInput;
};


export type MutationSetUserVehicleFilterArgs = {
  filter: UserVehicleFilterInput;
};


export type MutationSubmitDayArgs = {
  timeTracking: TimeTrackingInputType;
};


export type MutationSubmitTimeTrackingDayArgs = {
  timeTrackingDay: TimeTrackingDayInputType;
};


export type MutationSuggestInvoiceLinesArgs = {
  caseId: Scalars['String']['input'];
  includePreviousLines?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceERPReference: Scalars['String']['input'];
};


export type MutationTestAsbestosRiskArgs = {
  address: AddressInput;
};


export type MutationTestKmCaseArgs = {
  fromCoordinates: AddressInput;
  toCoordinates: AddressInput;
};


export type MutationTimeTrackingDayUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTimeTrackingUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTimedMessageUpdateObjectUserIdArgs = {
  updateInDB: Scalars['Boolean']['input'];
  userObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnlockScreeningArgs = {
  caseId: Scalars['String']['input'];
  screeningERPReferenceNo: Scalars['String']['input'];
};


export type MutationUpdateApvArgs = {
  damageCategory?: InputMaybe<Scalars['String']['input']>;
  damageCause?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<FileInput>;
  id: Scalars['String']['input'];
};


export type MutationUpdateBusinessAreaArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateBusinessAreasCasesArgs = {
  updateInDBAndBC: Scalars['Boolean']['input'];
};


export type MutationUpdateCarCalendarEventArgs = {
  carId: Scalars['String']['input'];
  event: CalendarEventInput;
  eventId: Scalars['String']['input'];
};


export type MutationUpdateCaseArgs = {
  adviser?: InputMaybe<CompanyContactInput>;
  alternativeContact?: InputMaybe<PersonInput>;
  areaResponsible?: InputMaybe<Scalars['String']['input']>;
  billingReady?: InputMaybe<Scalars['Boolean']['input']>;
  caseManager?: InputMaybe<Scalars['String']['input']>;
  damage?: InputMaybe<DamageInput>;
  debitor?: InputMaybe<DebitorInput>;
  fixedPriceOnCase?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  importantInfo?: InputMaybe<Scalars['String']['input']>;
  machineNotification?: InputMaybe<Scalars['Boolean']['input']>;
  policyHolder?: InputMaybe<ContactInput>;
  possibilityOfAsbestos?: InputMaybe<Scalars['Boolean']['input']>;
  projectManager?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<CompanyContactInput>;
  requisitioner?: InputMaybe<RequisitionerInput>;
  riskEvaluationAnswers?: InputMaybe<Array<RiskEvaluationAnswerInput>>;
  scalePointId?: InputMaybe<Scalars['String']['input']>;
  scalePointStatus?: InputMaybe<ScalePointStatus>;
  skafor?: InputMaybe<Scalars['Boolean']['input']>;
  ssgDepartment?: InputMaybe<Scalars['String']['input']>;
  ssgLocation?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CaseStatus>;
  timeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  track?: InputMaybe<Scalars['Int']['input']>;
  visitation?: InputMaybe<VisitationInput>;
  workComplete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCaseRiskEvaluationAnswersArgs = {
  id: Scalars['String']['input'];
  riskEvaluationAnswers: Array<RiskEvaluationAnswerInput>;
  riskEvaluationComment?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCaseTasksBasedOnWipArgs = {
  track1threshold: Scalars['Int']['input'];
  track2threshold: Scalars['Int']['input'];
};


export type MutationUpdateCasesInBcArgs = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  updateInBC: Scalars['Boolean']['input'];
};


export type MutationUpdateCasesWithBrokenDepartmentsArgs = {
  updateInDB: Scalars['Boolean']['input'];
};


export type MutationUpdateCatalogArgs = {
  addresses?: InputMaybe<Array<CatalogAddressInput>>;
  changedBy: Scalars['String']['input'];
  contactHours?: InputMaybe<Scalars['String']['input']>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['String']['input'];
  debitor?: InputMaybe<Scalars['String']['input']>;
  debitorVerified?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  propertyNumber: Scalars['String']['input'];
  smsService?: InputMaybe<Scalars['Boolean']['input']>;
  ssgAccountable?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCatalogContactArgs = {
  action: FileActionType;
  active: Scalars['Boolean']['input'];
  catalogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catalogsBefore?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  changedBy: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactType: CatalogContacts;
  customer: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  global: Scalars['Boolean']['input'];
  globalType: CatalogGlobalType;
  id: Scalars['String']['input'];
  informations: Array<InputMaybe<CatalogPhoneInformationInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCatalogCraftsmanArgs = {
  action: FileActionType;
  active: Scalars['Boolean']['input'];
  catalogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catalogsBefore?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  changedBy: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  global: Scalars['Boolean']['input'];
  globalType?: InputMaybe<CatalogGlobalType>;
  id: Scalars['String']['input'];
  informations: Array<InputMaybe<CatalogPhoneInformationInput>>;
  priority: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationUpdateCatalogCustomerArgs = {
  adUsers: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateCatalogsArgs = {
  catalogs?: InputMaybe<Array<InputMaybe<CatalogBatchInput>>>;
};


export type MutationUpdateCollectionItemArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CollectionItemType>;
};


export type MutationUpdateDamageAddressArgs = {
  damageContact: ContactInput;
  erpNo: Scalars['String']['input'];
};


export type MutationUpdateDamageCategoryArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateDamageCauseArgs = {
  business: Scalars['String']['input'];
  category: Scalars['String']['input'];
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  track: Scalars['Int']['input'];
  urgent: Scalars['Boolean']['input'];
};


export type MutationUpdateDebitorArgs = {
  addressLine?: InputMaybe<Scalars['String']['input']>;
  addressLineAlt?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  no: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDepartmentArgs = {
  departmentNumber?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  operationManagers?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateDepartmentsOnCasesArgs = {
  updateInDBAndBC: Scalars['Boolean']['input'];
};


export type MutationUpdateDrivingSlipArgs = {
  additionalDays?: InputMaybe<Array<AdditionalDayInput>>;
  additionalDrivers?: InputMaybe<Array<Scalars['String']['input']>>;
  car?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  driver?: InputMaybe<Scalars['String']['input']>;
  driverCarList?: InputMaybe<Array<DriverCarInput>>;
  drivingStarted?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  facadePictureTaken?: InputMaybe<Scalars['Boolean']['input']>;
  halfDay?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  immediatelyPlan?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plannerMessage?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateGdprAcceptArgs = {
  id: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateGroupPermissionArgs = {
  groupDamageCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  groupDamageCauses?: InputMaybe<Array<Scalars['String']['input']>>;
  groupDebitorGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  groupDebitors?: InputMaybe<Array<GroupPermissionInputListItemType>>;
  groupDepartments?: InputMaybe<Array<Scalars['String']['input']>>;
  groupLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  groupPermissionsList?: InputMaybe<Array<Permissions>>;
  groupRequisitionDepartments?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  ownCasesOnly?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateInputFieldArgs = {
  key: Scalars['String']['input'];
  permissionsList?: InputMaybe<Array<Permissions>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateInvoiceArgs = {
  caseId: Scalars['String']['input'];
  invoiceDescription: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  lines: Array<DraftInvoiceLineInputType>;
};


export type MutationUpdateInvoiceReasonCodeArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateJobArgs = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationUpdateLocationArgs = {
  address?: InputMaybe<AddressInput>;
  attachedPostalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  attachedPostalCodesInputString?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  movables?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLocationAndDepartmentArgs = {
  erpNo: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


export type MutationUpdateLocationAndDepartmentSlagelseArgs = {
  limit: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  updateInDBAndBC: Scalars['Boolean']['input'];
};


export type MutationUpdateMovableArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  placement?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationUpdateMovablesLocationArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationUpdateNotificationConfigArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  emailBodyTemplateId?: InputMaybe<Scalars['Int']['input']>;
  emailSubjectTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  smsTemplateId?: InputMaybe<Scalars['Int']['input']>;
  trigger: NotificationTrigger;
};


export type MutationUpdatePictureCommentArgs = {
  caseNo: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  fileID: Scalars['String']['input'];
};


export type MutationUpdatePoliceNumberArgs = {
  erpNo: Scalars['String']['input'];
  policeNumber: Scalars['String']['input'];
};


export type MutationUpdateQuestionArgs = {
  damageCategory: Scalars['String']['input'];
  damageCause: Scalars['String']['input'];
  id: Scalars['String']['input'];
  question: Scalars['String']['input'];
};


export type MutationUpdateQuestionnaireTemplateArgs = {
  damageCauses: Array<Scalars['String']['input']>;
  drivingSlipCategories: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  sections: Array<QuestionnaireSectionInputType>;
};


export type MutationUpdateRiskEvaluationCategoryArgs = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationUpdateRiskEvaluationQuestionArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  defaultChecked?: InputMaybe<Scalars['Boolean']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateScreeningArgs = {
  caseId: Scalars['String']['input'];
  lines: Array<ScreeningLineInputType>;
  name: Scalars['String']['input'];
  screeningERPReferenceNo: Scalars['String']['input'];
  wipAmount: Scalars['Decimal']['input'];
};


export type MutationUpdateScreeningInvoiceArgs = {
  caseId: Scalars['String']['input'];
  invoiceDescription: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  lines: Array<DraftInvoiceLineInputType>;
};


export type MutationUpdateScreeningPositionTextArgs = {
  id: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  templateCode?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSettingArgs = {
  bcSetting?: InputMaybe<BcSettingsInput>;
  catalogNotificationSetting?: InputMaybe<CatalogNotificationSettingInput>;
  drivingSlipCategoryMappingSettings?: InputMaybe<DrivingSlipCategoryMappingSettingsInput>;
  id: Scalars['String']['input'];
  in4moSetting?: InputMaybe<In4moSettingsInput>;
  invoiceSetting?: InputMaybe<InvoiceSettingsInput>;
  machineNotificationSetting?: InputMaybe<MachineNotificationSettingInput>;
  smsSetting?: InputMaybe<SmsSettingsInput>;
  smtpSetting?: InputMaybe<SmtpSettingsInput>;
  spSetting?: InputMaybe<SpSettingsInput>;
};


export type MutationUpdateTimeTrackingArgs = {
  addonLines?: InputMaybe<Array<InputMaybe<TimeTrackingInputType>>>;
  case: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  drivingSlip: Scalars['String']['input'];
  hours: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  jobTaskName?: InputMaybe<Scalars['String']['input']>;
  jobTaskNo: Scalars['String']['input'];
  paymentSupplementCode?: InputMaybe<Scalars['String']['input']>;
  paymentSupplementName?: InputMaybe<Scalars['String']['input']>;
  pieceworkAmount?: InputMaybe<Scalars['Float']['input']>;
  remark: Scalars['String']['input'];
  supplementType?: InputMaybe<Scalars['String']['input']>;
  supplementUom?: InputMaybe<Scalars['String']['input']>;
  timeTrackingStatus: TimeTrackingStatus;
  user: Scalars['String']['input'];
  workTypeCode: Scalars['String']['input'];
};


export type MutationUpdateTimeTrackingDayEntryArgs = {
  timeTrackingDayId: Scalars['String']['input'];
  timeTrackingEntry: TimeTrackingEntryUpdateInputType;
};


export type MutationUpdateTimedMessageArgs = {
  action: FileActionType;
  active: Scalars['Boolean']['input'];
  catalogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catalogsBefore?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  changedBy: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  endTime: Scalars['DateTime']['input'];
  global: Scalars['Boolean']['input'];
  globalType: CatalogGlobalType;
  id: Scalars['String']['input'];
  message: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type MutationUpdateTimedMessagesArgs = {
  timedMessages: Array<TimedMessageInput>;
};


export type MutationUpdateUserCalendarEventArgs = {
  event: CalendarEventInput;
  eventId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateUserInformationFromAdArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateUserInformationFromAdByIdArgs = {
  id: Scalars['String']['input'];
};


export type MutationUploadCaseFileArgs = {
  file: Array<Scalars['Byte']['input']>;
  fileName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
};


export type MutationUploadCaseFilesArgs = {
  files: Array<FileInput>;
  folder: Scalars['String']['input'];
};


export type MutationUploadCatalogFileArgs = {
  customerId: Scalars['String']['input'];
  file: Array<Scalars['Byte']['input']>;
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadCatalogFilesArgs = {
  customerId: Scalars['String']['input'];
  files: Array<FileInput>;
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadDrivingSlipFileArgs = {
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  file: Array<Scalars['Byte']['input']>;
  fileName: Scalars['String']['input'];
  metadata?: InputMaybe<Array<FileMetadataInput>>;
};


export type MutationUploadDrivingSlipFilesArgs = {
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  files: Array<FileInput>;
};


export type MutationUploadFileToScalePointArgs = {
  caseId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationUploadInvoiceFilesArgs = {
  caseNo: Scalars['String']['input'];
  files: Array<FileInput>;
  invoiceNo: Scalars['String']['input'];
};


export type MutationValidateInvoiceArgs = {
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
};

export type NoticeOfConstructionwasteFormData = {
  __typename?: 'NoticeOfConstructionwasteFormData';
  /** How large of an area in the building. */
  area: Maybe<Scalars['String']['output']>;
  /** A short description of what needs to be done. */
  assignment: Maybe<Scalars['String']['output']>;
  /** Who is going to transport the waste */
  carrier: Maybe<Scalars['String']['output']>;
  /** When will the work end */
  endDate: Maybe<Scalars['Date']['output']>;
  /** When will the work start */
  startDate: Maybe<Scalars['Date']['output']>;
  /** The type of waste and how much it weighs. */
  wasteFractions: Maybe<Scalars['String']['output']>;
  /** How the waste will be packaged */
  wastePackaging: Maybe<Scalars['String']['output']>;
  /** When was the building constructed */
  yearOfConstruction: Maybe<Scalars['String']['output']>;
};

export type NoticeOfConstructionwasteFormDataInput = {
  /** How large of an area in the building. */
  area?: InputMaybe<Scalars['String']['input']>;
  /** A short description of what needs to be done. */
  assignment?: InputMaybe<Scalars['String']['input']>;
  /** Who is going to transport the waste */
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** When will the work end */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** When will the work start */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The type of waste and how much it weighs. */
  wasteFractions?: InputMaybe<Scalars['String']['input']>;
  /** How the waste will be packaged */
  wastePackaging?: InputMaybe<Scalars['String']['input']>;
  /** When was the building constructed */
  yearOfConstruction?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationConfig = {
  __typename?: 'NotificationConfig';
  /** Display name of the notification */
  displayName: Maybe<Scalars['String']['output']>;
  /** Id of the email body template used from SharePoint */
  emailBodyTemplateId: Maybe<Scalars['Int']['output']>;
  /** Template of the email subject */
  emailSubjectTemplate: Maybe<Scalars['String']['output']>;
  /** Unique id of notification */
  id: Scalars['String']['output'];
  /** Id of the sms template used from SharePoint */
  smsTemplateId: Maybe<Scalars['Int']['output']>;
  /** Trigger of the notification */
  trigger: NotificationTrigger;
};

export type NotificationConfigInputType = {
  /** Display name of the notification */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Id of the email body template used from SharePoint */
  emailBodyTemplateId?: InputMaybe<Scalars['Int']['input']>;
  /** Template of the email subject */
  emailSubjectTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Id of the sms template used from SharePoint */
  smsTemplateId?: InputMaybe<Scalars['Int']['input']>;
  /** trigger of notification config */
  trigger: NotificationTrigger;
};

export type NotificationItem = {
  __typename?: 'NotificationItem';
  /** Error for notification */
  error: Maybe<Scalars['String']['output']>;
  /** Id of business area */
  id: Scalars['String']['output'];
  /** Object id for notification */
  objectId: Scalars['String']['output'];
  /** Object type for notification */
  objectType: Scalars['String']['output'];
  /** Receivers of notification */
  sendTo: Maybe<Scalars['String']['output']>;
  /** Notification sent at */
  sentAt: Scalars['DateTime']['output'];
  /** Is notification sent successfully */
  sentSuccessfully: Scalars['Boolean']['output'];
  /** Trigger for notification */
  trigger: NotificationTrigger;
  /** type of notification */
  type: Scalars['String']['output'];
};

export type NotificationItemInputType = {
  /** Error for notification */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Object id of notification */
  objectId: Scalars['String']['input'];
  /** Object type of notification */
  objectType: Scalars['String']['input'];
  /** Receivers of notification */
  sendTo: Scalars['String']['input'];
  /** Notification sent successfully */
  sentSuccessfully?: InputMaybe<Scalars['Boolean']['input']>;
  /** Trigger of notification */
  trigger: NotificationTrigger;
  /** Type of notification */
  type: Scalars['String']['input'];
};

export enum NotificationTrigger {
  CaseClosed = 'CASE_CLOSED',
  CaseClosedRequest = 'CASE_CLOSED_REQUEST',
  CaseCreated = 'CASE_CREATED',
  CaseCreatedAnonymous = 'CASE_CREATED_ANONYMOUS',
  CaseCreatedExternalPartner = 'CASE_CREATED_EXTERNAL_PARTNER',
  CaseEstimateEdited = 'CASE_ESTIMATE_EDITED',
  CaseMasterDataEdited = 'CASE_MASTER_DATA_EDITED',
  CaseMaterialPurchased = 'CASE_MATERIAL_PURCHASED',
  CaseRequisitionCreated = 'CASE_REQUISITION_CREATED',
  CaseSendEmail = 'CASE_SEND_EMAIL',
  CatalogCreated = 'CATALOG_CREATED',
  CatalogDeleted = 'CATALOG_DELETED',
  CatalogEdited = 'CATALOG_EDITED',
  DepartmentRequisitionCreated = 'DEPARTMENT_REQUISITION_CREATED',
  DrivingSlipAssigned = 'DRIVING_SLIP_ASSIGNED',
  DrivingSlipEdited = 'DRIVING_SLIP_EDITED',
  DrivingSlipRemoved = 'DRIVING_SLIP_REMOVED',
  InvoiceApprovalRequested = 'INVOICE_APPROVAL_REQUESTED',
  InvoiceApproved = 'INVOICE_APPROVED',
  InvoiceRejected = 'INVOICE_REJECTED',
  JobPersonalAssigned = 'JOB_PERSONAL_ASSIGNED',
  JobPersonalDeadline = 'JOB_PERSONAL_DEADLINE',
  MachineHibernation = 'MACHINE_HIBERNATION',
  MachineMoved = 'MACHINE_MOVED',
  TimeTrackingEntryDeclined = 'TIME_TRACKING_ENTRY_DECLINED',
  WarningCaseEstimateExceeded = 'WARNING_CASE_ESTIMATE_EXCEEDED',
  WarningCaseMilestoneMissed = 'WARNING_CASE_MILESTONE_MISSED',
  WarningMachineOverdue = 'WARNING_MACHINE_OVERDUE'
}

export type Offer = {
  __typename?: 'Offer';
  /** is offer competition offer */
  competitionOffer: Scalars['Boolean']['output'];
  /** footer text */
  footerText: Maybe<Scalars['String']['output']>;
  /** header text */
  headerText: Maybe<Scalars['String']['output']>;
  /** BC job number */
  jobNo: Scalars['String']['output'];
  /** Offer lines */
  lines: Array<OfferLine>;
  /** current status on Quote */
  opportunityStatus: Maybe<Scalars['String']['output']>;
  /** Quote Type */
  quoteType: Maybe<OfferQuoteTypeEnum>;
};

export type OfferInput = {
  /** is offer CompetitionOffer */
  competitionOffer: Scalars['Boolean']['input'];
  /** Free Text area for footer */
  footerText?: InputMaybe<Scalars['String']['input']>;
  /** Free Text area for header */
  headerText?: InputMaybe<Scalars['String']['input']>;
  /** BC Job No */
  jobNo: Scalars['String']['input'];
  /** Description of the case task */
  lines: Array<OfferLineInput>;
  /** Current status on quote */
  oppertunityStatusCode?: InputMaybe<Scalars['String']['input']>;
  /** type of quote */
  quoteType: OfferQuoteTypeEnum;
};

export type OfferLine = {
  __typename?: 'OfferLine';
  /** Currencycode */
  currencyCode: Maybe<Scalars['String']['output']>;
  /** Description */
  description: Scalars['String']['output'];
  /** document nr / e.g Screening */
  documentNo: Scalars['String']['output'];
  /** ERP Reference task */
  eRPReferenceTask: Scalars['String']['output'];
  /** is line a header */
  header: Scalars['Boolean']['output'];
  /** hideSum */
  hideSum: Scalars['Boolean']['output'];
  /** Line amount */
  lineAmount: Scalars['Decimal']['output'];
  /** Line number */
  lineNo: Scalars['Int']['output'];
  /** new Price of unit */
  newUnitPrice: Maybe<Scalars['Decimal']['output']>;
  /** Item / resource reference id */
  no: Scalars['String']['output'];
  /** Offerline status */
  offerlineType: OfferLineStatus;
  /** option */
  option: Scalars['Boolean']['output'];
  /** Date of planning */
  planningDate: Scalars['String']['output'];
  /** Quantity */
  quantity: Scalars['Decimal']['output'];
  /** Refrence id to line in screening template */
  screeningLineId: Maybe<Scalars['String']['output']>;
  /** Sorting index (header and lines are grouped by sorting index) */
  sortingIndex: Scalars['Int']['output'];
  /** Id of entity */
  systemId: Maybe<Scalars['String']['output']>;
  /** Assortment type */
  type: OfferRessourceType;
  /** Unit Cost */
  unitCost: Scalars['Decimal']['output'];
  /** Price of unit */
  unitPrice: Scalars['Decimal']['output'];
  /** Type of work */
  workType: Maybe<Scalars['String']['output']>;
};

export type OfferLineInput = {
  /** CaseERPReferenceNo */
  caseERPReferenceNo: Scalars['String']['input'];
  /** Description (item description or free text if resource */
  description: Scalars['String']['input'];
  /** Document No */
  documentNo?: InputMaybe<Scalars['String']['input']>;
  /** ERP Reference Task */
  eRPReferenceTask: Scalars['String']['input'];
  /** is line a header */
  header: Scalars['Boolean']['input'];
  /** HideSum */
  hideSum: Scalars['Boolean']['input'];
  /** Line no */
  lineNo?: InputMaybe<Scalars['Int']['input']>;
  /** New Unit price */
  newUnitPrice: Scalars['Decimal']['input'];
  /** Item/Resource No */
  no: Scalars['String']['input'];
  /** Offerline Status */
  offerLineStatus: OfferLineStatus;
  /** Option */
  option: Scalars['Boolean']['input'];
  /** Planning date */
  planningDate: Scalars['String']['input'];
  /** Quantity */
  quantity: Scalars['Decimal']['input'];
  /** Sortingindex (Group lines and a headaer with sorting index) */
  sortingIndex: Scalars['Int']['input'];
  /** System Id */
  systemId?: InputMaybe<Scalars['String']['input']>;
  /** Type */
  type: OfferRessourceType;
  /** Unit price */
  unitPrice: Scalars['Decimal']['input'];
  /** Type of work */
  workType: Scalars['String']['input'];
};

export enum OfferLineStatus {
  Create = 'CREATE',
  Delete = 'DELETE',
  None = 'NONE',
  Update = 'UPDATE'
}

export enum OfferQuoteTypeEnum {
  Estimate = 'ESTIMATE',
  Guesstimate = 'GUESSTIMATE',
  Quote = 'QUOTE'
}

export enum OfferRessourceType {
  GlAccount = 'GL_ACCOUNT',
  Item = 'ITEM',
  Resource = 'RESOURCE',
  Text = 'TEXT'
}

export type PaymentSupplement = {
  __typename?: 'PaymentSupplement';
  /** Blocked */
  blocked: Maybe<Scalars['Boolean']['output']>;
  /** Payment supplement code */
  code: Maybe<Scalars['String']['output']>;
  /** Description */
  description: Scalars['String']['output'];
  /** Id of payment supplement */
  id: Scalars['String']['output'];
  /** Job task no for time tracking */
  jobTaskNo: Scalars['String']['output'];
  /** Template JobNo indicates if supplement is internal or external */
  templateJobNo: Scalars['String']['output'];
  /** Payment supplement type */
  type: Maybe<Scalars['String']['output']>;
  /** Unit of measure */
  uOM: Scalars['String']['output'];
  /** Work type for the supplement */
  workTypeCode: Scalars['String']['output'];
};

export enum Permissions {
  AdministrationCatalogsOwner = 'ADMINISTRATION_CATALOGS_OWNER',
  AdministrationGdpr = 'ADMINISTRATION_GDPR',
  AdministrationSiteView = 'ADMINISTRATION_SITE_VIEW',
  AdministrationUserManagement = 'ADMINISTRATION_USER_MANAGEMENT',
  AdministrationWorkplaceAssessment = 'ADMINISTRATION_WORKPLACE_ASSESSMENT',
  AllMachineToken = 'ALL_MACHINE_TOKEN',
  CasesAgreementsEdit = 'CASES_AGREEMENTS_EDIT',
  CasesAgreementsPrivate = 'CASES_AGREEMENTS_PRIVATE',
  CasesClose = 'CASES_CLOSE',
  CasesCreate = 'CASES_CREATE',
  CasesDocumentsDelete = 'CASES_DOCUMENTS_DELETE',
  CasesDocumentsView = 'CASES_DOCUMENTS_VIEW',
  CasesDrivingSlipsEdit = 'CASES_DRIVING_SLIPS_EDIT',
  CasesEconomyInvoicesEdit = 'CASES_ECONOMY_INVOICES_EDIT',
  CasesEconomyInvoicesView = 'CASES_ECONOMY_INVOICES_VIEW',
  CasesEconomyView = 'CASES_ECONOMY_VIEW',
  CasesEmailEdit = 'CASES_EMAIL_EDIT',
  CasesEstimateCalculation = 'CASES_ESTIMATE_CALCULATION',
  CasesExternalSystemCreate = 'CASES_EXTERNAL_SYSTEM_CREATE',
  CasesMasterDataEdit = 'CASES_MASTER_DATA_EDIT',
  CasesMasterDataInvoicesAddressView = 'CASES_MASTER_DATA_INVOICES_ADDRESS_VIEW',
  CasesOngoingWorkView = 'CASES_ONGOING_WORK_VIEW',
  CasesOpen = 'CASES_OPEN',
  CasesOwnCasesOnly = 'CASES_OWN_CASES_ONLY',
  CasesRelatedCaseCreate = 'CASES_RELATED_CASE_CREATE',
  CasesReportEdit = 'CASES_REPORT_EDIT',
  CasesUsageView = 'CASES_USAGE_VIEW',
  CasesView = 'CASES_VIEW',
  CasesViewExternal = 'CASES_VIEW_EXTERNAL',
  CasesWorkplaceAssessment = 'CASES_WORKPLACE_ASSESSMENT',
  CatalogsDebitorVerify = 'CATALOGS_DEBITOR_VERIFY',
  CatalogsDelete = 'CATALOGS_DELETE',
  CatalogsEdit = 'CATALOGS_EDIT',
  CatalogsInformationBoxEdit = 'CATALOGS_INFORMATION_BOX_EDIT',
  CatalogsVerify = 'CATALOGS_VERIFY',
  CatalogsView = 'CATALOGS_VIEW',
  DrivingSlipsView = 'DRIVING_SLIPS_VIEW',
  KpIsView = 'KP_IS_VIEW',
  MachinesEdit = 'MACHINES_EDIT',
  MachinesView = 'MACHINES_VIEW',
  MovablesEdit = 'MOVABLES_EDIT',
  MovablesView = 'MOVABLES_VIEW',
  MyPageView = 'MY_PAGE_VIEW',
  None = 'NONE',
  PlanningEdit = 'PLANNING_EDIT',
  PlanningView = 'PLANNING_VIEW',
  RequisitionEdit = 'REQUISITION_EDIT',
  RequisitionView = 'REQUISITION_VIEW',
  TasksEdit = 'TASKS_EDIT',
  TasksView = 'TASKS_VIEW',
  TimeTracking = 'TIME_TRACKING',
  TimeTrackingApprover = 'TIME_TRACKING_APPROVER',
  TimeTrackingDatePicker = 'TIME_TRACKING_DATE_PICKER',
  TimeTrackingResponsible = 'TIME_TRACKING_RESPONSIBLE'
}

export type Person = {
  __typename?: 'Person';
  /** Comment on person */
  comment: Maybe<Scalars['String']['output']>;
  /** Person email address */
  email: Scalars['String']['output'];
  /** Name of person */
  name: Scalars['String']['output'];
  /** Optional person phone number */
  phone: Scalars['String']['output'];
};

export type PersonInput = {
  /** Comment on person */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Person email address */
  email: Scalars['String']['input'];
  /** Name of person */
  name: Scalars['String']['input'];
  /** Optional person phone number */
  phone: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  activeUsersOnCase: Array<User>;
  allAssortments: Maybe<Array<Assortment>>;
  allDebitors: Array<DebitorBase>;
  allECBDebitors: Array<DebitorBase>;
  allQuestionnaireTemplates: Array<QuestionnaireTemplate>;
  apvs: Array<Apv>;
  assortments: Maybe<Array<Assortment>>;
  businessArea: BusinessArea;
  businessAreas: Array<BusinessArea>;
  /** Cars' calendar in specified date range */
  carCalendars: Array<CarCalendar>;
  carsWithCalendars: Array<Car>;
  case: Case;
  caseEconomicsOverview: CaseEconomicsOverview;
  caseEconomicsOverviewNew: CaseEconomicsOverview;
  caseEconomicsSpec: CaseEconomicSpecType;
  caseEconomicsSpecification: CaseEconomicsOverview;
  caseFile: FileRetriever;
  caseFiles: Array<EsdhFile>;
  /** Case usage */
  caseUsage: CaseUsage;
  caseUsageExcelOverview: Array<Scalars['Byte']['output']>;
  cases: Array<Case>;
  casesNotPostedInBc: Array<DraftInvoice>;
  catalog: Catalog;
  catalogContact: CatalogContact;
  catalogContacts: Maybe<Array<CatalogContact>>;
  catalogCraftsman: CatalogCraftsman;
  catalogCraftsmen: Maybe<Array<CatalogCraftsman>>;
  catalogCustomer: CatalogCustomer;
  catalogCustomerByAdId: Maybe<CatalogCustomer>;
  catalogCustomerByUserObjectId: Maybe<Array<Maybe<CatalogCustomer>>>;
  catalogCustomers: Array<CatalogCustomer>;
  catalogFile: FileRetriever;
  catalogs: Array<Catalog>;
  causeQuestions: Array<VisitationQuestion>;
  checkOpenMovable: Scalars['Boolean']['output'];
  closeOppertunityCodes: Maybe<Array<CloseOppertunityCode>>;
  closedDayByUser: Maybe<TimeTracking>;
  closedDayManagerList: Array<TimeTrackingUserDayClose>;
  collectionItem: CollectionItem;
  collectionItems: Array<CollectionItem>;
  currentUser: Maybe<User>;
  damageCategories: Array<DamageCategory>;
  damageCategoriesAdmin: Array<DamageCategory>;
  damageCategory: DamageCategory;
  damageCause: DamageCause;
  damageCauses: Array<DamageCause>;
  damageCausesAdmin: Array<DamageCause>;
  debitor: DebitorBase;
  debitorDelayScalepointConnection: Maybe<DebitorDelayScalepointConnection>;
  debitorDelayScalepointConnections: Array<DebitorDelayScalepointConnection>;
  debitorShipmentAddresses: Array<DebitorShipmentAddress>;
  debitors: Array<DebitorBase>;
  debitorsAndGroups: DebitorsWithGroups;
  debitorsByReferenceNo: Array<DebitorBase>;
  department: Array<Department>;
  departments: Array<Department>;
  departmentsAdmin: Array<Department>;
  departmentsRequisition: Array<Department>;
  draftInvoiceLineTypes: Array<DraftInvoiceLineType>;
  drivingSlip: DrivingSlip;
  drivingSlipCategories: Array<DrivingSlipCategory>;
  drivingSlipFile: FileRetriever;
  drivingSlipFiles: Maybe<Array<EsdhFile>>;
  drivingSlipItems: Array<Item>;
  drivingSlips: Array<DrivingSlip>;
  duplicateCases: Array<Case>;
  emailTemplates: Array<SharePointTemplate>;
  exportDrivingSlipsToExcel: Array<Scalars['Byte']['output']>;
  exportMovableToExcel: Array<Scalars['Byte']['output']>;
  featureFlags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  flexTimeManagerList: Array<TimeTrackingUserFlexTime>;
  gdprAccept: Maybe<Gdpr>;
  getDistance: DistanceRetriever;
  getJobLedgerEntrySummary: Maybe<JobLedgerEntrySummary>;
  globalCatalogFiles: Array<EsdhFile>;
  groupsPermissions: Array<GroupPermission>;
  in4moDamageTypes: Array<In4moDamageType>;
  in4moTaskTypes: Array<In4moTaskType>;
  inputFields: Array<InputField>;
  inputFieldsAll: Array<InputField>;
  invoice: DraftInvoice;
  invoiceHeaders: Array<InvoiceHeader>;
  invoicePredictions: AiInvoicePrediction;
  invoiceReasonCode: InvoiceReasonCode;
  invoiceReasonCodes: Array<InvoiceReasonCode>;
  invoiceResources: Array<Resource>;
  invoices: Array<DraftInvoice>;
  invoicesForUsersApproval: Array<CaseInvoiceApprovalInfo>;
  items: Maybe<Array<Item>>;
  jobTasks: Maybe<Array<Maybe<JobTask>>>;
  jobs: Array<Job>;
  latestCatalog: Array<Catalog>;
  latestDayByUser: Maybe<TimeTracking>;
  locations: Array<Location>;
  locationsAdmin: Array<Location>;
  logData: Scalars['String']['output'];
  logDataPeriod: Scalars['String']['output'];
  machine: Maybe<Machine>;
  machineCaseOverview: Array<MachineCaseOverview>;
  machineGuideFiles: Array<EsdhFile>;
  machineHistory: Array<Machine>;
  machineLocations: Array<MachineLocation>;
  machineTypes: Array<Scalars['String']['output']>;
  machines: Array<Machine>;
  machinesForNotification: Array<CaseMachineNotificaton>;
  machinesForNotificationOld: Array<CaseMachineNotificaton>;
  machinesOnCase: Array<Machine>;
  machinesPreviouslyOnCase: Array<Machine>;
  movable: Movable;
  movableExcelOverview: Array<Scalars['Byte']['output']>;
  movableInvoiceableStatusOptions: Array<BoolKvp>;
  movableStatusOptions: Array<Scalars['String']['output']>;
  movables: Array<Movable>;
  movablesLocations: Array<MovablesLocation>;
  multipleUsers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  notificationConfig: Maybe<NotificationConfig>;
  notificationConfigs: Array<NotificationConfig>;
  notificationItems: Array<NotificationItem>;
  offers: Maybe<Array<Offer>>;
  openTimeRegistrationsOnCase: Scalars['Boolean']['output'];
  paymentSupplements: Array<Maybe<PaymentSupplement>>;
  questionnaireTemplateByDrivingSlip: Maybe<QuestionnaireTemplate>;
  questionnaireTemplatesByDrivingSlips: Array<QuestionnaireTemplate>;
  questions: Array<VisitationQuestion>;
  /** Gets all the rejected time trackings for a given user. It looks in the database and in BC to get all rejections */
  rejectedTimeTrackingsDayForUser: Array<TimeTrackingDay>;
  /** Gets all the rejected time trackings for a given user. It looks in the database and in BC to get all rejections */
  rejectedTimeTrackingsForUser: Array<TimeTracking>;
  requisition: Requisition;
  requisitions: Array<Requisition>;
  resources: Maybe<Array<Resource>>;
  riskEvaluationCategories: Array<RiskEvaluationCategory>;
  riskEvaluationQuestion: RiskEvaluationQuestion;
  riskEvaluationQuestions: Array<RiskEvaluationQuestion>;
  riskEvaluationQuestionsByCategoryId: Array<RiskEvaluationQuestion>;
  salesInvoiceLines: Array<SalesInvoiceLine>;
  samplePriceForLine: SamplePriceResult;
  samplePriceForOffer: SamplePriceResult;
  /** Fetches all screening position help texts */
  screeningPositionTexts: Array<ScreeningPositionText>;
  /** Fetches all screening templates */
  screeningTemplates: Array<Screening>;
  searchCasesByERPNo: Array<Case>;
  searchUsers: Array<User>;
  setting: Array<Settings>;
  smsTemplates: Array<SharePointTemplate>;
  ssgSetup: Maybe<SsgSetup>;
  testError: Maybe<Scalars['String']['output']>;
  timeTracking: TimeTracking;
  timeTrackingClosedDayManagerList: Array<TimeTrackingUserDayClose>;
  timeTrackingDay: TimeTrackingDay;
  timeTrackingDayClosedByUser: Maybe<TimeTrackingDay>;
  timeTrackingDayLatestByUser: Maybe<TimeTrackingDay>;
  timeTrackingDays: Array<TimeTrackingDay>;
  timeTrackingEntryLog: Array<TimeTrackingEntry>;
  timeTrackingRejectedDaysManagerList: Array<TimeTrackingDay>;
  timeTrackingUsersMissingClosedDay: Array<Scalars['String']['output']>;
  timeTrackings: Array<TimeTracking>;
  timeTrackingsDayForUser: Maybe<TimeTrackingDay>;
  timeTrackingsDayForUserBC: Array<TimeTrackingDay>;
  timeTrackingsForUser: Array<TimeTracking>;
  timeTrackingsForUserBC: Array<TimeTracking>;
  timeTrackingsInBcWithoutApproval: Array<TimeTrackingEntry>;
  timedMessage: TimedMessage;
  timedMessages: Array<TimedMessage>;
  unitOfMeasures: Array<Item>;
  userBasisTime: Scalars['Float']['output'];
  /** Users' calendar in specified date range */
  userCalendars: Array<UserCalendar>;
  userCheck: Maybe<User>;
  userFlexTime: Maybe<Scalars['Decimal']['output']>;
  users: Array<User>;
  usersMissingClosedDay: Array<Scalars['String']['output']>;
  usersWithCalendars: Array<User>;
  vehicles: Array<Vehicle>;
  vendor: Maybe<Vendor>;
  vendors: Array<Vendor>;
  workEnvRegulationsManagerList: Array<WorkerRestPeriod>;
  workTypes: Maybe<Array<WorkType>>;
};


export type QueryActiveUsersOnCaseArgs = {
  caseId: Scalars['String']['input'];
};


export type QueryAllAssortmentsArgs = {
  assortmentCode: Scalars['String']['input'];
};


export type QueryAssortmentsArgs = {
  assortmentCode: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryBusinessAreaArgs = {
  id: Scalars['String']['input'];
};


export type QueryCarCalendarsArgs = {
  carIdList: Array<Scalars['String']['input']>;
  dateRange: DateRangeInput;
};


export type QueryCaseArgs = {
  id: Scalars['String']['input'];
};


export type QueryCaseEconomicsOverviewArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryCaseEconomicsOverviewNewArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryCaseEconomicsSpecArgs = {
  erpReferenceId: Scalars['String']['input'];
};


export type QueryCaseEconomicsSpecificationArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryCaseFileArgs = {
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaseFilesArgs = {
  caseErpNo?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaseUsageArgs = {
  erpNo: Scalars['String']['input'];
};


export type QueryCaseUsageExcelOverviewArgs = {
  erpNo: Scalars['String']['input'];
};


export type QueryCasesArgs = {
  address?: InputMaybe<AddressInput>;
  anyManager?: InputMaybe<Scalars['String']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
  areaResponsible?: InputMaybe<Array<Scalars['String']['input']>>;
  awaiting?: InputMaybe<Scalars['Boolean']['input']>;
  calledBack?: InputMaybe<Scalars['Boolean']['input']>;
  caseManager?: InputMaybe<Array<Scalars['String']['input']>>;
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Array<Scalars['String']['input']>>;
  damageCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  damageCause?: InputMaybe<Array<Scalars['String']['input']>>;
  damageServiceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  debitor?: InputMaybe<Array<Scalars['String']['input']>>;
  department?: InputMaybe<Array<Scalars['String']['input']>>;
  erpReferenceNo?: InputMaybe<Scalars['String']['input']>;
  erpReferenceNos?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  favoriteCases?: InputMaybe<Scalars['Boolean']['input']>;
  favoriteColors?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  machineNotification?: InputMaybe<Scalars['Boolean']['input']>;
  machinesOnCase?: InputMaybe<Scalars['Boolean']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownCases?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<Array<CasePriority>>;
  priorityCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  projectManager?: InputMaybe<Array<Scalars['String']['input']>>;
  readyForInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  track?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryCatalogArgs = {
  id: Scalars['String']['input'];
};


export type QueryCatalogContactArgs = {
  id: Scalars['String']['input'];
};


export type QueryCatalogContactsArgs = {
  catalogId?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<CatalogContacts>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  globalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notGlobalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCatalogCraftsmanArgs = {
  id: Scalars['String']['input'];
};


export type QueryCatalogCraftsmenArgs = {
  catalogId?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  globalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notGlobalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalogCustomerArgs = {
  id: Scalars['String']['input'];
};


export type QueryCatalogCustomerByAdIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCatalogCustomersArgs = {
  ownCustomers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCatalogFileArgs = {
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalogsArgs = {
  address?: InputMaybe<AddressInput>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  debitorVerified?: InputMaybe<Scalars['Boolean']['input']>;
  debitors?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  noDebitor?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  smsService?: InputMaybe<Scalars['Boolean']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userObjectIDForTest?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCauseQuestionsArgs = {
  damageCause: Scalars['String']['input'];
};


export type QueryCheckOpenMovableArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryClosedDayByUserArgs = {
  user: Scalars['String']['input'];
};


export type QueryCollectionItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryCollectionItemsArgs = {
  type?: InputMaybe<CollectionItemType>;
};


export type QueryDamageCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryDamageCauseArgs = {
  id: Scalars['String']['input'];
};


export type QueryDamageCausesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDamageCausesAdminArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDebitorArgs = {
  id: Scalars['String']['input'];
};


export type QueryDebitorDelayScalepointConnectionArgs = {
  damageCauseId: Scalars['String']['input'];
  debitorId: Scalars['String']['input'];
};


export type QueryDebitorShipmentAddressesArgs = {
  id: Scalars['String']['input'];
};


export type QueryDebitorsArgs = {
  catalogUser?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDebitorsAndGroupsArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDebitorsByReferenceNoArgs = {
  referenceNoList: Array<Scalars['String']['input']>;
};


export type QueryDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryDepartmentsArgs = {
  operationManager?: InputMaybe<Scalars['String']['input']>;
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDepartmentsAdminArgs = {
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDepartmentsRequisitionArgs = {
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDrivingSlipArgs = {
  id: Scalars['String']['input'];
};


export type QueryDrivingSlipFileArgs = {
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type QueryDrivingSlipFilesArgs = {
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
};


export type QueryDrivingSlipItemsArgs = {
  drivingSlipCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDrivingSlipsArgs = {
  case?: InputMaybe<Scalars['String']['input']>;
  caseERPReferenceNo?: InputMaybe<Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  debitor?: InputMaybe<Array<Scalars['String']['input']>>;
  debitors?: InputMaybe<Array<Scalars['String']['input']>>;
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers?: InputMaybe<Array<Scalars['String']['input']>>;
  drivingSlipCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  priorityCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  seriesId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDuplicateCasesArgs = {
  address: AddressInput;
  caseId: Scalars['String']['input'];
  damageCategory: Scalars['String']['input'];
  hasScalepointUrl: Scalars['Boolean']['input'];
};


export type QueryExportDrivingSlipsToExcelArgs = {
  case?: InputMaybe<Scalars['String']['input']>;
  caseERPReferenceNo?: InputMaybe<Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  debitor?: InputMaybe<Array<Scalars['String']['input']>>;
  debitors?: InputMaybe<Array<Scalars['String']['input']>>;
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers?: InputMaybe<Array<Scalars['String']['input']>>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  priorityCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  seriesId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExportMovableToExcelArgs = {
  filters: MovableSearchFiltersInputType;
};


export type QueryGdprAcceptArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetDistanceArgs = {
  fromAddress: AddressInput;
  toAddress: AddressInput;
};


export type QueryGetJobLedgerEntrySummaryArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryGlobalCatalogFilesArgs = {
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInputFieldsArgs = {
  keys: Array<Scalars['String']['input']>;
};


export type QueryInvoiceArgs = {
  caseId: Scalars['String']['input'];
  invoiceNo: Scalars['String']['input'];
};


export type QueryInvoiceHeadersArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryInvoicePredictionsArgs = {
  invoicePredictionInput: AiInvoicePredictionInputType;
};


export type QueryInvoiceReasonCodeArgs = {
  id: Scalars['String']['input'];
};


export type QueryInvoicesArgs = {
  caseId: Scalars['String']['input'];
};


export type QueryInvoicesForUsersApprovalArgs = {
  department?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryJobTasksArgs = {
  erpReferenceNo: Scalars['String']['input'];
};


export type QueryJobsArgs = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  proxyFor?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<JobType>;
};


export type QueryLatestCatalogArgs = {
  date: Scalars['Date']['input'];
};


export type QueryLatestDayByUserArgs = {
  user: Scalars['String']['input'];
};


export type QueryLocationsArgs = {
  movableLocationsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationsAdminArgs = {
  movableLocationsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLogDataPeriodArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
};


export type QueryMachineArgs = {
  machineERPReferenceNo: Scalars['String']['input'];
};


export type QueryMachineCaseOverviewArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryMachineGuideFilesArgs = {
  filter?: InputMaybe<FileFilterInput>;
};


export type QueryMachineHistoryArgs = {
  machineERPReferenceNo: Scalars['String']['input'];
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryMachinesArgs = {
  cases?: InputMaybe<Array<Scalars['String']['input']>>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  hibernation?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reservationByRessource?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MachineStatus>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMachinesOnCaseArgs = {
  erpNo: Scalars['String']['input'];
};


export type QueryMachinesPreviouslyOnCaseArgs = {
  erpNo: Scalars['String']['input'];
};


export type QueryMovableArgs = {
  id: Scalars['String']['input'];
};


export type QueryMovableExcelOverviewArgs = {
  caseId: Scalars['String']['input'];
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMovableInvoiceableStatusOptionsArgs = {
  erpNo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMovablesArgs = {
  case?: InputMaybe<Scalars['String']['input']>;
  debitors?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryMovablesLocationsArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationConfigArgs = {
  trigger: NotificationTrigger;
};


export type QueryNotificationItemsArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOffersArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryOpenTimeRegistrationsOnCaseArgs = {
  caseERPReferenceNo: Scalars['String']['input'];
};


export type QueryQuestionnaireTemplateByDrivingSlipArgs = {
  damageCauseId: Scalars['String']['input'];
  drivingSlipCategoryCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuestionnaireTemplatesByDrivingSlipsArgs = {
  drivingSlips: Array<QuestionnaireTemplateByDrivingSlipInput>;
};


export type QueryRejectedTimeTrackingsDayForUserArgs = {
  user: Scalars['String']['input'];
};


export type QueryRejectedTimeTrackingsForUserArgs = {
  user: Scalars['String']['input'];
};


export type QueryRequisitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryRequisitionsArgs = {
  caseId?: InputMaybe<Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']>>;
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  myRequisitionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<RequisitionType>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourcesArgs = {
  ressourceType: Scalars['String']['input'];
};


export type QueryRiskEvaluationQuestionArgs = {
  id: Scalars['String']['input'];
};


export type QueryRiskEvaluationQuestionsByCategoryIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySalesInvoiceLinesArgs = {
  offerERPReferenceNo: Scalars['String']['input'];
};


export type QuerySamplePriceForLineArgs = {
  offerLine: OfferLineInput;
};


export type QuerySamplePriceForOfferArgs = {
  offer: OfferInput;
};


export type QueryScreeningPositionTextsArgs = {
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  templateCodes?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCasesByErpNoArgs = {
  erpNo: Scalars['String']['input'];
};


export type QuerySearchUsersArgs = {
  checkInBc?: InputMaybe<Scalars['Boolean']['input']>;
  onlyEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  searchText: Scalars['String']['input'];
};


export type QuerySettingArgs = {
  type: Scalars['String']['input'];
};


export type QueryTimeTrackingArgs = {
  id: Scalars['String']['input'];
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryTimeTrackingDayArgs = {
  id: Scalars['String']['input'];
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryTimeTrackingDayClosedByUserArgs = {
  user: Scalars['String']['input'];
};


export type QueryTimeTrackingDayLatestByUserArgs = {
  user: Scalars['String']['input'];
};


export type QueryTimeTrackingDaysArgs = {
  cases?: InputMaybe<Array<Scalars['String']['input']>>;
  debitors?: InputMaybe<Array<Scalars['String']['input']>>;
  jobTaskNo?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  timeTrackingDayStatus?: InputMaybe<TimeTrackingDayStatus>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTimeTrackingEntryLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryTimeTrackingsArgs = {
  cases?: InputMaybe<Array<Scalars['String']['input']>>;
  debitors?: InputMaybe<Array<Scalars['String']['input']>>;
  jobTaskNo?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  trackingType?: InputMaybe<TrackingType>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTimeTrackingsDayForUserArgs = {
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  user: Scalars['String']['input'];
};


export type QueryTimeTrackingsDayForUserBcArgs = {
  user: Scalars['String']['input'];
};


export type QueryTimeTrackingsForUserArgs = {
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  user: Scalars['String']['input'];
};


export type QueryTimeTrackingsForUserBcArgs = {
  user: Scalars['String']['input'];
};


export type QueryTimeTrackingsInBcWithoutApprovalArgs = {
  erpNo: Scalars['String']['input'];
};


export type QueryTimedMessageArgs = {
  id: Scalars['String']['input'];
};


export type QueryTimedMessagesArgs = {
  catalogId?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  globalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  notGlobalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryUserBasisTimeArgs = {
  date: Scalars['Date']['input'];
  user: Scalars['String']['input'];
};


export type QueryUserCalendarsArgs = {
  dateRange: DateRangeInput;
  userIdList: Array<Scalars['String']['input']>;
};


export type QueryUserCheckArgs = {
  adUserName: Scalars['String']['input'];
};


export type QueryUserFlexTimeArgs = {
  user: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  external?: InputMaybe<Scalars['Boolean']['input']>;
  hasProxy?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedBefore?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryVehiclesArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  isCar: Scalars['Boolean']['input'];
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryVendorArgs = {
  id: Scalars['String']['input'];
};


export type QueryVendorsArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionnaireChoice = {
  __typename?: 'QuestionnaireChoice';
  /** Questionnaire choice help text */
  helpText: Maybe<Scalars['String']['output']>;
  /** Questionnaire choice id */
  id: Scalars['String']['output'];
  /** Questionnaire choice is MultiSelect */
  isMultiSelectAllowed: Scalars['Boolean']['output'];
  /** Questionnaire choice is optional */
  isOptional: Scalars['Boolean']['output'];
  /** Questionnaire choice label */
  label: Scalars['String']['output'];
  /** Questionnaire MultiSelect Values */
  multiSelectValues: Maybe<Array<Scalars['String']['output']>>;
  /** Questionnaire choice parent id */
  parentId: Scalars['String']['output'];
  /** Questionnaire choice placeholder */
  placeholder: Maybe<Scalars['String']['output']>;
  /** Questionnaire choice will trigger a change to track two if case is track one (only for list options) */
  triggersTrackTwoChange: Scalars['Boolean']['output'];
  /** Questionnaire choice type */
  type: QuestionnaireChoiceType;
  /** Unit of measurement for the choice value */
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  /** Questionnaire choice value */
  value: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireChoiceInputType = {
  /** Questionnaire choice help text */
  helpText?: InputMaybe<Scalars['String']['input']>;
  /** Questionnaire choice id */
  id: Scalars['String']['input'];
  /** Questionnaire choice is Multiselect */
  isMultiSelectAllowed: Scalars['Boolean']['input'];
  /** Questionnaire choice is optional */
  isOptional: Scalars['Boolean']['input'];
  /** Questionnaire choice label */
  label: Scalars['String']['input'];
  /** Questionnaire choice Multiselect values */
  multiSelectValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Questionnaire choice parent id */
  parentId: Scalars['String']['input'];
  /** Questionnaire choice placeholder */
  placeholder?: InputMaybe<Scalars['String']['input']>;
  /** Questionnaire choice will trigger a change to track two if case is track one (only for list options) */
  triggersTrackTwoChange?: InputMaybe<Scalars['Boolean']['input']>;
  /** Questionnaire choice type */
  type: QuestionnaireChoiceType;
  /** Unit of measurement for the choice value */
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  /** Questionnaire choice value */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionnaireChoiceType {
  Dropdown = 'DROPDOWN',
  FreeText = 'FREE_TEXT',
  Number = 'NUMBER',
  RadioGroup = 'RADIO_GROUP',
  SelectOption = 'SELECT_OPTION',
  Null = '_NULL_'
}

export enum QuestionnaireCompletionStatus {
  Completed = 'COMPLETED',
  NotComplete = 'NOT_COMPLETE',
  Null = '_NULL_'
}

export type QuestionnaireSection = {
  __typename?: 'QuestionnaireSection';
  /** Correlates the section to a case agreement category */
  caseAgreementCategory: CaseAgreementCategory;
  /** Questionnaire section choices */
  choices: Array<QuestionnaireChoice>;
  /** Questionnaire section label */
  label: Scalars['String']['output'];
  /** A photo is required to complete the questionnaire section */
  photoRequired: Scalars['Boolean']['output'];
  /** Defines whether it should be saved in ScalePoint via case agreements */
  shouldSaveInScalePoint: Scalars['Boolean']['output'];
};

export type QuestionnaireSectionInputType = {
  /** Correlates the section to a case agreement category */
  caseAgreementCategory: CaseAgreementCategory;
  /** Questionnaire section choices */
  choices: Array<QuestionnaireChoiceInputType>;
  /** Questionnaire section label */
  label: Scalars['String']['input'];
  /** A photo is required to complete the questionnaire section */
  photoRequired: Scalars['Boolean']['input'];
  /** Defines whether it should be saved in ScalePoint via case agreements */
  shouldSaveInScalePoint: Scalars['Boolean']['input'];
};

export type QuestionnaireTemplate = {
  __typename?: 'QuestionnaireTemplate';
  /** Questionnaire change log */
  changes: Array<QuestionnaireTemplateChange>;
  /** Timestamp of when the questionnaire was created */
  createdAt: Scalars['DateTime']['output'];
  /** Questionnaire damage causes */
  damageCauses: Array<Scalars['String']['output']>;
  /** Questionnaire driving slip categories */
  drivingSlipCategories: Array<Scalars['String']['output']>;
  /** Unique id of questionnaire */
  id: Scalars['String']['output'];
  /** Questionnaire label */
  label: Scalars['String']['output'];
  /** Questionnaire sections */
  sections: Array<QuestionnaireSection>;
  /** Timestamp of when the questionnaire was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Questionnaire change version number */
  version: Scalars['Int']['output'];
};

export type QuestionnaireTemplateByDrivingSlipInput = {
  /** Driving slip category code */
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** Driving slip damage cause id */
  damageCauseId: Scalars['String']['input'];
};

export type QuestionnaireTemplateChange = {
  __typename?: 'QuestionnaireTemplateChange';
  /** Value after */
  after: QuestionnaireTemplateChangeDifference;
  /** Value before */
  before: QuestionnaireTemplateChangeDifference;
  /** Time of change */
  timestamp: Scalars['DateTime']['output'];
  /** User who performed the change */
  user: User;
};

export type QuestionnaireTemplateChangeDifference = {
  __typename?: 'QuestionnaireTemplateChangeDifference';
  /** Questionnaire damage causes */
  damageCauses: Maybe<Array<Scalars['String']['output']>>;
  /** Questionnaire driving slip category */
  drivingSlipCategory: Maybe<Array<Scalars['String']['output']>>;
  /** Questionnaire label */
  label: Maybe<Scalars['String']['output']>;
  /** Questionnaire sections */
  sections: Maybe<Array<QuestionnaireSection>>;
};

export type QuestionnaireTemplateInput = {
  /** Questionnaire damage causes */
  damageCauses: Array<Scalars['String']['input']>;
  /** Questionnaire driving slip categories */
  drivingSlipCategories: Array<Scalars['String']['input']>;
  /** Questionnaire label */
  label: Scalars['String']['input'];
  /** Questionnaire sections */
  sections: Array<QuestionnaireSectionInputType>;
};

export type ReportFile = {
  __typename?: 'ReportFile';
  /** User provided file description */
  description: Scalars['String']['output'];
  /** Name of file (with extension) */
  fileName: Scalars['String']['output'];
};

export type ReportFileInput = {
  /** User provided file description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of file (with extension) */
  fileName: Scalars['String']['input'];
};

export enum ReportFormatType {
  Pdf = 'PDF',
  Word = 'WORD'
}

export type Requisition = {
  __typename?: 'Requisition';
  /** case owning the requisition */
  case: Maybe<Case>;
  /** Timestamp of when the requisition was created */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the requisition */
  createdBy: User;
  /** location owning the requisition */
  department: Maybe<Department>;
  /** description of the requisition */
  description: Scalars['String']['output'];
  /** driving slip owning the requisition */
  drivingSlip: Maybe<DrivingSlip>;
  /** Whether an email has been sent to the vendor */
  emailHasBeenSent: Scalars['Boolean']['output'];
  /** id of the requisition */
  id: Scalars['String']['output'];
  /** orderNumber of the requisition */
  orderNumber: Scalars['String']['output'];
  /** Requisition status */
  status: Scalars['Boolean']['output'];
  /** the type of the requisition */
  type: RequisitionType;
  /** the vendor of the requisition */
  vendor: Maybe<Vendor>;
  /** email of the vendor */
  vendorEmail: Maybe<Scalars['String']['output']>;
  /** name of the vendor */
  vendorName: Scalars['String']['output'];
  /** phone number of the vendor */
  vendorPhoneNumber: Scalars['String']['output'];
};

export type RequisitionInput = {
  /** description of the requisition */
  description: Scalars['String']['input'];
  /** the type of the requisition */
  type: RequisitionType;
  /** the email of the vendor */
  vendorEmail?: InputMaybe<Scalars['String']['input']>;
  /** the name of the vendor */
  vendorName: Scalars['String']['input'];
  /** id of the vendor in the ERP system */
  vendorNo?: InputMaybe<Scalars['String']['input']>;
  /** the phone number of the vendor */
  vendorPhoneNumber: Scalars['String']['input'];
};

export enum RequisitionType {
  Material = 'MATERIAL',
  Subcontractor = 'SUBCONTRACTOR'
}

export type Requisitioner = {
  __typename?: 'Requisitioner';
  /** Comment on person */
  comment: Maybe<Scalars['String']['output']>;
  /** Person email address */
  email: Scalars['String']['output'];
  /** Name of person */
  name: Scalars['String']['output'];
  /** Optional person phone number */
  phone: Scalars['String']['output'];
  /** Requisitioner relation */
  relation: Scalars['String']['output'];
};

export type RequisitionerInput = {
  /** Comment on person */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Person email address */
  email: Scalars['String']['input'];
  /** Name of person */
  name: Scalars['String']['input'];
  /** Optional person phone number */
  phone: Scalars['String']['input'];
  /** Requisitioner relation */
  relation: Scalars['String']['input'];
};

export type Resource = {
  __typename?: 'Resource';
  /** baseUOM e.g Time  */
  baseUOM: Scalars['String']['output'];
  /** Resource Name */
  name: Scalars['String']['output'];
  /** Resource No */
  no: Scalars['String']['output'];
  /** Resource type */
  type: Scalars['String']['output'];
};

export type RiskEvaluationAnswerInput = {
  /** Answer given */
  answer: Scalars['Boolean']['input'];
  /** Id of question */
  question: Scalars['String']['input'];
};

export type RiskEvaluationAnswers = {
  __typename?: 'RiskEvaluationAnswers';
  /** Answer given */
  answer: Scalars['Boolean']['output'];
  /** Id of question answer is linked to */
  question: RiskEvaluationQuestion;
};

export type RiskEvaluationCategory = {
  __typename?: 'RiskEvaluationCategory';
  /** Name of risk category */
  categoryName: Scalars['String']['output'];
  /** Id of risk category */
  id: Scalars['String']['output'];
};

export type RiskEvaluationCategoryInput = {
  /** Name of risk category */
  categoryName: Scalars['String']['input'];
};

export type RiskEvaluationQuestion = {
  __typename?: 'RiskEvaluationQuestion';
  /** Id of category question is linked to */
  category: RiskEvaluationCategory;
  /** If a drivingslip is made during casecreation this question will be marked true on risk evaluation */
  defaultChecked: Scalars['Boolean']['output'];
  /** Help text for question */
  helpText: Scalars['String']['output'];
  /** Id of question */
  id: Scalars['String']['output'];
  /** Question */
  question: Scalars['String']['output'];
};

export type RiskEvaluationQuestionInput = {
  /** Id of category question is linked to */
  category: Scalars['String']['input'];
  /** If a drivingslip is made during casecreation this question will be marked true on risk evaluation */
  defaultChecked: Scalars['Boolean']['input'];
  /** Help text for question */
  helpText: Scalars['String']['input'];
  /** Question */
  question: Scalars['String']['input'];
};

export enum RiskEvaluationStatus {
  Accepted = 'ACCEPTED',
  NotAccepted = 'NOT_ACCEPTED',
  Null = '_NULL_'
}

export type SmsSettings = {
  __typename?: 'SMSSettings';
  /** Endpoint */
  endpoint: Scalars['String']['output'];
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** Name of sender */
  originator: Scalars['String']['output'];
  /** SMS service password */
  password: Scalars['String']['output'];
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
  /** SMS service username */
  username: Scalars['String']['output'];
};

export type SmsSettingsInput = {
  /** Endpoint */
  endpoint: Scalars['String']['input'];
  /** Name of sender */
  originator: Scalars['String']['input'];
  /** SMS service password */
  password: Scalars['String']['input'];
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
  /** SMS service username */
  username: Scalars['String']['input'];
};

export type SpDamageMapping = {
  __typename?: 'SPDamageMapping';
  /** Damage categories mappings */
  damageCategories: Array<StringKvp>;
  /** Damage causes mappings */
  damageCauses: Array<StringKvp>;
  /** Insurance company name */
  insuranceCompany: Scalars['String']['output'];
};

export type SpDamageMappingInput = {
  /** Damage categories mappings */
  damageCategories: Array<StringKvpInput>;
  /** Damage causes mappings */
  damageCauses: Array<StringKvpInput>;
  /** Insurance company name */
  insuranceCompany: Scalars['String']['input'];
};

export type SpDebitorMapping = {
  __typename?: 'SPDebitorMapping';
  /** Debitor mapping */
  debitor: Scalars['String']['output'];
  /** Insurance company name */
  insuranceCompany: Scalars['String']['output'];
  /** Insurance sub company name */
  insuranceSubCompany: Maybe<Scalars['String']['output']>;
};

export type SpDebitorMappingInput = {
  /** Debitor mapping */
  debitor: Scalars['String']['input'];
  /** Insurance company name */
  insuranceCompany: Scalars['String']['input'];
  /** Insurance sub company name */
  insuranceSubCompany?: InputMaybe<Scalars['String']['input']>;
};

export type SpLogin = {
  __typename?: 'SPLogin';
  /** Damage categories that should have the 'Content' prefix */
  contentSectorCategories: Array<Scalars['String']['output']>;
  /** Debitors that uses this setting */
  debitors: Array<Scalars['String']['output']>;
  /** Insurance company name */
  insuranceCompany: Scalars['String']['output'];
  /** ScalePoint token */
  token: Scalars['String']['output'];
  /** ScalePoint user login name */
  userLogin: Scalars['String']['output'];
};

export type SpLoginInput = {
  /** Damage categories that should have the 'Content' prefix */
  contentSectorCategories: Array<Scalars['String']['input']>;
  /** Debitors that uses this setting */
  debitors: Array<Scalars['String']['input']>;
  /** Insurance company name */
  insuranceCompany: Scalars['String']['input'];
  /** ScalePoint token */
  token: Scalars['String']['input'];
  /** ScalePoint user login name */
  userLogin: Scalars['String']['input'];
};

export type SpSettings = {
  __typename?: 'SPSettings';
  /** Scalepoint damageMappings */
  damageMappings: Array<SpDamageMapping>;
  /** Scalepoint debitorMappings */
  debitorMappings: Array<SpDebitorMapping>;
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** Scalepoint logins */
  logins: Array<SpLogin>;
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
};

export type SpSettingsInput = {
  /** Scalepoint damage mappings */
  damageMappings: Array<SpDamageMappingInput>;
  /** Scalepoint debitor mappings */
  debitorMappings: Array<SpDebitorMappingInput>;
  /** Scalepoint logins */
  logins: Array<SpLoginInput>;
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
};

export enum SalesHeaderEnum {
  Activate = 'ACTIVATE',
  Cancel = 'CANCEL',
  Update = 'UPDATE'
}

export type SalesInvoiceLine = {
  __typename?: 'SalesInvoiceLine';
  /** Amount including vat Tax */
  amountIncludingVAT: Maybe<Scalars['Decimal']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Document number (planningline reference) */
  documentNo: Maybe<Scalars['String']['output']>;
  /** Exclude In the enviromental fee */
  excludeInEnvFee: Maybe<Scalars['Boolean']['output']>;
  /** Exclude in the supply fee */
  excludeInSupplyFee: Maybe<Scalars['Boolean']['output']>;
  /** Line discount amount */
  lineDiscountAmount: Maybe<Scalars['Decimal']['output']>;
  /** Line discount percentage */
  lineDiscountPercentage: Maybe<Scalars['Decimal']['output']>;
  /** Line identifier */
  lineNo: Maybe<Scalars['Int']['output']>;
  /** Unique identifier */
  no: Maybe<Scalars['String']['output']>;
  /** Quantity */
  quantity: Maybe<Scalars['Decimal']['output']>;
  /** System Id */
  systemId: Scalars['String']['output'];
  /** line type */
  type: Maybe<Scalars['String']['output']>;
  /** Price of unit */
  unitPrice: Maybe<Scalars['Decimal']['output']>;
  /** Unit of measure */
  uom: Maybe<Scalars['String']['output']>;
  /** Vat tax base amount */
  vatBaseAmount: Maybe<Scalars['Decimal']['output']>;
  /** Vat tax percentage */
  vatPercentage: Maybe<Scalars['Decimal']['output']>;
};

export type SamplePriceResult = {
  __typename?: 'SamplePriceResult';
  /** Total line amount */
  lineAmount: Scalars['Decimal']['output'];
  /** Total cost */
  totalCost: Scalars['Decimal']['output'];
};

export enum ScalePointMergeDirection {
  MergedFrom = 'MERGED_FROM',
  MergedInto = 'MERGED_INTO'
}

export type ScalePointMergeInfo = {
  __typename?: 'ScalePointMergeInfo';
  /** ScalePoint merge info case id */
  caseId: Scalars['String']['output'];
  /** ScalePoint merge info direction */
  direction: ScalePointMergeDirection;
};

export enum ScalePointStatus {
  Approved = 'APPROVED',
  Connected = 'CONNECTED',
  Errored = 'ERRORED',
  NotConnected = 'NOT_CONNECTED',
  Rejected = 'REJECTED'
}

export type Screening = {
  __typename?: 'Screening';
  /** User provided screening description */
  description: Scalars['String']['output'];
  /** Screening reference id */
  erpReferenceId: Maybe<Scalars['String']['output']>;
  /** Screening reference number */
  erpReferenceNo: Maybe<Scalars['String']['output']>;
  /** Screening template lines */
  lines: Array<ScreeningLine>;
  /** Indicates if screening has been marked for invoicing */
  markedForInvoice: Scalars['Boolean']['output'];
  /** Indicates if screening has been marked for invoicing and are allowed to reopen */
  reopenAllowed: Scalars['Boolean']['output'];
  /** Screening template code */
  templateCode: Scalars['String']['output'];
  /** Screening template id */
  templateId: Scalars['String']['output'];
  /** Screening template name */
  templateName: Scalars['String']['output'];
};

export type ScreeningLine = {
  __typename?: 'ScreeningLine';
  /** Determines if user can override title */
  allowCustomTitle: Scalars['Boolean']['output'];
  /** Screening line title (when set) */
  customTitle: Maybe<Scalars['String']['output']>;
  /** Screening line ERP reference account */
  erpReferenceAccount: Scalars['String']['output'];
  /** Identifier used in ERP system */
  erpReferenceId: Scalars['String']['output'];
  /** Screening line ERP reference task */
  erpReferenceTask: Scalars['String']['output'];
  /** Determine whether to include/exclude from env. Fee calculation */
  excludeFromEnvFee: Maybe<Scalars['Boolean']['output']>;
  /** Determine whether to include/exclude from supply fee calculation */
  excludeFromSupplyFee: Maybe<Scalars['Boolean']['output']>;
  /** Screening line id */
  id: Scalars['Int']['output'];
  /** Screening line index */
  index: Scalars['Int']['output'];
  /** Optional screening line premium amount (fixed amount) */
  linePremiumFixedAmount: Maybe<Scalars['Decimal']['output']>;
  /** Optional screening line reference id to fee line */
  linePremiumId: Maybe<Scalars['Int']['output']>;
  /** Optional screening line premium amount (in %) */
  linePremiumPercentage: Maybe<Scalars['Decimal']['output']>;
  /** Screening line movable date from value (when set) */
  movableDateFrom: Maybe<Scalars['String']['output']>;
  /** Screening line movable date to value (when set) */
  movableDateTo: Maybe<Scalars['String']['output']>;
  /** Screening line movable days (when set) */
  movableDays: Maybe<Scalars['Decimal']['output']>;
  /** Screening line movable volume (when set) */
  movableVolume: Maybe<Scalars['Decimal']['output']>;
  /** Optional screening line parent id */
  parentId: Maybe<Scalars['Int']['output']>;
  /** Optional screening line position number */
  position: Maybe<Scalars['String']['output']>;
  /** Screening price amount per unit */
  price: Scalars['Decimal']['output'];
  /** Determines if header section is required */
  required: Scalars['Boolean']['output'];
  /** Boolean to indicate if calendar should be shown */
  showCalendar: Scalars['Boolean']['output'];
  /** Screening line title text */
  title: Scalars['String']['output'];
  /** Screening line type */
  type: ScreeningLineType;
  /** Screening line unit of measure */
  uom: Scalars['String']['output'];
  /** Screening line value (when set) */
  value: Maybe<Scalars['Decimal']['output']>;
};

export type ScreeningLineInputType = {
  /** Screening line account */
  account: Scalars['String']['input'];
  /** Identifier used in ERP system */
  erpReferenceId: Scalars['String']['input'];
  /** Determine whether to include/exclude from env. Fee calculation */
  excludeFromEnvFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determine whether to include/exclude from supply fee calculation */
  excludeFromSupplyFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Screening line job task */
  jobTask: Scalars['String']['input'];
  /** Screening line movable date from value */
  movableDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Screening line movable date to value */
  movableDateTo?: InputMaybe<Scalars['String']['input']>;
  /** Screening line movable days */
  movableDays?: InputMaybe<Scalars['Decimal']['input']>;
  /** Screening line movable volume */
  movableVolume?: InputMaybe<Scalars['Decimal']['input']>;
  /** Screening line price */
  price: Scalars['Decimal']['input'];
  /** Screening line title */
  title: Scalars['String']['input'];
  /** Screening line type */
  type: Scalars['String']['input'];
  /** Screening line value */
  value: Scalars['Decimal']['input'];
};

export enum ScreeningLineType {
  Amount = 'AMOUNT',
  Boolean = 'BOOLEAN',
  Decimal = 'DECIMAL',
  Fee = 'FEE',
  Heading = 'HEADING',
  Integer = 'INTEGER',
  Radio = 'RADIO',
  Resource = 'RESOURCE'
}

export type ScreeningPositionText = {
  __typename?: 'ScreeningPositionText';
  /** Unique id of entry */
  id: Scalars['String']['output'];
  /** Screening line position */
  position: Scalars['String']['output'];
  /** Screening template code */
  templateCode: Scalars['String']['output'];
  /** Screening line position help text */
  text: Scalars['String']['output'];
};

export type ScreeningPositionTextInput = {
  /** Screening line position */
  position: Scalars['String']['input'];
  /** Screening template code */
  templateCode: Scalars['String']['input'];
  /** Screening line position help text */
  text: Scalars['String']['input'];
};

export type Settings = BcSettings | CatalogNotificationSetting | DrivingSlipCategoryMappingSettings | In4moSettings | InvoiceSettings | MachineNotificationSetting | SmsSettings | SpSettings | SmtpSettings;

export type SharePointTemplate = {
  __typename?: 'SharePointTemplate';
  /** id of the template in SharePoint */
  id: Scalars['Int']['output'];
  /** name of the template in SharePoint with file extension */
  name: Scalars['String']['output'];
};

export type Signature = {
  __typename?: 'Signature';
  /** If the report contains multiple signatures, the index can be used to set the order */
  index: Maybe<Scalars['Int']['output']>;
  /** Date of the current signature */
  signatureDate: Maybe<Scalars['Date']['output']>;
  /** name and description of the signature */
  signatureDetails: Maybe<ReportFile>;
};

export type SignatureInputType = {
  /** If the report contains multiple signatures, the index can be used to set the order */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Date of the current signature */
  signatureDate?: InputMaybe<Scalars['Date']['input']>;
  /** name and description of the signature */
  signatureDetails?: InputMaybe<ReportFileInput>;
};

export type SmtpSettings = {
  __typename?: 'SmtpSettings';
  /** Senders email */
  email: Scalars['String']['output'];
  /** Host URL */
  host: Scalars['String']['output'];
  /** Unique id of setting */
  id: Scalars['String']['output'];
  /** Smtp service password */
  password: Scalars['String']['output'];
  /** Smtp port */
  port: Scalars['String']['output'];
  /** Settings type e.g: bc, smtp etc. */
  type: Scalars['String']['output'];
  /** Smtp service username */
  username: Scalars['String']['output'];
};

export type SmtpSettingsInput = {
  /** Senders email */
  email: Scalars['String']['input'];
  /** Host URL */
  host: Scalars['String']['input'];
  /** Smtp service password */
  password: Scalars['String']['input'];
  /** Smtp port */
  port: Scalars['String']['input'];
  /** Type of setting e.g. bc, smtp etc. */
  type: Scalars['String']['input'];
  /** Smtp service username */
  username: Scalars['String']['input'];
};

export type SsgSetup = {
  __typename?: 'SsgSetup';
  environmentFeeRessourceNo: Maybe<Scalars['String']['output']>;
  primaryKey: Scalars['String']['output'];
  supplyFeeDateFrom: Maybe<Scalars['Date']['output']>;
  supplyFeeDateTo: Maybe<Scalars['Date']['output']>;
  supplyFeeResourceNo: Maybe<Scalars['String']['output']>;
};

export type StringKvp = {
  __typename?: 'StringKVP';
  /** KVP key */
  key: Scalars['String']['output'];
  /** KVP value */
  value: Scalars['String']['output'];
};

export type StringKvpInput = {
  /** KVP key */
  key: Scalars['String']['input'];
  /** KVP value */
  value: Scalars['String']['input'];
};

export enum SupplementType {
  Piecework = 'PIECEWORK',
  StandAlone = 'STAND_ALONE',
  Surcharge = 'SURCHARGE',
  Timeregistration = 'TIMEREGISTRATION'
}

export type TimeTracking = {
  __typename?: 'TimeTracking';
  /** List of addon lines */
  addonLines: Maybe<Array<TimeTracking>>;
  /** Case for time tracking */
  case: Maybe<Case>;
  /** Timestamp of when the timetracking was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date for time tracking */
  date: Scalars['Date']['output'];
  /** DrivingSlip */
  drivingSlip: Maybe<DrivingSlip>;
  /** Hours for time tracking */
  hours: Scalars['Float']['output'];
  /** Id of time tracking */
  id: Scalars['String']['output'];
  /** BC case no */
  jobNo: Maybe<Scalars['String']['output']>;
  /** Job task name for time tracking */
  jobTaskName: Maybe<Scalars['String']['output']>;
  /** Job task no for time tracking */
  jobTaskNo: Scalars['String']['output'];
  /** Was the task on call */
  onCall: Scalars['Boolean']['output'];
  /** Parent id of time tracking */
  parentId: Maybe<Scalars['String']['output']>;
  /** Payment supplement code */
  paymentSupplementCode: Maybe<Scalars['String']['output']>;
  /** Payment supplement name */
  paymentSupplementName: Maybe<Scalars['String']['output']>;
  /** piecework amount */
  pieceworkAmount: Maybe<Scalars['Float']['output']>;
  /** Reject message for timetracking line */
  rejectMessage: Maybe<Scalars['String']['output']>;
  /** Remark for time tracking */
  remark: Maybe<Scalars['String']['output']>;
  /** Type of supplement: Stand alone, piecework, surcharge */
  supplementType: Maybe<SupplementType>;
  /** Payment Supplement unit of measure */
  supplementUom: Maybe<Scalars['String']['output']>;
  /** Time tracking status */
  timeTrackingStatus: TimeTrackingStatus;
  /** Type of time tracking: Timeregistration, dayclosed */
  trackingType: TrackingType;
  /** AD user */
  user: User;
  userId: Scalars['String']['output'];
  /** Work type for time tracking */
  workTypeCode: Scalars['String']['output'];
};

export type TimeTrackingDay = {
  __typename?: 'TimeTrackingDay';
  /** Timestamp of when the timetracking was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date for time tracking */
  date: Scalars['Date']['output'];
  /** Id of time tracking */
  id: Scalars['String']['output'];
  /** Indicates if day is part of range */
  isPartOfRange: Scalars['Boolean']['output'];
  /** Total Overtime hours */
  overtimeHours: Scalars['Float']['output'];
  /** End date for range */
  rangeEndDate: Maybe<Scalars['Date']['output']>;
  /** Start date for range */
  rangeStartDate: Maybe<Scalars['Date']['output']>;
  /** Type of open, closed or rejected */
  timeTrackingDayStatus: TimeTrackingDayStatus;
  /** Time Tracking Entries */
  timeTrackingEntries: Array<TimeTrackingEntry>;
  /** Total hours */
  totalHours: Scalars['Float']['output'];
  /** AD user */
  user: User;
  userId: Scalars['String']['output'];
};

export type TimeTrackingDayInputType = {
  /** Date for time tracking */
  date: Scalars['DateTime']['input'];
  /** Is part of range for time tracking */
  isPartOfRange: Scalars['Boolean']['input'];
  /** Range end date for time tracking */
  rangeEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** User for time tracking */
  user: Scalars['String']['input'];
};

export enum TimeTrackingDayStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  OpenRejected = 'OPEN_REJECTED',
  Rejected = 'REJECTED'
}

export type TimeTrackingEntry = {
  __typename?: 'TimeTrackingEntry';
  /** Add on supplementLines */
  addonLines: Array<TimeTrackingSupplement>;
  /** BC status */
  bcStatus: Maybe<TimeTrackingStatus>;
  /** Case for time tracking */
  case: Maybe<Case>;
  /** Timestamp of when the timetracking was created */
  createdAt: Scalars['DateTime']['output'];
  /** DrivingSlip */
  drivingSlip: Maybe<DrivingSlip>;
  /** Emploee responsible approval status */
  emploeeResponsible: TimeTrackingStatus;
  /** End date for time tracking */
  endDate: Scalars['Date']['output'];
  /** End time for time tracking */
  endTime: Scalars['String']['output'];
  /** Hours for time tracking */
  hours: Scalars['Float']['output'];
  /** Id of time tracking */
  id: Scalars['String']['output'];
  /** Does the entry include lunch */
  includesLunch: Scalars['Boolean']['output'];
  /** BC case no */
  jobNo: Maybe<Scalars['String']['output']>;
  /** Job task name for time tracking */
  jobTaskName: Maybe<Scalars['String']['output']>;
  /** Job task no for time tracking */
  jobTaskNo: Scalars['String']['output'];
  /** Timestamp of when the entry was last modified */
  lastModifiedAt: Maybe<Scalars['DateTime']['output']>;
  /** User who last modified the entry */
  lastModifiedBy: Maybe<User>;
  /** Was the task on call */
  onCall: Scalars['Boolean']['output'];
  /** Was the task on callback */
  onCallback: Scalars['Boolean']['output'];
  /** Payment supplement code */
  paymentSupplementCode: Maybe<Scalars['String']['output']>;
  /** Payment supplement name */
  paymentSupplementName: Maybe<Scalars['String']['output']>;
  /** piecework amount */
  pieceworkAmount: Maybe<Scalars['Float']['output']>;
  /** Project approval status */
  projectApprovalStatus: TimeTrackingStatus;
  /** Reject message for timetracking line */
  rejectMessage: Maybe<Scalars['String']['output']>;
  /** Remark for time tracking */
  remark: Maybe<Scalars['String']['output']>;
  /** Start date for time tracking */
  startDate: Scalars['Date']['output'];
  /** Start time for time tracking */
  startTime: Scalars['String']['output'];
  /** Type of supplement: Stand alone, piecework, surcharge */
  supplementType: Maybe<SupplementType>;
  /** Payment Supplement unit of measure */
  supplementUom: Maybe<Scalars['String']['output']>;
  /** task */
  task: TimeTrackingEntryTask;
  /** Time tracking status */
  timeTrackingStatus: TimeTrackingStatus;
  /** AD user */
  user: User;
  userId: Scalars['String']['output'];
  /** Work type for time tracking */
  workTypeCode: Scalars['String']['output'];
};

export type TimeTrackingEntryInputType = {
  /** List of addon lines */
  addonLines?: InputMaybe<Array<TimeTrackingSupplementInputType>>;
  /** Case for time tracking */
  case?: InputMaybe<Scalars['String']['input']>;
  /** DrivingSlip for time tracking */
  drivingSlip?: InputMaybe<Scalars['String']['input']>;
  /** End date for time tracking */
  endDate: Scalars['DateTime']['input'];
  /** endTime for time tracking */
  endTime: Scalars['String']['input'];
  /** Hours for time tracking */
  hours: Scalars['Float']['input'];
  /** Does the entry include lunch */
  includesLunch?: InputMaybe<Scalars['Boolean']['input']>;
  /** BC case no */
  jobNo?: InputMaybe<Scalars['String']['input']>;
  /** Job task name for time tracking */
  jobTaskName?: InputMaybe<Scalars['String']['input']>;
  /** Job task no for time tracking */
  jobTaskNo?: InputMaybe<Scalars['String']['input']>;
  /** Was the task on call */
  onCall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was the task on callback */
  onCallback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payment supplement code */
  paymentSupplementCode?: InputMaybe<Scalars['String']['input']>;
  /** Payment supplement name */
  paymentSupplementName?: InputMaybe<Scalars['String']['input']>;
  /** Piecework amount */
  pieceworkAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Remard for time tracking */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** Start date for time tracking */
  startDate: Scalars['DateTime']['input'];
  /** startTime for time tracking */
  startTime: Scalars['String']['input'];
  /** Type of supplement: Stand alone, piecework, surcharge */
  supplementType?: InputMaybe<SupplementType>;
  /** Payment Supplement unit of measure */
  supplementUom?: InputMaybe<Scalars['String']['input']>;
  /** Time tracking status */
  timeTrackingStatus?: InputMaybe<TimeTrackingStatus>;
  /** Type of time tracking: Timeregistration, dayclosed */
  trackingType: TrackingType;
  /** User for time tracking */
  user: Scalars['String']['input'];
  /** Work type for time tracking */
  workTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export enum TimeTrackingEntryTask {
  Case = 'CASE',
  Drivingslip = 'DRIVINGSLIP',
  Intern = 'INTERN'
}

export type TimeTrackingEntryUpdateInputType = {
  /** List of addon lines */
  addonLines?: InputMaybe<Array<TimeTrackingSupplementUpdateInputType>>;
  /** Case for time tracking */
  case?: InputMaybe<Scalars['String']['input']>;
  /** Date for time tracking */
  date: Scalars['DateTime']['input'];
  /** DrivingSlip for time tracking */
  drivingSlip?: InputMaybe<Scalars['String']['input']>;
  /** End date for time tracking */
  endDate: Scalars['DateTime']['input'];
  /** endTime for time tracking */
  endTime: Scalars['String']['input'];
  /** Hours for time tracking */
  hours: Scalars['Float']['input'];
  /** Time tracking entry id */
  id: Scalars['String']['input'];
  /** Does the entry include lunch */
  includesLunch?: InputMaybe<Scalars['Boolean']['input']>;
  /** BC case no */
  jobNo?: InputMaybe<Scalars['String']['input']>;
  /** Job task name for time tracking */
  jobTaskName?: InputMaybe<Scalars['String']['input']>;
  /** Job task no for time tracking */
  jobTaskNo?: InputMaybe<Scalars['String']['input']>;
  /** Was the task on call */
  onCall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was the task on callback */
  onCallback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tracking entry parent id */
  parentId: Scalars['String']['input'];
  /** Payment supplement code */
  paymentSupplementCode?: InputMaybe<Scalars['String']['input']>;
  /** Payment supplement name */
  paymentSupplementName?: InputMaybe<Scalars['String']['input']>;
  /** Piecework amount */
  pieceworkAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Remard for time tracking */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** Start date for time tracking */
  startDate: Scalars['DateTime']['input'];
  /** startTime for time tracking */
  startTime: Scalars['String']['input'];
  /** Type of supplement: Stand alone, piecework, surcharge */
  supplementType?: InputMaybe<SupplementType>;
  /** Payment Supplement unit of measure */
  supplementUom?: InputMaybe<Scalars['String']['input']>;
  /** Time tracking status */
  timeTrackingStatus?: InputMaybe<TimeTrackingStatus>;
  /** Type of time tracking: Timeregistration, dayclosed */
  trackingType: TrackingType;
  /** User for time tracking */
  user: Scalars['String']['input'];
  /** Work type for time tracking */
  workTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type TimeTrackingInputType = {
  /** List of addon lines */
  addonLines?: InputMaybe<Array<TimeTrackingInputType>>;
  /** Case for time tracking */
  case?: InputMaybe<Scalars['String']['input']>;
  /** Date for time tracking */
  date: Scalars['Date']['input'];
  /** DrivingSlip for time tracking */
  drivingSlip?: InputMaybe<Scalars['String']['input']>;
  /** Hours for time tracking */
  hours: Scalars['Float']['input'];
  /** BC case no */
  jobNo?: InputMaybe<Scalars['String']['input']>;
  /** Job task name for time tracking */
  jobTaskName?: InputMaybe<Scalars['String']['input']>;
  /** Job task no for time tracking */
  jobTaskNo?: InputMaybe<Scalars['String']['input']>;
  /** Was the task on call */
  onCall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payment supplement code */
  paymentSupplementCode?: InputMaybe<Scalars['String']['input']>;
  /** Payment supplement name */
  paymentSupplementName?: InputMaybe<Scalars['String']['input']>;
  /** Piecework amount */
  pieceworkAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Remard for time tracking */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** Type of supplement: Stand alone, piecework, surcharge */
  supplementType?: InputMaybe<SupplementType>;
  /** Payment Supplement unit of measure */
  supplementUom?: InputMaybe<Scalars['String']['input']>;
  /** Time tracking status */
  timeTrackingStatus?: InputMaybe<TimeTrackingStatus>;
  /** Type of time tracking: Timeregistration, dayclosed */
  trackingType: TrackingType;
  /** User for time tracking */
  user: Scalars['String']['input'];
  /** Work type for time tracking */
  workTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export enum TimeTrackingStatus {
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Open = 'OPEN',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type TimeTrackingSupplement = {
  __typename?: 'TimeTrackingSupplement';
  /** bcStatus */
  bcStatus: TimeTrackingStatus;
  /** Case for time tracking */
  case: Maybe<Case>;
  /** Timestamp of when the timetracking was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date for time tracking */
  date: Scalars['Date']['output'];
  /** Emploee responsible approval status */
  emploeeResponsible: TimeTrackingStatus;
  /** End time for time tracking */
  endTime: Scalars['String']['output'];
  /** Hours for time tracking */
  hours: Scalars['Float']['output'];
  /** Id of time tracking */
  id: Scalars['String']['output'];
  /** BC case no */
  jobNo: Maybe<Scalars['String']['output']>;
  /** Job task name for time tracking */
  jobTaskName: Maybe<Scalars['String']['output']>;
  /** Job task no for time tracking */
  jobTaskNo: Scalars['String']['output'];
  /** Was the task on call */
  onCall: Scalars['Boolean']['output'];
  /** Was the task on callback */
  onCallback: Scalars['Boolean']['output'];
  /** Payment supplement code */
  paymentSupplementCode: Maybe<Scalars['String']['output']>;
  /** Payment supplement name */
  paymentSupplementName: Maybe<Scalars['String']['output']>;
  /** piecework amount */
  pieceworkAmount: Maybe<Scalars['Float']['output']>;
  /** Project approval status */
  projectApprovalStatus: TimeTrackingStatus;
  /** Reject message for timetracking line */
  rejectMessage: Maybe<Scalars['String']['output']>;
  /** Remark for time tracking */
  remark: Maybe<Scalars['String']['output']>;
  /** Start time for time tracking */
  startTime: Scalars['String']['output'];
  /** Type of supplement: Stand alone, piecework, surcharge */
  supplementType: Maybe<SupplementType>;
  /** Payment Supplement unit of measure */
  supplementUom: Maybe<Scalars['String']['output']>;
  /** Time tracking status */
  timeTrackingStatus: TimeTrackingStatus;
  /** AD user */
  user: User;
  userId: Scalars['String']['output'];
  /** Work type for time tracking */
  workTypeCode: Scalars['String']['output'];
};

export type TimeTrackingSupplementInputType = {
  /** Case for time tracking */
  case?: InputMaybe<Scalars['String']['input']>;
  /** Date for time tracking */
  date: Scalars['Date']['input'];
  /** DrivingSlip for time tracking */
  drivingSlip?: InputMaybe<Scalars['String']['input']>;
  /** Hours for time tracking */
  hours: Scalars['Float']['input'];
  /** BC case no */
  jobNo?: InputMaybe<Scalars['String']['input']>;
  /** Job task name for time tracking */
  jobTaskName?: InputMaybe<Scalars['String']['input']>;
  /** Job task no for time tracking */
  jobTaskNo?: InputMaybe<Scalars['String']['input']>;
  /** Was the task on call */
  onCall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was the task on callback */
  onCallback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payment supplement code */
  paymentSupplementCode?: InputMaybe<Scalars['String']['input']>;
  /** Payment supplement name */
  paymentSupplementName?: InputMaybe<Scalars['String']['input']>;
  /** Piecework amount */
  pieceworkAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Remard for time tracking */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** Type of supplement: Stand alone, piecework, surcharge */
  supplementType?: InputMaybe<SupplementType>;
  /** Payment Supplement unit of measure */
  supplementUom?: InputMaybe<Scalars['String']['input']>;
  /** Time tracking status */
  timeTrackingStatus?: InputMaybe<TimeTrackingStatus>;
  /** User for time tracking */
  user: Scalars['String']['input'];
  /** Work type for time tracking */
  workTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type TimeTrackingSupplementUpdateInputType = {
  /** Case for time tracking */
  case?: InputMaybe<Scalars['String']['input']>;
  /** Date for time tracking */
  date: Scalars['Date']['input'];
  /** DrivingSlip for time tracking */
  drivingSlip?: InputMaybe<Scalars['String']['input']>;
  /** Hours for time tracking */
  hours: Scalars['Float']['input'];
  /** Time tracking supplement id */
  id?: InputMaybe<Scalars['String']['input']>;
  /** BC case no */
  jobNo?: InputMaybe<Scalars['String']['input']>;
  /** Job task name for time tracking */
  jobTaskName?: InputMaybe<Scalars['String']['input']>;
  /** Job task no for time tracking */
  jobTaskNo?: InputMaybe<Scalars['String']['input']>;
  /** Was the task on call */
  onCall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was the task on callback */
  onCallback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tracking supplement parent id */
  parentId: Scalars['String']['input'];
  /** Payment supplement code */
  paymentSupplementCode?: InputMaybe<Scalars['String']['input']>;
  /** Payment supplement name */
  paymentSupplementName?: InputMaybe<Scalars['String']['input']>;
  /** Piecework amount */
  pieceworkAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Remard for time tracking */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** Type of supplement: Stand alone, piecework, surcharge */
  supplementType?: InputMaybe<SupplementType>;
  /** Payment Supplement unit of measure */
  supplementUom?: InputMaybe<Scalars['String']['input']>;
  /** Time tracking status */
  timeTrackingStatus?: InputMaybe<TimeTrackingStatus>;
  /** User for time tracking */
  user: Scalars['String']['input'];
  /** Work type for time tracking */
  workTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type TimeTrackingUserDayClose = {
  __typename?: 'TimeTrackingUserDayClose';
  /** Last closed date for user */
  date: Scalars['Date']['output'];
  /** User object */
  user: User;
};

export type TimeTrackingUserFlexTime = {
  __typename?: 'TimeTrackingUserFlexTime';
  /** Flex time for the user */
  flexTime: Scalars['Decimal']['output'];
  /** User object */
  user: User;
};

export type TimedMessage = {
  __typename?: 'TimedMessage';
  /** Is timed message active */
  active: Scalars['Boolean']['output'];
  /** Catalog ids */
  catalogIds: Array<Scalars['String']['output']>;
  /** Catalogs that uses timed message */
  catalogs: Maybe<Array<Catalog>>;
  /** Craftsman changed by */
  changedBy: Scalars['String']['output'];
  /** Timed message Change log */
  changes: Array<TimedMessageChange>;
  /** Timestamp of when the timed message was created */
  createdAt: Scalars['DateTime']['output'];
  /** Customer */
  customer: CatalogCustomer;
  /** Time at which the message should stop showing */
  endTime: Scalars['DateTime']['output'];
  /** Is timed message global */
  global: Scalars['Boolean']['output'];
  /** Global type for timed message */
  globalType: CatalogGlobalType;
  /** id to display */
  id: Scalars['String']['output'];
  /** message to display */
  message: Scalars['String']['output'];
  /** Time at which the message should show from */
  startTime: Scalars['DateTime']['output'];
  /** Timestamp of when the timed message was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Version for timed message */
  version: Scalars['Int']['output'];
};

export type TimedMessageChange = {
  __typename?: 'TimedMessageChange';
  /** Value after */
  after: TimedMessageChangeDifference;
  /** Value before */
  before: TimedMessageChangeDifference;
  /** Changed by */
  changedBy: Maybe<Scalars['String']['output']>;
  /** Time of change */
  timestamp: Scalars['DateTime']['output'];
  /** User who performed the change */
  user: User;
};

export type TimedMessageChangeDifference = {
  __typename?: 'TimedMessageChangeDifference';
  active: Maybe<Scalars['Boolean']['output']>;
  catalogs: Maybe<Array<Catalog>>;
  changedBy: Maybe<Scalars['String']['output']>;
  customer: Maybe<CatalogCustomer>;
  endTime: Maybe<Scalars['DateTime']['output']>;
  global: Maybe<Scalars['Boolean']['output']>;
  globalType: Maybe<CatalogGlobalType>;
  message: Maybe<Scalars['String']['output']>;
  startTime: Maybe<Scalars['DateTime']['output']>;
};

export type TimedMessageInput = {
  /** Is timed message active */
  active: Scalars['Boolean']['input'];
  /** Catalogs that uses timed message */
  catalogs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Craftsman changed by */
  changedBy: Scalars['String']['input'];
  /** Customer for timed message */
  customer: Scalars['String']['input'];
  /** Datetime at which the message should stop showing */
  endTime: Scalars['DateTime']['input'];
  /** Is timed message global */
  global: Scalars['Boolean']['input'];
  /** Global type for timed message */
  globalType: CatalogGlobalType;
  /** message to display */
  message: Scalars['String']['input'];
  /** Datetime at which the message should start showing */
  startTime: Scalars['DateTime']['input'];
};

export enum TrackingType {
  Dayclosed = 'DAYCLOSED',
  Rejectedday = 'REJECTEDDAY',
  Timeregistration = 'TIMEREGISTRATION'
}

export type TrygMoistureMeassurement = {
  __typename?: 'TrygMoistureMeassurement';
  /** Construction */
  construction: Maybe<Scalars['String']['output']>;
  /** Control date */
  controlDate: Maybe<Scalars['String']['output']>;
  /** Control value */
  controlValue: Maybe<Scalars['String']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Expected final date */
  expectedFinalDate: Maybe<Scalars['String']['output']>;
  /** Expected final value */
  expectedFinalValue: Maybe<Scalars['String']['output']>;
  /** Material */
  material: Maybe<Scalars['String']['output']>;
  /** Method */
  method: Maybe<Scalars['String']['output']>;
  /** Paints */
  paints: Scalars['String']['output'];
  /** Paints Date */
  paintsDate: Maybe<Scalars['String']['output']>;
  /** Reference date */
  referenceDate: Maybe<Scalars['String']['output']>;
  /** Reference value */
  referenceValue: Maybe<Scalars['String']['output']>;
};

export type TrygMoistureMeassurementInput = {
  /** Construction */
  construction?: InputMaybe<Scalars['String']['input']>;
  /** Control date */
  controlDate?: InputMaybe<Scalars['String']['input']>;
  /** Control value */
  controlValue?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Expected final date */
  expectedFinalDate?: InputMaybe<Scalars['String']['input']>;
  /** Expected final value */
  expectedFinalValue?: InputMaybe<Scalars['String']['input']>;
  /** Material */
  material?: InputMaybe<Scalars['String']['input']>;
  /** Method */
  method?: InputMaybe<Scalars['String']['input']>;
  /** Paints */
  paints?: InputMaybe<Scalars['String']['input']>;
  /** Paints Date */
  paintsDate?: InputMaybe<Scalars['String']['input']>;
  /** Reference date */
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  /** Reference value */
  referenceValue?: InputMaybe<Scalars['String']['input']>;
};

export enum UsageLineType {
  Driving = 'DRIVING',
  Item = 'ITEM',
  ResourceMachine = 'RESOURCE_MACHINE',
  ResourceMovable = 'RESOURCE_MOVABLE',
  ResourcePerson = 'RESOURCE_PERSON',
  Subcontract = 'SUBCONTRACT',
  Trash = 'TRASH',
  Unknown = 'UNKNOWN'
}

export type User = {
  __typename?: 'User';
  /** Area user is attached to */
  area: Maybe<Scalars['String']['output']>;
  /** User saved car filters */
  carFilters: Array<UserVehicleFilter>;
  /** User saved case filters */
  caseFilters: Array<UserCaseFilter>;
  /** Users default language */
  defaultLanguage: Maybe<Scalars['String']['output']>;
  /** Department user is attached to */
  department: Maybe<Scalars['String']['output']>;
  /** User saved driving slip filters */
  drivingSlipFilters: Array<UserDrivingSlipFilter>;
  /** User saved driving slip overview filters */
  drivingSlipOverviewFilters: Array<UserDrivingSlipOverviewFilter>;
  /** Email of user */
  email: Scalars['String']['output'];
  /** Employee hire start date */
  employeeHireStartDate: Maybe<Scalars['DateTime']['output']>;
  /** User employee id */
  employeeId: Maybe<Scalars['String']['output']>;
  /** Employee salary type */
  employeeSalaryType: Maybe<Scalars['String']['output']>;
  /** External user */
  external: Scalars['Boolean']['output'];
  /** Users GDPR */
  gdpr: Maybe<Gdpr>;
  /** Permission groups the user is a member of */
  groupPermissions: Array<GroupPermission>;
  /** Unique id of user */
  id: Scalars['String']['output'];
  /** User saved job filters */
  jobFilters: Array<UserJobFilter>;
  /** Job function of user */
  jobFunction: Maybe<Scalars['String']['output']>;
  /** User saved machine filters */
  machineFilters: Array<UserMachineFilter>;
  /** List of managed users */
  managerFor: Array<Scalars['String']['output']>;
  /** User saved material filters */
  materialFilters: Array<UserVehicleFilter>;
  /** User saved movable filters */
  movableFilters: Array<UserMovableFilter>;
  /** Name of user */
  name: Scalars['String']['output'];
  /** permissions of user */
  permissions: Array<Permissions>;
  /** User phone number */
  phone: Maybe<Scalars['String']['output']>;
  /** User planner help text */
  plannerHelpText: Maybe<Scalars['String']['output']>;
  /** User planner help text updated at timestamp */
  plannerHelpTextUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Case manager attached to case */
  proxy: Maybe<User>;
  /** List of users for whom this user is a proxy */
  proxyFor: Array<User>;
  /** Case manager who set the proxy */
  proxySetBy: Maybe<User>;
  /** Timestamp of when the user's proxy was last updated */
  proxyUpdatedAt: Scalars['DateTime']['output'];
  /** User saved sanitizer filters */
  sanitizerFilters: Array<UserSanitizerFilter>;
  /** Timestamp of when the user was last updated (logged in) */
  updatedAt: Scalars['DateTime']['output'];
};

export type UserCalendar = {
  __typename?: 'UserCalendar';
  /** User calendar events */
  events: Array<CalendarEvent>;
  /** User */
  user: User;
};

export type UserCaseFilter = {
  __typename?: 'UserCaseFilter';
  /** Area responsibles to filter cases by */
  areaResponsibles: Array<Scalars['String']['output']>;
  /** Case awaiting status toggle */
  awaiting: Maybe<Scalars['Boolean']['output']>;
  /** Case called back status toggle */
  calledBack: Maybe<Scalars['Boolean']['output']>;
  /** Case managers to filter cases by */
  caseManagers: Array<Scalars['String']['output']>;
  /** Created by users to filter cases by */
  createdBy: Array<Scalars['String']['output']>;
  /** Damage categories to filter cases by */
  damageCategories: Array<Scalars['String']['output']>;
  /** Damage causes to filter cases by */
  damageCauses: Array<Scalars['String']['output']>;
  /** Case damage service completed status toggle */
  damageServiceCompleted: Maybe<Scalars['Boolean']['output']>;
  /** Debitors to filter cases by */
  debitors: Array<Scalars['String']['output']>;
  /** Departments to filter cases by */
  departments: Array<Scalars['String']['output']>;
  /** Unique filter key */
  key: Scalars['String']['output'];
  /** Locations to filter cases by */
  locations: Array<Scalars['String']['output']>;
  /** Case machines on case status toggle */
  machinesOnCase: Maybe<Scalars['Boolean']['output']>;
  /** Name of filter */
  name: Scalars['String']['output'];
  /** Postal code input text */
  postalCodeText: Scalars['String']['output'];
  /** Postal codes to filter cases by */
  postalCodes: Array<Scalars['String']['output']>;
  /** Priority to filter cases by */
  priority: Array<CasePriority>;
  /** Project managers to filter cases by */
  projectManagers: Array<Scalars['String']['output']>;
  /** Toggle to show applied closed cases */
  showAppliedClosedCases: Scalars['Boolean']['output'];
  /** Toggle to show business area fields */
  showBusinessAreaField: Scalars['Boolean']['output'];
  /** Toggle to show closed cases */
  showClosedCases: Scalars['Boolean']['output'];
  /** Toggle to show economy fields */
  showEconomyField: Scalars['Boolean']['output'];
  /** Track to filter cases by */
  track: Array<Scalars['Int']['output']>;
  /** Filter view type */
  view: UserCaseFilterViewType;
};

export type UserCaseFilterInput = {
  /** Area responsibles managers to filter cases by */
  areaResponsibles: Array<Scalars['String']['input']>;
  /** Case awaiting status toggle */
  awaiting?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case called back status toggle */
  calledBack?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case managers to filter cases by */
  caseManagers: Array<Scalars['String']['input']>;
  /** Created by users to filter cases by */
  createdBy: Array<Scalars['String']['input']>;
  /** Categories to filter cases by */
  damageCategories: Array<Scalars['String']['input']>;
  /** Causes to filter cases by */
  damageCauses: Array<Scalars['String']['input']>;
  /** Case damage service completed status toggle */
  damageServiceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Debitors to filter cases by */
  debitors: Array<Scalars['String']['input']>;
  /** Departments to filter cases by */
  departments: Array<Scalars['String']['input']>;
  /** Locations to filter cases by */
  locations: Array<Scalars['String']['input']>;
  /** Case machines on case status toggle */
  machinesOnCase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of filter */
  name: Scalars['String']['input'];
  /** Postal code input text */
  postalCodeText: Scalars['String']['input'];
  /** Postal codes to filter cases by */
  postalCodes: Array<Scalars['String']['input']>;
  /** priority to filter cases by */
  priority: Array<CasePriority>;
  /** Project managers to filter cases by */
  projectManagers: Array<Scalars['String']['input']>;
  /** Toggle to show applied closed cases */
  showAppliedClosedCases: Scalars['Boolean']['input'];
  /** Toggle to show business area fields */
  showBusinessAreaField: Scalars['Boolean']['input'];
  /** Toggle to show closed cases */
  showClosedCases: Scalars['Boolean']['input'];
  /** Toggle to show economy fields */
  showEconomyField: Scalars['Boolean']['input'];
  /** Track to filter cases by */
  track: Array<Scalars['Int']['input']>;
  /** Filter view type */
  view: UserCaseFilterViewType;
};

export enum UserCaseFilterViewType {
  All = 'ALL',
  Favorites = 'FAVORITES',
  InvoiceReady = 'INVOICE_READY',
  NotPlanned = 'NOT_PLANNED',
  Own = 'OWN'
}

export type UserDrivingSlipFilter = {
  __typename?: 'UserDrivingSlipFilter';
  /** Damage categories to filter driving slips by */
  damageCategories: Array<Scalars['String']['output']>;
  /** Damage causes to filter driving slips by */
  damageCauses: Array<Scalars['String']['output']>;
  /** Debitors to filter driving slips by */
  debitors: Array<Scalars['String']['output']>;
  /** Departments to filter driving slips by */
  departments: Array<Scalars['String']['output']>;
  /** Driving slip categories to filter driving slips by */
  drivingSlipCategories: Array<Scalars['String']['output']>;
  /** ERP reference nos to filter driving slips by */
  erpNos: Array<Scalars['String']['output']>;
  /** Unique filter key */
  key: Scalars['String']['output'];
  /** Locations to filter driving slips by */
  locations: Array<Scalars['String']['output']>;
  /** Name of filter */
  name: Scalars['String']['output'];
  /** Postal code input text */
  postalCodeText: Scalars['String']['output'];
  /** Postal codes to filter driving slips by */
  postalCodes: Array<Scalars['String']['output']>;
  /** Project managers to filter driving slips by */
  projectManagers: Array<Scalars['String']['output']>;
};

export type UserDrivingSlipFilterInput = {
  /** Categories to filter driving slips by */
  damageCategories: Array<Scalars['String']['input']>;
  /** Causes to filter driving slips by */
  damageCauses: Array<Scalars['String']['input']>;
  /** Debitors to filter driving slips by */
  debitors: Array<Scalars['String']['input']>;
  /** Departments to filter driving slips by */
  departments: Array<Scalars['String']['input']>;
  /** drivingSlipCategories to filter driving slips by */
  drivingSlipCategories: Array<Scalars['String']['input']>;
  /** ERP reference nos to filter driving slips by */
  erpNos: Array<Scalars['String']['input']>;
  /** Locations to filter driving slips by */
  locations: Array<Scalars['String']['input']>;
  /** Name of filter */
  name: Scalars['String']['input'];
  /** Postal code input text */
  postalCodeText: Scalars['String']['input'];
  /** Postal codes to filter driving slips by */
  postalCodes: Array<Scalars['String']['input']>;
  /** Project managers to filter driving slips by */
  projectManagers: Array<Scalars['String']['input']>;
};

export type UserDrivingSlipOverviewFilter = {
  __typename?: 'UserDrivingSlipOverviewFilter';
  /** Damage categories to filter by */
  damageCategories: Array<Scalars['String']['output']>;
  /** Damage causes to filter by */
  damageCauses: Array<Scalars['String']['output']>;
  /** Departments to filter by */
  departments: Array<Scalars['String']['output']>;
  /** Drivers to filter by */
  drivers: Array<Scalars['String']['output']>;
  /** Exceeded filter toggle */
  exceeded: Maybe<Scalars['Boolean']['output']>;
  /** Unique filter key */
  key: Scalars['String']['output'];
  /** Locations to filter by */
  locations: Array<Scalars['String']['output']>;
  /** Name of filter */
  name: Scalars['String']['output'];
  /** Filter for no drivers */
  noDriver: Maybe<Scalars['Boolean']['output']>;
  /** Status to filter by */
  status: Maybe<DrivingSlipStatus>;
  /** Urgent filter toggle */
  urgent: Maybe<Scalars['Boolean']['output']>;
};

export type UserDrivingSlipOverviewFilterInput = {
  /** Damage categories to filter by */
  damageCategories: Array<Scalars['String']['input']>;
  /** Damage causes to filter by */
  damageCauses: Array<Scalars['String']['input']>;
  /** Departments to filter by */
  departments: Array<Scalars['String']['input']>;
  /** Drivers to filter by */
  drivers: Array<Scalars['String']['input']>;
  /** Exceeded filter toggle */
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Locations to filter by */
  locations: Array<Scalars['String']['input']>;
  /** Name of filter */
  name: Scalars['String']['input'];
  /** Filter for no drivers */
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status to filter by */
  status?: InputMaybe<DrivingSlipStatus>;
  /** Urgent filter toggle */
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserJobFilter = {
  __typename?: 'UserJobFilter';
  /** Unique filter key */
  key: Scalars['String']['output'];
  /** Location to filter jobs by */
  location: Scalars['String']['output'];
  /** Name of filter */
  name: Scalars['String']['output'];
  /** Toggle to show only personal jobs */
  personalOnly: Scalars['Boolean']['output'];
};

export type UserJobFilterInput = {
  /** Location to filter jobs by */
  location: Scalars['String']['input'];
  /** Name of filter */
  name: Scalars['String']['input'];
  /** Toggle to show only personal jobs */
  personalOnly: Scalars['Boolean']['input'];
};

export type UserMachineFilter = {
  __typename?: 'UserMachineFilter';
  /** Cases to filter by */
  cases: Maybe<Array<Scalars['String']['output']>>;
  /** Include hibernating machines */
  hibernation: Maybe<Scalars['Boolean']['output']>;
  /** Unique filter key */
  key: Scalars['String']['output'];
  /** Locations to filter by */
  locations: Maybe<Array<Scalars['String']['output']>>;
  /** Name of filter */
  name: Scalars['String']['output'];
  /** Status to filter by */
  status: Maybe<MachineStatus>;
  /** Types to filter by */
  types: Maybe<Array<Scalars['String']['output']>>;
  /** Include unavailable machines */
  unavailable: Maybe<Scalars['Boolean']['output']>;
};

export type UserMachineFilterInput = {
  /** Cases to filter by */
  cases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include hibernating machines */
  hibernation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Locations to filter by */
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of filter */
  name: Scalars['String']['input'];
  /** Status to filter by */
  status?: InputMaybe<MachineStatus>;
  /** Types to filter by */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include unavailable machines */
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserMovableFilter = {
  __typename?: 'UserMovableFilter';
  /** Debitors to filter movables by */
  debitors: Maybe<Array<Scalars['String']['output']>>;
  /** ERP reference no to filter movables by */
  erpNo: Scalars['String']['output'];
  /** Toggle to show completed movables */
  includeCompleted: Scalars['Boolean']['output'];
  /** Unique filter key */
  key: Scalars['String']['output'];
  /** Location to filter movables by */
  location: Scalars['String']['output'];
  /** Name of filter */
  name: Scalars['String']['output'];
  /** Status to filter movables by */
  status: Scalars['String']['output'];
};

export type UserMovableFilterInput = {
  /** Debitors to filter movables by */
  debitors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ERP reference no to filter movable by */
  erpNo: Scalars['String']['input'];
  /** Toggle to show completed movables */
  includeCompleted: Scalars['Boolean']['input'];
  /** Location to filter movable by */
  location: Scalars['String']['input'];
  /** Name of filter */
  name: Scalars['String']['input'];
  /** Status to filter movable by */
  status: Scalars['String']['input'];
};

export type UserSanitizerFilter = {
  __typename?: 'UserSanitizerFilter';
  /** Departments to filter sanitizers by */
  departments: Array<Scalars['String']['output']>;
  /** Job functions to filter sanitizers by */
  jobFunctions: Array<Scalars['String']['output']>;
  /** Unique filter key */
  key: Scalars['String']['output'];
  /** Locations to filter sanitizers by */
  locations: Array<Scalars['String']['output']>;
  /** Name of filter */
  name: Scalars['String']['output'];
  /** Pre selected sanitizers on filter */
  sanitizers: Array<Scalars['String']['output']>;
};

export type UserSanitizerFilterInput = {
  /** Departments to filter sanitizers by */
  departments: Array<Scalars['String']['input']>;
  /** Job functions to filter sanitizers by */
  jobFunctions: Array<Scalars['String']['input']>;
  /** Locations to filter sanitizers by */
  locations: Array<Scalars['String']['input']>;
  /** Name of filter */
  name: Scalars['String']['input'];
  /** Pre selected sanitizers on filter */
  sanitizers: Array<Scalars['String']['input']>;
};

export type UserVehicleFilter = {
  __typename?: 'UserVehicleFilter';
  /** Pre selected cars on filter */
  cars: Array<Scalars['String']['output']>;
  /** Departments to filter cars by */
  departments: Array<Scalars['String']['output']>;
  /** Unique filter key */
  key: Scalars['String']['output'];
  /** Locations to filter cars by */
  locations: Array<Scalars['String']['output']>;
  /** Name of filter */
  name: Scalars['String']['output'];
};

export type UserVehicleFilterInput = {
  /** Pre selected cars on filter */
  cars: Array<Scalars['String']['input']>;
  /** Departments to filter cars by */
  departments: Array<Scalars['String']['input']>;
  /** Locations to filter cars by */
  locations: Array<Scalars['String']['input']>;
  /** Name of filter */
  name: Scalars['String']['input'];
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  /** Indicates the actual result of the validation rule */
  actualResult: Maybe<Scalars['String']['output']>;
  /** Indicates if rule can be bypassed with reason code */
  bypassAllowed: Scalars['Boolean']['output'];
  /** Indicates what was expected or required for the validation rule */
  expectedResult: Maybe<Scalars['String']['output']>;
  /** Indicates if rule is valid */
  valid: Scalars['Boolean']['output'];
};

export type ValidationResultKvp = {
  __typename?: 'ValidationResultKVP';
  /** Validation rule key */
  key: Scalars['String']['output'];
  /** Validation rule result */
  value: ValidationResult;
};

export type ValidationRuleBypass = {
  __typename?: 'ValidationRuleBypass';
  /** User comment */
  comment: Maybe<Scalars['String']['output']>;
  /** Reason code id */
  reasonCode: Scalars['String']['output'];
  /** Rule that was bypassed */
  rule: Scalars['String']['output'];
};

export type ValidationRuleBypassInput = {
  /** User comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Reason code id */
  reasonCode: Scalars['String']['input'];
  /** Rule that was bypassed */
  rule: Scalars['String']['input'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  /** Days where the vehicle is booked */
  bookedDays: Array<DrivingSlip>;
  /** Brand */
  brand: Maybe<Scalars['String']['output']>;
  /** Department Code */
  departmentCode: Scalars['String']['output'];
  /** Location Code */
  locationCode: Scalars['String']['output'];
  /** Registration Number */
  registrationNumber: Scalars['String']['output'];
  /** Type */
  type: Maybe<Scalars['String']['output']>;
  /** Basically Employee ID */
  user: Maybe<Scalars['String']['output']>;
  /** Username */
  username: Maybe<Scalars['String']['output']>;
  /** Vehicle Category */
  vehicleCategory: Scalars['String']['output'];
  /** Vehicle Number */
  vehicleNumber: Scalars['String']['output'];
};

export type Vendor = {
  __typename?: 'Vendor';
  /** The address of the vendor */
  address: Maybe<AddressSimple>;
  /** The name of the vendor */
  company: Maybe<Scalars['String']['output']>;
  /** The email of the vendor */
  email: Maybe<Scalars['String']['output']>;
  /** ERP reference no for vendor */
  erpReferenceNo: Scalars['String']['output'];
  /** The phone number of the vendor */
  phone: Maybe<Scalars['String']['output']>;
  /** Attached SSG department of the vendor */
  ssgDepartment: Scalars['String']['output'];
  /** Attached SSG location of the vendor */
  ssgLocation: Scalars['String']['output'];
  /** Vendor type */
  type: Scalars['String']['output'];
  /** The posting group of the vendor */
  vendorPostingGroup: Scalars['String']['output'];
};

export type Visitation = {
  __typename?: 'Visitation';
  /** A set of answers related to the damage cause */
  answers: Maybe<Array<Answer>>;
  /** If case is awaiting */
  awaiting: BoolWithComment;
  /** If there has been called back */
  calledBack: BoolWithComment;
  /** If case needs a moisture report */
  isMoistureReportRequired: Maybe<Scalars['Boolean']['output']>;
  /** If case needs an SP phase one report */
  isSpPhaseOneReportCreated: Maybe<Scalars['Boolean']['output']>;
  /** Case priority flags */
  priorities: Array<CasePriority>;
  /** If case has a regress opportunity */
  regress: Maybe<Scalars['Boolean']['output']>;
  /** If case is considered urgent */
  urgent: Scalars['Boolean']['output'];
};

export type VisitationInput = {
  /** A set of answers related to the damage cause */
  answers?: InputMaybe<Array<AnswerInput>>;
  /** Case awaiting status */
  awaiting: BoolWithCommentInput;
  /** Case called back status */
  calledBack: BoolWithCommentInput;
  /** If case requires moisture report */
  isMoistureReportRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** If SP Phase one report created */
  isSpPhaseOneReportCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case priority flags */
  priorities: Array<CasePriority>;
  /** If case has a regress opportunity */
  regress?: InputMaybe<Scalars['Boolean']['input']>;
  /** If case is considered urgent */
  urgent: Scalars['Boolean']['input'];
};

export type VisitationQuestion = {
  __typename?: 'VisitationQuestion';
  /** Which damage category the question is based on */
  damageCategory: DamageCategory;
  /** Which damage cause the question is based on */
  damageCause: DamageCause;
  /** Id of question */
  id: Scalars['String']['output'];
  /** Question to ask based on damage cause */
  question: Scalars['String']['output'];
};

export type VisitationQuestionInput = {
  /** Which damage category the question is based on */
  damageCategory: Scalars['String']['input'];
  /** Which damage cause the question is based on */
  damageCause: Scalars['String']['input'];
  /** Question to ask based on damage cause */
  question: Scalars['String']['input'];
};

export type WorkType = {
  __typename?: 'WorkType';
  /** code */
  code: Scalars['String']['output'];
  /** description */
  description: Scalars['String']['output'];
  /** System id */
  systemId: Maybe<Scalars['String']['output']>;
  /** Unit of messure */
  uOM: Scalars['String']['output'];
};

export type WorkerRestPeriod = {
  __typename?: 'WorkerRestPeriod';
  /** Available again time */
  availableAgainTime: Maybe<Scalars['String']['output']>;
  /** Current task */
  currentTask: Scalars['String']['output'];
  /** Days since rest day */
  daysSinceRestDay: Scalars['Int']['output'];
  /** Eight hour rest */
  eightHourRest: Maybe<Scalars['Boolean']['output']>;
  /** Eleven hour rest */
  elevenHourRest: Maybe<Scalars['Boolean']['output']>;
  /** Id of time tracking */
  hours48Over4Months: Scalars['Decimal']['output'];
  /** Hours current day */
  hoursCurrentDay: Scalars['Decimal']['output'];
  /** Last work time */
  lastWorkTime: Scalars['String']['output'];
  /** Started task */
  startedTask: Scalars['String']['output'];
  /** AD user */
  user: User;
};

export type CreateApvMutationVariables = Exact<{
  apv: ApvInput;
  file: FileInput;
}>;


export type CreateApvMutation = { __typename?: 'Mutation', createAPV: { __typename?: 'APV', id: string, url: string, damageCategory: { __typename?: 'DamageCategory', id: string, name: string }, damageCause: { __typename?: 'DamageCause', id: string, name: string } } };

export type DeleteApvMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteApvMutation = { __typename?: 'Mutation', deleteAPV: { __typename?: 'EmptyReturn', _: string } | null };

export type GetApVsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApVsQuery = { __typename?: 'Query', apvs: Array<{ __typename?: 'APV', id: string, url: string, damageCategory: { __typename?: 'DamageCategory', id: string, name: string }, damageCause: { __typename?: 'DamageCause', id: string, name: string } }> };

export type UpdateApvMutationVariables = Exact<{
  id: Scalars['String']['input'];
  damageCategory?: InputMaybe<Scalars['String']['input']>;
  damageCause?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<FileInput>;
}>;


export type UpdateApvMutation = { __typename?: 'Mutation', updateAPV: { __typename?: 'APV', id: string, url: string, damageCategory: { __typename?: 'DamageCategory', id: string, name: string }, damageCause: { __typename?: 'DamageCause', id: string, name: string } } };

export type CreateSettingsMutationVariables = Exact<{
  bcSetting?: InputMaybe<BcSettingsInput>;
  spSetting?: InputMaybe<SpSettingsInput>;
  smsSetting?: InputMaybe<SmsSettingsInput>;
  smtpSetting?: InputMaybe<SmtpSettingsInput>;
  catalogNotificationSetting?: InputMaybe<CatalogNotificationSettingInput>;
  invoiceSetting?: InputMaybe<InvoiceSettingsInput>;
  in4moSetting?: InputMaybe<In4moSettingsInput>;
  drivingSlipCategoryMappingSetting?: InputMaybe<DrivingSlipCategoryMappingSettingsInput>;
  machineNotificationSetting?: InputMaybe<MachineNotificationSettingInput>;
}>;


export type CreateSettingsMutation = { __typename?: 'Mutation', createSetting: { __typename?: 'BCSettings', id: string, type: string } | { __typename?: 'CatalogNotificationSetting', id: string, type: string } | { __typename?: 'DrivingSlipCategoryMappingSettings', id: string, type: string } | { __typename?: 'In4moSettings', id: string, type: string } | { __typename?: 'InvoiceSettings', id: string, type: string } | { __typename?: 'MachineNotificationSetting', id: string, type: string } | { __typename?: 'SMSSettings', id: string, type: string } | { __typename?: 'SPSettings', id: string, type: string } | { __typename?: 'SmtpSettings', id: string, type: string } | null };

export type DeleteSettingsMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSettingsMutation = { __typename?: 'Mutation', deleteSetting: { __typename?: 'EmptyReturn', _: string } | null };

export type GetIn4moTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIn4moTypesQuery = { __typename?: 'Query', in4moDamageTypes: Array<In4moDamageType>, in4moTaskTypes: Array<In4moTaskType> };

export type GetSettingsQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetSettingsQuery = { __typename?: 'Query', setting: Array<{ __typename?: 'BCSettings', id: string, type: string, username: string, password: string } | { __typename?: 'CatalogNotificationSetting', id: string, type: string, verifyNotifications: Array<{ __typename?: 'CatalogNotification', debitorVerification: boolean, email: string }>, debitorVerifyNotifications: Array<{ __typename?: 'CatalogNotification', debitorVerification: boolean, email: string }> } | { __typename?: 'DrivingSlipCategoryMappingSettings', id: string, type: string, drivingSlipCategoryMappings: Array<{ __typename?: 'DrivingSlipCategoryMapping', drivingSlipCategory: string, damageCategoryId: string, damageCauseId: string }> } | { __typename?: 'In4moSettings', id: string, type: string, username: string, password: string, debitorMappings: Array<{ __typename?: 'In4moDebitorMapping', insuranceCompany: string, debitor: string }>, damageMappings: Array<{ __typename?: 'In4moDamageMapping', damageType: In4moDamageType, taskType: In4moTaskType, damageCause: string }> } | { __typename?: 'InvoiceSettings', id: string, type: string, automaticInvoiceGroupPrefixes: Array<string>, isAmountBelowAmount: number, minHourlyRate: number } | { __typename?: 'MachineNotificationSetting', id: string, type: string, machineNotifications: Array<{ __typename?: 'MachineNotification', days: number, active: boolean }> } | { __typename?: 'SMSSettings', id: string, type: string, endpoint: string, originator: string, username: string, password: string } | { __typename?: 'SPSettings', id: string, type: string, logins: Array<{ __typename?: 'SPLogin', insuranceCompany: string, userLogin: string, token: string, debitors: Array<string>, contentSectorCategories: Array<string> }>, debitorMappings: Array<{ __typename?: 'SPDebitorMapping', insuranceCompany: string, insuranceSubCompany: string | null, debitor: string }>, damageMappings: Array<{ __typename?: 'SPDamageMapping', insuranceCompany: string, damageCategories: Array<{ __typename?: 'StringKVP', key: string, value: string }>, damageCauses: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> } | { __typename?: 'SmtpSettings', id: string, type: string, host: string, port: string, email: string, username: string, password: string }> };

export type UpdateSettingsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  bcSetting?: InputMaybe<BcSettingsInput>;
  spSetting?: InputMaybe<SpSettingsInput>;
  smsSetting?: InputMaybe<SmsSettingsInput>;
  smtpSetting?: InputMaybe<SmtpSettingsInput>;
  catalogNotificationSetting?: InputMaybe<CatalogNotificationSettingInput>;
  invoiceSetting?: InputMaybe<InvoiceSettingsInput>;
  in4moSetting?: InputMaybe<In4moSettingsInput>;
  drivingSlipCategoryMappingSettings?: InputMaybe<DrivingSlipCategoryMappingSettingsInput>;
  machineNotificationSetting?: InputMaybe<MachineNotificationSettingInput>;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSetting: { __typename?: 'BCSettings', id: string } | { __typename?: 'CatalogNotificationSetting', id: string } | { __typename?: 'DrivingSlipCategoryMappingSettings', id: string } | { __typename?: 'In4moSettings', id: string } | { __typename?: 'InvoiceSettings', id: string } | { __typename?: 'MachineNotificationSetting', id: string } | { __typename?: 'SMSSettings', id: string } | { __typename?: 'SPSettings', id: string } | { __typename?: 'SmtpSettings', id: string } | null };

export type CreateBusinessAreaMutationVariables = Exact<{
  business: BusinessAreaInputType;
}>;


export type CreateBusinessAreaMutation = { __typename?: 'Mutation', createBusinessArea: { __typename?: 'BusinessArea', id: string, name: string } };

export type DeleteBusinessAreaMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteBusinessAreaMutation = { __typename?: 'Mutation', deleteBusinessArea: { __typename?: 'EmptyReturn', _: string } | null };

export type GetBusinessAreaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessAreaQuery = { __typename?: 'Query', businessAreas: Array<{ __typename?: 'BusinessArea', id: string, name: string }> };

export type UpdateBusinessAreaMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateBusinessAreaMutation = { __typename?: 'Mutation', updateBusinessArea: { __typename?: 'BusinessArea', id: string, name: string } };

export type GetAdminCaseAdminDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminCaseAdminDataQuery = { __typename?: 'Query', damageCategories: Array<{ __typename?: 'DamageCategory', id: string, name: string }>, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }>, departments: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }>, locations: Array<{ __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }>, usersWithCalendars: Array<{ __typename?: 'User', plannerHelpText: string | null, plannerHelpTextUpdatedAt: string | null, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }> };

export type GetAdminCasesQueryVariables = Exact<{
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  erpReferenceNo?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAdminCasesQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, erpNo: string, status: CaseStatus }> };

export type GetCasesNotPostedInBcQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCasesNotPostedInBcQuery = { __typename?: 'Query', casesNotPostedInBc: Array<{ __typename?: 'DraftInvoice', caseErpNo: string, erpReferenceNo: string, status: InvoiceStatus }> };

export type AddRemoveUsersToAllCatalogCustomersMutationVariables = Exact<{
  adUsers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  add: Scalars['Boolean']['input'];
}>;


export type AddRemoveUsersToAllCatalogCustomersMutation = { __typename?: 'Mutation', addRemoveUsersToAllCatalogCustomers: string };

export type CreateCatalogCustomerMutationVariables = Exact<{
  catalogCustomer: CatalogCustomerInputType;
}>;


export type CreateCatalogCustomerMutation = { __typename?: 'Mutation', createCatalogCustomer: { __typename?: 'CatalogCustomer', id: string, name: string, user: { __typename?: 'User', id: string, name: string } | null, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> } };

export type DeleteCatalogCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCatalogCustomerMutation = { __typename?: 'Mutation', deleteCatalogCustomer: { __typename?: 'EmptyReturn', _: string } | null };

export type GetAdminCatalogCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminCatalogCustomersQuery = { __typename?: 'Query', catalogCustomers: Array<{ __typename?: 'CatalogCustomer', id: string, name: string, user: { __typename?: 'User', id: string, name: string } | null, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> }> };

export type UpdateCatalogCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  adUsers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateCatalogCustomerMutation = { __typename?: 'Mutation', updateCatalogCustomer: { __typename?: 'CatalogCustomer', id: string, name: string, user: { __typename?: 'User', id: string, name: string } | null, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> } };

export type GetAdminCatalogsQueryVariables = Exact<{
  customerIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAdminCatalogsQuery = { __typename?: 'Query', catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, craftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, contactName: string }>, contacts: Array<{ __typename?: 'CatalogContact', id: string, contactName: string }>, timedMessages: Array<{ __typename?: 'TimedMessage', id: string, message: string }> }> };

export type CreateCollectionItemMutationVariables = Exact<{
  collectionItem: CollectionItemInputType;
}>;


export type CreateCollectionItemMutation = { __typename?: 'Mutation', createCollectionItem: { __typename?: 'CollectionItem', id: string, name: string, type: CollectionItemType } };

export type DeleteCollectionItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCollectionItemMutation = { __typename?: 'Mutation', deleteCollectionItem: { __typename?: 'EmptyReturn', _: string } | null };

export type GetCollectionItemsQueryVariables = Exact<{
  type?: InputMaybe<CollectionItemType>;
}>;


export type GetCollectionItemsQuery = { __typename?: 'Query', collectionItems: Array<{ __typename?: 'CollectionItem', id: string, name: string, type: CollectionItemType }> };

export type UpdateCollectionItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CollectionItemType>;
}>;


export type UpdateCollectionItemMutation = { __typename?: 'Mutation', updateCollectionItem: { __typename?: 'CollectionItem', id: string, name: string, type: CollectionItemType } };

export type CreateDamageCategoryMutationVariables = Exact<{
  damageCategory: DamageCategoryInputType;
}>;


export type CreateDamageCategoryMutation = { __typename?: 'Mutation', createDamageCategory: { __typename?: 'DamageCategory', id: string, name: string } };

export type DeleteDamageCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDamageCategoryMutation = { __typename?: 'Mutation', deleteDamageCategory: { __typename?: 'EmptyReturn', _: string } | null };

export type GetAdminDamageCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminDamageCategoriesQuery = { __typename?: 'Query', damageCategoriesAdmin: Array<{ __typename?: 'DamageCategory', id: string, name: string }> };

export type UpdateDamageCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateDamageCategoryMutation = { __typename?: 'Mutation', updateDamageCategory: { __typename?: 'DamageCategory', id: string, name: string } };

export type CreateDamageCauseMutationVariables = Exact<{
  damageCause: DamageCauseInputType;
}>;


export type CreateDamageCauseMutation = { __typename?: 'Mutation', createDamageCause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } };

export type DeleteDamageCauseMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDamageCauseMutation = { __typename?: 'Mutation', deleteDamageCause: { __typename?: 'EmptyReturn', _: string } | null };

export type GetAdminDamageCausesQueryVariables = Exact<{
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAdminDamageCausesQuery = { __typename?: 'Query', damageCausesAdmin: Array<{ __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }> };

export type GetDamageCauseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDamageCauseQuery = { __typename?: 'Query', damageCause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } };

export type UpdateDamageCauseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  category: Scalars['String']['input'];
  business: Scalars['String']['input'];
  track: Scalars['Int']['input'];
  urgent: Scalars['Boolean']['input'];
}>;


export type UpdateDamageCauseMutation = { __typename?: 'Mutation', updateDamageCause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } };

export type CreateDebitorDelayScalepointConnectionMutationVariables = Exact<{
  debitorId: Scalars['String']['input'];
  damageCauseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateDebitorDelayScalepointConnectionMutation = { __typename?: 'Mutation', createDebitorDelayScalepointConnection: { __typename?: 'DebitorDelayScalepointConnection', id: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string }, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, category: { __typename?: 'DamageCategory', id: string, name: string } }> } };

export type DebitorDelayScalepointConnectionFragmentFragment = { __typename?: 'DebitorDelayScalepointConnection', id: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string }, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, category: { __typename?: 'DamageCategory', id: string, name: string } }> };

export type DeleteDebitorDelayScalepointConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDebitorDelayScalepointConnectionMutation = { __typename?: 'Mutation', deleteDebitorDelayScalepointConnection: string };

export type EditDebitorDelayScalepointConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  damageCauseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EditDebitorDelayScalepointConnectionMutation = { __typename?: 'Mutation', editDebitorDelayScalepointConnection: { __typename?: 'DebitorDelayScalepointConnection', id: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string }, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, category: { __typename?: 'DamageCategory', id: string, name: string } }> } };

export type GetAdminDebitorsQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type GetAdminDebitorsQuery = { __typename?: 'Query', debitors: Array<{ __typename?: 'DebitorBase', debitorId: string, company: string }> };

export type GetAllEcbDebitorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEcbDebitorsQuery = { __typename?: 'Query', allECBDebitors: Array<{ __typename?: 'DebitorBase', debitorId: string, type: DebitorType, gln: string | null, phone: string | null, email: string | null, company: string, createInECB: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string } | null }> };

export type GetDebitorDelayScalepointConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDebitorDelayScalepointConnectionsQuery = { __typename?: 'Query', debitorDelayScalepointConnections: Array<{ __typename?: 'DebitorDelayScalepointConnection', id: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string }, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, category: { __typename?: 'DamageCategory', id: string, name: string } }> }> };

export type GetDebitorsAndGroupsQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type GetDebitorsAndGroupsQuery = { __typename?: 'Query', debitorsAndGroups: { __typename?: 'DebitorsWithGroups', debitorGroups: Array<string> | null, debitors: Array<{ __typename?: 'Debitor', debitorId: string, company: string }> | null } };

export type GetDebitorsByReferenceNoQueryVariables = Exact<{
  referenceNoList: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDebitorsByReferenceNoQuery = { __typename?: 'Query', debitorsByReferenceNo: Array<{ __typename?: 'DebitorBase', debitorId: string, company: string }> };

export type CreateDepartmentMutationVariables = Exact<{
  department: DepartmentInputType;
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment: { __typename?: 'Department', id: string } };

export type DeleteDepartmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDepartmentMutation = { __typename?: 'Mutation', deleteDepartment: { __typename?: 'EmptyReturn', _: string } | null };

export type GetAdminDepartmentsQueryVariables = Exact<{
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAdminDepartmentsQuery = { __typename?: 'Query', departmentsAdmin: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, operationManagers: Array<{ __typename?: 'User', id: string, name: string }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }> };

export type UpdateDepartmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  departmentNumber?: InputMaybe<Scalars['Int']['input']>;
  operationManagers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateDepartmentMutation = { __typename?: 'Mutation', updateDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } };

export type GetDrivingSlipCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDrivingSlipCategoriesQuery = { __typename?: 'Query', drivingSlipCategories: Array<{ __typename?: 'DrivingSlipCategory', code: string, name: string, erpReferenceTasks: Array<string> }> };

export type CasesGdprCompliantMutationVariables = Exact<{
  caseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CasesGdprCompliantMutation = { __typename?: 'Mutation', casesGDPRCompliant: Array<{ __typename?: 'Case', id: string, erpNo: string }> };

export type CreateGroupPermissionMutationVariables = Exact<{
  groupPermission: GroupPermissionInputType;
  groupPermissionsList: Array<Permissions> | Permissions;
}>;


export type CreateGroupPermissionMutation = { __typename?: 'Mutation', createGroupPermission: { __typename?: 'GroupPermission', id: string, name: string, groupPermissionId: string, groupPermissions: Array<Permissions>, isNew: boolean, groupDebitorGroups: Array<string>, groupLocations: Array<string>, groupDepartments: Array<string>, groupDamageCategories: Array<string>, groupDamageCauses: Array<string>, groupRequisitionDepartments: Array<string>, groupDebitors: Array<{ __typename?: 'GroupPermissionListItem', value: string, label: string }> } };

export type GetGroupsPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsPermissionsQuery = { __typename?: 'Query', groupsPermissions: Array<{ __typename?: 'GroupPermission', id: string, name: string, groupPermissionId: string, groupPermissions: Array<Permissions>, isNew: boolean, groupDebitorGroups: Array<string>, groupLocations: Array<string>, groupDepartments: Array<string>, groupDamageCategories: Array<string>, groupDamageCauses: Array<string>, groupRequisitionDepartments: Array<string>, groupDebitors: Array<{ __typename?: 'GroupPermissionListItem', value: string, label: string }> }> };

export type SearchUserPermissionsQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchUserPermissionsQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', permissions: Array<Permissions>, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, groupPermissions: Array<{ __typename?: 'GroupPermission', id: string, name: string }> }> };

export type UpdateGroupPermissionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  groupPermissionsList?: InputMaybe<Array<Permissions> | Permissions>;
  groupDebitors?: InputMaybe<Array<GroupPermissionInputListItemType> | GroupPermissionInputListItemType>;
  groupDebitorGroups?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  groupLocations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  groupDepartments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  groupDamageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  groupDamageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  groupRequisitionDepartments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateGroupPermissionMutation = { __typename?: 'Mutation', updateGroupPermission: { __typename?: 'GroupPermission', id: string, name: string, groupPermissionId: string, groupPermissions: Array<Permissions>, isNew: boolean, groupDebitorGroups: Array<string>, groupLocations: Array<string>, groupDepartments: Array<string>, groupDamageCategories: Array<string>, groupDamageCauses: Array<string>, groupRequisitionDepartments: Array<string>, groupDebitors: Array<{ __typename?: 'GroupPermissionListItem', value: string, label: string }> } };

export type CreateInputFieldMutationVariables = Exact<{
  inputField: InputFieldInput;
}>;


export type CreateInputFieldMutation = { __typename?: 'Mutation', createInputfield: { __typename?: 'InputField', key: string, permissions: Array<Permissions>, required: boolean } | null };

export type DeleteInputFieldMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type DeleteInputFieldMutation = { __typename?: 'Mutation', deleteInputField: { __typename?: 'EmptyReturn', _: string } | null };

export type GetInputFieldsAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInputFieldsAllQuery = { __typename?: 'Query', inputFieldsAll: Array<{ __typename?: 'InputField', key: string, permissions: Array<Permissions>, required: boolean }> };

export type UpdateAdminInputFieldMutationVariables = Exact<{
  key: Scalars['String']['input'];
  permissionsList?: InputMaybe<Array<Permissions> | Permissions>;
  required: Scalars['Boolean']['input'];
}>;


export type UpdateAdminInputFieldMutation = { __typename?: 'Mutation', updateInputField: { __typename?: 'InputField', key: string, permissions: Array<Permissions>, required: boolean } | null };

export type CreateInvoiceReasonCodeMutationVariables = Exact<{
  invoiceReasonCode: InvoiceReasonCodeInputType;
}>;


export type CreateInvoiceReasonCodeMutation = { __typename?: 'Mutation', createInvoiceReasonCode: { __typename?: 'InvoiceReasonCode', id: string, name: string } };

export type DeleteInvoiceAdminMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
}>;


export type DeleteInvoiceAdminMutation = { __typename?: 'Mutation', deleteInvoiceAdmin: string };

export type DeleteInvoiceReasonCodeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteInvoiceReasonCodeMutation = { __typename?: 'Mutation', deleteInvoiceReasonCode: string };

export type GetCaseInvoicesQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
}>;


export type GetCaseInvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'DraftInvoice', erpReferenceNo: string, status: InvoiceStatus, screeningERPReferenceNoList: Array<string> | null, category: InvoiceCategory, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string }> }> };

export type GetInvoiceReasonCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceReasonCodesQuery = { __typename?: 'Query', invoiceReasonCodes: Array<{ __typename?: 'InvoiceReasonCode', id: string, name: string }> };

export type UpdateInvoiceReasonCodeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateInvoiceReasonCodeMutation = { __typename?: 'Mutation', updateInvoiceReasonCode: { __typename?: 'InvoiceReasonCode', id: string, name: string } };

export type CreateLocationMutationVariables = Exact<{
  location: LocationInputType;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'Location', id: string } | null };

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: { __typename?: 'EmptyReturn', _: string } | null };

export type GetAdminLocationsQueryVariables = Exact<{
  useLimitations?: InputMaybe<Scalars['Boolean']['input']>;
  movableLocationsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAdminLocationsQuery = { __typename?: 'Query', locationsAdmin: Array<{ __typename?: 'Location', attachedPostalCodesInputString: string, attachedPostalCodes: Array<string>, email: string, id: string, name: string, movables: boolean, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }> };

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  movables?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  attachedPostalCodesInputString?: InputMaybe<Scalars['String']['input']>;
  attachedPostalCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'Location', email: string, id: string, name: string, movables: boolean, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null };

export type GetLogDataPeriodQueryVariables = Exact<{
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
}>;


export type GetLogDataPeriodQuery = { __typename?: 'Query', logDataPeriod: string };

export type GetAdminMachineLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminMachineLocationsQuery = { __typename?: 'Query', machineLocations: Array<{ __typename?: 'MachineLocation', locationCode: string, address: string, city: string, contact: string, name: string, postCode: string, unavaliable: boolean }> };

export type GetAdminMachinesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminMachinesQuery = { __typename?: 'Query', machines: Array<{ __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean }> };

export type CreateMovablesLocationsMutationVariables = Exact<{
  movablesLocations: Array<MovablesLocationInputType> | MovablesLocationInputType;
}>;


export type CreateMovablesLocationsMutation = { __typename?: 'Mutation', createMovablesLocations: Array<{ __typename?: 'MovablesLocation', id: string }> };

export type DeleteMovablesLocationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteMovablesLocationMutation = { __typename?: 'Mutation', deleteMovablesLocation: { __typename?: 'EmptyReturn', _: string } | null };

export type DeleteMovablesLocationsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteMovablesLocationsMutation = { __typename?: 'Mutation', deleteMovablesLocations: Array<string> };

export type GetMovablesLocationsQueryVariables = Exact<{
  location?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMovablesLocationsQuery = { __typename?: 'Query', movablesLocations: Array<{ __typename?: 'MovablesLocation', id: string, name: string, volume: number, accVolume: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }> };

export type UpdateMovablesLocationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  volume: Scalars['Decimal']['input'];
}>;


export type UpdateMovablesLocationMutation = { __typename?: 'Mutation', updateMovablesLocation: { __typename?: 'MovablesLocation', id: string, name: string, volume: number, accVolume: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } };

export type CreateNotificationConfigMutationVariables = Exact<{
  config: NotificationConfigInputType;
}>;


export type CreateNotificationConfigMutation = { __typename?: 'Mutation', createNotificationConfig: { __typename?: 'NotificationConfig', id: string, trigger: NotificationTrigger, emailBodyTemplateId: number | null, smsTemplateId: number | null, emailSubjectTemplate: string | null, displayName: string | null } | null };

export type DeleteNotificationConfigMutationVariables = Exact<{
  trigger: NotificationTrigger;
}>;


export type DeleteNotificationConfigMutation = { __typename?: 'Mutation', deleteNotificationConfig: { __typename?: 'EmptyReturn', _: string } | null };

export type GetEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailTemplatesQuery = { __typename?: 'Query', emailTemplates: Array<{ __typename?: 'SharePointTemplate', id: number, name: string }> };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', notificationConfigs: Array<{ __typename?: 'NotificationConfig', id: string, trigger: NotificationTrigger, emailBodyTemplateId: number | null, smsTemplateId: number | null, emailSubjectTemplate: string | null, displayName: string | null }> };

export type GetSmsTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmsTemplatesQuery = { __typename?: 'Query', smsTemplates: Array<{ __typename?: 'SharePointTemplate', id: number, name: string }> };

export type UpdateNotificationConfigMutationVariables = Exact<{
  id: Scalars['String']['input'];
  trigger: NotificationTrigger;
  emailBodyTemplateId?: InputMaybe<Scalars['Int']['input']>;
  emailSubjectTemplate?: InputMaybe<Scalars['String']['input']>;
  smsTemplateId?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateNotificationConfigMutation = { __typename?: 'Mutation', updateNotificationConfig: { __typename?: 'NotificationConfig', id: string, trigger: NotificationTrigger, emailBodyTemplateId: number | null, smsTemplateId: number | null, emailSubjectTemplate: string | null, displayName: string | null } | null };

export type GetNotificationItemsQueryVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNotificationItemsQuery = { __typename?: 'Query', notificationItems: Array<{ __typename?: 'NotificationItem', id: string, trigger: NotificationTrigger, sendTo: string | null, objectType: string, objectId: string, type: string, sentSuccessfully: boolean, error: string | null, sentAt: string }> };

export type CreateQuestionnaireTemplateMutationVariables = Exact<{
  questionnaireTemplate: QuestionnaireTemplateInput;
}>;


export type CreateQuestionnaireTemplateMutation = { __typename?: 'Mutation', createQuestionnaireTemplate: { __typename?: 'QuestionnaireTemplate', id: string, label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, version: number, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, isMultiSelectAllowed: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, multiSelectValues: Array<string> | null }> }> } };

export type DeleteQuestionnaireTemplatesMutationVariables = Exact<{
  questionnaireTemplateIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteQuestionnaireTemplatesMutation = { __typename?: 'Mutation', deleteQuestionnaireTemplates: { __typename?: 'EmptyReturn', _: string } | null };

export type GetAllQuestionnaireTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllQuestionnaireTemplatesQuery = { __typename?: 'Query', allQuestionnaireTemplates: Array<{ __typename?: 'QuestionnaireTemplate', id: string, label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, version: number, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, isMultiSelectAllowed: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, multiSelectValues: Array<string> | null }> }> }> };

export type UpdateQuestionnaireTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  sections: Array<QuestionnaireSectionInputType> | QuestionnaireSectionInputType;
  damageCauses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  drivingSlipCategories: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateQuestionnaireTemplateMutation = { __typename?: 'Mutation', updateQuestionnaireTemplate: { __typename?: 'QuestionnaireTemplate', id: string, label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, version: number, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, isMultiSelectAllowed: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, multiSelectValues: Array<string> | null }> }> } };

export type CreateRiskEvaluationCategoryMutationVariables = Exact<{
  riskEvaluationCategory: RiskEvaluationCategoryInput;
}>;


export type CreateRiskEvaluationCategoryMutation = { __typename?: 'Mutation', createRiskEvaluationCategory: { __typename?: 'RiskEvaluationCategory', id: string, categoryName: string } };

export type CreateRiskEvaluationQuestionMutationVariables = Exact<{
  riskEvaluationQuestion: RiskEvaluationQuestionInput;
}>;


export type CreateRiskEvaluationQuestionMutation = { __typename?: 'Mutation', createRiskEvaluationQuestion: { __typename?: 'RiskEvaluationQuestion', id: string, question: string, helpText: string, defaultChecked: boolean, category: { __typename?: 'RiskEvaluationCategory', id: string, categoryName: string } } };

export type DeleteRiskEvaluationCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteRiskEvaluationCategoryMutation = { __typename?: 'Mutation', deleteRiskEvaluationCategory: { __typename?: 'EmptyReturn', _: string } | null };

export type DeleteRiskEvaluationQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteRiskEvaluationQuestionMutation = { __typename?: 'Mutation', deleteRiskEvaluationQuestion: { __typename?: 'EmptyReturn', _: string } | null };

export type GetRiskEvaluationQuestionsByCategoryIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRiskEvaluationQuestionsByCategoryIdQuery = { __typename?: 'Query', riskEvaluationQuestionsByCategoryId: Array<{ __typename?: 'RiskEvaluationQuestion', id: string, question: string, helpText: string, defaultChecked: boolean, category: { __typename?: 'RiskEvaluationCategory', id: string, categoryName: string } }> };

export type GetRiskEvaluationCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskEvaluationCategoriesQuery = { __typename?: 'Query', riskEvaluationCategories: Array<{ __typename?: 'RiskEvaluationCategory', id: string, categoryName: string }> };

export type GetRiskEvaluationQuestionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRiskEvaluationQuestionQuery = { __typename?: 'Query', riskEvaluationQuestion: { __typename?: 'RiskEvaluationQuestion', id: string, question: string, helpText: string, defaultChecked: boolean, category: { __typename?: 'RiskEvaluationCategory', id: string, categoryName: string } } };

export type GetRiskEvaluationQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskEvaluationQuestionsQuery = { __typename?: 'Query', riskEvaluationQuestions: Array<{ __typename?: 'RiskEvaluationQuestion', id: string, question: string, helpText: string, defaultChecked: boolean, category: { __typename?: 'RiskEvaluationCategory', id: string, categoryName: string } }> };

export type UpdateRiskEvaluationCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  categoryName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRiskEvaluationCategoryMutation = { __typename?: 'Mutation', updateRiskEvaluationCategory: { __typename?: 'RiskEvaluationCategory', id: string, categoryName: string } };

export type UpdateRiskEvaluationQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  defaultChecked?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRiskEvaluationQuestionMutation = { __typename?: 'Mutation', updateRiskEvaluationQuestion: { __typename?: 'RiskEvaluationQuestion', id: string, question: string, helpText: string, defaultChecked: boolean, category: { __typename?: 'RiskEvaluationCategory', id: string, categoryName: string } } };

export type CreateScreeningPositionTextMutationVariables = Exact<{
  screeningPositionText: ScreeningPositionTextInput;
}>;


export type CreateScreeningPositionTextMutation = { __typename?: 'Mutation', createScreeningPositionText: { __typename?: 'ScreeningPositionText', id: string, templateCode: string, position: string, text: string } };

export type DeleteScreeningPositionTextMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteScreeningPositionTextMutation = { __typename?: 'Mutation', deleteScreeningPositionText: { __typename?: 'EmptyReturn', _: string } | null };

export type GetAdminScreeningPositionTextsQueryVariables = Exact<{
  templateCodes?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetAdminScreeningPositionTextsQuery = { __typename?: 'Query', screeningPositionTexts: Array<{ __typename?: 'ScreeningPositionText', id: string, templateCode: string, position: string, text: string }> };

export type GetScreeningTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScreeningTemplatesQuery = { __typename?: 'Query', screeningTemplates: Array<{ __typename?: 'Screening', erpReferenceId: string | null, templateCode: string, templateName: string, lines: Array<{ __typename?: 'ScreeningLine', erpReferenceId: string, id: number, parentId: number | null, position: string | null, erpReferenceTask: string, erpReferenceAccount: string, required: boolean, type: ScreeningLineType, index: number, title: string, allowCustomTitle: boolean, uom: string, price: number, linePremiumPercentage: number | null, linePremiumFixedAmount: number | null, linePremiumId: number | null, showCalendar: boolean, excludeFromEnvFee: boolean | null }> }> };

export type UpdateScreeningPositionTextMutationVariables = Exact<{
  id: Scalars['String']['input'];
  templateCode: Scalars['String']['input'];
  position: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateScreeningPositionTextMutation = { __typename?: 'Mutation', updateScreeningPositionText: { __typename?: 'ScreeningPositionText', id: string, templateCode: string, position: string, text: string } | null };

export type GetAdminCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', permissions: Array<Permissions>, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null };

export type GetProxyUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProxyUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, name: string, email: string, proxyUpdatedAt: string, proxySetBy: { __typename?: 'User', id: string, name: string, email: string } | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null }> };

export type GetUsersQueryVariables = Exact<{
  external?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedBefore?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, name: string, email: string, updatedAt: string, external: boolean, phone: string | null, employeeId: string | null }> };

export type SearchAdminUsersQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchAdminUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }> };

export type SearchUserEmailsQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchUserEmailsQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: string, email: string }> };

export type SearchUserNamesQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type SearchUserNamesQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: string, name: string }> };

export type SetUserDefaultLanguageMutationVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type SetUserDefaultLanguageMutation = { __typename?: 'Mutation', setUserDefaultLanguage: { __typename?: 'User', defaultLanguage: string | null } };

export type CreateQuestionMutationVariables = Exact<{
  question: VisitationQuestionInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion: { __typename?: 'VisitationQuestion', id: string, question: string, damageCause: { __typename?: 'DamageCause', id: string, name: string }, damageCategory: { __typename?: 'DamageCategory', id: string, name: string } } };

export type DeleteQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion: { __typename?: 'EmptyReturn', _: string } | null };

export type GetQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionsQuery = { __typename?: 'Query', questions: Array<{ __typename?: 'VisitationQuestion', id: string, question: string, damageCause: { __typename?: 'DamageCause', id: string, name: string }, damageCategory: { __typename?: 'DamageCategory', id: string, name: string } }> };

export type UpdateQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  question: Scalars['String']['input'];
  damageCategory: Scalars['String']['input'];
  damageCause: Scalars['String']['input'];
}>;


export type UpdateQuestionMutation = { __typename?: 'Mutation', updateQuestion: { __typename?: 'VisitationQuestion', id: string, question: string, damageCause: { __typename?: 'DamageCause', id: string, name: string }, damageCategory: { __typename?: 'DamageCategory', id: string, name: string } } };

export type AddressFragmentFragment = { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string };

export type BaseApvFragmentFragment = { __typename?: 'APV', id: string, url: string, damageCategory: { __typename?: 'DamageCategory', id: string, name: string }, damageCause: { __typename?: 'DamageCause', id: string, name: string } };

export type BaseBusinessAreaFragmentFragment = { __typename?: 'BusinessArea', id: string, name: string };

export type BaseCarFragmentFragment = { __typename?: 'Car', id: string, name: string, department: string | null, email: string };

export type BaseCaseFragmentFragment = { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null };

export type BaseCaseNoDrivingSlipsFragmentFragment = { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, comment: string | null } }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, caseMachineUsages: Array<{ __typename?: 'CaseMachineUsage', machine: string, startTime: string, endTime: string | null, startMeterReading: number, endMeterReading: number | null }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, policyHolder: { __typename?: 'Contact', phone: string, email: string }, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null };

export type BaseCatalogAddressFragmentFragment = { __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string };

export type BaseCatalogContactFragmentFragment = { __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> };

export type BaseCatalogCraftsmanFragmentFragment = { __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> };

export type BaseCatalogCustomerFragmentFragment = { __typename?: 'CatalogCustomer', id: string, name: string, user: { __typename?: 'User', id: string, name: string } | null, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> };

export type BaseCatalogFragmentFragment = { __typename?: 'Catalog', id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null };

export type BaseCatalogFragmentChangesFragment = { __typename?: 'Catalog', id: string, propertyNumber: string, changedBy: string, ssgAccountable: string | null, description: string | null, contactNumber: string | null, contactHours: string | null, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null } | null, changes: Array<{ __typename?: 'CatalogChange', timestamp: string, changedBy: string | null, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'CatalogChangeDifference', ssgAccountable: string | null, propertyNumber: string | null, changedBy: string | null, description: string | null, contactNumber: string | null, contactHours: string | null, filenames: string | null, smsService: boolean | null, verified: boolean, debitorVerified: boolean, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> | null, contacts: { __typename?: 'CatalogContactChangeDifference', changedBy: string | null, contactName: string | null, type: string | null, contactType: CatalogContacts | null, email: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, craftsmen: { __typename?: 'CatalogCraftsmanChangeDifference', changedBy: string | null, type: string | null, contactName: string | null, email: string | null, priority: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, timedMessages: { __typename?: 'TimedMessageChangeDifference', changedBy: string | null, startTime: string | null, endTime: string | null, message: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null } | null }, after: { __typename?: 'CatalogChangeDifference', ssgAccountable: string | null, propertyNumber: string | null, changedBy: string | null, description: string | null, contactNumber: string | null, contactHours: string | null, filenames: string | null, smsService: boolean | null, verified: boolean, debitorVerified: boolean, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> | null, contacts: { __typename?: 'CatalogContactChangeDifference', changedBy: string | null, contactName: string | null, type: string | null, contactType: CatalogContacts | null, email: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, craftsmen: { __typename?: 'CatalogCraftsmanChangeDifference', changedBy: string | null, type: string | null, contactName: string | null, email: string | null, priority: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, timedMessages: { __typename?: 'TimedMessageChangeDifference', changedBy: string | null, startTime: string | null, endTime: string | null, message: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null } | null } }> };

export type BaseCollectionItemFragmentFragment = { __typename?: 'CollectionItem', id: string, name: string, type: CollectionItemType };

export type BaseDamageCategoryFragmentFragment = { __typename?: 'DamageCategory', id: string, name: string };

export type BaseDamageCauseFragmentFragment = { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null };

export type BaseDebitorFragmentFragment = { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null };

export type BaseDepartmentFragmentFragment = { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } };

export type BaseDrivingSlipCaseFragmentFragment = { __typename?: 'Case', id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } };

export type BaseDrivingSlipFragmentFragment = { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } };

export type BaseDrivingSlipQuestionnaireFragmentFragment = { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } };

export type BaseDrivingSlipQuestionnaireTemplateFragmentFragment = { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> };

export type BaseGdprFragmentFragment = { __typename?: 'GDPR', id: string, timestamp: string, userId: { __typename?: 'User', id: string } };

export type BaseGroupPermissionFragmentFragment = { __typename?: 'GroupPermission', id: string, name: string, groupPermissionId: string, groupPermissions: Array<Permissions>, isNew: boolean, groupDebitorGroups: Array<string>, groupLocations: Array<string>, groupDepartments: Array<string>, groupDamageCategories: Array<string>, groupDamageCauses: Array<string>, groupRequisitionDepartments: Array<string>, groupDebitors: Array<{ __typename?: 'GroupPermissionListItem', value: string, label: string }> };

export type BaseInspectionReportFormDataFragmentFragment = { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null };

export type BaseJobFragmentFragment = { __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null };

export type BaseLocationFragmentFragment = { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } };

export type BaseMachineFragmentFragment = { __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean };

export type BaseMachineLocationFragmentFragment = { __typename?: 'MachineLocation', locationCode: string, address: string, city: string, contact: string, name: string, postCode: string, unavaliable: boolean };

export type BaseMoistureReportFormDataFragmentFragment = { __typename?: 'MoistureReportFormData', inspectionDate: string, conclusion: string, damageCause: string, scope: string, contacts: string, regres: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, damageCauseImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, floorReport: Array<{ __typename?: 'FloorMoistureReportFormData', name: string, observations: { __typename?: 'MoistureReportObservations', roomOrApartment: string, construction: string | null, contacts: string | null, ceiling: string | null, walls: string | null, floor: string | null, movables: string | null, scope: string, recommendations: string }, moistureMeassurements: Array<{ __typename?: 'MoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, value: string, expectedFinalValue: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> };

export type BaseMoistureTrygReportFormDataFragmentFragment = { __typename?: 'MoistureTrygReportFormData', inspectionDate: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorReport: Array<{ __typename?: 'FloorMoistureTrygReportFormData', name: string | null, damageCause: string | null, multipleDamageCauses: string | null, moistureDamageCause: string | null, damageDescription: string | null, recommendations: string | null, urgentActions: string | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, moistureMeassurements: Array<{ __typename?: 'TrygMoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, paints: string, paintsDate: string | null, expectedFinalValue: string | null, expectedFinalDate: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, airMeassurements: { __typename?: 'AirMeassurementDetails', temperatureInside: number, temperatureOutside: number, relativeHumidityInside: number, relativeHumidityOutside: number, waterAmountInside: number, waterAmountOutside: number }, damageDescriptionImage: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, damageDrawingImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> | null };

export type BaseMovableFragmentFragment = { __typename?: 'Movable', id: string, description: string, volume: number, completed: boolean, status: string, version: number, case: { __typename?: 'Case', id: string, erpNo: string }, placement: { __typename?: 'MovablesLocation', id: string, name: string, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, changes: Array<{ __typename?: 'MovableChange', timestamp: string, user: { __typename?: 'User', id: string, name: string, email: string }, before: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null }, after: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null } }> };

export type BaseMovablesLocationFragmentFragment = { __typename?: 'MovablesLocation', id: string, name: string, volume: number, accVolume: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } };

export type BaseNotificationFragmentFragment = { __typename?: 'NotificationConfig', id: string, trigger: NotificationTrigger, emailBodyTemplateId: number | null, smsTemplateId: number | null, emailSubjectTemplate: string | null, displayName: string | null };

export type BaseNotificationItemFragmentFragment = { __typename?: 'NotificationItem', id: string, trigger: NotificationTrigger, sendTo: string | null, objectType: string, objectId: string, type: string, sentSuccessfully: boolean, error: string | null, sentAt: string };

export type BaseOfferFragmentFragment = { __typename?: 'Offer', jobNo: string, opportunityStatus: string | null, headerText: string | null, footerText: string | null, quoteType: OfferQuoteTypeEnum | null, competitionOffer: boolean, lines: Array<{ __typename?: 'OfferLine', documentNo: string, no: string, planningDate: string, description: string, quantity: number, unitPrice: number, newUnitPrice: number | null, lineAmount: number, currencyCode: string | null, workType: string | null, systemId: string | null, eRPReferenceTask: string, type: OfferRessourceType, option: boolean, hideSum: boolean, header: boolean, screeningLineId: string | null, sortingIndex: number, lineNo: number, unitCost: number }> };

export type BaseOfferItemFragmentFragment = { __typename?: 'Item', no: string, description: string, type: string, baseUOM: string };

export type BaseOfferJobTaskFragmentFragment = { __typename?: 'JobTask', erpRefrenceNo: string, jobTaskNo: string, description: string, price: number, workTypeCode: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null };

export type BaseOfferResourceFragmentFragment = { __typename?: 'Resource', no: string, name: string, type: string, baseUOM: string };

export type BaseQuestionnaireTemplateFragmentFragment = { __typename?: 'QuestionnaireTemplate', id: string, label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, version: number, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, isMultiSelectAllowed: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, multiSelectValues: Array<string> | null }> }> };

export type BaseReportFileFragment = { __typename?: 'ReportFile', fileName: string, description: string };

export type BaseRiskEvaluationQuestionFragmentFragment = { __typename?: 'RiskEvaluationQuestion', id: string, question: string, helpText: string, defaultChecked: boolean, category: { __typename?: 'RiskEvaluationCategory', id: string, categoryName: string } };

export type BaseScreeningPositionTextFragmentFragment = { __typename?: 'ScreeningPositionText', id: string, templateCode: string, position: string, text: string };

export type BaseTimeTrackingFragmentFragment = { __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null };

export type BaseTimedMessageFragmentFragment = { __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } };

export type BaseUserFragmentFragment = { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null };

export type BaseVisitationQuestionFragmentFragment = { __typename?: 'VisitationQuestion', id: string, question: string, damageCause: { __typename?: 'DamageCause', id: string, name: string }, damageCategory: { __typename?: 'DamageCategory', id: string, name: string } };

export type CalendarEventFragmentFragment = { __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null };

export type CaseChangesFragmentFragment = { __typename?: 'CaseChangeDifference', status: CaseStatus | null, track: number | null, importantInfo: string | null, skafor: boolean | null, fileNames: string | null, scalePointId: string | null, scalePointNumber: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus | null, debitor: { __typename?: 'Debitor', debitorId: string, type: DebitorType, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string } | null, drivingSlips: { __typename?: 'DrivingSlip', locked: boolean, status: DrivingSlipStatus, urgent: boolean, start: string, end: string, comment: string | null, driver: { __typename?: 'User', name: string } | null, car: { __typename?: 'Vehicle', vehicleNumber: string } | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } | null, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }> | null, caseMachineUsages: Array<{ __typename?: 'CaseMachineUsage', machine: string, startTime: string, endTime: string | null, startMeterReading: number, endMeterReading: number | null }> | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null };

export type CaseOrganizationFormDataFragmentFragment = { __typename?: 'CaseOrganizationFormData', caseOrganizationWorkers: Array<{ __typename?: 'CaseOrganizationWorker', index: number, title: string, name: string, phonenumber: string, date: string | null, instructor: string, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null> | null };

export type CaseUsageFragmentFragment = { __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null };

export type CatalogChangesFragmentFragment = { __typename?: 'CatalogChangeDifference', ssgAccountable: string | null, propertyNumber: string | null, changedBy: string | null, description: string | null, contactNumber: string | null, contactHours: string | null, filenames: string | null, smsService: boolean | null, verified: boolean, debitorVerified: boolean, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> | null, contacts: { __typename?: 'CatalogContactChangeDifference', changedBy: string | null, contactName: string | null, type: string | null, contactType: CatalogContacts | null, email: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, craftsmen: { __typename?: 'CatalogCraftsmanChangeDifference', changedBy: string | null, type: string | null, contactName: string | null, email: string | null, priority: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, timedMessages: { __typename?: 'TimedMessageChangeDifference', changedBy: string | null, startTime: string | null, endTime: string | null, message: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null } | null };

export type CatalogContactChangesFragmentFragment = { __typename?: 'CatalogContactChangeDifference', changedBy: string | null, contactName: string | null, type: string | null, contactType: CatalogContacts | null, email: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null };

export type CatalogCraftsmanChangesFragmentFragment = { __typename?: 'CatalogCraftsmanChangeDifference', changedBy: string | null, type: string | null, contactName: string | null, email: string | null, priority: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null };

export type CatalogFragmentFragment = { __typename?: 'Catalog', ssgAccountable: string | null, description: string | null, id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, craftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }>, contacts: Array<{ __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> }>, timedMessages: Array<{ __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } }>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null };

export type DamageFragmentFragment = { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> };

export type DeviationReportFormDataFragmentFragment = { __typename?: 'DeviationReportFormData', deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string } };

export type DraftInvoiceFragmentFragment = { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> };

export type DraftInvoiceLineFragmentFragment = { __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null };

export type DrivingSlipChangesFragmentFragment = { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null };

export type EsdhFileFragmentFragment = { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> };

export type EndevaluationFormDataFragmentFragment = { __typename?: 'EndevaluationReportFormData', evaluationCategories: Array<{ __typename?: 'EvaluationCategories', index: number, title: string, evaluations: Array<{ __typename?: 'Evaluation', index: number, question: string, answer: EvaluationEnum, remark: string } | null> | null }> | null, deviations: Array<{ __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string }> | null, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null };

export type IndoorClimateReportFormDataFragmentFragment = { __typename?: 'IndoorClimateReportFormData', inspectionDate: string | null, purpose: string | null, buildYear: string | null, squareMeters: string | null, dailyUsers: string | null, participants: string | null, backgroundStory: string | null, observations: string | null, showLabAnswers: boolean, showDataLog: boolean | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, indoorClimateMeassurements: Array<{ __typename?: 'IndoorClimateMeassurement', room: string | null, construction: string | null, material: string | null, description: string | null, instrument: string | null, value: string | null, referenceValue: string | null, calculatedValue: string | null }> | null };

export type GetInputFieldsQueryVariables = Exact<{
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetInputFieldsQuery = { __typename?: 'Query', inputFields: Array<{ __typename?: 'InputField', key: string, permissions: Array<Permissions> }> };

export type InspectionAssesmentFormDataFragmentFragment = { __typename?: 'InspectionAssesmentFormData', assesments: Array<{ __typename?: 'Assesment', id: number, color: AssesmentColor, comment: string, deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, reportDate: string } | null }> | null, signatures: Array<{ __typename?: 'Signature', signatureDate: string | null, index: number | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null> | null };

export type InvoiceReasonCodeFragmentFragment = { __typename?: 'InvoiceReasonCode', id: string, name: string };

export type NoticeOfConstructionwasteFormDataFragmentFragment = { __typename?: 'NoticeOfConstructionwasteFormData', area: string | null, assignment: string | null, wasteFractions: string | null, wastePackaging: string | null, carrier: string | null, yearOfConstruction: string | null, startDate: string | null, endDate: string | null };

export type CreateIndoorClimateReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: IndoorClimateReportFormDataInput;
  reportFormat: ReportFormatType;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateIndoorClimateReportMutation = { __typename?: 'Mutation', createIndoorClimateReport: { __typename?: 'ESDHFile', name: string } | null };

export type CreateWebMoistureReportV2MutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: MoistureReportFormDataInput;
  reportFormat: ReportFormatType;
  floorsToInclude?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateWebMoistureReportV2Mutation = { __typename?: 'Mutation', createMoistureReportV2: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type RequisitionFragmentFragment = { __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } };

export type SalesInvoiceLineFragmentFragment = { __typename?: 'SalesInvoiceLine', systemId: string, documentNo: string | null, lineNo: number | null, no: string | null, type: string | null, description: string | null, quantity: number | null, uom: string | null, unitPrice: number | null, lineDiscountAmount: number | null, lineDiscountPercentage: number | null, amountIncludingVAT: number | null, vatBaseAmount: number | null, vatPercentage: number | null };

export type TimedMessageChangesFragmentFragment = { __typename?: 'TimedMessageChangeDifference', changedBy: string | null, startTime: string | null, endTime: string | null, message: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null };

export type GetCommonCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommonCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', defaultLanguage: string | null, permissions: Array<Permissions>, external: boolean, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, gdpr: { __typename?: 'GDPR', id: string, timestamp: string, userId: { __typename?: 'User', id: string } } | null, caseFilters: Array<{ __typename?: 'UserCaseFilter', key: string, name: string, view: UserCaseFilterViewType, awaiting: boolean | null, damageServiceCompleted: boolean | null, calledBack: boolean | null, machinesOnCase: boolean | null, showEconomyField: boolean, showBusinessAreaField: boolean, showAppliedClosedCases: boolean, showClosedCases: boolean, debitors: Array<string>, postalCodeText: string, postalCodes: Array<string>, track: Array<number>, departments: Array<string>, locations: Array<string>, damageCategories: Array<string>, damageCauses: Array<string>, priority: Array<CasePriority>, caseManagers: Array<string>, projectManagers: Array<string> }>, drivingSlipFilters: Array<{ __typename?: 'UserDrivingSlipFilter', key: string, name: string, debitors: Array<string>, postalCodeText: string, postalCodes: Array<string>, departments: Array<string>, locations: Array<string>, damageCategories: Array<string>, damageCauses: Array<string>, erpNos: Array<string>, projectManagers: Array<string> }>, drivingSlipOverviewFilters: Array<{ __typename?: 'UserDrivingSlipOverviewFilter', key: string, name: string, status: DrivingSlipStatus | null, urgent: boolean | null, exceeded: boolean | null, departments: Array<string>, locations: Array<string>, damageCauses: Array<string>, damageCategories: Array<string>, drivers: Array<string>, noDriver: boolean | null }>, sanitizerFilters: Array<{ __typename?: 'UserSanitizerFilter', key: string, name: string, departments: Array<string>, locations: Array<string>, jobFunctions: Array<string>, sanitizers: Array<string> }>, carFilters: Array<{ __typename?: 'UserVehicleFilter', key: string, name: string, locations: Array<string>, cars: Array<string> }>, movableFilters: Array<{ __typename?: 'UserMovableFilter', key: string, name: string, erpNo: string, location: string, status: string, includeCompleted: boolean, debitors: Array<string> | null }>, jobFilters: Array<{ __typename?: 'UserJobFilter', key: string, name: string, location: string, personalOnly: boolean }>, machineFilters: Array<{ __typename?: 'UserMachineFilter', name: string, key: string, status: MachineStatus | null, cases: Array<string> | null, locations: Array<string> | null, types: Array<string> | null, unavailable: boolean | null, hibernation: boolean | null }> } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', permissions: Array<Permissions>, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null };

export type SetUserProxyMutationVariables = Exact<{
  myAdUserName: Scalars['String']['input'];
  proxyAdUserName: Scalars['String']['input'];
  proxySetByAdUserName: Scalars['String']['input'];
}>;


export type SetUserProxyMutation = { __typename?: 'Mutation', setUserProxy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } };

export type GetVehiclesQueryVariables = Exact<{
  isCar: Scalars['Boolean']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  type?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetVehiclesQuery = { __typename?: 'Query', vehicles: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string, bookedDays: Array<{ __typename?: 'DrivingSlip', id: string, start: string, driver: { __typename?: 'User', id: string, name: string } | null }> }> };

export type VehicleFragment = { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string };

export type VendorFragmentFragment = { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null };

export type BaseDrivingSlipCaseMobileFragmentFragment = { __typename?: 'Case', id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } };

export type CreateCaseAgreementsFromQuestionnaireMutationVariables = Exact<{
  id: Scalars['String']['input'];
  newCaseAgreements: Array<CaseAgreementInput> | CaseAgreementInput;
  trackTwoOptionSelected: Scalars['Boolean']['input'];
  seriesId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCaseAgreementsFromQuestionnaireMutation = { __typename?: 'Mutation', createCaseAgreementsFromQuestionnaire: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type CreateMobileV2CaseDraftItemUsageMutationVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
  itemERPReferenceNo: Scalars['String']['input'];
  itemDescription: Scalars['String']['input'];
  jobTaskERPReferenceNo: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  unitOfMeasureCode: Scalars['String']['input'];
}>;


export type CreateMobileV2CaseDraftItemUsageMutation = { __typename?: 'Mutation', createCaseDraftItemUsage: Array<{ __typename: 'CaseDraftUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unitOfMeasureCode: string, date: string, postedBy: string, description: string }> | null };

export type DeleteMobileV2ItemUsageMutationVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
  itemERPReferenceNo: Scalars['String']['input'];
}>;


export type DeleteMobileV2ItemUsageMutation = { __typename?: 'Mutation', deleteItemUsage: Array<{ __typename?: 'CaseDraftUsageLine', erpId: string, erpKey: string, title: string, quantity: number, date: string, postedBy: string, description: string }> | null };

export type GetCaseDamageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseDamageQuery = { __typename?: 'Query', case: { __typename?: 'Case', damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } } };

export type GetCaseDraftUsageLinesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseDraftUsageLinesQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, caseDraftItemsUsage: Array<{ __typename?: 'CaseDraftUsageLine', erpId: string, erpKey: string, title: string, quantity: number, date: string, postedBy: string }> } };

export type GetCaseIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCaseIdsQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', erpNo: string }> };

export type GetCaseRequisitionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseRequisitionsQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, erpNo: string, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } };

export type GetMobileV2CaseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMobileV2CaseQuery = { __typename?: 'Query', case: { __typename?: 'Case', version: number, id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', automaticTrackOneInvoicing: boolean | null, id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, changes: Array<{ __typename?: 'CaseChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, before: { __typename?: 'CaseChangeDifference', status: CaseStatus | null, track: number | null, importantInfo: string | null, skafor: boolean | null, fileNames: string | null, scalePointId: string | null, scalePointNumber: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus | null, debitor: { __typename?: 'Debitor', debitorId: string, type: DebitorType, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string } | null, drivingSlips: { __typename?: 'DrivingSlip', locked: boolean, status: DrivingSlipStatus, urgent: boolean, start: string, end: string, comment: string | null, driver: { __typename?: 'User', name: string } | null, car: { __typename?: 'Vehicle', vehicleNumber: string } | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } | null, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }> | null, caseMachineUsages: Array<{ __typename?: 'CaseMachineUsage', machine: string, startTime: string, endTime: string | null, startMeterReading: number, endMeterReading: number | null }> | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null }, after: { __typename?: 'CaseChangeDifference', status: CaseStatus | null, track: number | null, importantInfo: string | null, skafor: boolean | null, fileNames: string | null, scalePointId: string | null, scalePointNumber: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus | null, debitor: { __typename?: 'Debitor', debitorId: string, type: DebitorType, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string } | null, drivingSlips: { __typename?: 'DrivingSlip', locked: boolean, status: DrivingSlipStatus, urgent: boolean, start: string, end: string, comment: string | null, driver: { __typename?: 'User', name: string } | null, car: { __typename?: 'Vehicle', vehicleNumber: string } | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } | null, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }> | null, caseMachineUsages: Array<{ __typename?: 'CaseMachineUsage', machine: string, startTime: string, endTime: string | null, startMeterReading: number, endMeterReading: number | null }> | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null } }>, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type GetMobileV2CaseAdminDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMobileV2CaseAdminDataQuery = { __typename?: 'Query', damageCategories: Array<{ __typename?: 'DamageCategory', id: string, name: string }>, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }>, departments: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }>, locations: Array<{ __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }>, drivingSlipCategories: Array<{ __typename?: 'DrivingSlipCategory', code: string, name: string }>, drivingSlipItems: Array<{ __typename?: 'Item', no: string, description: string, baseUOM: string, jobTask: string, filterCode: string }> };

export type GetMobileV2CasesQueryVariables = Exact<{
  address?: InputMaybe<AddressInput>;
  awaiting?: InputMaybe<Scalars['Boolean']['input']>;
  damageServiceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  calledBack?: InputMaybe<Scalars['Boolean']['input']>;
  machinesOnCase?: InputMaybe<Scalars['Boolean']['input']>;
  ownCases?: InputMaybe<Scalars['Boolean']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  debitor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  track?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  department?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategory?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCause?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  priority?: InputMaybe<Array<CasePriority> | CasePriority>;
  caseManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  erpReferenceNo?: InputMaybe<Scalars['String']['input']>;
  erpReferenceNos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetMobileV2CasesQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null }> };

export type GetMobileV2CasesByErpNoQueryVariables = Exact<{
  erpReferenceNo: Scalars['String']['input'];
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMobileV2CasesByErpNoQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, erpNo: string, status: CaseStatus, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', unknown: boolean }, damage: { __typename?: 'Damage', date: string, description: string, category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string }, businessArea: { __typename?: 'BusinessArea', name: string }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, projectManager: { __typename?: 'User', id: string, name: string } | null, caseManager: { __typename?: 'User', id: string, name: string } | null }> };

export type GetMobileV2CasesForCatalogSuggestionsQueryVariables = Exact<{
  erpReferenceNo: Scalars['String']['input'];
}>;


export type GetMobileV2CasesForCatalogSuggestionsQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }> };

export type SendCaseEmailMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  to: Array<Scalars['String']['input']> | Scalars['String']['input'];
  cc: Array<Scalars['String']['input']> | Scalars['String']['input'];
  bcc: Array<Scalars['String']['input']> | Scalars['String']['input'];
  subject: Scalars['String']['input'];
  body: Scalars['String']['input'];
  includeCaseAgreements: Scalars['Boolean']['input'];
  quote: Scalars['Boolean']['input'];
  attachements?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SendCaseEmailMutation = { __typename?: 'Mutation', sendCaseEmail: { __typename?: 'EmptyReturn', _: string } | null };

export type UpdateCaseMobileMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status?: InputMaybe<CaseStatus>;
  damage?: InputMaybe<DamageInput>;
  policyHolder?: InputMaybe<ContactInput>;
  debitor?: InputMaybe<DebitorInput>;
  requisitioner?: InputMaybe<RequisitionerInput>;
  adviser?: InputMaybe<CompanyContactInput>;
  referrer?: InputMaybe<CompanyContactInput>;
  visitation?: InputMaybe<VisitationInput>;
  projectManager?: InputMaybe<Scalars['String']['input']>;
  caseManager?: InputMaybe<Scalars['String']['input']>;
  ssgLocation?: InputMaybe<Scalars['String']['input']>;
  ssgDepartment?: InputMaybe<Scalars['String']['input']>;
  billingReady?: InputMaybe<Scalars['Boolean']['input']>;
  workComplete?: InputMaybe<Scalars['Boolean']['input']>;
  importantInfo?: InputMaybe<Scalars['String']['input']>;
  skafor?: InputMaybe<Scalars['Boolean']['input']>;
  alternativeContact?: InputMaybe<PersonInput>;
  track?: InputMaybe<Scalars['Int']['input']>;
  riskEvaluationAnswers?: InputMaybe<Array<RiskEvaluationAnswerInput> | RiskEvaluationAnswerInput>;
  machineNotification?: InputMaybe<Scalars['Boolean']['input']>;
  timeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPriceOnCase?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type UpdateCaseMobileMutation = { __typename?: 'Mutation', updateCase: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type UpdateCaseRiskEvaluationAnswersMutationVariables = Exact<{
  id: Scalars['String']['input'];
  riskEvaluationAnswers: Array<RiskEvaluationAnswerInput> | RiskEvaluationAnswerInput;
  riskEvaluationComment?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCaseRiskEvaluationAnswersMutation = { __typename?: 'Mutation', updateCaseRiskEvaluationAnswers: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type UpdatePictureCommentMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  fileID: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type UpdatePictureCommentMutation = { __typename?: 'Mutation', updatePictureComment: { __typename?: 'EmptyReturn', _: string } | null };

export type GetCatalogsWithCraftsmenQueryVariables = Exact<{
  debitors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  smsService?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  debitorVerified?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressInput>;
  noDebitor?: InputMaybe<Scalars['Boolean']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCatalogsWithCraftsmenQuery = { __typename?: 'Query', catalogs: Array<{ __typename?: 'Catalog', id: string, craftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }> }> };

export type GetMobileV2CatalogsQueryVariables = Exact<{
  debitors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  smsService?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  debitorVerified?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressInput>;
  noDebitor?: InputMaybe<Scalars['Boolean']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMobileV2CatalogsQuery = { __typename?: 'Query', catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null }> };

export type GetAllDebitorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDebitorsQuery = { __typename?: 'Query', allDebitors: Array<{ __typename?: 'DebitorBase', debitorId: string, type: DebitorType, gln: string | null, phone: string | null, email: string | null, company: string, createInECB: boolean, callCenterActive: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string } | null }> };

export type GetMobileV2DepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMobileV2DepartmentsQuery = { __typename?: 'Query', departments: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }> };

export type BaseDrivingSlipMobileFragmentFragment = { __typename?: 'DrivingSlip', id: string, status: DrivingSlipStatus, urgent: boolean, start: string, createdAt: string, category: string | null, facadePictureTaken: boolean | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, name: string }, before: { __typename?: 'DrivingSlipChangeDifference', status: DrivingSlipStatus | null }, after: { __typename?: 'DrivingSlipChangeDifference', status: DrivingSlipStatus | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string } };

export type CaseDraftUsageLineFragmentFragment = { __typename: 'CaseDraftUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unitOfMeasureCode: string, date: string, postedBy: string, description: string };

export type GetDrivingSlipItemsQueryVariables = Exact<{
  drivingSlipCategory?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDrivingSlipItemsQuery = { __typename?: 'Query', drivingSlipItems: Array<{ __typename?: 'Item', no: string, description: string, baseUOM: string, jobTask: string }> };

export type GetMobileV2DrivingSlipQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMobileV2DrivingSlipQuery = { __typename?: 'Query', drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', version: number, id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, caseReports: { __typename?: 'CaseReports', inspectionReportFormData: { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null } | null, inspectionMovablesReportFormData: { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null } | null, moistureReportFormData: { __typename?: 'MoistureReportFormData', inspectionDate: string, conclusion: string, damageCause: string, scope: string, contacts: string, regres: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, damageCauseImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, floorReport: Array<{ __typename?: 'FloorMoistureReportFormData', name: string, observations: { __typename?: 'MoistureReportObservations', roomOrApartment: string, construction: string | null, contacts: string | null, ceiling: string | null, walls: string | null, floor: string | null, movables: string | null, scope: string, recommendations: string }, moistureMeassurements: Array<{ __typename?: 'MoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, value: string, expectedFinalValue: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> } | null, moistureTrygReportFormData: { __typename?: 'MoistureTrygReportFormData', inspectionDate: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorReport: Array<{ __typename?: 'FloorMoistureTrygReportFormData', name: string | null, damageCause: string | null, multipleDamageCauses: string | null, moistureDamageCause: string | null, damageDescription: string | null, recommendations: string | null, urgentActions: string | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, moistureMeassurements: Array<{ __typename?: 'TrygMoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, paints: string, paintsDate: string | null, expectedFinalValue: string | null, expectedFinalDate: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, airMeassurements: { __typename?: 'AirMeassurementDetails', temperatureInside: number, temperatureOutside: number, relativeHumidityInside: number, relativeHumidityOutside: number, waterAmountInside: number, waterAmountOutside: number }, damageDescriptionImage: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, damageDrawingImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> | null } | null, indoorClimateReportFormData: { __typename?: 'IndoorClimateReportFormData', inspectionDate: string | null, purpose: string | null, buildYear: string | null, squareMeters: string | null, dailyUsers: string | null, participants: string | null, backgroundStory: string | null, observations: string | null, showLabAnswers: boolean, showDataLog: boolean | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, indoorClimateMeassurements: Array<{ __typename?: 'IndoorClimateMeassurement', room: string | null, construction: string | null, material: string | null, description: string | null, instrument: string | null, value: string | null, referenceValue: string | null, calculatedValue: string | null }> | null } | null } | null, caseAsbestosReports: { __typename?: 'CaseAsbestosReports', noticeOfConstructionWasteFormData: { __typename?: 'NoticeOfConstructionwasteFormData', area: string | null, assignment: string | null, wasteFractions: string | null, wastePackaging: string | null, carrier: string | null, yearOfConstruction: string | null, startDate: string | null, endDate: string | null } | null, inspectionAssesmentFormData: { __typename?: 'InspectionAssesmentFormData', assesments: Array<{ __typename?: 'Assesment', id: number, color: AssesmentColor, comment: string, deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, reportDate: string } | null }> | null, signatures: Array<{ __typename?: 'Signature', signatureDate: string | null, index: number | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null> | null } | null, caseOrganizationFormData: { __typename?: 'CaseOrganizationFormData', caseOrganizationWorkers: Array<{ __typename?: 'CaseOrganizationWorker', index: number, title: string, name: string, phonenumber: string, date: string | null, instructor: string, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null> | null } | null, endevaluationReportFormData: { __typename?: 'EndevaluationReportFormData', evaluationCategories: Array<{ __typename?: 'EvaluationCategories', index: number, title: string, evaluations: Array<{ __typename?: 'Evaluation', index: number, question: string, answer: EvaluationEnum, remark: string } | null> | null }> | null, deviations: Array<{ __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string }> | null, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null, deviationReportFormData: { __typename?: 'DeviationReportFormData', deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string } } | null } | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, caseDraftItemsUsage: Array<{ __typename: 'CaseDraftUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unitOfMeasureCode: string, date: string, postedBy: string, description: string }>, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type GetMobileV2DrivingSlipsQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  caseERPReferenceNo?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  debitors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  seriesId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMobileV2DrivingSlipsQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', version: number, id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, caseReports: { __typename?: 'CaseReports', inspectionReportFormData: { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null } | null, inspectionMovablesReportFormData: { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null } | null, moistureReportFormData: { __typename?: 'MoistureReportFormData', inspectionDate: string, conclusion: string, damageCause: string, scope: string, contacts: string, regres: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, damageCauseImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, floorReport: Array<{ __typename?: 'FloorMoistureReportFormData', name: string, observations: { __typename?: 'MoistureReportObservations', roomOrApartment: string, construction: string | null, contacts: string | null, ceiling: string | null, walls: string | null, floor: string | null, movables: string | null, scope: string, recommendations: string }, moistureMeassurements: Array<{ __typename?: 'MoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, value: string, expectedFinalValue: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> } | null, moistureTrygReportFormData: { __typename?: 'MoistureTrygReportFormData', inspectionDate: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorReport: Array<{ __typename?: 'FloorMoistureTrygReportFormData', name: string | null, damageCause: string | null, multipleDamageCauses: string | null, moistureDamageCause: string | null, damageDescription: string | null, recommendations: string | null, urgentActions: string | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, moistureMeassurements: Array<{ __typename?: 'TrygMoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, paints: string, paintsDate: string | null, expectedFinalValue: string | null, expectedFinalDate: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, airMeassurements: { __typename?: 'AirMeassurementDetails', temperatureInside: number, temperatureOutside: number, relativeHumidityInside: number, relativeHumidityOutside: number, waterAmountInside: number, waterAmountOutside: number }, damageDescriptionImage: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, damageDrawingImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> | null } | null, indoorClimateReportFormData: { __typename?: 'IndoorClimateReportFormData', inspectionDate: string | null, purpose: string | null, buildYear: string | null, squareMeters: string | null, dailyUsers: string | null, participants: string | null, backgroundStory: string | null, observations: string | null, showLabAnswers: boolean, showDataLog: boolean | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, indoorClimateMeassurements: Array<{ __typename?: 'IndoorClimateMeassurement', room: string | null, construction: string | null, material: string | null, description: string | null, instrument: string | null, value: string | null, referenceValue: string | null, calculatedValue: string | null }> | null } | null } | null, caseAsbestosReports: { __typename?: 'CaseAsbestosReports', noticeOfConstructionWasteFormData: { __typename?: 'NoticeOfConstructionwasteFormData', area: string | null, assignment: string | null, wasteFractions: string | null, wastePackaging: string | null, carrier: string | null, yearOfConstruction: string | null, startDate: string | null, endDate: string | null } | null, inspectionAssesmentFormData: { __typename?: 'InspectionAssesmentFormData', assesments: Array<{ __typename?: 'Assesment', id: number, color: AssesmentColor, comment: string, deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, reportDate: string } | null }> | null, signatures: Array<{ __typename?: 'Signature', signatureDate: string | null, index: number | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null> | null } | null, caseOrganizationFormData: { __typename?: 'CaseOrganizationFormData', caseOrganizationWorkers: Array<{ __typename?: 'CaseOrganizationWorker', index: number, title: string, name: string, phonenumber: string, date: string | null, instructor: string, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null> | null } | null, endevaluationReportFormData: { __typename?: 'EndevaluationReportFormData', evaluationCategories: Array<{ __typename?: 'EvaluationCategories', index: number, title: string, evaluations: Array<{ __typename?: 'Evaluation', index: number, question: string, answer: EvaluationEnum, remark: string } | null> | null }> | null, deviations: Array<{ __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string }> | null, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null, deviationReportFormData: { __typename?: 'DeviationReportFormData', deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string } } | null } | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, caseDraftItemsUsage: Array<{ __typename: 'CaseDraftUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unitOfMeasureCode: string, date: string, postedBy: string, description: string }>, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> };

export type GetMobileV2DrivingSlipsNoCaseQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMobileV2DrivingSlipsNoCaseQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, start: string, category: string | null, end: string }> };

export type GetPersonalDrivingSlipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalDrivingSlipsQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> };

export type GetSeriesDrivingSlipsQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  caseERPReferenceNo?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  debitors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  seriesId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSeriesDrivingSlipsQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, facadePictureTaken: boolean | null, series: string, createdAt: string, driver: { __typename?: 'User', id: string, name: string } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null }> };

export type GetUnitOfMeasuresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitOfMeasuresQuery = { __typename?: 'Query', unitOfMeasures: Array<{ __typename?: 'Item', jobTask: string, unitOfMeasure: string }> };

export type SetDrivingSlipDrivingStartedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  drivingStarted: Scalars['DateTime']['input'];
  locationCoordinates?: InputMaybe<GeoCoordinateInput>;
  carNumber?: InputMaybe<Scalars['String']['input']>;
  passenger?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetDrivingSlipDrivingStartedMutation = { __typename?: 'Mutation', setDrivingSlipDrivingStarted: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type SetDrivingSlipFacadePictureTakenMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SetDrivingSlipFacadePictureTakenMutation = { __typename?: 'Mutation', setDrivingSlipFacadePictureTaken: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type SetDrivingSlipNoMaterialUsedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  noMaterialUsed: Scalars['Boolean']['input'];
}>;


export type SetDrivingSlipNoMaterialUsedMutation = { __typename?: 'Mutation', setDrivingSlipNoMaterialUsed: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type SetDrivingSlipNoWasteUsedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  noWasteUsed: Scalars['Boolean']['input'];
}>;


export type SetDrivingSlipNoWasteUsedMutation = { __typename?: 'Mutation', setDrivingSlipNoWasteUsed: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type SetDrivingSlipQuestionnaireCompletionStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  questionnaireCompletionStatus: QuestionnaireCompletionStatus;
}>;


export type SetDrivingSlipQuestionnaireCompletionStatusMutation = { __typename?: 'Mutation', setDrivingSlipQuestionnaireCompletionStatus: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type SetDrivingSlipRiskEvaluationStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  riskEvaluationStatus: RiskEvaluationStatus;
}>;


export type SetDrivingSlipRiskEvaluationStatusMutation = { __typename?: 'Mutation', setDrivingSlipRiskEvaluationStatus: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type SetMobileV2DrivingSlipQuestionnaireMutationVariables = Exact<{
  id: Scalars['String']['input'];
  questionnaire: DrivingSlipQuestionnaireInputType;
}>;


export type SetMobileV2DrivingSlipQuestionnaireMutation = { __typename?: 'Mutation', setDrivingSlipQuestionnaire: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type SetMobileV2DrivingSlipStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: DrivingSlipStatus;
  applyDrivingCost?: InputMaybe<Scalars['Boolean']['input']>;
  locationCoordinates?: InputMaybe<GeoCoordinateInput>;
}>;


export type SetMobileV2DrivingSlipStatusMutation = { __typename?: 'Mutation', setDrivingSlipStatus: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type V2DrivingSlipCaseFragmentFragment = { __typename?: 'Case', version: number, id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, caseReports: { __typename?: 'CaseReports', inspectionReportFormData: { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null } | null, inspectionMovablesReportFormData: { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null } | null, moistureReportFormData: { __typename?: 'MoistureReportFormData', inspectionDate: string, conclusion: string, damageCause: string, scope: string, contacts: string, regres: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, damageCauseImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, floorReport: Array<{ __typename?: 'FloorMoistureReportFormData', name: string, observations: { __typename?: 'MoistureReportObservations', roomOrApartment: string, construction: string | null, contacts: string | null, ceiling: string | null, walls: string | null, floor: string | null, movables: string | null, scope: string, recommendations: string }, moistureMeassurements: Array<{ __typename?: 'MoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, value: string, expectedFinalValue: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> } | null, moistureTrygReportFormData: { __typename?: 'MoistureTrygReportFormData', inspectionDate: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorReport: Array<{ __typename?: 'FloorMoistureTrygReportFormData', name: string | null, damageCause: string | null, multipleDamageCauses: string | null, moistureDamageCause: string | null, damageDescription: string | null, recommendations: string | null, urgentActions: string | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, moistureMeassurements: Array<{ __typename?: 'TrygMoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, paints: string, paintsDate: string | null, expectedFinalValue: string | null, expectedFinalDate: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, airMeassurements: { __typename?: 'AirMeassurementDetails', temperatureInside: number, temperatureOutside: number, relativeHumidityInside: number, relativeHumidityOutside: number, waterAmountInside: number, waterAmountOutside: number }, damageDescriptionImage: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, damageDrawingImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> | null } | null, indoorClimateReportFormData: { __typename?: 'IndoorClimateReportFormData', inspectionDate: string | null, purpose: string | null, buildYear: string | null, squareMeters: string | null, dailyUsers: string | null, participants: string | null, backgroundStory: string | null, observations: string | null, showLabAnswers: boolean, showDataLog: boolean | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, indoorClimateMeassurements: Array<{ __typename?: 'IndoorClimateMeassurement', room: string | null, construction: string | null, material: string | null, description: string | null, instrument: string | null, value: string | null, referenceValue: string | null, calculatedValue: string | null }> | null } | null } | null, caseAsbestosReports: { __typename?: 'CaseAsbestosReports', noticeOfConstructionWasteFormData: { __typename?: 'NoticeOfConstructionwasteFormData', area: string | null, assignment: string | null, wasteFractions: string | null, wastePackaging: string | null, carrier: string | null, yearOfConstruction: string | null, startDate: string | null, endDate: string | null } | null, inspectionAssesmentFormData: { __typename?: 'InspectionAssesmentFormData', assesments: Array<{ __typename?: 'Assesment', id: number, color: AssesmentColor, comment: string, deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, reportDate: string } | null }> | null, signatures: Array<{ __typename?: 'Signature', signatureDate: string | null, index: number | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null> | null } | null, caseOrganizationFormData: { __typename?: 'CaseOrganizationFormData', caseOrganizationWorkers: Array<{ __typename?: 'CaseOrganizationWorker', index: number, title: string, name: string, phonenumber: string, date: string | null, instructor: string, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null> | null } | null, endevaluationReportFormData: { __typename?: 'EndevaluationReportFormData', evaluationCategories: Array<{ __typename?: 'EvaluationCategories', index: number, title: string, evaluations: Array<{ __typename?: 'Evaluation', index: number, question: string, answer: EvaluationEnum, remark: string } | null> | null }> | null, deviations: Array<{ __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string }> | null, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null, deviationReportFormData: { __typename?: 'DeviationReportFormData', deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string } } | null } | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, caseDraftItemsUsage: Array<{ __typename: 'CaseDraftUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unitOfMeasureCode: string, date: string, postedBy: string, description: string }>, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } };

export type DeleteDrivingSlipFileMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type DeleteDrivingSlipFileMutation = { __typename?: 'Mutation', deleteDrivingSlipFile: { __typename?: 'EmptyReturn', _: string } | null };

export type GetCaseEsdhFilesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseEsdhFilesQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, erpNo: string, documents: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> } };

export type GetCaseFilesQueryVariables = Exact<{
  folder?: InputMaybe<Scalars['String']['input']>;
  caseErpNo?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseFilesQuery = { __typename?: 'Query', caseFiles: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type GetCatalogEsdhFilesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatalogEsdhFilesQuery = { __typename?: 'Query', catalog: { __typename?: 'Catalog', id: string, propertyNumber: string, documents: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> } };

export type GetDrivingSlipFilesQueryVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
}>;


export type GetDrivingSlipFilesQuery = { __typename?: 'Query', drivingSlipFiles: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> | null };

export type GetMobileV2CaseFileQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMobileV2CaseFileQuery = { __typename?: 'Query', caseFile: { __typename?: 'FileRetriever', fileData: Array<any>, filename: string, fileDataBase64: string } };

export type GetMobileV2DrivingSlipFileQueryVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type GetMobileV2DrivingSlipFileQuery = { __typename?: 'Query', drivingSlipFile: { __typename?: 'FileRetriever', fileData: Array<any>, filename: string, fileDataBase64: string } };

export type ModifyDrivingSlipFileMetadataMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  metadata: Array<FileMetadataInput> | FileMetadataInput;
}>;


export type ModifyDrivingSlipFileMetadataMutation = { __typename?: 'Mutation', modifyDrivingSlipFileMetadata: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } };

export type QueueUploadDrivingSlipFileMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  file: Array<Scalars['Byte']['input']> | Scalars['Byte']['input'];
  metadata?: InputMaybe<Array<FileMetadataInput> | FileMetadataInput>;
}>;


export type QueueUploadDrivingSlipFileMutation = { __typename?: 'Mutation', queueUploadDrivingSlipFile: { __typename?: 'EmptyReturn', _: string } | null };

export type QueueUploadDrivingSlipFilesMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  files: Array<FileInput> | FileInput;
}>;


export type QueueUploadDrivingSlipFilesMutation = { __typename?: 'Mutation', queueUploadDrivingSlipFiles: { __typename?: 'EmptyReturn', _: string } | null };

export type UploadDrivingSlipFileMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  file: Array<Scalars['Byte']['input']> | Scalars['Byte']['input'];
  metadata?: InputMaybe<Array<FileMetadataInput> | FileMetadataInput>;
}>;


export type UploadDrivingSlipFileMutation = { __typename?: 'Mutation', uploadDrivingSlipFile: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } };

export type UploadDrivingSlipFilesMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  files: Array<FileInput> | FileInput;
}>;


export type UploadDrivingSlipFilesMutation = { __typename?: 'Mutation', uploadDrivingSlipFiles: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type GetMachineQueryVariables = Exact<{
  machineNo: Scalars['String']['input'];
}>;


export type GetMachineQuery = { __typename?: 'Query', machine: { __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean } | null };

export type GetMachineGuidesQueryVariables = Exact<{
  filter?: InputMaybe<FileFilterInput>;
}>;


export type GetMachineGuidesQuery = { __typename?: 'Query', machineGuideFiles: Array<{ __typename?: 'ESDHFile', name: string }> };

export type GetMobileV2MachineGuideFilesQueryVariables = Exact<{
  filter?: InputMaybe<FileFilterInput>;
}>;


export type GetMobileV2MachineGuideFilesQuery = { __typename?: 'Query', machineGuideFiles: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type GetMobileV2MachineLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMobileV2MachineLocationsQuery = { __typename?: 'Query', machineLocations: Array<{ __typename?: 'MachineLocation', name: string, locationCode: string }> };

export type GetMobileV2MachinesOnCaseQueryVariables = Exact<{
  caseNo: Scalars['String']['input'];
}>;


export type GetMobileV2MachinesOnCaseQuery = { __typename?: 'Query', machinesOnCase: Array<{ __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean }> };

export type MoveMobileV2MachineMutationVariables = Exact<{
  machineInput: MachineInput;
  caseNo: Scalars['String']['input'];
}>;


export type MoveMobileV2MachineMutation = { __typename?: 'Mutation', moveMachine: { __typename?: 'Machine', erpReferenceNo: string } | null };

export type ReserveMachineMutationVariables = Exact<{
  machineInput: MachineInput;
}>;


export type ReserveMachineMutation = { __typename?: 'Mutation', machineReserve: { __typename?: 'Machine', erpReferenceNo: string } | null };

export type ChangeOfferStatusMutationVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
  offerERPReferenceNo: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  action: SalesHeaderEnum;
}>;


export type ChangeOfferStatusMutation = { __typename?: 'Mutation', changeOfferStatus: string | null };

export type AssortmentsQueryVariables = Exact<{
  assortmentCode: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type AssortmentsQuery = { __typename?: 'Query', assortments: Array<{ __typename?: 'Assortment', no: string, type: string, description: string, uom: string }> | null };

export type CloseOppertunityCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type CloseOppertunityCodesQuery = { __typename?: 'Query', closeOppertunityCodes: Array<{ __typename?: 'CloseOppertunityCode', type: string, description: string, code: string }> | null };

export type JobTasksQueryVariables = Exact<{
  erpReferenceNo: Scalars['String']['input'];
}>;


export type JobTasksQuery = { __typename?: 'Query', jobTasks: Array<{ __typename?: 'JobTask', erpRefrenceNo: string, jobTaskNo: string, description: string, price: number, workTypeCode: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null } | null> | null };

export type OffersQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type OffersQuery = { __typename?: 'Query', offers: Array<{ __typename?: 'Offer', jobNo: string, opportunityStatus: string | null, headerText: string | null, footerText: string | null, quoteType: OfferQuoteTypeEnum | null, competitionOffer: boolean, lines: Array<{ __typename?: 'OfferLine', documentNo: string, no: string, planningDate: string, description: string, quantity: number, unitPrice: number, newUnitPrice: number | null, lineAmount: number, currencyCode: string | null, workType: string | null, systemId: string | null, eRPReferenceTask: string, type: OfferRessourceType, option: boolean, hideSum: boolean, header: boolean, screeningLineId: string | null, sortingIndex: number, lineNo: number, unitCost: number }> }> | null };

export type GetSamplePriceForLineQueryVariables = Exact<{
  offerLine: OfferLineInput;
}>;


export type GetSamplePriceForLineQuery = { __typename?: 'Query', samplePriceForLine: { __typename?: 'SamplePriceResult', totalCost: number, lineAmount: number } };

export type HandleOfferMutationVariables = Exact<{
  offer: OfferInput;
  caseId: Scalars['String']['input'];
  offerERPReferenceNo?: InputMaybe<Scalars['String']['input']>;
}>;


export type HandleOfferMutation = { __typename?: 'Mutation', handleOffer: { __typename?: 'Offer', jobNo: string, opportunityStatus: string | null, headerText: string | null, footerText: string | null, quoteType: OfferQuoteTypeEnum | null, competitionOffer: boolean, lines: Array<{ __typename?: 'OfferLine', documentNo: string, no: string, planningDate: string, description: string, quantity: number, unitPrice: number, newUnitPrice: number | null, lineAmount: number, currencyCode: string | null, workType: string | null, systemId: string | null, eRPReferenceTask: string, type: OfferRessourceType, option: boolean, hideSum: boolean, header: boolean, screeningLineId: string | null, sortingIndex: number, lineNo: number, unitCost: number }> } };

export type GetQuestionnaireTemplateByDrivingSlipQueryVariables = Exact<{
  drivingSlipCategoryCode?: InputMaybe<Scalars['String']['input']>;
  damageCauseId: Scalars['String']['input'];
}>;


export type GetQuestionnaireTemplateByDrivingSlipQuery = { __typename?: 'Query', questionnaireTemplateByDrivingSlip: { __typename?: 'QuestionnaireTemplate', id: string, label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, version: number, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, isMultiSelectAllowed: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, multiSelectValues: Array<string> | null }> }> } | null };

export type GetQuestionnaireTemplatesByDrivingSlipsQueryVariables = Exact<{
  drivingSlips: Array<QuestionnaireTemplateByDrivingSlipInput> | QuestionnaireTemplateByDrivingSlipInput;
}>;


export type GetQuestionnaireTemplatesByDrivingSlipsQuery = { __typename?: 'Query', questionnaireTemplatesByDrivingSlips: Array<{ __typename?: 'QuestionnaireTemplate', id: string, label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, version: number, createdAt: string, updatedAt: string, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, isMultiSelectAllowed: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, multiSelectValues: Array<string> | null }> }> }> };

export type CreateFalckDehumidifierReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: FalckDehumidifierReportFormDataInput;
}>;


export type CreateFalckDehumidifierReportMutation = { __typename?: 'Mutation', createFalckDehumidifierReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } };

export type CreateMobileIndoorClimateReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: IndoorClimateReportFormDataInput;
  reportFormat: ReportFormatType;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateMobileIndoorClimateReportMutation = { __typename?: 'Mutation', createIndoorClimateReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateMobileV2CaseOrganizationReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: CaseOrganizationFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateMobileV2CaseOrganizationReportMutation = { __typename?: 'Mutation', createCaseOrganizationReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } | null };

export type CreateMobileV2DamageReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
}>;


export type CreateMobileV2DamageReportMutation = { __typename?: 'Mutation', createDamageReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } };

export type CreateMobileV2EndevaluationReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: EndevaluationReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateMobileV2EndevaluationReportMutation = { __typename?: 'Mutation', createEndevaluationReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } | null };

export type CreateMobileV2InspectionAssesmentReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: InspectionAssesmentFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateMobileV2InspectionAssesmentReportMutation = { __typename?: 'Mutation', createInspectionAssesmentReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } | null };

export type CreateMobileV2InspectionMovablesReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: InspectionReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateMobileV2InspectionMovablesReportMutation = { __typename?: 'Mutation', createInspectionMovablesReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } | null };

export type CreateMobileV2InspectionReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: InspectionReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateMobileV2InspectionReportMutation = { __typename?: 'Mutation', createInspectionReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } | null };

export type CreateMobileV2MoistureReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: MoistureReportFormDataInput;
  reportFormat: ReportFormatType;
  floorsToInclude?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateMobileV2MoistureReportMutation = { __typename?: 'Mutation', createMoistureReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } | null };

export type CreateMobileV2MoistureTrygReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: MoistureTrygReportFormDataInput;
  reportFormat: ReportFormatType;
  floorsToInclude?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateMobileV2MoistureTrygReportMutation = { __typename?: 'Mutation', createMoistureTrygReport: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } | null };

export type GetCaseReportsAndDocumentsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseReportsAndDocumentsQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, erpNo: string, documents: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }>, caseReports: { __typename?: 'CaseReports', inspectionReportFormData: { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null } | null, inspectionMovablesReportFormData: { __typename?: 'InspectionReportFormData', backgroundStory: string | null, observations: string | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, comments: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null } | null, moistureReportFormData: { __typename?: 'MoistureReportFormData', inspectionDate: string, conclusion: string, damageCause: string, scope: string, contacts: string, regres: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, damageCauseImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, floorReport: Array<{ __typename?: 'FloorMoistureReportFormData', name: string, observations: { __typename?: 'MoistureReportObservations', roomOrApartment: string, construction: string | null, contacts: string | null, ceiling: string | null, walls: string | null, floor: string | null, movables: string | null, scope: string, recommendations: string }, moistureMeassurements: Array<{ __typename?: 'MoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, value: string, expectedFinalValue: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> } | null, moistureTrygReportFormData: { __typename?: 'MoistureTrygReportFormData', inspectionDate: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorReport: Array<{ __typename?: 'FloorMoistureTrygReportFormData', name: string | null, damageCause: string | null, multipleDamageCauses: string | null, moistureDamageCause: string | null, damageDescription: string | null, recommendations: string | null, urgentActions: string | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, moistureMeassurements: Array<{ __typename?: 'TrygMoistureMeassurement', construction: string | null, material: string | null, description: string | null, method: string | null, paints: string, paintsDate: string | null, expectedFinalValue: string | null, expectedFinalDate: string | null, referenceValue: string | null, referenceDate: string | null, controlValue: string | null, controlDate: string | null }> | null, airMeassurements: { __typename?: 'AirMeassurementDetails', temperatureInside: number, temperatureOutside: number, relativeHumidityInside: number, relativeHumidityOutside: number, waterAmountInside: number, waterAmountOutside: number }, damageDescriptionImage: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, damageDrawingImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null }> | null } | null, indoorClimateReportFormData: { __typename?: 'IndoorClimateReportFormData', inspectionDate: string | null, purpose: string | null, buildYear: string | null, squareMeters: string | null, dailyUsers: string | null, participants: string | null, backgroundStory: string | null, observations: string | null, showLabAnswers: boolean, showDataLog: boolean | null, assessmentAndConclusion: string | null, suggestedActionPlan: string | null, facadeImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, floorplanImage: { __typename?: 'ReportFile', fileName: string, description: string } | null, otherImages: Array<{ __typename?: 'ReportFile', fileName: string, description: string }> | null, indoorClimateMeassurements: Array<{ __typename?: 'IndoorClimateMeassurement', room: string | null, construction: string | null, material: string | null, description: string | null, instrument: string | null, value: string | null, referenceValue: string | null, calculatedValue: string | null }> | null } | null } | null } };

export type CreateCaseRequisitionMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  requisition: RequisitionInput;
  shouldSendEmail: Scalars['Boolean']['input'];
}>;


export type CreateCaseRequisitionMutation = { __typename?: 'Mutation', createCaseRequisition: { __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } } };

export type CreateDepartmentRequisitionMutationVariables = Exact<{
  departmentId: Scalars['String']['input'];
  requisition: RequisitionInput;
  shouldSendEmail: Scalars['Boolean']['input'];
}>;


export type CreateDepartmentRequisitionMutation = { __typename?: 'Mutation', createDepartmentRequisition: { __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } } };

export type GetMobileV2RequisitionsQueryVariables = Exact<{
  myRequisitionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMobileV2RequisitionsQuery = { __typename?: 'Query', requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }> };

export type GetRequisitionsOnCaseQueryVariables = Exact<{
  caseId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRequisitionsOnCaseQuery = { __typename?: 'Query', requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }> };

export type GetVendorsQueryVariables = Exact<{
  company?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVendorsQuery = { __typename?: 'Query', vendors: Array<{ __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null }> };

export type CreateTimeTrackingMutationVariables = Exact<{
  timeTracking: TimeTrackingInputType;
}>;


export type CreateTimeTrackingMutation = { __typename?: 'Mutation', createTimeTracking: { __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null } };

export type DeleteTimeTrackingMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTimeTrackingMutation = { __typename?: 'Mutation', deleteTimeTracking: { __typename?: 'EmptyReturn', _: string } | null };

export type GetClosedDayByUserQueryVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type GetClosedDayByUserQuery = { __typename?: 'Query', closedDayByUser: { __typename?: 'TimeTracking', id: string, trackingType: TrackingType, date: string, user: { __typename?: 'User', id: string } } | null };

export type GetLatestDayByUserQueryVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type GetLatestDayByUserQuery = { __typename?: 'Query', latestDayByUser: { __typename?: 'TimeTracking', id: string, trackingType: TrackingType, date: string } | null };

export type GetMobileV2CasesForTimeTrackingQueryVariables = Exact<{
  erpReferenceNos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetMobileV2CasesForTimeTrackingQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, erpNo: string, track: number, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } }> };

export type GetPaymentSupplementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentSupplementsQuery = { __typename?: 'Query', paymentSupplements: Array<{ __typename?: 'PaymentSupplement', id: string, code: string | null, type: string | null, description: string, templateJobNo: string, blocked: boolean | null, uOM: string, workTypeCode: string } | null> };

export type GetRejectedTimeTrackingsForUserQueryVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type GetRejectedTimeTrackingsForUserQuery = { __typename?: 'Query', rejectedTimeTrackingsForUser: Array<{ __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null }> };

export type GetTimeTrackingQueryVariables = Exact<{
  id: Scalars['String']['input'];
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetTimeTrackingQuery = { __typename?: 'Query', timeTracking: { __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null } };

export type GetTimeTrackingsForUserQueryVariables = Exact<{
  user: Scalars['String']['input'];
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetTimeTrackingsForUserQuery = { __typename?: 'Query', timeTrackingsForUser: Array<{ __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null }> };

export type GetTimeTrackingsQueryVariables = Exact<{
  trackingType?: InputMaybe<TrackingType>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  users?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetTimeTrackingsQuery = { __typename?: 'Query', timeTrackings: Array<{ __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null }> };

export type SubmitDayMutationVariables = Exact<{
  timeTracking: TimeTrackingInputType;
}>;


export type SubmitDayMutation = { __typename?: 'Mutation', submitDay: { __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null } | null };

export type UpdateTimeTrackingMutationVariables = Exact<{
  id: Scalars['String']['input'];
  user: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  hours: Scalars['Float']['input'];
  case: Scalars['String']['input'];
  drivingSlip: Scalars['String']['input'];
  remark: Scalars['String']['input'];
  jobTaskNo: Scalars['String']['input'];
  jobTaskName?: InputMaybe<Scalars['String']['input']>;
  workTypeCode: Scalars['String']['input'];
  timeTrackingStatus: TimeTrackingStatus;
  pieceworkAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentSupplementCode?: InputMaybe<Scalars['String']['input']>;
  paymentSupplementName?: InputMaybe<Scalars['String']['input']>;
  supplementType?: InputMaybe<Scalars['String']['input']>;
  supplementUom?: InputMaybe<Scalars['String']['input']>;
  addonLines?: InputMaybe<Array<TimeTrackingInputType> | TimeTrackingInputType>;
}>;


export type UpdateTimeTrackingMutation = { __typename?: 'Mutation', updateTimeTracking: { __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null } };

export type UserBasisTimeQueryVariables = Exact<{
  user: Scalars['String']['input'];
  date: Scalars['Date']['input'];
}>;


export type UserBasisTimeQuery = { __typename?: 'Query', userBasisTime: number };

export type GetMobileV2CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMobileV2CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', permissions: Array<Permissions>, employeeHireStartDate: string | null, employeeSalaryType: string | null, managerFor: Array<string>, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null };

export type SearchMobileV2UsersQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  onlyEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  checkInBc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchMobileV2UsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', employeeHireStartDate: string | null, employeeSalaryType: string | null, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }> };

export type ActiveUsersOnCaseQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
}>;


export type ActiveUsersOnCaseQuery = { __typename?: 'Query', activeUsersOnCase: Array<{ __typename?: 'User', name: string, email: string }> };

export type CloseCasesMutationVariables = Exact<{
  erpNos: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CloseCasesMutation = { __typename?: 'Mutation', closeCases: Array<{ __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null }> };

export type CreateCaseMutationVariables = Exact<{
  case: CaseInput;
  drivingSlip?: InputMaybe<DrivingSlipHelperInput>;
  saveInScalePoint: Scalars['Boolean']['input'];
  migrationInput?: InputMaybe<CaseMigration>;
}>;


export type CreateCaseMutation = { __typename?: 'Mutation', createCase: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type CreateCaseAgreementMutationVariables = Exact<{
  id: Scalars['String']['input'];
  caseAgreement: CaseAgreementInput;
}>;


export type CreateCaseAgreementMutation = { __typename?: 'Mutation', createCaseAgreement: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type FavoriteCaseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
}>;


export type FavoriteCaseMutation = { __typename?: 'Mutation', favoriteCase: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type GetCaseAdminDataPlannerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCaseAdminDataPlannerQuery = { __typename?: 'Query', damageCategories: Array<{ __typename?: 'DamageCategory', id: string, name: string }>, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }>, departments: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }>, locations: Array<{ __typename?: 'Location', attachedPostalCodesInputString: string, attachedPostalCodes: Array<string>, id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }>, usersWithCalendars: Array<{ __typename?: 'User', plannerHelpText: string | null, plannerHelpTextUpdatedAt: string | null, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }>, drivingSlipCategories: Array<{ __typename?: 'DrivingSlipCategory', code: string, name: string }> };

export type CaseEconomicsOverviewQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type CaseEconomicsOverviewQuery = { __typename?: 'Query', caseEconomicsOverview: { __typename?: 'CaseEconomicsOverview', jobNo: string, costTotal: number, salesTotal: number, invoicedTotal: number, quote: number, screening: number, profit: number, deltaNotInvoiced: number, coverageRatio: number, totalContractAmountLCY: number, wipLimit: number, costEstimate: number, percentageOfCompletion: number } };

export type CaseEconomicsOverviewNewQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type CaseEconomicsOverviewNewQuery = { __typename?: 'Query', caseEconomicsOverviewNew: { __typename?: 'CaseEconomicsOverview', jobNo: string, quote: number, screening: number, percentageOfCompletion: number, wipLimit: number, getHoursAvailable: number, getHoursUsed: number, costEstimate: number } };

export type GetCaseEconomySpecQueryVariables = Exact<{
  erpReferenceId: Scalars['String']['input'];
}>;


export type GetCaseEconomySpecQuery = { __typename?: 'Query', caseEconomicsSpec: { __typename?: 'CaseEconomicSpecType', cost: Array<{ __typename?: 'CaseEconomicsSpecKVT', name: string, value: number }>, sale: Array<{ __typename?: 'CaseEconomicsSpecKVT', name: string, value: number }> } };

export type GetCaseForMovableQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseForMovableQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, status: CaseStatus, erpNo: string } };

export type GetCaseForPrintQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseForPrintQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string } } };

export type GetCaseMovablesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseMovablesQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, movables: Array<{ __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } }> } };

export type GetCaseUsageQueryVariables = Exact<{
  erpNo: Scalars['String']['input'];
}>;


export type GetCaseUsageQuery = { __typename?: 'Query', caseUsage: { __typename?: 'CaseUsage', subcontracts: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }>, items: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }>, machines: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }>, movables: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }>, persons: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }>, trash: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }>, driving: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }>, substitute: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }>, vehicleExpenses: Array<{ __typename?: 'CaseUsageLine', erpId: string, erpKey: string, title: string, quantity: number, unit: string, lineCost: number, totalCost: number, attachments: Array<string>, ressourceName: string, postingDate: string, originalPostingDate: string, substitute: boolean | null, vehicleExpense: boolean | null }> } };

export type GetCaseUsageExcelOverviewQueryVariables = Exact<{
  erpNo: Scalars['String']['input'];
}>;


export type GetCaseUsageExcelOverviewQuery = { __typename?: 'Query', caseUsageExcelOverview: Array<any> };

export type GetCasesForExportQueryVariables = Exact<{
  address?: InputMaybe<AddressInput>;
  awaiting?: InputMaybe<Scalars['Boolean']['input']>;
  damageServiceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  calledBack?: InputMaybe<Scalars['Boolean']['input']>;
  machinesOnCase?: InputMaybe<Scalars['Boolean']['input']>;
  ownCases?: InputMaybe<Scalars['Boolean']['input']>;
  favoriteCases?: InputMaybe<Scalars['Boolean']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  debitor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  track?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  department?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategory?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCause?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  priority?: InputMaybe<Array<CasePriority> | CasePriority>;
  caseManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  createdBy?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  areaResponsible?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  anyManager?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  erpReferenceNo?: InputMaybe<Scalars['String']['input']>;
  erpReferenceNos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  favoriteColors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeEconomy: Scalars['Boolean']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCasesForExportQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, status: CaseStatus, erpNo: string, track: number, createdAt: string, skafor: boolean, arrived: boolean, arrivedDate: string | null, activeRequisitions: boolean, debitor: { __typename?: 'Debitor', company: string, policeNumber: string }, damage: { __typename?: 'Damage', businessArea: { __typename?: 'BusinessArea', name: string }, category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', name: string }, ssgDepartment: { __typename?: 'Department', name: string, departmentNumber: number }, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, visitation: { __typename?: 'Visitation', priorities: Array<CasePriority>, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', value: boolean, comment: string | null } }, caseEconomics: { __typename?: 'CaseEconomicsOverview', salesTotal: number, invoicedTotal: number } | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, createdAt: string, status: DrivingSlipStatus, start: string, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }> }>, caseReports: { __typename?: 'CaseReports', inspectionReportFormData: { __typename: 'InspectionReportFormData' } | null, indoorClimateReportFormData: { __typename: 'IndoorClimateReportFormData' } | null, moistureReportFormData: { __typename: 'MoistureReportFormData' } | null, moistureTrygReportFormData: { __typename: 'MoistureTrygReportFormData' } | null } | null }> };

export type GetCasesWithChangesQueryVariables = Exact<{
  address?: InputMaybe<AddressInput>;
  awaiting?: InputMaybe<Scalars['Boolean']['input']>;
  damageServiceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  calledBack?: InputMaybe<Scalars['Boolean']['input']>;
  machinesOnCase?: InputMaybe<Scalars['Boolean']['input']>;
  ownCases?: InputMaybe<Scalars['Boolean']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  debitor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  track?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  department?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategory?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCause?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  priority?: InputMaybe<Array<CasePriority> | CasePriority>;
  caseManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  anyManager?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  erpReferenceNo?: InputMaybe<Scalars['String']['input']>;
  erpReferenceNos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeEconomy: Scalars['Boolean']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCasesWithChangesQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, changes: Array<{ __typename?: 'CaseChange', timestamp: string, after: { __typename?: 'CaseChangeDifference', status: CaseStatus | null }, user: { __typename?: 'User', id: string, name: string } | null }>, caseEconomics: { __typename?: 'CaseEconomicsOverview', jobNo: string, costTotal: number, salesTotal: number, invoicedTotal: number, quote: number, screening: number, profit: number, deltaNotInvoiced: number, coverageRatio: number } | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null }> };

export type GetDamageAdminDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDamageAdminDataQuery = { __typename?: 'Query', damageCategories: Array<{ __typename?: 'DamageCategory', id: string, name: string }>, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }> };

export type GetDuplicateCasesQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  address: AddressInput;
  damageCategory: Scalars['String']['input'];
  hasScalepointUrl: Scalars['Boolean']['input'];
}>;


export type GetDuplicateCasesQuery = { __typename?: 'Query', duplicateCases: Array<{ __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null }> };

export type GetJobLedgerEntrySummaryQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type GetJobLedgerEntrySummaryQuery = { __typename?: 'Query', getJobLedgerEntrySummary: { __typename?: 'JobLedgerEntrySummary', jobNo: string, invoicedAmount: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, igvaAmount: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, totalRevenue: { __typename?: 'JobLedgerEntry', actual: number, expected: number | null, indentation: number, bold: boolean }, material: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, personel: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, substitute: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, subcontractor: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, machine: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, vehicleExpenses: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, storageCosts: { __typename?: 'JobLedgerEntry', actual: number, indentation: number, bold: boolean }, totalCost: { __typename?: 'JobLedgerEntry', actual: number, expected: number | null, indentation: number, bold: boolean }, grossProfit: { __typename?: 'JobLedgerEntry', actual: number, expected: number | null, indentation: number, bold: boolean }, grossProfitPct: { __typename?: 'JobLedgerEntry', actual: number, expected: number | null, indentation: number, bold: boolean } } | null };

export type GetOperationManagerCaseDataQueryVariables = Exact<{
  address?: InputMaybe<AddressInput>;
  awaiting?: InputMaybe<Scalars['Boolean']['input']>;
  damageServiceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  calledBack?: InputMaybe<Scalars['Boolean']['input']>;
  machinesOnCase?: InputMaybe<Scalars['Boolean']['input']>;
  ownCases?: InputMaybe<Scalars['Boolean']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  debitor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  track?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  department?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategory?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCause?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  priority?: InputMaybe<Array<CasePriority> | CasePriority>;
  caseManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  anyManager?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  erpReferenceNo?: InputMaybe<Scalars['String']['input']>;
  erpReferenceNos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeEconomy: Scalars['Boolean']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOperationManagerCaseDataQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', machineOnCase: boolean, openMovables: boolean, activeMovables: boolean, openTimeRegistrations: boolean, activeRequisitions: boolean, activePurchaseDocuments: boolean, activeInvoiceStatus: InvoiceStatus | null, id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, changes: Array<{ __typename?: 'CaseChange', timestamp: string, after: { __typename?: 'CaseChangeDifference', status: CaseStatus | null }, user: { __typename?: 'User', id: string, name: string } | null }>, caseEconomics: { __typename?: 'CaseEconomicsOverview', jobNo: string, costTotal: number, salesTotal: number, invoicedTotal: number, quote: number, screening: number, profit: number, deltaNotInvoiced: number, coverageRatio: number } | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null }> };

export type GetSsgInfoAdminDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSsgInfoAdminDataQuery = { __typename?: 'Query', departments: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }>, locations: Array<{ __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }> };

export type GetSingleCaseQueryVariables = Exact<{
  id: Scalars['String']['input'];
  includeEconomy: Scalars['Boolean']['input'];
}>;


export type GetSingleCaseQuery = { __typename?: 'Query', case: { __typename?: 'Case', delayScalepoint: boolean | null, activeMovables: boolean, machineOnCase: boolean, scalePointUrl: string | null, activeRequisitions: boolean, activeInvoiceStatus: InvoiceStatus | null, activePurchaseDocuments: boolean, openMovables: boolean, openTimeRegistrations: boolean, version: number, fixedPriceOnCase: number, possibilityOfAsbestos: boolean | null, id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, debitor: { __typename?: 'Debitor', automaticTrackOneInvoicing: boolean | null, allowInvoicingWithoutReqNo: boolean, blocked: boolean, actualKilometers: boolean, supplyFeePercentage: number, maxSupplyFeeAmount: number | null, supplyFeeDateFrom: string | null, supplyFeeDateTo: string | null, id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, invoices: Array<{ __typename?: 'DraftInvoice', erpReferenceNo: string, status: InvoiceStatus, category: InvoiceCategory }>, projectManagerFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, caseManagerFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, changes: Array<{ __typename?: 'CaseChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, before: { __typename?: 'CaseChangeDifference', status: CaseStatus | null, track: number | null, importantInfo: string | null, skafor: boolean | null, fileNames: string | null, scalePointId: string | null, scalePointNumber: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus | null, debitor: { __typename?: 'Debitor', debitorId: string, type: DebitorType, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string } | null, drivingSlips: { __typename?: 'DrivingSlip', locked: boolean, status: DrivingSlipStatus, urgent: boolean, start: string, end: string, comment: string | null, driver: { __typename?: 'User', name: string } | null, car: { __typename?: 'Vehicle', vehicleNumber: string } | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } | null, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }> | null, caseMachineUsages: Array<{ __typename?: 'CaseMachineUsage', machine: string, startTime: string, endTime: string | null, startMeterReading: number, endMeterReading: number | null }> | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null }, after: { __typename?: 'CaseChangeDifference', status: CaseStatus | null, track: number | null, importantInfo: string | null, skafor: boolean | null, fileNames: string | null, scalePointId: string | null, scalePointNumber: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus | null, debitor: { __typename?: 'Debitor', debitorId: string, type: DebitorType, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string } | null, drivingSlips: { __typename?: 'DrivingSlip', locked: boolean, status: DrivingSlipStatus, urgent: boolean, start: string, end: string, comment: string | null, driver: { __typename?: 'User', name: string } | null, car: { __typename?: 'Vehicle', vehicleNumber: string } | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } | null, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }> | null, caseMachineUsages: Array<{ __typename?: 'CaseMachineUsage', machine: string, startTime: string, endTime: string | null, startMeterReading: number, endMeterReading: number | null }> | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null } }>, caseEconomics: { __typename?: 'CaseEconomicsOverview', jobNo: string, costTotal: number, salesTotal: number, invoicedTotal: number, quote: number, screening: number, profit: number, deltaNotInvoiced: number, coverageRatio: number } | null, caseReports: { __typename?: 'CaseReports', inspectionReportFormData: { __typename: 'InspectionReportFormData', created: boolean } | null, indoorClimateReportFormData: { __typename: 'IndoorClimateReportFormData', created: boolean } | null, inspectionMovablesReportFormData: { __typename: 'InspectionReportFormData', created: boolean } | null, moistureReportFormData: { __typename: 'MoistureReportFormData', created: boolean } | null, moistureTrygReportFormData: { __typename: 'MoistureTrygReportFormData', created: boolean } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type GetWebCaseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWebCaseQuery = { __typename?: 'Query', case: { __typename?: 'Case', activeMovables: boolean, machineOnCase: boolean, scalePointUrl: string | null, activeRequisitions: boolean, activeInvoiceStatus: InvoiceStatus | null, version: number, id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', automaticTrackOneInvoicing: boolean | null, allowInvoicingWithoutReqNo: boolean, id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, projectManagerFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, caseManagerFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, changes: Array<{ __typename?: 'CaseChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, before: { __typename?: 'CaseChangeDifference', status: CaseStatus | null, track: number | null, importantInfo: string | null, skafor: boolean | null, fileNames: string | null, scalePointId: string | null, scalePointNumber: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus | null, debitor: { __typename?: 'Debitor', debitorId: string, type: DebitorType, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string } | null, drivingSlips: { __typename?: 'DrivingSlip', locked: boolean, status: DrivingSlipStatus, urgent: boolean, start: string, end: string, comment: string | null, driver: { __typename?: 'User', name: string } | null, car: { __typename?: 'Vehicle', vehicleNumber: string } | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } | null, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }> | null, caseMachineUsages: Array<{ __typename?: 'CaseMachineUsage', machine: string, startTime: string, endTime: string | null, startMeterReading: number, endMeterReading: number | null }> | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null }, after: { __typename?: 'CaseChangeDifference', status: CaseStatus | null, track: number | null, importantInfo: string | null, skafor: boolean | null, fileNames: string | null, scalePointId: string | null, scalePointNumber: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus | null, debitor: { __typename?: 'Debitor', debitorId: string, type: DebitorType, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null } | null, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string } | null, drivingSlips: { __typename?: 'DrivingSlip', locked: boolean, status: DrivingSlipStatus, urgent: boolean, start: string, end: string, comment: string | null, driver: { __typename?: 'User', name: string } | null, car: { __typename?: 'Vehicle', vehicleNumber: string } | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } | null, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } | null, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }> | null, caseMachineUsages: Array<{ __typename?: 'CaseMachineUsage', machine: string, startTime: string, endTime: string | null, startMeterReading: number, endMeterReading: number | null }> | null, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null } }>, caseReports: { __typename?: 'CaseReports', inspectionReportFormData: { __typename: 'InspectionReportFormData' } | null, indoorClimateReportFormData: { __typename: 'IndoorClimateReportFormData' } | null, moistureReportFormData: { __typename: 'MoistureReportFormData' } | null, moistureTrygReportFormData: { __typename: 'MoistureTrygReportFormData' } | null } | null, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type GetWebCaseAdminDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebCaseAdminDataQuery = { __typename?: 'Query', damageCategories: Array<{ __typename?: 'DamageCategory', id: string, name: string }>, damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }>, departments: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }>, locations: Array<{ __typename?: 'Location', attachedPostalCodesInputString: string, attachedPostalCodes: Array<string>, id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }>, drivingSlipCategories: Array<{ __typename?: 'DrivingSlipCategory', code: string, name: string }> };

export type GetWebCasesQueryVariables = Exact<{
  address?: InputMaybe<AddressInput>;
  awaiting?: InputMaybe<Scalars['Boolean']['input']>;
  damageServiceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  calledBack?: InputMaybe<Scalars['Boolean']['input']>;
  machinesOnCase?: InputMaybe<Scalars['Boolean']['input']>;
  ownCases?: InputMaybe<Scalars['Boolean']['input']>;
  favoriteCases?: InputMaybe<Scalars['Boolean']['input']>;
  readyForInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  priorityCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  debitor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  track?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  department?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategory?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCause?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  priority?: InputMaybe<Array<CasePriority> | CasePriority>;
  caseManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectManager?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  createdBy?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  areaResponsible?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  anyManager?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
  erpReferenceNo?: InputMaybe<Scalars['String']['input']>;
  erpReferenceNos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  favoriteColors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeEconomy: Scalars['Boolean']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWebCasesQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, createdAt: string, skafor: boolean, activeMovables: boolean, machineOnCase: boolean, activeRequisitions: boolean, activeInvoiceStatus: InvoiceStatus | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, projectManagerFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, caseManagerFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, start: string, status: DrivingSlipStatus, driver: { __typename?: 'User', name: string } | null }> }>, caseReports: { __typename?: 'CaseReports', inspectionReportFormData: { __typename: 'InspectionReportFormData', created: boolean } | null, indoorClimateReportFormData: { __typename: 'IndoorClimateReportFormData', created: boolean } | null, moistureReportFormData: { __typename: 'MoistureReportFormData', created: boolean } | null, moistureTrygReportFormData: { __typename: 'MoistureTrygReportFormData', created: boolean } | null, inspectionMovablesReportFormData: { __typename: 'InspectionReportFormData', created: boolean } | null } | null, invoices: Array<{ __typename?: 'DraftInvoice', erpReferenceNo: string, status: InvoiceStatus, category: InvoiceCategory }>, caseEconomics: { __typename?: 'CaseEconomicsOverview', jobNo: string, costTotal: number, salesTotal: number, invoicedTotal: number, quote: number, screening: number, profit: number, deltaNotInvoiced: number, coverageRatio: number } | null }> };

export type GetWebCasesByErpNoQueryVariables = Exact<{
  erpReferenceNo: Scalars['String']['input'];
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWebCasesByErpNoQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, erpNo: string, status: CaseStatus, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', date: string, description: string, category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string }, businessArea: { __typename?: 'BusinessArea', name: string }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, projectManager: { __typename?: 'User', id: string, name: string } | null, caseManager: { __typename?: 'User', id: string, name: string } | null }> };

export type GetWebCasesForCatalogSuggestionsQueryVariables = Exact<{
  erpReferenceNo: Scalars['String']['input'];
}>;


export type GetWebCasesForCatalogSuggestionsQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }> };

export type MergeCasesMutationVariables = Exact<{
  primaryCaseId: Scalars['String']['input'];
  duplicateCaseId: Scalars['String']['input'];
  shouldCloseDuplicateCase: Scalars['Boolean']['input'];
}>;


export type MergeCasesMutation = { __typename?: 'Mutation', mergeCases: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type RejectCaseClosingMutationVariables = Exact<{
  id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  rejectionComment: Scalars['String']['input'];
}>;


export type RejectCaseClosingMutation = { __typename?: 'Mutation', rejectCaseClosing: { __typename?: 'Case', status: CaseStatus } };

export type ResetCaseFileCacheMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
}>;


export type ResetCaseFileCacheMutation = { __typename?: 'Mutation', resetCaseFileCache: { __typename?: 'EmptyReturn', _: string } | null };

export type SearchCasesByErpNoQueryVariables = Exact<{
  erpNo: Scalars['String']['input'];
}>;


export type SearchCasesByErpNoQuery = { __typename?: 'Query', searchCasesByERPNo: Array<{ __typename?: 'Case', erpNo: string, id: string }> };

export type SetCostEstimateMutationVariables = Exact<{
  erpNo: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
}>;


export type SetCostEstimateMutation = { __typename?: 'Mutation', setCostEstimate: number };

export type SetHoursAvailableMutationVariables = Exact<{
  erpNo: Scalars['String']['input'];
  hoursAvailable: Scalars['Decimal']['input'];
}>;


export type SetHoursAvailableMutation = { __typename?: 'Mutation', setHoursAvailable: number };

export type SetSsgPriceMutationVariables = Exact<{
  erpNo: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
}>;


export type SetSsgPriceMutation = { __typename?: 'Mutation', setSSGPrice: number };

export type UpdateCaseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status?: InputMaybe<CaseStatus>;
  damage?: InputMaybe<DamageInput>;
  policyHolder?: InputMaybe<ContactInput>;
  debitor?: InputMaybe<DebitorInput>;
  requisitioner?: InputMaybe<RequisitionerInput>;
  adviser?: InputMaybe<CompanyContactInput>;
  referrer?: InputMaybe<CompanyContactInput>;
  visitation?: InputMaybe<VisitationInput>;
  projectManager?: InputMaybe<Scalars['String']['input']>;
  caseManager?: InputMaybe<Scalars['String']['input']>;
  areaResponsible?: InputMaybe<Scalars['String']['input']>;
  ssgLocation?: InputMaybe<Scalars['String']['input']>;
  ssgDepartment?: InputMaybe<Scalars['String']['input']>;
  billingReady?: InputMaybe<Scalars['Boolean']['input']>;
  workComplete?: InputMaybe<Scalars['Boolean']['input']>;
  importantInfo?: InputMaybe<Scalars['String']['input']>;
  skafor?: InputMaybe<Scalars['Boolean']['input']>;
  alternativeContact?: InputMaybe<PersonInput>;
  track?: InputMaybe<Scalars['Int']['input']>;
  riskEvaluationAnswers?: InputMaybe<Array<RiskEvaluationAnswerInput> | RiskEvaluationAnswerInput>;
  machineNotification?: InputMaybe<Scalars['Boolean']['input']>;
  timeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPriceOnCase?: InputMaybe<Scalars['Decimal']['input']>;
  possibilityOfAsbestos?: InputMaybe<Scalars['Boolean']['input']>;
  scalePointStatus?: InputMaybe<ScalePointStatus>;
}>;


export type UpdateCaseMutation = { __typename?: 'Mutation', updateCase: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, reportSent: boolean, distance: string | null, machineNotification: boolean | null, timeRegistration: boolean | null, billingReady: boolean, workComplete: boolean, updatedAt: string, createdAt: string, skafor: boolean, importantInfo: string | null, riskEvaluationComment: string | null, scalePointUrl: string | null, scalePointStatus: ScalePointStatus, scalePointErrorMessage: string | null, arrived: boolean, arrivedDate: string | null, possibilityOfAsbestos: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isMoistureReportRequired: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null }, requisitioner: { __typename?: 'Requisitioner', name: string, phone: string, email: string, relation: string }, adviser: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, referrer: { __typename?: 'CompanyContact', name: string, phone: string, email: string, companyName: string | null, companyPhone: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null, proxy: { __typename?: 'User', id: string, name: string, email: string } | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseAgreements: Array<{ __typename?: 'CaseAgreement', content: string, category: CaseAgreementCategory, timestamp: string, shouldSaveInScalePoint: boolean, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } }>, caseEmails: Array<{ __typename?: 'CaseEmail', content: string, attachments: Array<string>, receivers: Array<string>, timestamp: string }>, userFavorite: { __typename?: 'CaseFavorite', user: string, color: string | null, active: boolean } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> | null, drivingSlipSeries: Array<{ __typename?: 'DrivingSlipSeries', id: string, completed: boolean, drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> }>, alternativeContact: { __typename?: 'Person', name: string, phone: string, email: string, comment: string | null } | null, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }>, scalePointMergeInfo: { __typename?: 'ScalePointMergeInfo', direction: ScalePointMergeDirection, caseId: string } | null } };

export type AddCatalogToContactMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  catalogId: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
}>;


export type AddCatalogToContactMutation = { __typename?: 'Mutation', addCatalogToContact: { __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> } };

export type CreateCatalogContactMutationVariables = Exact<{
  catalogContact: CatalogContactInput;
}>;


export type CreateCatalogContactMutation = { __typename?: 'Mutation', createCatalogContact: { __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> } };

export type DeleteCatalogContactMutationVariables = Exact<{
  id: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
}>;


export type DeleteCatalogContactMutation = { __typename?: 'Mutation', deleteCatalogContact: { __typename?: 'EmptyReturn', _: string } | null };

export type GetCatalogContactChangesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatalogContactChangesQuery = { __typename?: 'Query', catalogContact: { __typename?: 'CatalogContact', id: string, changes: Array<{ __typename?: 'CatalogContactChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'CatalogContactChangeDifference', changedBy: string | null, contactName: string | null, type: string | null, contactType: CatalogContacts | null, email: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null }, after: { __typename?: 'CatalogContactChangeDifference', changedBy: string | null, contactName: string | null, type: string | null, contactType: CatalogContacts | null, email: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } }> } };

export type GetCatalogContactForAddExcistingQueryVariables = Exact<{
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  notGlobalOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCatalogContactForAddExcistingQuery = { __typename?: 'Query', catalogContacts: Array<{ __typename?: 'CatalogContact', id: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> }> | null };

export type GetCatalogContactsQueryVariables = Exact<{
  globalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  contactType?: InputMaybe<CatalogContacts>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCatalogContactsQuery = { __typename?: 'Query', catalogContacts: Array<{ __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> }> | null };

export type UpdateCatalogContactMutationVariables = Exact<{
  id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  contactType: CatalogContacts;
  globalType: CatalogGlobalType;
  informations: Array<InputMaybe<CatalogPhoneInformationInput>> | InputMaybe<CatalogPhoneInformationInput>;
  global: Scalars['Boolean']['input'];
  active: Scalars['Boolean']['input'];
  catalogs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  action: FileActionType;
  catalogsBefore?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateCatalogContactMutation = { __typename?: 'Mutation', updateCatalogContact: { __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> } };

export type AddCatalogToCraftsmanMutationVariables = Exact<{
  craftsmanId: Scalars['String']['input'];
  catalogId: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
}>;


export type AddCatalogToCraftsmanMutation = { __typename?: 'Mutation', addCatalogToCraftsman: { __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> } };

export type CreateCatalogCraftsmanMutationVariables = Exact<{
  catalogCraftsman: CatalogCraftsmanInput;
}>;


export type CreateCatalogCraftsmanMutation = { __typename?: 'Mutation', createCatalogCraftsman: { __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> } };

export type DeleteCatalogCraftsmanMutationVariables = Exact<{
  id: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
}>;


export type DeleteCatalogCraftsmanMutation = { __typename?: 'Mutation', deleteCatalogCraftsman: string };

export type GetCatalogCraftsmanChangesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatalogCraftsmanChangesQuery = { __typename?: 'Query', catalogCraftsman: { __typename?: 'CatalogCraftsman', id: string, changes: Array<{ __typename?: 'CatalogCraftsmanChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'CatalogCraftsmanChangeDifference', changedBy: string | null, type: string | null, contactName: string | null, email: string | null, priority: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null }, after: { __typename?: 'CatalogCraftsmanChangeDifference', changedBy: string | null, type: string | null, contactName: string | null, email: string | null, priority: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } }> } };

export type GetCatalogCraftsmenQueryVariables = Exact<{
  globalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCatalogCraftsmenQuery = { __typename?: 'Query', catalogCraftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }> | null };

export type GetCatalogCraftsmenForAddExcistingQueryVariables = Exact<{
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  notGlobalOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCatalogCraftsmenForAddExcistingQuery = { __typename?: 'Query', catalogCraftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, type: string, contactName: string, email: string | null, priority: string, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }> | null };

export type UpdateCatalogCraftsmanMutationVariables = Exact<{
  id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  type: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  globalType: CatalogGlobalType;
  email?: InputMaybe<Scalars['String']['input']>;
  informations: Array<InputMaybe<CatalogPhoneInformationInput>> | InputMaybe<CatalogPhoneInformationInput>;
  global: Scalars['Boolean']['input'];
  active: Scalars['Boolean']['input'];
  catalogs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  action: FileActionType;
  catalogsBefore?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateCatalogCraftsmanMutation = { __typename?: 'Mutation', updateCatalogCraftsman: { __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> } };

export type GetCatalogCustomerByAdIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatalogCustomerByAdIdQuery = { __typename?: 'Query', catalogCustomerByAdId: { __typename?: 'CatalogCustomer', id: string, name: string, user: { __typename?: 'User', id: string, name: string } | null, users: Array<{ __typename?: 'User', id: string, name: string, email: string }> } | null };

export type GetWebCatalogCustomersQueryVariables = Exact<{
  ownCustomers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWebCatalogCustomersQuery = { __typename?: 'Query', catalogCustomers: Array<{ __typename?: 'CatalogCustomer', id: string, name: string }> };

export type CreateCatalogMutationVariables = Exact<{
  catalog: CatalogInput;
}>;


export type CreateCatalogMutation = { __typename?: 'Mutation', createCatalog: { __typename?: 'Catalog', ssgAccountable: string | null, description: string | null, id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, craftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }>, contacts: Array<{ __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> }>, timedMessages: Array<{ __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } }>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null } };

export type CreateCatalogsMutationVariables = Exact<{
  catalogs: Array<CatalogInput> | CatalogInput;
}>;


export type CreateCatalogsMutation = { __typename?: 'Mutation', createCatalogs: Array<{ __typename?: 'Catalog', ssgAccountable: string | null, description: string | null, id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, craftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }>, contacts: Array<{ __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> }>, timedMessages: Array<{ __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } }>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null }> };

export type DeleteCatalogMutationVariables = Exact<{
  id: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
}>;


export type DeleteCatalogMutation = { __typename?: 'Mutation', deleteCatalog: { __typename?: 'EmptyReturn', _: string } | null };

export type GetCatalogQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatalogQuery = { __typename?: 'Query', catalog: { __typename?: 'Catalog', ssgAccountable: string | null, description: string | null, id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, craftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }>, contacts: Array<{ __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> }>, timedMessages: Array<{ __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } }>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null } };

export type GetCatalogCaseCreationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatalogCaseCreationQuery = { __typename?: 'Query', catalog: { __typename?: 'Catalog', id: string, debitor: { __typename?: 'Debitor', id: string, debitorId: string, company: string } | null, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string }> } };

export type GetCatalogChangesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatalogChangesQuery = { __typename?: 'Query', catalog: { __typename?: 'Catalog', version: number, changes: Array<{ __typename?: 'CatalogChange', timestamp: string, changedBy: string | null, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'CatalogChangeDifference', ssgAccountable: string | null, propertyNumber: string | null, changedBy: string | null, description: string | null, contactNumber: string | null, contactHours: string | null, filenames: string | null, smsService: boolean | null, verified: boolean, debitorVerified: boolean, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> | null, contacts: { __typename?: 'CatalogContactChangeDifference', changedBy: string | null, contactName: string | null, type: string | null, contactType: CatalogContacts | null, email: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, craftsmen: { __typename?: 'CatalogCraftsmanChangeDifference', changedBy: string | null, type: string | null, contactName: string | null, email: string | null, priority: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, timedMessages: { __typename?: 'TimedMessageChangeDifference', changedBy: string | null, startTime: string | null, endTime: string | null, message: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null } | null }, after: { __typename?: 'CatalogChangeDifference', ssgAccountable: string | null, propertyNumber: string | null, changedBy: string | null, description: string | null, contactNumber: string | null, contactHours: string | null, filenames: string | null, smsService: boolean | null, verified: boolean, debitorVerified: boolean, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> | null, contacts: { __typename?: 'CatalogContactChangeDifference', changedBy: string | null, contactName: string | null, type: string | null, contactType: CatalogContacts | null, email: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, craftsmen: { __typename?: 'CatalogCraftsmanChangeDifference', changedBy: string | null, type: string | null, contactName: string | null, email: string | null, priority: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, timedMessages: { __typename?: 'TimedMessageChangeDifference', changedBy: string | null, startTime: string | null, endTime: string | null, message: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } | null, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null } | null } }> } };

export type GetCatalogsForDropdownQueryVariables = Exact<{
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCatalogsForDropdownQuery = { __typename?: 'Query', catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, customer: { __typename?: 'CatalogCustomer', id: string } }> };

export type GetLatestCatalogQueryVariables = Exact<{
  date: Scalars['Date']['input'];
}>;


export type GetLatestCatalogQuery = { __typename?: 'Query', latestCatalog: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null }> };

export type GetWebCatalogsQueryVariables = Exact<{
  debitors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  smsService?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  debitorVerified?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressInput>;
  noDebitor?: InputMaybe<Scalars['Boolean']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWebCatalogsQuery = { __typename?: 'Query', catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null }> };

export type UpdateCatalogMutationVariables = Exact<{
  id: Scalars['String']['input'];
  propertyNumber: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  contactHours?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<CatalogAddressInput> | CatalogAddressInput>;
  smsService: Scalars['Boolean']['input'];
  debitor?: InputMaybe<Scalars['String']['input']>;
  ssgAccountable?: InputMaybe<Scalars['String']['input']>;
  verified: Scalars['Boolean']['input'];
  debitorVerified: Scalars['Boolean']['input'];
}>;


export type UpdateCatalogMutation = { __typename?: 'Mutation', updateCatalog: { __typename?: 'Catalog', ssgAccountable: string | null, description: string | null, id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, craftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }>, contacts: Array<{ __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> }>, timedMessages: Array<{ __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } }>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null } };

export type UpdateCatalogsMutationVariables = Exact<{
  catalogs: Array<InputMaybe<CatalogBatchInput>> | InputMaybe<CatalogBatchInput>;
}>;


export type UpdateCatalogsMutation = { __typename?: 'Mutation', updateCatalogs: Array<{ __typename?: 'Catalog', ssgAccountable: string | null, description: string | null, id: string, propertyNumber: string, contactNumber: string | null, contactHours: string | null, changedBy: string, smsService: boolean, verified: boolean, debitorVerified: boolean, version: number, updatedAt: string, createdAt: string, craftsmen: Array<{ __typename?: 'CatalogCraftsman', id: string, changedBy: string, type: string, contactName: string, email: string | null, priority: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null }> }>, contacts: Array<{ __typename?: 'CatalogContact', id: string, changedBy: string, contactName: string, type: string | null, contactType: CatalogContacts, email: string | null, global: boolean, globalType: CatalogGlobalType, active: boolean, catalogIds: Array<string>, version: number, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, informations: Array<{ __typename?: 'CatalogPhoneInformation', phoneNumber: string, remark: string | null } | null> }>, timedMessages: Array<{ __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } }>, customer: { __typename?: 'CatalogCustomer', id: string, name: string }, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }>, debitor: { __typename?: 'Debitor', company: string, debitorId: string, gln: string | null, salesPersonCode: string, salesPersonName: string } | null }> };

export type GetWebDamageCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebDamageCategoriesQuery = { __typename?: 'Query', damageCategories: Array<{ __typename?: 'DamageCategory', id: string, name: string }> };

export type GetWebDamageCausesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebDamageCausesQuery = { __typename?: 'Query', damageCauses: Array<{ __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }> };

export type GetDebitorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDebitorQuery = { __typename?: 'Query', debitor: { __typename?: 'DebitorBase', debitorId: string, type: DebitorType, gln: string | null, phone: string | null, email: string | null, company: string, createInECB: boolean, callCenterActive: boolean, assortmentCode: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, supplyFeePercentage: number, maxSupplyFeeAmount: number | null, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string } | null } };

export type GetDebitorDelayScalepointConnectionQueryVariables = Exact<{
  debitorId: Scalars['String']['input'];
  damageCauseId: Scalars['String']['input'];
}>;


export type GetDebitorDelayScalepointConnectionQuery = { __typename?: 'Query', debitorDelayScalepointConnection: { __typename?: 'DebitorDelayScalepointConnection', id: string } | null };

export type GetDebitorShipmentAddressesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDebitorShipmentAddressesQuery = { __typename?: 'Query', debitorShipmentAddresses: Array<{ __typename?: 'DebitorShipmentAddress', id: string, gln: string, name: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string } }> };

export type GetWebDebitorsQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  catalogUser?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWebDebitorsQuery = { __typename?: 'Query', debitors: Array<{ __typename?: 'DebitorBase', debitorId: string, type: DebitorType, gln: string | null, phone: string | null, email: string | null, company: string, createInECB: boolean, callCenterActive: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string } | null }> };

export type UpdateDebitorMutationVariables = Exact<{
  no: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  addressLine?: InputMaybe<Scalars['String']['input']>;
  addressLineAlt?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDebitorMutation = { __typename?: 'Mutation', updateDebitor: string | null };

export type GetRequisitionDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequisitionDepartmentsQuery = { __typename?: 'Query', departmentsRequisition: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }> };

export type GetWebDepartmentsQueryVariables = Exact<{
  operationManager?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWebDepartmentsQuery = { __typename?: 'Query', departments: Array<{ __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }> };

export type CompleteDrivingSlipsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CompleteDrivingSlipsMutation = { __typename?: 'Mutation', completeDrivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, status: DrivingSlipStatus }> };

export type CreateDrivingSlipMutationVariables = Exact<{
  drivingSlip: DrivingSlipHelperInput;
  caseId: Scalars['String']['input'];
  includeCase?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateDrivingSlipMutation = { __typename?: 'Mutation', createDrivingSlip: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case?: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> };

export type DeleteDrivingSlipMutationVariables = Exact<{
  id: Scalars['String']['input'];
  caseId: Scalars['String']['input'];
}>;


export type DeleteDrivingSlipMutation = { __typename?: 'Mutation', deleteDrivingSlip: { __typename?: 'EmptyReturn', _: string } | null };

export type GetDistanceQueryVariables = Exact<{
  fromAddress: AddressInput;
  toAddress: AddressInput;
}>;


export type GetDistanceQuery = { __typename?: 'Query', getDistance: { __typename?: 'DistanceRetriever', distance: string, duration: string } };

export type GetDrivingSlipsExcelQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  debitor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  priorityCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDrivingSlipsExcelQuery = { __typename?: 'Query', exportDrivingSlipsToExcel: Array<any> };

export type GetDrivingSlipIDsQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDrivingSlipIDsQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string }> };

export type GetDrivingSlipsOverviewQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  debitor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  priorityCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDrivingSlipsOverviewQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, start: string, end: string, deadline: string | null, updatedAt: string, createdAt: string, version: number, comment: string | null, category: string | null, drivingStarted: string | null, eventReferenceId: string | null, driver: { __typename?: 'User', id: string, name: string, email: string, phone: string | null, department: string | null, jobFunction: string | null } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, erpNo: string, track: number, createdAt: string, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, isSpPhaseOneReportCreated: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null } } }> };

export type GetDrivingSlipsPlannerQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDrivingSlipsPlannerQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string }> | null }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }> };

export type GetWebDrivingSlipQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWebDrivingSlipQuery = { __typename?: 'Query', drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type GetWebDrivingSlipsQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWebDrivingSlipsQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> };

export type GetWebDrivingSlipsNoCaseQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWebDrivingSlipsNoCaseQuery = { __typename?: 'Query', drivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> };

export type SetWebDrivingSlipStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: DrivingSlipStatus;
}>;


export type SetWebDrivingSlipStatusMutation = { __typename?: 'Mutation', setDrivingSlipStatus: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } };

export type UpdateWebDrivingSlipMutationVariables = Exact<{
  id: Scalars['String']['input'];
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  driver?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  car?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  additionalDays?: InputMaybe<Array<AdditionalDayInput> | AdditionalDayInput>;
  additionalDrivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  driverCarList?: InputMaybe<Array<DriverCarInput> | DriverCarInput>;
  location: Scalars['String']['input'];
  department: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  immediatelyPlan?: InputMaybe<Scalars['Boolean']['input']>;
  plannerMessage?: InputMaybe<Scalars['String']['input']>;
  halfDay?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateWebDrivingSlipMutation = { __typename?: 'Mutation', updateDrivingSlip: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } }> };

export type AddCaseFileToDrivingSlipMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  caseFolder: Scalars['String']['input'];
  seriesFolder: Scalars['String']['input'];
}>;


export type AddCaseFileToDrivingSlipMutation = { __typename?: 'Mutation', addCaseFileToDrivingSlip: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } };

export type AddCaseFilesToDrivingSlipMutationVariables = Exact<{
  filenames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  caseFolder: Scalars['String']['input'];
  seriesFolder: Scalars['String']['input'];
}>;


export type AddCaseFilesToDrivingSlipMutation = { __typename?: 'Mutation', addCaseFilesToDrivingSlip: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type DeleteCaseFileMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
}>;


export type DeleteCaseFileMutation = { __typename?: 'Mutation', deleteCaseFile: { __typename?: 'EmptyReturn', _: string } | null };

export type DeleteCatalogFileMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCatalogFileMutation = { __typename?: 'Mutation', deleteCatalogFile: { __typename?: 'EmptyReturn', _: string } | null };

export type DeleteInvoiceFileMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  invoiceNo: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type DeleteInvoiceFileMutation = { __typename?: 'Mutation', deleteInvoiceFile: { __typename?: 'EmptyReturn', _: string } | null };

export type GetCatalogFileQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCatalogFileQuery = { __typename?: 'Query', catalogFile: { __typename?: 'FileRetriever', fileData: Array<any>, filename: string } };

export type GetGlobalCatalogEsdhFilesQueryVariables = Exact<{
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetGlobalCatalogEsdhFilesQuery = { __typename?: 'Query', globalCatalogFiles: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type GetWebCaseFileQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWebCaseFileQuery = { __typename?: 'Query', caseFile: { __typename?: 'FileRetriever', fileData: Array<any>, filename: string } };

export type GetWebDrivingSlipFileQueryVariables = Exact<{
  caseNo: Scalars['String']['input'];
  drivingSlipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type GetWebDrivingSlipFileQuery = { __typename?: 'Query', drivingSlipFile: { __typename?: 'FileRetriever', fileData: Array<any>, filename: string } };

export type LogCaseFileChangeMutationVariables = Exact<{
  case: Scalars['String']['input'];
  action: FileActionType;
  filename: Scalars['String']['input'];
}>;


export type LogCaseFileChangeMutation = { __typename?: 'Mutation', logCaseFileChange: { __typename?: 'EmptyReturn', _: string } | null };

export type LogCatalogFileChangeMutationVariables = Exact<{
  catalogId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  action: FileActionType;
  globalFile: Scalars['Boolean']['input'];
  filename: Scalars['String']['input'];
}>;


export type LogCatalogFileChangeMutation = { __typename?: 'Mutation', logCatalogFileChange: { __typename?: 'EmptyReturn', _: string } | null };

export type LogDrivingSlipFileChangeMutationVariables = Exact<{
  series: Scalars['String']['input'];
  action: FileActionType;
  filename: Scalars['String']['input'];
}>;


export type LogDrivingSlipFileChangeMutation = { __typename?: 'Mutation', logDrivingSlipFileChange: { __typename?: 'EmptyReturn', _: string } | null };

export type UploadCaseFileMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  file: Array<Scalars['Byte']['input']> | Scalars['Byte']['input'];
}>;


export type UploadCaseFileMutation = { __typename?: 'Mutation', uploadCaseFile: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } };

export type UploadCaseFilesMutationVariables = Exact<{
  folder: Scalars['String']['input'];
  files: Array<FileInput> | FileInput;
}>;


export type UploadCaseFilesMutation = { __typename?: 'Mutation', uploadCaseFiles: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type UploadCatalogFileMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  file: Array<Scalars['Byte']['input']> | Scalars['Byte']['input'];
}>;


export type UploadCatalogFileMutation = { __typename?: 'Mutation', uploadCatalogFile: { __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> } };

export type UploadCatalogFilesMutationVariables = Exact<{
  folder?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  files: Array<FileInput> | FileInput;
}>;


export type UploadCatalogFilesMutation = { __typename?: 'Mutation', uploadCatalogFiles: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type UploadInvoiceFilesMutationVariables = Exact<{
  caseNo: Scalars['String']['input'];
  invoiceNo: Scalars['String']['input'];
  files: Array<FileInput> | FileInput;
}>;


export type UploadInvoiceFilesMutation = { __typename?: 'Mutation', uploadInvoiceFiles: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type CreateGdprAcceptMutationVariables = Exact<{
  gdpr: GdprInputType;
}>;


export type CreateGdprAcceptMutation = { __typename?: 'Mutation', createGDPRAccept: { __typename?: 'GDPR', id: string, timestamp: string, userId: { __typename?: 'User', id: string } } };

export type DeleteGdprAcceptMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteGdprAcceptMutation = { __typename?: 'Mutation', deleteGDPRAccept: { __typename?: 'EmptyReturn', _: string } | null };

export type GetGdprAcceptQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetGdprAcceptQuery = { __typename?: 'Query', gdprAccept: { __typename?: 'GDPR', id: string, timestamp: string, userId: { __typename?: 'User', id: string } } | null };

export type UpdateGdprAcceptMutationVariables = Exact<{
  id: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
}>;


export type UpdateGdprAcceptMutation = { __typename?: 'Mutation', updateGDPRAccept: { __typename?: 'GDPR', id: string, timestamp: string, userId: { __typename?: 'User', id: string } } };

export type GetSsgSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSsgSettingsQuery = { __typename?: 'Query', ssgSetup: { __typename?: 'SsgSetup', primaryKey: string, environmentFeeRessourceNo: string | null, supplyFeeResourceNo: string | null, supplyFeeDateFrom: string | null, supplyFeeDateTo: string | null } | null };

export type UpdateWebInputFieldMutationVariables = Exact<{
  key: Scalars['String']['input'];
  permissionsList: Array<Permissions> | Permissions;
}>;


export type UpdateWebInputFieldMutation = { __typename?: 'Mutation', updateInputField: { __typename?: 'InputField', key: string, permissions: Array<Permissions> } | null };

export type ApproveInvoiceMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
}>;


export type ApproveInvoiceMutation = { __typename?: 'Mutation', approveInvoice: { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> } };

export type CreateInvoiceMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  category: InvoiceCategory;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> } };

export type DeleteInvoiceMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
}>;


export type DeleteInvoiceMutation = { __typename?: 'Mutation', deleteInvoice: { __typename?: 'EmptyReturn', _: string } | null };

export type AllAssortmentsQueryVariables = Exact<{
  assortmentCode: Scalars['String']['input'];
}>;


export type AllAssortmentsQuery = { __typename?: 'Query', allAssortments: Array<{ __typename?: 'Assortment', no: string, type: string, description: string, uom: string }> | null };

export type GetDraftInvoiceLineTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDraftInvoiceLineTypesQuery = { __typename?: 'Query', draftInvoiceLineTypes: Array<{ __typename?: 'DraftInvoiceLineType', id: number, name: string }> };

export type GetInvoiceApprovalQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
}>;


export type GetInvoiceApprovalQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, erpNo: string, createdAt: string, projectManager: { __typename?: 'User', name: string } | null, debitor: { __typename?: 'Debitor', company: string, maxEnvironmentFeeAmount: number, environmentFeePercentage: number, supplyFeePercentage: number, maxSupplyFeeAmount: number | null, supplyFeeDateFrom: string | null, supplyFeeDateTo: string | null, assortmentCode: string | null }, ssgDepartment: { __typename?: 'Department', name: string, departmentNumber: number }, invoices: Array<{ __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, createdBy: { __typename?: 'User', name: string } | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> }>, screenings: Array<{ __typename?: 'Screening', lines: Array<{ __typename?: 'ScreeningLine', erpReferenceId: string, uom: string }> }> }, invoiceReasonCodes: Array<{ __typename?: 'InvoiceReasonCode', id: string, name: string }> };

export type GetInvoiceAttachmentsQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceNo: Scalars['String']['input'];
}>;


export type GetInvoiceAttachmentsQuery = { __typename?: 'Query', invoice: { __typename?: 'DraftInvoice', attachments: Array<{ __typename?: 'ESDHFile', name: string, url: string, fileId: string }> } };

export type GetInvoiceHeaderQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type GetInvoiceHeaderQuery = { __typename?: 'Query', invoiceHeaders: Array<{ __typename?: 'InvoiceHeader', no: string | null, orderNo: string, salesPerson: string | null, customerNo: string | null, paymentTerms: string | null, jobNo: string | null }> };

export type GetInvoicePredictionsQueryVariables = Exact<{
  invoicePredictionInput: AiInvoicePredictionInputType;
}>;


export type GetInvoicePredictionsQuery = { __typename?: 'Query', invoicePredictions: { __typename?: 'AIInvoicePrediction', jobTaskDescriptions: Array<string>, lineSuggestions: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, quantity: number | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, workTypeCode: string, screeningLinePositionText: string }> } };

export type InvoiceResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoiceResourcesQuery = { __typename?: 'Query', invoiceResources: Array<{ __typename?: 'Resource', no: string, name: string, type: string, baseUOM: string }> };

export type GetInvoicesQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
}>;


export type GetInvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> }> };

export type GetInvoicesForUsersApprovalQueryVariables = Exact<{
  department?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetInvoicesForUsersApprovalQuery = { __typename?: 'Query', invoicesForUsersApproval: Array<{ __typename?: 'CaseInvoiceApprovalInfo', case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, supplyFeePercentage: number, maxSupplyFeeAmount: number | null, supplyFeeDateFrom: string | null, supplyFeeDateTo: string | null }, projectManager: { __typename?: 'User', name: string } | null, ssgDepartment: { __typename?: 'Department', name: string, departmentNumber: number }, caseEconomics: { __typename?: 'CaseEconomicsOverview', costTotal: number } | null }, invoiceToApprove: { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, lines: Array<{ __typename?: 'DraftInvoiceLine', quantity: number | null, unitPrice: number | null, unitCost: number | null, no: string, newUnitPrice: number | null }>, createdBy: { __typename?: 'User', name: string } | null } }> };

export type GetSalesInvoiceLinesQueryVariables = Exact<{
  offerERPReferenceNo: Scalars['String']['input'];
}>;


export type GetSalesInvoiceLinesQuery = { __typename?: 'Query', salesInvoiceLines: Array<{ __typename?: 'SalesInvoiceLine', systemId: string, documentNo: string | null, lineNo: number | null, no: string | null, type: string | null, description: string | null, quantity: number | null, uom: string | null, unitPrice: number | null, lineDiscountAmount: number | null, lineDiscountPercentage: number | null, amountIncludingVAT: number | null, vatBaseAmount: number | null, vatPercentage: number | null }> };

export type GetSamplePriceForInvoiceLineMutationVariables = Exact<{
  invoiceLine: DraftInvoiceLineInputType;
}>;


export type GetSamplePriceForInvoiceLineMutation = { __typename?: 'Mutation', samplePriceForInvoiceLine: { __typename?: 'SamplePriceResult', totalCost: number, lineAmount: number } };

export type OpenInvoiceForEditingMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
}>;


export type OpenInvoiceForEditingMutation = { __typename?: 'Mutation', openInvoiceForEditing: { __typename?: 'DraftInvoice', erpReferenceNo: string } };

export type OverrideInvoiceDatesMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  documentDate: Scalars['Date']['input'];
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
}>;


export type OverrideInvoiceDatesMutation = { __typename?: 'Mutation', overrideInvoiceDates: { __typename?: 'EmptyReturn', _: string } | null };

export type RejectInvoiceMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectInvoiceMutation = { __typename?: 'Mutation', rejectInvoice: { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> } };

export type RequestInvoiceApprovalMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
}>;


export type RequestInvoiceApprovalMutation = { __typename?: 'Mutation', requestInvoiceApproval: { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> } };

export type SetInvoiceReasonCodesMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  validationRuleBypasses: Array<ValidationRuleBypassInput> | ValidationRuleBypassInput;
}>;


export type SetInvoiceReasonCodesMutation = { __typename?: 'Mutation', setInvoiceReasonCodes: { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> } };

export type SuggestInvoiceLinesMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  includePreviousLines?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SuggestInvoiceLinesMutation = { __typename?: 'Mutation', suggestInvoiceLines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> | null };

export type UpdateInvoiceMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  lines: Array<DraftInvoiceLineInputType> | DraftInvoiceLineInputType;
  invoiceDescription: Scalars['String']['input'];
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice: { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> } };

export type UpdateScreeningInvoiceMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
  invoiceDescription: Scalars['String']['input'];
  lines: Array<DraftInvoiceLineInputType> | DraftInvoiceLineInputType;
}>;


export type UpdateScreeningInvoiceMutation = { __typename?: 'Mutation', updateScreeningInvoice: { __typename?: 'DraftInvoice', erpReferenceNo: string, category: InvoiceCategory, status: InvoiceStatus, invoicePostingDate: string, invoiceStartDate: string, invoiceEndDate: string, hasSuggestedLines: boolean, invoiceDescription: string, rejectionReason: string | null, validationRuleBypasses: Array<{ __typename?: 'ValidationRuleBypass', rule: string, reasonCode: string, comment: string | null }>, lines: Array<{ __typename?: 'DraftInvoiceLine', systemId: string, sortIndex: number, caseNo: string, documentNo: string, no: string, erpReferenceTask: string, lineAmount: number | null, lineType: string, type: string, attachDocument: boolean | null, allowAttachDocument: boolean, description: string, quantity: number | null, quoteLineId: string, screeningTitle: string, screeningLine: boolean, screeningLineId: string, screeningLinePosition: string | null, unitPrice: number | null, unitCost: number | null, newUnitPrice: number | null, planningDate: string, workTypeCode: string, createdBy: string, unitOfMeasure: string, excludeInEnvFee: boolean | null, excludeInSupplyFee: boolean | null }> } };

export type ValidateInvoiceMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  invoiceERPReference: Scalars['String']['input'];
}>;


export type ValidateInvoiceMutation = { __typename?: 'Mutation', validateInvoice: Array<{ __typename?: 'ValidationResultKVP', key: string, value: { __typename?: 'ValidationResult', valid: boolean, bypassAllowed: boolean, expectedResult: string | null, actualResult: string | null } }> };

export type CreateJobMutationVariables = Exact<{
  job: JobInput;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null } };

export type GetJobsQueryVariables = Exact<{
  type?: InputMaybe<JobType>;
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  proxyFor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetJobsQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null }> };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string, type: JobType, description: string, deadline: string, source: JobSource, completed: boolean, assignedTo: { __typename?: 'User', id: string, name: string, email: string } | null, location: { __typename?: 'Location', id: string, name: string } | null, case: { __typename?: 'Case', id: string, erpNo: string, scalePointUrl: string | null } | null, movable: { __typename?: 'Movable', id: string, description: string, status: string, placement: { __typename?: 'MovablesLocation', id: string, name: string } } | null } | null };

export type GetWebLocationsQueryVariables = Exact<{
  movableLocationsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWebLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }> };

export type GetMachineCaseOverviewQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type GetMachineCaseOverviewQuery = { __typename?: 'Query', machineCaseOverview: Array<{ __typename?: 'MachineCaseOverview', machine: string, dateStart: string, daysActive: string, usage: string }> };

export type GetMachineHistoryQueryVariables = Exact<{
  machineERPReferenceNo: Scalars['String']['input'];
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetMachineHistoryQuery = { __typename?: 'Query', machineHistory: Array<{ __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean }> };

export type GetMachineTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMachineTypesQuery = { __typename?: 'Query', machineTypes: Array<string> };

export type GetMachinesPreviouslyOnCaseQueryVariables = Exact<{
  erpNo: Scalars['String']['input'];
}>;


export type GetMachinesPreviouslyOnCaseQuery = { __typename?: 'Query', machinesPreviouslyOnCase: Array<{ __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean }> };

export type GetWebMachineQueryVariables = Exact<{
  machineERPReferenceNo: Scalars['String']['input'];
}>;


export type GetWebMachineQuery = { __typename?: 'Query', machine: { __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean } | null };

export type GetWebMachineGuideFilesQueryVariables = Exact<{
  filter?: InputMaybe<FileFilterInput>;
}>;


export type GetWebMachineGuideFilesQuery = { __typename?: 'Query', machineGuideFiles: Array<{ __typename?: 'ESDHFile', name: string, thumbnail: string, url: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }> };

export type GetWebMachineLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebMachineLocationsQuery = { __typename?: 'Query', machineLocations: Array<{ __typename?: 'MachineLocation', locationCode: string, address: string, city: string, contact: string, name: string, postCode: string, unavaliable: boolean }> };

export type GetWebMachinesQueryVariables = Exact<{
  status?: InputMaybe<MachineStatus>;
  cases?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
  hibernation?: InputMaybe<Scalars['Boolean']['input']>;
  reservationByRessource?: InputMaybe<Scalars['String']['input']>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWebMachinesQuery = { __typename?: 'Query', machines: Array<{ __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean }> };

export type GetWebMachinesOnCaseQueryVariables = Exact<{
  erpNo: Scalars['String']['input'];
}>;


export type GetWebMachinesOnCaseQuery = { __typename?: 'Query', machinesOnCase: Array<{ __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean }> };

export type MachineReserveMutationVariables = Exact<{
  machineInput: MachineInput;
}>;


export type MachineReserveMutation = { __typename?: 'Mutation', machineReserve: { __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean } | null };

export type MoveWebMachinesMutationVariables = Exact<{
  erpReferenceNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  erpCaseReference: Scalars['String']['input'];
  erpLocationReference: Scalars['String']['input'];
}>;


export type MoveWebMachinesMutation = { __typename?: 'Mutation', moveMachines: Array<{ __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean }> };

export type MoveWebMachineMutationVariables = Exact<{
  machineInput: MachineInput;
  caseERPreferenceNo: Scalars['String']['input'];
}>;


export type MoveWebMachineMutation = { __typename?: 'Mutation', moveMachine: { __typename?: 'Machine', erpReferenceNo: string, name: string, dateStart: string, dateEnd: string, eRPCaseReference: string | null, eRPLocationReference: string | null, consumption: number, userName: string, type: string, active: boolean, placement: string, originLocation: string, hibernate: boolean, hibernationReason: string, educationPrerequisit: Array<string> | null, startTime: string, serviceDate: string, consumptionFactor: number, consumptionType: MachineConsumptionType, modelNumber: string, reservationStart: string | null, reservationEnd: string | null, reservationDescription: string | null, reservationByRessource: string | null, reservationOnCase: string | null, blocked: boolean, placementDescription: string | null, usageMeterEnd: number, unavailableReason: string, discontinued: boolean } | null };

export type GetWorkEnvRegulationsManagerListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkEnvRegulationsManagerListQuery = { __typename?: 'Query', workEnvRegulationsManagerList: Array<{ __typename?: 'WorkerRestPeriod', hours48Over4Months: number, hoursCurrentDay: number, elevenHourRest: boolean | null, eightHourRest: boolean | null, daysSinceRestDay: number, lastWorkTime: string, availableAgainTime: string | null, currentTask: string, startedTask: string, user: { __typename?: 'User', id: string, name: string, jobFunction: string | null, employeeId: string | null } }> };

export type ChangeLabelAndStatusMovableMutationVariables = Exact<{
  oldMovableId: Scalars['String']['input'];
  newMovableId: Scalars['String']['input'];
  newStatus: Scalars['String']['input'];
}>;


export type ChangeLabelAndStatusMovableMutation = { __typename?: 'Mutation', changeLabelAndStatusMovable: { __typename?: 'Movable', id: string, description: string, volume: number, completed: boolean, status: string, version: number, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }, placement: { __typename?: 'MovablesLocation', id: string, name: string, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, changes: Array<{ __typename?: 'MovableChange', timestamp: string, user: { __typename?: 'User', id: string, name: string, email: string }, before: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null }, after: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null } }> } };

export type CheckMovableMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CheckMovableMutation = { __typename?: 'Mutation', checkMovable: { __typename?: 'Movable', id: string, completed: boolean, status: string } | null };

export type CheckOpenMovableQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type CheckOpenMovableQuery = { __typename?: 'Query', checkOpenMovable: boolean };

export type CheckOpenMovablesOnCaseQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type CheckOpenMovablesOnCaseQuery = { __typename?: 'Query', checkOpenMovable: boolean };

export type CreateMovableMutationVariables = Exact<{
  movable: MovableInput;
}>;


export type CreateMovableMutation = { __typename?: 'Mutation', createMovable: { __typename?: 'Movable', id: string, description: string, volume: number, completed: boolean, status: string, version: number, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }, placement: { __typename?: 'MovablesLocation', id: string, name: string, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, changes: Array<{ __typename?: 'MovableChange', timestamp: string, user: { __typename?: 'User', id: string, name: string, email: string }, before: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null }, after: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null } }> } };

export type ExportMovableToExcelQueryVariables = Exact<{
  filters: MovableSearchFiltersInputType;
}>;


export type ExportMovableToExcelQuery = { __typename?: 'Query', exportMovableToExcel: Array<any> };

export type GenerateMovableIdListMutationVariables = Exact<{
  count: Scalars['Int']['input'];
}>;


export type GenerateMovableIdListMutation = { __typename?: 'Mutation', generateMovableIdList: Array<string> };

export type GetMovableQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMovableQuery = { __typename?: 'Query', movable: { __typename?: 'Movable', id: string, description: string, volume: number, completed: boolean, status: string, version: number, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }, placement: { __typename?: 'MovablesLocation', id: string, name: string, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, changes: Array<{ __typename?: 'MovableChange', timestamp: string, user: { __typename?: 'User', id: string, name: string, email: string }, before: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null }, after: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null } }> } };

export type GetMovableInvoiceableStatusOptionsQueryVariables = Exact<{
  erpNo: Scalars['String']['input'];
}>;


export type GetMovableInvoiceableStatusOptionsQuery = { __typename?: 'Query', movableInvoiceableStatusOptions: Array<{ __typename?: 'BoolKVP', key: string, value: boolean }> };

export type GetMovableLocationsQueryVariables = Exact<{
  location?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMovableLocationsQuery = { __typename?: 'Query', movablesLocations: Array<{ __typename?: 'MovablesLocation', accVolume: number, id: string, name: string, volume: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }> };

export type GetMovableStatusOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMovableStatusOptionsQuery = { __typename?: 'Query', movableStatusOptions: Array<string> };

export type GetMovablesQueryVariables = Exact<{
  case?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  debitors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onlyCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMovablesQuery = { __typename?: 'Query', movables: Array<{ __typename?: 'Movable', id: string, description: string, volume: number, completed: boolean, status: string, version: number, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }, placement: { __typename?: 'MovablesLocation', id: string, name: string, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, changes: Array<{ __typename?: 'MovableChange', timestamp: string, user: { __typename?: 'User', id: string, name: string, email: string }, before: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null }, after: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null } }> }> };

export type GetMovablesOverviewExcelQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMovablesOverviewExcelQuery = { __typename?: 'Query', movableExcelOverview: Array<any> };

export type UpdateMovableMutationVariables = Exact<{
  id: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type UpdateMovableMutation = { __typename?: 'Mutation', updateMovable: { __typename?: 'Movable', id: string, description: string, volume: number, completed: boolean, status: string, version: number, case: { __typename?: 'Case', id: string, erpNo: string }, placement: { __typename?: 'MovablesLocation', id: string, name: string, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, changes: Array<{ __typename?: 'MovableChange', timestamp: string, user: { __typename?: 'User', id: string, name: string, email: string }, before: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null }, after: { __typename?: 'MovableChangeDifference', description: string | null, volume: number | null, completed: boolean | null, status: string | null, placement: { __typename?: 'MovablesLocation', id: string, name: string } | null } }> } };

export type ItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', no: string, description: string, type: string, baseUOM: string }> | null };

export type ResourcesQueryVariables = Exact<{
  ressourceType: Scalars['String']['input'];
}>;


export type ResourcesQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Resource', no: string, name: string, type: string, baseUOM: string }> | null };

export type GetSamplePriceForOfferQueryVariables = Exact<{
  offer: OfferInput;
}>;


export type GetSamplePriceForOfferQuery = { __typename?: 'Query', samplePriceForOffer: { __typename?: 'SamplePriceResult', totalCost: number, lineAmount: number } };

export type WorkTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkTypesQuery = { __typename?: 'Query', workTypes: Array<{ __typename?: 'WorkType', systemId: string | null, description: string, code: string, uOM: string }> | null };

export type ChangeCarOnCalendarEventMutationVariables = Exact<{
  carId: Scalars['String']['input'];
  event: CalendarEventInput;
  originalEventId: Scalars['String']['input'];
  originalCarId: Scalars['String']['input'];
}>;


export type ChangeCarOnCalendarEventMutation = { __typename?: 'Mutation', changeCarOnCalendarEvent: { __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null } };

export type ChangeUserOnCalendarEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  event: CalendarEventInput;
  originalEventId: Scalars['String']['input'];
  originalUserId: Scalars['String']['input'];
}>;


export type ChangeUserOnCalendarEventMutation = { __typename?: 'Mutation', changeUserOnCalendarEvent: { __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null } };

export type CreateCarCalendarEventMutationVariables = Exact<{
  carId: Scalars['String']['input'];
  event: CalendarEventInput;
}>;


export type CreateCarCalendarEventMutation = { __typename?: 'Mutation', createCarCalendarEvent: { __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null } };

export type CreateUserCalendarEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  event: CalendarEventInput;
}>;


export type CreateUserCalendarEventMutation = { __typename?: 'Mutation', createUserCalendarEvent: { __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null } };

export type DeleteCarCalendarEventMutationVariables = Exact<{
  carId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  drivingSlipId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCarCalendarEventMutation = { __typename?: 'Mutation', deleteCarCalendarEvent: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null };

export type DeleteUserCalendarEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  drivingSlipId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteUserCalendarEventMutation = { __typename?: 'Mutation', deleteUserCalendarEvent: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, skafor: boolean, riskEvaluationComment: string | null, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, areaResponsible: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', name: string, phone: string | null, email: string } | null, ssgLocation: { __typename?: 'Location', id: string, name: string, movables: boolean, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, ssgDepartment: { __typename?: 'Department', id: string, name: string, departmentNumber: number, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } }, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null, visitation: { __typename?: 'Visitation', urgent: boolean, priorities: Array<CasePriority>, regress: boolean | null, calledBack: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, awaiting: { __typename?: 'BoolWithComment', timestamp: string | null, value: boolean, comment: string | null }, answers: Array<{ __typename?: 'Answer', question: string, answer: string, title: string }> | null } }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null };

export type GetCarCalendarsQueryVariables = Exact<{
  carIdList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateRange: DateRangeInput;
}>;


export type GetCarCalendarsQuery = { __typename?: 'Query', carCalendars: Array<{ __typename?: 'CarCalendar', car: { __typename?: 'Car', id: string, name: string, department: string | null, email: string }, events: Array<{ __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null }> }> };

export type GetCarsWithCalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCarsWithCalendarsQuery = { __typename?: 'Query', carsWithCalendars: Array<{ __typename?: 'Car', id: string, name: string, department: string | null, email: string }> };

export type GetUserCalendarsQueryVariables = Exact<{
  userIdList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateRange: DateRangeInput;
}>;


export type GetUserCalendarsQuery = { __typename?: 'Query', userCalendars: Array<{ __typename?: 'UserCalendar', user: { __typename?: 'User', plannerHelpText: string | null, plannerHelpTextUpdatedAt: string | null, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, events: Array<{ __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null }> }> };

export type GetUsersWithCalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersWithCalendarsQuery = { __typename?: 'Query', usersWithCalendars: Array<{ __typename?: 'User', plannerHelpText: string | null, plannerHelpTextUpdatedAt: string | null, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }> };

export type UpdateCarCalendarEventMutationVariables = Exact<{
  carId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  event: CalendarEventInput;
}>;


export type UpdateCarCalendarEventMutation = { __typename?: 'Mutation', updateCarCalendarEvent: { __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null } };

export type UpdateUserCalendarEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  event: CalendarEventInput;
}>;


export type UpdateUserCalendarEventMutation = { __typename?: 'Mutation', updateUserCalendarEvent: { __typename: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, version: number, updatedAt: string, createdAt: string, passenger: boolean, halfDay: boolean, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, questionnaireCompletionStatus: QuestionnaireCompletionStatus, facadePictureTaken: boolean | null, drivingStarted: string | null, eventReferenceId: string | null, noWasteUsed: boolean, noMaterialUsed: boolean, plannerMessage: string | null, starDrivenKM: number | null, actualDrivenKM: number | null, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null } }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null }, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, questionnaire: { __typename?: 'DrivingSlipQuestionnaireType', id: string, sourceTemplateId: string, sourceTemplateVersion: number, updatedAt: string, template: { __typename?: 'DrivingSlipQuestionnaireTemplate', label: string, damageCauses: Array<string>, drivingSlipCategories: Array<string>, sections: Array<{ __typename?: 'QuestionnaireSection', label: string, photoRequired: boolean, shouldSaveInScalePoint: boolean, caseAgreementCategory: CaseAgreementCategory, choices: Array<{ __typename?: 'QuestionnaireChoice', id: string, parentId: string, type: QuestionnaireChoiceType, label: string, value: string | null, placeholder: string | null, helpText: string | null, isOptional: boolean, triggersTrackTwoChange: boolean, unitOfMeasure: string | null, isMultiSelectAllowed: boolean, multiSelectValues: Array<string> | null }> }> } } | null, changes: Array<{ __typename?: 'DrivingSlipChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null }, after: { __typename?: 'DrivingSlipChangeDifference', locked: boolean | null, status: DrivingSlipStatus | null, urgent: boolean | null, fileNames: string | null, start: string | null, eventReferenceId: string | null, end: string | null, comment: string | null, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }> | null } }>, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number } } | null } };

export type AddCarOrMaterialsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  car?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddCarOrMaterialsMutation = { __typename?: 'Mutation', addCarOrMaterials: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } };

export type ChangeUserOnEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  event: CalendarEventInput;
  originalEventId: Scalars['String']['input'];
  originalUserId: Scalars['String']['input'];
}>;


export type ChangeUserOnEventMutation = { __typename?: 'Mutation', changeUserOnCalendarEvent: { __typename?: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null } };

export type CreateCalendarEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  event: CalendarEventInput;
}>;


export type CreateCalendarEventMutation = { __typename?: 'Mutation', createUserCalendarEvent: { __typename?: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null } };

export type CreateDrivingSlipNewPlannerMutationVariables = Exact<{
  drivingSlip: DrivingSlipHelperInput;
  caseId: Scalars['String']['input'];
}>;


export type CreateDrivingSlipNewPlannerMutation = { __typename?: 'Mutation', createDrivingSlip: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }> };

export type DeleteCalendarEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  drivingSlipId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCalendarEventMutation = { __typename?: 'Mutation', deleteUserCalendarEvent: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null };

export type DrivingSlipNewPlannerFragment = { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } };

export type EventFragment = { __typename?: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null };

export type GetCalendarsQueryVariables = Exact<{
  userIdList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateRange: DateRangeInput;
}>;


export type GetCalendarsQuery = { __typename?: 'Query', userCalendars: Array<{ __typename?: 'UserCalendar', user: { __typename?: 'User', plannerHelpText: string | null, plannerHelpTextUpdatedAt: string | null, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, events: Array<{ __typename?: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null }> }> };

export type GetDrivingSlipsNewPlannerQueryVariables = Exact<{
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<DrivingSlipStatus>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  exceeded?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivingSlipCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  drivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minStartDate?: InputMaybe<Scalars['Date']['input']>;
  maxStartDate?: InputMaybe<Scalars['Date']['input']>;
  minEndDate?: InputMaybe<Scalars['Date']['input']>;
  maxEndDate?: InputMaybe<Scalars['Date']['input']>;
  noDriver?: InputMaybe<Scalars['Boolean']['input']>;
  case?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDrivingSlipsNewPlannerQuery = { __typename?: 'Query', plannerDrivingSlips: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }> };

export type RemoveCarFromDrivingSlipMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveCarFromDrivingSlipMutation = { __typename?: 'Mutation', removeCar: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } };

export type RemoveMaterialFromDrivingSlipMutationVariables = Exact<{
  id: Scalars['String']['input'];
  material: Scalars['String']['input'];
}>;


export type RemoveMaterialFromDrivingSlipMutation = { __typename?: 'Mutation', removeMaterial: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } };

export type SetDrivingSlipStatusNewPlannerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: DrivingSlipStatus;
}>;


export type SetDrivingSlipStatusNewPlannerMutation = { __typename?: 'Mutation', setDrivingSlipStatus: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } };

export type UpdateCalendarEventMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  event: CalendarEventInput;
}>;


export type UpdateCalendarEventMutation = { __typename?: 'Mutation', updateUserCalendarEvent: { __typename?: 'CalendarEvent', referenceId: string, title: string, type: CalendarEventType, isAllDay: boolean, systemCreatedEvent: boolean, timeRange: { __typename?: 'DateTimeRange', from: string, to: string }, drivingSlip: { __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null } };

export type UpdateWebDrivingSlipNewPlannerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  driver?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  additionalDays?: InputMaybe<Array<AdditionalDayInput> | AdditionalDayInput>;
  additionalDrivers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  location: Scalars['String']['input'];
  department: Scalars['String']['input'];
  driverCarList?: InputMaybe<Array<DriverCarInput> | DriverCarInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  immediatelyPlan?: InputMaybe<Scalars['Boolean']['input']>;
  plannerMessage?: InputMaybe<Scalars['String']['input']>;
  car?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  halfDay?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateWebDrivingSlipNewPlannerMutation = { __typename?: 'Mutation', updateDrivingSlip: Array<{ __typename?: 'DrivingSlip', id: string, series: string, locked: boolean, status: DrivingSlipStatus, urgent: boolean, estimatedHours: number | null, start: string, end: string, deadline: string | null, comment: string | null, category: string | null, riskEvaluationStatus: RiskEvaluationStatus, createdAt: string, version: number, plannerMessage: string | null, eventReferenceId: string | null, passenger: boolean, halfDay: boolean, car: { __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string } | null, materials: Array<{ __typename?: 'Vehicle', vehicleNumber: string, locationCode: string, registrationNumber: string, departmentCode: string, brand: string | null, username: string | null, user: string | null, vehicleCategory: string }>, driver: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, location: { __typename?: 'Location', id: string, name: string }, department: { __typename?: 'Department', id: string, name: string, departmentNumber: number }, case: { __typename?: 'Case', id: string, status: CaseStatus, erpId: string, erpNo: string, track: number, skafor: boolean, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, projectManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, caseManager: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, createdBy: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null } | null, policyHolder: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } }> };

export type CreateCaseOrganizationReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: CaseOrganizationFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateCaseOrganizationReportMutation = { __typename?: 'Mutation', createCaseOrganizationReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateDeviationReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: DeviationReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateDeviationReportMutation = { __typename?: 'Mutation', createDeviationReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateEndevaluationReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: EndevaluationReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateEndevaluationReportMutation = { __typename?: 'Mutation', createEndevaluationReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateInspectionAssesmentReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: InspectionAssesmentFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateInspectionAssesmentReportMutation = { __typename?: 'Mutation', createInspectionAssesmentReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateNoticeOfConstructionwasteReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: NoticeOfConstructionwasteFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateNoticeOfConstructionwasteReportMutation = { __typename?: 'Mutation', createNoticeOfConstructionwasteReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateWebDamageReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreateWebDamageReportMutation = { __typename?: 'Mutation', createDamageReport: { __typename?: 'ESDHFile', name: string, url: string, fileId: string } };

export type CreateWebInspectionMovablesReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: InspectionReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateWebInspectionMovablesReportMutation = { __typename?: 'Mutation', createInspectionMovablesReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateWebInspectionReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: InspectionReportFormDataInput;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateWebInspectionReportMutation = { __typename?: 'Mutation', createInspectionReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateWebMoistureReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: MoistureReportFormDataInput;
  reportFormat: ReportFormatType;
  floorsToInclude?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateWebMoistureReportMutation = { __typename?: 'Mutation', createMoistureReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type CreateWebMoistureTrygReportMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  formData: MoistureTrygReportFormDataInput;
  reportFormat: ReportFormatType;
  floorsToInclude?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onlySave: Scalars['Boolean']['input'];
}>;


export type CreateWebMoistureTrygReportMutation = { __typename?: 'Mutation', createMoistureTrygReport: { __typename?: 'ESDHFile', name: string, fileId: string } | null };

export type GetCaseAsbestosReportsAndDocumentsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseAsbestosReportsAndDocumentsQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, erpNo: string, documents: Array<{ __typename?: 'ESDHFile', name: string, url: string, thumbnail: string, extension: string, groupingKey: string, created: string, comments: string | null, fileId: string, metadata: Array<{ __typename?: 'StringKVP', key: string, value: string }> }>, caseAsbestosReports: { __typename?: 'CaseAsbestosReports', noticeOfConstructionWasteFormData: { __typename?: 'NoticeOfConstructionwasteFormData', area: string | null, assignment: string | null, wasteFractions: string | null, wastePackaging: string | null, carrier: string | null, yearOfConstruction: string | null, startDate: string | null, endDate: string | null } | null, inspectionAssesmentFormData: { __typename?: 'InspectionAssesmentFormData', assesments: Array<{ __typename?: 'Assesment', id: number, color: AssesmentColor, comment: string, deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, reportDate: string } | null }> | null, signatures: Array<{ __typename?: 'Signature', signatureDate: string | null, index: number | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null> | null } | null, caseOrganizationFormData: { __typename?: 'CaseOrganizationFormData', caseOrganizationWorkers: Array<{ __typename?: 'CaseOrganizationWorker', index: number, title: string, name: string, phonenumber: string, date: string | null, instructor: string, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null> | null } | null, endevaluationReportFormData: { __typename?: 'EndevaluationReportFormData', evaluationCategories: Array<{ __typename?: 'EvaluationCategories', index: number, title: string, evaluations: Array<{ __typename?: 'Evaluation', index: number, question: string, answer: EvaluationEnum, remark: string } | null> | null }> | null, deviations: Array<{ __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string }> | null, signature: { __typename?: 'Signature', index: number | null, signatureDate: string | null, signatureDetails: { __typename?: 'ReportFile', fileName: string, description: string } | null } | null } | null, deviationReportFormData: { __typename?: 'DeviationReportFormData', deviation: { __typename?: 'Deviation', severityLevel: DeviationColor, description: string, cause: string, action: string, actionDate: string | null, actionResponsible: string, relatedEvaluationQuestion: string | null, relatedEvaluationCategory: string | null, reportDate: string } } | null } | null } };

export type CreateDrivingSlipRequisitionMutationVariables = Exact<{
  drivingSlipId: Scalars['String']['input'];
  requisition: RequisitionInput;
  shouldSendEmail: Scalars['Boolean']['input'];
}>;


export type CreateDrivingSlipRequisitionMutation = { __typename?: 'Mutation', createDrivingSlipRequisition: { __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } } };

export type GetWebRequisitionsQueryVariables = Exact<{
  myRequisitionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RequisitionType>;
  damageCategories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  damageCauses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  excludeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWebRequisitionsQuery = { __typename?: 'Query', requisitions: Array<{ __typename?: 'Requisition', id: string, description: string, orderNumber: string, type: RequisitionType, status: boolean, createdAt: string, vendorEmail: string | null, vendorPhoneNumber: string, vendorName: string, case: { __typename?: 'Case', id: string, erpNo: string, debitor: { __typename?: 'Debitor', debitorId: string, company: string, unknown: boolean }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string, id: string }, cause: { __typename?: 'DamageCause', name: string, id: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } } } } | null, department: { __typename?: 'Department', id: string, name: string } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string, case: { __typename?: 'Case', id: string, erpNo: string, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', name: string }, cause: { __typename?: 'DamageCause', name: string } } } } | null, vendor: { __typename?: 'Vendor', erpReferenceNo: string, company: string | null, email: string | null, phone: string | null, vendorPostingGroup: string, ssgDepartment: string, ssgLocation: string, type: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, phone: string | null, email: string } }> };

export type GetRiskEvalutaionAnswersQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRiskEvalutaionAnswersQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, riskEvaluationAnswers: Array<{ __typename?: 'RiskEvaluationAnswers', answer: boolean, question: { __typename?: 'RiskEvaluationQuestion', id: string, question: string } }> | null } };

export type CreateScreeningMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  template: Scalars['String']['input'];
  name: Scalars['String']['input'];
  lines: Array<ScreeningLineInputType> | ScreeningLineInputType;
  wipAmount: Scalars['Decimal']['input'];
}>;


export type CreateScreeningMutation = { __typename?: 'Mutation', createScreening: { __typename?: 'EmptyReturn', _: string } | null };

export type DeleteScreeningMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  screeningERPReferenceNo: Scalars['String']['input'];
  wipAmount: Scalars['Decimal']['input'];
}>;


export type DeleteScreeningMutation = { __typename?: 'Mutation', deleteScreening: { __typename?: 'EmptyReturn', _: string } | null };

export type GetScreeningsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetScreeningsQuery = { __typename?: 'Query', case: { __typename?: 'Case', id: string, createdAt: string, caseDefaultScreeningTemplate: string, screenings: Array<{ __typename?: 'Screening', erpReferenceId: string | null, erpReferenceNo: string | null, templateId: string, templateCode: string, templateName: string, description: string, markedForInvoice: boolean, reopenAllowed: boolean, lines: Array<{ __typename?: 'ScreeningLine', erpReferenceId: string, id: number, parentId: number | null, position: string | null, type: ScreeningLineType, index: number, title: string, allowCustomTitle: boolean, showCalendar: boolean, uom: string, price: number, linePremiumPercentage: number | null, linePremiumFixedAmount: number | null, linePremiumId: number | null, value: number | null, customTitle: string | null, movableVolume: number | null, movableDays: number | null, movableDateFrom: string | null, movableDateTo: string | null, excludeFromEnvFee: boolean | null, excludeFromSupplyFee: boolean | null }> }> } };

export type GetWebScreeningPositionTextsQueryVariables = Exact<{
  positions: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetWebScreeningPositionTextsQuery = { __typename?: 'Query', screeningPositionTexts: Array<{ __typename?: 'ScreeningPositionText', id: string, position: string, text: string }> };

export type GetWebScreeningTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebScreeningTemplatesQuery = { __typename?: 'Query', screeningTemplates: Array<{ __typename?: 'Screening', erpReferenceId: string | null, templateCode: string, templateName: string, lines: Array<{ __typename?: 'ScreeningLine', erpReferenceId: string, id: number, parentId: number | null, position: string | null, erpReferenceTask: string, erpReferenceAccount: string, required: boolean, type: ScreeningLineType, index: number, title: string, allowCustomTitle: boolean, uom: string, price: number, linePremiumPercentage: number | null, linePremiumFixedAmount: number | null, linePremiumId: number | null, showCalendar: boolean, excludeFromEnvFee: boolean | null, excludeFromSupplyFee: boolean | null }> }> };

export type UnlockScreeningMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  screeningERPReferenceNo: Scalars['String']['input'];
}>;


export type UnlockScreeningMutation = { __typename?: 'Mutation', unlockScreening: { __typename?: 'EmptyReturn', _: string } | null };

export type UpdateScreeningMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  screeningERPReferenceNo: Scalars['String']['input'];
  name: Scalars['String']['input'];
  lines: Array<ScreeningLineInputType> | ScreeningLineInputType;
  wipAmount: Scalars['Decimal']['input'];
}>;


export type UpdateScreeningMutation = { __typename?: 'Mutation', updateScreening: { __typename?: 'EmptyReturn', _: string } | null };

export type GetAdminSettingsQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetAdminSettingsQuery = { __typename?: 'Query', setting: Array<{ __typename?: 'BCSettings' } | { __typename?: 'CatalogNotificationSetting' } | { __typename?: 'DrivingSlipCategoryMappingSettings', id: string, type: string, drivingSlipCategoryMappings: Array<{ __typename?: 'DrivingSlipCategoryMapping', drivingSlipCategory: string, damageCategoryId: string, damageCauseId: string }> } | { __typename?: 'In4moSettings' } | { __typename?: 'InvoiceSettings', id: string, minHourlyRate: number } | { __typename?: 'MachineNotificationSetting' } | { __typename?: 'SMSSettings' } | { __typename?: 'SPSettings' } | { __typename?: 'SmtpSettings' }> };

export type GetManagerClosedDayUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagerClosedDayUserListQuery = { __typename?: 'Query', closedDayManagerList: Array<{ __typename?: 'TimeTrackingUserDayClose', date: string, user: { __typename?: 'User', id: string, name: string, email: string, phone: string | null } }> };

export type GetManagerFlexTimeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagerFlexTimeListQuery = { __typename?: 'Query', flexTimeManagerList: Array<{ __typename?: 'TimeTrackingUserFlexTime', flexTime: number, user: { __typename?: 'User', id: string, name: string, email: string, phone: string | null } }> };

export type GetWebCasesForTimeTrackingQueryVariables = Exact<{
  erpReferenceNos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  appliedClosed?: InputMaybe<Scalars['Boolean']['input']>;
  closedCases?: InputMaybe<Scalars['Boolean']['input']>;
  includeEconomy: Scalars['Boolean']['input'];
}>;


export type GetWebCasesForTimeTrackingQuery = { __typename?: 'Query', cases: Array<{ __typename?: 'Case', id: string, erpNo: string, track: number, timeRegistration: boolean | null, debitor: { __typename?: 'Debitor', id: string, type: DebitorType, debitorId: string, company: string, attention: string | null, excess: number | null, policeNumber: string, cvrNumber: string, gln: string | null, phone: string | null, email: string | null, defaultScreeningTemplate: string | null, assortmentCode: string | null, unknown: boolean, createInECB: boolean, callCenterActive: boolean, debitorGroup: string | null, environmentFeePercentage: number, maxEnvironmentFeeAmount: number, priorityCustomer: boolean, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } | null, shippingAddress: { __typename?: 'DebitorShipmentAddress', id: string, gln: string, address: { __typename?: 'AddressSimple', addressLine: string | null, addressLineAlt: string | null, city: string, postalCode: string, country: string } } | null, billingAddress: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } | null }, damage: { __typename?: 'Damage', date: string, description: string, accessConditions: string, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string, track: number, urgent: boolean, businessArea: { __typename?: 'BusinessArea', id: string, name: string }, category: { __typename?: 'DamageCategory', id: string, name: string }, departments: Array<{ __typename?: 'Department', id: string, departmentNumber: number, name: string, location: { __typename?: 'Location', id: string, name: string } } | null> | null }, contact: { __typename?: 'Contact', name: string, phone: string, email: string, address: { __typename?: 'Address', road: string, houseNumber: string, floor: string | null, addressLine: string | null, addressLineAlt: string | null, postalCode: string, city: string, country: string } }, contacts: Array<{ __typename?: 'DamageContact', name: string, role: string, phone: string | null, email: string | null }> }, caseEconomics: { __typename?: 'CaseEconomicsOverview', jobNo: string, costTotal: number, salesTotal: number, invoicedTotal: number, quote: number, screening: number, profit: number, deltaNotInvoiced: number, coverageRatio: number } | null }> };

export type OpenRejectedDayMutationVariables = Exact<{
  userEmail: Scalars['String']['input'];
  date: Scalars['Date']['input'];
}>;


export type OpenRejectedDayMutation = { __typename?: 'Mutation', openRejectedDay: Array<{ __typename?: 'TimeTracking', id: string, createdAt: string, date: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, addonLines: Array<{ __typename?: 'TimeTracking', id: string, date: string, hours: number, remark: string | null, jobTaskNo: string, onCall: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, trackingType: TrackingType, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', company: string } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null }> | null }> };

export type OpenTimeRegistrationsOnCaseQueryVariables = Exact<{
  caseERPReferenceNo: Scalars['String']['input'];
}>;


export type OpenTimeRegistrationsOnCaseQuery = { __typename?: 'Query', openTimeRegistrationsOnCase: boolean };

export type AppendTimeTrackingSupplementMutationVariables = Exact<{
  timeTrackingDayId: Scalars['String']['input'];
  timeTrackingEntryId: Scalars['String']['input'];
  timeTrackingSupplement: TimeTrackingSupplementUpdateInputType;
}>;


export type AppendTimeTrackingSupplementMutation = { __typename?: 'Mutation', appendTimeTrackingSupplement: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } };

export type BaseTimeTrackingEntryFragment = { __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> };

export type CreateTimeTrackingDayMutationVariables = Exact<{
  timeTrackingDay: TimeTrackingDayInputType;
  timeTrackingEntry: TimeTrackingEntryInputType;
}>;


export type CreateTimeTrackingDayMutation = { __typename?: 'Mutation', createTimeTrackingDay: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus | null, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } };

export type DeleteTimeTrackingDayMutationVariables = Exact<{
  dayId: Scalars['String']['input'];
}>;


export type DeleteTimeTrackingDayMutation = { __typename?: 'Mutation', deleteTimeTrackingDay: string | null };

export type DeleteTimeTrackingDayEntryMutationVariables = Exact<{
  dayId: Scalars['String']['input'];
  entryId: Scalars['String']['input'];
}>;


export type DeleteTimeTrackingDayEntryMutation = { __typename?: 'Mutation', deleteTimeTrackingDayEntry: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } | null };

export type DeleteTimeTrackingEntrySupplementMutationVariables = Exact<{
  dayId: Scalars['String']['input'];
  entryId: Scalars['String']['input'];
  supplementId: Scalars['String']['input'];
}>;


export type DeleteTimeTrackingEntrySupplementMutation = { __typename?: 'Mutation', deleteTimeTrackingEntrySupplement: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } | null };

export type GetTimeTrackingDayLatestByUserQueryVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type GetTimeTrackingDayLatestByUserQuery = { __typename?: 'Query', timeTrackingDayLatestByUser: { __typename?: 'TimeTrackingDay', id: string, timeTrackingDayStatus: TimeTrackingDayStatus, date: string } | null };

export type GetManagerTimeTrackingClosedDayUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagerTimeTrackingClosedDayUserListQuery = { __typename?: 'Query', timeTrackingClosedDayManagerList: Array<{ __typename?: 'TimeTrackingUserDayClose', date: string, user: { __typename?: 'User', id: string, name: string, email: string, phone: string | null } }> };

export type GetManagerTimeTrackingRejectedDayUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagerTimeTrackingRejectedDayUserListQuery = { __typename?: 'Query', timeTrackingRejectedDaysManagerList: Array<{ __typename?: 'TimeTrackingDay', date: string, user: { __typename?: 'User', id: string, name: string, email: string, phone: string | null } }> };

export type GetTimeTrackingDayClosedByUserQueryVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type GetTimeTrackingDayClosedByUserQuery = { __typename?: 'Query', timeTrackingDayClosedByUser: { __typename?: 'TimeTrackingDay', id: string, timeTrackingDayStatus: TimeTrackingDayStatus, date: string, user: { __typename?: 'User', id: string } } | null };

export type GetTimeTrackingDaysQueryVariables = Exact<{
  timeTrackingDayStatus?: InputMaybe<TimeTrackingDayStatus>;
  minDate: Scalars['Date']['input'];
  maxDate: Scalars['Date']['input'];
  users?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetTimeTrackingDaysQuery = { __typename?: 'Query', timeTrackingDays: Array<{ __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> }> };

export type GetTimeTrackingEntryLogQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTimeTrackingEntryLogQuery = { __typename?: 'Query', timeTrackingEntryLog: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> };

export type GetTimeTrackingsDayForUserQueryVariables = Exact<{
  user: Scalars['String']['input'];
  minDate?: InputMaybe<Scalars['Date']['input']>;
  maxDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetTimeTrackingsDayForUserQuery = { __typename?: 'Query', timeTrackingsDayForUser: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus | null, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } | null };

export type GetTimeTrackingsInBcWithoutApprovalQueryVariables = Exact<{
  erpNo: Scalars['String']['input'];
}>;


export type GetTimeTrackingsInBcWithoutApprovalQuery = { __typename?: 'Query', timeTrackingsInBcWithoutApproval: Array<{ __typename?: 'TimeTrackingEntry', id: string, startDate: string, hours: number, jobTaskName: string | null, startTime: string, endTime: string, emploeeResponsible: TimeTrackingStatus, projectApprovalStatus: TimeTrackingStatus, user: { __typename?: 'User', name: string } }> };

export type GetflexTimeManagerListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetflexTimeManagerListQuery = { __typename?: 'Query', flexTimeManagerList: Array<{ __typename?: 'TimeTrackingUserFlexTime', flexTime: number, user: { __typename?: 'User', id: string, name: string, email: string, phone: string | null } }> };

export type GetrejectedTimeTrackingsDayForUserQueryVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type GetrejectedTimeTrackingsDayForUserQuery = { __typename?: 'Query', rejectedTimeTrackingsDayForUser: Array<{ __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus | null, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> }> };

export type OpenRejectedTimeTrackingDayMutationVariables = Exact<{
  userEmail: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  dayId: Scalars['String']['input'];
}>;


export type OpenRejectedTimeTrackingDayMutation = { __typename?: 'Mutation', openRejectedTimeTrackingDay: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } };

export type ReopenTimeTrackingDayMutationVariables = Exact<{
  timeTrackingDay: TimeTrackingDayInputType;
}>;


export type ReopenTimeTrackingDayMutation = { __typename?: 'Mutation', reopenTimeTrackingDay: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } | null };

export type SubmitTimeTrackingDayMutationVariables = Exact<{
  timeTrackingDay: TimeTrackingDayInputType;
}>;


export type SubmitTimeTrackingDayMutation = { __typename?: 'Mutation', submitTimeTrackingDay: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } | null };

export type BaseSupplementFragment = { __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null };

export type TimeTrackingDayFragment = { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, bcStatus: TimeTrackingStatus | null, timeTrackingStatus: TimeTrackingStatus, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> };

export type UpdateTimeTrackingDayEntryMutationVariables = Exact<{
  timeTrackingDayId: Scalars['String']['input'];
  timeTrackingEntry: TimeTrackingEntryUpdateInputType;
}>;


export type UpdateTimeTrackingDayEntryMutation = { __typename?: 'Mutation', updateTimeTrackingDayEntry: { __typename?: 'TimeTrackingDay', id: string, createdAt: string, timeTrackingDayStatus: TimeTrackingDayStatus, userId: string, date: string, totalHours: number, overtimeHours: number, isPartOfRange: boolean, rangeStartDate: string | null, rangeEndDate: string | null, user: { __typename?: 'User', id: string, name: string, employeeId: string | null }, timeTrackingEntries: Array<{ __typename?: 'TimeTrackingEntry', id: string, createdAt: string, userId: string, startDate: string, endDate: string, startTime: string, endTime: string, hours: number, jobNo: string | null, remark: string | null, jobTaskNo: string, onCall: boolean, onCallback: boolean, includesLunch: boolean, task: TimeTrackingEntryTask, jobTaskName: string | null, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus | null, rejectMessage: string | null, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, lastModifiedAt: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string }, damage: { __typename?: 'Damage', category: { __typename?: 'DamageCategory', id: string, name: string }, cause: { __typename?: 'DamageCause', id: string, name: string }, contact: { __typename?: 'Contact', address: { __typename?: 'Address', road: string, houseNumber: string, postalCode: string, city: string } } } } | null, drivingSlip: { __typename?: 'DrivingSlip', id: string } | null, lastModifiedBy: { __typename?: 'User', id: string, name: string } | null, addonLines: Array<{ __typename?: 'TimeTrackingSupplement', id: string, createdAt: string, userId: string, date: string, hours: number, remark: string | null, jobTaskNo: string, jobNo: string | null, jobTaskName: string | null, onCall: boolean, onCallback: boolean, workTypeCode: string, timeTrackingStatus: TimeTrackingStatus, bcStatus: TimeTrackingStatus, pieceworkAmount: number | null, supplementType: SupplementType | null, paymentSupplementCode: string | null, paymentSupplementName: string | null, supplementUom: string | null, rejectMessage: string | null, user: { __typename?: 'User', id: string, name: string }, case: { __typename?: 'Case', id: string, erpId: string, erpNo: string, debitor: { __typename?: 'Debitor', id: string, company: string } } | null }> }> } };

export type AddCatalogToTimedMessageMutationVariables = Exact<{
  timedMessageId: Scalars['String']['input'];
  catalogId: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
}>;


export type AddCatalogToTimedMessageMutation = { __typename?: 'Mutation', addCatalogToTimedMessage: { __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } } };

export type CreateTimedMessageMutationVariables = Exact<{
  timedMessage: TimedMessageInput;
}>;


export type CreateTimedMessageMutation = { __typename?: 'Mutation', createTimedMessage: { __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } } };

export type DeleteTimedMessageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
}>;


export type DeleteTimedMessageMutation = { __typename?: 'Mutation', deleteTimedMessage: string };

export type GetTimedMessageChangesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTimedMessageChangesQuery = { __typename?: 'Query', timedMessage: { __typename?: 'TimedMessage', id: string, changes: Array<{ __typename?: 'TimedMessageChange', timestamp: string, user: { __typename?: 'User', id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }, before: { __typename?: 'TimedMessageChangeDifference', changedBy: string | null, startTime: string | null, endTime: string | null, message: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null }, after: { __typename?: 'TimedMessageChangeDifference', changedBy: string | null, startTime: string | null, endTime: string | null, message: string | null, global: boolean | null, globalType: CatalogGlobalType | null, active: boolean | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } | null, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null } }> } };

export type GetTimedMessagesQueryVariables = Exact<{
  globalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  thisCustomerOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTimedMessagesQuery = { __typename?: 'Query', timedMessages: Array<{ __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, catalogs: Array<{ __typename?: 'Catalog', id: string, propertyNumber: string, addresses: Array<{ __typename?: 'CatalogAddress', addressLine: string, zipCode: string, city: string, startNumber: string, endNumber: string, houseNumbers: HouseNumbers, comment: string }> }> | null, customer: { __typename?: 'CatalogCustomer', id: string, name: string } }> };

export type GetTimedMessagesForAddExcistingQueryVariables = Exact<{
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  notGlobalOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTimedMessagesForAddExcistingQuery = { __typename?: 'Query', timedMessages: Array<{ __typename?: 'TimedMessage', id: string, startTime: string, endTime: string, message: string }> };

export type UpdateTimedMessageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
  message: Scalars['String']['input'];
  global: Scalars['Boolean']['input'];
  active: Scalars['Boolean']['input'];
  globalType: CatalogGlobalType;
  catalogs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  action: FileActionType;
  catalogsBefore?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateTimedMessageMutation = { __typename?: 'Mutation', updateTimedMessage: { __typename?: 'TimedMessage', id: string, changedBy: string, startTime: string, endTime: string, message: string, global: boolean, globalType: CatalogGlobalType, active: boolean, version: number, catalogIds: Array<string>, customer: { __typename?: 'CatalogCustomer', id: string, name: string } } };

export type GetUserFlexTimeQueryVariables = Exact<{
  user: Scalars['String']['input'];
}>;


export type GetUserFlexTimeQuery = { __typename?: 'Query', userFlexTime: number | null };

export type GetWebCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', defaultLanguage: string | null, permissions: Array<Permissions>, external: boolean, employeeHireStartDate: string | null, employeeSalaryType: string | null, managerFor: Array<string>, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, gdpr: { __typename?: 'GDPR', id: string, timestamp: string, userId: { __typename?: 'User', id: string } } | null, caseFilters: Array<{ __typename?: 'UserCaseFilter', key: string, name: string, view: UserCaseFilterViewType, awaiting: boolean | null, damageServiceCompleted: boolean | null, calledBack: boolean | null, machinesOnCase: boolean | null, showEconomyField: boolean, showBusinessAreaField: boolean, showAppliedClosedCases: boolean, showClosedCases: boolean, debitors: Array<string>, postalCodeText: string, postalCodes: Array<string>, track: Array<number>, departments: Array<string>, locations: Array<string>, damageCategories: Array<string>, damageCauses: Array<string>, priority: Array<CasePriority>, caseManagers: Array<string>, projectManagers: Array<string>, areaResponsibles: Array<string>, createdBy: Array<string> }>, drivingSlipFilters: Array<{ __typename?: 'UserDrivingSlipFilter', key: string, name: string, debitors: Array<string>, postalCodeText: string, postalCodes: Array<string>, departments: Array<string>, locations: Array<string>, damageCategories: Array<string>, damageCauses: Array<string>, erpNos: Array<string>, projectManagers: Array<string>, drivingSlipCategories: Array<string> }>, drivingSlipOverviewFilters: Array<{ __typename?: 'UserDrivingSlipOverviewFilter', key: string, name: string, status: DrivingSlipStatus | null, urgent: boolean | null, exceeded: boolean | null, departments: Array<string>, locations: Array<string>, damageCauses: Array<string>, damageCategories: Array<string>, drivers: Array<string>, noDriver: boolean | null }>, sanitizerFilters: Array<{ __typename?: 'UserSanitizerFilter', key: string, name: string, departments: Array<string>, locations: Array<string>, jobFunctions: Array<string>, sanitizers: Array<string> }>, carFilters: Array<{ __typename?: 'UserVehicleFilter', key: string, name: string, locations: Array<string>, cars: Array<string>, departments: Array<string> }>, materialFilters: Array<{ __typename?: 'UserVehicleFilter', key: string, name: string, locations: Array<string>, cars: Array<string>, departments: Array<string> }>, movableFilters: Array<{ __typename?: 'UserMovableFilter', key: string, name: string, erpNo: string, location: string, status: string, includeCompleted: boolean, debitors: Array<string> | null }>, jobFilters: Array<{ __typename?: 'UserJobFilter', key: string, name: string, location: string, personalOnly: boolean }>, machineFilters: Array<{ __typename?: 'UserMachineFilter', name: string, key: string, status: MachineStatus | null, cases: Array<string> | null, locations: Array<string> | null, types: Array<string> | null, unavailable: boolean | null, hibernation: boolean | null }>, proxy: { __typename?: 'User', id: string, name: string, email: string } | null, proxyFor: Array<{ __typename?: 'User', id: string, name: string, email: string }> } | null };

export type RemoveUserCarFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserCarFilterMutation = { __typename?: 'Mutation', removeUserVehicleFilter: { __typename?: 'User', id: string, name: string, email: string, carFilters: Array<{ __typename?: 'UserVehicleFilter', key: string, name: string }> } };

export type RemoveUserCaseFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserCaseFilterMutation = { __typename?: 'Mutation', removeUserCaseFilter: { __typename?: 'User', id: string, name: string, email: string, caseFilters: Array<{ __typename?: 'UserCaseFilter', key: string, name: string }> } };

export type RemoveUserDrivingSlipFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserDrivingSlipFilterMutation = { __typename?: 'Mutation', removeUserDrivingSlipFilter: { __typename?: 'User', id: string, name: string, email: string, drivingSlipFilters: Array<{ __typename?: 'UserDrivingSlipFilter', key: string, name: string }> } };

export type RemoveUserDrivingSlipOverviewFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserDrivingSlipOverviewFilterMutation = { __typename?: 'Mutation', removeUserDrivingSlipOverviewFilter: { __typename?: 'User', id: string, name: string, email: string, drivingSlipOverviewFilters: Array<{ __typename?: 'UserDrivingSlipOverviewFilter', key: string, name: string }> } };

export type RemoveUserJobFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserJobFilterMutation = { __typename?: 'Mutation', removeUserJobFilter: { __typename?: 'User', id: string, name: string, email: string, jobFilters: Array<{ __typename?: 'UserJobFilter', key: string, name: string }> } };

export type RemoveUserMachineFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserMachineFilterMutation = { __typename?: 'Mutation', removeUserMachineFilter: { __typename?: 'User', id: string, name: string, email: string, machineFilters: Array<{ __typename?: 'UserMachineFilter', key: string, name: string }> } };

export type RemoveUserMaterialFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserMaterialFilterMutation = { __typename?: 'Mutation', removeUserMaterialFilter: { __typename?: 'User', id: string, name: string, email: string, materialFilters: Array<{ __typename?: 'UserVehicleFilter', key: string, name: string }> } };

export type RemoveUserMovableFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserMovableFilterMutation = { __typename?: 'Mutation', removeUserMovableFilter: { __typename?: 'User', id: string, name: string, email: string, movableFilters: Array<{ __typename?: 'UserMovableFilter', key: string, name: string }> } };

export type RemoveUserSanitizerFilterMutationVariables = Exact<{
  filterKey: Scalars['String']['input'];
}>;


export type RemoveUserSanitizerFilterMutation = { __typename?: 'Mutation', removeUserSanitizerFilter: { __typename?: 'User', id: string, name: string, sanitizerFilters: Array<{ __typename?: 'UserSanitizerFilter', key: string, name: string, departments: Array<string>, locations: Array<string>, jobFunctions: Array<string>, sanitizers: Array<string> }> } };

export type SearchWebUsersQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  onlyEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  checkInBc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchWebUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', employeeHireStartDate: string | null, employeeSalaryType: string | null, id: string, employeeId: string | null, name: string, department: string | null, area: string | null, jobFunction: string | null, email: string, phone: string | null, defaultLanguage: string | null }> };

export type SetUserCarFilterMutationVariables = Exact<{
  filter: UserVehicleFilterInput;
}>;


export type SetUserCarFilterMutation = { __typename?: 'Mutation', setUserVehicleFilter: { __typename?: 'User', id: string, name: string, carFilters: Array<{ __typename?: 'UserVehicleFilter', key: string, name: string, locations: Array<string>, cars: Array<string> }> } };

export type SetUserCaseFilterMutationVariables = Exact<{
  filter: UserCaseFilterInput;
}>;


export type SetUserCaseFilterMutation = { __typename?: 'Mutation', setUserCaseFilter: { __typename?: 'User', id: string, name: string, caseFilters: Array<{ __typename?: 'UserCaseFilter', key: string, name: string, view: UserCaseFilterViewType, awaiting: boolean | null, damageServiceCompleted: boolean | null, calledBack: boolean | null, machinesOnCase: boolean | null, showEconomyField: boolean, showBusinessAreaField: boolean, showAppliedClosedCases: boolean, showClosedCases: boolean, debitors: Array<string>, postalCodeText: string, postalCodes: Array<string>, track: Array<number>, departments: Array<string>, locations: Array<string>, damageCategories: Array<string>, damageCauses: Array<string>, priority: Array<CasePriority>, caseManagers: Array<string>, projectManagers: Array<string>, areaResponsibles: Array<string>, createdBy: Array<string> }> } };

export type SetUserDrivingSlipFilterMutationVariables = Exact<{
  filter: UserDrivingSlipFilterInput;
}>;


export type SetUserDrivingSlipFilterMutation = { __typename?: 'Mutation', setUserDrivingSlipFilter: { __typename?: 'User', id: string, name: string, drivingSlipFilters: Array<{ __typename?: 'UserDrivingSlipFilter', key: string, name: string, debitors: Array<string>, postalCodeText: string, postalCodes: Array<string>, departments: Array<string>, locations: Array<string>, damageCategories: Array<string>, damageCauses: Array<string>, erpNos: Array<string>, projectManagers: Array<string>, drivingSlipCategories: Array<string> }> } };

export type SetUserDrivingSlipOverviewFilterMutationVariables = Exact<{
  filter: UserDrivingSlipOverviewFilterInput;
}>;


export type SetUserDrivingSlipOverviewFilterMutation = { __typename?: 'Mutation', setUserDrivingSlipOverviewFilter: { __typename?: 'User', id: string, name: string, drivingSlipOverviewFilters: Array<{ __typename?: 'UserDrivingSlipOverviewFilter', key: string, name: string, status: DrivingSlipStatus | null, urgent: boolean | null, exceeded: boolean | null, departments: Array<string>, locations: Array<string>, damageCauses: Array<string>, damageCategories: Array<string>, drivers: Array<string>, noDriver: boolean | null }> } };

export type SetUserJobFilterMutationVariables = Exact<{
  filter: UserJobFilterInput;
}>;


export type SetUserJobFilterMutation = { __typename?: 'Mutation', setUserJobFilter: { __typename?: 'User', id: string, name: string, jobFilters: Array<{ __typename?: 'UserJobFilter', key: string, name: string, location: string, personalOnly: boolean }> } };

export type SetUserMachineFilterMutationVariables = Exact<{
  filter: UserMachineFilterInput;
}>;


export type SetUserMachineFilterMutation = { __typename?: 'Mutation', setUserMachineFilter: { __typename?: 'User', id: string, name: string, machineFilters: Array<{ __typename?: 'UserMachineFilter', key: string, name: string, status: MachineStatus | null, cases: Array<string> | null, locations: Array<string> | null, types: Array<string> | null, unavailable: boolean | null, hibernation: boolean | null }> } };

export type SetUserMaterialFilterMutationVariables = Exact<{
  filter: UserVehicleFilterInput;
}>;


export type SetUserMaterialFilterMutation = { __typename?: 'Mutation', setUserMaterialFilter: { __typename?: 'User', id: string, name: string, materialFilters: Array<{ __typename?: 'UserVehicleFilter', key: string, name: string, locations: Array<string>, cars: Array<string> }> } };

export type SetUserMovableFilterMutationVariables = Exact<{
  filter: UserMovableFilterInput;
}>;


export type SetUserMovableFilterMutation = { __typename?: 'Mutation', setUserMovableFilter: { __typename?: 'User', id: string, name: string, movableFilters: Array<{ __typename?: 'UserMovableFilter', key: string, name: string, erpNo: string, location: string, status: string, includeCompleted: boolean, debitors: Array<string> | null }> } };

export type SetUserPlannerHelpTextMutationVariables = Exact<{
  id: Scalars['String']['input'];
  helpText: Scalars['String']['input'];
}>;


export type SetUserPlannerHelpTextMutation = { __typename?: 'Mutation', setUserPlannerHelpText: { __typename?: 'User', id: string, plannerHelpText: string | null } };

export type SetUserSanitizerFilterMutationVariables = Exact<{
  filter: UserSanitizerFilterInput;
}>;


export type SetUserSanitizerFilterMutation = { __typename?: 'Mutation', setUserSanitizerFilter: { __typename?: 'User', id: string, name: string, sanitizerFilters: Array<{ __typename?: 'UserSanitizerFilter', key: string, name: string, departments: Array<string>, locations: Array<string>, jobFunctions: Array<string>, sanitizers: Array<string> }> } };

export type GetCauseQuestionsQueryVariables = Exact<{
  damageCause: Scalars['String']['input'];
}>;


export type GetCauseQuestionsQuery = { __typename?: 'Query', causeQuestions: Array<{ __typename?: 'VisitationQuestion', id: string, question: string, damageCause: { __typename?: 'DamageCause', id: string, name: string }, damageCategory: { __typename?: 'DamageCategory', id: string, name: string } }> };

export const DebitorDelayScalepointConnectionFragmentFragmentDoc = gql`
    fragment DebitorDelayScalepointConnectionFragment on DebitorDelayScalepointConnection {
  id
  debitor {
    debitorId
    company
  }
  damageCauses {
    id
    name
    category {
      id
      name
    }
  }
}
    `;
export const BaseApvFragmentFragmentDoc = gql`
    fragment BaseAPVFragment on APV {
  id
  url
  damageCategory {
    id
    name
  }
  damageCause {
    id
    name
  }
}
    `;
export const BaseCarFragmentFragmentDoc = gql`
    fragment BaseCarFragment on Car {
  id
  name
  department
  email
}
    `;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  road
  houseNumber
  floor
  addressLine
  addressLineAlt
  postalCode
  city
  country
}
    `;
export const BaseDebitorFragmentFragmentDoc = gql`
    fragment BaseDebitorFragment on Debitor {
  id
  type
  debitorId
  company
  attention
  address {
    addressLine
    addressLineAlt
    city
    postalCode
    country
  }
  shippingAddress {
    id
    gln
    address {
      addressLine
      addressLineAlt
      city
      postalCode
      country
    }
  }
  billingAddress {
    ...AddressFragment
  }
  excess
  policeNumber
  cvrNumber
  gln
  phone
  email
  defaultScreeningTemplate
  assortmentCode
  unknown
  createInECB
  callCenterActive
  debitorGroup
  environmentFeePercentage
  maxEnvironmentFeeAmount
  priorityCustomer
}
    ${AddressFragmentFragmentDoc}`;
export const BaseBusinessAreaFragmentFragmentDoc = gql`
    fragment BaseBusinessAreaFragment on BusinessArea {
  id
  name
}
    `;
export const BaseDamageCategoryFragmentFragmentDoc = gql`
    fragment BaseDamageCategoryFragment on DamageCategory {
  id
  name
}
    `;
export const BaseDamageCauseFragmentFragmentDoc = gql`
    fragment BaseDamageCauseFragment on DamageCause {
  id
  name
  businessArea {
    id
    name
  }
  category {
    id
    name
  }
  departments {
    id
    departmentNumber
    name
    location {
      id
      name
    }
  }
  track
  urgent
}
    `;
export const DamageFragmentFragmentDoc = gql`
    fragment DamageFragment on Damage {
  businessArea {
    ...BaseBusinessAreaFragment
  }
  category {
    ...BaseDamageCategoryFragment
  }
  cause {
    ...BaseDamageCauseFragment
  }
  date
  description
  contact {
    name
    phone
    email
    address {
      ...AddressFragment
    }
  }
  contacts {
    name
    role
    phone
    email
  }
  accessConditions
}
    ${BaseBusinessAreaFragmentFragmentDoc}
${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export const BaseUserFragmentFragmentDoc = gql`
    fragment BaseUserFragment on User {
  id
  employeeId
  name
  department
  area
  jobFunction
  email
  phone
  defaultLanguage
}
    `;
export const BaseLocationFragmentFragmentDoc = gql`
    fragment BaseLocationFragment on Location {
  id
  name
  movables
  address {
    ...AddressFragment
  }
  email
}
    ${AddressFragmentFragmentDoc}`;
export const BaseDepartmentFragmentFragmentDoc = gql`
    fragment BaseDepartmentFragment on Department {
  id
  name
  departmentNumber
  location {
    id
    name
    address {
      ...AddressFragment
    }
  }
}
    ${AddressFragmentFragmentDoc}`;
export const BaseJobFragmentFragmentDoc = gql`
    fragment BaseJobFragment on Job {
  id
  type
  description
  deadline
  source
  assignedTo {
    id
    name
    email
  }
  location {
    id
    name
  }
  case {
    id
    erpNo
    scalePointUrl
  }
  movable {
    id
    description
    status
    placement {
      id
      name
    }
  }
  completed
}
    `;
export const VehicleFragmentDoc = gql`
    fragment Vehicle on Vehicle {
  vehicleNumber
  locationCode
  registrationNumber
  departmentCode
  brand
  username
  user
  vehicleCategory
}
    `;
export const BaseDrivingSlipQuestionnaireTemplateFragmentFragmentDoc = gql`
    fragment BaseDrivingSlipQuestionnaireTemplateFragment on DrivingSlipQuestionnaireTemplate {
  label
  sections {
    label
    choices {
      id
      parentId
      type
      label
      value
      placeholder
      helpText
      isOptional
      triggersTrackTwoChange
      unitOfMeasure
      isMultiSelectAllowed
      multiSelectValues
    }
    photoRequired
    shouldSaveInScalePoint
    caseAgreementCategory
  }
  damageCauses
  drivingSlipCategories
}
    `;
export const BaseDrivingSlipQuestionnaireFragmentFragmentDoc = gql`
    fragment BaseDrivingSlipQuestionnaireFragment on DrivingSlipQuestionnaireType {
  id
  sourceTemplateId
  sourceTemplateVersion
  template {
    ...BaseDrivingSlipQuestionnaireTemplateFragment
  }
  updatedAt
}
    ${BaseDrivingSlipQuestionnaireTemplateFragmentFragmentDoc}`;
export const DrivingSlipChangesFragmentFragmentDoc = gql`
    fragment DrivingSlipChangesFragment on DrivingSlipChangeDifference {
  locked
  status
  urgent
  fileNames
  driver {
    ...BaseUserFragment
  }
  car {
    ...Vehicle
  }
  materials {
    ...Vehicle
  }
  start
  eventReferenceId
  end
  comment
}
    ${BaseUserFragmentFragmentDoc}
${VehicleFragmentDoc}`;
export const BaseDrivingSlipFragmentFragmentDoc = gql`
    fragment BaseDrivingSlipFragment on DrivingSlip {
  id
  series
  locked
  status
  urgent
  series
  car {
    ...Vehicle
  }
  materials {
    ...Vehicle
  }
  driver {
    ...BaseUserFragment
  }
  estimatedHours
  start
  end
  deadline
  questionnaire {
    ...BaseDrivingSlipQuestionnaireFragment
  }
  comment
  version
  updatedAt
  createdAt
  passenger
  halfDay
  changes {
    timestamp
    user {
      ...BaseUserFragment
    }
    before {
      ...DrivingSlipChangesFragment
    }
    after {
      ...DrivingSlipChangesFragment
    }
  }
  location {
    id
    name
  }
  department {
    id
    name
    departmentNumber
  }
  category
  riskEvaluationStatus
  questionnaireCompletionStatus
  facadePictureTaken
  drivingStarted
  eventReferenceId
  noWasteUsed
  noMaterialUsed
  plannerMessage
  starDrivenKM
  actualDrivenKM
}
    ${VehicleFragmentDoc}
${BaseUserFragmentFragmentDoc}
${BaseDrivingSlipQuestionnaireFragmentFragmentDoc}
${DrivingSlipChangesFragmentFragmentDoc}`;
export const VendorFragmentFragmentDoc = gql`
    fragment VendorFragment on Vendor {
  erpReferenceNo
  company
  address {
    addressLine
    addressLineAlt
    city
    postalCode
    country
  }
  email
  phone
  vendorPostingGroup
  ssgDepartment
  ssgLocation
  type
}
    `;
export const RequisitionFragmentFragmentDoc = gql`
    fragment RequisitionFragment on Requisition {
  id
  case {
    id
    erpNo
    debitor {
      debitorId
      company
      unknown
    }
    damage {
      category {
        name
        id
      }
      cause {
        name
        id
      }
      contact {
        address {
          ...AddressFragment
        }
      }
    }
  }
  department {
    id
    name
  }
  drivingSlip {
    id
    case {
      id
      erpNo
      damage {
        category {
          name
        }
        cause {
          name
        }
      }
    }
  }
  description
  orderNumber
  type
  status
  vendor {
    ...VendorFragment
  }
  createdAt
  createdBy {
    id
    name
    phone
    email
  }
  vendorEmail
  vendorPhoneNumber
  vendorName
}
    ${AddressFragmentFragmentDoc}
${VendorFragmentFragmentDoc}`;
export const BaseCaseFragmentFragmentDoc = gql`
    fragment BaseCaseFragment on Case {
  id
  status
  erpId
  erpNo
  track
  reportSent
  distance
  machineNotification
  timeRegistration
  debitor {
    ...BaseDebitorFragment
  }
  damage {
    ...DamageFragment
  }
  policyHolder {
    name
    phone
    email
    address {
      ...AddressFragment
    }
  }
  visitation {
    urgent
    priorities
    regress
    calledBack {
      timestamp
      value
      comment
    }
    awaiting {
      timestamp
      value
      comment
    }
    answers {
      question
      answer
      title
    }
    isMoistureReportRequired
    isSpPhaseOneReportCreated
  }
  requisitioner {
    name
    phone
    email
    relation
  }
  adviser {
    name
    phone
    email
    companyName
    companyPhone
  }
  referrer {
    name
    phone
    email
    companyName
    companyPhone
  }
  projectManager {
    ...BaseUserFragment
    proxy {
      id
      name
      email
    }
  }
  caseManager {
    ...BaseUserFragment
  }
  ssgLocation {
    ...BaseLocationFragment
  }
  ssgDepartment {
    ...BaseDepartmentFragment
  }
  areaResponsible {
    ...BaseUserFragment
  }
  billingReady
  workComplete
  caseAgreements {
    content
    category
    user {
      ...BaseUserFragment
    }
    timestamp
    shouldSaveInScalePoint
  }
  caseEmails {
    content
    attachments
    receivers
    timestamp
  }
  userFavorite {
    user
    color
    active
  }
  createdBy {
    ...BaseUserFragment
  }
  updatedAt
  createdAt
  skafor
  jobs {
    ...BaseJobFragment
  }
  drivingSlipSeries {
    id
    completed
    drivingSlips {
      ...BaseDrivingSlipFragment
    }
  }
  importantInfo
  alternativeContact {
    name
    phone
    email
    comment
  }
  riskEvaluationAnswers {
    question {
      id
      question
    }
    answer
  }
  riskEvaluationComment
  requisitions {
    ...RequisitionFragment
  }
  scalePointUrl
  scalePointStatus
  scalePointErrorMessage
  scalePointMergeInfo {
    direction
    caseId
  }
  arrived
  arrivedDate
  possibilityOfAsbestos
}
    ${BaseDebitorFragmentFragmentDoc}
${DamageFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}
${BaseJobFragmentFragmentDoc}
${BaseDrivingSlipFragmentFragmentDoc}
${RequisitionFragmentFragmentDoc}`;
export const BaseCaseNoDrivingSlipsFragmentFragmentDoc = gql`
    fragment BaseCaseNoDrivingSlipsFragment on Case {
  id
  status
  erpId
  erpNo
  track
  debitor {
    ...BaseDebitorFragment
  }
  damage {
    ...DamageFragment
  }
  visitation {
    urgent
    priorities
    regress
    calledBack {
      timestamp
      comment
    }
  }
  requisitioner {
    name
    phone
    email
    relation
  }
  adviser {
    name
    phone
    email
    companyName
    companyPhone
  }
  referrer {
    name
    phone
    email
    companyName
    companyPhone
  }
  projectManager {
    ...BaseUserFragment
  }
  caseManager {
    ...BaseUserFragment
  }
  ssgLocation {
    ...BaseLocationFragment
  }
  ssgDepartment {
    ...BaseDepartmentFragment
  }
  billingReady
  workComplete
  caseAgreements {
    content
    category
    user {
      ...BaseUserFragment
    }
    timestamp
    shouldSaveInScalePoint
  }
  caseEmails {
    content
    attachments
    receivers
    timestamp
  }
  caseMachineUsages {
    machine
    startTime
    endTime
    startMeterReading
    endMeterReading
  }
  userFavorite {
    user
    color
    active
  }
  createdBy {
    ...BaseUserFragment
  }
  updatedAt
  createdAt
  skafor
  jobs {
    ...BaseJobFragment
  }
  policyHolder {
    phone
    email
  }
  importantInfo
  alternativeContact {
    name
    phone
    email
    comment
  }
}
    ${BaseDebitorFragmentFragmentDoc}
${DamageFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}
${BaseJobFragmentFragmentDoc}`;
export const BaseCatalogCustomerFragmentFragmentDoc = gql`
    fragment BaseCatalogCustomerFragment on CatalogCustomer {
  id
  name
  user {
    id
    name
  }
  users {
    id
    name
    email
  }
}
    `;
export const BaseCatalogAddressFragmentFragmentDoc = gql`
    fragment BaseCatalogAddressFragment on CatalogAddress {
  addressLine
  zipCode
  city
  startNumber
  endNumber
  houseNumbers
  comment
}
    `;
export const CatalogContactChangesFragmentFragmentDoc = gql`
    fragment CatalogContactChangesFragment on CatalogContactChangeDifference {
  customer {
    id
    name
  }
  changedBy
  contactName
  type
  contactType
  email
  informations {
    phoneNumber
    remark
  }
  global
  globalType
  active
  catalogs {
    id
    propertyNumber
    addresses {
      ...BaseCatalogAddressFragment
    }
  }
}
    ${BaseCatalogAddressFragmentFragmentDoc}`;
export const CatalogCraftsmanChangesFragmentFragmentDoc = gql`
    fragment CatalogCraftsmanChangesFragment on CatalogCraftsmanChangeDifference {
  customer {
    id
    name
  }
  changedBy
  type
  contactName
  informations {
    phoneNumber
    remark
  }
  email
  priority
  global
  globalType
  active
  catalogs {
    id
    propertyNumber
    addresses {
      ...BaseCatalogAddressFragment
    }
  }
}
    ${BaseCatalogAddressFragmentFragmentDoc}`;
export const TimedMessageChangesFragmentFragmentDoc = gql`
    fragment TimedMessageChangesFragment on TimedMessageChangeDifference {
  customer {
    id
    name
  }
  changedBy
  startTime
  endTime
  message
  global
  globalType
  active
  catalogs {
    id
    propertyNumber
    addresses {
      ...BaseCatalogAddressFragment
    }
  }
}
    ${BaseCatalogAddressFragmentFragmentDoc}`;
export const CatalogChangesFragmentFragmentDoc = gql`
    fragment CatalogChangesFragment on CatalogChangeDifference {
  ssgAccountable
  propertyNumber
  customer {
    id
    name
  }
  changedBy
  description
  contactNumber
  contactHours
  addresses {
    ...BaseCatalogAddressFragment
  }
  contacts {
    ...CatalogContactChangesFragment
  }
  craftsmen {
    ...CatalogCraftsmanChangesFragment
  }
  timedMessages {
    ...TimedMessageChangesFragment
  }
  filenames
  smsService
  verified
  debitorVerified
  debitor {
    company
    debitorId
    gln
  }
}
    ${BaseCatalogAddressFragmentFragmentDoc}
${CatalogContactChangesFragmentFragmentDoc}
${CatalogCraftsmanChangesFragmentFragmentDoc}
${TimedMessageChangesFragmentFragmentDoc}`;
export const BaseCatalogFragmentChangesFragmentDoc = gql`
    fragment BaseCatalogFragmentChanges on Catalog {
  id
  propertyNumber
  customer {
    id
    name
  }
  changedBy
  addresses {
    ...BaseCatalogAddressFragment
  }
  ssgAccountable
  description
  contactNumber
  contactHours
  smsService
  debitor {
    company
    debitorId
    gln
  }
  verified
  debitorVerified
  version
  updatedAt
  createdAt
  changes {
    timestamp
    user {
      ...BaseUserFragment
    }
    changedBy
    before {
      ...CatalogChangesFragment
    }
    after {
      ...CatalogChangesFragment
    }
  }
}
    ${BaseCatalogAddressFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${CatalogChangesFragmentFragmentDoc}`;
export const BaseCollectionItemFragmentFragmentDoc = gql`
    fragment BaseCollectionItemFragment on CollectionItem {
  id
  name
  type
}
    `;
export const BaseGdprFragmentFragmentDoc = gql`
    fragment BaseGDPRFragment on GDPR {
  id
  timestamp
  userId {
    id
  }
}
    `;
export const BaseGroupPermissionFragmentFragmentDoc = gql`
    fragment BaseGroupPermissionFragment on GroupPermission {
  id
  name
  groupPermissionId
  groupPermissions
  isNew
  groupDebitors {
    value
    label
  }
  groupDebitorGroups
  groupLocations
  groupDepartments
  groupDamageCategories
  groupDamageCauses
  groupRequisitionDepartments
}
    `;
export const BaseMachineFragmentFragmentDoc = gql`
    fragment BaseMachineFragment on Machine {
  erpReferenceNo
  name
  dateStart
  dateEnd
  eRPCaseReference
  eRPLocationReference
  consumption
  userName
  type
  active
  placement
  originLocation
  hibernate
  hibernationReason
  educationPrerequisit
  startTime
  serviceDate
  consumptionFactor
  consumptionType
  modelNumber
  reservationStart
  reservationEnd
  reservationDescription
  reservationByRessource
  reservationOnCase
  blocked
  placementDescription
  usageMeterEnd
  unavailableReason
  discontinued
}
    `;
export const BaseMachineLocationFragmentFragmentDoc = gql`
    fragment BaseMachineLocationFragment on MachineLocation {
  locationCode
  address
  city
  contact
  name
  postCode
  unavaliable
}
    `;
export const BaseMovableFragmentFragmentDoc = gql`
    fragment BaseMovableFragment on Movable {
  id
  description
  volume
  case {
    id
    erpNo
  }
  completed
  status
  placement {
    id
    name
    location {
      id
      name
      address {
        ...AddressFragment
      }
    }
  }
  version
  changes {
    timestamp
    user {
      id
      name
      email
    }
    before {
      description
      volume
      completed
      status
      placement {
        id
        name
      }
    }
    after {
      description
      volume
      completed
      status
      placement {
        id
        name
      }
    }
  }
}
    ${AddressFragmentFragmentDoc}`;
export const BaseMovablesLocationFragmentFragmentDoc = gql`
    fragment BaseMovablesLocationFragment on MovablesLocation {
  id
  name
  volume
  accVolume
  location {
    id
    name
    address {
      road
      houseNumber
      floor
      addressLine
      addressLineAlt
      postalCode
      city
      country
    }
  }
}
    `;
export const BaseNotificationFragmentFragmentDoc = gql`
    fragment BaseNotificationFragment on NotificationConfig {
  id
  trigger
  emailBodyTemplateId
  smsTemplateId
  emailSubjectTemplate
  displayName
}
    `;
export const BaseNotificationItemFragmentFragmentDoc = gql`
    fragment BaseNotificationItemFragment on NotificationItem {
  id
  trigger
  sendTo
  objectType
  objectId
  type
  sentSuccessfully
  error
  sentAt
}
    `;
export const BaseOfferFragmentFragmentDoc = gql`
    fragment BaseOfferFragment on Offer {
  jobNo
  lines {
    documentNo
    no
    planningDate
    description
    quantity
    unitPrice
    newUnitPrice
    lineAmount
    currencyCode
    workType
    systemId
    eRPReferenceTask
    type
    option
    hideSum
    header
    screeningLineId
    sortingIndex
    lineNo
    unitCost
  }
  opportunityStatus
  headerText
  footerText
  quoteType
  competitionOffer
}
    `;
export const BaseOfferItemFragmentFragmentDoc = gql`
    fragment BaseOfferItemFragment on Item {
  no
  description
  type
  baseUOM
}
    `;
export const BaseOfferJobTaskFragmentFragmentDoc = gql`
    fragment BaseOfferJobTaskFragment on JobTask {
  erpRefrenceNo
  jobTaskNo
  description
  price
  workTypeCode
  excludeInEnvFee
  excludeInSupplyFee
}
    `;
export const BaseOfferResourceFragmentFragmentDoc = gql`
    fragment BaseOfferResourceFragment on Resource {
  no
  name
  type
  baseUOM
}
    `;
export const BaseQuestionnaireTemplateFragmentFragmentDoc = gql`
    fragment BaseQuestionnaireTemplateFragment on QuestionnaireTemplate {
  id
  label
  sections {
    label
    choices {
      id
      parentId
      type
      label
      value
      placeholder
      helpText
      isOptional
      isMultiSelectAllowed
      triggersTrackTwoChange
      unitOfMeasure
      multiSelectValues
    }
    photoRequired
    shouldSaveInScalePoint
    caseAgreementCategory
  }
  damageCauses
  drivingSlipCategories
  version
  createdAt
  updatedAt
}
    `;
export const BaseRiskEvaluationQuestionFragmentFragmentDoc = gql`
    fragment BaseRiskEvaluationQuestionFragment on RiskEvaluationQuestion {
  id
  category {
    id
    categoryName
  }
  question
  helpText
  defaultChecked
}
    `;
export const BaseScreeningPositionTextFragmentFragmentDoc = gql`
    fragment BaseScreeningPositionTextFragment on ScreeningPositionText {
  id
  templateCode
  position
  text
}
    `;
export const BaseTimeTrackingFragmentFragmentDoc = gql`
    fragment BaseTimeTrackingFragment on TimeTracking {
  id
  createdAt
  user {
    id
    name
  }
  date
  hours
  jobNo
  case {
    id
    erpId
    erpNo
    debitor {
      company
    }
    damage {
      category {
        id
        name
      }
      cause {
        id
        name
      }
      contact {
        address {
          road
          houseNumber
          postalCode
          city
        }
      }
    }
  }
  drivingSlip {
    id
  }
  remark
  jobTaskNo
  onCall
  jobTaskName
  workTypeCode
  timeTrackingStatus
  trackingType
  pieceworkAmount
  supplementType
  paymentSupplementCode
  paymentSupplementName
  supplementUom
  rejectMessage
  addonLines {
    id
    user {
      id
      name
    }
    date
    hours
    case {
      id
      erpId
      erpNo
      debitor {
        company
      }
    }
    drivingSlip {
      id
    }
    remark
    jobTaskNo
    onCall
    workTypeCode
    timeTrackingStatus
    trackingType
    pieceworkAmount
    supplementType
    paymentSupplementCode
    paymentSupplementName
    supplementUom
    rejectMessage
  }
}
    `;
export const BaseVisitationQuestionFragmentFragmentDoc = gql`
    fragment BaseVisitationQuestionFragment on VisitationQuestion {
  id
  question
  damageCause {
    id
    name
  }
  damageCategory {
    id
    name
  }
}
    `;
export const CalendarEventFragmentFragmentDoc = gql`
    fragment CalendarEventFragment on CalendarEvent {
  referenceId
  title
  type
  timeRange {
    from
    to
  }
  isAllDay
  systemCreatedEvent
  drivingSlip {
    ...BaseDrivingSlipFragment
    case {
      id
      erpNo
      damage {
        contact {
          name
          phone
          email
          address {
            ...AddressFragment
          }
        }
        category {
          ...BaseDamageCategoryFragment
        }
        cause {
          ...BaseDamageCauseFragment
        }
      }
      projectManager {
        ...BaseUserFragment
      }
    }
  }
  __typename
}
    ${BaseDrivingSlipFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}`;
export const CaseChangesFragmentFragmentDoc = gql`
    fragment CaseChangesFragment on CaseChangeDifference {
  status
  track
  debitor {
    debitorId
    type
    attention
    billingAddress {
      ...AddressFragment
    }
    excess
    policeNumber
    cvrNumber
  }
  damage {
    ...DamageFragment
  }
  policyHolder {
    name
    phone
    email
    address {
      ...AddressFragment
    }
  }
  visitation {
    urgent
    priorities
    regress
    calledBack {
      timestamp
      value
      comment
    }
    awaiting {
      timestamp
      value
      comment
    }
    answers {
      question
      answer
    }
  }
  requisitioner {
    name
    phone
    email
    relation
  }
  drivingSlips {
    locked
    status
    urgent
    driver {
      name
    }
    car {
      vehicleNumber
    }
    start
    end
    comment
  }
  projectManager {
    ...BaseUserFragment
  }
  caseManager {
    ...BaseUserFragment
  }
  ssgLocation {
    ...BaseLocationFragment
  }
  ssgDepartment {
    ...BaseDepartmentFragment
  }
  caseEmails {
    content
    attachments
    receivers
    timestamp
  }
  caseMachineUsages {
    machine
    startTime
    endTime
    startMeterReading
    endMeterReading
  }
  requisitioner {
    name
    phone
    email
    relation
  }
  projectManager {
    ...BaseUserFragment
  }
  caseManager {
    ...BaseUserFragment
  }
  caseEmails {
    content
    attachments
    receivers
    timestamp
  }
  caseMachineUsages {
    machine
    startTime
    endTime
    startMeterReading
    endMeterReading
  }
  importantInfo
  skafor
  alternativeContact {
    name
    phone
    email
    comment
  }
  riskEvaluationAnswers {
    question {
      id
      question
    }
    answer
  }
  fileNames
  scalePointId
  scalePointNumber
  scalePointUrl
  scalePointStatus
}
    ${AddressFragmentFragmentDoc}
${DamageFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}`;
export const CaseUsageFragmentFragmentDoc = gql`
    fragment CaseUsageFragment on CaseUsageLine {
  erpId
  erpKey
  title
  quantity
  unit
  lineCost
  totalCost
  attachments
  ressourceName
  postingDate
  originalPostingDate
  substitute
  vehicleExpense
}
    `;
export const BaseCatalogFragmentFragmentDoc = gql`
    fragment BaseCatalogFragment on Catalog {
  id
  propertyNumber
  contactNumber
  contactHours
  customer {
    id
    name
  }
  changedBy
  addresses {
    ...BaseCatalogAddressFragment
  }
  smsService
  debitor {
    company
    debitorId
    gln
    salesPersonCode
    salesPersonName
  }
  verified
  debitorVerified
  version
  updatedAt
  createdAt
}
    ${BaseCatalogAddressFragmentFragmentDoc}`;
export const BaseCatalogCraftsmanFragmentFragmentDoc = gql`
    fragment BaseCatalogCraftsmanFragment on CatalogCraftsman {
  id
  customer {
    id
    name
  }
  changedBy
  type
  contactName
  informations {
    phoneNumber
    remark
  }
  email
  priority
  global
  globalType
  active
  version
  catalogIds
}
    `;
export const BaseCatalogContactFragmentFragmentDoc = gql`
    fragment BaseCatalogContactFragment on CatalogContact {
  id
  customer {
    id
    name
  }
  changedBy
  contactName
  type
  contactType
  email
  informations {
    phoneNumber
    remark
  }
  global
  globalType
  active
  catalogIds
  version
}
    `;
export const BaseTimedMessageFragmentFragmentDoc = gql`
    fragment BaseTimedMessageFragment on TimedMessage {
  id
  customer {
    id
    name
  }
  changedBy
  startTime
  endTime
  message
  global
  globalType
  active
  version
  catalogIds
}
    `;
export const CatalogFragmentFragmentDoc = gql`
    fragment CatalogFragment on Catalog {
  ...BaseCatalogFragment
  ssgAccountable
  description
  craftsmen {
    ...BaseCatalogCraftsmanFragment
  }
  contacts {
    ...BaseCatalogContactFragment
  }
  timedMessages {
    ...BaseTimedMessageFragment
  }
}
    ${BaseCatalogFragmentFragmentDoc}
${BaseCatalogCraftsmanFragmentFragmentDoc}
${BaseCatalogContactFragmentFragmentDoc}
${BaseTimedMessageFragmentFragmentDoc}`;
export const DraftInvoiceLineFragmentFragmentDoc = gql`
    fragment DraftInvoiceLineFragment on DraftInvoiceLine {
  systemId
  sortIndex
  caseNo
  documentNo
  no
  erpReferenceTask
  lineAmount
  lineType
  type
  attachDocument
  allowAttachDocument
  description
  quantity
  quoteLineId
  screeningTitle
  screeningLine
  screeningLineId
  screeningLinePosition
  unitPrice
  unitCost
  newUnitPrice
  planningDate
  workTypeCode
  createdBy
  unitOfMeasure
  excludeInEnvFee
  excludeInSupplyFee
}
    `;
export const DraftInvoiceFragmentFragmentDoc = gql`
    fragment DraftInvoiceFragment on DraftInvoice {
  erpReferenceNo
  category
  status
  invoicePostingDate
  invoiceStartDate
  invoiceEndDate
  validationRuleBypasses {
    rule
    reasonCode
    comment
  }
  lines {
    ...DraftInvoiceLineFragment
  }
  hasSuggestedLines
  invoiceDescription
  rejectionReason
}
    ${DraftInvoiceLineFragmentFragmentDoc}`;
export const EsdhFileFragmentFragmentDoc = gql`
    fragment ESDHFileFragment on ESDHFile {
  name
  url
  thumbnail
  extension
  groupingKey
  created
  metadata {
    key
    value
  }
  comments
  fileId
}
    `;
export const InvoiceReasonCodeFragmentFragmentDoc = gql`
    fragment InvoiceReasonCodeFragment on InvoiceReasonCode {
  id
  name
}
    `;
export const SalesInvoiceLineFragmentFragmentDoc = gql`
    fragment SalesInvoiceLineFragment on SalesInvoiceLine {
  systemId
  documentNo
  lineNo
  no
  type
  description
  quantity
  uom
  unitPrice
  lineDiscountAmount
  lineDiscountPercentage
  amountIncludingVAT
  vatBaseAmount
  vatPercentage
}
    `;
export const BaseDrivingSlipCaseMobileFragmentFragmentDoc = gql`
    fragment BaseDrivingSlipCaseMobileFragment on Case {
  id
  erpNo
  skafor
  debitor {
    ...BaseDebitorFragment
  }
  damage {
    contact {
      name
      phone
      email
      address {
        ...AddressFragment
      }
    }
    category {
      ...BaseDamageCategoryFragment
    }
    cause {
      ...BaseDamageCauseFragment
    }
  }
  policyHolder {
    name
    phone
    email
  }
  areaResponsible {
    ...BaseUserFragment
  }
  projectManager {
    ...BaseUserFragment
  }
  caseManager {
    name
    phone
    email
  }
  ssgLocation {
    ...BaseLocationFragment
  }
  ssgDepartment {
    ...BaseDepartmentFragment
  }
  riskEvaluationAnswers {
    question {
      id
      question
    }
    answer
  }
  riskEvaluationComment
  visitation {
    urgent
    priorities
    regress
    calledBack {
      timestamp
      value
      comment
    }
    awaiting {
      timestamp
      value
      comment
    }
    answers {
      question
      answer
      title
    }
  }
  timeRegistration
}
    ${BaseDebitorFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}`;
export const BaseDrivingSlipMobileFragmentFragmentDoc = gql`
    fragment BaseDrivingSlipMobileFragment on DrivingSlip {
  id
  status
  urgent
  start
  createdAt
  changes {
    timestamp
    user {
      id
      name
    }
    before {
      status
    }
    after {
      status
    }
  }
  location {
    id
    name
  }
  department {
    id
    name
  }
  category
  facadePictureTaken
}
    `;
export const BaseDrivingSlipCaseFragmentFragmentDoc = gql`
    fragment BaseDrivingSlipCaseFragment on Case {
  id
  erpNo
  skafor
  debitor {
    ...BaseDebitorFragment
  }
  damage {
    contact {
      name
      phone
      email
      address {
        ...AddressFragment
      }
    }
    category {
      ...BaseDamageCategoryFragment
    }
    cause {
      ...BaseDamageCauseFragment
    }
  }
  policyHolder {
    name
    phone
    email
    address {
      ...AddressFragment
    }
  }
  areaResponsible {
    ...BaseUserFragment
  }
  projectManager {
    ...BaseUserFragment
  }
  caseManager {
    name
    phone
    email
  }
  ssgLocation {
    ...BaseLocationFragment
  }
  ssgDepartment {
    ...BaseDepartmentFragment
  }
  riskEvaluationAnswers {
    question {
      id
      question
    }
    answer
  }
  riskEvaluationComment
  visitation {
    urgent
    priorities
    regress
    calledBack {
      timestamp
      value
      comment
    }
    awaiting {
      timestamp
      value
      comment
    }
    answers {
      question
      answer
      title
    }
  }
  timeRegistration
}
    ${BaseDebitorFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}`;
export const BaseReportFileFragmentDoc = gql`
    fragment BaseReportFile on ReportFile {
  fileName
  description
}
    `;
export const BaseInspectionReportFormDataFragmentFragmentDoc = gql`
    fragment BaseInspectionReportFormDataFragment on InspectionReportFormData {
  facadeImage {
    ...BaseReportFile
  }
  backgroundStory
  observations
  assessmentAndConclusion
  suggestedActionPlan
  comments
  floorplanImage {
    ...BaseReportFile
  }
  otherImages {
    ...BaseReportFile
  }
}
    ${BaseReportFileFragmentDoc}`;
export const BaseMoistureReportFormDataFragmentFragmentDoc = gql`
    fragment BaseMoistureReportFormDataFragment on MoistureReportFormData {
  facadeImage {
    ...BaseReportFile
  }
  inspectionDate
  conclusion
  damageCause
  scope
  contacts
  regres
  damageCauseImages {
    ...BaseReportFile
  }
  floorReport {
    name
    observations {
      roomOrApartment
      construction
      contacts
      ceiling
      walls
      floor
      movables
      scope
      recommendations
    }
    moistureMeassurements {
      construction
      material
      description
      method
      value
      expectedFinalValue
      referenceValue
      referenceDate
      controlValue
      controlDate
    }
    floorplanImage {
      ...BaseReportFile
    }
    otherImages {
      ...BaseReportFile
    }
  }
}
    ${BaseReportFileFragmentDoc}`;
export const BaseMoistureTrygReportFormDataFragmentFragmentDoc = gql`
    fragment BaseMoistureTrygReportFormDataFragment on MoistureTrygReportFormData {
  facadeImage {
    ...BaseReportFile
  }
  inspectionDate
  floorReport {
    name
    damageCause
    multipleDamageCauses
    moistureDamageCause
    damageDescription
    floorplanImage {
      ...BaseReportFile
    }
    moistureMeassurements {
      construction
      material
      description
      method
      paints
      paintsDate
      expectedFinalValue
      expectedFinalDate
      referenceValue
      referenceDate
      controlValue
      controlDate
    }
    airMeassurements {
      temperatureInside
      temperatureOutside
      relativeHumidityInside
      relativeHumidityOutside
      waterAmountInside
      waterAmountOutside
    }
    damageDescriptionImage {
      ...BaseReportFile
    }
    damageDrawingImage {
      ...BaseReportFile
    }
    recommendations
    urgentActions
    otherImages {
      ...BaseReportFile
    }
  }
}
    ${BaseReportFileFragmentDoc}`;
export const IndoorClimateReportFormDataFragmentFragmentDoc = gql`
    fragment IndoorClimateReportFormDataFragment on IndoorClimateReportFormData {
  facadeImage {
    ...BaseReportFile
  }
  inspectionDate
  purpose
  buildYear
  squareMeters
  dailyUsers
  participants
  backgroundStory
  observations
  showLabAnswers
  showDataLog
  assessmentAndConclusion
  suggestedActionPlan
  floorplanImage {
    ...BaseReportFile
  }
  otherImages {
    ...BaseReportFile
  }
  indoorClimateMeassurements {
    room
    construction
    material
    description
    instrument
    value
    referenceValue
    calculatedValue
  }
}
    ${BaseReportFileFragmentDoc}`;
export const NoticeOfConstructionwasteFormDataFragmentFragmentDoc = gql`
    fragment NoticeOfConstructionwasteFormDataFragment on NoticeOfConstructionwasteFormData {
  area
  assignment
  wasteFractions
  wastePackaging
  carrier
  yearOfConstruction
  startDate
  endDate
}
    `;
export const InspectionAssesmentFormDataFragmentFragmentDoc = gql`
    fragment InspectionAssesmentFormDataFragment on InspectionAssesmentFormData {
  assesments {
    id
    color
    comment
    deviation {
      severityLevel
      description
      cause
      action
      actionDate
      actionResponsible
      reportDate
    }
  }
  signatures {
    signatureDetails {
      fileName
      description
    }
    signatureDate
    index
  }
}
    `;
export const CaseOrganizationFormDataFragmentFragmentDoc = gql`
    fragment CaseOrganizationFormDataFragment on CaseOrganizationFormData {
  caseOrganizationWorkers {
    index
    title
    name
    phonenumber
    date
    instructor
    signature {
      index
      signatureDate
      signatureDetails {
        fileName
        description
      }
    }
  }
}
    `;
export const EndevaluationFormDataFragmentFragmentDoc = gql`
    fragment EndevaluationFormDataFragment on EndevaluationReportFormData {
  evaluationCategories {
    index
    title
    evaluations {
      index
      question
      answer
      remark
    }
  }
  deviations {
    severityLevel
    description
    cause
    action
    actionDate
    actionResponsible
    relatedEvaluationQuestion
    relatedEvaluationCategory
    reportDate
  }
  signature {
    index
    signatureDate
    signatureDetails {
      fileName
      description
    }
  }
}
    `;
export const DeviationReportFormDataFragmentFragmentDoc = gql`
    fragment DeviationReportFormDataFragment on DeviationReportFormData {
  deviation {
    severityLevel
    description
    cause
    action
    actionDate
    actionResponsible
    relatedEvaluationQuestion
    relatedEvaluationCategory
    reportDate
  }
}
    `;
export const CaseDraftUsageLineFragmentFragmentDoc = gql`
    fragment CaseDraftUsageLineFragment on CaseDraftUsageLine {
  erpId
  erpKey
  title
  quantity
  unitOfMeasureCode
  date
  postedBy
  description
  __typename
}
    `;
export const V2DrivingSlipCaseFragmentFragmentDoc = gql`
    fragment V2DrivingSlipCaseFragment on Case {
  ...BaseDrivingSlipCaseFragment
  caseReports {
    inspectionReportFormData {
      ...BaseInspectionReportFormDataFragment
    }
    inspectionMovablesReportFormData {
      ...BaseInspectionReportFormDataFragment
    }
    moistureReportFormData {
      ...BaseMoistureReportFormDataFragment
    }
    moistureTrygReportFormData {
      ...BaseMoistureTrygReportFormDataFragment
    }
    indoorClimateReportFormData {
      ...IndoorClimateReportFormDataFragment
    }
  }
  caseAsbestosReports {
    noticeOfConstructionWasteFormData {
      ...NoticeOfConstructionwasteFormDataFragment
    }
    inspectionAssesmentFormData {
      ...InspectionAssesmentFormDataFragment
    }
    caseOrganizationFormData {
      ...CaseOrganizationFormDataFragment
    }
    endevaluationReportFormData {
      ...EndevaluationFormDataFragment
    }
    deviationReportFormData {
      ...DeviationReportFormDataFragment
    }
  }
  alternativeContact {
    name
    phone
    email
    comment
  }
  requisitioner {
    name
    phone
    email
    relation
  }
  caseDraftItemsUsage {
    ...CaseDraftUsageLineFragment
  }
  version
}
    ${BaseDrivingSlipCaseFragmentFragmentDoc}
${BaseInspectionReportFormDataFragmentFragmentDoc}
${BaseMoistureReportFormDataFragmentFragmentDoc}
${BaseMoistureTrygReportFormDataFragmentFragmentDoc}
${IndoorClimateReportFormDataFragmentFragmentDoc}
${NoticeOfConstructionwasteFormDataFragmentFragmentDoc}
${InspectionAssesmentFormDataFragmentFragmentDoc}
${CaseOrganizationFormDataFragmentFragmentDoc}
${EndevaluationFormDataFragmentFragmentDoc}
${DeviationReportFormDataFragmentFragmentDoc}
${CaseDraftUsageLineFragmentFragmentDoc}`;
export const DrivingSlipNewPlannerFragmentDoc = gql`
    fragment DrivingSlipNewPlanner on DrivingSlip {
  id
  series
  locked
  status
  urgent
  series
  car {
    ...Vehicle
  }
  materials {
    ...Vehicle
  }
  driver {
    ...BaseUserFragment
  }
  estimatedHours
  start
  end
  deadline
  comment
  location {
    id
    name
  }
  department {
    id
    name
    departmentNumber
  }
  category
  riskEvaluationStatus
  createdAt
  version
  plannerMessage
  eventReferenceId
  passenger
  halfDay
  case {
    id
    status
    erpId
    erpNo
    track
    debitor {
      ...BaseDebitorFragment
    }
    damage {
      ...DamageFragment
    }
    projectManager {
      ...BaseUserFragment
    }
    caseManager {
      ...BaseUserFragment
    }
    createdBy {
      ...BaseUserFragment
    }
    skafor
    policyHolder {
      name
      phone
      email
      address {
        ...AddressFragment
      }
    }
  }
}
    ${VehicleFragmentDoc}
${BaseUserFragmentFragmentDoc}
${BaseDebitorFragmentFragmentDoc}
${DamageFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export const EventFragmentDoc = gql`
    fragment Event on CalendarEvent {
  referenceId
  title
  type
  timeRange {
    from
    to
  }
  isAllDay
  systemCreatedEvent
  drivingSlip {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;
export const BaseSupplementFragmentDoc = gql`
    fragment BaseSupplement on TimeTrackingSupplement {
  id
  createdAt
  user {
    id
    name
  }
  userId
  date
  hours
  case {
    id
    erpId
    erpNo
    debitor {
      id
      company
    }
  }
  remark
  jobTaskNo
  jobNo
  jobTaskName
  onCall
  onCallback
  workTypeCode
  timeTrackingStatus
  bcStatus
  pieceworkAmount
  supplementType
  paymentSupplementCode
  paymentSupplementName
  supplementUom
  rejectMessage
}
    `;
export const BaseTimeTrackingEntryFragmentDoc = gql`
    fragment BaseTimeTrackingEntry on TimeTrackingEntry {
  id
  createdAt
  user {
    id
    name
  }
  userId
  startDate
  endDate
  startTime
  endTime
  hours
  case {
    id
    erpId
    erpNo
    debitor {
      id
      company
    }
    damage {
      category {
        id
        name
      }
      cause {
        id
        name
      }
      contact {
        address {
          road
          houseNumber
          postalCode
          city
        }
      }
    }
  }
  drivingSlip {
    id
  }
  jobNo
  remark
  jobTaskNo
  onCall
  onCallback
  includesLunch
  task
  jobTaskName
  workTypeCode
  bcStatus
  timeTrackingStatus
  rejectMessage
  pieceworkAmount
  supplementType
  paymentSupplementCode
  paymentSupplementName
  supplementUom
  lastModifiedAt
  lastModifiedBy {
    id
    name
  }
  addonLines {
    ...BaseSupplement
  }
}
    ${BaseSupplementFragmentDoc}`;
export const TimeTrackingDayFragmentDoc = gql`
    fragment TimeTrackingDay on TimeTrackingDay {
  id
  createdAt
  timeTrackingDayStatus
  user {
    id
    name
    employeeId
  }
  userId
  date
  totalHours
  overtimeHours
  isPartOfRange
  rangeStartDate
  rangeEndDate
  timeTrackingEntries {
    ...BaseTimeTrackingEntry
  }
}
    ${BaseTimeTrackingEntryFragmentDoc}`;
export const CreateApvDocument = gql`
    mutation CreateAPV($apv: APVInput!, $file: FileInput!) {
  createAPV(apv: $apv, file: $file) {
    ...BaseAPVFragment
  }
}
    ${BaseApvFragmentFragmentDoc}`;
export type CreateApvMutationFn = Apollo.MutationFunction<CreateApvMutation, CreateApvMutationVariables>;

/**
 * __useCreateApvMutation__
 *
 * To run a mutation, you first call `useCreateApvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApvMutation, { data, loading, error }] = useCreateApvMutation({
 *   variables: {
 *      apv: // value for 'apv'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateApvMutation(baseOptions?: Apollo.MutationHookOptions<CreateApvMutation, CreateApvMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateApvMutation, CreateApvMutationVariables>(CreateApvDocument, options);
}
export type CreateApvMutationHookResult = ReturnType<typeof useCreateApvMutation>;
export type CreateApvMutationResult = Apollo.MutationResult<CreateApvMutation>;
export type CreateApvMutationOptions = Apollo.BaseMutationOptions<CreateApvMutation, CreateApvMutationVariables>;
export const DeleteApvDocument = gql`
    mutation DeleteAPV($id: String!) {
  deleteAPV(id: $id) {
    _
  }
}
    `;
export type DeleteApvMutationFn = Apollo.MutationFunction<DeleteApvMutation, DeleteApvMutationVariables>;

/**
 * __useDeleteApvMutation__
 *
 * To run a mutation, you first call `useDeleteApvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApvMutation, { data, loading, error }] = useDeleteApvMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApvMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApvMutation, DeleteApvMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteApvMutation, DeleteApvMutationVariables>(DeleteApvDocument, options);
}
export type DeleteApvMutationHookResult = ReturnType<typeof useDeleteApvMutation>;
export type DeleteApvMutationResult = Apollo.MutationResult<DeleteApvMutation>;
export type DeleteApvMutationOptions = Apollo.BaseMutationOptions<DeleteApvMutation, DeleteApvMutationVariables>;
export const GetApVsDocument = gql`
    query GetAPVs {
  apvs {
    ...BaseAPVFragment
  }
}
    ${BaseApvFragmentFragmentDoc}`;

/**
 * __useGetApVsQuery__
 *
 * To run a query within a React component, call `useGetApVsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApVsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApVsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApVsQuery(baseOptions?: Apollo.QueryHookOptions<GetApVsQuery, GetApVsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetApVsQuery, GetApVsQueryVariables>(GetApVsDocument, options);
}
export function useGetApVsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApVsQuery, GetApVsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetApVsQuery, GetApVsQueryVariables>(GetApVsDocument, options);
}
export function useGetApVsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApVsQuery, GetApVsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetApVsQuery, GetApVsQueryVariables>(GetApVsDocument, options);
}
export type GetApVsQueryHookResult = ReturnType<typeof useGetApVsQuery>;
export type GetApVsLazyQueryHookResult = ReturnType<typeof useGetApVsLazyQuery>;
export type GetApVsSuspenseQueryHookResult = ReturnType<typeof useGetApVsSuspenseQuery>;
export type GetApVsQueryResult = Apollo.QueryResult<GetApVsQuery, GetApVsQueryVariables>;
export function refetchGetApVsQuery(variables?: GetApVsQueryVariables) {
  return { query: GetApVsDocument, variables: variables }
}
export const UpdateApvDocument = gql`
    mutation UpdateAPV($id: String!, $damageCategory: String, $damageCause: String, $file: FileInput) {
  updateAPV(
    id: $id
    damageCategory: $damageCategory
    damageCause: $damageCause
    file: $file
  ) {
    ...BaseAPVFragment
  }
}
    ${BaseApvFragmentFragmentDoc}`;
export type UpdateApvMutationFn = Apollo.MutationFunction<UpdateApvMutation, UpdateApvMutationVariables>;

/**
 * __useUpdateApvMutation__
 *
 * To run a mutation, you first call `useUpdateApvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApvMutation, { data, loading, error }] = useUpdateApvMutation({
 *   variables: {
 *      id: // value for 'id'
 *      damageCategory: // value for 'damageCategory'
 *      damageCause: // value for 'damageCause'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateApvMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApvMutation, UpdateApvMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateApvMutation, UpdateApvMutationVariables>(UpdateApvDocument, options);
}
export type UpdateApvMutationHookResult = ReturnType<typeof useUpdateApvMutation>;
export type UpdateApvMutationResult = Apollo.MutationResult<UpdateApvMutation>;
export type UpdateApvMutationOptions = Apollo.BaseMutationOptions<UpdateApvMutation, UpdateApvMutationVariables>;
export const CreateSettingsDocument = gql`
    mutation CreateSettings($bcSetting: BCSettingsInput, $spSetting: SPSettingsInput, $smsSetting: SMSSettingsInput, $smtpSetting: SmtpSettingsInput, $catalogNotificationSetting: CatalogNotificationSettingInput, $invoiceSetting: InvoiceSettingsInput, $in4moSetting: In4moSettingsInput, $drivingSlipCategoryMappingSetting: DrivingSlipCategoryMappingSettingsInput, $machineNotificationSetting: MachineNotificationSettingInput) {
  createSetting(
    bcSetting: $bcSetting
    spSetting: $spSetting
    smsSetting: $smsSetting
    smtpSetting: $smtpSetting
    catalogNotificationSetting: $catalogNotificationSetting
    invoiceSetting: $invoiceSetting
    in4moSetting: $in4moSetting
    drivingSlipCategoryMappingSetting: $drivingSlipCategoryMappingSetting
    machineNotificationSetting: $machineNotificationSetting
  ) {
    ... on BCSettings {
      id
      type
    }
    ... on SPSettings {
      id
      type
    }
    ... on SMSSettings {
      id
      type
    }
    ... on SmtpSettings {
      id
      type
    }
    ... on CatalogNotificationSetting {
      id
      type
    }
    ... on InvoiceSettings {
      id
      type
    }
    ... on In4moSettings {
      id
      type
    }
    ... on DrivingSlipCategoryMappingSettings {
      id
      type
    }
    ... on MachineNotificationSetting {
      id
      type
    }
  }
}
    `;
export type CreateSettingsMutationFn = Apollo.MutationFunction<CreateSettingsMutation, CreateSettingsMutationVariables>;

/**
 * __useCreateSettingsMutation__
 *
 * To run a mutation, you first call `useCreateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSettingsMutation, { data, loading, error }] = useCreateSettingsMutation({
 *   variables: {
 *      bcSetting: // value for 'bcSetting'
 *      spSetting: // value for 'spSetting'
 *      smsSetting: // value for 'smsSetting'
 *      smtpSetting: // value for 'smtpSetting'
 *      catalogNotificationSetting: // value for 'catalogNotificationSetting'
 *      invoiceSetting: // value for 'invoiceSetting'
 *      in4moSetting: // value for 'in4moSetting'
 *      drivingSlipCategoryMappingSetting: // value for 'drivingSlipCategoryMappingSetting'
 *      machineNotificationSetting: // value for 'machineNotificationSetting'
 *   },
 * });
 */
export function useCreateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSettingsMutation, CreateSettingsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSettingsMutation, CreateSettingsMutationVariables>(CreateSettingsDocument, options);
}
export type CreateSettingsMutationHookResult = ReturnType<typeof useCreateSettingsMutation>;
export type CreateSettingsMutationResult = Apollo.MutationResult<CreateSettingsMutation>;
export type CreateSettingsMutationOptions = Apollo.BaseMutationOptions<CreateSettingsMutation, CreateSettingsMutationVariables>;
export const DeleteSettingsDocument = gql`
    mutation DeleteSettings($id: String!) {
  deleteSetting(id: $id) {
    _
  }
}
    `;
export type DeleteSettingsMutationFn = Apollo.MutationFunction<DeleteSettingsMutation, DeleteSettingsMutationVariables>;

/**
 * __useDeleteSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSettingsMutation, { data, loading, error }] = useDeleteSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSettingsMutation, DeleteSettingsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSettingsMutation, DeleteSettingsMutationVariables>(DeleteSettingsDocument, options);
}
export type DeleteSettingsMutationHookResult = ReturnType<typeof useDeleteSettingsMutation>;
export type DeleteSettingsMutationResult = Apollo.MutationResult<DeleteSettingsMutation>;
export type DeleteSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteSettingsMutation, DeleteSettingsMutationVariables>;
export const GetIn4moTypesDocument = gql`
    query GetIn4moTypes {
  in4moDamageTypes
  in4moTaskTypes
}
    `;

/**
 * __useGetIn4moTypesQuery__
 *
 * To run a query within a React component, call `useGetIn4moTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIn4moTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIn4moTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIn4moTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetIn4moTypesQuery, GetIn4moTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetIn4moTypesQuery, GetIn4moTypesQueryVariables>(GetIn4moTypesDocument, options);
}
export function useGetIn4moTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIn4moTypesQuery, GetIn4moTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetIn4moTypesQuery, GetIn4moTypesQueryVariables>(GetIn4moTypesDocument, options);
}
export function useGetIn4moTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIn4moTypesQuery, GetIn4moTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetIn4moTypesQuery, GetIn4moTypesQueryVariables>(GetIn4moTypesDocument, options);
}
export type GetIn4moTypesQueryHookResult = ReturnType<typeof useGetIn4moTypesQuery>;
export type GetIn4moTypesLazyQueryHookResult = ReturnType<typeof useGetIn4moTypesLazyQuery>;
export type GetIn4moTypesSuspenseQueryHookResult = ReturnType<typeof useGetIn4moTypesSuspenseQuery>;
export type GetIn4moTypesQueryResult = Apollo.QueryResult<GetIn4moTypesQuery, GetIn4moTypesQueryVariables>;
export function refetchGetIn4moTypesQuery(variables?: GetIn4moTypesQueryVariables) {
  return { query: GetIn4moTypesDocument, variables: variables }
}
export const GetSettingsDocument = gql`
    query GetSettings($type: String!) {
  setting(type: $type) {
    ... on BCSettings {
      id
      type
      username
      password
    }
    ... on SPSettings {
      id
      type
      logins {
        insuranceCompany
        userLogin
        token
        debitors
        contentSectorCategories
      }
      debitorMappings {
        insuranceCompany
        insuranceSubCompany
        debitor
      }
      damageMappings {
        insuranceCompany
        damageCategories {
          key
          value
        }
        damageCauses {
          key
          value
        }
      }
    }
    ... on SMSSettings {
      id
      type
      endpoint
      originator
      username
      password
    }
    ... on SmtpSettings {
      id
      type
      host
      port
      email
      username
      password
    }
    ... on CatalogNotificationSetting {
      id
      type
      verifyNotifications {
        debitorVerification
        email
      }
      debitorVerifyNotifications {
        debitorVerification
        email
      }
    }
    ... on InvoiceSettings {
      id
      type
      automaticInvoiceGroupPrefixes
      isAmountBelowAmount
      minHourlyRate
    }
    ... on In4moSettings {
      id
      type
      username
      password
      debitorMappings {
        insuranceCompany
        debitor
      }
      damageMappings {
        damageType
        taskType
        damageCause
      }
    }
    ... on DrivingSlipCategoryMappingSettings {
      id
      type
      drivingSlipCategoryMappings {
        drivingSlipCategory
        damageCategoryId
        damageCauseId
      }
    }
    ... on MachineNotificationSetting {
      id
      type
      machineNotifications {
        days
        active
      }
    }
  }
}
    `;

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
}
export function useGetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
}
export function useGetSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
}
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<typeof useGetSettingsLazyQuery>;
export type GetSettingsSuspenseQueryHookResult = ReturnType<typeof useGetSettingsSuspenseQuery>;
export type GetSettingsQueryResult = Apollo.QueryResult<GetSettingsQuery, GetSettingsQueryVariables>;
export function refetchGetSettingsQuery(variables: GetSettingsQueryVariables) {
  return { query: GetSettingsDocument, variables: variables }
}
export const UpdateSettingsDocument = gql`
    mutation UpdateSettings($id: String!, $bcSetting: BCSettingsInput, $spSetting: SPSettingsInput, $smsSetting: SMSSettingsInput, $smtpSetting: SmtpSettingsInput, $catalogNotificationSetting: CatalogNotificationSettingInput, $invoiceSetting: InvoiceSettingsInput, $in4moSetting: In4moSettingsInput, $drivingSlipCategoryMappingSettings: DrivingSlipCategoryMappingSettingsInput, $machineNotificationSetting: MachineNotificationSettingInput) {
  updateSetting(
    id: $id
    bcSetting: $bcSetting
    spSetting: $spSetting
    smsSetting: $smsSetting
    smtpSetting: $smtpSetting
    catalogNotificationSetting: $catalogNotificationSetting
    invoiceSetting: $invoiceSetting
    in4moSetting: $in4moSetting
    drivingSlipCategoryMappingSettings: $drivingSlipCategoryMappingSettings
    machineNotificationSetting: $machineNotificationSetting
  ) {
    ... on BCSettings {
      id
    }
    ... on SPSettings {
      id
    }
    ... on SMSSettings {
      id
    }
    ... on SmtpSettings {
      id
    }
    ... on CatalogNotificationSetting {
      id
    }
    ... on InvoiceSettings {
      id
    }
    ... on In4moSettings {
      id
    }
    ... on DrivingSlipCategoryMappingSettings {
      id
    }
    ... on MachineNotificationSetting {
      id
    }
  }
}
    `;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bcSetting: // value for 'bcSetting'
 *      spSetting: // value for 'spSetting'
 *      smsSetting: // value for 'smsSetting'
 *      smtpSetting: // value for 'smtpSetting'
 *      catalogNotificationSetting: // value for 'catalogNotificationSetting'
 *      invoiceSetting: // value for 'invoiceSetting'
 *      in4moSetting: // value for 'in4moSetting'
 *      drivingSlipCategoryMappingSettings: // value for 'drivingSlipCategoryMappingSettings'
 *      machineNotificationSetting: // value for 'machineNotificationSetting'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
}
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const CreateBusinessAreaDocument = gql`
    mutation CreateBusinessArea($business: BusinessAreaInputType!) {
  createBusinessArea(business: $business) {
    ...BaseBusinessAreaFragment
  }
}
    ${BaseBusinessAreaFragmentFragmentDoc}`;
export type CreateBusinessAreaMutationFn = Apollo.MutationFunction<CreateBusinessAreaMutation, CreateBusinessAreaMutationVariables>;

/**
 * __useCreateBusinessAreaMutation__
 *
 * To run a mutation, you first call `useCreateBusinessAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessAreaMutation, { data, loading, error }] = useCreateBusinessAreaMutation({
 *   variables: {
 *      business: // value for 'business'
 *   },
 * });
 */
export function useCreateBusinessAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessAreaMutation, CreateBusinessAreaMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateBusinessAreaMutation, CreateBusinessAreaMutationVariables>(CreateBusinessAreaDocument, options);
}
export type CreateBusinessAreaMutationHookResult = ReturnType<typeof useCreateBusinessAreaMutation>;
export type CreateBusinessAreaMutationResult = Apollo.MutationResult<CreateBusinessAreaMutation>;
export type CreateBusinessAreaMutationOptions = Apollo.BaseMutationOptions<CreateBusinessAreaMutation, CreateBusinessAreaMutationVariables>;
export const DeleteBusinessAreaDocument = gql`
    mutation DeleteBusinessArea($id: String!) {
  deleteBusinessArea(id: $id) {
    _
  }
}
    `;
export type DeleteBusinessAreaMutationFn = Apollo.MutationFunction<DeleteBusinessAreaMutation, DeleteBusinessAreaMutationVariables>;

/**
 * __useDeleteBusinessAreaMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessAreaMutation, { data, loading, error }] = useDeleteBusinessAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBusinessAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessAreaMutation, DeleteBusinessAreaMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteBusinessAreaMutation, DeleteBusinessAreaMutationVariables>(DeleteBusinessAreaDocument, options);
}
export type DeleteBusinessAreaMutationHookResult = ReturnType<typeof useDeleteBusinessAreaMutation>;
export type DeleteBusinessAreaMutationResult = Apollo.MutationResult<DeleteBusinessAreaMutation>;
export type DeleteBusinessAreaMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessAreaMutation, DeleteBusinessAreaMutationVariables>;
export const GetBusinessAreaDocument = gql`
    query GetBusinessArea {
  businessAreas {
    ...BaseBusinessAreaFragment
  }
}
    ${BaseBusinessAreaFragmentFragmentDoc}`;

/**
 * __useGetBusinessAreaQuery__
 *
 * To run a query within a React component, call `useGetBusinessAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAreaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessAreaQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessAreaQuery, GetBusinessAreaQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetBusinessAreaQuery, GetBusinessAreaQueryVariables>(GetBusinessAreaDocument, options);
}
export function useGetBusinessAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessAreaQuery, GetBusinessAreaQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetBusinessAreaQuery, GetBusinessAreaQueryVariables>(GetBusinessAreaDocument, options);
}
export function useGetBusinessAreaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessAreaQuery, GetBusinessAreaQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetBusinessAreaQuery, GetBusinessAreaQueryVariables>(GetBusinessAreaDocument, options);
}
export type GetBusinessAreaQueryHookResult = ReturnType<typeof useGetBusinessAreaQuery>;
export type GetBusinessAreaLazyQueryHookResult = ReturnType<typeof useGetBusinessAreaLazyQuery>;
export type GetBusinessAreaSuspenseQueryHookResult = ReturnType<typeof useGetBusinessAreaSuspenseQuery>;
export type GetBusinessAreaQueryResult = Apollo.QueryResult<GetBusinessAreaQuery, GetBusinessAreaQueryVariables>;
export function refetchGetBusinessAreaQuery(variables?: GetBusinessAreaQueryVariables) {
  return { query: GetBusinessAreaDocument, variables: variables }
}
export const UpdateBusinessAreaDocument = gql`
    mutation UpdateBusinessArea($id: String!, $name: String!) {
  updateBusinessArea(id: $id, name: $name) {
    ...BaseBusinessAreaFragment
  }
}
    ${BaseBusinessAreaFragmentFragmentDoc}`;
export type UpdateBusinessAreaMutationFn = Apollo.MutationFunction<UpdateBusinessAreaMutation, UpdateBusinessAreaMutationVariables>;

/**
 * __useUpdateBusinessAreaMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAreaMutation, { data, loading, error }] = useUpdateBusinessAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateBusinessAreaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAreaMutation, UpdateBusinessAreaMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateBusinessAreaMutation, UpdateBusinessAreaMutationVariables>(UpdateBusinessAreaDocument, options);
}
export type UpdateBusinessAreaMutationHookResult = ReturnType<typeof useUpdateBusinessAreaMutation>;
export type UpdateBusinessAreaMutationResult = Apollo.MutationResult<UpdateBusinessAreaMutation>;
export type UpdateBusinessAreaMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAreaMutation, UpdateBusinessAreaMutationVariables>;
export const GetAdminCaseAdminDataDocument = gql`
    query GetAdminCaseAdminData {
  damageCategories {
    ...BaseDamageCategoryFragment
  }
  damageCauses {
    ...BaseDamageCauseFragment
  }
  departments {
    ...BaseDepartmentFragment
  }
  locations {
    ...BaseLocationFragment
  }
  usersWithCalendars {
    ...BaseUserFragment
    plannerHelpText
    plannerHelpTextUpdatedAt
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}`;

/**
 * __useGetAdminCaseAdminDataQuery__
 *
 * To run a query within a React component, call `useGetAdminCaseAdminDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCaseAdminDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCaseAdminDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminCaseAdminDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminCaseAdminDataQuery, GetAdminCaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminCaseAdminDataQuery, GetAdminCaseAdminDataQueryVariables>(GetAdminCaseAdminDataDocument, options);
}
export function useGetAdminCaseAdminDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCaseAdminDataQuery, GetAdminCaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminCaseAdminDataQuery, GetAdminCaseAdminDataQueryVariables>(GetAdminCaseAdminDataDocument, options);
}
export function useGetAdminCaseAdminDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminCaseAdminDataQuery, GetAdminCaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminCaseAdminDataQuery, GetAdminCaseAdminDataQueryVariables>(GetAdminCaseAdminDataDocument, options);
}
export type GetAdminCaseAdminDataQueryHookResult = ReturnType<typeof useGetAdminCaseAdminDataQuery>;
export type GetAdminCaseAdminDataLazyQueryHookResult = ReturnType<typeof useGetAdminCaseAdminDataLazyQuery>;
export type GetAdminCaseAdminDataSuspenseQueryHookResult = ReturnType<typeof useGetAdminCaseAdminDataSuspenseQuery>;
export type GetAdminCaseAdminDataQueryResult = Apollo.QueryResult<GetAdminCaseAdminDataQuery, GetAdminCaseAdminDataQueryVariables>;
export function refetchGetAdminCaseAdminDataQuery(variables?: GetAdminCaseAdminDataQueryVariables) {
  return { query: GetAdminCaseAdminDataDocument, variables: variables }
}
export const GetAdminCasesDocument = gql`
    query GetAdminCases($closedCases: Boolean, $minDate: Date, $maxDate: Date, $erpReferenceNo: String) {
  cases(
    closedCases: $closedCases
    minDate: $minDate
    maxDate: $maxDate
    erpReferenceNo: $erpReferenceNo
  ) {
    id
    erpNo
    status
  }
}
    `;

/**
 * __useGetAdminCasesQuery__
 *
 * To run a query within a React component, call `useGetAdminCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCasesQuery({
 *   variables: {
 *      closedCases: // value for 'closedCases'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *   },
 * });
 */
export function useGetAdminCasesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminCasesQuery, GetAdminCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminCasesQuery, GetAdminCasesQueryVariables>(GetAdminCasesDocument, options);
}
export function useGetAdminCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCasesQuery, GetAdminCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminCasesQuery, GetAdminCasesQueryVariables>(GetAdminCasesDocument, options);
}
export function useGetAdminCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminCasesQuery, GetAdminCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminCasesQuery, GetAdminCasesQueryVariables>(GetAdminCasesDocument, options);
}
export type GetAdminCasesQueryHookResult = ReturnType<typeof useGetAdminCasesQuery>;
export type GetAdminCasesLazyQueryHookResult = ReturnType<typeof useGetAdminCasesLazyQuery>;
export type GetAdminCasesSuspenseQueryHookResult = ReturnType<typeof useGetAdminCasesSuspenseQuery>;
export type GetAdminCasesQueryResult = Apollo.QueryResult<GetAdminCasesQuery, GetAdminCasesQueryVariables>;
export function refetchGetAdminCasesQuery(variables?: GetAdminCasesQueryVariables) {
  return { query: GetAdminCasesDocument, variables: variables }
}
export const GetCasesNotPostedInBcDocument = gql`
    query GetCasesNotPostedInBc {
  casesNotPostedInBc {
    caseErpNo
    erpReferenceNo
    status
  }
}
    `;

/**
 * __useGetCasesNotPostedInBcQuery__
 *
 * To run a query within a React component, call `useGetCasesNotPostedInBcQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesNotPostedInBcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesNotPostedInBcQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCasesNotPostedInBcQuery(baseOptions?: Apollo.QueryHookOptions<GetCasesNotPostedInBcQuery, GetCasesNotPostedInBcQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCasesNotPostedInBcQuery, GetCasesNotPostedInBcQueryVariables>(GetCasesNotPostedInBcDocument, options);
}
export function useGetCasesNotPostedInBcLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesNotPostedInBcQuery, GetCasesNotPostedInBcQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCasesNotPostedInBcQuery, GetCasesNotPostedInBcQueryVariables>(GetCasesNotPostedInBcDocument, options);
}
export function useGetCasesNotPostedInBcSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasesNotPostedInBcQuery, GetCasesNotPostedInBcQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCasesNotPostedInBcQuery, GetCasesNotPostedInBcQueryVariables>(GetCasesNotPostedInBcDocument, options);
}
export type GetCasesNotPostedInBcQueryHookResult = ReturnType<typeof useGetCasesNotPostedInBcQuery>;
export type GetCasesNotPostedInBcLazyQueryHookResult = ReturnType<typeof useGetCasesNotPostedInBcLazyQuery>;
export type GetCasesNotPostedInBcSuspenseQueryHookResult = ReturnType<typeof useGetCasesNotPostedInBcSuspenseQuery>;
export type GetCasesNotPostedInBcQueryResult = Apollo.QueryResult<GetCasesNotPostedInBcQuery, GetCasesNotPostedInBcQueryVariables>;
export function refetchGetCasesNotPostedInBcQuery(variables?: GetCasesNotPostedInBcQueryVariables) {
  return { query: GetCasesNotPostedInBcDocument, variables: variables }
}
export const AddRemoveUsersToAllCatalogCustomersDocument = gql`
    mutation AddRemoveUsersToAllCatalogCustomers($adUsers: [String!]!, $add: Boolean!) {
  addRemoveUsersToAllCatalogCustomers(adUsers: $adUsers, add: $add)
}
    `;
export type AddRemoveUsersToAllCatalogCustomersMutationFn = Apollo.MutationFunction<AddRemoveUsersToAllCatalogCustomersMutation, AddRemoveUsersToAllCatalogCustomersMutationVariables>;

/**
 * __useAddRemoveUsersToAllCatalogCustomersMutation__
 *
 * To run a mutation, you first call `useAddRemoveUsersToAllCatalogCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRemoveUsersToAllCatalogCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRemoveUsersToAllCatalogCustomersMutation, { data, loading, error }] = useAddRemoveUsersToAllCatalogCustomersMutation({
 *   variables: {
 *      adUsers: // value for 'adUsers'
 *      add: // value for 'add'
 *   },
 * });
 */
export function useAddRemoveUsersToAllCatalogCustomersMutation(baseOptions?: Apollo.MutationHookOptions<AddRemoveUsersToAllCatalogCustomersMutation, AddRemoveUsersToAllCatalogCustomersMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddRemoveUsersToAllCatalogCustomersMutation, AddRemoveUsersToAllCatalogCustomersMutationVariables>(AddRemoveUsersToAllCatalogCustomersDocument, options);
}
export type AddRemoveUsersToAllCatalogCustomersMutationHookResult = ReturnType<typeof useAddRemoveUsersToAllCatalogCustomersMutation>;
export type AddRemoveUsersToAllCatalogCustomersMutationResult = Apollo.MutationResult<AddRemoveUsersToAllCatalogCustomersMutation>;
export type AddRemoveUsersToAllCatalogCustomersMutationOptions = Apollo.BaseMutationOptions<AddRemoveUsersToAllCatalogCustomersMutation, AddRemoveUsersToAllCatalogCustomersMutationVariables>;
export const CreateCatalogCustomerDocument = gql`
    mutation CreateCatalogCustomer($catalogCustomer: CatalogCustomerInputType!) {
  createCatalogCustomer(catalogCustomer: $catalogCustomer) {
    ...BaseCatalogCustomerFragment
  }
}
    ${BaseCatalogCustomerFragmentFragmentDoc}`;
export type CreateCatalogCustomerMutationFn = Apollo.MutationFunction<CreateCatalogCustomerMutation, CreateCatalogCustomerMutationVariables>;

/**
 * __useCreateCatalogCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCatalogCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCatalogCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCatalogCustomerMutation, { data, loading, error }] = useCreateCatalogCustomerMutation({
 *   variables: {
 *      catalogCustomer: // value for 'catalogCustomer'
 *   },
 * });
 */
export function useCreateCatalogCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCatalogCustomerMutation, CreateCatalogCustomerMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCatalogCustomerMutation, CreateCatalogCustomerMutationVariables>(CreateCatalogCustomerDocument, options);
}
export type CreateCatalogCustomerMutationHookResult = ReturnType<typeof useCreateCatalogCustomerMutation>;
export type CreateCatalogCustomerMutationResult = Apollo.MutationResult<CreateCatalogCustomerMutation>;
export type CreateCatalogCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCatalogCustomerMutation, CreateCatalogCustomerMutationVariables>;
export const DeleteCatalogCustomerDocument = gql`
    mutation DeleteCatalogCustomer($id: String!) {
  deleteCatalogCustomer(id: $id) {
    _
  }
}
    `;
export type DeleteCatalogCustomerMutationFn = Apollo.MutationFunction<DeleteCatalogCustomerMutation, DeleteCatalogCustomerMutationVariables>;

/**
 * __useDeleteCatalogCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCatalogCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCatalogCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCatalogCustomerMutation, { data, loading, error }] = useDeleteCatalogCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCatalogCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCatalogCustomerMutation, DeleteCatalogCustomerMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCatalogCustomerMutation, DeleteCatalogCustomerMutationVariables>(DeleteCatalogCustomerDocument, options);
}
export type DeleteCatalogCustomerMutationHookResult = ReturnType<typeof useDeleteCatalogCustomerMutation>;
export type DeleteCatalogCustomerMutationResult = Apollo.MutationResult<DeleteCatalogCustomerMutation>;
export type DeleteCatalogCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCatalogCustomerMutation, DeleteCatalogCustomerMutationVariables>;
export const GetAdminCatalogCustomersDocument = gql`
    query GetAdminCatalogCustomers {
  catalogCustomers {
    ...BaseCatalogCustomerFragment
  }
}
    ${BaseCatalogCustomerFragmentFragmentDoc}`;

/**
 * __useGetAdminCatalogCustomersQuery__
 *
 * To run a query within a React component, call `useGetAdminCatalogCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCatalogCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCatalogCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminCatalogCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminCatalogCustomersQuery, GetAdminCatalogCustomersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminCatalogCustomersQuery, GetAdminCatalogCustomersQueryVariables>(GetAdminCatalogCustomersDocument, options);
}
export function useGetAdminCatalogCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCatalogCustomersQuery, GetAdminCatalogCustomersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminCatalogCustomersQuery, GetAdminCatalogCustomersQueryVariables>(GetAdminCatalogCustomersDocument, options);
}
export function useGetAdminCatalogCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminCatalogCustomersQuery, GetAdminCatalogCustomersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminCatalogCustomersQuery, GetAdminCatalogCustomersQueryVariables>(GetAdminCatalogCustomersDocument, options);
}
export type GetAdminCatalogCustomersQueryHookResult = ReturnType<typeof useGetAdminCatalogCustomersQuery>;
export type GetAdminCatalogCustomersLazyQueryHookResult = ReturnType<typeof useGetAdminCatalogCustomersLazyQuery>;
export type GetAdminCatalogCustomersSuspenseQueryHookResult = ReturnType<typeof useGetAdminCatalogCustomersSuspenseQuery>;
export type GetAdminCatalogCustomersQueryResult = Apollo.QueryResult<GetAdminCatalogCustomersQuery, GetAdminCatalogCustomersQueryVariables>;
export function refetchGetAdminCatalogCustomersQuery(variables?: GetAdminCatalogCustomersQueryVariables) {
  return { query: GetAdminCatalogCustomersDocument, variables: variables }
}
export const UpdateCatalogCustomerDocument = gql`
    mutation UpdateCatalogCustomer($id: String!, $name: String!, $adUsers: [String!]!) {
  updateCatalogCustomer(id: $id, name: $name, adUsers: $adUsers) {
    ...BaseCatalogCustomerFragment
  }
}
    ${BaseCatalogCustomerFragmentFragmentDoc}`;
export type UpdateCatalogCustomerMutationFn = Apollo.MutationFunction<UpdateCatalogCustomerMutation, UpdateCatalogCustomerMutationVariables>;

/**
 * __useUpdateCatalogCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCatalogCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCatalogCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCatalogCustomerMutation, { data, loading, error }] = useUpdateCatalogCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      adUsers: // value for 'adUsers'
 *   },
 * });
 */
export function useUpdateCatalogCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCatalogCustomerMutation, UpdateCatalogCustomerMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCatalogCustomerMutation, UpdateCatalogCustomerMutationVariables>(UpdateCatalogCustomerDocument, options);
}
export type UpdateCatalogCustomerMutationHookResult = ReturnType<typeof useUpdateCatalogCustomerMutation>;
export type UpdateCatalogCustomerMutationResult = Apollo.MutationResult<UpdateCatalogCustomerMutation>;
export type UpdateCatalogCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCatalogCustomerMutation, UpdateCatalogCustomerMutationVariables>;
export const GetAdminCatalogsDocument = gql`
    query GetAdminCatalogs($customerIds: [String!]!) {
  catalogs(customerIds: $customerIds) {
    id
    propertyNumber
    craftsmen {
      id
      contactName
    }
    contacts {
      id
      contactName
    }
    timedMessages {
      id
      message
    }
  }
}
    `;

/**
 * __useGetAdminCatalogsQuery__
 *
 * To run a query within a React component, call `useGetAdminCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCatalogsQuery({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useGetAdminCatalogsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminCatalogsQuery, GetAdminCatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminCatalogsQuery, GetAdminCatalogsQueryVariables>(GetAdminCatalogsDocument, options);
}
export function useGetAdminCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCatalogsQuery, GetAdminCatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminCatalogsQuery, GetAdminCatalogsQueryVariables>(GetAdminCatalogsDocument, options);
}
export function useGetAdminCatalogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminCatalogsQuery, GetAdminCatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminCatalogsQuery, GetAdminCatalogsQueryVariables>(GetAdminCatalogsDocument, options);
}
export type GetAdminCatalogsQueryHookResult = ReturnType<typeof useGetAdminCatalogsQuery>;
export type GetAdminCatalogsLazyQueryHookResult = ReturnType<typeof useGetAdminCatalogsLazyQuery>;
export type GetAdminCatalogsSuspenseQueryHookResult = ReturnType<typeof useGetAdminCatalogsSuspenseQuery>;
export type GetAdminCatalogsQueryResult = Apollo.QueryResult<GetAdminCatalogsQuery, GetAdminCatalogsQueryVariables>;
export function refetchGetAdminCatalogsQuery(variables: GetAdminCatalogsQueryVariables) {
  return { query: GetAdminCatalogsDocument, variables: variables }
}
export const CreateCollectionItemDocument = gql`
    mutation CreateCollectionItem($collectionItem: CollectionItemInputType!) {
  createCollectionItem(collectionItem: $collectionItem) {
    ...BaseCollectionItemFragment
  }
}
    ${BaseCollectionItemFragmentFragmentDoc}`;
export type CreateCollectionItemMutationFn = Apollo.MutationFunction<CreateCollectionItemMutation, CreateCollectionItemMutationVariables>;

/**
 * __useCreateCollectionItemMutation__
 *
 * To run a mutation, you first call `useCreateCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionItemMutation, { data, loading, error }] = useCreateCollectionItemMutation({
 *   variables: {
 *      collectionItem: // value for 'collectionItem'
 *   },
 * });
 */
export function useCreateCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionItemMutation, CreateCollectionItemMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCollectionItemMutation, CreateCollectionItemMutationVariables>(CreateCollectionItemDocument, options);
}
export type CreateCollectionItemMutationHookResult = ReturnType<typeof useCreateCollectionItemMutation>;
export type CreateCollectionItemMutationResult = Apollo.MutationResult<CreateCollectionItemMutation>;
export type CreateCollectionItemMutationOptions = Apollo.BaseMutationOptions<CreateCollectionItemMutation, CreateCollectionItemMutationVariables>;
export const DeleteCollectionItemDocument = gql`
    mutation DeleteCollectionItem($id: String!) {
  deleteCollectionItem(id: $id) {
    _
  }
}
    `;
export type DeleteCollectionItemMutationFn = Apollo.MutationFunction<DeleteCollectionItemMutation, DeleteCollectionItemMutationVariables>;

/**
 * __useDeleteCollectionItemMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionItemMutation, { data, loading, error }] = useDeleteCollectionItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollectionItemMutation, DeleteCollectionItemMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCollectionItemMutation, DeleteCollectionItemMutationVariables>(DeleteCollectionItemDocument, options);
}
export type DeleteCollectionItemMutationHookResult = ReturnType<typeof useDeleteCollectionItemMutation>;
export type DeleteCollectionItemMutationResult = Apollo.MutationResult<DeleteCollectionItemMutation>;
export type DeleteCollectionItemMutationOptions = Apollo.BaseMutationOptions<DeleteCollectionItemMutation, DeleteCollectionItemMutationVariables>;
export const GetCollectionItemsDocument = gql`
    query GetCollectionItems($type: CollectionItemType) {
  collectionItems(type: $type) {
    ...BaseCollectionItemFragment
  }
}
    ${BaseCollectionItemFragmentFragmentDoc}`;

/**
 * __useGetCollectionItemsQuery__
 *
 * To run a query within a React component, call `useGetCollectionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionItemsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetCollectionItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionItemsQuery, GetCollectionItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCollectionItemsQuery, GetCollectionItemsQueryVariables>(GetCollectionItemsDocument, options);
}
export function useGetCollectionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionItemsQuery, GetCollectionItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCollectionItemsQuery, GetCollectionItemsQueryVariables>(GetCollectionItemsDocument, options);
}
export function useGetCollectionItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCollectionItemsQuery, GetCollectionItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCollectionItemsQuery, GetCollectionItemsQueryVariables>(GetCollectionItemsDocument, options);
}
export type GetCollectionItemsQueryHookResult = ReturnType<typeof useGetCollectionItemsQuery>;
export type GetCollectionItemsLazyQueryHookResult = ReturnType<typeof useGetCollectionItemsLazyQuery>;
export type GetCollectionItemsSuspenseQueryHookResult = ReturnType<typeof useGetCollectionItemsSuspenseQuery>;
export type GetCollectionItemsQueryResult = Apollo.QueryResult<GetCollectionItemsQuery, GetCollectionItemsQueryVariables>;
export function refetchGetCollectionItemsQuery(variables?: GetCollectionItemsQueryVariables) {
  return { query: GetCollectionItemsDocument, variables: variables }
}
export const UpdateCollectionItemDocument = gql`
    mutation UpdateCollectionItem($id: String!, $name: String, $type: CollectionItemType) {
  updateCollectionItem(id: $id, name: $name, type: $type) {
    ...BaseCollectionItemFragment
  }
}
    ${BaseCollectionItemFragmentFragmentDoc}`;
export type UpdateCollectionItemMutationFn = Apollo.MutationFunction<UpdateCollectionItemMutation, UpdateCollectionItemMutationVariables>;

/**
 * __useUpdateCollectionItemMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionItemMutation, { data, loading, error }] = useUpdateCollectionItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionItemMutation, UpdateCollectionItemMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCollectionItemMutation, UpdateCollectionItemMutationVariables>(UpdateCollectionItemDocument, options);
}
export type UpdateCollectionItemMutationHookResult = ReturnType<typeof useUpdateCollectionItemMutation>;
export type UpdateCollectionItemMutationResult = Apollo.MutationResult<UpdateCollectionItemMutation>;
export type UpdateCollectionItemMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionItemMutation, UpdateCollectionItemMutationVariables>;
export const CreateDamageCategoryDocument = gql`
    mutation CreateDamageCategory($damageCategory: DamageCategoryInputType!) {
  createDamageCategory(damageCategory: $damageCategory) {
    ...BaseDamageCategoryFragment
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}`;
export type CreateDamageCategoryMutationFn = Apollo.MutationFunction<CreateDamageCategoryMutation, CreateDamageCategoryMutationVariables>;

/**
 * __useCreateDamageCategoryMutation__
 *
 * To run a mutation, you first call `useCreateDamageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDamageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDamageCategoryMutation, { data, loading, error }] = useCreateDamageCategoryMutation({
 *   variables: {
 *      damageCategory: // value for 'damageCategory'
 *   },
 * });
 */
export function useCreateDamageCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDamageCategoryMutation, CreateDamageCategoryMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDamageCategoryMutation, CreateDamageCategoryMutationVariables>(CreateDamageCategoryDocument, options);
}
export type CreateDamageCategoryMutationHookResult = ReturnType<typeof useCreateDamageCategoryMutation>;
export type CreateDamageCategoryMutationResult = Apollo.MutationResult<CreateDamageCategoryMutation>;
export type CreateDamageCategoryMutationOptions = Apollo.BaseMutationOptions<CreateDamageCategoryMutation, CreateDamageCategoryMutationVariables>;
export const DeleteDamageCategoryDocument = gql`
    mutation DeleteDamageCategory($id: String!) {
  deleteDamageCategory(id: $id) {
    _
  }
}
    `;
export type DeleteDamageCategoryMutationFn = Apollo.MutationFunction<DeleteDamageCategoryMutation, DeleteDamageCategoryMutationVariables>;

/**
 * __useDeleteDamageCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteDamageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDamageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDamageCategoryMutation, { data, loading, error }] = useDeleteDamageCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDamageCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDamageCategoryMutation, DeleteDamageCategoryMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDamageCategoryMutation, DeleteDamageCategoryMutationVariables>(DeleteDamageCategoryDocument, options);
}
export type DeleteDamageCategoryMutationHookResult = ReturnType<typeof useDeleteDamageCategoryMutation>;
export type DeleteDamageCategoryMutationResult = Apollo.MutationResult<DeleteDamageCategoryMutation>;
export type DeleteDamageCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteDamageCategoryMutation, DeleteDamageCategoryMutationVariables>;
export const GetAdminDamageCategoriesDocument = gql`
    query GetAdminDamageCategories {
  damageCategoriesAdmin {
    ...BaseDamageCategoryFragment
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}`;

/**
 * __useGetAdminDamageCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAdminDamageCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDamageCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDamageCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminDamageCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDamageCategoriesQuery, GetAdminDamageCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminDamageCategoriesQuery, GetAdminDamageCategoriesQueryVariables>(GetAdminDamageCategoriesDocument, options);
}
export function useGetAdminDamageCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDamageCategoriesQuery, GetAdminDamageCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminDamageCategoriesQuery, GetAdminDamageCategoriesQueryVariables>(GetAdminDamageCategoriesDocument, options);
}
export function useGetAdminDamageCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminDamageCategoriesQuery, GetAdminDamageCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminDamageCategoriesQuery, GetAdminDamageCategoriesQueryVariables>(GetAdminDamageCategoriesDocument, options);
}
export type GetAdminDamageCategoriesQueryHookResult = ReturnType<typeof useGetAdminDamageCategoriesQuery>;
export type GetAdminDamageCategoriesLazyQueryHookResult = ReturnType<typeof useGetAdminDamageCategoriesLazyQuery>;
export type GetAdminDamageCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetAdminDamageCategoriesSuspenseQuery>;
export type GetAdminDamageCategoriesQueryResult = Apollo.QueryResult<GetAdminDamageCategoriesQuery, GetAdminDamageCategoriesQueryVariables>;
export function refetchGetAdminDamageCategoriesQuery(variables?: GetAdminDamageCategoriesQueryVariables) {
  return { query: GetAdminDamageCategoriesDocument, variables: variables }
}
export const UpdateDamageCategoryDocument = gql`
    mutation UpdateDamageCategory($id: String!, $name: String!) {
  updateDamageCategory(id: $id, name: $name) {
    ...BaseDamageCategoryFragment
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}`;
export type UpdateDamageCategoryMutationFn = Apollo.MutationFunction<UpdateDamageCategoryMutation, UpdateDamageCategoryMutationVariables>;

/**
 * __useUpdateDamageCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateDamageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDamageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDamageCategoryMutation, { data, loading, error }] = useUpdateDamageCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateDamageCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDamageCategoryMutation, UpdateDamageCategoryMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateDamageCategoryMutation, UpdateDamageCategoryMutationVariables>(UpdateDamageCategoryDocument, options);
}
export type UpdateDamageCategoryMutationHookResult = ReturnType<typeof useUpdateDamageCategoryMutation>;
export type UpdateDamageCategoryMutationResult = Apollo.MutationResult<UpdateDamageCategoryMutation>;
export type UpdateDamageCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateDamageCategoryMutation, UpdateDamageCategoryMutationVariables>;
export const CreateDamageCauseDocument = gql`
    mutation CreateDamageCause($damageCause: DamageCauseInputType!) {
  createDamageCause(damageCause: $damageCause) {
    ...BaseDamageCauseFragment
  }
}
    ${BaseDamageCauseFragmentFragmentDoc}`;
export type CreateDamageCauseMutationFn = Apollo.MutationFunction<CreateDamageCauseMutation, CreateDamageCauseMutationVariables>;

/**
 * __useCreateDamageCauseMutation__
 *
 * To run a mutation, you first call `useCreateDamageCauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDamageCauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDamageCauseMutation, { data, loading, error }] = useCreateDamageCauseMutation({
 *   variables: {
 *      damageCause: // value for 'damageCause'
 *   },
 * });
 */
export function useCreateDamageCauseMutation(baseOptions?: Apollo.MutationHookOptions<CreateDamageCauseMutation, CreateDamageCauseMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDamageCauseMutation, CreateDamageCauseMutationVariables>(CreateDamageCauseDocument, options);
}
export type CreateDamageCauseMutationHookResult = ReturnType<typeof useCreateDamageCauseMutation>;
export type CreateDamageCauseMutationResult = Apollo.MutationResult<CreateDamageCauseMutation>;
export type CreateDamageCauseMutationOptions = Apollo.BaseMutationOptions<CreateDamageCauseMutation, CreateDamageCauseMutationVariables>;
export const DeleteDamageCauseDocument = gql`
    mutation DeleteDamageCause($id: String!) {
  deleteDamageCause(id: $id) {
    _
  }
}
    `;
export type DeleteDamageCauseMutationFn = Apollo.MutationFunction<DeleteDamageCauseMutation, DeleteDamageCauseMutationVariables>;

/**
 * __useDeleteDamageCauseMutation__
 *
 * To run a mutation, you first call `useDeleteDamageCauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDamageCauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDamageCauseMutation, { data, loading, error }] = useDeleteDamageCauseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDamageCauseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDamageCauseMutation, DeleteDamageCauseMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDamageCauseMutation, DeleteDamageCauseMutationVariables>(DeleteDamageCauseDocument, options);
}
export type DeleteDamageCauseMutationHookResult = ReturnType<typeof useDeleteDamageCauseMutation>;
export type DeleteDamageCauseMutationResult = Apollo.MutationResult<DeleteDamageCauseMutation>;
export type DeleteDamageCauseMutationOptions = Apollo.BaseMutationOptions<DeleteDamageCauseMutation, DeleteDamageCauseMutationVariables>;
export const GetAdminDamageCausesDocument = gql`
    query GetAdminDamageCauses($useLimitations: Boolean, $category: String) {
  damageCausesAdmin(useLimitations: $useLimitations, category: $category) {
    ...BaseDamageCauseFragment
  }
}
    ${BaseDamageCauseFragmentFragmentDoc}`;

/**
 * __useGetAdminDamageCausesQuery__
 *
 * To run a query within a React component, call `useGetAdminDamageCausesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDamageCausesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDamageCausesQuery({
 *   variables: {
 *      useLimitations: // value for 'useLimitations'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetAdminDamageCausesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDamageCausesQuery, GetAdminDamageCausesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminDamageCausesQuery, GetAdminDamageCausesQueryVariables>(GetAdminDamageCausesDocument, options);
}
export function useGetAdminDamageCausesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDamageCausesQuery, GetAdminDamageCausesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminDamageCausesQuery, GetAdminDamageCausesQueryVariables>(GetAdminDamageCausesDocument, options);
}
export function useGetAdminDamageCausesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminDamageCausesQuery, GetAdminDamageCausesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminDamageCausesQuery, GetAdminDamageCausesQueryVariables>(GetAdminDamageCausesDocument, options);
}
export type GetAdminDamageCausesQueryHookResult = ReturnType<typeof useGetAdminDamageCausesQuery>;
export type GetAdminDamageCausesLazyQueryHookResult = ReturnType<typeof useGetAdminDamageCausesLazyQuery>;
export type GetAdminDamageCausesSuspenseQueryHookResult = ReturnType<typeof useGetAdminDamageCausesSuspenseQuery>;
export type GetAdminDamageCausesQueryResult = Apollo.QueryResult<GetAdminDamageCausesQuery, GetAdminDamageCausesQueryVariables>;
export function refetchGetAdminDamageCausesQuery(variables?: GetAdminDamageCausesQueryVariables) {
  return { query: GetAdminDamageCausesDocument, variables: variables }
}
export const GetDamageCauseDocument = gql`
    query GetDamageCause($id: String!) {
  damageCause(id: $id) {
    ...BaseDamageCauseFragment
  }
}
    ${BaseDamageCauseFragmentFragmentDoc}`;

/**
 * __useGetDamageCauseQuery__
 *
 * To run a query within a React component, call `useGetDamageCauseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDamageCauseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDamageCauseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDamageCauseQuery(baseOptions: Apollo.QueryHookOptions<GetDamageCauseQuery, GetDamageCauseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDamageCauseQuery, GetDamageCauseQueryVariables>(GetDamageCauseDocument, options);
}
export function useGetDamageCauseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDamageCauseQuery, GetDamageCauseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDamageCauseQuery, GetDamageCauseQueryVariables>(GetDamageCauseDocument, options);
}
export function useGetDamageCauseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDamageCauseQuery, GetDamageCauseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDamageCauseQuery, GetDamageCauseQueryVariables>(GetDamageCauseDocument, options);
}
export type GetDamageCauseQueryHookResult = ReturnType<typeof useGetDamageCauseQuery>;
export type GetDamageCauseLazyQueryHookResult = ReturnType<typeof useGetDamageCauseLazyQuery>;
export type GetDamageCauseSuspenseQueryHookResult = ReturnType<typeof useGetDamageCauseSuspenseQuery>;
export type GetDamageCauseQueryResult = Apollo.QueryResult<GetDamageCauseQuery, GetDamageCauseQueryVariables>;
export function refetchGetDamageCauseQuery(variables: GetDamageCauseQueryVariables) {
  return { query: GetDamageCauseDocument, variables: variables }
}
export const UpdateDamageCauseDocument = gql`
    mutation UpdateDamageCause($id: String!, $name: String!, $departments: [String!], $category: String!, $business: String!, $track: Int!, $urgent: Boolean!) {
  updateDamageCause(
    id: $id
    name: $name
    departments: $departments
    category: $category
    business: $business
    track: $track
    urgent: $urgent
  ) {
    ...BaseDamageCauseFragment
  }
}
    ${BaseDamageCauseFragmentFragmentDoc}`;
export type UpdateDamageCauseMutationFn = Apollo.MutationFunction<UpdateDamageCauseMutation, UpdateDamageCauseMutationVariables>;

/**
 * __useUpdateDamageCauseMutation__
 *
 * To run a mutation, you first call `useUpdateDamageCauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDamageCauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDamageCauseMutation, { data, loading, error }] = useUpdateDamageCauseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      departments: // value for 'departments'
 *      category: // value for 'category'
 *      business: // value for 'business'
 *      track: // value for 'track'
 *      urgent: // value for 'urgent'
 *   },
 * });
 */
export function useUpdateDamageCauseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDamageCauseMutation, UpdateDamageCauseMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateDamageCauseMutation, UpdateDamageCauseMutationVariables>(UpdateDamageCauseDocument, options);
}
export type UpdateDamageCauseMutationHookResult = ReturnType<typeof useUpdateDamageCauseMutation>;
export type UpdateDamageCauseMutationResult = Apollo.MutationResult<UpdateDamageCauseMutation>;
export type UpdateDamageCauseMutationOptions = Apollo.BaseMutationOptions<UpdateDamageCauseMutation, UpdateDamageCauseMutationVariables>;
export const CreateDebitorDelayScalepointConnectionDocument = gql`
    mutation CreateDebitorDelayScalepointConnection($debitorId: String!, $damageCauseIds: [String!]!) {
  createDebitorDelayScalepointConnection(
    debitorId: $debitorId
    damageCauseIds: $damageCauseIds
  ) {
    ...DebitorDelayScalepointConnectionFragment
  }
}
    ${DebitorDelayScalepointConnectionFragmentFragmentDoc}`;
export type CreateDebitorDelayScalepointConnectionMutationFn = Apollo.MutationFunction<CreateDebitorDelayScalepointConnectionMutation, CreateDebitorDelayScalepointConnectionMutationVariables>;

/**
 * __useCreateDebitorDelayScalepointConnectionMutation__
 *
 * To run a mutation, you first call `useCreateDebitorDelayScalepointConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDebitorDelayScalepointConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDebitorDelayScalepointConnectionMutation, { data, loading, error }] = useCreateDebitorDelayScalepointConnectionMutation({
 *   variables: {
 *      debitorId: // value for 'debitorId'
 *      damageCauseIds: // value for 'damageCauseIds'
 *   },
 * });
 */
export function useCreateDebitorDelayScalepointConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDebitorDelayScalepointConnectionMutation, CreateDebitorDelayScalepointConnectionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDebitorDelayScalepointConnectionMutation, CreateDebitorDelayScalepointConnectionMutationVariables>(CreateDebitorDelayScalepointConnectionDocument, options);
}
export type CreateDebitorDelayScalepointConnectionMutationHookResult = ReturnType<typeof useCreateDebitorDelayScalepointConnectionMutation>;
export type CreateDebitorDelayScalepointConnectionMutationResult = Apollo.MutationResult<CreateDebitorDelayScalepointConnectionMutation>;
export type CreateDebitorDelayScalepointConnectionMutationOptions = Apollo.BaseMutationOptions<CreateDebitorDelayScalepointConnectionMutation, CreateDebitorDelayScalepointConnectionMutationVariables>;
export const DeleteDebitorDelayScalepointConnectionDocument = gql`
    mutation DeleteDebitorDelayScalepointConnection($id: String!) {
  deleteDebitorDelayScalepointConnection(id: $id)
}
    `;
export type DeleteDebitorDelayScalepointConnectionMutationFn = Apollo.MutationFunction<DeleteDebitorDelayScalepointConnectionMutation, DeleteDebitorDelayScalepointConnectionMutationVariables>;

/**
 * __useDeleteDebitorDelayScalepointConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteDebitorDelayScalepointConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDebitorDelayScalepointConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDebitorDelayScalepointConnectionMutation, { data, loading, error }] = useDeleteDebitorDelayScalepointConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDebitorDelayScalepointConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDebitorDelayScalepointConnectionMutation, DeleteDebitorDelayScalepointConnectionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDebitorDelayScalepointConnectionMutation, DeleteDebitorDelayScalepointConnectionMutationVariables>(DeleteDebitorDelayScalepointConnectionDocument, options);
}
export type DeleteDebitorDelayScalepointConnectionMutationHookResult = ReturnType<typeof useDeleteDebitorDelayScalepointConnectionMutation>;
export type DeleteDebitorDelayScalepointConnectionMutationResult = Apollo.MutationResult<DeleteDebitorDelayScalepointConnectionMutation>;
export type DeleteDebitorDelayScalepointConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteDebitorDelayScalepointConnectionMutation, DeleteDebitorDelayScalepointConnectionMutationVariables>;
export const EditDebitorDelayScalepointConnectionDocument = gql`
    mutation EditDebitorDelayScalepointConnection($id: String!, $damageCauseIds: [String!]!) {
  editDebitorDelayScalepointConnection(id: $id, damageCauseIds: $damageCauseIds) {
    ...DebitorDelayScalepointConnectionFragment
  }
}
    ${DebitorDelayScalepointConnectionFragmentFragmentDoc}`;
export type EditDebitorDelayScalepointConnectionMutationFn = Apollo.MutationFunction<EditDebitorDelayScalepointConnectionMutation, EditDebitorDelayScalepointConnectionMutationVariables>;

/**
 * __useEditDebitorDelayScalepointConnectionMutation__
 *
 * To run a mutation, you first call `useEditDebitorDelayScalepointConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDebitorDelayScalepointConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDebitorDelayScalepointConnectionMutation, { data, loading, error }] = useEditDebitorDelayScalepointConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      damageCauseIds: // value for 'damageCauseIds'
 *   },
 * });
 */
export function useEditDebitorDelayScalepointConnectionMutation(baseOptions?: Apollo.MutationHookOptions<EditDebitorDelayScalepointConnectionMutation, EditDebitorDelayScalepointConnectionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditDebitorDelayScalepointConnectionMutation, EditDebitorDelayScalepointConnectionMutationVariables>(EditDebitorDelayScalepointConnectionDocument, options);
}
export type EditDebitorDelayScalepointConnectionMutationHookResult = ReturnType<typeof useEditDebitorDelayScalepointConnectionMutation>;
export type EditDebitorDelayScalepointConnectionMutationResult = Apollo.MutationResult<EditDebitorDelayScalepointConnectionMutation>;
export type EditDebitorDelayScalepointConnectionMutationOptions = Apollo.BaseMutationOptions<EditDebitorDelayScalepointConnectionMutation, EditDebitorDelayScalepointConnectionMutationVariables>;
export const GetAdminDebitorsDocument = gql`
    query GetAdminDebitors($searchText: String!) {
  debitors(searchText: $searchText) {
    debitorId
    company
  }
}
    `;

/**
 * __useGetAdminDebitorsQuery__
 *
 * To run a query within a React component, call `useGetAdminDebitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDebitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDebitorsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetAdminDebitorsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminDebitorsQuery, GetAdminDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminDebitorsQuery, GetAdminDebitorsQueryVariables>(GetAdminDebitorsDocument, options);
}
export function useGetAdminDebitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDebitorsQuery, GetAdminDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminDebitorsQuery, GetAdminDebitorsQueryVariables>(GetAdminDebitorsDocument, options);
}
export function useGetAdminDebitorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminDebitorsQuery, GetAdminDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminDebitorsQuery, GetAdminDebitorsQueryVariables>(GetAdminDebitorsDocument, options);
}
export type GetAdminDebitorsQueryHookResult = ReturnType<typeof useGetAdminDebitorsQuery>;
export type GetAdminDebitorsLazyQueryHookResult = ReturnType<typeof useGetAdminDebitorsLazyQuery>;
export type GetAdminDebitorsSuspenseQueryHookResult = ReturnType<typeof useGetAdminDebitorsSuspenseQuery>;
export type GetAdminDebitorsQueryResult = Apollo.QueryResult<GetAdminDebitorsQuery, GetAdminDebitorsQueryVariables>;
export function refetchGetAdminDebitorsQuery(variables: GetAdminDebitorsQueryVariables) {
  return { query: GetAdminDebitorsDocument, variables: variables }
}
export const GetAllEcbDebitorsDocument = gql`
    query GetAllECBDebitors {
  allECBDebitors {
    debitorId
    type
    gln
    phone
    email
    address {
      addressLine
      addressLineAlt
      postalCode
      city
    }
    company
    createInECB
  }
}
    `;

/**
 * __useGetAllEcbDebitorsQuery__
 *
 * To run a query within a React component, call `useGetAllEcbDebitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEcbDebitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEcbDebitorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEcbDebitorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEcbDebitorsQuery, GetAllEcbDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAllEcbDebitorsQuery, GetAllEcbDebitorsQueryVariables>(GetAllEcbDebitorsDocument, options);
}
export function useGetAllEcbDebitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEcbDebitorsQuery, GetAllEcbDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAllEcbDebitorsQuery, GetAllEcbDebitorsQueryVariables>(GetAllEcbDebitorsDocument, options);
}
export function useGetAllEcbDebitorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllEcbDebitorsQuery, GetAllEcbDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAllEcbDebitorsQuery, GetAllEcbDebitorsQueryVariables>(GetAllEcbDebitorsDocument, options);
}
export type GetAllEcbDebitorsQueryHookResult = ReturnType<typeof useGetAllEcbDebitorsQuery>;
export type GetAllEcbDebitorsLazyQueryHookResult = ReturnType<typeof useGetAllEcbDebitorsLazyQuery>;
export type GetAllEcbDebitorsSuspenseQueryHookResult = ReturnType<typeof useGetAllEcbDebitorsSuspenseQuery>;
export type GetAllEcbDebitorsQueryResult = Apollo.QueryResult<GetAllEcbDebitorsQuery, GetAllEcbDebitorsQueryVariables>;
export function refetchGetAllEcbDebitorsQuery(variables?: GetAllEcbDebitorsQueryVariables) {
  return { query: GetAllEcbDebitorsDocument, variables: variables }
}
export const GetDebitorDelayScalepointConnectionsDocument = gql`
    query GetDebitorDelayScalepointConnections {
  debitorDelayScalepointConnections {
    ...DebitorDelayScalepointConnectionFragment
  }
}
    ${DebitorDelayScalepointConnectionFragmentFragmentDoc}`;

/**
 * __useGetDebitorDelayScalepointConnectionsQuery__
 *
 * To run a query within a React component, call `useGetDebitorDelayScalepointConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitorDelayScalepointConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDebitorDelayScalepointConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDebitorDelayScalepointConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDebitorDelayScalepointConnectionsQuery, GetDebitorDelayScalepointConnectionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDebitorDelayScalepointConnectionsQuery, GetDebitorDelayScalepointConnectionsQueryVariables>(GetDebitorDelayScalepointConnectionsDocument, options);
}
export function useGetDebitorDelayScalepointConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDebitorDelayScalepointConnectionsQuery, GetDebitorDelayScalepointConnectionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDebitorDelayScalepointConnectionsQuery, GetDebitorDelayScalepointConnectionsQueryVariables>(GetDebitorDelayScalepointConnectionsDocument, options);
}
export function useGetDebitorDelayScalepointConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDebitorDelayScalepointConnectionsQuery, GetDebitorDelayScalepointConnectionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDebitorDelayScalepointConnectionsQuery, GetDebitorDelayScalepointConnectionsQueryVariables>(GetDebitorDelayScalepointConnectionsDocument, options);
}
export type GetDebitorDelayScalepointConnectionsQueryHookResult = ReturnType<typeof useGetDebitorDelayScalepointConnectionsQuery>;
export type GetDebitorDelayScalepointConnectionsLazyQueryHookResult = ReturnType<typeof useGetDebitorDelayScalepointConnectionsLazyQuery>;
export type GetDebitorDelayScalepointConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetDebitorDelayScalepointConnectionsSuspenseQuery>;
export type GetDebitorDelayScalepointConnectionsQueryResult = Apollo.QueryResult<GetDebitorDelayScalepointConnectionsQuery, GetDebitorDelayScalepointConnectionsQueryVariables>;
export function refetchGetDebitorDelayScalepointConnectionsQuery(variables?: GetDebitorDelayScalepointConnectionsQueryVariables) {
  return { query: GetDebitorDelayScalepointConnectionsDocument, variables: variables }
}
export const GetDebitorsAndGroupsDocument = gql`
    query GetDebitorsAndGroups($searchText: String!) {
  debitorsAndGroups(searchText: $searchText) {
    debitors {
      debitorId
      company
    }
    debitorGroups
  }
}
    `;

/**
 * __useGetDebitorsAndGroupsQuery__
 *
 * To run a query within a React component, call `useGetDebitorsAndGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitorsAndGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDebitorsAndGroupsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetDebitorsAndGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetDebitorsAndGroupsQuery, GetDebitorsAndGroupsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDebitorsAndGroupsQuery, GetDebitorsAndGroupsQueryVariables>(GetDebitorsAndGroupsDocument, options);
}
export function useGetDebitorsAndGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDebitorsAndGroupsQuery, GetDebitorsAndGroupsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDebitorsAndGroupsQuery, GetDebitorsAndGroupsQueryVariables>(GetDebitorsAndGroupsDocument, options);
}
export function useGetDebitorsAndGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDebitorsAndGroupsQuery, GetDebitorsAndGroupsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDebitorsAndGroupsQuery, GetDebitorsAndGroupsQueryVariables>(GetDebitorsAndGroupsDocument, options);
}
export type GetDebitorsAndGroupsQueryHookResult = ReturnType<typeof useGetDebitorsAndGroupsQuery>;
export type GetDebitorsAndGroupsLazyQueryHookResult = ReturnType<typeof useGetDebitorsAndGroupsLazyQuery>;
export type GetDebitorsAndGroupsSuspenseQueryHookResult = ReturnType<typeof useGetDebitorsAndGroupsSuspenseQuery>;
export type GetDebitorsAndGroupsQueryResult = Apollo.QueryResult<GetDebitorsAndGroupsQuery, GetDebitorsAndGroupsQueryVariables>;
export function refetchGetDebitorsAndGroupsQuery(variables: GetDebitorsAndGroupsQueryVariables) {
  return { query: GetDebitorsAndGroupsDocument, variables: variables }
}
export const GetDebitorsByReferenceNoDocument = gql`
    query GetDebitorsByReferenceNo($referenceNoList: [String!]!) {
  debitorsByReferenceNo(referenceNoList: $referenceNoList) {
    debitorId
    company
  }
}
    `;

/**
 * __useGetDebitorsByReferenceNoQuery__
 *
 * To run a query within a React component, call `useGetDebitorsByReferenceNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitorsByReferenceNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDebitorsByReferenceNoQuery({
 *   variables: {
 *      referenceNoList: // value for 'referenceNoList'
 *   },
 * });
 */
export function useGetDebitorsByReferenceNoQuery(baseOptions: Apollo.QueryHookOptions<GetDebitorsByReferenceNoQuery, GetDebitorsByReferenceNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDebitorsByReferenceNoQuery, GetDebitorsByReferenceNoQueryVariables>(GetDebitorsByReferenceNoDocument, options);
}
export function useGetDebitorsByReferenceNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDebitorsByReferenceNoQuery, GetDebitorsByReferenceNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDebitorsByReferenceNoQuery, GetDebitorsByReferenceNoQueryVariables>(GetDebitorsByReferenceNoDocument, options);
}
export function useGetDebitorsByReferenceNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDebitorsByReferenceNoQuery, GetDebitorsByReferenceNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDebitorsByReferenceNoQuery, GetDebitorsByReferenceNoQueryVariables>(GetDebitorsByReferenceNoDocument, options);
}
export type GetDebitorsByReferenceNoQueryHookResult = ReturnType<typeof useGetDebitorsByReferenceNoQuery>;
export type GetDebitorsByReferenceNoLazyQueryHookResult = ReturnType<typeof useGetDebitorsByReferenceNoLazyQuery>;
export type GetDebitorsByReferenceNoSuspenseQueryHookResult = ReturnType<typeof useGetDebitorsByReferenceNoSuspenseQuery>;
export type GetDebitorsByReferenceNoQueryResult = Apollo.QueryResult<GetDebitorsByReferenceNoQuery, GetDebitorsByReferenceNoQueryVariables>;
export function refetchGetDebitorsByReferenceNoQuery(variables: GetDebitorsByReferenceNoQueryVariables) {
  return { query: GetDebitorsByReferenceNoDocument, variables: variables }
}
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($department: DepartmentInputType!) {
  createDepartment(department: $department) {
    id
  }
}
    `;
export type CreateDepartmentMutationFn = Apollo.MutationFunction<CreateDepartmentMutation, CreateDepartmentMutationVariables>;

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentMutation, { data, loading, error }] = useCreateDepartmentMutation({
 *   variables: {
 *      department: // value for 'department'
 *   },
 * });
 */
export function useCreateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, options);
}
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>;
export type CreateDepartmentMutationResult = Apollo.MutationResult<CreateDepartmentMutation>;
export type CreateDepartmentMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>;
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($id: String!) {
  deleteDepartment(id: $id) {
    _
  }
}
    `;
export type DeleteDepartmentMutationFn = Apollo.MutationFunction<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;

/**
 * __useDeleteDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepartmentMutation, { data, loading, error }] = useDeleteDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, options);
}
export type DeleteDepartmentMutationHookResult = ReturnType<typeof useDeleteDepartmentMutation>;
export type DeleteDepartmentMutationResult = Apollo.MutationResult<DeleteDepartmentMutation>;
export type DeleteDepartmentMutationOptions = Apollo.BaseMutationOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;
export const GetAdminDepartmentsDocument = gql`
    query GetAdminDepartments($useLimitations: Boolean) {
  departmentsAdmin(useLimitations: $useLimitations) {
    ...BaseDepartmentFragment
    operationManagers {
      id
      name
    }
  }
}
    ${BaseDepartmentFragmentFragmentDoc}`;

/**
 * __useGetAdminDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetAdminDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDepartmentsQuery({
 *   variables: {
 *      useLimitations: // value for 'useLimitations'
 *   },
 * });
 */
export function useGetAdminDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDepartmentsQuery, GetAdminDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminDepartmentsQuery, GetAdminDepartmentsQueryVariables>(GetAdminDepartmentsDocument, options);
}
export function useGetAdminDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDepartmentsQuery, GetAdminDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminDepartmentsQuery, GetAdminDepartmentsQueryVariables>(GetAdminDepartmentsDocument, options);
}
export function useGetAdminDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminDepartmentsQuery, GetAdminDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminDepartmentsQuery, GetAdminDepartmentsQueryVariables>(GetAdminDepartmentsDocument, options);
}
export type GetAdminDepartmentsQueryHookResult = ReturnType<typeof useGetAdminDepartmentsQuery>;
export type GetAdminDepartmentsLazyQueryHookResult = ReturnType<typeof useGetAdminDepartmentsLazyQuery>;
export type GetAdminDepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetAdminDepartmentsSuspenseQuery>;
export type GetAdminDepartmentsQueryResult = Apollo.QueryResult<GetAdminDepartmentsQuery, GetAdminDepartmentsQueryVariables>;
export function refetchGetAdminDepartmentsQuery(variables?: GetAdminDepartmentsQueryVariables) {
  return { query: GetAdminDepartmentsDocument, variables: variables }
}
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($id: String!, $name: String, $departmentNumber: Int, $operationManagers: [String!]) {
  updateDepartment(
    id: $id
    name: $name
    departmentNumber: $departmentNumber
    operationManagers: $operationManagers
  ) {
    ...BaseDepartmentFragment
  }
}
    ${BaseDepartmentFragmentFragmentDoc}`;
export type UpdateDepartmentMutationFn = Apollo.MutationFunction<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      departmentNumber: // value for 'departmentNumber'
 *      operationManagers: // value for 'operationManagers'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, options);
}
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = Apollo.MutationResult<UpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const GetDrivingSlipCategoriesDocument = gql`
    query GetDrivingSlipCategories {
  drivingSlipCategories {
    code
    name
    erpReferenceTasks
  }
}
    `;

/**
 * __useGetDrivingSlipCategoriesQuery__
 *
 * To run a query within a React component, call `useGetDrivingSlipCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingSlipCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingSlipCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDrivingSlipCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetDrivingSlipCategoriesQuery, GetDrivingSlipCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrivingSlipCategoriesQuery, GetDrivingSlipCategoriesQueryVariables>(GetDrivingSlipCategoriesDocument, options);
}
export function useGetDrivingSlipCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrivingSlipCategoriesQuery, GetDrivingSlipCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrivingSlipCategoriesQuery, GetDrivingSlipCategoriesQueryVariables>(GetDrivingSlipCategoriesDocument, options);
}
export function useGetDrivingSlipCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrivingSlipCategoriesQuery, GetDrivingSlipCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDrivingSlipCategoriesQuery, GetDrivingSlipCategoriesQueryVariables>(GetDrivingSlipCategoriesDocument, options);
}
export type GetDrivingSlipCategoriesQueryHookResult = ReturnType<typeof useGetDrivingSlipCategoriesQuery>;
export type GetDrivingSlipCategoriesLazyQueryHookResult = ReturnType<typeof useGetDrivingSlipCategoriesLazyQuery>;
export type GetDrivingSlipCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetDrivingSlipCategoriesSuspenseQuery>;
export type GetDrivingSlipCategoriesQueryResult = Apollo.QueryResult<GetDrivingSlipCategoriesQuery, GetDrivingSlipCategoriesQueryVariables>;
export function refetchGetDrivingSlipCategoriesQuery(variables?: GetDrivingSlipCategoriesQueryVariables) {
  return { query: GetDrivingSlipCategoriesDocument, variables: variables }
}
export const CasesGdprCompliantDocument = gql`
    mutation CasesGDPRCompliant($caseIds: [String!]!) {
  casesGDPRCompliant(caseIds: $caseIds) {
    id
    erpNo
  }
}
    `;
export type CasesGdprCompliantMutationFn = Apollo.MutationFunction<CasesGdprCompliantMutation, CasesGdprCompliantMutationVariables>;

/**
 * __useCasesGdprCompliantMutation__
 *
 * To run a mutation, you first call `useCasesGdprCompliantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCasesGdprCompliantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [casesGdprCompliantMutation, { data, loading, error }] = useCasesGdprCompliantMutation({
 *   variables: {
 *      caseIds: // value for 'caseIds'
 *   },
 * });
 */
export function useCasesGdprCompliantMutation(baseOptions?: Apollo.MutationHookOptions<CasesGdprCompliantMutation, CasesGdprCompliantMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CasesGdprCompliantMutation, CasesGdprCompliantMutationVariables>(CasesGdprCompliantDocument, options);
}
export type CasesGdprCompliantMutationHookResult = ReturnType<typeof useCasesGdprCompliantMutation>;
export type CasesGdprCompliantMutationResult = Apollo.MutationResult<CasesGdprCompliantMutation>;
export type CasesGdprCompliantMutationOptions = Apollo.BaseMutationOptions<CasesGdprCompliantMutation, CasesGdprCompliantMutationVariables>;
export const CreateGroupPermissionDocument = gql`
    mutation CreateGroupPermission($groupPermission: GroupPermissionInputType!, $groupPermissionsList: [Permissions!]!) {
  createGroupPermission(
    groupPermission: $groupPermission
    groupPermissionsList: $groupPermissionsList
  ) {
    ...BaseGroupPermissionFragment
  }
}
    ${BaseGroupPermissionFragmentFragmentDoc}`;
export type CreateGroupPermissionMutationFn = Apollo.MutationFunction<CreateGroupPermissionMutation, CreateGroupPermissionMutationVariables>;

/**
 * __useCreateGroupPermissionMutation__
 *
 * To run a mutation, you first call `useCreateGroupPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupPermissionMutation, { data, loading, error }] = useCreateGroupPermissionMutation({
 *   variables: {
 *      groupPermission: // value for 'groupPermission'
 *      groupPermissionsList: // value for 'groupPermissionsList'
 *   },
 * });
 */
export function useCreateGroupPermissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupPermissionMutation, CreateGroupPermissionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateGroupPermissionMutation, CreateGroupPermissionMutationVariables>(CreateGroupPermissionDocument, options);
}
export type CreateGroupPermissionMutationHookResult = ReturnType<typeof useCreateGroupPermissionMutation>;
export type CreateGroupPermissionMutationResult = Apollo.MutationResult<CreateGroupPermissionMutation>;
export type CreateGroupPermissionMutationOptions = Apollo.BaseMutationOptions<CreateGroupPermissionMutation, CreateGroupPermissionMutationVariables>;
export const GetGroupsPermissionsDocument = gql`
    query GetGroupsPermissions {
  groupsPermissions {
    ...BaseGroupPermissionFragment
  }
}
    ${BaseGroupPermissionFragmentFragmentDoc}`;

/**
 * __useGetGroupsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetGroupsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupsPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsPermissionsQuery, GetGroupsPermissionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetGroupsPermissionsQuery, GetGroupsPermissionsQueryVariables>(GetGroupsPermissionsDocument, options);
}
export function useGetGroupsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsPermissionsQuery, GetGroupsPermissionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetGroupsPermissionsQuery, GetGroupsPermissionsQueryVariables>(GetGroupsPermissionsDocument, options);
}
export function useGetGroupsPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsPermissionsQuery, GetGroupsPermissionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetGroupsPermissionsQuery, GetGroupsPermissionsQueryVariables>(GetGroupsPermissionsDocument, options);
}
export type GetGroupsPermissionsQueryHookResult = ReturnType<typeof useGetGroupsPermissionsQuery>;
export type GetGroupsPermissionsLazyQueryHookResult = ReturnType<typeof useGetGroupsPermissionsLazyQuery>;
export type GetGroupsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsPermissionsSuspenseQuery>;
export type GetGroupsPermissionsQueryResult = Apollo.QueryResult<GetGroupsPermissionsQuery, GetGroupsPermissionsQueryVariables>;
export function refetchGetGroupsPermissionsQuery(variables?: GetGroupsPermissionsQueryVariables) {
  return { query: GetGroupsPermissionsDocument, variables: variables }
}
export const SearchUserPermissionsDocument = gql`
    query SearchUserPermissions($searchText: String!) {
  searchUsers(searchText: $searchText) {
    ...BaseUserFragment
    permissions
    groupPermissions {
      id
      name
    }
  }
}
    ${BaseUserFragmentFragmentDoc}`;

/**
 * __useSearchUserPermissionsQuery__
 *
 * To run a query within a React component, call `useSearchUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserPermissionsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<SearchUserPermissionsQuery, SearchUserPermissionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchUserPermissionsQuery, SearchUserPermissionsQueryVariables>(SearchUserPermissionsDocument, options);
}
export function useSearchUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserPermissionsQuery, SearchUserPermissionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchUserPermissionsQuery, SearchUserPermissionsQueryVariables>(SearchUserPermissionsDocument, options);
}
export function useSearchUserPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUserPermissionsQuery, SearchUserPermissionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchUserPermissionsQuery, SearchUserPermissionsQueryVariables>(SearchUserPermissionsDocument, options);
}
export type SearchUserPermissionsQueryHookResult = ReturnType<typeof useSearchUserPermissionsQuery>;
export type SearchUserPermissionsLazyQueryHookResult = ReturnType<typeof useSearchUserPermissionsLazyQuery>;
export type SearchUserPermissionsSuspenseQueryHookResult = ReturnType<typeof useSearchUserPermissionsSuspenseQuery>;
export type SearchUserPermissionsQueryResult = Apollo.QueryResult<SearchUserPermissionsQuery, SearchUserPermissionsQueryVariables>;
export function refetchSearchUserPermissionsQuery(variables: SearchUserPermissionsQueryVariables) {
  return { query: SearchUserPermissionsDocument, variables: variables }
}
export const UpdateGroupPermissionDocument = gql`
    mutation UpdateGroupPermission($id: String!, $groupPermissionsList: [Permissions!], $groupDebitors: [GroupPermissionInputListItemType!], $groupDebitorGroups: [String!], $groupLocations: [String!], $groupDepartments: [String!], $groupDamageCategories: [String!], $groupDamageCauses: [String!], $groupRequisitionDepartments: [String!]) {
  updateGroupPermission(
    id: $id
    groupPermissionsList: $groupPermissionsList
    groupDebitors: $groupDebitors
    groupDebitorGroups: $groupDebitorGroups
    groupLocations: $groupLocations
    groupDepartments: $groupDepartments
    groupDamageCategories: $groupDamageCategories
    groupDamageCauses: $groupDamageCauses
    groupRequisitionDepartments: $groupRequisitionDepartments
  ) {
    ...BaseGroupPermissionFragment
  }
}
    ${BaseGroupPermissionFragmentFragmentDoc}`;
export type UpdateGroupPermissionMutationFn = Apollo.MutationFunction<UpdateGroupPermissionMutation, UpdateGroupPermissionMutationVariables>;

/**
 * __useUpdateGroupPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateGroupPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupPermissionMutation, { data, loading, error }] = useUpdateGroupPermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      groupPermissionsList: // value for 'groupPermissionsList'
 *      groupDebitors: // value for 'groupDebitors'
 *      groupDebitorGroups: // value for 'groupDebitorGroups'
 *      groupLocations: // value for 'groupLocations'
 *      groupDepartments: // value for 'groupDepartments'
 *      groupDamageCategories: // value for 'groupDamageCategories'
 *      groupDamageCauses: // value for 'groupDamageCauses'
 *      groupRequisitionDepartments: // value for 'groupRequisitionDepartments'
 *   },
 * });
 */
export function useUpdateGroupPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupPermissionMutation, UpdateGroupPermissionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateGroupPermissionMutation, UpdateGroupPermissionMutationVariables>(UpdateGroupPermissionDocument, options);
}
export type UpdateGroupPermissionMutationHookResult = ReturnType<typeof useUpdateGroupPermissionMutation>;
export type UpdateGroupPermissionMutationResult = Apollo.MutationResult<UpdateGroupPermissionMutation>;
export type UpdateGroupPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateGroupPermissionMutation, UpdateGroupPermissionMutationVariables>;
export const CreateInputFieldDocument = gql`
    mutation CreateInputField($inputField: InputFieldInput!) {
  createInputfield(inputField: $inputField) {
    key
    permissions
    required
  }
}
    `;
export type CreateInputFieldMutationFn = Apollo.MutationFunction<CreateInputFieldMutation, CreateInputFieldMutationVariables>;

/**
 * __useCreateInputFieldMutation__
 *
 * To run a mutation, you first call `useCreateInputFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInputFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInputFieldMutation, { data, loading, error }] = useCreateInputFieldMutation({
 *   variables: {
 *      inputField: // value for 'inputField'
 *   },
 * });
 */
export function useCreateInputFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateInputFieldMutation, CreateInputFieldMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateInputFieldMutation, CreateInputFieldMutationVariables>(CreateInputFieldDocument, options);
}
export type CreateInputFieldMutationHookResult = ReturnType<typeof useCreateInputFieldMutation>;
export type CreateInputFieldMutationResult = Apollo.MutationResult<CreateInputFieldMutation>;
export type CreateInputFieldMutationOptions = Apollo.BaseMutationOptions<CreateInputFieldMutation, CreateInputFieldMutationVariables>;
export const DeleteInputFieldDocument = gql`
    mutation DeleteInputField($key: String!) {
  deleteInputField(key: $key) {
    _
  }
}
    `;
export type DeleteInputFieldMutationFn = Apollo.MutationFunction<DeleteInputFieldMutation, DeleteInputFieldMutationVariables>;

/**
 * __useDeleteInputFieldMutation__
 *
 * To run a mutation, you first call `useDeleteInputFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInputFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInputFieldMutation, { data, loading, error }] = useDeleteInputFieldMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteInputFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInputFieldMutation, DeleteInputFieldMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteInputFieldMutation, DeleteInputFieldMutationVariables>(DeleteInputFieldDocument, options);
}
export type DeleteInputFieldMutationHookResult = ReturnType<typeof useDeleteInputFieldMutation>;
export type DeleteInputFieldMutationResult = Apollo.MutationResult<DeleteInputFieldMutation>;
export type DeleteInputFieldMutationOptions = Apollo.BaseMutationOptions<DeleteInputFieldMutation, DeleteInputFieldMutationVariables>;
export const GetInputFieldsAllDocument = gql`
    query GetInputFieldsAll {
  inputFieldsAll {
    key
    permissions
    required
  }
}
    `;

/**
 * __useGetInputFieldsAllQuery__
 *
 * To run a query within a React component, call `useGetInputFieldsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInputFieldsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInputFieldsAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInputFieldsAllQuery(baseOptions?: Apollo.QueryHookOptions<GetInputFieldsAllQuery, GetInputFieldsAllQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInputFieldsAllQuery, GetInputFieldsAllQueryVariables>(GetInputFieldsAllDocument, options);
}
export function useGetInputFieldsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInputFieldsAllQuery, GetInputFieldsAllQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInputFieldsAllQuery, GetInputFieldsAllQueryVariables>(GetInputFieldsAllDocument, options);
}
export function useGetInputFieldsAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInputFieldsAllQuery, GetInputFieldsAllQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInputFieldsAllQuery, GetInputFieldsAllQueryVariables>(GetInputFieldsAllDocument, options);
}
export type GetInputFieldsAllQueryHookResult = ReturnType<typeof useGetInputFieldsAllQuery>;
export type GetInputFieldsAllLazyQueryHookResult = ReturnType<typeof useGetInputFieldsAllLazyQuery>;
export type GetInputFieldsAllSuspenseQueryHookResult = ReturnType<typeof useGetInputFieldsAllSuspenseQuery>;
export type GetInputFieldsAllQueryResult = Apollo.QueryResult<GetInputFieldsAllQuery, GetInputFieldsAllQueryVariables>;
export function refetchGetInputFieldsAllQuery(variables?: GetInputFieldsAllQueryVariables) {
  return { query: GetInputFieldsAllDocument, variables: variables }
}
export const UpdateAdminInputFieldDocument = gql`
    mutation UpdateAdminInputField($key: String!, $permissionsList: [Permissions!], $required: Boolean!) {
  updateInputField(
    key: $key
    permissionsList: $permissionsList
    required: $required
  ) {
    key
    permissions
    required
  }
}
    `;
export type UpdateAdminInputFieldMutationFn = Apollo.MutationFunction<UpdateAdminInputFieldMutation, UpdateAdminInputFieldMutationVariables>;

/**
 * __useUpdateAdminInputFieldMutation__
 *
 * To run a mutation, you first call `useUpdateAdminInputFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminInputFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminInputFieldMutation, { data, loading, error }] = useUpdateAdminInputFieldMutation({
 *   variables: {
 *      key: // value for 'key'
 *      permissionsList: // value for 'permissionsList'
 *      required: // value for 'required'
 *   },
 * });
 */
export function useUpdateAdminInputFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminInputFieldMutation, UpdateAdminInputFieldMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateAdminInputFieldMutation, UpdateAdminInputFieldMutationVariables>(UpdateAdminInputFieldDocument, options);
}
export type UpdateAdminInputFieldMutationHookResult = ReturnType<typeof useUpdateAdminInputFieldMutation>;
export type UpdateAdminInputFieldMutationResult = Apollo.MutationResult<UpdateAdminInputFieldMutation>;
export type UpdateAdminInputFieldMutationOptions = Apollo.BaseMutationOptions<UpdateAdminInputFieldMutation, UpdateAdminInputFieldMutationVariables>;
export const CreateInvoiceReasonCodeDocument = gql`
    mutation CreateInvoiceReasonCode($invoiceReasonCode: InvoiceReasonCodeInputType!) {
  createInvoiceReasonCode(invoiceReasonCode: $invoiceReasonCode) {
    ...InvoiceReasonCodeFragment
  }
}
    ${InvoiceReasonCodeFragmentFragmentDoc}`;
export type CreateInvoiceReasonCodeMutationFn = Apollo.MutationFunction<CreateInvoiceReasonCodeMutation, CreateInvoiceReasonCodeMutationVariables>;

/**
 * __useCreateInvoiceReasonCodeMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceReasonCodeMutation, { data, loading, error }] = useCreateInvoiceReasonCodeMutation({
 *   variables: {
 *      invoiceReasonCode: // value for 'invoiceReasonCode'
 *   },
 * });
 */
export function useCreateInvoiceReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceReasonCodeMutation, CreateInvoiceReasonCodeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateInvoiceReasonCodeMutation, CreateInvoiceReasonCodeMutationVariables>(CreateInvoiceReasonCodeDocument, options);
}
export type CreateInvoiceReasonCodeMutationHookResult = ReturnType<typeof useCreateInvoiceReasonCodeMutation>;
export type CreateInvoiceReasonCodeMutationResult = Apollo.MutationResult<CreateInvoiceReasonCodeMutation>;
export type CreateInvoiceReasonCodeMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceReasonCodeMutation, CreateInvoiceReasonCodeMutationVariables>;
export const DeleteInvoiceAdminDocument = gql`
    mutation DeleteInvoiceAdmin($caseId: String!, $invoiceERPReference: String!) {
  deleteInvoiceAdmin(caseId: $caseId, invoiceERPReference: $invoiceERPReference)
}
    `;
export type DeleteInvoiceAdminMutationFn = Apollo.MutationFunction<DeleteInvoiceAdminMutation, DeleteInvoiceAdminMutationVariables>;

/**
 * __useDeleteInvoiceAdminMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceAdminMutation, { data, loading, error }] = useDeleteInvoiceAdminMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *   },
 * });
 */
export function useDeleteInvoiceAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceAdminMutation, DeleteInvoiceAdminMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteInvoiceAdminMutation, DeleteInvoiceAdminMutationVariables>(DeleteInvoiceAdminDocument, options);
}
export type DeleteInvoiceAdminMutationHookResult = ReturnType<typeof useDeleteInvoiceAdminMutation>;
export type DeleteInvoiceAdminMutationResult = Apollo.MutationResult<DeleteInvoiceAdminMutation>;
export type DeleteInvoiceAdminMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceAdminMutation, DeleteInvoiceAdminMutationVariables>;
export const DeleteInvoiceReasonCodeDocument = gql`
    mutation DeleteInvoiceReasonCode($id: String!) {
  deleteInvoiceReasonCode(id: $id)
}
    `;
export type DeleteInvoiceReasonCodeMutationFn = Apollo.MutationFunction<DeleteInvoiceReasonCodeMutation, DeleteInvoiceReasonCodeMutationVariables>;

/**
 * __useDeleteInvoiceReasonCodeMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceReasonCodeMutation, { data, loading, error }] = useDeleteInvoiceReasonCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvoiceReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceReasonCodeMutation, DeleteInvoiceReasonCodeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteInvoiceReasonCodeMutation, DeleteInvoiceReasonCodeMutationVariables>(DeleteInvoiceReasonCodeDocument, options);
}
export type DeleteInvoiceReasonCodeMutationHookResult = ReturnType<typeof useDeleteInvoiceReasonCodeMutation>;
export type DeleteInvoiceReasonCodeMutationResult = Apollo.MutationResult<DeleteInvoiceReasonCodeMutation>;
export type DeleteInvoiceReasonCodeMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceReasonCodeMutation, DeleteInvoiceReasonCodeMutationVariables>;
export const GetCaseInvoicesDocument = gql`
    query GetCaseInvoices($caseId: String!) {
  invoices(caseId: $caseId) {
    erpReferenceNo
    status
    screeningERPReferenceNoList
    category
    lines {
      systemId
      sortIndex
      caseNo
      documentNo
      no
      erpReferenceTask
      lineAmount
      lineType
      type
      attachDocument
      allowAttachDocument
      description
      quantity
      quoteLineId
      screeningTitle
      screeningLine
      screeningLineId
      screeningLinePosition
      unitPrice
      unitCost
      newUnitPrice
      planningDate
      workTypeCode
    }
  }
}
    `;

/**
 * __useGetCaseInvoicesQuery__
 *
 * To run a query within a React component, call `useGetCaseInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseInvoicesQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetCaseInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseInvoicesQuery, GetCaseInvoicesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseInvoicesQuery, GetCaseInvoicesQueryVariables>(GetCaseInvoicesDocument, options);
}
export function useGetCaseInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseInvoicesQuery, GetCaseInvoicesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseInvoicesQuery, GetCaseInvoicesQueryVariables>(GetCaseInvoicesDocument, options);
}
export function useGetCaseInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseInvoicesQuery, GetCaseInvoicesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseInvoicesQuery, GetCaseInvoicesQueryVariables>(GetCaseInvoicesDocument, options);
}
export type GetCaseInvoicesQueryHookResult = ReturnType<typeof useGetCaseInvoicesQuery>;
export type GetCaseInvoicesLazyQueryHookResult = ReturnType<typeof useGetCaseInvoicesLazyQuery>;
export type GetCaseInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetCaseInvoicesSuspenseQuery>;
export type GetCaseInvoicesQueryResult = Apollo.QueryResult<GetCaseInvoicesQuery, GetCaseInvoicesQueryVariables>;
export function refetchGetCaseInvoicesQuery(variables: GetCaseInvoicesQueryVariables) {
  return { query: GetCaseInvoicesDocument, variables: variables }
}
export const GetInvoiceReasonCodesDocument = gql`
    query GetInvoiceReasonCodes {
  invoiceReasonCodes {
    ...InvoiceReasonCodeFragment
  }
}
    ${InvoiceReasonCodeFragmentFragmentDoc}`;

/**
 * __useGetInvoiceReasonCodesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceReasonCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceReasonCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceReasonCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvoiceReasonCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoiceReasonCodesQuery, GetInvoiceReasonCodesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInvoiceReasonCodesQuery, GetInvoiceReasonCodesQueryVariables>(GetInvoiceReasonCodesDocument, options);
}
export function useGetInvoiceReasonCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceReasonCodesQuery, GetInvoiceReasonCodesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInvoiceReasonCodesQuery, GetInvoiceReasonCodesQueryVariables>(GetInvoiceReasonCodesDocument, options);
}
export function useGetInvoiceReasonCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceReasonCodesQuery, GetInvoiceReasonCodesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInvoiceReasonCodesQuery, GetInvoiceReasonCodesQueryVariables>(GetInvoiceReasonCodesDocument, options);
}
export type GetInvoiceReasonCodesQueryHookResult = ReturnType<typeof useGetInvoiceReasonCodesQuery>;
export type GetInvoiceReasonCodesLazyQueryHookResult = ReturnType<typeof useGetInvoiceReasonCodesLazyQuery>;
export type GetInvoiceReasonCodesSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceReasonCodesSuspenseQuery>;
export type GetInvoiceReasonCodesQueryResult = Apollo.QueryResult<GetInvoiceReasonCodesQuery, GetInvoiceReasonCodesQueryVariables>;
export function refetchGetInvoiceReasonCodesQuery(variables?: GetInvoiceReasonCodesQueryVariables) {
  return { query: GetInvoiceReasonCodesDocument, variables: variables }
}
export const UpdateInvoiceReasonCodeDocument = gql`
    mutation UpdateInvoiceReasonCode($id: String!, $name: String) {
  updateInvoiceReasonCode(id: $id, name: $name) {
    ...InvoiceReasonCodeFragment
  }
}
    ${InvoiceReasonCodeFragmentFragmentDoc}`;
export type UpdateInvoiceReasonCodeMutationFn = Apollo.MutationFunction<UpdateInvoiceReasonCodeMutation, UpdateInvoiceReasonCodeMutationVariables>;

/**
 * __useUpdateInvoiceReasonCodeMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceReasonCodeMutation, { data, loading, error }] = useUpdateInvoiceReasonCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateInvoiceReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceReasonCodeMutation, UpdateInvoiceReasonCodeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateInvoiceReasonCodeMutation, UpdateInvoiceReasonCodeMutationVariables>(UpdateInvoiceReasonCodeDocument, options);
}
export type UpdateInvoiceReasonCodeMutationHookResult = ReturnType<typeof useUpdateInvoiceReasonCodeMutation>;
export type UpdateInvoiceReasonCodeMutationResult = Apollo.MutationResult<UpdateInvoiceReasonCodeMutation>;
export type UpdateInvoiceReasonCodeMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceReasonCodeMutation, UpdateInvoiceReasonCodeMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($location: LocationInputType!) {
  createLocation(location: $location) {
    id
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
}
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($id: String!) {
  deleteLocation(id: $id) {
    _
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
}
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const GetAdminLocationsDocument = gql`
    query GetAdminLocations($useLimitations: Boolean, $movableLocationsOnly: Boolean) {
  locationsAdmin(
    useLimitations: $useLimitations
    movableLocationsOnly: $movableLocationsOnly
  ) {
    ...BaseLocationFragment
    attachedPostalCodesInputString
    attachedPostalCodes
    email
  }
}
    ${BaseLocationFragmentFragmentDoc}`;

/**
 * __useGetAdminLocationsQuery__
 *
 * To run a query within a React component, call `useGetAdminLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminLocationsQuery({
 *   variables: {
 *      useLimitations: // value for 'useLimitations'
 *      movableLocationsOnly: // value for 'movableLocationsOnly'
 *   },
 * });
 */
export function useGetAdminLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminLocationsQuery, GetAdminLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminLocationsQuery, GetAdminLocationsQueryVariables>(GetAdminLocationsDocument, options);
}
export function useGetAdminLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminLocationsQuery, GetAdminLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminLocationsQuery, GetAdminLocationsQueryVariables>(GetAdminLocationsDocument, options);
}
export function useGetAdminLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminLocationsQuery, GetAdminLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminLocationsQuery, GetAdminLocationsQueryVariables>(GetAdminLocationsDocument, options);
}
export type GetAdminLocationsQueryHookResult = ReturnType<typeof useGetAdminLocationsQuery>;
export type GetAdminLocationsLazyQueryHookResult = ReturnType<typeof useGetAdminLocationsLazyQuery>;
export type GetAdminLocationsSuspenseQueryHookResult = ReturnType<typeof useGetAdminLocationsSuspenseQuery>;
export type GetAdminLocationsQueryResult = Apollo.QueryResult<GetAdminLocationsQuery, GetAdminLocationsQueryVariables>;
export function refetchGetAdminLocationsQuery(variables?: GetAdminLocationsQueryVariables) {
  return { query: GetAdminLocationsDocument, variables: variables }
}
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($id: String!, $name: String, $movables: Boolean, $address: AddressInput, $email: String, $attachedPostalCodesInputString: String, $attachedPostalCodes: [String!]) {
  updateLocation(
    id: $id
    name: $name
    movables: $movables
    address: $address
    email: $email
    attachedPostalCodesInputString: $attachedPostalCodesInputString
    attachedPostalCodes: $attachedPostalCodes
  ) {
    ...BaseLocationFragment
    email
  }
}
    ${BaseLocationFragmentFragmentDoc}`;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      movables: // value for 'movables'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      attachedPostalCodesInputString: // value for 'attachedPostalCodesInputString'
 *      attachedPostalCodes: // value for 'attachedPostalCodes'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
}
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const GetLogDataPeriodDocument = gql`
    query GetLogDataPeriod($dateFrom: String!, $dateTo: String!) {
  logDataPeriod(dateFrom: $dateFrom, dateTo: $dateTo)
}
    `;

/**
 * __useGetLogDataPeriodQuery__
 *
 * To run a query within a React component, call `useGetLogDataPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogDataPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogDataPeriodQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetLogDataPeriodQuery(baseOptions: Apollo.QueryHookOptions<GetLogDataPeriodQuery, GetLogDataPeriodQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLogDataPeriodQuery, GetLogDataPeriodQueryVariables>(GetLogDataPeriodDocument, options);
}
export function useGetLogDataPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogDataPeriodQuery, GetLogDataPeriodQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetLogDataPeriodQuery, GetLogDataPeriodQueryVariables>(GetLogDataPeriodDocument, options);
}
export function useGetLogDataPeriodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLogDataPeriodQuery, GetLogDataPeriodQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetLogDataPeriodQuery, GetLogDataPeriodQueryVariables>(GetLogDataPeriodDocument, options);
}
export type GetLogDataPeriodQueryHookResult = ReturnType<typeof useGetLogDataPeriodQuery>;
export type GetLogDataPeriodLazyQueryHookResult = ReturnType<typeof useGetLogDataPeriodLazyQuery>;
export type GetLogDataPeriodSuspenseQueryHookResult = ReturnType<typeof useGetLogDataPeriodSuspenseQuery>;
export type GetLogDataPeriodQueryResult = Apollo.QueryResult<GetLogDataPeriodQuery, GetLogDataPeriodQueryVariables>;
export function refetchGetLogDataPeriodQuery(variables: GetLogDataPeriodQueryVariables) {
  return { query: GetLogDataPeriodDocument, variables: variables }
}
export const GetAdminMachineLocationsDocument = gql`
    query GetAdminMachineLocations {
  machineLocations {
    ...BaseMachineLocationFragment
  }
}
    ${BaseMachineLocationFragmentFragmentDoc}`;

/**
 * __useGetAdminMachineLocationsQuery__
 *
 * To run a query within a React component, call `useGetAdminMachineLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminMachineLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminMachineLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminMachineLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminMachineLocationsQuery, GetAdminMachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminMachineLocationsQuery, GetAdminMachineLocationsQueryVariables>(GetAdminMachineLocationsDocument, options);
}
export function useGetAdminMachineLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminMachineLocationsQuery, GetAdminMachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminMachineLocationsQuery, GetAdminMachineLocationsQueryVariables>(GetAdminMachineLocationsDocument, options);
}
export function useGetAdminMachineLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminMachineLocationsQuery, GetAdminMachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminMachineLocationsQuery, GetAdminMachineLocationsQueryVariables>(GetAdminMachineLocationsDocument, options);
}
export type GetAdminMachineLocationsQueryHookResult = ReturnType<typeof useGetAdminMachineLocationsQuery>;
export type GetAdminMachineLocationsLazyQueryHookResult = ReturnType<typeof useGetAdminMachineLocationsLazyQuery>;
export type GetAdminMachineLocationsSuspenseQueryHookResult = ReturnType<typeof useGetAdminMachineLocationsSuspenseQuery>;
export type GetAdminMachineLocationsQueryResult = Apollo.QueryResult<GetAdminMachineLocationsQuery, GetAdminMachineLocationsQueryVariables>;
export function refetchGetAdminMachineLocationsQuery(variables?: GetAdminMachineLocationsQueryVariables) {
  return { query: GetAdminMachineLocationsDocument, variables: variables }
}
export const GetAdminMachinesDocument = gql`
    query GetAdminMachines {
  machines {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;

/**
 * __useGetAdminMachinesQuery__
 *
 * To run a query within a React component, call `useGetAdminMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminMachinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminMachinesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminMachinesQuery, GetAdminMachinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminMachinesQuery, GetAdminMachinesQueryVariables>(GetAdminMachinesDocument, options);
}
export function useGetAdminMachinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminMachinesQuery, GetAdminMachinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminMachinesQuery, GetAdminMachinesQueryVariables>(GetAdminMachinesDocument, options);
}
export function useGetAdminMachinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminMachinesQuery, GetAdminMachinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminMachinesQuery, GetAdminMachinesQueryVariables>(GetAdminMachinesDocument, options);
}
export type GetAdminMachinesQueryHookResult = ReturnType<typeof useGetAdminMachinesQuery>;
export type GetAdminMachinesLazyQueryHookResult = ReturnType<typeof useGetAdminMachinesLazyQuery>;
export type GetAdminMachinesSuspenseQueryHookResult = ReturnType<typeof useGetAdminMachinesSuspenseQuery>;
export type GetAdminMachinesQueryResult = Apollo.QueryResult<GetAdminMachinesQuery, GetAdminMachinesQueryVariables>;
export function refetchGetAdminMachinesQuery(variables?: GetAdminMachinesQueryVariables) {
  return { query: GetAdminMachinesDocument, variables: variables }
}
export const CreateMovablesLocationsDocument = gql`
    mutation CreateMovablesLocations($movablesLocations: [MovablesLocationInputType!]!) {
  createMovablesLocations(movablesLocations: $movablesLocations) {
    id
  }
}
    `;
export type CreateMovablesLocationsMutationFn = Apollo.MutationFunction<CreateMovablesLocationsMutation, CreateMovablesLocationsMutationVariables>;

/**
 * __useCreateMovablesLocationsMutation__
 *
 * To run a mutation, you first call `useCreateMovablesLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMovablesLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMovablesLocationsMutation, { data, loading, error }] = useCreateMovablesLocationsMutation({
 *   variables: {
 *      movablesLocations: // value for 'movablesLocations'
 *   },
 * });
 */
export function useCreateMovablesLocationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMovablesLocationsMutation, CreateMovablesLocationsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMovablesLocationsMutation, CreateMovablesLocationsMutationVariables>(CreateMovablesLocationsDocument, options);
}
export type CreateMovablesLocationsMutationHookResult = ReturnType<typeof useCreateMovablesLocationsMutation>;
export type CreateMovablesLocationsMutationResult = Apollo.MutationResult<CreateMovablesLocationsMutation>;
export type CreateMovablesLocationsMutationOptions = Apollo.BaseMutationOptions<CreateMovablesLocationsMutation, CreateMovablesLocationsMutationVariables>;
export const DeleteMovablesLocationDocument = gql`
    mutation DeleteMovablesLocation($id: String!) {
  deleteMovablesLocation(id: $id) {
    _
  }
}
    `;
export type DeleteMovablesLocationMutationFn = Apollo.MutationFunction<DeleteMovablesLocationMutation, DeleteMovablesLocationMutationVariables>;

/**
 * __useDeleteMovablesLocationMutation__
 *
 * To run a mutation, you first call `useDeleteMovablesLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMovablesLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMovablesLocationMutation, { data, loading, error }] = useDeleteMovablesLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMovablesLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMovablesLocationMutation, DeleteMovablesLocationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteMovablesLocationMutation, DeleteMovablesLocationMutationVariables>(DeleteMovablesLocationDocument, options);
}
export type DeleteMovablesLocationMutationHookResult = ReturnType<typeof useDeleteMovablesLocationMutation>;
export type DeleteMovablesLocationMutationResult = Apollo.MutationResult<DeleteMovablesLocationMutation>;
export type DeleteMovablesLocationMutationOptions = Apollo.BaseMutationOptions<DeleteMovablesLocationMutation, DeleteMovablesLocationMutationVariables>;
export const DeleteMovablesLocationsDocument = gql`
    mutation DeleteMovablesLocations($ids: [String!]!) {
  deleteMovablesLocations(ids: $ids)
}
    `;
export type DeleteMovablesLocationsMutationFn = Apollo.MutationFunction<DeleteMovablesLocationsMutation, DeleteMovablesLocationsMutationVariables>;

/**
 * __useDeleteMovablesLocationsMutation__
 *
 * To run a mutation, you first call `useDeleteMovablesLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMovablesLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMovablesLocationsMutation, { data, loading, error }] = useDeleteMovablesLocationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteMovablesLocationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMovablesLocationsMutation, DeleteMovablesLocationsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteMovablesLocationsMutation, DeleteMovablesLocationsMutationVariables>(DeleteMovablesLocationsDocument, options);
}
export type DeleteMovablesLocationsMutationHookResult = ReturnType<typeof useDeleteMovablesLocationsMutation>;
export type DeleteMovablesLocationsMutationResult = Apollo.MutationResult<DeleteMovablesLocationsMutation>;
export type DeleteMovablesLocationsMutationOptions = Apollo.BaseMutationOptions<DeleteMovablesLocationsMutation, DeleteMovablesLocationsMutationVariables>;
export const GetMovablesLocationsDocument = gql`
    query GetMovablesLocations($location: String) {
  movablesLocations(location: $location) {
    ...BaseMovablesLocationFragment
  }
}
    ${BaseMovablesLocationFragmentFragmentDoc}`;

/**
 * __useGetMovablesLocationsQuery__
 *
 * To run a query within a React component, call `useGetMovablesLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovablesLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovablesLocationsQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetMovablesLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMovablesLocationsQuery, GetMovablesLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMovablesLocationsQuery, GetMovablesLocationsQueryVariables>(GetMovablesLocationsDocument, options);
}
export function useGetMovablesLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovablesLocationsQuery, GetMovablesLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMovablesLocationsQuery, GetMovablesLocationsQueryVariables>(GetMovablesLocationsDocument, options);
}
export function useGetMovablesLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovablesLocationsQuery, GetMovablesLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMovablesLocationsQuery, GetMovablesLocationsQueryVariables>(GetMovablesLocationsDocument, options);
}
export type GetMovablesLocationsQueryHookResult = ReturnType<typeof useGetMovablesLocationsQuery>;
export type GetMovablesLocationsLazyQueryHookResult = ReturnType<typeof useGetMovablesLocationsLazyQuery>;
export type GetMovablesLocationsSuspenseQueryHookResult = ReturnType<typeof useGetMovablesLocationsSuspenseQuery>;
export type GetMovablesLocationsQueryResult = Apollo.QueryResult<GetMovablesLocationsQuery, GetMovablesLocationsQueryVariables>;
export function refetchGetMovablesLocationsQuery(variables?: GetMovablesLocationsQueryVariables) {
  return { query: GetMovablesLocationsDocument, variables: variables }
}
export const UpdateMovablesLocationDocument = gql`
    mutation UpdateMovablesLocation($id: String!, $name: String, $volume: Decimal!) {
  updateMovablesLocation(id: $id, name: $name, volume: $volume) {
    ...BaseMovablesLocationFragment
  }
}
    ${BaseMovablesLocationFragmentFragmentDoc}`;
export type UpdateMovablesLocationMutationFn = Apollo.MutationFunction<UpdateMovablesLocationMutation, UpdateMovablesLocationMutationVariables>;

/**
 * __useUpdateMovablesLocationMutation__
 *
 * To run a mutation, you first call `useUpdateMovablesLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovablesLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovablesLocationMutation, { data, loading, error }] = useUpdateMovablesLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      volume: // value for 'volume'
 *   },
 * });
 */
export function useUpdateMovablesLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMovablesLocationMutation, UpdateMovablesLocationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateMovablesLocationMutation, UpdateMovablesLocationMutationVariables>(UpdateMovablesLocationDocument, options);
}
export type UpdateMovablesLocationMutationHookResult = ReturnType<typeof useUpdateMovablesLocationMutation>;
export type UpdateMovablesLocationMutationResult = Apollo.MutationResult<UpdateMovablesLocationMutation>;
export type UpdateMovablesLocationMutationOptions = Apollo.BaseMutationOptions<UpdateMovablesLocationMutation, UpdateMovablesLocationMutationVariables>;
export const CreateNotificationConfigDocument = gql`
    mutation CreateNotificationConfig($config: NotificationConfigInputType!) {
  createNotificationConfig(config: $config) {
    ...BaseNotificationFragment
  }
}
    ${BaseNotificationFragmentFragmentDoc}`;
export type CreateNotificationConfigMutationFn = Apollo.MutationFunction<CreateNotificationConfigMutation, CreateNotificationConfigMutationVariables>;

/**
 * __useCreateNotificationConfigMutation__
 *
 * To run a mutation, you first call `useCreateNotificationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationConfigMutation, { data, loading, error }] = useCreateNotificationConfigMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useCreateNotificationConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationConfigMutation, CreateNotificationConfigMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateNotificationConfigMutation, CreateNotificationConfigMutationVariables>(CreateNotificationConfigDocument, options);
}
export type CreateNotificationConfigMutationHookResult = ReturnType<typeof useCreateNotificationConfigMutation>;
export type CreateNotificationConfigMutationResult = Apollo.MutationResult<CreateNotificationConfigMutation>;
export type CreateNotificationConfigMutationOptions = Apollo.BaseMutationOptions<CreateNotificationConfigMutation, CreateNotificationConfigMutationVariables>;
export const DeleteNotificationConfigDocument = gql`
    mutation DeleteNotificationConfig($trigger: NotificationTrigger!) {
  deleteNotificationConfig(trigger: $trigger) {
    _
  }
}
    `;
export type DeleteNotificationConfigMutationFn = Apollo.MutationFunction<DeleteNotificationConfigMutation, DeleteNotificationConfigMutationVariables>;

/**
 * __useDeleteNotificationConfigMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationConfigMutation, { data, loading, error }] = useDeleteNotificationConfigMutation({
 *   variables: {
 *      trigger: // value for 'trigger'
 *   },
 * });
 */
export function useDeleteNotificationConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationConfigMutation, DeleteNotificationConfigMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteNotificationConfigMutation, DeleteNotificationConfigMutationVariables>(DeleteNotificationConfigDocument, options);
}
export type DeleteNotificationConfigMutationHookResult = ReturnType<typeof useDeleteNotificationConfigMutation>;
export type DeleteNotificationConfigMutationResult = Apollo.MutationResult<DeleteNotificationConfigMutation>;
export type DeleteNotificationConfigMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationConfigMutation, DeleteNotificationConfigMutationVariables>;
export const GetEmailTemplatesDocument = gql`
    query GetEmailTemplates {
  emailTemplates {
    id
    name
  }
}
    `;

/**
 * __useGetEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
}
export function useGetEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
}
export function useGetEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
}
export type GetEmailTemplatesQueryHookResult = ReturnType<typeof useGetEmailTemplatesQuery>;
export type GetEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetEmailTemplatesLazyQuery>;
export type GetEmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplatesSuspenseQuery>;
export type GetEmailTemplatesQueryResult = Apollo.QueryResult<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>;
export function refetchGetEmailTemplatesQuery(variables?: GetEmailTemplatesQueryVariables) {
  return { query: GetEmailTemplatesDocument, variables: variables }
}
export const GetNotificationsDocument = gql`
    query GetNotifications {
  notificationConfigs {
    ...BaseNotificationFragment
  }
}
    ${BaseNotificationFragmentFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function refetchGetNotificationsQuery(variables?: GetNotificationsQueryVariables) {
  return { query: GetNotificationsDocument, variables: variables }
}
export const GetSmsTemplatesDocument = gql`
    query GetSmsTemplates {
  smsTemplates {
    id
    name
  }
}
    `;

/**
 * __useGetSmsTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSmsTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSmsTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>(GetSmsTemplatesDocument, options);
}
export function useGetSmsTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>(GetSmsTemplatesDocument, options);
}
export function useGetSmsTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>(GetSmsTemplatesDocument, options);
}
export type GetSmsTemplatesQueryHookResult = ReturnType<typeof useGetSmsTemplatesQuery>;
export type GetSmsTemplatesLazyQueryHookResult = ReturnType<typeof useGetSmsTemplatesLazyQuery>;
export type GetSmsTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetSmsTemplatesSuspenseQuery>;
export type GetSmsTemplatesQueryResult = Apollo.QueryResult<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>;
export function refetchGetSmsTemplatesQuery(variables?: GetSmsTemplatesQueryVariables) {
  return { query: GetSmsTemplatesDocument, variables: variables }
}
export const UpdateNotificationConfigDocument = gql`
    mutation UpdateNotificationConfig($id: String!, $trigger: NotificationTrigger!, $emailBodyTemplateId: Int, $emailSubjectTemplate: String, $smsTemplateId: Int, $displayName: String) {
  updateNotificationConfig(
    id: $id
    trigger: $trigger
    emailBodyTemplateId: $emailBodyTemplateId
    smsTemplateId: $smsTemplateId
    emailSubjectTemplate: $emailSubjectTemplate
    displayName: $displayName
  ) {
    ...BaseNotificationFragment
  }
}
    ${BaseNotificationFragmentFragmentDoc}`;
export type UpdateNotificationConfigMutationFn = Apollo.MutationFunction<UpdateNotificationConfigMutation, UpdateNotificationConfigMutationVariables>;

/**
 * __useUpdateNotificationConfigMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationConfigMutation, { data, loading, error }] = useUpdateNotificationConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trigger: // value for 'trigger'
 *      emailBodyTemplateId: // value for 'emailBodyTemplateId'
 *      emailSubjectTemplate: // value for 'emailSubjectTemplate'
 *      smsTemplateId: // value for 'smsTemplateId'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useUpdateNotificationConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationConfigMutation, UpdateNotificationConfigMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateNotificationConfigMutation, UpdateNotificationConfigMutationVariables>(UpdateNotificationConfigDocument, options);
}
export type UpdateNotificationConfigMutationHookResult = ReturnType<typeof useUpdateNotificationConfigMutation>;
export type UpdateNotificationConfigMutationResult = Apollo.MutationResult<UpdateNotificationConfigMutation>;
export type UpdateNotificationConfigMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationConfigMutation, UpdateNotificationConfigMutationVariables>;
export const GetNotificationItemsDocument = gql`
    query GetNotificationItems($dateFrom: String, $dateTo: String) {
  notificationItems(dateFrom: $dateFrom, dateTo: $dateTo) {
    ...BaseNotificationItemFragment
  }
}
    ${BaseNotificationItemFragmentFragmentDoc}`;

/**
 * __useGetNotificationItemsQuery__
 *
 * To run a query within a React component, call `useGetNotificationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationItemsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetNotificationItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationItemsQuery, GetNotificationItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetNotificationItemsQuery, GetNotificationItemsQueryVariables>(GetNotificationItemsDocument, options);
}
export function useGetNotificationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationItemsQuery, GetNotificationItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetNotificationItemsQuery, GetNotificationItemsQueryVariables>(GetNotificationItemsDocument, options);
}
export function useGetNotificationItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationItemsQuery, GetNotificationItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetNotificationItemsQuery, GetNotificationItemsQueryVariables>(GetNotificationItemsDocument, options);
}
export type GetNotificationItemsQueryHookResult = ReturnType<typeof useGetNotificationItemsQuery>;
export type GetNotificationItemsLazyQueryHookResult = ReturnType<typeof useGetNotificationItemsLazyQuery>;
export type GetNotificationItemsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationItemsSuspenseQuery>;
export type GetNotificationItemsQueryResult = Apollo.QueryResult<GetNotificationItemsQuery, GetNotificationItemsQueryVariables>;
export function refetchGetNotificationItemsQuery(variables?: GetNotificationItemsQueryVariables) {
  return { query: GetNotificationItemsDocument, variables: variables }
}
export const CreateQuestionnaireTemplateDocument = gql`
    mutation CreateQuestionnaireTemplate($questionnaireTemplate: QuestionnaireTemplateInput!) {
  createQuestionnaireTemplate(questionnaireTemplate: $questionnaireTemplate) {
    ...BaseQuestionnaireTemplateFragment
  }
}
    ${BaseQuestionnaireTemplateFragmentFragmentDoc}`;
export type CreateQuestionnaireTemplateMutationFn = Apollo.MutationFunction<CreateQuestionnaireTemplateMutation, CreateQuestionnaireTemplateMutationVariables>;

/**
 * __useCreateQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionnaireTemplateMutation, { data, loading, error }] = useCreateQuestionnaireTemplateMutation({
 *   variables: {
 *      questionnaireTemplate: // value for 'questionnaireTemplate'
 *   },
 * });
 */
export function useCreateQuestionnaireTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionnaireTemplateMutation, CreateQuestionnaireTemplateMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateQuestionnaireTemplateMutation, CreateQuestionnaireTemplateMutationVariables>(CreateQuestionnaireTemplateDocument, options);
}
export type CreateQuestionnaireTemplateMutationHookResult = ReturnType<typeof useCreateQuestionnaireTemplateMutation>;
export type CreateQuestionnaireTemplateMutationResult = Apollo.MutationResult<CreateQuestionnaireTemplateMutation>;
export type CreateQuestionnaireTemplateMutationOptions = Apollo.BaseMutationOptions<CreateQuestionnaireTemplateMutation, CreateQuestionnaireTemplateMutationVariables>;
export const DeleteQuestionnaireTemplatesDocument = gql`
    mutation DeleteQuestionnaireTemplates($questionnaireTemplateIds: [String!]!) {
  deleteQuestionnaireTemplates(
    questionnaireTemplateIds: $questionnaireTemplateIds
  ) {
    _
  }
}
    `;
export type DeleteQuestionnaireTemplatesMutationFn = Apollo.MutationFunction<DeleteQuestionnaireTemplatesMutation, DeleteQuestionnaireTemplatesMutationVariables>;

/**
 * __useDeleteQuestionnaireTemplatesMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionnaireTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionnaireTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionnaireTemplatesMutation, { data, loading, error }] = useDeleteQuestionnaireTemplatesMutation({
 *   variables: {
 *      questionnaireTemplateIds: // value for 'questionnaireTemplateIds'
 *   },
 * });
 */
export function useDeleteQuestionnaireTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionnaireTemplatesMutation, DeleteQuestionnaireTemplatesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteQuestionnaireTemplatesMutation, DeleteQuestionnaireTemplatesMutationVariables>(DeleteQuestionnaireTemplatesDocument, options);
}
export type DeleteQuestionnaireTemplatesMutationHookResult = ReturnType<typeof useDeleteQuestionnaireTemplatesMutation>;
export type DeleteQuestionnaireTemplatesMutationResult = Apollo.MutationResult<DeleteQuestionnaireTemplatesMutation>;
export type DeleteQuestionnaireTemplatesMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionnaireTemplatesMutation, DeleteQuestionnaireTemplatesMutationVariables>;
export const GetAllQuestionnaireTemplatesDocument = gql`
    query GetAllQuestionnaireTemplates {
  allQuestionnaireTemplates {
    ...BaseQuestionnaireTemplateFragment
  }
}
    ${BaseQuestionnaireTemplateFragmentFragmentDoc}`;

/**
 * __useGetAllQuestionnaireTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAllQuestionnaireTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuestionnaireTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllQuestionnaireTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllQuestionnaireTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>(GetAllQuestionnaireTemplatesDocument, options);
}
export function useGetAllQuestionnaireTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>(GetAllQuestionnaireTemplatesDocument, options);
}
export function useGetAllQuestionnaireTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>(GetAllQuestionnaireTemplatesDocument, options);
}
export type GetAllQuestionnaireTemplatesQueryHookResult = ReturnType<typeof useGetAllQuestionnaireTemplatesQuery>;
export type GetAllQuestionnaireTemplatesLazyQueryHookResult = ReturnType<typeof useGetAllQuestionnaireTemplatesLazyQuery>;
export type GetAllQuestionnaireTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetAllQuestionnaireTemplatesSuspenseQuery>;
export type GetAllQuestionnaireTemplatesQueryResult = Apollo.QueryResult<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>;
export function refetchGetAllQuestionnaireTemplatesQuery(variables?: GetAllQuestionnaireTemplatesQueryVariables) {
  return { query: GetAllQuestionnaireTemplatesDocument, variables: variables }
}
export const UpdateQuestionnaireTemplateDocument = gql`
    mutation UpdateQuestionnaireTemplate($id: String!, $label: String!, $sections: [QuestionnaireSectionInputType!]!, $damageCauses: [String!]!, $drivingSlipCategories: [String!]!) {
  updateQuestionnaireTemplate(
    id: $id
    label: $label
    sections: $sections
    damageCauses: $damageCauses
    drivingSlipCategories: $drivingSlipCategories
  ) {
    ...BaseQuestionnaireTemplateFragment
  }
}
    ${BaseQuestionnaireTemplateFragmentFragmentDoc}`;
export type UpdateQuestionnaireTemplateMutationFn = Apollo.MutationFunction<UpdateQuestionnaireTemplateMutation, UpdateQuestionnaireTemplateMutationVariables>;

/**
 * __useUpdateQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionnaireTemplateMutation, { data, loading, error }] = useUpdateQuestionnaireTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      label: // value for 'label'
 *      sections: // value for 'sections'
 *      damageCauses: // value for 'damageCauses'
 *      drivingSlipCategories: // value for 'drivingSlipCategories'
 *   },
 * });
 */
export function useUpdateQuestionnaireTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionnaireTemplateMutation, UpdateQuestionnaireTemplateMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateQuestionnaireTemplateMutation, UpdateQuestionnaireTemplateMutationVariables>(UpdateQuestionnaireTemplateDocument, options);
}
export type UpdateQuestionnaireTemplateMutationHookResult = ReturnType<typeof useUpdateQuestionnaireTemplateMutation>;
export type UpdateQuestionnaireTemplateMutationResult = Apollo.MutationResult<UpdateQuestionnaireTemplateMutation>;
export type UpdateQuestionnaireTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionnaireTemplateMutation, UpdateQuestionnaireTemplateMutationVariables>;
export const CreateRiskEvaluationCategoryDocument = gql`
    mutation CreateRiskEvaluationCategory($riskEvaluationCategory: RiskEvaluationCategoryInput!) {
  createRiskEvaluationCategory(riskEvaluationCategory: $riskEvaluationCategory) {
    id
    categoryName
  }
}
    `;
export type CreateRiskEvaluationCategoryMutationFn = Apollo.MutationFunction<CreateRiskEvaluationCategoryMutation, CreateRiskEvaluationCategoryMutationVariables>;

/**
 * __useCreateRiskEvaluationCategoryMutation__
 *
 * To run a mutation, you first call `useCreateRiskEvaluationCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskEvaluationCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskEvaluationCategoryMutation, { data, loading, error }] = useCreateRiskEvaluationCategoryMutation({
 *   variables: {
 *      riskEvaluationCategory: // value for 'riskEvaluationCategory'
 *   },
 * });
 */
export function useCreateRiskEvaluationCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskEvaluationCategoryMutation, CreateRiskEvaluationCategoryMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateRiskEvaluationCategoryMutation, CreateRiskEvaluationCategoryMutationVariables>(CreateRiskEvaluationCategoryDocument, options);
}
export type CreateRiskEvaluationCategoryMutationHookResult = ReturnType<typeof useCreateRiskEvaluationCategoryMutation>;
export type CreateRiskEvaluationCategoryMutationResult = Apollo.MutationResult<CreateRiskEvaluationCategoryMutation>;
export type CreateRiskEvaluationCategoryMutationOptions = Apollo.BaseMutationOptions<CreateRiskEvaluationCategoryMutation, CreateRiskEvaluationCategoryMutationVariables>;
export const CreateRiskEvaluationQuestionDocument = gql`
    mutation CreateRiskEvaluationQuestion($riskEvaluationQuestion: RiskEvaluationQuestionInput!) {
  createRiskEvaluationQuestion(riskEvaluationQuestion: $riskEvaluationQuestion) {
    ...BaseRiskEvaluationQuestionFragment
  }
}
    ${BaseRiskEvaluationQuestionFragmentFragmentDoc}`;
export type CreateRiskEvaluationQuestionMutationFn = Apollo.MutationFunction<CreateRiskEvaluationQuestionMutation, CreateRiskEvaluationQuestionMutationVariables>;

/**
 * __useCreateRiskEvaluationQuestionMutation__
 *
 * To run a mutation, you first call `useCreateRiskEvaluationQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskEvaluationQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskEvaluationQuestionMutation, { data, loading, error }] = useCreateRiskEvaluationQuestionMutation({
 *   variables: {
 *      riskEvaluationQuestion: // value for 'riskEvaluationQuestion'
 *   },
 * });
 */
export function useCreateRiskEvaluationQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskEvaluationQuestionMutation, CreateRiskEvaluationQuestionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateRiskEvaluationQuestionMutation, CreateRiskEvaluationQuestionMutationVariables>(CreateRiskEvaluationQuestionDocument, options);
}
export type CreateRiskEvaluationQuestionMutationHookResult = ReturnType<typeof useCreateRiskEvaluationQuestionMutation>;
export type CreateRiskEvaluationQuestionMutationResult = Apollo.MutationResult<CreateRiskEvaluationQuestionMutation>;
export type CreateRiskEvaluationQuestionMutationOptions = Apollo.BaseMutationOptions<CreateRiskEvaluationQuestionMutation, CreateRiskEvaluationQuestionMutationVariables>;
export const DeleteRiskEvaluationCategoryDocument = gql`
    mutation DeleteRiskEvaluationCategory($id: String!) {
  deleteRiskEvaluationCategory(id: $id) {
    _
  }
}
    `;
export type DeleteRiskEvaluationCategoryMutationFn = Apollo.MutationFunction<DeleteRiskEvaluationCategoryMutation, DeleteRiskEvaluationCategoryMutationVariables>;

/**
 * __useDeleteRiskEvaluationCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteRiskEvaluationCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRiskEvaluationCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRiskEvaluationCategoryMutation, { data, loading, error }] = useDeleteRiskEvaluationCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRiskEvaluationCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRiskEvaluationCategoryMutation, DeleteRiskEvaluationCategoryMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteRiskEvaluationCategoryMutation, DeleteRiskEvaluationCategoryMutationVariables>(DeleteRiskEvaluationCategoryDocument, options);
}
export type DeleteRiskEvaluationCategoryMutationHookResult = ReturnType<typeof useDeleteRiskEvaluationCategoryMutation>;
export type DeleteRiskEvaluationCategoryMutationResult = Apollo.MutationResult<DeleteRiskEvaluationCategoryMutation>;
export type DeleteRiskEvaluationCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteRiskEvaluationCategoryMutation, DeleteRiskEvaluationCategoryMutationVariables>;
export const DeleteRiskEvaluationQuestionDocument = gql`
    mutation DeleteRiskEvaluationQuestion($id: String!) {
  deleteRiskEvaluationQuestion(id: $id) {
    _
  }
}
    `;
export type DeleteRiskEvaluationQuestionMutationFn = Apollo.MutationFunction<DeleteRiskEvaluationQuestionMutation, DeleteRiskEvaluationQuestionMutationVariables>;

/**
 * __useDeleteRiskEvaluationQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteRiskEvaluationQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRiskEvaluationQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRiskEvaluationQuestionMutation, { data, loading, error }] = useDeleteRiskEvaluationQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRiskEvaluationQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRiskEvaluationQuestionMutation, DeleteRiskEvaluationQuestionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteRiskEvaluationQuestionMutation, DeleteRiskEvaluationQuestionMutationVariables>(DeleteRiskEvaluationQuestionDocument, options);
}
export type DeleteRiskEvaluationQuestionMutationHookResult = ReturnType<typeof useDeleteRiskEvaluationQuestionMutation>;
export type DeleteRiskEvaluationQuestionMutationResult = Apollo.MutationResult<DeleteRiskEvaluationQuestionMutation>;
export type DeleteRiskEvaluationQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteRiskEvaluationQuestionMutation, DeleteRiskEvaluationQuestionMutationVariables>;
export const GetRiskEvaluationQuestionsByCategoryIdDocument = gql`
    query GetRiskEvaluationQuestionsByCategoryId($id: String!) {
  riskEvaluationQuestionsByCategoryId(id: $id) {
    ...BaseRiskEvaluationQuestionFragment
  }
}
    ${BaseRiskEvaluationQuestionFragmentFragmentDoc}`;

/**
 * __useGetRiskEvaluationQuestionsByCategoryIdQuery__
 *
 * To run a query within a React component, call `useGetRiskEvaluationQuestionsByCategoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskEvaluationQuestionsByCategoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskEvaluationQuestionsByCategoryIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRiskEvaluationQuestionsByCategoryIdQuery(baseOptions: Apollo.QueryHookOptions<GetRiskEvaluationQuestionsByCategoryIdQuery, GetRiskEvaluationQuestionsByCategoryIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRiskEvaluationQuestionsByCategoryIdQuery, GetRiskEvaluationQuestionsByCategoryIdQueryVariables>(GetRiskEvaluationQuestionsByCategoryIdDocument, options);
}
export function useGetRiskEvaluationQuestionsByCategoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskEvaluationQuestionsByCategoryIdQuery, GetRiskEvaluationQuestionsByCategoryIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRiskEvaluationQuestionsByCategoryIdQuery, GetRiskEvaluationQuestionsByCategoryIdQueryVariables>(GetRiskEvaluationQuestionsByCategoryIdDocument, options);
}
export function useGetRiskEvaluationQuestionsByCategoryIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRiskEvaluationQuestionsByCategoryIdQuery, GetRiskEvaluationQuestionsByCategoryIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRiskEvaluationQuestionsByCategoryIdQuery, GetRiskEvaluationQuestionsByCategoryIdQueryVariables>(GetRiskEvaluationQuestionsByCategoryIdDocument, options);
}
export type GetRiskEvaluationQuestionsByCategoryIdQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionsByCategoryIdQuery>;
export type GetRiskEvaluationQuestionsByCategoryIdLazyQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionsByCategoryIdLazyQuery>;
export type GetRiskEvaluationQuestionsByCategoryIdSuspenseQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionsByCategoryIdSuspenseQuery>;
export type GetRiskEvaluationQuestionsByCategoryIdQueryResult = Apollo.QueryResult<GetRiskEvaluationQuestionsByCategoryIdQuery, GetRiskEvaluationQuestionsByCategoryIdQueryVariables>;
export function refetchGetRiskEvaluationQuestionsByCategoryIdQuery(variables: GetRiskEvaluationQuestionsByCategoryIdQueryVariables) {
  return { query: GetRiskEvaluationQuestionsByCategoryIdDocument, variables: variables }
}
export const GetRiskEvaluationCategoriesDocument = gql`
    query GetRiskEvaluationCategories {
  riskEvaluationCategories {
    id
    categoryName
  }
}
    `;

/**
 * __useGetRiskEvaluationCategoriesQuery__
 *
 * To run a query within a React component, call `useGetRiskEvaluationCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskEvaluationCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskEvaluationCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRiskEvaluationCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetRiskEvaluationCategoriesQuery, GetRiskEvaluationCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRiskEvaluationCategoriesQuery, GetRiskEvaluationCategoriesQueryVariables>(GetRiskEvaluationCategoriesDocument, options);
}
export function useGetRiskEvaluationCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskEvaluationCategoriesQuery, GetRiskEvaluationCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRiskEvaluationCategoriesQuery, GetRiskEvaluationCategoriesQueryVariables>(GetRiskEvaluationCategoriesDocument, options);
}
export function useGetRiskEvaluationCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRiskEvaluationCategoriesQuery, GetRiskEvaluationCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRiskEvaluationCategoriesQuery, GetRiskEvaluationCategoriesQueryVariables>(GetRiskEvaluationCategoriesDocument, options);
}
export type GetRiskEvaluationCategoriesQueryHookResult = ReturnType<typeof useGetRiskEvaluationCategoriesQuery>;
export type GetRiskEvaluationCategoriesLazyQueryHookResult = ReturnType<typeof useGetRiskEvaluationCategoriesLazyQuery>;
export type GetRiskEvaluationCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetRiskEvaluationCategoriesSuspenseQuery>;
export type GetRiskEvaluationCategoriesQueryResult = Apollo.QueryResult<GetRiskEvaluationCategoriesQuery, GetRiskEvaluationCategoriesQueryVariables>;
export function refetchGetRiskEvaluationCategoriesQuery(variables?: GetRiskEvaluationCategoriesQueryVariables) {
  return { query: GetRiskEvaluationCategoriesDocument, variables: variables }
}
export const GetRiskEvaluationQuestionDocument = gql`
    query GetRiskEvaluationQuestion($id: String!) {
  riskEvaluationQuestion(id: $id) {
    ...BaseRiskEvaluationQuestionFragment
  }
}
    ${BaseRiskEvaluationQuestionFragmentFragmentDoc}`;

/**
 * __useGetRiskEvaluationQuestionQuery__
 *
 * To run a query within a React component, call `useGetRiskEvaluationQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskEvaluationQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskEvaluationQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRiskEvaluationQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetRiskEvaluationQuestionQuery, GetRiskEvaluationQuestionQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRiskEvaluationQuestionQuery, GetRiskEvaluationQuestionQueryVariables>(GetRiskEvaluationQuestionDocument, options);
}
export function useGetRiskEvaluationQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskEvaluationQuestionQuery, GetRiskEvaluationQuestionQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRiskEvaluationQuestionQuery, GetRiskEvaluationQuestionQueryVariables>(GetRiskEvaluationQuestionDocument, options);
}
export function useGetRiskEvaluationQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRiskEvaluationQuestionQuery, GetRiskEvaluationQuestionQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRiskEvaluationQuestionQuery, GetRiskEvaluationQuestionQueryVariables>(GetRiskEvaluationQuestionDocument, options);
}
export type GetRiskEvaluationQuestionQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionQuery>;
export type GetRiskEvaluationQuestionLazyQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionLazyQuery>;
export type GetRiskEvaluationQuestionSuspenseQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionSuspenseQuery>;
export type GetRiskEvaluationQuestionQueryResult = Apollo.QueryResult<GetRiskEvaluationQuestionQuery, GetRiskEvaluationQuestionQueryVariables>;
export function refetchGetRiskEvaluationQuestionQuery(variables: GetRiskEvaluationQuestionQueryVariables) {
  return { query: GetRiskEvaluationQuestionDocument, variables: variables }
}
export const GetRiskEvaluationQuestionsDocument = gql`
    query GetRiskEvaluationQuestions {
  riskEvaluationQuestions {
    ...BaseRiskEvaluationQuestionFragment
  }
}
    ${BaseRiskEvaluationQuestionFragmentFragmentDoc}`;

/**
 * __useGetRiskEvaluationQuestionsQuery__
 *
 * To run a query within a React component, call `useGetRiskEvaluationQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskEvaluationQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskEvaluationQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRiskEvaluationQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRiskEvaluationQuestionsQuery, GetRiskEvaluationQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRiskEvaluationQuestionsQuery, GetRiskEvaluationQuestionsQueryVariables>(GetRiskEvaluationQuestionsDocument, options);
}
export function useGetRiskEvaluationQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskEvaluationQuestionsQuery, GetRiskEvaluationQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRiskEvaluationQuestionsQuery, GetRiskEvaluationQuestionsQueryVariables>(GetRiskEvaluationQuestionsDocument, options);
}
export function useGetRiskEvaluationQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRiskEvaluationQuestionsQuery, GetRiskEvaluationQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRiskEvaluationQuestionsQuery, GetRiskEvaluationQuestionsQueryVariables>(GetRiskEvaluationQuestionsDocument, options);
}
export type GetRiskEvaluationQuestionsQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionsQuery>;
export type GetRiskEvaluationQuestionsLazyQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionsLazyQuery>;
export type GetRiskEvaluationQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetRiskEvaluationQuestionsSuspenseQuery>;
export type GetRiskEvaluationQuestionsQueryResult = Apollo.QueryResult<GetRiskEvaluationQuestionsQuery, GetRiskEvaluationQuestionsQueryVariables>;
export function refetchGetRiskEvaluationQuestionsQuery(variables?: GetRiskEvaluationQuestionsQueryVariables) {
  return { query: GetRiskEvaluationQuestionsDocument, variables: variables }
}
export const UpdateRiskEvaluationCategoryDocument = gql`
    mutation UpdateRiskEvaluationCategory($id: String!, $categoryName: String) {
  updateRiskEvaluationCategory(id: $id, categoryName: $categoryName) {
    id
    categoryName
  }
}
    `;
export type UpdateRiskEvaluationCategoryMutationFn = Apollo.MutationFunction<UpdateRiskEvaluationCategoryMutation, UpdateRiskEvaluationCategoryMutationVariables>;

/**
 * __useUpdateRiskEvaluationCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateRiskEvaluationCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskEvaluationCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskEvaluationCategoryMutation, { data, loading, error }] = useUpdateRiskEvaluationCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      categoryName: // value for 'categoryName'
 *   },
 * });
 */
export function useUpdateRiskEvaluationCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskEvaluationCategoryMutation, UpdateRiskEvaluationCategoryMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateRiskEvaluationCategoryMutation, UpdateRiskEvaluationCategoryMutationVariables>(UpdateRiskEvaluationCategoryDocument, options);
}
export type UpdateRiskEvaluationCategoryMutationHookResult = ReturnType<typeof useUpdateRiskEvaluationCategoryMutation>;
export type UpdateRiskEvaluationCategoryMutationResult = Apollo.MutationResult<UpdateRiskEvaluationCategoryMutation>;
export type UpdateRiskEvaluationCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateRiskEvaluationCategoryMutation, UpdateRiskEvaluationCategoryMutationVariables>;
export const UpdateRiskEvaluationQuestionDocument = gql`
    mutation UpdateRiskEvaluationQuestion($id: String!, $category: String, $question: String, $helpText: String, $defaultChecked: Boolean) {
  updateRiskEvaluationQuestion(
    id: $id
    category: $category
    question: $question
    helpText: $helpText
    defaultChecked: $defaultChecked
  ) {
    ...BaseRiskEvaluationQuestionFragment
  }
}
    ${BaseRiskEvaluationQuestionFragmentFragmentDoc}`;
export type UpdateRiskEvaluationQuestionMutationFn = Apollo.MutationFunction<UpdateRiskEvaluationQuestionMutation, UpdateRiskEvaluationQuestionMutationVariables>;

/**
 * __useUpdateRiskEvaluationQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateRiskEvaluationQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskEvaluationQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskEvaluationQuestionMutation, { data, loading, error }] = useUpdateRiskEvaluationQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      category: // value for 'category'
 *      question: // value for 'question'
 *      helpText: // value for 'helpText'
 *      defaultChecked: // value for 'defaultChecked'
 *   },
 * });
 */
export function useUpdateRiskEvaluationQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskEvaluationQuestionMutation, UpdateRiskEvaluationQuestionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateRiskEvaluationQuestionMutation, UpdateRiskEvaluationQuestionMutationVariables>(UpdateRiskEvaluationQuestionDocument, options);
}
export type UpdateRiskEvaluationQuestionMutationHookResult = ReturnType<typeof useUpdateRiskEvaluationQuestionMutation>;
export type UpdateRiskEvaluationQuestionMutationResult = Apollo.MutationResult<UpdateRiskEvaluationQuestionMutation>;
export type UpdateRiskEvaluationQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateRiskEvaluationQuestionMutation, UpdateRiskEvaluationQuestionMutationVariables>;
export const CreateScreeningPositionTextDocument = gql`
    mutation CreateScreeningPositionText($screeningPositionText: ScreeningPositionTextInput!) {
  createScreeningPositionText(screeningPositionText: $screeningPositionText) {
    ...BaseScreeningPositionTextFragment
  }
}
    ${BaseScreeningPositionTextFragmentFragmentDoc}`;
export type CreateScreeningPositionTextMutationFn = Apollo.MutationFunction<CreateScreeningPositionTextMutation, CreateScreeningPositionTextMutationVariables>;

/**
 * __useCreateScreeningPositionTextMutation__
 *
 * To run a mutation, you first call `useCreateScreeningPositionTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScreeningPositionTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScreeningPositionTextMutation, { data, loading, error }] = useCreateScreeningPositionTextMutation({
 *   variables: {
 *      screeningPositionText: // value for 'screeningPositionText'
 *   },
 * });
 */
export function useCreateScreeningPositionTextMutation(baseOptions?: Apollo.MutationHookOptions<CreateScreeningPositionTextMutation, CreateScreeningPositionTextMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateScreeningPositionTextMutation, CreateScreeningPositionTextMutationVariables>(CreateScreeningPositionTextDocument, options);
}
export type CreateScreeningPositionTextMutationHookResult = ReturnType<typeof useCreateScreeningPositionTextMutation>;
export type CreateScreeningPositionTextMutationResult = Apollo.MutationResult<CreateScreeningPositionTextMutation>;
export type CreateScreeningPositionTextMutationOptions = Apollo.BaseMutationOptions<CreateScreeningPositionTextMutation, CreateScreeningPositionTextMutationVariables>;
export const DeleteScreeningPositionTextDocument = gql`
    mutation DeleteScreeningPositionText($id: String!) {
  deleteScreeningPositionText(id: $id) {
    _
  }
}
    `;
export type DeleteScreeningPositionTextMutationFn = Apollo.MutationFunction<DeleteScreeningPositionTextMutation, DeleteScreeningPositionTextMutationVariables>;

/**
 * __useDeleteScreeningPositionTextMutation__
 *
 * To run a mutation, you first call `useDeleteScreeningPositionTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScreeningPositionTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScreeningPositionTextMutation, { data, loading, error }] = useDeleteScreeningPositionTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScreeningPositionTextMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScreeningPositionTextMutation, DeleteScreeningPositionTextMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteScreeningPositionTextMutation, DeleteScreeningPositionTextMutationVariables>(DeleteScreeningPositionTextDocument, options);
}
export type DeleteScreeningPositionTextMutationHookResult = ReturnType<typeof useDeleteScreeningPositionTextMutation>;
export type DeleteScreeningPositionTextMutationResult = Apollo.MutationResult<DeleteScreeningPositionTextMutation>;
export type DeleteScreeningPositionTextMutationOptions = Apollo.BaseMutationOptions<DeleteScreeningPositionTextMutation, DeleteScreeningPositionTextMutationVariables>;
export const GetAdminScreeningPositionTextsDocument = gql`
    query GetAdminScreeningPositionTexts($templateCodes: String, $positions: [String!]) {
  screeningPositionTexts(templateCodes: $templateCodes, positions: $positions) {
    id
    templateCode
    position
    text
  }
}
    `;

/**
 * __useGetAdminScreeningPositionTextsQuery__
 *
 * To run a query within a React component, call `useGetAdminScreeningPositionTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminScreeningPositionTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminScreeningPositionTextsQuery({
 *   variables: {
 *      templateCodes: // value for 'templateCodes'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useGetAdminScreeningPositionTextsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminScreeningPositionTextsQuery, GetAdminScreeningPositionTextsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminScreeningPositionTextsQuery, GetAdminScreeningPositionTextsQueryVariables>(GetAdminScreeningPositionTextsDocument, options);
}
export function useGetAdminScreeningPositionTextsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminScreeningPositionTextsQuery, GetAdminScreeningPositionTextsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminScreeningPositionTextsQuery, GetAdminScreeningPositionTextsQueryVariables>(GetAdminScreeningPositionTextsDocument, options);
}
export function useGetAdminScreeningPositionTextsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminScreeningPositionTextsQuery, GetAdminScreeningPositionTextsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminScreeningPositionTextsQuery, GetAdminScreeningPositionTextsQueryVariables>(GetAdminScreeningPositionTextsDocument, options);
}
export type GetAdminScreeningPositionTextsQueryHookResult = ReturnType<typeof useGetAdminScreeningPositionTextsQuery>;
export type GetAdminScreeningPositionTextsLazyQueryHookResult = ReturnType<typeof useGetAdminScreeningPositionTextsLazyQuery>;
export type GetAdminScreeningPositionTextsSuspenseQueryHookResult = ReturnType<typeof useGetAdminScreeningPositionTextsSuspenseQuery>;
export type GetAdminScreeningPositionTextsQueryResult = Apollo.QueryResult<GetAdminScreeningPositionTextsQuery, GetAdminScreeningPositionTextsQueryVariables>;
export function refetchGetAdminScreeningPositionTextsQuery(variables?: GetAdminScreeningPositionTextsQueryVariables) {
  return { query: GetAdminScreeningPositionTextsDocument, variables: variables }
}
export const GetScreeningTemplatesDocument = gql`
    query GetScreeningTemplates {
  screeningTemplates {
    erpReferenceId
    templateCode
    templateName
    lines {
      erpReferenceId
      id
      parentId
      position
      erpReferenceTask
      erpReferenceAccount
      required
      type
      index
      title
      allowCustomTitle
      uom
      price
      linePremiumPercentage
      linePremiumFixedAmount
      linePremiumId
      showCalendar
      excludeFromEnvFee
    }
  }
}
    `;

/**
 * __useGetScreeningTemplatesQuery__
 *
 * To run a query within a React component, call `useGetScreeningTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreeningTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreeningTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScreeningTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetScreeningTemplatesQuery, GetScreeningTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetScreeningTemplatesQuery, GetScreeningTemplatesQueryVariables>(GetScreeningTemplatesDocument, options);
}
export function useGetScreeningTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScreeningTemplatesQuery, GetScreeningTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetScreeningTemplatesQuery, GetScreeningTemplatesQueryVariables>(GetScreeningTemplatesDocument, options);
}
export function useGetScreeningTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScreeningTemplatesQuery, GetScreeningTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetScreeningTemplatesQuery, GetScreeningTemplatesQueryVariables>(GetScreeningTemplatesDocument, options);
}
export type GetScreeningTemplatesQueryHookResult = ReturnType<typeof useGetScreeningTemplatesQuery>;
export type GetScreeningTemplatesLazyQueryHookResult = ReturnType<typeof useGetScreeningTemplatesLazyQuery>;
export type GetScreeningTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetScreeningTemplatesSuspenseQuery>;
export type GetScreeningTemplatesQueryResult = Apollo.QueryResult<GetScreeningTemplatesQuery, GetScreeningTemplatesQueryVariables>;
export function refetchGetScreeningTemplatesQuery(variables?: GetScreeningTemplatesQueryVariables) {
  return { query: GetScreeningTemplatesDocument, variables: variables }
}
export const UpdateScreeningPositionTextDocument = gql`
    mutation UpdateScreeningPositionText($id: String!, $templateCode: String!, $position: String!, $text: String!) {
  updateScreeningPositionText(
    id: $id
    templateCode: $templateCode
    position: $position
    text: $text
  ) {
    ...BaseScreeningPositionTextFragment
  }
}
    ${BaseScreeningPositionTextFragmentFragmentDoc}`;
export type UpdateScreeningPositionTextMutationFn = Apollo.MutationFunction<UpdateScreeningPositionTextMutation, UpdateScreeningPositionTextMutationVariables>;

/**
 * __useUpdateScreeningPositionTextMutation__
 *
 * To run a mutation, you first call `useUpdateScreeningPositionTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreeningPositionTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreeningPositionTextMutation, { data, loading, error }] = useUpdateScreeningPositionTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *      templateCode: // value for 'templateCode'
 *      position: // value for 'position'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateScreeningPositionTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScreeningPositionTextMutation, UpdateScreeningPositionTextMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScreeningPositionTextMutation, UpdateScreeningPositionTextMutationVariables>(UpdateScreeningPositionTextDocument, options);
}
export type UpdateScreeningPositionTextMutationHookResult = ReturnType<typeof useUpdateScreeningPositionTextMutation>;
export type UpdateScreeningPositionTextMutationResult = Apollo.MutationResult<UpdateScreeningPositionTextMutation>;
export type UpdateScreeningPositionTextMutationOptions = Apollo.BaseMutationOptions<UpdateScreeningPositionTextMutation, UpdateScreeningPositionTextMutationVariables>;
export const GetAdminCurrentUserDocument = gql`
    query GetAdminCurrentUser {
  currentUser {
    ...BaseUserFragment
    permissions
  }
}
    ${BaseUserFragmentFragmentDoc}`;

/**
 * __useGetAdminCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetAdminCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminCurrentUserQuery, GetAdminCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminCurrentUserQuery, GetAdminCurrentUserQueryVariables>(GetAdminCurrentUserDocument, options);
}
export function useGetAdminCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCurrentUserQuery, GetAdminCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminCurrentUserQuery, GetAdminCurrentUserQueryVariables>(GetAdminCurrentUserDocument, options);
}
export function useGetAdminCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminCurrentUserQuery, GetAdminCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminCurrentUserQuery, GetAdminCurrentUserQueryVariables>(GetAdminCurrentUserDocument, options);
}
export type GetAdminCurrentUserQueryHookResult = ReturnType<typeof useGetAdminCurrentUserQuery>;
export type GetAdminCurrentUserLazyQueryHookResult = ReturnType<typeof useGetAdminCurrentUserLazyQuery>;
export type GetAdminCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetAdminCurrentUserSuspenseQuery>;
export type GetAdminCurrentUserQueryResult = Apollo.QueryResult<GetAdminCurrentUserQuery, GetAdminCurrentUserQueryVariables>;
export function refetchGetAdminCurrentUserQuery(variables?: GetAdminCurrentUserQueryVariables) {
  return { query: GetAdminCurrentUserDocument, variables: variables }
}
export const GetProxyUsersDocument = gql`
    query GetProxyUsers {
  users(hasProxy: true) {
    id
    name
    email
    proxyUpdatedAt
    proxySetBy {
      id
      name
      email
    }
    proxy {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useGetProxyUsersQuery__
 *
 * To run a query within a React component, call `useGetProxyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProxyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProxyUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProxyUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetProxyUsersQuery, GetProxyUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProxyUsersQuery, GetProxyUsersQueryVariables>(GetProxyUsersDocument, options);
}
export function useGetProxyUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProxyUsersQuery, GetProxyUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProxyUsersQuery, GetProxyUsersQueryVariables>(GetProxyUsersDocument, options);
}
export function useGetProxyUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProxyUsersQuery, GetProxyUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetProxyUsersQuery, GetProxyUsersQueryVariables>(GetProxyUsersDocument, options);
}
export type GetProxyUsersQueryHookResult = ReturnType<typeof useGetProxyUsersQuery>;
export type GetProxyUsersLazyQueryHookResult = ReturnType<typeof useGetProxyUsersLazyQuery>;
export type GetProxyUsersSuspenseQueryHookResult = ReturnType<typeof useGetProxyUsersSuspenseQuery>;
export type GetProxyUsersQueryResult = Apollo.QueryResult<GetProxyUsersQuery, GetProxyUsersQueryVariables>;
export function refetchGetProxyUsersQuery(variables?: GetProxyUsersQueryVariables) {
  return { query: GetProxyUsersDocument, variables: variables }
}
export const GetUsersDocument = gql`
    query GetUsers($external: Boolean, $includeDeleted: Boolean, $lastUpdatedBefore: Date) {
  users(
    external: $external
    includeDeleted: $includeDeleted
    lastUpdatedBefore: $lastUpdatedBefore
  ) {
    id
    name
    email
    updatedAt
    external
    phone
    employeeId
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      external: // value for 'external'
 *      includeDeleted: // value for 'includeDeleted'
 *      lastUpdatedBefore: // value for 'lastUpdatedBefore'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
  return { query: GetUsersDocument, variables: variables }
}
export const SearchAdminUsersDocument = gql`
    query SearchAdminUsers($searchText: String!) {
  searchUsers(searchText: $searchText) {
    ...BaseUserFragment
  }
}
    ${BaseUserFragmentFragmentDoc}`;

/**
 * __useSearchAdminUsersQuery__
 *
 * To run a query within a React component, call `useSearchAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAdminUsersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchAdminUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>(SearchAdminUsersDocument, options);
}
export function useSearchAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>(SearchAdminUsersDocument, options);
}
export function useSearchAdminUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>(SearchAdminUsersDocument, options);
}
export type SearchAdminUsersQueryHookResult = ReturnType<typeof useSearchAdminUsersQuery>;
export type SearchAdminUsersLazyQueryHookResult = ReturnType<typeof useSearchAdminUsersLazyQuery>;
export type SearchAdminUsersSuspenseQueryHookResult = ReturnType<typeof useSearchAdminUsersSuspenseQuery>;
export type SearchAdminUsersQueryResult = Apollo.QueryResult<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>;
export function refetchSearchAdminUsersQuery(variables: SearchAdminUsersQueryVariables) {
  return { query: SearchAdminUsersDocument, variables: variables }
}
export const SearchUserEmailsDocument = gql`
    query SearchUserEmails($searchText: String!) {
  searchUsers(searchText: $searchText) {
    id
    email
  }
}
    `;

/**
 * __useSearchUserEmailsQuery__
 *
 * To run a query within a React component, call `useSearchUserEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserEmailsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchUserEmailsQuery(baseOptions: Apollo.QueryHookOptions<SearchUserEmailsQuery, SearchUserEmailsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchUserEmailsQuery, SearchUserEmailsQueryVariables>(SearchUserEmailsDocument, options);
}
export function useSearchUserEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserEmailsQuery, SearchUserEmailsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchUserEmailsQuery, SearchUserEmailsQueryVariables>(SearchUserEmailsDocument, options);
}
export function useSearchUserEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUserEmailsQuery, SearchUserEmailsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchUserEmailsQuery, SearchUserEmailsQueryVariables>(SearchUserEmailsDocument, options);
}
export type SearchUserEmailsQueryHookResult = ReturnType<typeof useSearchUserEmailsQuery>;
export type SearchUserEmailsLazyQueryHookResult = ReturnType<typeof useSearchUserEmailsLazyQuery>;
export type SearchUserEmailsSuspenseQueryHookResult = ReturnType<typeof useSearchUserEmailsSuspenseQuery>;
export type SearchUserEmailsQueryResult = Apollo.QueryResult<SearchUserEmailsQuery, SearchUserEmailsQueryVariables>;
export function refetchSearchUserEmailsQuery(variables: SearchUserEmailsQueryVariables) {
  return { query: SearchUserEmailsDocument, variables: variables }
}
export const SearchUserNamesDocument = gql`
    query SearchUserNames($searchText: String!) {
  searchUsers(searchText: $searchText) {
    id
    name
  }
}
    `;

/**
 * __useSearchUserNamesQuery__
 *
 * To run a query within a React component, call `useSearchUserNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserNamesQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchUserNamesQuery(baseOptions: Apollo.QueryHookOptions<SearchUserNamesQuery, SearchUserNamesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchUserNamesQuery, SearchUserNamesQueryVariables>(SearchUserNamesDocument, options);
}
export function useSearchUserNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserNamesQuery, SearchUserNamesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchUserNamesQuery, SearchUserNamesQueryVariables>(SearchUserNamesDocument, options);
}
export function useSearchUserNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUserNamesQuery, SearchUserNamesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchUserNamesQuery, SearchUserNamesQueryVariables>(SearchUserNamesDocument, options);
}
export type SearchUserNamesQueryHookResult = ReturnType<typeof useSearchUserNamesQuery>;
export type SearchUserNamesLazyQueryHookResult = ReturnType<typeof useSearchUserNamesLazyQuery>;
export type SearchUserNamesSuspenseQueryHookResult = ReturnType<typeof useSearchUserNamesSuspenseQuery>;
export type SearchUserNamesQueryResult = Apollo.QueryResult<SearchUserNamesQuery, SearchUserNamesQueryVariables>;
export function refetchSearchUserNamesQuery(variables: SearchUserNamesQueryVariables) {
  return { query: SearchUserNamesDocument, variables: variables }
}
export const SetUserDefaultLanguageDocument = gql`
    mutation SetUserDefaultLanguage($language: String!) {
  setUserDefaultLanguage(language: $language) {
    defaultLanguage
  }
}
    `;
export type SetUserDefaultLanguageMutationFn = Apollo.MutationFunction<SetUserDefaultLanguageMutation, SetUserDefaultLanguageMutationVariables>;

/**
 * __useSetUserDefaultLanguageMutation__
 *
 * To run a mutation, you first call `useSetUserDefaultLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserDefaultLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserDefaultLanguageMutation, { data, loading, error }] = useSetUserDefaultLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSetUserDefaultLanguageMutation(baseOptions?: Apollo.MutationHookOptions<SetUserDefaultLanguageMutation, SetUserDefaultLanguageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserDefaultLanguageMutation, SetUserDefaultLanguageMutationVariables>(SetUserDefaultLanguageDocument, options);
}
export type SetUserDefaultLanguageMutationHookResult = ReturnType<typeof useSetUserDefaultLanguageMutation>;
export type SetUserDefaultLanguageMutationResult = Apollo.MutationResult<SetUserDefaultLanguageMutation>;
export type SetUserDefaultLanguageMutationOptions = Apollo.BaseMutationOptions<SetUserDefaultLanguageMutation, SetUserDefaultLanguageMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation CreateQuestion($question: VisitationQuestionInput!) {
  createQuestion(question: $question) {
    ...BaseVisitationQuestionFragment
  }
}
    ${BaseVisitationQuestionFragmentFragmentDoc}`;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      question: // value for 'question'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
}
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation DeleteQuestion($id: String!) {
  deleteQuestion(id: $id) {
    _
  }
}
    `;
export type DeleteQuestionMutationFn = Apollo.MutationFunction<DeleteQuestionMutation, DeleteQuestionMutationVariables>;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMutation, { data, loading, error }] = useDeleteQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteQuestionMutation, DeleteQuestionMutationVariables>(DeleteQuestionDocument, options);
}
export type DeleteQuestionMutationHookResult = ReturnType<typeof useDeleteQuestionMutation>;
export type DeleteQuestionMutationResult = Apollo.MutationResult<DeleteQuestionMutation>;
export type DeleteQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const GetQuestionsDocument = gql`
    query GetQuestions {
  questions {
    ...BaseVisitationQuestionFragment
  }
}
    ${BaseVisitationQuestionFragmentFragmentDoc}`;

/**
 * __useGetQuestionsQuery__
 *
 * To run a query within a React component, call `useGetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
}
export function useGetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
}
export function useGetQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
}
export type GetQuestionsQueryHookResult = ReturnType<typeof useGetQuestionsQuery>;
export type GetQuestionsLazyQueryHookResult = ReturnType<typeof useGetQuestionsLazyQuery>;
export type GetQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsSuspenseQuery>;
export type GetQuestionsQueryResult = Apollo.QueryResult<GetQuestionsQuery, GetQuestionsQueryVariables>;
export function refetchGetQuestionsQuery(variables?: GetQuestionsQueryVariables) {
  return { query: GetQuestionsDocument, variables: variables }
}
export const UpdateQuestionDocument = gql`
    mutation UpdateQuestion($id: String!, $question: String!, $damageCategory: String!, $damageCause: String!) {
  updateQuestion(
    id: $id
    question: $question
    damageCategory: $damageCategory
    damageCause: $damageCause
  ) {
    ...BaseVisitationQuestionFragment
  }
}
    ${BaseVisitationQuestionFragmentFragmentDoc}`;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<UpdateQuestionMutation, UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      question: // value for 'question'
 *      damageCategory: // value for 'damageCategory'
 *      damageCause: // value for 'damageCause'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
}
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const GetInputFieldsDocument = gql`
    query GetInputFields($keys: [String!]!) {
  inputFields(keys: $keys) {
    key
    permissions
  }
}
    `;

/**
 * __useGetInputFieldsQuery__
 *
 * To run a query within a React component, call `useGetInputFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInputFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInputFieldsQuery({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useGetInputFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetInputFieldsQuery, GetInputFieldsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInputFieldsQuery, GetInputFieldsQueryVariables>(GetInputFieldsDocument, options);
}
export function useGetInputFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInputFieldsQuery, GetInputFieldsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInputFieldsQuery, GetInputFieldsQueryVariables>(GetInputFieldsDocument, options);
}
export function useGetInputFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInputFieldsQuery, GetInputFieldsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInputFieldsQuery, GetInputFieldsQueryVariables>(GetInputFieldsDocument, options);
}
export type GetInputFieldsQueryHookResult = ReturnType<typeof useGetInputFieldsQuery>;
export type GetInputFieldsLazyQueryHookResult = ReturnType<typeof useGetInputFieldsLazyQuery>;
export type GetInputFieldsSuspenseQueryHookResult = ReturnType<typeof useGetInputFieldsSuspenseQuery>;
export type GetInputFieldsQueryResult = Apollo.QueryResult<GetInputFieldsQuery, GetInputFieldsQueryVariables>;
export function refetchGetInputFieldsQuery(variables: GetInputFieldsQueryVariables) {
  return { query: GetInputFieldsDocument, variables: variables }
}
export const CreateIndoorClimateReportDocument = gql`
    mutation CreateIndoorClimateReport($caseId: String!, $formData: IndoorClimateReportFormDataInput!, $reportFormat: ReportFormatType!, $onlySave: Boolean!) {
  createIndoorClimateReport(
    caseId: $caseId
    formData: $formData
    reportFormat: $reportFormat
    onlySave: $onlySave
  ) {
    name
  }
}
    `;
export type CreateIndoorClimateReportMutationFn = Apollo.MutationFunction<CreateIndoorClimateReportMutation, CreateIndoorClimateReportMutationVariables>;

/**
 * __useCreateIndoorClimateReportMutation__
 *
 * To run a mutation, you first call `useCreateIndoorClimateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndoorClimateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndoorClimateReportMutation, { data, loading, error }] = useCreateIndoorClimateReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      reportFormat: // value for 'reportFormat'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateIndoorClimateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndoorClimateReportMutation, CreateIndoorClimateReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateIndoorClimateReportMutation, CreateIndoorClimateReportMutationVariables>(CreateIndoorClimateReportDocument, options);
}
export type CreateIndoorClimateReportMutationHookResult = ReturnType<typeof useCreateIndoorClimateReportMutation>;
export type CreateIndoorClimateReportMutationResult = Apollo.MutationResult<CreateIndoorClimateReportMutation>;
export type CreateIndoorClimateReportMutationOptions = Apollo.BaseMutationOptions<CreateIndoorClimateReportMutation, CreateIndoorClimateReportMutationVariables>;
export const CreateWebMoistureReportV2Document = gql`
    mutation CreateWebMoistureReportV2($caseId: String!, $formData: MoistureReportFormDataInput!, $reportFormat: ReportFormatType!, $floorsToInclude: [String!], $onlySave: Boolean!) {
  createMoistureReportV2(
    caseId: $caseId
    formData: $formData
    reportFormat: $reportFormat
    floorsToInclude: $floorsToInclude
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateWebMoistureReportV2MutationFn = Apollo.MutationFunction<CreateWebMoistureReportV2Mutation, CreateWebMoistureReportV2MutationVariables>;

/**
 * __useCreateWebMoistureReportV2Mutation__
 *
 * To run a mutation, you first call `useCreateWebMoistureReportV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebMoistureReportV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebMoistureReportV2Mutation, { data, loading, error }] = useCreateWebMoistureReportV2Mutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      reportFormat: // value for 'reportFormat'
 *      floorsToInclude: // value for 'floorsToInclude'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateWebMoistureReportV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateWebMoistureReportV2Mutation, CreateWebMoistureReportV2MutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateWebMoistureReportV2Mutation, CreateWebMoistureReportV2MutationVariables>(CreateWebMoistureReportV2Document, options);
}
export type CreateWebMoistureReportV2MutationHookResult = ReturnType<typeof useCreateWebMoistureReportV2Mutation>;
export type CreateWebMoistureReportV2MutationResult = Apollo.MutationResult<CreateWebMoistureReportV2Mutation>;
export type CreateWebMoistureReportV2MutationOptions = Apollo.BaseMutationOptions<CreateWebMoistureReportV2Mutation, CreateWebMoistureReportV2MutationVariables>;
export const GetCommonCurrentUserDocument = gql`
    query GetCommonCurrentUser {
  currentUser {
    ...BaseUserFragment
    gdpr {
      ...BaseGDPRFragment
    }
    defaultLanguage
    permissions
    external
    caseFilters {
      key
      name
      view
      awaiting
      damageServiceCompleted
      calledBack
      machinesOnCase
      showEconomyField
      showBusinessAreaField
      showAppliedClosedCases
      showClosedCases
      debitors
      postalCodeText
      postalCodes
      track
      departments
      locations
      damageCategories
      damageCauses
      priority
      caseManagers
      projectManagers
    }
    drivingSlipFilters {
      key
      name
      debitors
      postalCodeText
      postalCodes
      departments
      locations
      damageCategories
      damageCauses
      erpNos
      projectManagers
    }
    drivingSlipOverviewFilters {
      key
      name
      status
      urgent
      exceeded
      departments
      locations
      damageCauses
      damageCategories
      drivers
      noDriver
    }
    sanitizerFilters {
      key
      name
      departments
      locations
      jobFunctions
      sanitizers
    }
    carFilters {
      key
      name
      locations
      cars
    }
    movableFilters {
      key
      name
      erpNo
      location
      status
      includeCompleted
      debitors
    }
    jobFilters {
      key
      name
      location
      personalOnly
    }
    machineFilters {
      name
      key
      status
      cases
      locations
      types
      unavailable
      hibernation
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${BaseGdprFragmentFragmentDoc}`;

/**
 * __useGetCommonCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCommonCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommonCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCommonCurrentUserQuery, GetCommonCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCommonCurrentUserQuery, GetCommonCurrentUserQueryVariables>(GetCommonCurrentUserDocument, options);
}
export function useGetCommonCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonCurrentUserQuery, GetCommonCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCommonCurrentUserQuery, GetCommonCurrentUserQueryVariables>(GetCommonCurrentUserDocument, options);
}
export function useGetCommonCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommonCurrentUserQuery, GetCommonCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCommonCurrentUserQuery, GetCommonCurrentUserQueryVariables>(GetCommonCurrentUserDocument, options);
}
export type GetCommonCurrentUserQueryHookResult = ReturnType<typeof useGetCommonCurrentUserQuery>;
export type GetCommonCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCommonCurrentUserLazyQuery>;
export type GetCommonCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCommonCurrentUserSuspenseQuery>;
export type GetCommonCurrentUserQueryResult = Apollo.QueryResult<GetCommonCurrentUserQuery, GetCommonCurrentUserQueryVariables>;
export function refetchGetCommonCurrentUserQuery(variables?: GetCommonCurrentUserQueryVariables) {
  return { query: GetCommonCurrentUserDocument, variables: variables }
}
export const GetUserDocument = gql`
    query GetUser {
  currentUser {
    ...BaseUserFragment
    permissions
  }
}
    ${BaseUserFragmentFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export function refetchGetUserQuery(variables?: GetUserQueryVariables) {
  return { query: GetUserDocument, variables: variables }
}
export const SetUserProxyDocument = gql`
    mutation SetUserProxy($myAdUserName: String!, $proxyAdUserName: String!, $proxySetByAdUserName: String!) {
  setUserProxy(
    myAdUserName: $myAdUserName
    proxyAdUserName: $proxyAdUserName
    proxySetByAdUserName: $proxySetByAdUserName
  ) {
    ...BaseUserFragment
    proxy {
      id
      name
      email
    }
  }
}
    ${BaseUserFragmentFragmentDoc}`;
export type SetUserProxyMutationFn = Apollo.MutationFunction<SetUserProxyMutation, SetUserProxyMutationVariables>;

/**
 * __useSetUserProxyMutation__
 *
 * To run a mutation, you first call `useSetUserProxyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserProxyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserProxyMutation, { data, loading, error }] = useSetUserProxyMutation({
 *   variables: {
 *      myAdUserName: // value for 'myAdUserName'
 *      proxyAdUserName: // value for 'proxyAdUserName'
 *      proxySetByAdUserName: // value for 'proxySetByAdUserName'
 *   },
 * });
 */
export function useSetUserProxyMutation(baseOptions?: Apollo.MutationHookOptions<SetUserProxyMutation, SetUserProxyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserProxyMutation, SetUserProxyMutationVariables>(SetUserProxyDocument, options);
}
export type SetUserProxyMutationHookResult = ReturnType<typeof useSetUserProxyMutation>;
export type SetUserProxyMutationResult = Apollo.MutationResult<SetUserProxyMutation>;
export type SetUserProxyMutationOptions = Apollo.BaseMutationOptions<SetUserProxyMutation, SetUserProxyMutationVariables>;
export const GetVehiclesDocument = gql`
    query GetVehicles($isCar: Boolean!, $dateRange: DateRangeInput, $locations: [String!], $departments: [String!], $type: [String!]) {
  vehicles(
    isCar: $isCar
    dateRange: $dateRange
    locations: $locations
    type: $type
    departments: $departments
  ) {
    ...Vehicle
    bookedDays {
      id
      start
      driver {
        id
        name
      }
    }
  }
}
    ${VehicleFragmentDoc}`;

/**
 * __useGetVehiclesQuery__
 *
 * To run a query within a React component, call `useGetVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehiclesQuery({
 *   variables: {
 *      isCar: // value for 'isCar'
 *      dateRange: // value for 'dateRange'
 *      locations: // value for 'locations'
 *      departments: // value for 'departments'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetVehiclesQuery(baseOptions: Apollo.QueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
}
export function useGetVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
}
export function useGetVehiclesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
}
export type GetVehiclesQueryHookResult = ReturnType<typeof useGetVehiclesQuery>;
export type GetVehiclesLazyQueryHookResult = ReturnType<typeof useGetVehiclesLazyQuery>;
export type GetVehiclesSuspenseQueryHookResult = ReturnType<typeof useGetVehiclesSuspenseQuery>;
export type GetVehiclesQueryResult = Apollo.QueryResult<GetVehiclesQuery, GetVehiclesQueryVariables>;
export function refetchGetVehiclesQuery(variables: GetVehiclesQueryVariables) {
  return { query: GetVehiclesDocument, variables: variables }
}
export const CreateCaseAgreementsFromQuestionnaireDocument = gql`
    mutation CreateCaseAgreementsFromQuestionnaire($id: String!, $newCaseAgreements: [CaseAgreementInput!]!, $trackTwoOptionSelected: Boolean!, $seriesId: String) {
  createCaseAgreementsFromQuestionnaire(
    id: $id
    newCaseAgreements: $newCaseAgreements
    trackTwoOptionSelected: $trackTwoOptionSelected
    seriesId: $seriesId
  ) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type CreateCaseAgreementsFromQuestionnaireMutationFn = Apollo.MutationFunction<CreateCaseAgreementsFromQuestionnaireMutation, CreateCaseAgreementsFromQuestionnaireMutationVariables>;

/**
 * __useCreateCaseAgreementsFromQuestionnaireMutation__
 *
 * To run a mutation, you first call `useCreateCaseAgreementsFromQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseAgreementsFromQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseAgreementsFromQuestionnaireMutation, { data, loading, error }] = useCreateCaseAgreementsFromQuestionnaireMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newCaseAgreements: // value for 'newCaseAgreements'
 *      trackTwoOptionSelected: // value for 'trackTwoOptionSelected'
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useCreateCaseAgreementsFromQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseAgreementsFromQuestionnaireMutation, CreateCaseAgreementsFromQuestionnaireMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCaseAgreementsFromQuestionnaireMutation, CreateCaseAgreementsFromQuestionnaireMutationVariables>(CreateCaseAgreementsFromQuestionnaireDocument, options);
}
export type CreateCaseAgreementsFromQuestionnaireMutationHookResult = ReturnType<typeof useCreateCaseAgreementsFromQuestionnaireMutation>;
export type CreateCaseAgreementsFromQuestionnaireMutationResult = Apollo.MutationResult<CreateCaseAgreementsFromQuestionnaireMutation>;
export type CreateCaseAgreementsFromQuestionnaireMutationOptions = Apollo.BaseMutationOptions<CreateCaseAgreementsFromQuestionnaireMutation, CreateCaseAgreementsFromQuestionnaireMutationVariables>;
export const CreateMobileV2CaseDraftItemUsageDocument = gql`
    mutation CreateMobileV2CaseDraftItemUsage($caseERPReferenceNo: String!, $itemERPReferenceNo: String!, $itemDescription: String!, $jobTaskERPReferenceNo: String!, $quantity: Decimal!, $unitOfMeasureCode: String!) {
  createCaseDraftItemUsage(
    caseERPReferenceNo: $caseERPReferenceNo
    itemERPReferenceNo: $itemERPReferenceNo
    itemDescription: $itemDescription
    jobTaskERPReferenceNo: $jobTaskERPReferenceNo
    quantity: $quantity
    unitOfMeasureCode: $unitOfMeasureCode
  ) {
    erpId
    erpKey
    title
    quantity
    unitOfMeasureCode
    date
    postedBy
    description
    __typename
  }
}
    `;
export type CreateMobileV2CaseDraftItemUsageMutationFn = Apollo.MutationFunction<CreateMobileV2CaseDraftItemUsageMutation, CreateMobileV2CaseDraftItemUsageMutationVariables>;

/**
 * __useCreateMobileV2CaseDraftItemUsageMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2CaseDraftItemUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2CaseDraftItemUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2CaseDraftItemUsageMutation, { data, loading, error }] = useCreateMobileV2CaseDraftItemUsageMutation({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *      itemERPReferenceNo: // value for 'itemERPReferenceNo'
 *      itemDescription: // value for 'itemDescription'
 *      jobTaskERPReferenceNo: // value for 'jobTaskERPReferenceNo'
 *      quantity: // value for 'quantity'
 *      unitOfMeasureCode: // value for 'unitOfMeasureCode'
 *   },
 * });
 */
export function useCreateMobileV2CaseDraftItemUsageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2CaseDraftItemUsageMutation, CreateMobileV2CaseDraftItemUsageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2CaseDraftItemUsageMutation, CreateMobileV2CaseDraftItemUsageMutationVariables>(CreateMobileV2CaseDraftItemUsageDocument, options);
}
export type CreateMobileV2CaseDraftItemUsageMutationHookResult = ReturnType<typeof useCreateMobileV2CaseDraftItemUsageMutation>;
export type CreateMobileV2CaseDraftItemUsageMutationResult = Apollo.MutationResult<CreateMobileV2CaseDraftItemUsageMutation>;
export type CreateMobileV2CaseDraftItemUsageMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2CaseDraftItemUsageMutation, CreateMobileV2CaseDraftItemUsageMutationVariables>;
export const DeleteMobileV2ItemUsageDocument = gql`
    mutation DeleteMobileV2ItemUsage($caseERPReferenceNo: String!, $itemERPReferenceNo: String!) {
  deleteItemUsage(
    caseERPReferenceNo: $caseERPReferenceNo
    itemERPReferenceNo: $itemERPReferenceNo
  ) {
    erpId
    erpKey
    title
    quantity
    date
    postedBy
    description
  }
}
    `;
export type DeleteMobileV2ItemUsageMutationFn = Apollo.MutationFunction<DeleteMobileV2ItemUsageMutation, DeleteMobileV2ItemUsageMutationVariables>;

/**
 * __useDeleteMobileV2ItemUsageMutation__
 *
 * To run a mutation, you first call `useDeleteMobileV2ItemUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMobileV2ItemUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMobileV2ItemUsageMutation, { data, loading, error }] = useDeleteMobileV2ItemUsageMutation({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *      itemERPReferenceNo: // value for 'itemERPReferenceNo'
 *   },
 * });
 */
export function useDeleteMobileV2ItemUsageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMobileV2ItemUsageMutation, DeleteMobileV2ItemUsageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteMobileV2ItemUsageMutation, DeleteMobileV2ItemUsageMutationVariables>(DeleteMobileV2ItemUsageDocument, options);
}
export type DeleteMobileV2ItemUsageMutationHookResult = ReturnType<typeof useDeleteMobileV2ItemUsageMutation>;
export type DeleteMobileV2ItemUsageMutationResult = Apollo.MutationResult<DeleteMobileV2ItemUsageMutation>;
export type DeleteMobileV2ItemUsageMutationOptions = Apollo.BaseMutationOptions<DeleteMobileV2ItemUsageMutation, DeleteMobileV2ItemUsageMutationVariables>;
export const GetCaseDamageDocument = gql`
    query GetCaseDamage($id: String!) {
  case(id: $id) {
    damage {
      ...DamageFragment
    }
  }
}
    ${DamageFragmentFragmentDoc}`;

/**
 * __useGetCaseDamageQuery__
 *
 * To run a query within a React component, call `useGetCaseDamageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseDamageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseDamageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseDamageQuery(baseOptions: Apollo.QueryHookOptions<GetCaseDamageQuery, GetCaseDamageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseDamageQuery, GetCaseDamageQueryVariables>(GetCaseDamageDocument, options);
}
export function useGetCaseDamageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseDamageQuery, GetCaseDamageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseDamageQuery, GetCaseDamageQueryVariables>(GetCaseDamageDocument, options);
}
export function useGetCaseDamageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseDamageQuery, GetCaseDamageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseDamageQuery, GetCaseDamageQueryVariables>(GetCaseDamageDocument, options);
}
export type GetCaseDamageQueryHookResult = ReturnType<typeof useGetCaseDamageQuery>;
export type GetCaseDamageLazyQueryHookResult = ReturnType<typeof useGetCaseDamageLazyQuery>;
export type GetCaseDamageSuspenseQueryHookResult = ReturnType<typeof useGetCaseDamageSuspenseQuery>;
export type GetCaseDamageQueryResult = Apollo.QueryResult<GetCaseDamageQuery, GetCaseDamageQueryVariables>;
export function refetchGetCaseDamageQuery(variables: GetCaseDamageQueryVariables) {
  return { query: GetCaseDamageDocument, variables: variables }
}
export const GetCaseDraftUsageLinesDocument = gql`
    query GetCaseDraftUsageLines($id: String!) {
  case(id: $id) {
    id
    caseDraftItemsUsage {
      erpId
      erpKey
      title
      quantity
      date
      postedBy
    }
  }
}
    `;

/**
 * __useGetCaseDraftUsageLinesQuery__
 *
 * To run a query within a React component, call `useGetCaseDraftUsageLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseDraftUsageLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseDraftUsageLinesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseDraftUsageLinesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseDraftUsageLinesQuery, GetCaseDraftUsageLinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseDraftUsageLinesQuery, GetCaseDraftUsageLinesQueryVariables>(GetCaseDraftUsageLinesDocument, options);
}
export function useGetCaseDraftUsageLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseDraftUsageLinesQuery, GetCaseDraftUsageLinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseDraftUsageLinesQuery, GetCaseDraftUsageLinesQueryVariables>(GetCaseDraftUsageLinesDocument, options);
}
export function useGetCaseDraftUsageLinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseDraftUsageLinesQuery, GetCaseDraftUsageLinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseDraftUsageLinesQuery, GetCaseDraftUsageLinesQueryVariables>(GetCaseDraftUsageLinesDocument, options);
}
export type GetCaseDraftUsageLinesQueryHookResult = ReturnType<typeof useGetCaseDraftUsageLinesQuery>;
export type GetCaseDraftUsageLinesLazyQueryHookResult = ReturnType<typeof useGetCaseDraftUsageLinesLazyQuery>;
export type GetCaseDraftUsageLinesSuspenseQueryHookResult = ReturnType<typeof useGetCaseDraftUsageLinesSuspenseQuery>;
export type GetCaseDraftUsageLinesQueryResult = Apollo.QueryResult<GetCaseDraftUsageLinesQuery, GetCaseDraftUsageLinesQueryVariables>;
export function refetchGetCaseDraftUsageLinesQuery(variables: GetCaseDraftUsageLinesQueryVariables) {
  return { query: GetCaseDraftUsageLinesDocument, variables: variables }
}
export const GetCaseIdsDocument = gql`
    query GetCaseIds {
  cases {
    erpNo
  }
}
    `;

/**
 * __useGetCaseIdsQuery__
 *
 * To run a query within a React component, call `useGetCaseIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCaseIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetCaseIdsQuery, GetCaseIdsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseIdsQuery, GetCaseIdsQueryVariables>(GetCaseIdsDocument, options);
}
export function useGetCaseIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseIdsQuery, GetCaseIdsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseIdsQuery, GetCaseIdsQueryVariables>(GetCaseIdsDocument, options);
}
export function useGetCaseIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseIdsQuery, GetCaseIdsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseIdsQuery, GetCaseIdsQueryVariables>(GetCaseIdsDocument, options);
}
export type GetCaseIdsQueryHookResult = ReturnType<typeof useGetCaseIdsQuery>;
export type GetCaseIdsLazyQueryHookResult = ReturnType<typeof useGetCaseIdsLazyQuery>;
export type GetCaseIdsSuspenseQueryHookResult = ReturnType<typeof useGetCaseIdsSuspenseQuery>;
export type GetCaseIdsQueryResult = Apollo.QueryResult<GetCaseIdsQuery, GetCaseIdsQueryVariables>;
export function refetchGetCaseIdsQuery(variables?: GetCaseIdsQueryVariables) {
  return { query: GetCaseIdsDocument, variables: variables }
}
export const GetCaseRequisitionsDocument = gql`
    query GetCaseRequisitions($id: String!) {
  case(id: $id) {
    id
    erpNo
    requisitions {
      ...RequisitionFragment
    }
    ssgLocation {
      ...BaseLocationFragment
    }
    ssgDepartment {
      ...BaseDepartmentFragment
    }
    debitor {
      ...BaseDebitorFragment
    }
    damage {
      contact {
        address {
          ...AddressFragment
        }
      }
    }
  }
}
    ${RequisitionFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}
${BaseDebitorFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useGetCaseRequisitionsQuery__
 *
 * To run a query within a React component, call `useGetCaseRequisitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseRequisitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseRequisitionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseRequisitionsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseRequisitionsQuery, GetCaseRequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseRequisitionsQuery, GetCaseRequisitionsQueryVariables>(GetCaseRequisitionsDocument, options);
}
export function useGetCaseRequisitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseRequisitionsQuery, GetCaseRequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseRequisitionsQuery, GetCaseRequisitionsQueryVariables>(GetCaseRequisitionsDocument, options);
}
export function useGetCaseRequisitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseRequisitionsQuery, GetCaseRequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseRequisitionsQuery, GetCaseRequisitionsQueryVariables>(GetCaseRequisitionsDocument, options);
}
export type GetCaseRequisitionsQueryHookResult = ReturnType<typeof useGetCaseRequisitionsQuery>;
export type GetCaseRequisitionsLazyQueryHookResult = ReturnType<typeof useGetCaseRequisitionsLazyQuery>;
export type GetCaseRequisitionsSuspenseQueryHookResult = ReturnType<typeof useGetCaseRequisitionsSuspenseQuery>;
export type GetCaseRequisitionsQueryResult = Apollo.QueryResult<GetCaseRequisitionsQuery, GetCaseRequisitionsQueryVariables>;
export function refetchGetCaseRequisitionsQuery(variables: GetCaseRequisitionsQueryVariables) {
  return { query: GetCaseRequisitionsDocument, variables: variables }
}
export const GetMobileV2CaseDocument = gql`
    query GetMobileV2Case($id: String!) {
  case(id: $id) {
    ...BaseCaseFragment
    debitor {
      automaticTrackOneInvoicing
    }
    version
    changes {
      timestamp
      user {
        ...BaseUserFragment
      }
      before {
        ...CaseChangesFragment
      }
      after {
        ...CaseChangesFragment
      }
    }
  }
}
    ${BaseCaseFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${CaseChangesFragmentFragmentDoc}`;

/**
 * __useGetMobileV2CaseQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMobileV2CaseQuery(baseOptions: Apollo.QueryHookOptions<GetMobileV2CaseQuery, GetMobileV2CaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CaseQuery, GetMobileV2CaseQueryVariables>(GetMobileV2CaseDocument, options);
}
export function useGetMobileV2CaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CaseQuery, GetMobileV2CaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CaseQuery, GetMobileV2CaseQueryVariables>(GetMobileV2CaseDocument, options);
}
export function useGetMobileV2CaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CaseQuery, GetMobileV2CaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CaseQuery, GetMobileV2CaseQueryVariables>(GetMobileV2CaseDocument, options);
}
export type GetMobileV2CaseQueryHookResult = ReturnType<typeof useGetMobileV2CaseQuery>;
export type GetMobileV2CaseLazyQueryHookResult = ReturnType<typeof useGetMobileV2CaseLazyQuery>;
export type GetMobileV2CaseSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CaseSuspenseQuery>;
export type GetMobileV2CaseQueryResult = Apollo.QueryResult<GetMobileV2CaseQuery, GetMobileV2CaseQueryVariables>;
export function refetchGetMobileV2CaseQuery(variables: GetMobileV2CaseQueryVariables) {
  return { query: GetMobileV2CaseDocument, variables: variables }
}
export const GetMobileV2CaseAdminDataDocument = gql`
    query GetMobileV2CaseAdminData {
  damageCategories {
    ...BaseDamageCategoryFragment
  }
  damageCauses {
    ...BaseDamageCauseFragment
  }
  departments {
    ...BaseDepartmentFragment
  }
  locations {
    ...BaseLocationFragment
  }
  drivingSlipCategories {
    code
    name
  }
  drivingSlipItems {
    no
    description
    baseUOM
    jobTask
    filterCode
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}`;

/**
 * __useGetMobileV2CaseAdminDataQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CaseAdminDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CaseAdminDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CaseAdminDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMobileV2CaseAdminDataQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2CaseAdminDataQuery, GetMobileV2CaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CaseAdminDataQuery, GetMobileV2CaseAdminDataQueryVariables>(GetMobileV2CaseAdminDataDocument, options);
}
export function useGetMobileV2CaseAdminDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CaseAdminDataQuery, GetMobileV2CaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CaseAdminDataQuery, GetMobileV2CaseAdminDataQueryVariables>(GetMobileV2CaseAdminDataDocument, options);
}
export function useGetMobileV2CaseAdminDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CaseAdminDataQuery, GetMobileV2CaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CaseAdminDataQuery, GetMobileV2CaseAdminDataQueryVariables>(GetMobileV2CaseAdminDataDocument, options);
}
export type GetMobileV2CaseAdminDataQueryHookResult = ReturnType<typeof useGetMobileV2CaseAdminDataQuery>;
export type GetMobileV2CaseAdminDataLazyQueryHookResult = ReturnType<typeof useGetMobileV2CaseAdminDataLazyQuery>;
export type GetMobileV2CaseAdminDataSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CaseAdminDataSuspenseQuery>;
export type GetMobileV2CaseAdminDataQueryResult = Apollo.QueryResult<GetMobileV2CaseAdminDataQuery, GetMobileV2CaseAdminDataQueryVariables>;
export function refetchGetMobileV2CaseAdminDataQuery(variables?: GetMobileV2CaseAdminDataQueryVariables) {
  return { query: GetMobileV2CaseAdminDataDocument, variables: variables }
}
export const GetMobileV2CasesDocument = gql`
    query GetMobileV2Cases($address: AddressInput, $awaiting: Boolean, $damageServiceCompleted: Boolean, $calledBack: Boolean, $machinesOnCase: Boolean, $ownCases: Boolean, $appliedClosed: Boolean, $closedCases: Boolean, $debitor: [String!], $postalCode: [String!], $track: [Int!], $department: [String!], $location: [String!], $damageCategory: [String!], $damageCause: [String!], $priority: [CasePriority!], $caseManager: [String!], $projectManager: [String!], $minDate: Date, $maxDate: Date, $erpReferenceNo: String, $erpReferenceNos: [String!]) {
  cases(
    address: $address
    awaiting: $awaiting
    damageServiceCompleted: $damageServiceCompleted
    calledBack: $calledBack
    machinesOnCase: $machinesOnCase
    ownCases: $ownCases
    appliedClosed: $appliedClosed
    closedCases: $closedCases
    debitor: $debitor
    postalCode: $postalCode
    track: $track
    department: $department
    location: $location
    damageCategory: $damageCategory
    damageCause: $damageCause
    priority: $priority
    caseManager: $caseManager
    projectManager: $projectManager
    minDate: $minDate
    maxDate: $maxDate
    erpReferenceNo: $erpReferenceNo
    erpReferenceNos: $erpReferenceNos
  ) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;

/**
 * __useGetMobileV2CasesQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CasesQuery({
 *   variables: {
 *      address: // value for 'address'
 *      awaiting: // value for 'awaiting'
 *      damageServiceCompleted: // value for 'damageServiceCompleted'
 *      calledBack: // value for 'calledBack'
 *      machinesOnCase: // value for 'machinesOnCase'
 *      ownCases: // value for 'ownCases'
 *      appliedClosed: // value for 'appliedClosed'
 *      closedCases: // value for 'closedCases'
 *      debitor: // value for 'debitor'
 *      postalCode: // value for 'postalCode'
 *      track: // value for 'track'
 *      department: // value for 'department'
 *      location: // value for 'location'
 *      damageCategory: // value for 'damageCategory'
 *      damageCause: // value for 'damageCause'
 *      priority: // value for 'priority'
 *      caseManager: // value for 'caseManager'
 *      projectManager: // value for 'projectManager'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *      erpReferenceNos: // value for 'erpReferenceNos'
 *   },
 * });
 */
export function useGetMobileV2CasesQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2CasesQuery, GetMobileV2CasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CasesQuery, GetMobileV2CasesQueryVariables>(GetMobileV2CasesDocument, options);
}
export function useGetMobileV2CasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CasesQuery, GetMobileV2CasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CasesQuery, GetMobileV2CasesQueryVariables>(GetMobileV2CasesDocument, options);
}
export function useGetMobileV2CasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CasesQuery, GetMobileV2CasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CasesQuery, GetMobileV2CasesQueryVariables>(GetMobileV2CasesDocument, options);
}
export type GetMobileV2CasesQueryHookResult = ReturnType<typeof useGetMobileV2CasesQuery>;
export type GetMobileV2CasesLazyQueryHookResult = ReturnType<typeof useGetMobileV2CasesLazyQuery>;
export type GetMobileV2CasesSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CasesSuspenseQuery>;
export type GetMobileV2CasesQueryResult = Apollo.QueryResult<GetMobileV2CasesQuery, GetMobileV2CasesQueryVariables>;
export function refetchGetMobileV2CasesQuery(variables?: GetMobileV2CasesQueryVariables) {
  return { query: GetMobileV2CasesDocument, variables: variables }
}
export const GetMobileV2CasesByErpNoDocument = gql`
    query GetMobileV2CasesByErpNo($erpReferenceNo: String!, $closedCases: Boolean = true, $appliedClosed: Boolean) {
  cases(
    erpReferenceNo: $erpReferenceNo
    closedCases: $closedCases
    appliedClosed: $appliedClosed
  ) {
    id
    erpNo
    status
    timeRegistration
    debitor {
      unknown
    }
    damage {
      category {
        name
      }
      cause {
        name
      }
      businessArea {
        name
      }
      date
      description
      contact {
        name
        phone
        email
        address {
          road
          houseNumber
          floor
          addressLineAlt
          postalCode
          city
          country
        }
      }
    }
    projectManager {
      id
      name
    }
    caseManager {
      id
      name
    }
  }
}
    `;

/**
 * __useGetMobileV2CasesByErpNoQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CasesByErpNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CasesByErpNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CasesByErpNoQuery({
 *   variables: {
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *      closedCases: // value for 'closedCases'
 *      appliedClosed: // value for 'appliedClosed'
 *   },
 * });
 */
export function useGetMobileV2CasesByErpNoQuery(baseOptions: Apollo.QueryHookOptions<GetMobileV2CasesByErpNoQuery, GetMobileV2CasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CasesByErpNoQuery, GetMobileV2CasesByErpNoQueryVariables>(GetMobileV2CasesByErpNoDocument, options);
}
export function useGetMobileV2CasesByErpNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CasesByErpNoQuery, GetMobileV2CasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CasesByErpNoQuery, GetMobileV2CasesByErpNoQueryVariables>(GetMobileV2CasesByErpNoDocument, options);
}
export function useGetMobileV2CasesByErpNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CasesByErpNoQuery, GetMobileV2CasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CasesByErpNoQuery, GetMobileV2CasesByErpNoQueryVariables>(GetMobileV2CasesByErpNoDocument, options);
}
export type GetMobileV2CasesByErpNoQueryHookResult = ReturnType<typeof useGetMobileV2CasesByErpNoQuery>;
export type GetMobileV2CasesByErpNoLazyQueryHookResult = ReturnType<typeof useGetMobileV2CasesByErpNoLazyQuery>;
export type GetMobileV2CasesByErpNoSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CasesByErpNoSuspenseQuery>;
export type GetMobileV2CasesByErpNoQueryResult = Apollo.QueryResult<GetMobileV2CasesByErpNoQuery, GetMobileV2CasesByErpNoQueryVariables>;
export function refetchGetMobileV2CasesByErpNoQuery(variables: GetMobileV2CasesByErpNoQueryVariables) {
  return { query: GetMobileV2CasesByErpNoDocument, variables: variables }
}
export const GetMobileV2CasesForCatalogSuggestionsDocument = gql`
    query GetMobileV2CasesForCatalogSuggestions($erpReferenceNo: String!) {
  cases(erpReferenceNo: $erpReferenceNo) {
    id
    erpNo
    debitor {
      id
      company
      unknown
    }
    damage {
      contact {
        name
        phone
        email
        address {
          road
          houseNumber
          floor
          addressLineAlt
          postalCode
          city
          country
        }
      }
    }
  }
}
    `;

/**
 * __useGetMobileV2CasesForCatalogSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CasesForCatalogSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CasesForCatalogSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CasesForCatalogSuggestionsQuery({
 *   variables: {
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *   },
 * });
 */
export function useGetMobileV2CasesForCatalogSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetMobileV2CasesForCatalogSuggestionsQuery, GetMobileV2CasesForCatalogSuggestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CasesForCatalogSuggestionsQuery, GetMobileV2CasesForCatalogSuggestionsQueryVariables>(GetMobileV2CasesForCatalogSuggestionsDocument, options);
}
export function useGetMobileV2CasesForCatalogSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CasesForCatalogSuggestionsQuery, GetMobileV2CasesForCatalogSuggestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CasesForCatalogSuggestionsQuery, GetMobileV2CasesForCatalogSuggestionsQueryVariables>(GetMobileV2CasesForCatalogSuggestionsDocument, options);
}
export function useGetMobileV2CasesForCatalogSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CasesForCatalogSuggestionsQuery, GetMobileV2CasesForCatalogSuggestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CasesForCatalogSuggestionsQuery, GetMobileV2CasesForCatalogSuggestionsQueryVariables>(GetMobileV2CasesForCatalogSuggestionsDocument, options);
}
export type GetMobileV2CasesForCatalogSuggestionsQueryHookResult = ReturnType<typeof useGetMobileV2CasesForCatalogSuggestionsQuery>;
export type GetMobileV2CasesForCatalogSuggestionsLazyQueryHookResult = ReturnType<typeof useGetMobileV2CasesForCatalogSuggestionsLazyQuery>;
export type GetMobileV2CasesForCatalogSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CasesForCatalogSuggestionsSuspenseQuery>;
export type GetMobileV2CasesForCatalogSuggestionsQueryResult = Apollo.QueryResult<GetMobileV2CasesForCatalogSuggestionsQuery, GetMobileV2CasesForCatalogSuggestionsQueryVariables>;
export function refetchGetMobileV2CasesForCatalogSuggestionsQuery(variables: GetMobileV2CasesForCatalogSuggestionsQueryVariables) {
  return { query: GetMobileV2CasesForCatalogSuggestionsDocument, variables: variables }
}
export const SendCaseEmailDocument = gql`
    mutation SendCaseEmail($caseId: String!, $to: [String!]!, $cc: [String!]!, $bcc: [String!]!, $subject: String!, $body: String!, $includeCaseAgreements: Boolean!, $quote: Boolean!, $attachements: [String!]) {
  sendCaseEmail(
    caseId: $caseId
    receivers: $to
    cc: $cc
    bcc: $bcc
    subject: $subject
    body: $body
    includeCaseAgreements: $includeCaseAgreements
    quote: $quote
    attachements: $attachements
  ) {
    _
  }
}
    `;
export type SendCaseEmailMutationFn = Apollo.MutationFunction<SendCaseEmailMutation, SendCaseEmailMutationVariables>;

/**
 * __useSendCaseEmailMutation__
 *
 * To run a mutation, you first call `useSendCaseEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCaseEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCaseEmailMutation, { data, loading, error }] = useSendCaseEmailMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      to: // value for 'to'
 *      cc: // value for 'cc'
 *      bcc: // value for 'bcc'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      includeCaseAgreements: // value for 'includeCaseAgreements'
 *      quote: // value for 'quote'
 *      attachements: // value for 'attachements'
 *   },
 * });
 */
export function useSendCaseEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCaseEmailMutation, SendCaseEmailMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendCaseEmailMutation, SendCaseEmailMutationVariables>(SendCaseEmailDocument, options);
}
export type SendCaseEmailMutationHookResult = ReturnType<typeof useSendCaseEmailMutation>;
export type SendCaseEmailMutationResult = Apollo.MutationResult<SendCaseEmailMutation>;
export type SendCaseEmailMutationOptions = Apollo.BaseMutationOptions<SendCaseEmailMutation, SendCaseEmailMutationVariables>;
export const UpdateCaseMobileDocument = gql`
    mutation UpdateCaseMobile($id: String!, $status: CaseStatus, $damage: DamageInput, $policyHolder: ContactInput, $debitor: DebitorInput, $requisitioner: RequisitionerInput, $adviser: CompanyContactInput, $referrer: CompanyContactInput, $visitation: VisitationInput, $projectManager: String, $caseManager: String, $ssgLocation: String, $ssgDepartment: String, $billingReady: Boolean, $workComplete: Boolean, $importantInfo: String, $skafor: Boolean, $alternativeContact: PersonInput, $track: Int, $riskEvaluationAnswers: [RiskEvaluationAnswerInput!], $machineNotification: Boolean, $timeRegistration: Boolean, $fixedPriceOnCase: Decimal) {
  updateCase(
    id: $id
    status: $status
    damage: $damage
    policyHolder: $policyHolder
    debitor: $debitor
    requisitioner: $requisitioner
    adviser: $adviser
    referrer: $referrer
    projectManager: $projectManager
    caseManager: $caseManager
    ssgLocation: $ssgLocation
    ssgDepartment: $ssgDepartment
    billingReady: $billingReady
    workComplete: $workComplete
    visitation: $visitation
    importantInfo: $importantInfo
    skafor: $skafor
    alternativeContact: $alternativeContact
    track: $track
    riskEvaluationAnswers: $riskEvaluationAnswers
    machineNotification: $machineNotification
    timeRegistration: $timeRegistration
    fixedPriceOnCase: $fixedPriceOnCase
  ) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type UpdateCaseMobileMutationFn = Apollo.MutationFunction<UpdateCaseMobileMutation, UpdateCaseMobileMutationVariables>;

/**
 * __useUpdateCaseMobileMutation__
 *
 * To run a mutation, you first call `useUpdateCaseMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseMobileMutation, { data, loading, error }] = useUpdateCaseMobileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      damage: // value for 'damage'
 *      policyHolder: // value for 'policyHolder'
 *      debitor: // value for 'debitor'
 *      requisitioner: // value for 'requisitioner'
 *      adviser: // value for 'adviser'
 *      referrer: // value for 'referrer'
 *      visitation: // value for 'visitation'
 *      projectManager: // value for 'projectManager'
 *      caseManager: // value for 'caseManager'
 *      ssgLocation: // value for 'ssgLocation'
 *      ssgDepartment: // value for 'ssgDepartment'
 *      billingReady: // value for 'billingReady'
 *      workComplete: // value for 'workComplete'
 *      importantInfo: // value for 'importantInfo'
 *      skafor: // value for 'skafor'
 *      alternativeContact: // value for 'alternativeContact'
 *      track: // value for 'track'
 *      riskEvaluationAnswers: // value for 'riskEvaluationAnswers'
 *      machineNotification: // value for 'machineNotification'
 *      timeRegistration: // value for 'timeRegistration'
 *      fixedPriceOnCase: // value for 'fixedPriceOnCase'
 *   },
 * });
 */
export function useUpdateCaseMobileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseMobileMutation, UpdateCaseMobileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCaseMobileMutation, UpdateCaseMobileMutationVariables>(UpdateCaseMobileDocument, options);
}
export type UpdateCaseMobileMutationHookResult = ReturnType<typeof useUpdateCaseMobileMutation>;
export type UpdateCaseMobileMutationResult = Apollo.MutationResult<UpdateCaseMobileMutation>;
export type UpdateCaseMobileMutationOptions = Apollo.BaseMutationOptions<UpdateCaseMobileMutation, UpdateCaseMobileMutationVariables>;
export const UpdateCaseRiskEvaluationAnswersDocument = gql`
    mutation UpdateCaseRiskEvaluationAnswers($id: String!, $riskEvaluationAnswers: [RiskEvaluationAnswerInput!]!, $riskEvaluationComment: String) {
  updateCaseRiskEvaluationAnswers(
    id: $id
    riskEvaluationAnswers: $riskEvaluationAnswers
    riskEvaluationComment: $riskEvaluationComment
  ) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type UpdateCaseRiskEvaluationAnswersMutationFn = Apollo.MutationFunction<UpdateCaseRiskEvaluationAnswersMutation, UpdateCaseRiskEvaluationAnswersMutationVariables>;

/**
 * __useUpdateCaseRiskEvaluationAnswersMutation__
 *
 * To run a mutation, you first call `useUpdateCaseRiskEvaluationAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseRiskEvaluationAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseRiskEvaluationAnswersMutation, { data, loading, error }] = useUpdateCaseRiskEvaluationAnswersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      riskEvaluationAnswers: // value for 'riskEvaluationAnswers'
 *      riskEvaluationComment: // value for 'riskEvaluationComment'
 *   },
 * });
 */
export function useUpdateCaseRiskEvaluationAnswersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseRiskEvaluationAnswersMutation, UpdateCaseRiskEvaluationAnswersMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCaseRiskEvaluationAnswersMutation, UpdateCaseRiskEvaluationAnswersMutationVariables>(UpdateCaseRiskEvaluationAnswersDocument, options);
}
export type UpdateCaseRiskEvaluationAnswersMutationHookResult = ReturnType<typeof useUpdateCaseRiskEvaluationAnswersMutation>;
export type UpdateCaseRiskEvaluationAnswersMutationResult = Apollo.MutationResult<UpdateCaseRiskEvaluationAnswersMutation>;
export type UpdateCaseRiskEvaluationAnswersMutationOptions = Apollo.BaseMutationOptions<UpdateCaseRiskEvaluationAnswersMutation, UpdateCaseRiskEvaluationAnswersMutationVariables>;
export const UpdatePictureCommentDocument = gql`
    mutation UpdatePictureComment($caseNo: String!, $fileID: String!, $comment: String!) {
  updatePictureComment(caseNo: $caseNo, fileID: $fileID, comment: $comment) {
    _
  }
}
    `;
export type UpdatePictureCommentMutationFn = Apollo.MutationFunction<UpdatePictureCommentMutation, UpdatePictureCommentMutationVariables>;

/**
 * __useUpdatePictureCommentMutation__
 *
 * To run a mutation, you first call `useUpdatePictureCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePictureCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePictureCommentMutation, { data, loading, error }] = useUpdatePictureCommentMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      fileID: // value for 'fileID'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdatePictureCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePictureCommentMutation, UpdatePictureCommentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdatePictureCommentMutation, UpdatePictureCommentMutationVariables>(UpdatePictureCommentDocument, options);
}
export type UpdatePictureCommentMutationHookResult = ReturnType<typeof useUpdatePictureCommentMutation>;
export type UpdatePictureCommentMutationResult = Apollo.MutationResult<UpdatePictureCommentMutation>;
export type UpdatePictureCommentMutationOptions = Apollo.BaseMutationOptions<UpdatePictureCommentMutation, UpdatePictureCommentMutationVariables>;
export const GetCatalogsWithCraftsmenDocument = gql`
    query GetCatalogsWithCraftsmen($debitors: [String!], $smsService: Boolean, $verified: Boolean, $debitorVerified: Boolean, $address: AddressInput, $noDebitor: Boolean, $thisCustomerOnly: Boolean) {
  catalogs(
    debitors: $debitors
    smsService: $smsService
    verified: $verified
    debitorVerified: $debitorVerified
    address: $address
    noDebitor: $noDebitor
    thisCustomerOnly: $thisCustomerOnly
  ) {
    id
    craftsmen {
      ...BaseCatalogCraftsmanFragment
    }
  }
}
    ${BaseCatalogCraftsmanFragmentFragmentDoc}`;

/**
 * __useGetCatalogsWithCraftsmenQuery__
 *
 * To run a query within a React component, call `useGetCatalogsWithCraftsmenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogsWithCraftsmenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogsWithCraftsmenQuery({
 *   variables: {
 *      debitors: // value for 'debitors'
 *      smsService: // value for 'smsService'
 *      verified: // value for 'verified'
 *      debitorVerified: // value for 'debitorVerified'
 *      address: // value for 'address'
 *      noDebitor: // value for 'noDebitor'
 *      thisCustomerOnly: // value for 'thisCustomerOnly'
 *   },
 * });
 */
export function useGetCatalogsWithCraftsmenQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogsWithCraftsmenQuery, GetCatalogsWithCraftsmenQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogsWithCraftsmenQuery, GetCatalogsWithCraftsmenQueryVariables>(GetCatalogsWithCraftsmenDocument, options);
}
export function useGetCatalogsWithCraftsmenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogsWithCraftsmenQuery, GetCatalogsWithCraftsmenQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogsWithCraftsmenQuery, GetCatalogsWithCraftsmenQueryVariables>(GetCatalogsWithCraftsmenDocument, options);
}
export function useGetCatalogsWithCraftsmenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogsWithCraftsmenQuery, GetCatalogsWithCraftsmenQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogsWithCraftsmenQuery, GetCatalogsWithCraftsmenQueryVariables>(GetCatalogsWithCraftsmenDocument, options);
}
export type GetCatalogsWithCraftsmenQueryHookResult = ReturnType<typeof useGetCatalogsWithCraftsmenQuery>;
export type GetCatalogsWithCraftsmenLazyQueryHookResult = ReturnType<typeof useGetCatalogsWithCraftsmenLazyQuery>;
export type GetCatalogsWithCraftsmenSuspenseQueryHookResult = ReturnType<typeof useGetCatalogsWithCraftsmenSuspenseQuery>;
export type GetCatalogsWithCraftsmenQueryResult = Apollo.QueryResult<GetCatalogsWithCraftsmenQuery, GetCatalogsWithCraftsmenQueryVariables>;
export function refetchGetCatalogsWithCraftsmenQuery(variables?: GetCatalogsWithCraftsmenQueryVariables) {
  return { query: GetCatalogsWithCraftsmenDocument, variables: variables }
}
export const GetMobileV2CatalogsDocument = gql`
    query GetMobileV2Catalogs($debitors: [String!], $smsService: Boolean, $verified: Boolean, $debitorVerified: Boolean, $address: AddressInput, $noDebitor: Boolean, $thisCustomerOnly: Boolean) {
  catalogs(
    debitors: $debitors
    smsService: $smsService
    verified: $verified
    debitorVerified: $debitorVerified
    address: $address
    noDebitor: $noDebitor
    thisCustomerOnly: $thisCustomerOnly
  ) {
    ...BaseCatalogFragment
  }
}
    ${BaseCatalogFragmentFragmentDoc}`;

/**
 * __useGetMobileV2CatalogsQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CatalogsQuery({
 *   variables: {
 *      debitors: // value for 'debitors'
 *      smsService: // value for 'smsService'
 *      verified: // value for 'verified'
 *      debitorVerified: // value for 'debitorVerified'
 *      address: // value for 'address'
 *      noDebitor: // value for 'noDebitor'
 *      thisCustomerOnly: // value for 'thisCustomerOnly'
 *   },
 * });
 */
export function useGetMobileV2CatalogsQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2CatalogsQuery, GetMobileV2CatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CatalogsQuery, GetMobileV2CatalogsQueryVariables>(GetMobileV2CatalogsDocument, options);
}
export function useGetMobileV2CatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CatalogsQuery, GetMobileV2CatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CatalogsQuery, GetMobileV2CatalogsQueryVariables>(GetMobileV2CatalogsDocument, options);
}
export function useGetMobileV2CatalogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CatalogsQuery, GetMobileV2CatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CatalogsQuery, GetMobileV2CatalogsQueryVariables>(GetMobileV2CatalogsDocument, options);
}
export type GetMobileV2CatalogsQueryHookResult = ReturnType<typeof useGetMobileV2CatalogsQuery>;
export type GetMobileV2CatalogsLazyQueryHookResult = ReturnType<typeof useGetMobileV2CatalogsLazyQuery>;
export type GetMobileV2CatalogsSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CatalogsSuspenseQuery>;
export type GetMobileV2CatalogsQueryResult = Apollo.QueryResult<GetMobileV2CatalogsQuery, GetMobileV2CatalogsQueryVariables>;
export function refetchGetMobileV2CatalogsQuery(variables?: GetMobileV2CatalogsQueryVariables) {
  return { query: GetMobileV2CatalogsDocument, variables: variables }
}
export const GetAllDebitorsDocument = gql`
    query GetAllDebitors {
  allDebitors {
    debitorId
    type
    gln
    phone
    email
    address {
      addressLine
      addressLineAlt
      postalCode
      city
    }
    company
    createInECB
    callCenterActive
  }
}
    `;

/**
 * __useGetAllDebitorsQuery__
 *
 * To run a query within a React component, call `useGetAllDebitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDebitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDebitorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDebitorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDebitorsQuery, GetAllDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAllDebitorsQuery, GetAllDebitorsQueryVariables>(GetAllDebitorsDocument, options);
}
export function useGetAllDebitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDebitorsQuery, GetAllDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAllDebitorsQuery, GetAllDebitorsQueryVariables>(GetAllDebitorsDocument, options);
}
export function useGetAllDebitorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllDebitorsQuery, GetAllDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAllDebitorsQuery, GetAllDebitorsQueryVariables>(GetAllDebitorsDocument, options);
}
export type GetAllDebitorsQueryHookResult = ReturnType<typeof useGetAllDebitorsQuery>;
export type GetAllDebitorsLazyQueryHookResult = ReturnType<typeof useGetAllDebitorsLazyQuery>;
export type GetAllDebitorsSuspenseQueryHookResult = ReturnType<typeof useGetAllDebitorsSuspenseQuery>;
export type GetAllDebitorsQueryResult = Apollo.QueryResult<GetAllDebitorsQuery, GetAllDebitorsQueryVariables>;
export function refetchGetAllDebitorsQuery(variables?: GetAllDebitorsQueryVariables) {
  return { query: GetAllDebitorsDocument, variables: variables }
}
export const GetMobileV2DepartmentsDocument = gql`
    query GetMobileV2Departments {
  departments {
    ...BaseDepartmentFragment
  }
}
    ${BaseDepartmentFragmentFragmentDoc}`;

/**
 * __useGetMobileV2DepartmentsQuery__
 *
 * To run a query within a React component, call `useGetMobileV2DepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2DepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2DepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMobileV2DepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2DepartmentsQuery, GetMobileV2DepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2DepartmentsQuery, GetMobileV2DepartmentsQueryVariables>(GetMobileV2DepartmentsDocument, options);
}
export function useGetMobileV2DepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2DepartmentsQuery, GetMobileV2DepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2DepartmentsQuery, GetMobileV2DepartmentsQueryVariables>(GetMobileV2DepartmentsDocument, options);
}
export function useGetMobileV2DepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2DepartmentsQuery, GetMobileV2DepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2DepartmentsQuery, GetMobileV2DepartmentsQueryVariables>(GetMobileV2DepartmentsDocument, options);
}
export type GetMobileV2DepartmentsQueryHookResult = ReturnType<typeof useGetMobileV2DepartmentsQuery>;
export type GetMobileV2DepartmentsLazyQueryHookResult = ReturnType<typeof useGetMobileV2DepartmentsLazyQuery>;
export type GetMobileV2DepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2DepartmentsSuspenseQuery>;
export type GetMobileV2DepartmentsQueryResult = Apollo.QueryResult<GetMobileV2DepartmentsQuery, GetMobileV2DepartmentsQueryVariables>;
export function refetchGetMobileV2DepartmentsQuery(variables?: GetMobileV2DepartmentsQueryVariables) {
  return { query: GetMobileV2DepartmentsDocument, variables: variables }
}
export const GetDrivingSlipItemsDocument = gql`
    query GetDrivingSlipItems($drivingSlipCategory: String) {
  drivingSlipItems(drivingSlipCategory: $drivingSlipCategory) {
    no
    description
    baseUOM
    jobTask
  }
}
    `;

/**
 * __useGetDrivingSlipItemsQuery__
 *
 * To run a query within a React component, call `useGetDrivingSlipItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingSlipItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingSlipItemsQuery({
 *   variables: {
 *      drivingSlipCategory: // value for 'drivingSlipCategory'
 *   },
 * });
 */
export function useGetDrivingSlipItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetDrivingSlipItemsQuery, GetDrivingSlipItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrivingSlipItemsQuery, GetDrivingSlipItemsQueryVariables>(GetDrivingSlipItemsDocument, options);
}
export function useGetDrivingSlipItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrivingSlipItemsQuery, GetDrivingSlipItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrivingSlipItemsQuery, GetDrivingSlipItemsQueryVariables>(GetDrivingSlipItemsDocument, options);
}
export function useGetDrivingSlipItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrivingSlipItemsQuery, GetDrivingSlipItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDrivingSlipItemsQuery, GetDrivingSlipItemsQueryVariables>(GetDrivingSlipItemsDocument, options);
}
export type GetDrivingSlipItemsQueryHookResult = ReturnType<typeof useGetDrivingSlipItemsQuery>;
export type GetDrivingSlipItemsLazyQueryHookResult = ReturnType<typeof useGetDrivingSlipItemsLazyQuery>;
export type GetDrivingSlipItemsSuspenseQueryHookResult = ReturnType<typeof useGetDrivingSlipItemsSuspenseQuery>;
export type GetDrivingSlipItemsQueryResult = Apollo.QueryResult<GetDrivingSlipItemsQuery, GetDrivingSlipItemsQueryVariables>;
export function refetchGetDrivingSlipItemsQuery(variables?: GetDrivingSlipItemsQueryVariables) {
  return { query: GetDrivingSlipItemsDocument, variables: variables }
}
export const GetMobileV2DrivingSlipDocument = gql`
    query GetMobileV2DrivingSlip($id: String!) {
  drivingSlip(id: $id) {
    ...BaseDrivingSlipFragment
    case {
      ...V2DrivingSlipCaseFragment
    }
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}
${V2DrivingSlipCaseFragmentFragmentDoc}`;

/**
 * __useGetMobileV2DrivingSlipQuery__
 *
 * To run a query within a React component, call `useGetMobileV2DrivingSlipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2DrivingSlipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2DrivingSlipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMobileV2DrivingSlipQuery(baseOptions: Apollo.QueryHookOptions<GetMobileV2DrivingSlipQuery, GetMobileV2DrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2DrivingSlipQuery, GetMobileV2DrivingSlipQueryVariables>(GetMobileV2DrivingSlipDocument, options);
}
export function useGetMobileV2DrivingSlipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2DrivingSlipQuery, GetMobileV2DrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2DrivingSlipQuery, GetMobileV2DrivingSlipQueryVariables>(GetMobileV2DrivingSlipDocument, options);
}
export function useGetMobileV2DrivingSlipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2DrivingSlipQuery, GetMobileV2DrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2DrivingSlipQuery, GetMobileV2DrivingSlipQueryVariables>(GetMobileV2DrivingSlipDocument, options);
}
export type GetMobileV2DrivingSlipQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipQuery>;
export type GetMobileV2DrivingSlipLazyQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipLazyQuery>;
export type GetMobileV2DrivingSlipSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipSuspenseQuery>;
export type GetMobileV2DrivingSlipQueryResult = Apollo.QueryResult<GetMobileV2DrivingSlipQuery, GetMobileV2DrivingSlipQueryVariables>;
export function refetchGetMobileV2DrivingSlipQuery(variables: GetMobileV2DrivingSlipQueryVariables) {
  return { query: GetMobileV2DrivingSlipDocument, variables: variables }
}
export const GetMobileV2DrivingSlipsDocument = gql`
    query GetMobileV2DrivingSlips($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $caseERPReferenceNo: String, $postalCode: String, $debitors: [String!], $offset: Int, $limit: Int, $mobile: Boolean, $excludeTotalCount: Boolean, $seriesId: String) {
  drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    caseERPReferenceNo: $caseERPReferenceNo
    postalCode: $postalCode
    debitors: $debitors
    offset: $offset
    limit: $limit
    mobile: $mobile
    excludeTotalCount: $excludeTotalCount
    seriesId: $seriesId
  ) {
    ...BaseDrivingSlipFragment
    case {
      ...V2DrivingSlipCaseFragment
    }
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}
${V2DrivingSlipCaseFragmentFragmentDoc}`;

/**
 * __useGetMobileV2DrivingSlipsQuery__
 *
 * To run a query within a React component, call `useGetMobileV2DrivingSlipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2DrivingSlipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2DrivingSlipsQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *      postalCode: // value for 'postalCode'
 *      debitors: // value for 'debitors'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      mobile: // value for 'mobile'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useGetMobileV2DrivingSlipsQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2DrivingSlipsQuery, GetMobileV2DrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2DrivingSlipsQuery, GetMobileV2DrivingSlipsQueryVariables>(GetMobileV2DrivingSlipsDocument, options);
}
export function useGetMobileV2DrivingSlipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2DrivingSlipsQuery, GetMobileV2DrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2DrivingSlipsQuery, GetMobileV2DrivingSlipsQueryVariables>(GetMobileV2DrivingSlipsDocument, options);
}
export function useGetMobileV2DrivingSlipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2DrivingSlipsQuery, GetMobileV2DrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2DrivingSlipsQuery, GetMobileV2DrivingSlipsQueryVariables>(GetMobileV2DrivingSlipsDocument, options);
}
export type GetMobileV2DrivingSlipsQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipsQuery>;
export type GetMobileV2DrivingSlipsLazyQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipsLazyQuery>;
export type GetMobileV2DrivingSlipsSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipsSuspenseQuery>;
export type GetMobileV2DrivingSlipsQueryResult = Apollo.QueryResult<GetMobileV2DrivingSlipsQuery, GetMobileV2DrivingSlipsQueryVariables>;
export function refetchGetMobileV2DrivingSlipsQuery(variables?: GetMobileV2DrivingSlipsQueryVariables) {
  return { query: GetMobileV2DrivingSlipsDocument, variables: variables }
}
export const GetMobileV2DrivingSlipsNoCaseDocument = gql`
    query GetMobileV2DrivingSlipsNoCase($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $case: String) {
  drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    case: $case
  ) {
    id
    start
    category
    end
  }
}
    `;

/**
 * __useGetMobileV2DrivingSlipsNoCaseQuery__
 *
 * To run a query within a React component, call `useGetMobileV2DrivingSlipsNoCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2DrivingSlipsNoCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2DrivingSlipsNoCaseQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      case: // value for 'case'
 *   },
 * });
 */
export function useGetMobileV2DrivingSlipsNoCaseQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2DrivingSlipsNoCaseQuery, GetMobileV2DrivingSlipsNoCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2DrivingSlipsNoCaseQuery, GetMobileV2DrivingSlipsNoCaseQueryVariables>(GetMobileV2DrivingSlipsNoCaseDocument, options);
}
export function useGetMobileV2DrivingSlipsNoCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2DrivingSlipsNoCaseQuery, GetMobileV2DrivingSlipsNoCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2DrivingSlipsNoCaseQuery, GetMobileV2DrivingSlipsNoCaseQueryVariables>(GetMobileV2DrivingSlipsNoCaseDocument, options);
}
export function useGetMobileV2DrivingSlipsNoCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2DrivingSlipsNoCaseQuery, GetMobileV2DrivingSlipsNoCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2DrivingSlipsNoCaseQuery, GetMobileV2DrivingSlipsNoCaseQueryVariables>(GetMobileV2DrivingSlipsNoCaseDocument, options);
}
export type GetMobileV2DrivingSlipsNoCaseQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipsNoCaseQuery>;
export type GetMobileV2DrivingSlipsNoCaseLazyQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipsNoCaseLazyQuery>;
export type GetMobileV2DrivingSlipsNoCaseSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipsNoCaseSuspenseQuery>;
export type GetMobileV2DrivingSlipsNoCaseQueryResult = Apollo.QueryResult<GetMobileV2DrivingSlipsNoCaseQuery, GetMobileV2DrivingSlipsNoCaseQueryVariables>;
export function refetchGetMobileV2DrivingSlipsNoCaseQuery(variables?: GetMobileV2DrivingSlipsNoCaseQueryVariables) {
  return { query: GetMobileV2DrivingSlipsNoCaseDocument, variables: variables }
}
export const GetPersonalDrivingSlipsDocument = gql`
    query GetPersonalDrivingSlips {
  drivingSlips(personalOnly: true) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;

/**
 * __useGetPersonalDrivingSlipsQuery__
 *
 * To run a query within a React component, call `useGetPersonalDrivingSlipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalDrivingSlipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalDrivingSlipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalDrivingSlipsQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonalDrivingSlipsQuery, GetPersonalDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPersonalDrivingSlipsQuery, GetPersonalDrivingSlipsQueryVariables>(GetPersonalDrivingSlipsDocument, options);
}
export function useGetPersonalDrivingSlipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalDrivingSlipsQuery, GetPersonalDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPersonalDrivingSlipsQuery, GetPersonalDrivingSlipsQueryVariables>(GetPersonalDrivingSlipsDocument, options);
}
export function useGetPersonalDrivingSlipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPersonalDrivingSlipsQuery, GetPersonalDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetPersonalDrivingSlipsQuery, GetPersonalDrivingSlipsQueryVariables>(GetPersonalDrivingSlipsDocument, options);
}
export type GetPersonalDrivingSlipsQueryHookResult = ReturnType<typeof useGetPersonalDrivingSlipsQuery>;
export type GetPersonalDrivingSlipsLazyQueryHookResult = ReturnType<typeof useGetPersonalDrivingSlipsLazyQuery>;
export type GetPersonalDrivingSlipsSuspenseQueryHookResult = ReturnType<typeof useGetPersonalDrivingSlipsSuspenseQuery>;
export type GetPersonalDrivingSlipsQueryResult = Apollo.QueryResult<GetPersonalDrivingSlipsQuery, GetPersonalDrivingSlipsQueryVariables>;
export function refetchGetPersonalDrivingSlipsQuery(variables?: GetPersonalDrivingSlipsQueryVariables) {
  return { query: GetPersonalDrivingSlipsDocument, variables: variables }
}
export const GetSeriesDrivingSlipsDocument = gql`
    query GetSeriesDrivingSlips($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $caseERPReferenceNo: String, $postalCode: String, $debitors: [String!], $offset: Int, $limit: Int, $mobile: Boolean, $excludeTotalCount: Boolean, $seriesId: String) {
  drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    caseERPReferenceNo: $caseERPReferenceNo
    postalCode: $postalCode
    debitors: $debitors
    offset: $offset
    limit: $limit
    mobile: $mobile
    excludeTotalCount: $excludeTotalCount
    seriesId: $seriesId
  ) {
    id
    facadePictureTaken
    series
    createdAt
    driver {
      id
      name
    }
    questionnaire {
      ...BaseDrivingSlipQuestionnaireFragment
    }
  }
}
    ${BaseDrivingSlipQuestionnaireFragmentFragmentDoc}`;

/**
 * __useGetSeriesDrivingSlipsQuery__
 *
 * To run a query within a React component, call `useGetSeriesDrivingSlipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesDrivingSlipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesDrivingSlipsQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *      postalCode: // value for 'postalCode'
 *      debitors: // value for 'debitors'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      mobile: // value for 'mobile'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useGetSeriesDrivingSlipsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeriesDrivingSlipsQuery, GetSeriesDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSeriesDrivingSlipsQuery, GetSeriesDrivingSlipsQueryVariables>(GetSeriesDrivingSlipsDocument, options);
}
export function useGetSeriesDrivingSlipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeriesDrivingSlipsQuery, GetSeriesDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSeriesDrivingSlipsQuery, GetSeriesDrivingSlipsQueryVariables>(GetSeriesDrivingSlipsDocument, options);
}
export function useGetSeriesDrivingSlipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSeriesDrivingSlipsQuery, GetSeriesDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSeriesDrivingSlipsQuery, GetSeriesDrivingSlipsQueryVariables>(GetSeriesDrivingSlipsDocument, options);
}
export type GetSeriesDrivingSlipsQueryHookResult = ReturnType<typeof useGetSeriesDrivingSlipsQuery>;
export type GetSeriesDrivingSlipsLazyQueryHookResult = ReturnType<typeof useGetSeriesDrivingSlipsLazyQuery>;
export type GetSeriesDrivingSlipsSuspenseQueryHookResult = ReturnType<typeof useGetSeriesDrivingSlipsSuspenseQuery>;
export type GetSeriesDrivingSlipsQueryResult = Apollo.QueryResult<GetSeriesDrivingSlipsQuery, GetSeriesDrivingSlipsQueryVariables>;
export function refetchGetSeriesDrivingSlipsQuery(variables?: GetSeriesDrivingSlipsQueryVariables) {
  return { query: GetSeriesDrivingSlipsDocument, variables: variables }
}
export const GetUnitOfMeasuresDocument = gql`
    query GetUnitOfMeasures {
  unitOfMeasures {
    jobTask
    unitOfMeasure
  }
}
    `;

/**
 * __useGetUnitOfMeasuresQuery__
 *
 * To run a query within a React component, call `useGetUnitOfMeasuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitOfMeasuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitOfMeasuresQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitOfMeasuresQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitOfMeasuresQuery, GetUnitOfMeasuresQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUnitOfMeasuresQuery, GetUnitOfMeasuresQueryVariables>(GetUnitOfMeasuresDocument, options);
}
export function useGetUnitOfMeasuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitOfMeasuresQuery, GetUnitOfMeasuresQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUnitOfMeasuresQuery, GetUnitOfMeasuresQueryVariables>(GetUnitOfMeasuresDocument, options);
}
export function useGetUnitOfMeasuresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnitOfMeasuresQuery, GetUnitOfMeasuresQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUnitOfMeasuresQuery, GetUnitOfMeasuresQueryVariables>(GetUnitOfMeasuresDocument, options);
}
export type GetUnitOfMeasuresQueryHookResult = ReturnType<typeof useGetUnitOfMeasuresQuery>;
export type GetUnitOfMeasuresLazyQueryHookResult = ReturnType<typeof useGetUnitOfMeasuresLazyQuery>;
export type GetUnitOfMeasuresSuspenseQueryHookResult = ReturnType<typeof useGetUnitOfMeasuresSuspenseQuery>;
export type GetUnitOfMeasuresQueryResult = Apollo.QueryResult<GetUnitOfMeasuresQuery, GetUnitOfMeasuresQueryVariables>;
export function refetchGetUnitOfMeasuresQuery(variables?: GetUnitOfMeasuresQueryVariables) {
  return { query: GetUnitOfMeasuresDocument, variables: variables }
}
export const SetDrivingSlipDrivingStartedDocument = gql`
    mutation SetDrivingSlipDrivingStarted($id: String!, $drivingStarted: DateTime!, $locationCoordinates: GeoCoordinateInput, $carNumber: String, $passenger: Boolean) {
  setDrivingSlipDrivingStarted(
    id: $id
    drivingStarted: $drivingStarted
    locationCoordinates: $locationCoordinates
    carNumber: $carNumber
    passenger: $passenger
  ) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetDrivingSlipDrivingStartedMutationFn = Apollo.MutationFunction<SetDrivingSlipDrivingStartedMutation, SetDrivingSlipDrivingStartedMutationVariables>;

/**
 * __useSetDrivingSlipDrivingStartedMutation__
 *
 * To run a mutation, you first call `useSetDrivingSlipDrivingStartedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDrivingSlipDrivingStartedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDrivingSlipDrivingStartedMutation, { data, loading, error }] = useSetDrivingSlipDrivingStartedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      drivingStarted: // value for 'drivingStarted'
 *      locationCoordinates: // value for 'locationCoordinates'
 *      carNumber: // value for 'carNumber'
 *      passenger: // value for 'passenger'
 *   },
 * });
 */
export function useSetDrivingSlipDrivingStartedMutation(baseOptions?: Apollo.MutationHookOptions<SetDrivingSlipDrivingStartedMutation, SetDrivingSlipDrivingStartedMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetDrivingSlipDrivingStartedMutation, SetDrivingSlipDrivingStartedMutationVariables>(SetDrivingSlipDrivingStartedDocument, options);
}
export type SetDrivingSlipDrivingStartedMutationHookResult = ReturnType<typeof useSetDrivingSlipDrivingStartedMutation>;
export type SetDrivingSlipDrivingStartedMutationResult = Apollo.MutationResult<SetDrivingSlipDrivingStartedMutation>;
export type SetDrivingSlipDrivingStartedMutationOptions = Apollo.BaseMutationOptions<SetDrivingSlipDrivingStartedMutation, SetDrivingSlipDrivingStartedMutationVariables>;
export const SetDrivingSlipFacadePictureTakenDocument = gql`
    mutation SetDrivingSlipFacadePictureTaken($id: String!) {
  setDrivingSlipFacadePictureTaken(id: $id) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetDrivingSlipFacadePictureTakenMutationFn = Apollo.MutationFunction<SetDrivingSlipFacadePictureTakenMutation, SetDrivingSlipFacadePictureTakenMutationVariables>;

/**
 * __useSetDrivingSlipFacadePictureTakenMutation__
 *
 * To run a mutation, you first call `useSetDrivingSlipFacadePictureTakenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDrivingSlipFacadePictureTakenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDrivingSlipFacadePictureTakenMutation, { data, loading, error }] = useSetDrivingSlipFacadePictureTakenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDrivingSlipFacadePictureTakenMutation(baseOptions?: Apollo.MutationHookOptions<SetDrivingSlipFacadePictureTakenMutation, SetDrivingSlipFacadePictureTakenMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetDrivingSlipFacadePictureTakenMutation, SetDrivingSlipFacadePictureTakenMutationVariables>(SetDrivingSlipFacadePictureTakenDocument, options);
}
export type SetDrivingSlipFacadePictureTakenMutationHookResult = ReturnType<typeof useSetDrivingSlipFacadePictureTakenMutation>;
export type SetDrivingSlipFacadePictureTakenMutationResult = Apollo.MutationResult<SetDrivingSlipFacadePictureTakenMutation>;
export type SetDrivingSlipFacadePictureTakenMutationOptions = Apollo.BaseMutationOptions<SetDrivingSlipFacadePictureTakenMutation, SetDrivingSlipFacadePictureTakenMutationVariables>;
export const SetDrivingSlipNoMaterialUsedDocument = gql`
    mutation SetDrivingSlipNoMaterialUsed($id: String!, $noMaterialUsed: Boolean!) {
  setDrivingSlipNoMaterialUsed(id: $id, noMaterialUsed: $noMaterialUsed) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetDrivingSlipNoMaterialUsedMutationFn = Apollo.MutationFunction<SetDrivingSlipNoMaterialUsedMutation, SetDrivingSlipNoMaterialUsedMutationVariables>;

/**
 * __useSetDrivingSlipNoMaterialUsedMutation__
 *
 * To run a mutation, you first call `useSetDrivingSlipNoMaterialUsedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDrivingSlipNoMaterialUsedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDrivingSlipNoMaterialUsedMutation, { data, loading, error }] = useSetDrivingSlipNoMaterialUsedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      noMaterialUsed: // value for 'noMaterialUsed'
 *   },
 * });
 */
export function useSetDrivingSlipNoMaterialUsedMutation(baseOptions?: Apollo.MutationHookOptions<SetDrivingSlipNoMaterialUsedMutation, SetDrivingSlipNoMaterialUsedMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetDrivingSlipNoMaterialUsedMutation, SetDrivingSlipNoMaterialUsedMutationVariables>(SetDrivingSlipNoMaterialUsedDocument, options);
}
export type SetDrivingSlipNoMaterialUsedMutationHookResult = ReturnType<typeof useSetDrivingSlipNoMaterialUsedMutation>;
export type SetDrivingSlipNoMaterialUsedMutationResult = Apollo.MutationResult<SetDrivingSlipNoMaterialUsedMutation>;
export type SetDrivingSlipNoMaterialUsedMutationOptions = Apollo.BaseMutationOptions<SetDrivingSlipNoMaterialUsedMutation, SetDrivingSlipNoMaterialUsedMutationVariables>;
export const SetDrivingSlipNoWasteUsedDocument = gql`
    mutation SetDrivingSlipNoWasteUsed($id: String!, $noWasteUsed: Boolean!) {
  setDrivingSlipNoWasteUsed(id: $id, noWasteUsed: $noWasteUsed) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetDrivingSlipNoWasteUsedMutationFn = Apollo.MutationFunction<SetDrivingSlipNoWasteUsedMutation, SetDrivingSlipNoWasteUsedMutationVariables>;

/**
 * __useSetDrivingSlipNoWasteUsedMutation__
 *
 * To run a mutation, you first call `useSetDrivingSlipNoWasteUsedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDrivingSlipNoWasteUsedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDrivingSlipNoWasteUsedMutation, { data, loading, error }] = useSetDrivingSlipNoWasteUsedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      noWasteUsed: // value for 'noWasteUsed'
 *   },
 * });
 */
export function useSetDrivingSlipNoWasteUsedMutation(baseOptions?: Apollo.MutationHookOptions<SetDrivingSlipNoWasteUsedMutation, SetDrivingSlipNoWasteUsedMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetDrivingSlipNoWasteUsedMutation, SetDrivingSlipNoWasteUsedMutationVariables>(SetDrivingSlipNoWasteUsedDocument, options);
}
export type SetDrivingSlipNoWasteUsedMutationHookResult = ReturnType<typeof useSetDrivingSlipNoWasteUsedMutation>;
export type SetDrivingSlipNoWasteUsedMutationResult = Apollo.MutationResult<SetDrivingSlipNoWasteUsedMutation>;
export type SetDrivingSlipNoWasteUsedMutationOptions = Apollo.BaseMutationOptions<SetDrivingSlipNoWasteUsedMutation, SetDrivingSlipNoWasteUsedMutationVariables>;
export const SetDrivingSlipQuestionnaireCompletionStatusDocument = gql`
    mutation SetDrivingSlipQuestionnaireCompletionStatus($id: String!, $questionnaireCompletionStatus: QuestionnaireCompletionStatus!) {
  setDrivingSlipQuestionnaireCompletionStatus(
    id: $id
    questionnaireCompletionStatus: $questionnaireCompletionStatus
  ) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetDrivingSlipQuestionnaireCompletionStatusMutationFn = Apollo.MutationFunction<SetDrivingSlipQuestionnaireCompletionStatusMutation, SetDrivingSlipQuestionnaireCompletionStatusMutationVariables>;

/**
 * __useSetDrivingSlipQuestionnaireCompletionStatusMutation__
 *
 * To run a mutation, you first call `useSetDrivingSlipQuestionnaireCompletionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDrivingSlipQuestionnaireCompletionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDrivingSlipQuestionnaireCompletionStatusMutation, { data, loading, error }] = useSetDrivingSlipQuestionnaireCompletionStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionnaireCompletionStatus: // value for 'questionnaireCompletionStatus'
 *   },
 * });
 */
export function useSetDrivingSlipQuestionnaireCompletionStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetDrivingSlipQuestionnaireCompletionStatusMutation, SetDrivingSlipQuestionnaireCompletionStatusMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetDrivingSlipQuestionnaireCompletionStatusMutation, SetDrivingSlipQuestionnaireCompletionStatusMutationVariables>(SetDrivingSlipQuestionnaireCompletionStatusDocument, options);
}
export type SetDrivingSlipQuestionnaireCompletionStatusMutationHookResult = ReturnType<typeof useSetDrivingSlipQuestionnaireCompletionStatusMutation>;
export type SetDrivingSlipQuestionnaireCompletionStatusMutationResult = Apollo.MutationResult<SetDrivingSlipQuestionnaireCompletionStatusMutation>;
export type SetDrivingSlipQuestionnaireCompletionStatusMutationOptions = Apollo.BaseMutationOptions<SetDrivingSlipQuestionnaireCompletionStatusMutation, SetDrivingSlipQuestionnaireCompletionStatusMutationVariables>;
export const SetDrivingSlipRiskEvaluationStatusDocument = gql`
    mutation SetDrivingSlipRiskEvaluationStatus($id: String!, $riskEvaluationStatus: RiskEvaluationStatus!) {
  setDrivingSlipRiskEvaluationStatus(
    id: $id
    riskEvaluationStatus: $riskEvaluationStatus
  ) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetDrivingSlipRiskEvaluationStatusMutationFn = Apollo.MutationFunction<SetDrivingSlipRiskEvaluationStatusMutation, SetDrivingSlipRiskEvaluationStatusMutationVariables>;

/**
 * __useSetDrivingSlipRiskEvaluationStatusMutation__
 *
 * To run a mutation, you first call `useSetDrivingSlipRiskEvaluationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDrivingSlipRiskEvaluationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDrivingSlipRiskEvaluationStatusMutation, { data, loading, error }] = useSetDrivingSlipRiskEvaluationStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      riskEvaluationStatus: // value for 'riskEvaluationStatus'
 *   },
 * });
 */
export function useSetDrivingSlipRiskEvaluationStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetDrivingSlipRiskEvaluationStatusMutation, SetDrivingSlipRiskEvaluationStatusMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetDrivingSlipRiskEvaluationStatusMutation, SetDrivingSlipRiskEvaluationStatusMutationVariables>(SetDrivingSlipRiskEvaluationStatusDocument, options);
}
export type SetDrivingSlipRiskEvaluationStatusMutationHookResult = ReturnType<typeof useSetDrivingSlipRiskEvaluationStatusMutation>;
export type SetDrivingSlipRiskEvaluationStatusMutationResult = Apollo.MutationResult<SetDrivingSlipRiskEvaluationStatusMutation>;
export type SetDrivingSlipRiskEvaluationStatusMutationOptions = Apollo.BaseMutationOptions<SetDrivingSlipRiskEvaluationStatusMutation, SetDrivingSlipRiskEvaluationStatusMutationVariables>;
export const SetMobileV2DrivingSlipQuestionnaireDocument = gql`
    mutation SetMobileV2DrivingSlipQuestionnaire($id: String!, $questionnaire: DrivingSlipQuestionnaireInputType!) {
  setDrivingSlipQuestionnaire(id: $id, questionnaire: $questionnaire) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetMobileV2DrivingSlipQuestionnaireMutationFn = Apollo.MutationFunction<SetMobileV2DrivingSlipQuestionnaireMutation, SetMobileV2DrivingSlipQuestionnaireMutationVariables>;

/**
 * __useSetMobileV2DrivingSlipQuestionnaireMutation__
 *
 * To run a mutation, you first call `useSetMobileV2DrivingSlipQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMobileV2DrivingSlipQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMobileV2DrivingSlipQuestionnaireMutation, { data, loading, error }] = useSetMobileV2DrivingSlipQuestionnaireMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionnaire: // value for 'questionnaire'
 *   },
 * });
 */
export function useSetMobileV2DrivingSlipQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<SetMobileV2DrivingSlipQuestionnaireMutation, SetMobileV2DrivingSlipQuestionnaireMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetMobileV2DrivingSlipQuestionnaireMutation, SetMobileV2DrivingSlipQuestionnaireMutationVariables>(SetMobileV2DrivingSlipQuestionnaireDocument, options);
}
export type SetMobileV2DrivingSlipQuestionnaireMutationHookResult = ReturnType<typeof useSetMobileV2DrivingSlipQuestionnaireMutation>;
export type SetMobileV2DrivingSlipQuestionnaireMutationResult = Apollo.MutationResult<SetMobileV2DrivingSlipQuestionnaireMutation>;
export type SetMobileV2DrivingSlipQuestionnaireMutationOptions = Apollo.BaseMutationOptions<SetMobileV2DrivingSlipQuestionnaireMutation, SetMobileV2DrivingSlipQuestionnaireMutationVariables>;
export const SetMobileV2DrivingSlipStatusDocument = gql`
    mutation SetMobileV2DrivingSlipStatus($id: String!, $status: DrivingSlipStatus!, $applyDrivingCost: Boolean, $locationCoordinates: GeoCoordinateInput) {
  setDrivingSlipStatus(
    id: $id
    status: $status
    applyDrivingCost: $applyDrivingCost
    locationCoordinates: $locationCoordinates
  ) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetMobileV2DrivingSlipStatusMutationFn = Apollo.MutationFunction<SetMobileV2DrivingSlipStatusMutation, SetMobileV2DrivingSlipStatusMutationVariables>;

/**
 * __useSetMobileV2DrivingSlipStatusMutation__
 *
 * To run a mutation, you first call `useSetMobileV2DrivingSlipStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMobileV2DrivingSlipStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMobileV2DrivingSlipStatusMutation, { data, loading, error }] = useSetMobileV2DrivingSlipStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      applyDrivingCost: // value for 'applyDrivingCost'
 *      locationCoordinates: // value for 'locationCoordinates'
 *   },
 * });
 */
export function useSetMobileV2DrivingSlipStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetMobileV2DrivingSlipStatusMutation, SetMobileV2DrivingSlipStatusMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetMobileV2DrivingSlipStatusMutation, SetMobileV2DrivingSlipStatusMutationVariables>(SetMobileV2DrivingSlipStatusDocument, options);
}
export type SetMobileV2DrivingSlipStatusMutationHookResult = ReturnType<typeof useSetMobileV2DrivingSlipStatusMutation>;
export type SetMobileV2DrivingSlipStatusMutationResult = Apollo.MutationResult<SetMobileV2DrivingSlipStatusMutation>;
export type SetMobileV2DrivingSlipStatusMutationOptions = Apollo.BaseMutationOptions<SetMobileV2DrivingSlipStatusMutation, SetMobileV2DrivingSlipStatusMutationVariables>;
export const DeleteDrivingSlipFileDocument = gql`
    mutation DeleteDrivingSlipFile($caseNo: String!, $drivingSlipId: String!, $fileName: String!) {
  deleteDrivingSlipFile(
    caseNo: $caseNo
    drivingSlipId: $drivingSlipId
    fileName: $fileName
  ) {
    _
  }
}
    `;
export type DeleteDrivingSlipFileMutationFn = Apollo.MutationFunction<DeleteDrivingSlipFileMutation, DeleteDrivingSlipFileMutationVariables>;

/**
 * __useDeleteDrivingSlipFileMutation__
 *
 * To run a mutation, you first call `useDeleteDrivingSlipFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDrivingSlipFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDrivingSlipFileMutation, { data, loading, error }] = useDeleteDrivingSlipFileMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useDeleteDrivingSlipFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDrivingSlipFileMutation, DeleteDrivingSlipFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDrivingSlipFileMutation, DeleteDrivingSlipFileMutationVariables>(DeleteDrivingSlipFileDocument, options);
}
export type DeleteDrivingSlipFileMutationHookResult = ReturnType<typeof useDeleteDrivingSlipFileMutation>;
export type DeleteDrivingSlipFileMutationResult = Apollo.MutationResult<DeleteDrivingSlipFileMutation>;
export type DeleteDrivingSlipFileMutationOptions = Apollo.BaseMutationOptions<DeleteDrivingSlipFileMutation, DeleteDrivingSlipFileMutationVariables>;
export const GetCaseEsdhFilesDocument = gql`
    query GetCaseESDHFiles($id: String!) {
  case(id: $id) {
    id
    erpNo
    documents {
      ...ESDHFileFragment
    }
  }
}
    ${EsdhFileFragmentFragmentDoc}`;

/**
 * __useGetCaseEsdhFilesQuery__
 *
 * To run a query within a React component, call `useGetCaseEsdhFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseEsdhFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseEsdhFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseEsdhFilesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseEsdhFilesQuery, GetCaseEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseEsdhFilesQuery, GetCaseEsdhFilesQueryVariables>(GetCaseEsdhFilesDocument, options);
}
export function useGetCaseEsdhFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseEsdhFilesQuery, GetCaseEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseEsdhFilesQuery, GetCaseEsdhFilesQueryVariables>(GetCaseEsdhFilesDocument, options);
}
export function useGetCaseEsdhFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseEsdhFilesQuery, GetCaseEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseEsdhFilesQuery, GetCaseEsdhFilesQueryVariables>(GetCaseEsdhFilesDocument, options);
}
export type GetCaseEsdhFilesQueryHookResult = ReturnType<typeof useGetCaseEsdhFilesQuery>;
export type GetCaseEsdhFilesLazyQueryHookResult = ReturnType<typeof useGetCaseEsdhFilesLazyQuery>;
export type GetCaseEsdhFilesSuspenseQueryHookResult = ReturnType<typeof useGetCaseEsdhFilesSuspenseQuery>;
export type GetCaseEsdhFilesQueryResult = Apollo.QueryResult<GetCaseEsdhFilesQuery, GetCaseEsdhFilesQueryVariables>;
export function refetchGetCaseEsdhFilesQuery(variables: GetCaseEsdhFilesQueryVariables) {
  return { query: GetCaseEsdhFilesDocument, variables: variables }
}
export const GetCaseFilesDocument = gql`
    query GetCaseFiles($folder: String, $caseErpNo: String) {
  caseFiles(folder: $folder, caseErpNo: $caseErpNo) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;

/**
 * __useGetCaseFilesQuery__
 *
 * To run a query within a React component, call `useGetCaseFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseFilesQuery({
 *   variables: {
 *      folder: // value for 'folder'
 *      caseErpNo: // value for 'caseErpNo'
 *   },
 * });
 */
export function useGetCaseFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetCaseFilesQuery, GetCaseFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseFilesQuery, GetCaseFilesQueryVariables>(GetCaseFilesDocument, options);
}
export function useGetCaseFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseFilesQuery, GetCaseFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseFilesQuery, GetCaseFilesQueryVariables>(GetCaseFilesDocument, options);
}
export function useGetCaseFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseFilesQuery, GetCaseFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseFilesQuery, GetCaseFilesQueryVariables>(GetCaseFilesDocument, options);
}
export type GetCaseFilesQueryHookResult = ReturnType<typeof useGetCaseFilesQuery>;
export type GetCaseFilesLazyQueryHookResult = ReturnType<typeof useGetCaseFilesLazyQuery>;
export type GetCaseFilesSuspenseQueryHookResult = ReturnType<typeof useGetCaseFilesSuspenseQuery>;
export type GetCaseFilesQueryResult = Apollo.QueryResult<GetCaseFilesQuery, GetCaseFilesQueryVariables>;
export function refetchGetCaseFilesQuery(variables?: GetCaseFilesQueryVariables) {
  return { query: GetCaseFilesDocument, variables: variables }
}
export const GetCatalogEsdhFilesDocument = gql`
    query GetCatalogESDHFiles($id: String!) {
  catalog(id: $id) {
    id
    propertyNumber
    documents {
      ...ESDHFileFragment
    }
  }
}
    ${EsdhFileFragmentFragmentDoc}`;

/**
 * __useGetCatalogEsdhFilesQuery__
 *
 * To run a query within a React component, call `useGetCatalogEsdhFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogEsdhFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogEsdhFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatalogEsdhFilesQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogEsdhFilesQuery, GetCatalogEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogEsdhFilesQuery, GetCatalogEsdhFilesQueryVariables>(GetCatalogEsdhFilesDocument, options);
}
export function useGetCatalogEsdhFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogEsdhFilesQuery, GetCatalogEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogEsdhFilesQuery, GetCatalogEsdhFilesQueryVariables>(GetCatalogEsdhFilesDocument, options);
}
export function useGetCatalogEsdhFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogEsdhFilesQuery, GetCatalogEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogEsdhFilesQuery, GetCatalogEsdhFilesQueryVariables>(GetCatalogEsdhFilesDocument, options);
}
export type GetCatalogEsdhFilesQueryHookResult = ReturnType<typeof useGetCatalogEsdhFilesQuery>;
export type GetCatalogEsdhFilesLazyQueryHookResult = ReturnType<typeof useGetCatalogEsdhFilesLazyQuery>;
export type GetCatalogEsdhFilesSuspenseQueryHookResult = ReturnType<typeof useGetCatalogEsdhFilesSuspenseQuery>;
export type GetCatalogEsdhFilesQueryResult = Apollo.QueryResult<GetCatalogEsdhFilesQuery, GetCatalogEsdhFilesQueryVariables>;
export function refetchGetCatalogEsdhFilesQuery(variables: GetCatalogEsdhFilesQueryVariables) {
  return { query: GetCatalogEsdhFilesDocument, variables: variables }
}
export const GetDrivingSlipFilesDocument = gql`
    query GetDrivingSlipFiles($caseNo: String!, $drivingSlipId: String!) {
  drivingSlipFiles(caseNo: $caseNo, drivingSlipId: $drivingSlipId) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;

/**
 * __useGetDrivingSlipFilesQuery__
 *
 * To run a query within a React component, call `useGetDrivingSlipFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingSlipFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingSlipFilesQuery({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *   },
 * });
 */
export function useGetDrivingSlipFilesQuery(baseOptions: Apollo.QueryHookOptions<GetDrivingSlipFilesQuery, GetDrivingSlipFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrivingSlipFilesQuery, GetDrivingSlipFilesQueryVariables>(GetDrivingSlipFilesDocument, options);
}
export function useGetDrivingSlipFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrivingSlipFilesQuery, GetDrivingSlipFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrivingSlipFilesQuery, GetDrivingSlipFilesQueryVariables>(GetDrivingSlipFilesDocument, options);
}
export function useGetDrivingSlipFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrivingSlipFilesQuery, GetDrivingSlipFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDrivingSlipFilesQuery, GetDrivingSlipFilesQueryVariables>(GetDrivingSlipFilesDocument, options);
}
export type GetDrivingSlipFilesQueryHookResult = ReturnType<typeof useGetDrivingSlipFilesQuery>;
export type GetDrivingSlipFilesLazyQueryHookResult = ReturnType<typeof useGetDrivingSlipFilesLazyQuery>;
export type GetDrivingSlipFilesSuspenseQueryHookResult = ReturnType<typeof useGetDrivingSlipFilesSuspenseQuery>;
export type GetDrivingSlipFilesQueryResult = Apollo.QueryResult<GetDrivingSlipFilesQuery, GetDrivingSlipFilesQueryVariables>;
export function refetchGetDrivingSlipFilesQuery(variables: GetDrivingSlipFilesQueryVariables) {
  return { query: GetDrivingSlipFilesDocument, variables: variables }
}
export const GetMobileV2CaseFileDocument = gql`
    query GetMobileV2CaseFile($fileName: String!, $folder: String) {
  caseFile(fileName: $fileName, folder: $folder) {
    fileData
    filename
    fileDataBase64
  }
}
    `;

/**
 * __useGetMobileV2CaseFileQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CaseFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CaseFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CaseFileQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useGetMobileV2CaseFileQuery(baseOptions: Apollo.QueryHookOptions<GetMobileV2CaseFileQuery, GetMobileV2CaseFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CaseFileQuery, GetMobileV2CaseFileQueryVariables>(GetMobileV2CaseFileDocument, options);
}
export function useGetMobileV2CaseFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CaseFileQuery, GetMobileV2CaseFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CaseFileQuery, GetMobileV2CaseFileQueryVariables>(GetMobileV2CaseFileDocument, options);
}
export function useGetMobileV2CaseFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CaseFileQuery, GetMobileV2CaseFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CaseFileQuery, GetMobileV2CaseFileQueryVariables>(GetMobileV2CaseFileDocument, options);
}
export type GetMobileV2CaseFileQueryHookResult = ReturnType<typeof useGetMobileV2CaseFileQuery>;
export type GetMobileV2CaseFileLazyQueryHookResult = ReturnType<typeof useGetMobileV2CaseFileLazyQuery>;
export type GetMobileV2CaseFileSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CaseFileSuspenseQuery>;
export type GetMobileV2CaseFileQueryResult = Apollo.QueryResult<GetMobileV2CaseFileQuery, GetMobileV2CaseFileQueryVariables>;
export function refetchGetMobileV2CaseFileQuery(variables: GetMobileV2CaseFileQueryVariables) {
  return { query: GetMobileV2CaseFileDocument, variables: variables }
}
export const GetMobileV2DrivingSlipFileDocument = gql`
    query GetMobileV2DrivingSlipFile($caseNo: String!, $drivingSlipId: String!, $fileName: String!) {
  drivingSlipFile(
    caseNo: $caseNo
    drivingSlipId: $drivingSlipId
    fileName: $fileName
  ) {
    fileData
    filename
    fileDataBase64
  }
}
    `;

/**
 * __useGetMobileV2DrivingSlipFileQuery__
 *
 * To run a query within a React component, call `useGetMobileV2DrivingSlipFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2DrivingSlipFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2DrivingSlipFileQuery({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetMobileV2DrivingSlipFileQuery(baseOptions: Apollo.QueryHookOptions<GetMobileV2DrivingSlipFileQuery, GetMobileV2DrivingSlipFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2DrivingSlipFileQuery, GetMobileV2DrivingSlipFileQueryVariables>(GetMobileV2DrivingSlipFileDocument, options);
}
export function useGetMobileV2DrivingSlipFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2DrivingSlipFileQuery, GetMobileV2DrivingSlipFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2DrivingSlipFileQuery, GetMobileV2DrivingSlipFileQueryVariables>(GetMobileV2DrivingSlipFileDocument, options);
}
export function useGetMobileV2DrivingSlipFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2DrivingSlipFileQuery, GetMobileV2DrivingSlipFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2DrivingSlipFileQuery, GetMobileV2DrivingSlipFileQueryVariables>(GetMobileV2DrivingSlipFileDocument, options);
}
export type GetMobileV2DrivingSlipFileQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipFileQuery>;
export type GetMobileV2DrivingSlipFileLazyQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipFileLazyQuery>;
export type GetMobileV2DrivingSlipFileSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2DrivingSlipFileSuspenseQuery>;
export type GetMobileV2DrivingSlipFileQueryResult = Apollo.QueryResult<GetMobileV2DrivingSlipFileQuery, GetMobileV2DrivingSlipFileQueryVariables>;
export function refetchGetMobileV2DrivingSlipFileQuery(variables: GetMobileV2DrivingSlipFileQueryVariables) {
  return { query: GetMobileV2DrivingSlipFileDocument, variables: variables }
}
export const ModifyDrivingSlipFileMetadataDocument = gql`
    mutation ModifyDrivingSlipFileMetadata($caseNo: String!, $drivingSlipId: String!, $fileName: String!, $metadata: [FileMetadataInput!]!) {
  modifyDrivingSlipFileMetadata(
    caseNo: $caseNo
    drivingSlipId: $drivingSlipId
    fileName: $fileName
    metadata: $metadata
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type ModifyDrivingSlipFileMetadataMutationFn = Apollo.MutationFunction<ModifyDrivingSlipFileMetadataMutation, ModifyDrivingSlipFileMetadataMutationVariables>;

/**
 * __useModifyDrivingSlipFileMetadataMutation__
 *
 * To run a mutation, you first call `useModifyDrivingSlipFileMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyDrivingSlipFileMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyDrivingSlipFileMetadataMutation, { data, loading, error }] = useModifyDrivingSlipFileMetadataMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *      fileName: // value for 'fileName'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useModifyDrivingSlipFileMetadataMutation(baseOptions?: Apollo.MutationHookOptions<ModifyDrivingSlipFileMetadataMutation, ModifyDrivingSlipFileMetadataMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ModifyDrivingSlipFileMetadataMutation, ModifyDrivingSlipFileMetadataMutationVariables>(ModifyDrivingSlipFileMetadataDocument, options);
}
export type ModifyDrivingSlipFileMetadataMutationHookResult = ReturnType<typeof useModifyDrivingSlipFileMetadataMutation>;
export type ModifyDrivingSlipFileMetadataMutationResult = Apollo.MutationResult<ModifyDrivingSlipFileMetadataMutation>;
export type ModifyDrivingSlipFileMetadataMutationOptions = Apollo.BaseMutationOptions<ModifyDrivingSlipFileMetadataMutation, ModifyDrivingSlipFileMetadataMutationVariables>;
export const QueueUploadDrivingSlipFileDocument = gql`
    mutation QueueUploadDrivingSlipFile($caseNo: String!, $drivingSlipId: String!, $fileName: String!, $file: [Byte!]!, $metadata: [FileMetadataInput!]) {
  queueUploadDrivingSlipFile(
    caseNo: $caseNo
    drivingSlipId: $drivingSlipId
    fileName: $fileName
    file: $file
    metadata: $metadata
  ) {
    _
  }
}
    `;
export type QueueUploadDrivingSlipFileMutationFn = Apollo.MutationFunction<QueueUploadDrivingSlipFileMutation, QueueUploadDrivingSlipFileMutationVariables>;

/**
 * __useQueueUploadDrivingSlipFileMutation__
 *
 * To run a mutation, you first call `useQueueUploadDrivingSlipFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueUploadDrivingSlipFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueUploadDrivingSlipFileMutation, { data, loading, error }] = useQueueUploadDrivingSlipFileMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *      fileName: // value for 'fileName'
 *      file: // value for 'file'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useQueueUploadDrivingSlipFileMutation(baseOptions?: Apollo.MutationHookOptions<QueueUploadDrivingSlipFileMutation, QueueUploadDrivingSlipFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<QueueUploadDrivingSlipFileMutation, QueueUploadDrivingSlipFileMutationVariables>(QueueUploadDrivingSlipFileDocument, options);
}
export type QueueUploadDrivingSlipFileMutationHookResult = ReturnType<typeof useQueueUploadDrivingSlipFileMutation>;
export type QueueUploadDrivingSlipFileMutationResult = Apollo.MutationResult<QueueUploadDrivingSlipFileMutation>;
export type QueueUploadDrivingSlipFileMutationOptions = Apollo.BaseMutationOptions<QueueUploadDrivingSlipFileMutation, QueueUploadDrivingSlipFileMutationVariables>;
export const QueueUploadDrivingSlipFilesDocument = gql`
    mutation QueueUploadDrivingSlipFiles($caseNo: String!, $drivingSlipId: String!, $files: [FileInput!]!) {
  queueUploadDrivingSlipFiles(
    caseNo: $caseNo
    drivingSlipId: $drivingSlipId
    files: $files
  ) {
    _
  }
}
    `;
export type QueueUploadDrivingSlipFilesMutationFn = Apollo.MutationFunction<QueueUploadDrivingSlipFilesMutation, QueueUploadDrivingSlipFilesMutationVariables>;

/**
 * __useQueueUploadDrivingSlipFilesMutation__
 *
 * To run a mutation, you first call `useQueueUploadDrivingSlipFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueUploadDrivingSlipFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueUploadDrivingSlipFilesMutation, { data, loading, error }] = useQueueUploadDrivingSlipFilesMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useQueueUploadDrivingSlipFilesMutation(baseOptions?: Apollo.MutationHookOptions<QueueUploadDrivingSlipFilesMutation, QueueUploadDrivingSlipFilesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<QueueUploadDrivingSlipFilesMutation, QueueUploadDrivingSlipFilesMutationVariables>(QueueUploadDrivingSlipFilesDocument, options);
}
export type QueueUploadDrivingSlipFilesMutationHookResult = ReturnType<typeof useQueueUploadDrivingSlipFilesMutation>;
export type QueueUploadDrivingSlipFilesMutationResult = Apollo.MutationResult<QueueUploadDrivingSlipFilesMutation>;
export type QueueUploadDrivingSlipFilesMutationOptions = Apollo.BaseMutationOptions<QueueUploadDrivingSlipFilesMutation, QueueUploadDrivingSlipFilesMutationVariables>;
export const UploadDrivingSlipFileDocument = gql`
    mutation UploadDrivingSlipFile($caseNo: String!, $drivingSlipId: String!, $fileName: String!, $file: [Byte!]!, $metadata: [FileMetadataInput!]) {
  uploadDrivingSlipFile(
    caseNo: $caseNo
    drivingSlipId: $drivingSlipId
    fileName: $fileName
    file: $file
    metadata: $metadata
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type UploadDrivingSlipFileMutationFn = Apollo.MutationFunction<UploadDrivingSlipFileMutation, UploadDrivingSlipFileMutationVariables>;

/**
 * __useUploadDrivingSlipFileMutation__
 *
 * To run a mutation, you first call `useUploadDrivingSlipFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDrivingSlipFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDrivingSlipFileMutation, { data, loading, error }] = useUploadDrivingSlipFileMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *      fileName: // value for 'fileName'
 *      file: // value for 'file'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUploadDrivingSlipFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadDrivingSlipFileMutation, UploadDrivingSlipFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadDrivingSlipFileMutation, UploadDrivingSlipFileMutationVariables>(UploadDrivingSlipFileDocument, options);
}
export type UploadDrivingSlipFileMutationHookResult = ReturnType<typeof useUploadDrivingSlipFileMutation>;
export type UploadDrivingSlipFileMutationResult = Apollo.MutationResult<UploadDrivingSlipFileMutation>;
export type UploadDrivingSlipFileMutationOptions = Apollo.BaseMutationOptions<UploadDrivingSlipFileMutation, UploadDrivingSlipFileMutationVariables>;
export const UploadDrivingSlipFilesDocument = gql`
    mutation UploadDrivingSlipFiles($caseNo: String!, $drivingSlipId: String!, $files: [FileInput!]!) {
  uploadDrivingSlipFiles(
    caseNo: $caseNo
    drivingSlipId: $drivingSlipId
    files: $files
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type UploadDrivingSlipFilesMutationFn = Apollo.MutationFunction<UploadDrivingSlipFilesMutation, UploadDrivingSlipFilesMutationVariables>;

/**
 * __useUploadDrivingSlipFilesMutation__
 *
 * To run a mutation, you first call `useUploadDrivingSlipFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDrivingSlipFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDrivingSlipFilesMutation, { data, loading, error }] = useUploadDrivingSlipFilesMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadDrivingSlipFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadDrivingSlipFilesMutation, UploadDrivingSlipFilesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadDrivingSlipFilesMutation, UploadDrivingSlipFilesMutationVariables>(UploadDrivingSlipFilesDocument, options);
}
export type UploadDrivingSlipFilesMutationHookResult = ReturnType<typeof useUploadDrivingSlipFilesMutation>;
export type UploadDrivingSlipFilesMutationResult = Apollo.MutationResult<UploadDrivingSlipFilesMutation>;
export type UploadDrivingSlipFilesMutationOptions = Apollo.BaseMutationOptions<UploadDrivingSlipFilesMutation, UploadDrivingSlipFilesMutationVariables>;
export const GetMachineDocument = gql`
    query GetMachine($machineNo: String!) {
  machine(machineERPReferenceNo: $machineNo) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;

/**
 * __useGetMachineQuery__
 *
 * To run a query within a React component, call `useGetMachineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineQuery({
 *   variables: {
 *      machineNo: // value for 'machineNo'
 *   },
 * });
 */
export function useGetMachineQuery(baseOptions: Apollo.QueryHookOptions<GetMachineQuery, GetMachineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMachineQuery, GetMachineQueryVariables>(GetMachineDocument, options);
}
export function useGetMachineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineQuery, GetMachineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMachineQuery, GetMachineQueryVariables>(GetMachineDocument, options);
}
export function useGetMachineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMachineQuery, GetMachineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMachineQuery, GetMachineQueryVariables>(GetMachineDocument, options);
}
export type GetMachineQueryHookResult = ReturnType<typeof useGetMachineQuery>;
export type GetMachineLazyQueryHookResult = ReturnType<typeof useGetMachineLazyQuery>;
export type GetMachineSuspenseQueryHookResult = ReturnType<typeof useGetMachineSuspenseQuery>;
export type GetMachineQueryResult = Apollo.QueryResult<GetMachineQuery, GetMachineQueryVariables>;
export function refetchGetMachineQuery(variables: GetMachineQueryVariables) {
  return { query: GetMachineDocument, variables: variables }
}
export const GetMachineGuidesDocument = gql`
    query GetMachineGuides($filter: FileFilterInput) {
  machineGuideFiles(filter: $filter) {
    name
  }
}
    `;

/**
 * __useGetMachineGuidesQuery__
 *
 * To run a query within a React component, call `useGetMachineGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineGuidesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMachineGuidesQuery(baseOptions?: Apollo.QueryHookOptions<GetMachineGuidesQuery, GetMachineGuidesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMachineGuidesQuery, GetMachineGuidesQueryVariables>(GetMachineGuidesDocument, options);
}
export function useGetMachineGuidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineGuidesQuery, GetMachineGuidesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMachineGuidesQuery, GetMachineGuidesQueryVariables>(GetMachineGuidesDocument, options);
}
export function useGetMachineGuidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMachineGuidesQuery, GetMachineGuidesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMachineGuidesQuery, GetMachineGuidesQueryVariables>(GetMachineGuidesDocument, options);
}
export type GetMachineGuidesQueryHookResult = ReturnType<typeof useGetMachineGuidesQuery>;
export type GetMachineGuidesLazyQueryHookResult = ReturnType<typeof useGetMachineGuidesLazyQuery>;
export type GetMachineGuidesSuspenseQueryHookResult = ReturnType<typeof useGetMachineGuidesSuspenseQuery>;
export type GetMachineGuidesQueryResult = Apollo.QueryResult<GetMachineGuidesQuery, GetMachineGuidesQueryVariables>;
export function refetchGetMachineGuidesQuery(variables?: GetMachineGuidesQueryVariables) {
  return { query: GetMachineGuidesDocument, variables: variables }
}
export const GetMobileV2MachineGuideFilesDocument = gql`
    query GetMobileV2MachineGuideFiles($filter: FileFilterInput) {
  machineGuideFiles(filter: $filter) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;

/**
 * __useGetMobileV2MachineGuideFilesQuery__
 *
 * To run a query within a React component, call `useGetMobileV2MachineGuideFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2MachineGuideFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2MachineGuideFilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMobileV2MachineGuideFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2MachineGuideFilesQuery, GetMobileV2MachineGuideFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2MachineGuideFilesQuery, GetMobileV2MachineGuideFilesQueryVariables>(GetMobileV2MachineGuideFilesDocument, options);
}
export function useGetMobileV2MachineGuideFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2MachineGuideFilesQuery, GetMobileV2MachineGuideFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2MachineGuideFilesQuery, GetMobileV2MachineGuideFilesQueryVariables>(GetMobileV2MachineGuideFilesDocument, options);
}
export function useGetMobileV2MachineGuideFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2MachineGuideFilesQuery, GetMobileV2MachineGuideFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2MachineGuideFilesQuery, GetMobileV2MachineGuideFilesQueryVariables>(GetMobileV2MachineGuideFilesDocument, options);
}
export type GetMobileV2MachineGuideFilesQueryHookResult = ReturnType<typeof useGetMobileV2MachineGuideFilesQuery>;
export type GetMobileV2MachineGuideFilesLazyQueryHookResult = ReturnType<typeof useGetMobileV2MachineGuideFilesLazyQuery>;
export type GetMobileV2MachineGuideFilesSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2MachineGuideFilesSuspenseQuery>;
export type GetMobileV2MachineGuideFilesQueryResult = Apollo.QueryResult<GetMobileV2MachineGuideFilesQuery, GetMobileV2MachineGuideFilesQueryVariables>;
export function refetchGetMobileV2MachineGuideFilesQuery(variables?: GetMobileV2MachineGuideFilesQueryVariables) {
  return { query: GetMobileV2MachineGuideFilesDocument, variables: variables }
}
export const GetMobileV2MachineLocationsDocument = gql`
    query GetMobileV2MachineLocations {
  machineLocations {
    name
    locationCode
  }
}
    `;

/**
 * __useGetMobileV2MachineLocationsQuery__
 *
 * To run a query within a React component, call `useGetMobileV2MachineLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2MachineLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2MachineLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMobileV2MachineLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2MachineLocationsQuery, GetMobileV2MachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2MachineLocationsQuery, GetMobileV2MachineLocationsQueryVariables>(GetMobileV2MachineLocationsDocument, options);
}
export function useGetMobileV2MachineLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2MachineLocationsQuery, GetMobileV2MachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2MachineLocationsQuery, GetMobileV2MachineLocationsQueryVariables>(GetMobileV2MachineLocationsDocument, options);
}
export function useGetMobileV2MachineLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2MachineLocationsQuery, GetMobileV2MachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2MachineLocationsQuery, GetMobileV2MachineLocationsQueryVariables>(GetMobileV2MachineLocationsDocument, options);
}
export type GetMobileV2MachineLocationsQueryHookResult = ReturnType<typeof useGetMobileV2MachineLocationsQuery>;
export type GetMobileV2MachineLocationsLazyQueryHookResult = ReturnType<typeof useGetMobileV2MachineLocationsLazyQuery>;
export type GetMobileV2MachineLocationsSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2MachineLocationsSuspenseQuery>;
export type GetMobileV2MachineLocationsQueryResult = Apollo.QueryResult<GetMobileV2MachineLocationsQuery, GetMobileV2MachineLocationsQueryVariables>;
export function refetchGetMobileV2MachineLocationsQuery(variables?: GetMobileV2MachineLocationsQueryVariables) {
  return { query: GetMobileV2MachineLocationsDocument, variables: variables }
}
export const GetMobileV2MachinesOnCaseDocument = gql`
    query GetMobileV2MachinesOnCase($caseNo: String!) {
  machinesOnCase(erpNo: $caseNo) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;

/**
 * __useGetMobileV2MachinesOnCaseQuery__
 *
 * To run a query within a React component, call `useGetMobileV2MachinesOnCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2MachinesOnCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2MachinesOnCaseQuery({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *   },
 * });
 */
export function useGetMobileV2MachinesOnCaseQuery(baseOptions: Apollo.QueryHookOptions<GetMobileV2MachinesOnCaseQuery, GetMobileV2MachinesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2MachinesOnCaseQuery, GetMobileV2MachinesOnCaseQueryVariables>(GetMobileV2MachinesOnCaseDocument, options);
}
export function useGetMobileV2MachinesOnCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2MachinesOnCaseQuery, GetMobileV2MachinesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2MachinesOnCaseQuery, GetMobileV2MachinesOnCaseQueryVariables>(GetMobileV2MachinesOnCaseDocument, options);
}
export function useGetMobileV2MachinesOnCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2MachinesOnCaseQuery, GetMobileV2MachinesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2MachinesOnCaseQuery, GetMobileV2MachinesOnCaseQueryVariables>(GetMobileV2MachinesOnCaseDocument, options);
}
export type GetMobileV2MachinesOnCaseQueryHookResult = ReturnType<typeof useGetMobileV2MachinesOnCaseQuery>;
export type GetMobileV2MachinesOnCaseLazyQueryHookResult = ReturnType<typeof useGetMobileV2MachinesOnCaseLazyQuery>;
export type GetMobileV2MachinesOnCaseSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2MachinesOnCaseSuspenseQuery>;
export type GetMobileV2MachinesOnCaseQueryResult = Apollo.QueryResult<GetMobileV2MachinesOnCaseQuery, GetMobileV2MachinesOnCaseQueryVariables>;
export function refetchGetMobileV2MachinesOnCaseQuery(variables: GetMobileV2MachinesOnCaseQueryVariables) {
  return { query: GetMobileV2MachinesOnCaseDocument, variables: variables }
}
export const MoveMobileV2MachineDocument = gql`
    mutation MoveMobileV2Machine($machineInput: MachineInput!, $caseNo: String!) {
  moveMachine(machineInput: $machineInput, caseERPreferenceNo: $caseNo) {
    erpReferenceNo
  }
}
    `;
export type MoveMobileV2MachineMutationFn = Apollo.MutationFunction<MoveMobileV2MachineMutation, MoveMobileV2MachineMutationVariables>;

/**
 * __useMoveMobileV2MachineMutation__
 *
 * To run a mutation, you first call `useMoveMobileV2MachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveMobileV2MachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveMobileV2MachineMutation, { data, loading, error }] = useMoveMobileV2MachineMutation({
 *   variables: {
 *      machineInput: // value for 'machineInput'
 *      caseNo: // value for 'caseNo'
 *   },
 * });
 */
export function useMoveMobileV2MachineMutation(baseOptions?: Apollo.MutationHookOptions<MoveMobileV2MachineMutation, MoveMobileV2MachineMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MoveMobileV2MachineMutation, MoveMobileV2MachineMutationVariables>(MoveMobileV2MachineDocument, options);
}
export type MoveMobileV2MachineMutationHookResult = ReturnType<typeof useMoveMobileV2MachineMutation>;
export type MoveMobileV2MachineMutationResult = Apollo.MutationResult<MoveMobileV2MachineMutation>;
export type MoveMobileV2MachineMutationOptions = Apollo.BaseMutationOptions<MoveMobileV2MachineMutation, MoveMobileV2MachineMutationVariables>;
export const ReserveMachineDocument = gql`
    mutation ReserveMachine($machineInput: MachineInput!) {
  machineReserve(machineInput: $machineInput) {
    erpReferenceNo
  }
}
    `;
export type ReserveMachineMutationFn = Apollo.MutationFunction<ReserveMachineMutation, ReserveMachineMutationVariables>;

/**
 * __useReserveMachineMutation__
 *
 * To run a mutation, you first call `useReserveMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveMachineMutation, { data, loading, error }] = useReserveMachineMutation({
 *   variables: {
 *      machineInput: // value for 'machineInput'
 *   },
 * });
 */
export function useReserveMachineMutation(baseOptions?: Apollo.MutationHookOptions<ReserveMachineMutation, ReserveMachineMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReserveMachineMutation, ReserveMachineMutationVariables>(ReserveMachineDocument, options);
}
export type ReserveMachineMutationHookResult = ReturnType<typeof useReserveMachineMutation>;
export type ReserveMachineMutationResult = Apollo.MutationResult<ReserveMachineMutation>;
export type ReserveMachineMutationOptions = Apollo.BaseMutationOptions<ReserveMachineMutation, ReserveMachineMutationVariables>;
export const ChangeOfferStatusDocument = gql`
    mutation ChangeOfferStatus($caseERPReferenceNo: String!, $offerERPReferenceNo: String!, $reasonCode: String!, $action: SalesHeaderEnum!) {
  changeOfferStatus(
    caseERPReferenceNo: $caseERPReferenceNo
    offerERPReferenceNo: $offerERPReferenceNo
    reasonCode: $reasonCode
    action: $action
  )
}
    `;
export type ChangeOfferStatusMutationFn = Apollo.MutationFunction<ChangeOfferStatusMutation, ChangeOfferStatusMutationVariables>;

/**
 * __useChangeOfferStatusMutation__
 *
 * To run a mutation, you first call `useChangeOfferStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOfferStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOfferStatusMutation, { data, loading, error }] = useChangeOfferStatusMutation({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *      offerERPReferenceNo: // value for 'offerERPReferenceNo'
 *      reasonCode: // value for 'reasonCode'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useChangeOfferStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOfferStatusMutation, ChangeOfferStatusMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ChangeOfferStatusMutation, ChangeOfferStatusMutationVariables>(ChangeOfferStatusDocument, options);
}
export type ChangeOfferStatusMutationHookResult = ReturnType<typeof useChangeOfferStatusMutation>;
export type ChangeOfferStatusMutationResult = Apollo.MutationResult<ChangeOfferStatusMutation>;
export type ChangeOfferStatusMutationOptions = Apollo.BaseMutationOptions<ChangeOfferStatusMutation, ChangeOfferStatusMutationVariables>;
export const AssortmentsDocument = gql`
    query Assortments($assortmentCode: String!, $type: String!) {
  assortments(assortmentCode: $assortmentCode, type: $type) {
    no
    type
    description
    uom
  }
}
    `;

/**
 * __useAssortmentsQuery__
 *
 * To run a query within a React component, call `useAssortmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssortmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssortmentsQuery({
 *   variables: {
 *      assortmentCode: // value for 'assortmentCode'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAssortmentsQuery(baseOptions: Apollo.QueryHookOptions<AssortmentsQuery, AssortmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssortmentsQuery, AssortmentsQueryVariables>(AssortmentsDocument, options);
}
export function useAssortmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssortmentsQuery, AssortmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AssortmentsQuery, AssortmentsQueryVariables>(AssortmentsDocument, options);
}
export function useAssortmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssortmentsQuery, AssortmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AssortmentsQuery, AssortmentsQueryVariables>(AssortmentsDocument, options);
}
export type AssortmentsQueryHookResult = ReturnType<typeof useAssortmentsQuery>;
export type AssortmentsLazyQueryHookResult = ReturnType<typeof useAssortmentsLazyQuery>;
export type AssortmentsSuspenseQueryHookResult = ReturnType<typeof useAssortmentsSuspenseQuery>;
export type AssortmentsQueryResult = Apollo.QueryResult<AssortmentsQuery, AssortmentsQueryVariables>;
export function refetchAssortmentsQuery(variables: AssortmentsQueryVariables) {
  return { query: AssortmentsDocument, variables: variables }
}
export const CloseOppertunityCodesDocument = gql`
    query CloseOppertunityCodes {
  closeOppertunityCodes {
    type
    description
    code
  }
}
    `;

/**
 * __useCloseOppertunityCodesQuery__
 *
 * To run a query within a React component, call `useCloseOppertunityCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloseOppertunityCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloseOppertunityCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCloseOppertunityCodesQuery(baseOptions?: Apollo.QueryHookOptions<CloseOppertunityCodesQuery, CloseOppertunityCodesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CloseOppertunityCodesQuery, CloseOppertunityCodesQueryVariables>(CloseOppertunityCodesDocument, options);
}
export function useCloseOppertunityCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloseOppertunityCodesQuery, CloseOppertunityCodesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CloseOppertunityCodesQuery, CloseOppertunityCodesQueryVariables>(CloseOppertunityCodesDocument, options);
}
export function useCloseOppertunityCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CloseOppertunityCodesQuery, CloseOppertunityCodesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CloseOppertunityCodesQuery, CloseOppertunityCodesQueryVariables>(CloseOppertunityCodesDocument, options);
}
export type CloseOppertunityCodesQueryHookResult = ReturnType<typeof useCloseOppertunityCodesQuery>;
export type CloseOppertunityCodesLazyQueryHookResult = ReturnType<typeof useCloseOppertunityCodesLazyQuery>;
export type CloseOppertunityCodesSuspenseQueryHookResult = ReturnType<typeof useCloseOppertunityCodesSuspenseQuery>;
export type CloseOppertunityCodesQueryResult = Apollo.QueryResult<CloseOppertunityCodesQuery, CloseOppertunityCodesQueryVariables>;
export function refetchCloseOppertunityCodesQuery(variables?: CloseOppertunityCodesQueryVariables) {
  return { query: CloseOppertunityCodesDocument, variables: variables }
}
export const JobTasksDocument = gql`
    query JobTasks($erpReferenceNo: String!) {
  jobTasks(erpReferenceNo: $erpReferenceNo) {
    ...BaseOfferJobTaskFragment
  }
}
    ${BaseOfferJobTaskFragmentFragmentDoc}`;

/**
 * __useJobTasksQuery__
 *
 * To run a query within a React component, call `useJobTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTasksQuery({
 *   variables: {
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *   },
 * });
 */
export function useJobTasksQuery(baseOptions: Apollo.QueryHookOptions<JobTasksQuery, JobTasksQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JobTasksQuery, JobTasksQueryVariables>(JobTasksDocument, options);
}
export function useJobTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTasksQuery, JobTasksQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JobTasksQuery, JobTasksQueryVariables>(JobTasksDocument, options);
}
export function useJobTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobTasksQuery, JobTasksQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JobTasksQuery, JobTasksQueryVariables>(JobTasksDocument, options);
}
export type JobTasksQueryHookResult = ReturnType<typeof useJobTasksQuery>;
export type JobTasksLazyQueryHookResult = ReturnType<typeof useJobTasksLazyQuery>;
export type JobTasksSuspenseQueryHookResult = ReturnType<typeof useJobTasksSuspenseQuery>;
export type JobTasksQueryResult = Apollo.QueryResult<JobTasksQuery, JobTasksQueryVariables>;
export function refetchJobTasksQuery(variables: JobTasksQueryVariables) {
  return { query: JobTasksDocument, variables: variables }
}
export const OffersDocument = gql`
    query Offers($caseERPReferenceNo: String!) {
  offers(caseERPReferenceNo: $caseERPReferenceNo) {
    ...BaseOfferFragment
  }
}
    ${BaseOfferFragmentFragmentDoc}`;

/**
 * __useOffersQuery__
 *
 * To run a query within a React component, call `useOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useOffersQuery(baseOptions: Apollo.QueryHookOptions<OffersQuery, OffersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export function useOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersQuery, OffersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export function useOffersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OffersQuery, OffersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export type OffersQueryHookResult = ReturnType<typeof useOffersQuery>;
export type OffersLazyQueryHookResult = ReturnType<typeof useOffersLazyQuery>;
export type OffersSuspenseQueryHookResult = ReturnType<typeof useOffersSuspenseQuery>;
export type OffersQueryResult = Apollo.QueryResult<OffersQuery, OffersQueryVariables>;
export function refetchOffersQuery(variables: OffersQueryVariables) {
  return { query: OffersDocument, variables: variables }
}
export const GetSamplePriceForLineDocument = gql`
    query GetSamplePriceForLine($offerLine: OfferLineInput!) {
  samplePriceForLine(offerLine: $offerLine) {
    totalCost
    lineAmount
  }
}
    `;

/**
 * __useGetSamplePriceForLineQuery__
 *
 * To run a query within a React component, call `useGetSamplePriceForLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSamplePriceForLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSamplePriceForLineQuery({
 *   variables: {
 *      offerLine: // value for 'offerLine'
 *   },
 * });
 */
export function useGetSamplePriceForLineQuery(baseOptions: Apollo.QueryHookOptions<GetSamplePriceForLineQuery, GetSamplePriceForLineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSamplePriceForLineQuery, GetSamplePriceForLineQueryVariables>(GetSamplePriceForLineDocument, options);
}
export function useGetSamplePriceForLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSamplePriceForLineQuery, GetSamplePriceForLineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSamplePriceForLineQuery, GetSamplePriceForLineQueryVariables>(GetSamplePriceForLineDocument, options);
}
export function useGetSamplePriceForLineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSamplePriceForLineQuery, GetSamplePriceForLineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSamplePriceForLineQuery, GetSamplePriceForLineQueryVariables>(GetSamplePriceForLineDocument, options);
}
export type GetSamplePriceForLineQueryHookResult = ReturnType<typeof useGetSamplePriceForLineQuery>;
export type GetSamplePriceForLineLazyQueryHookResult = ReturnType<typeof useGetSamplePriceForLineLazyQuery>;
export type GetSamplePriceForLineSuspenseQueryHookResult = ReturnType<typeof useGetSamplePriceForLineSuspenseQuery>;
export type GetSamplePriceForLineQueryResult = Apollo.QueryResult<GetSamplePriceForLineQuery, GetSamplePriceForLineQueryVariables>;
export function refetchGetSamplePriceForLineQuery(variables: GetSamplePriceForLineQueryVariables) {
  return { query: GetSamplePriceForLineDocument, variables: variables }
}
export const HandleOfferDocument = gql`
    mutation HandleOffer($offer: OfferInput!, $caseId: String!, $offerERPReferenceNo: String) {
  handleOffer(
    offer: $offer
    caseId: $caseId
    offerERPReferenceNo: $offerERPReferenceNo
  ) {
    ...BaseOfferFragment
  }
}
    ${BaseOfferFragmentFragmentDoc}`;
export type HandleOfferMutationFn = Apollo.MutationFunction<HandleOfferMutation, HandleOfferMutationVariables>;

/**
 * __useHandleOfferMutation__
 *
 * To run a mutation, you first call `useHandleOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleOfferMutation, { data, loading, error }] = useHandleOfferMutation({
 *   variables: {
 *      offer: // value for 'offer'
 *      caseId: // value for 'caseId'
 *      offerERPReferenceNo: // value for 'offerERPReferenceNo'
 *   },
 * });
 */
export function useHandleOfferMutation(baseOptions?: Apollo.MutationHookOptions<HandleOfferMutation, HandleOfferMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<HandleOfferMutation, HandleOfferMutationVariables>(HandleOfferDocument, options);
}
export type HandleOfferMutationHookResult = ReturnType<typeof useHandleOfferMutation>;
export type HandleOfferMutationResult = Apollo.MutationResult<HandleOfferMutation>;
export type HandleOfferMutationOptions = Apollo.BaseMutationOptions<HandleOfferMutation, HandleOfferMutationVariables>;
export const GetQuestionnaireTemplateByDrivingSlipDocument = gql`
    query GetQuestionnaireTemplateByDrivingSlip($drivingSlipCategoryCode: String, $damageCauseId: String!) {
  questionnaireTemplateByDrivingSlip(
    drivingSlipCategoryCode: $drivingSlipCategoryCode
    damageCauseId: $damageCauseId
  ) {
    ...BaseQuestionnaireTemplateFragment
  }
}
    ${BaseQuestionnaireTemplateFragmentFragmentDoc}`;

/**
 * __useGetQuestionnaireTemplateByDrivingSlipQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireTemplateByDrivingSlipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireTemplateByDrivingSlipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireTemplateByDrivingSlipQuery({
 *   variables: {
 *      drivingSlipCategoryCode: // value for 'drivingSlipCategoryCode'
 *      damageCauseId: // value for 'damageCauseId'
 *   },
 * });
 */
export function useGetQuestionnaireTemplateByDrivingSlipQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionnaireTemplateByDrivingSlipQuery, GetQuestionnaireTemplateByDrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetQuestionnaireTemplateByDrivingSlipQuery, GetQuestionnaireTemplateByDrivingSlipQueryVariables>(GetQuestionnaireTemplateByDrivingSlipDocument, options);
}
export function useGetQuestionnaireTemplateByDrivingSlipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnaireTemplateByDrivingSlipQuery, GetQuestionnaireTemplateByDrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetQuestionnaireTemplateByDrivingSlipQuery, GetQuestionnaireTemplateByDrivingSlipQueryVariables>(GetQuestionnaireTemplateByDrivingSlipDocument, options);
}
export function useGetQuestionnaireTemplateByDrivingSlipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionnaireTemplateByDrivingSlipQuery, GetQuestionnaireTemplateByDrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetQuestionnaireTemplateByDrivingSlipQuery, GetQuestionnaireTemplateByDrivingSlipQueryVariables>(GetQuestionnaireTemplateByDrivingSlipDocument, options);
}
export type GetQuestionnaireTemplateByDrivingSlipQueryHookResult = ReturnType<typeof useGetQuestionnaireTemplateByDrivingSlipQuery>;
export type GetQuestionnaireTemplateByDrivingSlipLazyQueryHookResult = ReturnType<typeof useGetQuestionnaireTemplateByDrivingSlipLazyQuery>;
export type GetQuestionnaireTemplateByDrivingSlipSuspenseQueryHookResult = ReturnType<typeof useGetQuestionnaireTemplateByDrivingSlipSuspenseQuery>;
export type GetQuestionnaireTemplateByDrivingSlipQueryResult = Apollo.QueryResult<GetQuestionnaireTemplateByDrivingSlipQuery, GetQuestionnaireTemplateByDrivingSlipQueryVariables>;
export function refetchGetQuestionnaireTemplateByDrivingSlipQuery(variables: GetQuestionnaireTemplateByDrivingSlipQueryVariables) {
  return { query: GetQuestionnaireTemplateByDrivingSlipDocument, variables: variables }
}
export const GetQuestionnaireTemplatesByDrivingSlipsDocument = gql`
    query GetQuestionnaireTemplatesByDrivingSlips($drivingSlips: [QuestionnaireTemplateByDrivingSlipInput!]!) {
  questionnaireTemplatesByDrivingSlips(drivingSlips: $drivingSlips) {
    ...BaseQuestionnaireTemplateFragment
  }
}
    ${BaseQuestionnaireTemplateFragmentFragmentDoc}`;

/**
 * __useGetQuestionnaireTemplatesByDrivingSlipsQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireTemplatesByDrivingSlipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireTemplatesByDrivingSlipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireTemplatesByDrivingSlipsQuery({
 *   variables: {
 *      drivingSlips: // value for 'drivingSlips'
 *   },
 * });
 */
export function useGetQuestionnaireTemplatesByDrivingSlipsQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionnaireTemplatesByDrivingSlipsQuery, GetQuestionnaireTemplatesByDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetQuestionnaireTemplatesByDrivingSlipsQuery, GetQuestionnaireTemplatesByDrivingSlipsQueryVariables>(GetQuestionnaireTemplatesByDrivingSlipsDocument, options);
}
export function useGetQuestionnaireTemplatesByDrivingSlipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnaireTemplatesByDrivingSlipsQuery, GetQuestionnaireTemplatesByDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetQuestionnaireTemplatesByDrivingSlipsQuery, GetQuestionnaireTemplatesByDrivingSlipsQueryVariables>(GetQuestionnaireTemplatesByDrivingSlipsDocument, options);
}
export function useGetQuestionnaireTemplatesByDrivingSlipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionnaireTemplatesByDrivingSlipsQuery, GetQuestionnaireTemplatesByDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetQuestionnaireTemplatesByDrivingSlipsQuery, GetQuestionnaireTemplatesByDrivingSlipsQueryVariables>(GetQuestionnaireTemplatesByDrivingSlipsDocument, options);
}
export type GetQuestionnaireTemplatesByDrivingSlipsQueryHookResult = ReturnType<typeof useGetQuestionnaireTemplatesByDrivingSlipsQuery>;
export type GetQuestionnaireTemplatesByDrivingSlipsLazyQueryHookResult = ReturnType<typeof useGetQuestionnaireTemplatesByDrivingSlipsLazyQuery>;
export type GetQuestionnaireTemplatesByDrivingSlipsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionnaireTemplatesByDrivingSlipsSuspenseQuery>;
export type GetQuestionnaireTemplatesByDrivingSlipsQueryResult = Apollo.QueryResult<GetQuestionnaireTemplatesByDrivingSlipsQuery, GetQuestionnaireTemplatesByDrivingSlipsQueryVariables>;
export function refetchGetQuestionnaireTemplatesByDrivingSlipsQuery(variables: GetQuestionnaireTemplatesByDrivingSlipsQueryVariables) {
  return { query: GetQuestionnaireTemplatesByDrivingSlipsDocument, variables: variables }
}
export const CreateFalckDehumidifierReportDocument = gql`
    mutation CreateFalckDehumidifierReport($caseId: String!, $formData: FalckDehumidifierReportFormDataInput!) {
  createFalckDehumidifierReport(caseId: $caseId, formData: $formData) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateFalckDehumidifierReportMutationFn = Apollo.MutationFunction<CreateFalckDehumidifierReportMutation, CreateFalckDehumidifierReportMutationVariables>;

/**
 * __useCreateFalckDehumidifierReportMutation__
 *
 * To run a mutation, you first call `useCreateFalckDehumidifierReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFalckDehumidifierReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFalckDehumidifierReportMutation, { data, loading, error }] = useCreateFalckDehumidifierReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *   },
 * });
 */
export function useCreateFalckDehumidifierReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateFalckDehumidifierReportMutation, CreateFalckDehumidifierReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFalckDehumidifierReportMutation, CreateFalckDehumidifierReportMutationVariables>(CreateFalckDehumidifierReportDocument, options);
}
export type CreateFalckDehumidifierReportMutationHookResult = ReturnType<typeof useCreateFalckDehumidifierReportMutation>;
export type CreateFalckDehumidifierReportMutationResult = Apollo.MutationResult<CreateFalckDehumidifierReportMutation>;
export type CreateFalckDehumidifierReportMutationOptions = Apollo.BaseMutationOptions<CreateFalckDehumidifierReportMutation, CreateFalckDehumidifierReportMutationVariables>;
export const CreateMobileIndoorClimateReportDocument = gql`
    mutation CreateMobileIndoorClimateReport($caseId: String!, $formData: IndoorClimateReportFormDataInput!, $reportFormat: ReportFormatType!, $onlySave: Boolean!) {
  createIndoorClimateReport(
    caseId: $caseId
    formData: $formData
    reportFormat: $reportFormat
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateMobileIndoorClimateReportMutationFn = Apollo.MutationFunction<CreateMobileIndoorClimateReportMutation, CreateMobileIndoorClimateReportMutationVariables>;

/**
 * __useCreateMobileIndoorClimateReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileIndoorClimateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileIndoorClimateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileIndoorClimateReportMutation, { data, loading, error }] = useCreateMobileIndoorClimateReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      reportFormat: // value for 'reportFormat'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateMobileIndoorClimateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileIndoorClimateReportMutation, CreateMobileIndoorClimateReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileIndoorClimateReportMutation, CreateMobileIndoorClimateReportMutationVariables>(CreateMobileIndoorClimateReportDocument, options);
}
export type CreateMobileIndoorClimateReportMutationHookResult = ReturnType<typeof useCreateMobileIndoorClimateReportMutation>;
export type CreateMobileIndoorClimateReportMutationResult = Apollo.MutationResult<CreateMobileIndoorClimateReportMutation>;
export type CreateMobileIndoorClimateReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileIndoorClimateReportMutation, CreateMobileIndoorClimateReportMutationVariables>;
export const CreateMobileV2CaseOrganizationReportDocument = gql`
    mutation CreateMobileV2CaseOrganizationReport($caseId: String!, $formData: CaseOrganizationFormDataInput!, $onlySave: Boolean!) {
  createCaseOrganizationReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateMobileV2CaseOrganizationReportMutationFn = Apollo.MutationFunction<CreateMobileV2CaseOrganizationReportMutation, CreateMobileV2CaseOrganizationReportMutationVariables>;

/**
 * __useCreateMobileV2CaseOrganizationReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2CaseOrganizationReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2CaseOrganizationReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2CaseOrganizationReportMutation, { data, loading, error }] = useCreateMobileV2CaseOrganizationReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateMobileV2CaseOrganizationReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2CaseOrganizationReportMutation, CreateMobileV2CaseOrganizationReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2CaseOrganizationReportMutation, CreateMobileV2CaseOrganizationReportMutationVariables>(CreateMobileV2CaseOrganizationReportDocument, options);
}
export type CreateMobileV2CaseOrganizationReportMutationHookResult = ReturnType<typeof useCreateMobileV2CaseOrganizationReportMutation>;
export type CreateMobileV2CaseOrganizationReportMutationResult = Apollo.MutationResult<CreateMobileV2CaseOrganizationReportMutation>;
export type CreateMobileV2CaseOrganizationReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2CaseOrganizationReportMutation, CreateMobileV2CaseOrganizationReportMutationVariables>;
export const CreateMobileV2DamageReportDocument = gql`
    mutation CreateMobileV2DamageReport($caseId: String!) {
  createDamageReport(caseId: $caseId) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateMobileV2DamageReportMutationFn = Apollo.MutationFunction<CreateMobileV2DamageReportMutation, CreateMobileV2DamageReportMutationVariables>;

/**
 * __useCreateMobileV2DamageReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2DamageReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2DamageReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2DamageReportMutation, { data, loading, error }] = useCreateMobileV2DamageReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useCreateMobileV2DamageReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2DamageReportMutation, CreateMobileV2DamageReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2DamageReportMutation, CreateMobileV2DamageReportMutationVariables>(CreateMobileV2DamageReportDocument, options);
}
export type CreateMobileV2DamageReportMutationHookResult = ReturnType<typeof useCreateMobileV2DamageReportMutation>;
export type CreateMobileV2DamageReportMutationResult = Apollo.MutationResult<CreateMobileV2DamageReportMutation>;
export type CreateMobileV2DamageReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2DamageReportMutation, CreateMobileV2DamageReportMutationVariables>;
export const CreateMobileV2EndevaluationReportDocument = gql`
    mutation CreateMobileV2EndevaluationReport($caseId: String!, $formData: EndevaluationReportFormDataInput!, $onlySave: Boolean!) {
  createEndevaluationReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateMobileV2EndevaluationReportMutationFn = Apollo.MutationFunction<CreateMobileV2EndevaluationReportMutation, CreateMobileV2EndevaluationReportMutationVariables>;

/**
 * __useCreateMobileV2EndevaluationReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2EndevaluationReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2EndevaluationReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2EndevaluationReportMutation, { data, loading, error }] = useCreateMobileV2EndevaluationReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateMobileV2EndevaluationReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2EndevaluationReportMutation, CreateMobileV2EndevaluationReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2EndevaluationReportMutation, CreateMobileV2EndevaluationReportMutationVariables>(CreateMobileV2EndevaluationReportDocument, options);
}
export type CreateMobileV2EndevaluationReportMutationHookResult = ReturnType<typeof useCreateMobileV2EndevaluationReportMutation>;
export type CreateMobileV2EndevaluationReportMutationResult = Apollo.MutationResult<CreateMobileV2EndevaluationReportMutation>;
export type CreateMobileV2EndevaluationReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2EndevaluationReportMutation, CreateMobileV2EndevaluationReportMutationVariables>;
export const CreateMobileV2InspectionAssesmentReportDocument = gql`
    mutation CreateMobileV2InspectionAssesmentReport($caseId: String!, $formData: InspectionAssesmentFormDataInput!, $onlySave: Boolean!) {
  createInspectionAssesmentReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateMobileV2InspectionAssesmentReportMutationFn = Apollo.MutationFunction<CreateMobileV2InspectionAssesmentReportMutation, CreateMobileV2InspectionAssesmentReportMutationVariables>;

/**
 * __useCreateMobileV2InspectionAssesmentReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2InspectionAssesmentReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2InspectionAssesmentReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2InspectionAssesmentReportMutation, { data, loading, error }] = useCreateMobileV2InspectionAssesmentReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateMobileV2InspectionAssesmentReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2InspectionAssesmentReportMutation, CreateMobileV2InspectionAssesmentReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2InspectionAssesmentReportMutation, CreateMobileV2InspectionAssesmentReportMutationVariables>(CreateMobileV2InspectionAssesmentReportDocument, options);
}
export type CreateMobileV2InspectionAssesmentReportMutationHookResult = ReturnType<typeof useCreateMobileV2InspectionAssesmentReportMutation>;
export type CreateMobileV2InspectionAssesmentReportMutationResult = Apollo.MutationResult<CreateMobileV2InspectionAssesmentReportMutation>;
export type CreateMobileV2InspectionAssesmentReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2InspectionAssesmentReportMutation, CreateMobileV2InspectionAssesmentReportMutationVariables>;
export const CreateMobileV2InspectionMovablesReportDocument = gql`
    mutation CreateMobileV2InspectionMovablesReport($caseId: String!, $formData: InspectionReportFormDataInput!, $onlySave: Boolean!) {
  createInspectionMovablesReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateMobileV2InspectionMovablesReportMutationFn = Apollo.MutationFunction<CreateMobileV2InspectionMovablesReportMutation, CreateMobileV2InspectionMovablesReportMutationVariables>;

/**
 * __useCreateMobileV2InspectionMovablesReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2InspectionMovablesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2InspectionMovablesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2InspectionMovablesReportMutation, { data, loading, error }] = useCreateMobileV2InspectionMovablesReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateMobileV2InspectionMovablesReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2InspectionMovablesReportMutation, CreateMobileV2InspectionMovablesReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2InspectionMovablesReportMutation, CreateMobileV2InspectionMovablesReportMutationVariables>(CreateMobileV2InspectionMovablesReportDocument, options);
}
export type CreateMobileV2InspectionMovablesReportMutationHookResult = ReturnType<typeof useCreateMobileV2InspectionMovablesReportMutation>;
export type CreateMobileV2InspectionMovablesReportMutationResult = Apollo.MutationResult<CreateMobileV2InspectionMovablesReportMutation>;
export type CreateMobileV2InspectionMovablesReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2InspectionMovablesReportMutation, CreateMobileV2InspectionMovablesReportMutationVariables>;
export const CreateMobileV2InspectionReportDocument = gql`
    mutation CreateMobileV2InspectionReport($caseId: String!, $formData: InspectionReportFormDataInput!, $onlySave: Boolean!) {
  createInspectionReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateMobileV2InspectionReportMutationFn = Apollo.MutationFunction<CreateMobileV2InspectionReportMutation, CreateMobileV2InspectionReportMutationVariables>;

/**
 * __useCreateMobileV2InspectionReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2InspectionReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2InspectionReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2InspectionReportMutation, { data, loading, error }] = useCreateMobileV2InspectionReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateMobileV2InspectionReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2InspectionReportMutation, CreateMobileV2InspectionReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2InspectionReportMutation, CreateMobileV2InspectionReportMutationVariables>(CreateMobileV2InspectionReportDocument, options);
}
export type CreateMobileV2InspectionReportMutationHookResult = ReturnType<typeof useCreateMobileV2InspectionReportMutation>;
export type CreateMobileV2InspectionReportMutationResult = Apollo.MutationResult<CreateMobileV2InspectionReportMutation>;
export type CreateMobileV2InspectionReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2InspectionReportMutation, CreateMobileV2InspectionReportMutationVariables>;
export const CreateMobileV2MoistureReportDocument = gql`
    mutation CreateMobileV2MoistureReport($caseId: String!, $formData: MoistureReportFormDataInput!, $reportFormat: ReportFormatType!, $floorsToInclude: [String!], $onlySave: Boolean!) {
  createMoistureReport(
    caseId: $caseId
    formData: $formData
    reportFormat: $reportFormat
    floorsToInclude: $floorsToInclude
    onlySave: $onlySave
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateMobileV2MoistureReportMutationFn = Apollo.MutationFunction<CreateMobileV2MoistureReportMutation, CreateMobileV2MoistureReportMutationVariables>;

/**
 * __useCreateMobileV2MoistureReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2MoistureReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2MoistureReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2MoistureReportMutation, { data, loading, error }] = useCreateMobileV2MoistureReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      reportFormat: // value for 'reportFormat'
 *      floorsToInclude: // value for 'floorsToInclude'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateMobileV2MoistureReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2MoistureReportMutation, CreateMobileV2MoistureReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2MoistureReportMutation, CreateMobileV2MoistureReportMutationVariables>(CreateMobileV2MoistureReportDocument, options);
}
export type CreateMobileV2MoistureReportMutationHookResult = ReturnType<typeof useCreateMobileV2MoistureReportMutation>;
export type CreateMobileV2MoistureReportMutationResult = Apollo.MutationResult<CreateMobileV2MoistureReportMutation>;
export type CreateMobileV2MoistureReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2MoistureReportMutation, CreateMobileV2MoistureReportMutationVariables>;
export const CreateMobileV2MoistureTrygReportDocument = gql`
    mutation CreateMobileV2MoistureTrygReport($caseId: String!, $formData: MoistureTrygReportFormDataInput!, $reportFormat: ReportFormatType!, $floorsToInclude: [String!], $onlySave: Boolean!) {
  createMoistureTrygReport(
    caseId: $caseId
    formData: $formData
    reportFormat: $reportFormat
    floorsToInclude: $floorsToInclude
    onlySave: $onlySave
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type CreateMobileV2MoistureTrygReportMutationFn = Apollo.MutationFunction<CreateMobileV2MoistureTrygReportMutation, CreateMobileV2MoistureTrygReportMutationVariables>;

/**
 * __useCreateMobileV2MoistureTrygReportMutation__
 *
 * To run a mutation, you first call `useCreateMobileV2MoistureTrygReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileV2MoistureTrygReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileV2MoistureTrygReportMutation, { data, loading, error }] = useCreateMobileV2MoistureTrygReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      reportFormat: // value for 'reportFormat'
 *      floorsToInclude: // value for 'floorsToInclude'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateMobileV2MoistureTrygReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobileV2MoistureTrygReportMutation, CreateMobileV2MoistureTrygReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMobileV2MoistureTrygReportMutation, CreateMobileV2MoistureTrygReportMutationVariables>(CreateMobileV2MoistureTrygReportDocument, options);
}
export type CreateMobileV2MoistureTrygReportMutationHookResult = ReturnType<typeof useCreateMobileV2MoistureTrygReportMutation>;
export type CreateMobileV2MoistureTrygReportMutationResult = Apollo.MutationResult<CreateMobileV2MoistureTrygReportMutation>;
export type CreateMobileV2MoistureTrygReportMutationOptions = Apollo.BaseMutationOptions<CreateMobileV2MoistureTrygReportMutation, CreateMobileV2MoistureTrygReportMutationVariables>;
export const GetCaseReportsAndDocumentsDocument = gql`
    query GetCaseReportsAndDocuments($id: String!) {
  case(id: $id) {
    id
    erpNo
    documents {
      ...ESDHFileFragment
    }
    caseReports {
      inspectionReportFormData {
        ...BaseInspectionReportFormDataFragment
      }
      inspectionMovablesReportFormData {
        ...BaseInspectionReportFormDataFragment
      }
      moistureReportFormData {
        ...BaseMoistureReportFormDataFragment
      }
      moistureTrygReportFormData {
        ...BaseMoistureTrygReportFormDataFragment
      }
      indoorClimateReportFormData {
        ...IndoorClimateReportFormDataFragment
      }
    }
  }
}
    ${EsdhFileFragmentFragmentDoc}
${BaseInspectionReportFormDataFragmentFragmentDoc}
${BaseMoistureReportFormDataFragmentFragmentDoc}
${BaseMoistureTrygReportFormDataFragmentFragmentDoc}
${IndoorClimateReportFormDataFragmentFragmentDoc}`;

/**
 * __useGetCaseReportsAndDocumentsQuery__
 *
 * To run a query within a React component, call `useGetCaseReportsAndDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseReportsAndDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseReportsAndDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseReportsAndDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseReportsAndDocumentsQuery, GetCaseReportsAndDocumentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseReportsAndDocumentsQuery, GetCaseReportsAndDocumentsQueryVariables>(GetCaseReportsAndDocumentsDocument, options);
}
export function useGetCaseReportsAndDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseReportsAndDocumentsQuery, GetCaseReportsAndDocumentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseReportsAndDocumentsQuery, GetCaseReportsAndDocumentsQueryVariables>(GetCaseReportsAndDocumentsDocument, options);
}
export function useGetCaseReportsAndDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseReportsAndDocumentsQuery, GetCaseReportsAndDocumentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseReportsAndDocumentsQuery, GetCaseReportsAndDocumentsQueryVariables>(GetCaseReportsAndDocumentsDocument, options);
}
export type GetCaseReportsAndDocumentsQueryHookResult = ReturnType<typeof useGetCaseReportsAndDocumentsQuery>;
export type GetCaseReportsAndDocumentsLazyQueryHookResult = ReturnType<typeof useGetCaseReportsAndDocumentsLazyQuery>;
export type GetCaseReportsAndDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetCaseReportsAndDocumentsSuspenseQuery>;
export type GetCaseReportsAndDocumentsQueryResult = Apollo.QueryResult<GetCaseReportsAndDocumentsQuery, GetCaseReportsAndDocumentsQueryVariables>;
export function refetchGetCaseReportsAndDocumentsQuery(variables: GetCaseReportsAndDocumentsQueryVariables) {
  return { query: GetCaseReportsAndDocumentsDocument, variables: variables }
}
export const CreateCaseRequisitionDocument = gql`
    mutation CreateCaseRequisition($caseId: String!, $requisition: RequisitionInput!, $shouldSendEmail: Boolean!) {
  createCaseRequisition(
    caseId: $caseId
    requisition: $requisition
    shouldSendEmail: $shouldSendEmail
  ) {
    ...RequisitionFragment
  }
}
    ${RequisitionFragmentFragmentDoc}`;
export type CreateCaseRequisitionMutationFn = Apollo.MutationFunction<CreateCaseRequisitionMutation, CreateCaseRequisitionMutationVariables>;

/**
 * __useCreateCaseRequisitionMutation__
 *
 * To run a mutation, you first call `useCreateCaseRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseRequisitionMutation, { data, loading, error }] = useCreateCaseRequisitionMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      requisition: // value for 'requisition'
 *      shouldSendEmail: // value for 'shouldSendEmail'
 *   },
 * });
 */
export function useCreateCaseRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseRequisitionMutation, CreateCaseRequisitionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCaseRequisitionMutation, CreateCaseRequisitionMutationVariables>(CreateCaseRequisitionDocument, options);
}
export type CreateCaseRequisitionMutationHookResult = ReturnType<typeof useCreateCaseRequisitionMutation>;
export type CreateCaseRequisitionMutationResult = Apollo.MutationResult<CreateCaseRequisitionMutation>;
export type CreateCaseRequisitionMutationOptions = Apollo.BaseMutationOptions<CreateCaseRequisitionMutation, CreateCaseRequisitionMutationVariables>;
export const CreateDepartmentRequisitionDocument = gql`
    mutation CreateDepartmentRequisition($departmentId: String!, $requisition: RequisitionInput!, $shouldSendEmail: Boolean!) {
  createDepartmentRequisition(
    departmentId: $departmentId
    requisition: $requisition
    shouldSendEmail: $shouldSendEmail
  ) {
    ...RequisitionFragment
  }
}
    ${RequisitionFragmentFragmentDoc}`;
export type CreateDepartmentRequisitionMutationFn = Apollo.MutationFunction<CreateDepartmentRequisitionMutation, CreateDepartmentRequisitionMutationVariables>;

/**
 * __useCreateDepartmentRequisitionMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentRequisitionMutation, { data, loading, error }] = useCreateDepartmentRequisitionMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      requisition: // value for 'requisition'
 *      shouldSendEmail: // value for 'shouldSendEmail'
 *   },
 * });
 */
export function useCreateDepartmentRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentRequisitionMutation, CreateDepartmentRequisitionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDepartmentRequisitionMutation, CreateDepartmentRequisitionMutationVariables>(CreateDepartmentRequisitionDocument, options);
}
export type CreateDepartmentRequisitionMutationHookResult = ReturnType<typeof useCreateDepartmentRequisitionMutation>;
export type CreateDepartmentRequisitionMutationResult = Apollo.MutationResult<CreateDepartmentRequisitionMutation>;
export type CreateDepartmentRequisitionMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentRequisitionMutation, CreateDepartmentRequisitionMutationVariables>;
export const GetMobileV2RequisitionsDocument = gql`
    query GetMobileV2Requisitions($myRequisitionsOnly: Boolean, $caseId: String, $offset: Int, $limit: Int, $excludeTotalCount: Boolean) {
  requisitions(
    myRequisitionsOnly: $myRequisitionsOnly
    caseId: $caseId
    offset: $offset
    limit: $limit
    excludeTotalCount: $excludeTotalCount
  ) {
    ...RequisitionFragment
  }
}
    ${RequisitionFragmentFragmentDoc}`;

/**
 * __useGetMobileV2RequisitionsQuery__
 *
 * To run a query within a React component, call `useGetMobileV2RequisitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2RequisitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2RequisitionsQuery({
 *   variables: {
 *      myRequisitionsOnly: // value for 'myRequisitionsOnly'
 *      caseId: // value for 'caseId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetMobileV2RequisitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2RequisitionsQuery, GetMobileV2RequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2RequisitionsQuery, GetMobileV2RequisitionsQueryVariables>(GetMobileV2RequisitionsDocument, options);
}
export function useGetMobileV2RequisitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2RequisitionsQuery, GetMobileV2RequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2RequisitionsQuery, GetMobileV2RequisitionsQueryVariables>(GetMobileV2RequisitionsDocument, options);
}
export function useGetMobileV2RequisitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2RequisitionsQuery, GetMobileV2RequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2RequisitionsQuery, GetMobileV2RequisitionsQueryVariables>(GetMobileV2RequisitionsDocument, options);
}
export type GetMobileV2RequisitionsQueryHookResult = ReturnType<typeof useGetMobileV2RequisitionsQuery>;
export type GetMobileV2RequisitionsLazyQueryHookResult = ReturnType<typeof useGetMobileV2RequisitionsLazyQuery>;
export type GetMobileV2RequisitionsSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2RequisitionsSuspenseQuery>;
export type GetMobileV2RequisitionsQueryResult = Apollo.QueryResult<GetMobileV2RequisitionsQuery, GetMobileV2RequisitionsQueryVariables>;
export function refetchGetMobileV2RequisitionsQuery(variables?: GetMobileV2RequisitionsQueryVariables) {
  return { query: GetMobileV2RequisitionsDocument, variables: variables }
}
export const GetRequisitionsOnCaseDocument = gql`
    query GetRequisitionsOnCase($caseId: String) {
  requisitions(caseId: $caseId) {
    ...RequisitionFragment
  }
}
    ${RequisitionFragmentFragmentDoc}`;

/**
 * __useGetRequisitionsOnCaseQuery__
 *
 * To run a query within a React component, call `useGetRequisitionsOnCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionsOnCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionsOnCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetRequisitionsOnCaseQuery(baseOptions?: Apollo.QueryHookOptions<GetRequisitionsOnCaseQuery, GetRequisitionsOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionsOnCaseQuery, GetRequisitionsOnCaseQueryVariables>(GetRequisitionsOnCaseDocument, options);
}
export function useGetRequisitionsOnCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionsOnCaseQuery, GetRequisitionsOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionsOnCaseQuery, GetRequisitionsOnCaseQueryVariables>(GetRequisitionsOnCaseDocument, options);
}
export function useGetRequisitionsOnCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionsOnCaseQuery, GetRequisitionsOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionsOnCaseQuery, GetRequisitionsOnCaseQueryVariables>(GetRequisitionsOnCaseDocument, options);
}
export type GetRequisitionsOnCaseQueryHookResult = ReturnType<typeof useGetRequisitionsOnCaseQuery>;
export type GetRequisitionsOnCaseLazyQueryHookResult = ReturnType<typeof useGetRequisitionsOnCaseLazyQuery>;
export type GetRequisitionsOnCaseSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionsOnCaseSuspenseQuery>;
export type GetRequisitionsOnCaseQueryResult = Apollo.QueryResult<GetRequisitionsOnCaseQuery, GetRequisitionsOnCaseQueryVariables>;
export function refetchGetRequisitionsOnCaseQuery(variables?: GetRequisitionsOnCaseQueryVariables) {
  return { query: GetRequisitionsOnCaseDocument, variables: variables }
}
export const GetVendorsDocument = gql`
    query GetVendors($company: String) {
  vendors(company: $company) {
    ...VendorFragment
  }
}
    ${VendorFragmentFragmentDoc}`;

/**
 * __useGetVendorsQuery__
 *
 * To run a query within a React component, call `useGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsQuery({
 *   variables: {
 *      company: // value for 'company'
 *   },
 * });
 */
export function useGetVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
}
export function useGetVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
}
export function useGetVendorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
}
export type GetVendorsQueryHookResult = ReturnType<typeof useGetVendorsQuery>;
export type GetVendorsLazyQueryHookResult = ReturnType<typeof useGetVendorsLazyQuery>;
export type GetVendorsSuspenseQueryHookResult = ReturnType<typeof useGetVendorsSuspenseQuery>;
export type GetVendorsQueryResult = Apollo.QueryResult<GetVendorsQuery, GetVendorsQueryVariables>;
export function refetchGetVendorsQuery(variables?: GetVendorsQueryVariables) {
  return { query: GetVendorsDocument, variables: variables }
}
export const CreateTimeTrackingDocument = gql`
    mutation CreateTimeTracking($timeTracking: TimeTrackingInputType!) {
  createTimeTracking(timeTracking: $timeTracking) {
    ...BaseTimeTrackingFragment
  }
}
    ${BaseTimeTrackingFragmentFragmentDoc}`;
export type CreateTimeTrackingMutationFn = Apollo.MutationFunction<CreateTimeTrackingMutation, CreateTimeTrackingMutationVariables>;

/**
 * __useCreateTimeTrackingMutation__
 *
 * To run a mutation, you first call `useCreateTimeTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeTrackingMutation, { data, loading, error }] = useCreateTimeTrackingMutation({
 *   variables: {
 *      timeTracking: // value for 'timeTracking'
 *   },
 * });
 */
export function useCreateTimeTrackingMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeTrackingMutation, CreateTimeTrackingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTimeTrackingMutation, CreateTimeTrackingMutationVariables>(CreateTimeTrackingDocument, options);
}
export type CreateTimeTrackingMutationHookResult = ReturnType<typeof useCreateTimeTrackingMutation>;
export type CreateTimeTrackingMutationResult = Apollo.MutationResult<CreateTimeTrackingMutation>;
export type CreateTimeTrackingMutationOptions = Apollo.BaseMutationOptions<CreateTimeTrackingMutation, CreateTimeTrackingMutationVariables>;
export const DeleteTimeTrackingDocument = gql`
    mutation DeleteTimeTracking($id: String!) {
  deleteTimeTracking(id: $id) {
    _
  }
}
    `;
export type DeleteTimeTrackingMutationFn = Apollo.MutationFunction<DeleteTimeTrackingMutation, DeleteTimeTrackingMutationVariables>;

/**
 * __useDeleteTimeTrackingMutation__
 *
 * To run a mutation, you first call `useDeleteTimeTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeTrackingMutation, { data, loading, error }] = useDeleteTimeTrackingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeTrackingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeTrackingMutation, DeleteTimeTrackingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTimeTrackingMutation, DeleteTimeTrackingMutationVariables>(DeleteTimeTrackingDocument, options);
}
export type DeleteTimeTrackingMutationHookResult = ReturnType<typeof useDeleteTimeTrackingMutation>;
export type DeleteTimeTrackingMutationResult = Apollo.MutationResult<DeleteTimeTrackingMutation>;
export type DeleteTimeTrackingMutationOptions = Apollo.BaseMutationOptions<DeleteTimeTrackingMutation, DeleteTimeTrackingMutationVariables>;
export const GetClosedDayByUserDocument = gql`
    query GetClosedDayByUser($user: String!) {
  closedDayByUser(user: $user) {
    id
    user {
      id
    }
    trackingType
    date
  }
}
    `;

/**
 * __useGetClosedDayByUserQuery__
 *
 * To run a query within a React component, call `useGetClosedDayByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClosedDayByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClosedDayByUserQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetClosedDayByUserQuery(baseOptions: Apollo.QueryHookOptions<GetClosedDayByUserQuery, GetClosedDayByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetClosedDayByUserQuery, GetClosedDayByUserQueryVariables>(GetClosedDayByUserDocument, options);
}
export function useGetClosedDayByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClosedDayByUserQuery, GetClosedDayByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetClosedDayByUserQuery, GetClosedDayByUserQueryVariables>(GetClosedDayByUserDocument, options);
}
export function useGetClosedDayByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClosedDayByUserQuery, GetClosedDayByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetClosedDayByUserQuery, GetClosedDayByUserQueryVariables>(GetClosedDayByUserDocument, options);
}
export type GetClosedDayByUserQueryHookResult = ReturnType<typeof useGetClosedDayByUserQuery>;
export type GetClosedDayByUserLazyQueryHookResult = ReturnType<typeof useGetClosedDayByUserLazyQuery>;
export type GetClosedDayByUserSuspenseQueryHookResult = ReturnType<typeof useGetClosedDayByUserSuspenseQuery>;
export type GetClosedDayByUserQueryResult = Apollo.QueryResult<GetClosedDayByUserQuery, GetClosedDayByUserQueryVariables>;
export function refetchGetClosedDayByUserQuery(variables: GetClosedDayByUserQueryVariables) {
  return { query: GetClosedDayByUserDocument, variables: variables }
}
export const GetLatestDayByUserDocument = gql`
    query GetLatestDayByUser($user: String!) {
  latestDayByUser(user: $user) {
    id
    trackingType
    date
  }
}
    `;

/**
 * __useGetLatestDayByUserQuery__
 *
 * To run a query within a React component, call `useGetLatestDayByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestDayByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestDayByUserQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetLatestDayByUserQuery(baseOptions: Apollo.QueryHookOptions<GetLatestDayByUserQuery, GetLatestDayByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLatestDayByUserQuery, GetLatestDayByUserQueryVariables>(GetLatestDayByUserDocument, options);
}
export function useGetLatestDayByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestDayByUserQuery, GetLatestDayByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetLatestDayByUserQuery, GetLatestDayByUserQueryVariables>(GetLatestDayByUserDocument, options);
}
export function useGetLatestDayByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestDayByUserQuery, GetLatestDayByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetLatestDayByUserQuery, GetLatestDayByUserQueryVariables>(GetLatestDayByUserDocument, options);
}
export type GetLatestDayByUserQueryHookResult = ReturnType<typeof useGetLatestDayByUserQuery>;
export type GetLatestDayByUserLazyQueryHookResult = ReturnType<typeof useGetLatestDayByUserLazyQuery>;
export type GetLatestDayByUserSuspenseQueryHookResult = ReturnType<typeof useGetLatestDayByUserSuspenseQuery>;
export type GetLatestDayByUserQueryResult = Apollo.QueryResult<GetLatestDayByUserQuery, GetLatestDayByUserQueryVariables>;
export function refetchGetLatestDayByUserQuery(variables: GetLatestDayByUserQueryVariables) {
  return { query: GetLatestDayByUserDocument, variables: variables }
}
export const GetMobileV2CasesForTimeTrackingDocument = gql`
    query GetMobileV2CasesForTimeTracking($erpReferenceNos: [String!]) {
  cases(erpReferenceNos: $erpReferenceNos) {
    id
    erpNo
    track
    timeRegistration
    debitor {
      ...BaseDebitorFragment
    }
    damage {
      ...DamageFragment
    }
  }
}
    ${BaseDebitorFragmentFragmentDoc}
${DamageFragmentFragmentDoc}`;

/**
 * __useGetMobileV2CasesForTimeTrackingQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CasesForTimeTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CasesForTimeTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CasesForTimeTrackingQuery({
 *   variables: {
 *      erpReferenceNos: // value for 'erpReferenceNos'
 *   },
 * });
 */
export function useGetMobileV2CasesForTimeTrackingQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2CasesForTimeTrackingQuery, GetMobileV2CasesForTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CasesForTimeTrackingQuery, GetMobileV2CasesForTimeTrackingQueryVariables>(GetMobileV2CasesForTimeTrackingDocument, options);
}
export function useGetMobileV2CasesForTimeTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CasesForTimeTrackingQuery, GetMobileV2CasesForTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CasesForTimeTrackingQuery, GetMobileV2CasesForTimeTrackingQueryVariables>(GetMobileV2CasesForTimeTrackingDocument, options);
}
export function useGetMobileV2CasesForTimeTrackingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CasesForTimeTrackingQuery, GetMobileV2CasesForTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CasesForTimeTrackingQuery, GetMobileV2CasesForTimeTrackingQueryVariables>(GetMobileV2CasesForTimeTrackingDocument, options);
}
export type GetMobileV2CasesForTimeTrackingQueryHookResult = ReturnType<typeof useGetMobileV2CasesForTimeTrackingQuery>;
export type GetMobileV2CasesForTimeTrackingLazyQueryHookResult = ReturnType<typeof useGetMobileV2CasesForTimeTrackingLazyQuery>;
export type GetMobileV2CasesForTimeTrackingSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CasesForTimeTrackingSuspenseQuery>;
export type GetMobileV2CasesForTimeTrackingQueryResult = Apollo.QueryResult<GetMobileV2CasesForTimeTrackingQuery, GetMobileV2CasesForTimeTrackingQueryVariables>;
export function refetchGetMobileV2CasesForTimeTrackingQuery(variables?: GetMobileV2CasesForTimeTrackingQueryVariables) {
  return { query: GetMobileV2CasesForTimeTrackingDocument, variables: variables }
}
export const GetPaymentSupplementsDocument = gql`
    query GetPaymentSupplements {
  paymentSupplements {
    id
    code
    type
    description
    templateJobNo
    blocked
    uOM
    workTypeCode
  }
}
    `;

/**
 * __useGetPaymentSupplementsQuery__
 *
 * To run a query within a React component, call `useGetPaymentSupplementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentSupplementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentSupplementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentSupplementsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentSupplementsQuery, GetPaymentSupplementsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPaymentSupplementsQuery, GetPaymentSupplementsQueryVariables>(GetPaymentSupplementsDocument, options);
}
export function useGetPaymentSupplementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentSupplementsQuery, GetPaymentSupplementsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPaymentSupplementsQuery, GetPaymentSupplementsQueryVariables>(GetPaymentSupplementsDocument, options);
}
export function useGetPaymentSupplementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentSupplementsQuery, GetPaymentSupplementsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetPaymentSupplementsQuery, GetPaymentSupplementsQueryVariables>(GetPaymentSupplementsDocument, options);
}
export type GetPaymentSupplementsQueryHookResult = ReturnType<typeof useGetPaymentSupplementsQuery>;
export type GetPaymentSupplementsLazyQueryHookResult = ReturnType<typeof useGetPaymentSupplementsLazyQuery>;
export type GetPaymentSupplementsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentSupplementsSuspenseQuery>;
export type GetPaymentSupplementsQueryResult = Apollo.QueryResult<GetPaymentSupplementsQuery, GetPaymentSupplementsQueryVariables>;
export function refetchGetPaymentSupplementsQuery(variables?: GetPaymentSupplementsQueryVariables) {
  return { query: GetPaymentSupplementsDocument, variables: variables }
}
export const GetRejectedTimeTrackingsForUserDocument = gql`
    query GetRejectedTimeTrackingsForUser($user: String!) {
  rejectedTimeTrackingsForUser(user: $user) {
    ...BaseTimeTrackingFragment
  }
}
    ${BaseTimeTrackingFragmentFragmentDoc}`;

/**
 * __useGetRejectedTimeTrackingsForUserQuery__
 *
 * To run a query within a React component, call `useGetRejectedTimeTrackingsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRejectedTimeTrackingsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRejectedTimeTrackingsForUserQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetRejectedTimeTrackingsForUserQuery(baseOptions: Apollo.QueryHookOptions<GetRejectedTimeTrackingsForUserQuery, GetRejectedTimeTrackingsForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRejectedTimeTrackingsForUserQuery, GetRejectedTimeTrackingsForUserQueryVariables>(GetRejectedTimeTrackingsForUserDocument, options);
}
export function useGetRejectedTimeTrackingsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRejectedTimeTrackingsForUserQuery, GetRejectedTimeTrackingsForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRejectedTimeTrackingsForUserQuery, GetRejectedTimeTrackingsForUserQueryVariables>(GetRejectedTimeTrackingsForUserDocument, options);
}
export function useGetRejectedTimeTrackingsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRejectedTimeTrackingsForUserQuery, GetRejectedTimeTrackingsForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRejectedTimeTrackingsForUserQuery, GetRejectedTimeTrackingsForUserQueryVariables>(GetRejectedTimeTrackingsForUserDocument, options);
}
export type GetRejectedTimeTrackingsForUserQueryHookResult = ReturnType<typeof useGetRejectedTimeTrackingsForUserQuery>;
export type GetRejectedTimeTrackingsForUserLazyQueryHookResult = ReturnType<typeof useGetRejectedTimeTrackingsForUserLazyQuery>;
export type GetRejectedTimeTrackingsForUserSuspenseQueryHookResult = ReturnType<typeof useGetRejectedTimeTrackingsForUserSuspenseQuery>;
export type GetRejectedTimeTrackingsForUserQueryResult = Apollo.QueryResult<GetRejectedTimeTrackingsForUserQuery, GetRejectedTimeTrackingsForUserQueryVariables>;
export function refetchGetRejectedTimeTrackingsForUserQuery(variables: GetRejectedTimeTrackingsForUserQueryVariables) {
  return { query: GetRejectedTimeTrackingsForUserDocument, variables: variables }
}
export const GetTimeTrackingDocument = gql`
    query GetTimeTracking($id: String!, $minDate: Date, $maxDate: Date) {
  timeTracking(id: $id, minDate: $minDate, maxDate: $maxDate) {
    ...BaseTimeTrackingFragment
  }
}
    ${BaseTimeTrackingFragmentFragmentDoc}`;

/**
 * __useGetTimeTrackingQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetTimeTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetTimeTrackingQuery, GetTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingQuery, GetTimeTrackingQueryVariables>(GetTimeTrackingDocument, options);
}
export function useGetTimeTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingQuery, GetTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingQuery, GetTimeTrackingQueryVariables>(GetTimeTrackingDocument, options);
}
export function useGetTimeTrackingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingQuery, GetTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingQuery, GetTimeTrackingQueryVariables>(GetTimeTrackingDocument, options);
}
export type GetTimeTrackingQueryHookResult = ReturnType<typeof useGetTimeTrackingQuery>;
export type GetTimeTrackingLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingLazyQuery>;
export type GetTimeTrackingSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingSuspenseQuery>;
export type GetTimeTrackingQueryResult = Apollo.QueryResult<GetTimeTrackingQuery, GetTimeTrackingQueryVariables>;
export function refetchGetTimeTrackingQuery(variables: GetTimeTrackingQueryVariables) {
  return { query: GetTimeTrackingDocument, variables: variables }
}
export const GetTimeTrackingsForUserDocument = gql`
    query GetTimeTrackingsForUser($user: String!, $minDate: Date, $maxDate: Date) {
  timeTrackingsForUser(user: $user, minDate: $minDate, maxDate: $maxDate) {
    ...BaseTimeTrackingFragment
  }
}
    ${BaseTimeTrackingFragmentFragmentDoc}`;

/**
 * __useGetTimeTrackingsForUserQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingsForUserQuery({
 *   variables: {
 *      user: // value for 'user'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetTimeTrackingsForUserQuery(baseOptions: Apollo.QueryHookOptions<GetTimeTrackingsForUserQuery, GetTimeTrackingsForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingsForUserQuery, GetTimeTrackingsForUserQueryVariables>(GetTimeTrackingsForUserDocument, options);
}
export function useGetTimeTrackingsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingsForUserQuery, GetTimeTrackingsForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingsForUserQuery, GetTimeTrackingsForUserQueryVariables>(GetTimeTrackingsForUserDocument, options);
}
export function useGetTimeTrackingsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingsForUserQuery, GetTimeTrackingsForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingsForUserQuery, GetTimeTrackingsForUserQueryVariables>(GetTimeTrackingsForUserDocument, options);
}
export type GetTimeTrackingsForUserQueryHookResult = ReturnType<typeof useGetTimeTrackingsForUserQuery>;
export type GetTimeTrackingsForUserLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingsForUserLazyQuery>;
export type GetTimeTrackingsForUserSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingsForUserSuspenseQuery>;
export type GetTimeTrackingsForUserQueryResult = Apollo.QueryResult<GetTimeTrackingsForUserQuery, GetTimeTrackingsForUserQueryVariables>;
export function refetchGetTimeTrackingsForUserQuery(variables: GetTimeTrackingsForUserQueryVariables) {
  return { query: GetTimeTrackingsForUserDocument, variables: variables }
}
export const GetTimeTrackingsDocument = gql`
    query GetTimeTrackings($trackingType: TrackingType, $minDate: Date, $maxDate: Date, $users: [String!]) {
  timeTrackings(
    trackingType: $trackingType
    minDate: $minDate
    maxDate: $maxDate
    users: $users
  ) {
    ...BaseTimeTrackingFragment
  }
}
    ${BaseTimeTrackingFragmentFragmentDoc}`;

/**
 * __useGetTimeTrackingsQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingsQuery({
 *   variables: {
 *      trackingType: // value for 'trackingType'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      users: // value for 'users'
 *   },
 * });
 */
export function useGetTimeTrackingsQuery(baseOptions?: Apollo.QueryHookOptions<GetTimeTrackingsQuery, GetTimeTrackingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingsQuery, GetTimeTrackingsQueryVariables>(GetTimeTrackingsDocument, options);
}
export function useGetTimeTrackingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingsQuery, GetTimeTrackingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingsQuery, GetTimeTrackingsQueryVariables>(GetTimeTrackingsDocument, options);
}
export function useGetTimeTrackingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingsQuery, GetTimeTrackingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingsQuery, GetTimeTrackingsQueryVariables>(GetTimeTrackingsDocument, options);
}
export type GetTimeTrackingsQueryHookResult = ReturnType<typeof useGetTimeTrackingsQuery>;
export type GetTimeTrackingsLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingsLazyQuery>;
export type GetTimeTrackingsSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingsSuspenseQuery>;
export type GetTimeTrackingsQueryResult = Apollo.QueryResult<GetTimeTrackingsQuery, GetTimeTrackingsQueryVariables>;
export function refetchGetTimeTrackingsQuery(variables?: GetTimeTrackingsQueryVariables) {
  return { query: GetTimeTrackingsDocument, variables: variables }
}
export const SubmitDayDocument = gql`
    mutation SubmitDay($timeTracking: TimeTrackingInputType!) {
  submitDay(timeTracking: $timeTracking) {
    ...BaseTimeTrackingFragment
  }
}
    ${BaseTimeTrackingFragmentFragmentDoc}`;
export type SubmitDayMutationFn = Apollo.MutationFunction<SubmitDayMutation, SubmitDayMutationVariables>;

/**
 * __useSubmitDayMutation__
 *
 * To run a mutation, you first call `useSubmitDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDayMutation, { data, loading, error }] = useSubmitDayMutation({
 *   variables: {
 *      timeTracking: // value for 'timeTracking'
 *   },
 * });
 */
export function useSubmitDayMutation(baseOptions?: Apollo.MutationHookOptions<SubmitDayMutation, SubmitDayMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SubmitDayMutation, SubmitDayMutationVariables>(SubmitDayDocument, options);
}
export type SubmitDayMutationHookResult = ReturnType<typeof useSubmitDayMutation>;
export type SubmitDayMutationResult = Apollo.MutationResult<SubmitDayMutation>;
export type SubmitDayMutationOptions = Apollo.BaseMutationOptions<SubmitDayMutation, SubmitDayMutationVariables>;
export const UpdateTimeTrackingDocument = gql`
    mutation UpdateTimeTracking($id: String!, $user: String!, $date: Date!, $hours: Float!, $case: String!, $drivingSlip: String!, $remark: String!, $jobTaskNo: String!, $jobTaskName: String, $workTypeCode: String!, $timeTrackingStatus: TimeTrackingStatus!, $pieceworkAmount: Float, $paymentSupplementCode: String, $paymentSupplementName: String, $supplementType: String, $supplementUom: String, $addonLines: [TimeTrackingInputType!]) {
  updateTimeTracking(
    id: $id
    user: $user
    date: $date
    hours: $hours
    case: $case
    drivingSlip: $drivingSlip
    remark: $remark
    jobTaskNo: $jobTaskNo
    jobTaskName: $jobTaskName
    workTypeCode: $workTypeCode
    timeTrackingStatus: $timeTrackingStatus
    pieceworkAmount: $pieceworkAmount
    paymentSupplementCode: $paymentSupplementCode
    paymentSupplementName: $paymentSupplementName
    supplementType: $supplementType
    supplementUom: $supplementUom
    addonLines: $addonLines
  ) {
    ...BaseTimeTrackingFragment
  }
}
    ${BaseTimeTrackingFragmentFragmentDoc}`;
export type UpdateTimeTrackingMutationFn = Apollo.MutationFunction<UpdateTimeTrackingMutation, UpdateTimeTrackingMutationVariables>;

/**
 * __useUpdateTimeTrackingMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTrackingMutation, { data, loading, error }] = useUpdateTimeTrackingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *      date: // value for 'date'
 *      hours: // value for 'hours'
 *      case: // value for 'case'
 *      drivingSlip: // value for 'drivingSlip'
 *      remark: // value for 'remark'
 *      jobTaskNo: // value for 'jobTaskNo'
 *      jobTaskName: // value for 'jobTaskName'
 *      workTypeCode: // value for 'workTypeCode'
 *      timeTrackingStatus: // value for 'timeTrackingStatus'
 *      pieceworkAmount: // value for 'pieceworkAmount'
 *      paymentSupplementCode: // value for 'paymentSupplementCode'
 *      paymentSupplementName: // value for 'paymentSupplementName'
 *      supplementType: // value for 'supplementType'
 *      supplementUom: // value for 'supplementUom'
 *      addonLines: // value for 'addonLines'
 *   },
 * });
 */
export function useUpdateTimeTrackingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeTrackingMutation, UpdateTimeTrackingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTimeTrackingMutation, UpdateTimeTrackingMutationVariables>(UpdateTimeTrackingDocument, options);
}
export type UpdateTimeTrackingMutationHookResult = ReturnType<typeof useUpdateTimeTrackingMutation>;
export type UpdateTimeTrackingMutationResult = Apollo.MutationResult<UpdateTimeTrackingMutation>;
export type UpdateTimeTrackingMutationOptions = Apollo.BaseMutationOptions<UpdateTimeTrackingMutation, UpdateTimeTrackingMutationVariables>;
export const UserBasisTimeDocument = gql`
    query UserBasisTime($user: String!, $date: Date!) {
  userBasisTime(user: $user, date: $date)
}
    `;

/**
 * __useUserBasisTimeQuery__
 *
 * To run a query within a React component, call `useUserBasisTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBasisTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBasisTimeQuery({
 *   variables: {
 *      user: // value for 'user'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUserBasisTimeQuery(baseOptions: Apollo.QueryHookOptions<UserBasisTimeQuery, UserBasisTimeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserBasisTimeQuery, UserBasisTimeQueryVariables>(UserBasisTimeDocument, options);
}
export function useUserBasisTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBasisTimeQuery, UserBasisTimeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserBasisTimeQuery, UserBasisTimeQueryVariables>(UserBasisTimeDocument, options);
}
export function useUserBasisTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserBasisTimeQuery, UserBasisTimeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserBasisTimeQuery, UserBasisTimeQueryVariables>(UserBasisTimeDocument, options);
}
export type UserBasisTimeQueryHookResult = ReturnType<typeof useUserBasisTimeQuery>;
export type UserBasisTimeLazyQueryHookResult = ReturnType<typeof useUserBasisTimeLazyQuery>;
export type UserBasisTimeSuspenseQueryHookResult = ReturnType<typeof useUserBasisTimeSuspenseQuery>;
export type UserBasisTimeQueryResult = Apollo.QueryResult<UserBasisTimeQuery, UserBasisTimeQueryVariables>;
export function refetchUserBasisTimeQuery(variables: UserBasisTimeQueryVariables) {
  return { query: UserBasisTimeDocument, variables: variables }
}
export const GetMobileV2CurrentUserDocument = gql`
    query GetMobileV2CurrentUser {
  currentUser {
    ...BaseUserFragment
    permissions
    employeeHireStartDate
    employeeSalaryType
    managerFor
  }
}
    ${BaseUserFragmentFragmentDoc}`;

/**
 * __useGetMobileV2CurrentUserQuery__
 *
 * To run a query within a React component, call `useGetMobileV2CurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileV2CurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileV2CurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMobileV2CurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileV2CurrentUserQuery, GetMobileV2CurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMobileV2CurrentUserQuery, GetMobileV2CurrentUserQueryVariables>(GetMobileV2CurrentUserDocument, options);
}
export function useGetMobileV2CurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileV2CurrentUserQuery, GetMobileV2CurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMobileV2CurrentUserQuery, GetMobileV2CurrentUserQueryVariables>(GetMobileV2CurrentUserDocument, options);
}
export function useGetMobileV2CurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileV2CurrentUserQuery, GetMobileV2CurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMobileV2CurrentUserQuery, GetMobileV2CurrentUserQueryVariables>(GetMobileV2CurrentUserDocument, options);
}
export type GetMobileV2CurrentUserQueryHookResult = ReturnType<typeof useGetMobileV2CurrentUserQuery>;
export type GetMobileV2CurrentUserLazyQueryHookResult = ReturnType<typeof useGetMobileV2CurrentUserLazyQuery>;
export type GetMobileV2CurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetMobileV2CurrentUserSuspenseQuery>;
export type GetMobileV2CurrentUserQueryResult = Apollo.QueryResult<GetMobileV2CurrentUserQuery, GetMobileV2CurrentUserQueryVariables>;
export function refetchGetMobileV2CurrentUserQuery(variables?: GetMobileV2CurrentUserQueryVariables) {
  return { query: GetMobileV2CurrentUserDocument, variables: variables }
}
export const SearchMobileV2UsersDocument = gql`
    query SearchMobileV2Users($searchText: String!, $onlyEmployees: Boolean, $checkInBc: Boolean) {
  searchUsers(
    searchText: $searchText
    onlyEmployees: $onlyEmployees
    checkInBc: $checkInBc
  ) {
    ...BaseUserFragment
    employeeHireStartDate
    employeeSalaryType
  }
}
    ${BaseUserFragmentFragmentDoc}`;

/**
 * __useSearchMobileV2UsersQuery__
 *
 * To run a query within a React component, call `useSearchMobileV2UsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMobileV2UsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMobileV2UsersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      onlyEmployees: // value for 'onlyEmployees'
 *      checkInBc: // value for 'checkInBc'
 *   },
 * });
 */
export function useSearchMobileV2UsersQuery(baseOptions: Apollo.QueryHookOptions<SearchMobileV2UsersQuery, SearchMobileV2UsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchMobileV2UsersQuery, SearchMobileV2UsersQueryVariables>(SearchMobileV2UsersDocument, options);
}
export function useSearchMobileV2UsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMobileV2UsersQuery, SearchMobileV2UsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchMobileV2UsersQuery, SearchMobileV2UsersQueryVariables>(SearchMobileV2UsersDocument, options);
}
export function useSearchMobileV2UsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMobileV2UsersQuery, SearchMobileV2UsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchMobileV2UsersQuery, SearchMobileV2UsersQueryVariables>(SearchMobileV2UsersDocument, options);
}
export type SearchMobileV2UsersQueryHookResult = ReturnType<typeof useSearchMobileV2UsersQuery>;
export type SearchMobileV2UsersLazyQueryHookResult = ReturnType<typeof useSearchMobileV2UsersLazyQuery>;
export type SearchMobileV2UsersSuspenseQueryHookResult = ReturnType<typeof useSearchMobileV2UsersSuspenseQuery>;
export type SearchMobileV2UsersQueryResult = Apollo.QueryResult<SearchMobileV2UsersQuery, SearchMobileV2UsersQueryVariables>;
export function refetchSearchMobileV2UsersQuery(variables: SearchMobileV2UsersQueryVariables) {
  return { query: SearchMobileV2UsersDocument, variables: variables }
}
export const ActiveUsersOnCaseDocument = gql`
    query ActiveUsersOnCase($caseId: String!) {
  activeUsersOnCase(caseId: $caseId) {
    name
    email
  }
}
    `;

/**
 * __useActiveUsersOnCaseQuery__
 *
 * To run a query within a React component, call `useActiveUsersOnCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveUsersOnCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveUsersOnCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useActiveUsersOnCaseQuery(baseOptions: Apollo.QueryHookOptions<ActiveUsersOnCaseQuery, ActiveUsersOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ActiveUsersOnCaseQuery, ActiveUsersOnCaseQueryVariables>(ActiveUsersOnCaseDocument, options);
}
export function useActiveUsersOnCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveUsersOnCaseQuery, ActiveUsersOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ActiveUsersOnCaseQuery, ActiveUsersOnCaseQueryVariables>(ActiveUsersOnCaseDocument, options);
}
export function useActiveUsersOnCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveUsersOnCaseQuery, ActiveUsersOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ActiveUsersOnCaseQuery, ActiveUsersOnCaseQueryVariables>(ActiveUsersOnCaseDocument, options);
}
export type ActiveUsersOnCaseQueryHookResult = ReturnType<typeof useActiveUsersOnCaseQuery>;
export type ActiveUsersOnCaseLazyQueryHookResult = ReturnType<typeof useActiveUsersOnCaseLazyQuery>;
export type ActiveUsersOnCaseSuspenseQueryHookResult = ReturnType<typeof useActiveUsersOnCaseSuspenseQuery>;
export type ActiveUsersOnCaseQueryResult = Apollo.QueryResult<ActiveUsersOnCaseQuery, ActiveUsersOnCaseQueryVariables>;
export function refetchActiveUsersOnCaseQuery(variables: ActiveUsersOnCaseQueryVariables) {
  return { query: ActiveUsersOnCaseDocument, variables: variables }
}
export const CloseCasesDocument = gql`
    mutation CloseCases($erpNos: [String!]!) {
  closeCases(erpNos: $erpNos) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type CloseCasesMutationFn = Apollo.MutationFunction<CloseCasesMutation, CloseCasesMutationVariables>;

/**
 * __useCloseCasesMutation__
 *
 * To run a mutation, you first call `useCloseCasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseCasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeCasesMutation, { data, loading, error }] = useCloseCasesMutation({
 *   variables: {
 *      erpNos: // value for 'erpNos'
 *   },
 * });
 */
export function useCloseCasesMutation(baseOptions?: Apollo.MutationHookOptions<CloseCasesMutation, CloseCasesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CloseCasesMutation, CloseCasesMutationVariables>(CloseCasesDocument, options);
}
export type CloseCasesMutationHookResult = ReturnType<typeof useCloseCasesMutation>;
export type CloseCasesMutationResult = Apollo.MutationResult<CloseCasesMutation>;
export type CloseCasesMutationOptions = Apollo.BaseMutationOptions<CloseCasesMutation, CloseCasesMutationVariables>;
export const CreateCaseDocument = gql`
    mutation CreateCase($case: CaseInput!, $drivingSlip: DrivingSlipHelperInput, $saveInScalePoint: Boolean!, $migrationInput: CaseMigration) {
  createCase(
    case: $case
    drivingSlip: $drivingSlip
    saveInScalePoint: $saveInScalePoint
    migrationInput: $migrationInput
  ) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type CreateCaseMutationFn = Apollo.MutationFunction<CreateCaseMutation, CreateCaseMutationVariables>;

/**
 * __useCreateCaseMutation__
 *
 * To run a mutation, you first call `useCreateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseMutation, { data, loading, error }] = useCreateCaseMutation({
 *   variables: {
 *      case: // value for 'case'
 *      drivingSlip: // value for 'drivingSlip'
 *      saveInScalePoint: // value for 'saveInScalePoint'
 *      migrationInput: // value for 'migrationInput'
 *   },
 * });
 */
export function useCreateCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseMutation, CreateCaseMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCaseMutation, CreateCaseMutationVariables>(CreateCaseDocument, options);
}
export type CreateCaseMutationHookResult = ReturnType<typeof useCreateCaseMutation>;
export type CreateCaseMutationResult = Apollo.MutationResult<CreateCaseMutation>;
export type CreateCaseMutationOptions = Apollo.BaseMutationOptions<CreateCaseMutation, CreateCaseMutationVariables>;
export const CreateCaseAgreementDocument = gql`
    mutation CreateCaseAgreement($id: String!, $caseAgreement: CaseAgreementInput!) {
  createCaseAgreement(id: $id, caseAgreement: $caseAgreement) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type CreateCaseAgreementMutationFn = Apollo.MutationFunction<CreateCaseAgreementMutation, CreateCaseAgreementMutationVariables>;

/**
 * __useCreateCaseAgreementMutation__
 *
 * To run a mutation, you first call `useCreateCaseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseAgreementMutation, { data, loading, error }] = useCreateCaseAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      caseAgreement: // value for 'caseAgreement'
 *   },
 * });
 */
export function useCreateCaseAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseAgreementMutation, CreateCaseAgreementMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCaseAgreementMutation, CreateCaseAgreementMutationVariables>(CreateCaseAgreementDocument, options);
}
export type CreateCaseAgreementMutationHookResult = ReturnType<typeof useCreateCaseAgreementMutation>;
export type CreateCaseAgreementMutationResult = Apollo.MutationResult<CreateCaseAgreementMutation>;
export type CreateCaseAgreementMutationOptions = Apollo.BaseMutationOptions<CreateCaseAgreementMutation, CreateCaseAgreementMutationVariables>;
export const FavoriteCaseDocument = gql`
    mutation FavoriteCase($id: String!, $color: String, $active: Boolean!) {
  favoriteCase(id: $id, color: $color, active: $active) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type FavoriteCaseMutationFn = Apollo.MutationFunction<FavoriteCaseMutation, FavoriteCaseMutationVariables>;

/**
 * __useFavoriteCaseMutation__
 *
 * To run a mutation, you first call `useFavoriteCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavoriteCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favoriteCaseMutation, { data, loading, error }] = useFavoriteCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      color: // value for 'color'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFavoriteCaseMutation(baseOptions?: Apollo.MutationHookOptions<FavoriteCaseMutation, FavoriteCaseMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<FavoriteCaseMutation, FavoriteCaseMutationVariables>(FavoriteCaseDocument, options);
}
export type FavoriteCaseMutationHookResult = ReturnType<typeof useFavoriteCaseMutation>;
export type FavoriteCaseMutationResult = Apollo.MutationResult<FavoriteCaseMutation>;
export type FavoriteCaseMutationOptions = Apollo.BaseMutationOptions<FavoriteCaseMutation, FavoriteCaseMutationVariables>;
export const GetCaseAdminDataPlannerDocument = gql`
    query GetCaseAdminDataPlanner {
  damageCategories {
    ...BaseDamageCategoryFragment
  }
  damageCauses {
    ...BaseDamageCauseFragment
  }
  departments {
    ...BaseDepartmentFragment
  }
  locations {
    ...BaseLocationFragment
    attachedPostalCodesInputString
    attachedPostalCodes
  }
  usersWithCalendars {
    ...BaseUserFragment
    plannerHelpText
    plannerHelpTextUpdatedAt
  }
  drivingSlipCategories {
    code
    name
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}`;

/**
 * __useGetCaseAdminDataPlannerQuery__
 *
 * To run a query within a React component, call `useGetCaseAdminDataPlannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseAdminDataPlannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseAdminDataPlannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCaseAdminDataPlannerQuery(baseOptions?: Apollo.QueryHookOptions<GetCaseAdminDataPlannerQuery, GetCaseAdminDataPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseAdminDataPlannerQuery, GetCaseAdminDataPlannerQueryVariables>(GetCaseAdminDataPlannerDocument, options);
}
export function useGetCaseAdminDataPlannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseAdminDataPlannerQuery, GetCaseAdminDataPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseAdminDataPlannerQuery, GetCaseAdminDataPlannerQueryVariables>(GetCaseAdminDataPlannerDocument, options);
}
export function useGetCaseAdminDataPlannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseAdminDataPlannerQuery, GetCaseAdminDataPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseAdminDataPlannerQuery, GetCaseAdminDataPlannerQueryVariables>(GetCaseAdminDataPlannerDocument, options);
}
export type GetCaseAdminDataPlannerQueryHookResult = ReturnType<typeof useGetCaseAdminDataPlannerQuery>;
export type GetCaseAdminDataPlannerLazyQueryHookResult = ReturnType<typeof useGetCaseAdminDataPlannerLazyQuery>;
export type GetCaseAdminDataPlannerSuspenseQueryHookResult = ReturnType<typeof useGetCaseAdminDataPlannerSuspenseQuery>;
export type GetCaseAdminDataPlannerQueryResult = Apollo.QueryResult<GetCaseAdminDataPlannerQuery, GetCaseAdminDataPlannerQueryVariables>;
export function refetchGetCaseAdminDataPlannerQuery(variables?: GetCaseAdminDataPlannerQueryVariables) {
  return { query: GetCaseAdminDataPlannerDocument, variables: variables }
}
export const CaseEconomicsOverviewDocument = gql`
    query CaseEconomicsOverview($caseERPReferenceNo: String!) {
  caseEconomicsOverview(caseERPReferenceNo: $caseERPReferenceNo) {
    jobNo
    costTotal
    salesTotal
    invoicedTotal
    quote
    screening
    profit
    deltaNotInvoiced
    coverageRatio
    totalContractAmountLCY
    wipLimit
    costEstimate
    percentageOfCompletion
  }
}
    `;

/**
 * __useCaseEconomicsOverviewQuery__
 *
 * To run a query within a React component, call `useCaseEconomicsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseEconomicsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseEconomicsOverviewQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useCaseEconomicsOverviewQuery(baseOptions: Apollo.QueryHookOptions<CaseEconomicsOverviewQuery, CaseEconomicsOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CaseEconomicsOverviewQuery, CaseEconomicsOverviewQueryVariables>(CaseEconomicsOverviewDocument, options);
}
export function useCaseEconomicsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseEconomicsOverviewQuery, CaseEconomicsOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CaseEconomicsOverviewQuery, CaseEconomicsOverviewQueryVariables>(CaseEconomicsOverviewDocument, options);
}
export function useCaseEconomicsOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaseEconomicsOverviewQuery, CaseEconomicsOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CaseEconomicsOverviewQuery, CaseEconomicsOverviewQueryVariables>(CaseEconomicsOverviewDocument, options);
}
export type CaseEconomicsOverviewQueryHookResult = ReturnType<typeof useCaseEconomicsOverviewQuery>;
export type CaseEconomicsOverviewLazyQueryHookResult = ReturnType<typeof useCaseEconomicsOverviewLazyQuery>;
export type CaseEconomicsOverviewSuspenseQueryHookResult = ReturnType<typeof useCaseEconomicsOverviewSuspenseQuery>;
export type CaseEconomicsOverviewQueryResult = Apollo.QueryResult<CaseEconomicsOverviewQuery, CaseEconomicsOverviewQueryVariables>;
export function refetchCaseEconomicsOverviewQuery(variables: CaseEconomicsOverviewQueryVariables) {
  return { query: CaseEconomicsOverviewDocument, variables: variables }
}
export const CaseEconomicsOverviewNewDocument = gql`
    query CaseEconomicsOverviewNew($caseERPReferenceNo: String!) {
  caseEconomicsOverviewNew(caseERPReferenceNo: $caseERPReferenceNo) {
    jobNo
    quote
    screening
    percentageOfCompletion
    wipLimit
    getHoursAvailable
    getHoursUsed
    costEstimate
  }
}
    `;

/**
 * __useCaseEconomicsOverviewNewQuery__
 *
 * To run a query within a React component, call `useCaseEconomicsOverviewNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseEconomicsOverviewNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseEconomicsOverviewNewQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useCaseEconomicsOverviewNewQuery(baseOptions: Apollo.QueryHookOptions<CaseEconomicsOverviewNewQuery, CaseEconomicsOverviewNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CaseEconomicsOverviewNewQuery, CaseEconomicsOverviewNewQueryVariables>(CaseEconomicsOverviewNewDocument, options);
}
export function useCaseEconomicsOverviewNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseEconomicsOverviewNewQuery, CaseEconomicsOverviewNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CaseEconomicsOverviewNewQuery, CaseEconomicsOverviewNewQueryVariables>(CaseEconomicsOverviewNewDocument, options);
}
export function useCaseEconomicsOverviewNewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaseEconomicsOverviewNewQuery, CaseEconomicsOverviewNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CaseEconomicsOverviewNewQuery, CaseEconomicsOverviewNewQueryVariables>(CaseEconomicsOverviewNewDocument, options);
}
export type CaseEconomicsOverviewNewQueryHookResult = ReturnType<typeof useCaseEconomicsOverviewNewQuery>;
export type CaseEconomicsOverviewNewLazyQueryHookResult = ReturnType<typeof useCaseEconomicsOverviewNewLazyQuery>;
export type CaseEconomicsOverviewNewSuspenseQueryHookResult = ReturnType<typeof useCaseEconomicsOverviewNewSuspenseQuery>;
export type CaseEconomicsOverviewNewQueryResult = Apollo.QueryResult<CaseEconomicsOverviewNewQuery, CaseEconomicsOverviewNewQueryVariables>;
export function refetchCaseEconomicsOverviewNewQuery(variables: CaseEconomicsOverviewNewQueryVariables) {
  return { query: CaseEconomicsOverviewNewDocument, variables: variables }
}
export const GetCaseEconomySpecDocument = gql`
    query GetCaseEconomySpec($erpReferenceId: String!) {
  caseEconomicsSpec(erpReferenceId: $erpReferenceId) {
    cost {
      name
      value
    }
    sale {
      name
      value
    }
  }
}
    `;

/**
 * __useGetCaseEconomySpecQuery__
 *
 * To run a query within a React component, call `useGetCaseEconomySpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseEconomySpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseEconomySpecQuery({
 *   variables: {
 *      erpReferenceId: // value for 'erpReferenceId'
 *   },
 * });
 */
export function useGetCaseEconomySpecQuery(baseOptions: Apollo.QueryHookOptions<GetCaseEconomySpecQuery, GetCaseEconomySpecQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseEconomySpecQuery, GetCaseEconomySpecQueryVariables>(GetCaseEconomySpecDocument, options);
}
export function useGetCaseEconomySpecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseEconomySpecQuery, GetCaseEconomySpecQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseEconomySpecQuery, GetCaseEconomySpecQueryVariables>(GetCaseEconomySpecDocument, options);
}
export function useGetCaseEconomySpecSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseEconomySpecQuery, GetCaseEconomySpecQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseEconomySpecQuery, GetCaseEconomySpecQueryVariables>(GetCaseEconomySpecDocument, options);
}
export type GetCaseEconomySpecQueryHookResult = ReturnType<typeof useGetCaseEconomySpecQuery>;
export type GetCaseEconomySpecLazyQueryHookResult = ReturnType<typeof useGetCaseEconomySpecLazyQuery>;
export type GetCaseEconomySpecSuspenseQueryHookResult = ReturnType<typeof useGetCaseEconomySpecSuspenseQuery>;
export type GetCaseEconomySpecQueryResult = Apollo.QueryResult<GetCaseEconomySpecQuery, GetCaseEconomySpecQueryVariables>;
export function refetchGetCaseEconomySpecQuery(variables: GetCaseEconomySpecQueryVariables) {
  return { query: GetCaseEconomySpecDocument, variables: variables }
}
export const GetCaseForMovableDocument = gql`
    query GetCaseForMovable($id: String!) {
  case(id: $id) {
    id
    status
    erpNo
  }
}
    `;

/**
 * __useGetCaseForMovableQuery__
 *
 * To run a query within a React component, call `useGetCaseForMovableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseForMovableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseForMovableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseForMovableQuery(baseOptions: Apollo.QueryHookOptions<GetCaseForMovableQuery, GetCaseForMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseForMovableQuery, GetCaseForMovableQueryVariables>(GetCaseForMovableDocument, options);
}
export function useGetCaseForMovableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseForMovableQuery, GetCaseForMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseForMovableQuery, GetCaseForMovableQueryVariables>(GetCaseForMovableDocument, options);
}
export function useGetCaseForMovableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseForMovableQuery, GetCaseForMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseForMovableQuery, GetCaseForMovableQueryVariables>(GetCaseForMovableDocument, options);
}
export type GetCaseForMovableQueryHookResult = ReturnType<typeof useGetCaseForMovableQuery>;
export type GetCaseForMovableLazyQueryHookResult = ReturnType<typeof useGetCaseForMovableLazyQuery>;
export type GetCaseForMovableSuspenseQueryHookResult = ReturnType<typeof useGetCaseForMovableSuspenseQuery>;
export type GetCaseForMovableQueryResult = Apollo.QueryResult<GetCaseForMovableQuery, GetCaseForMovableQueryVariables>;
export function refetchGetCaseForMovableQuery(variables: GetCaseForMovableQueryVariables) {
  return { query: GetCaseForMovableDocument, variables: variables }
}
export const GetCaseForPrintDocument = gql`
    query GetCaseForPrint($id: String!) {
  case(id: $id) {
    id
    erpNo
    debitor {
      debitorId
      company
    }
  }
}
    `;

/**
 * __useGetCaseForPrintQuery__
 *
 * To run a query within a React component, call `useGetCaseForPrintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseForPrintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseForPrintQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseForPrintQuery(baseOptions: Apollo.QueryHookOptions<GetCaseForPrintQuery, GetCaseForPrintQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseForPrintQuery, GetCaseForPrintQueryVariables>(GetCaseForPrintDocument, options);
}
export function useGetCaseForPrintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseForPrintQuery, GetCaseForPrintQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseForPrintQuery, GetCaseForPrintQueryVariables>(GetCaseForPrintDocument, options);
}
export function useGetCaseForPrintSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseForPrintQuery, GetCaseForPrintQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseForPrintQuery, GetCaseForPrintQueryVariables>(GetCaseForPrintDocument, options);
}
export type GetCaseForPrintQueryHookResult = ReturnType<typeof useGetCaseForPrintQuery>;
export type GetCaseForPrintLazyQueryHookResult = ReturnType<typeof useGetCaseForPrintLazyQuery>;
export type GetCaseForPrintSuspenseQueryHookResult = ReturnType<typeof useGetCaseForPrintSuspenseQuery>;
export type GetCaseForPrintQueryResult = Apollo.QueryResult<GetCaseForPrintQuery, GetCaseForPrintQueryVariables>;
export function refetchGetCaseForPrintQuery(variables: GetCaseForPrintQueryVariables) {
  return { query: GetCaseForPrintDocument, variables: variables }
}
export const GetCaseMovablesDocument = gql`
    query GetCaseMovables($id: String!) {
  case(id: $id) {
    id
    movables {
      id
      description
      status
      placement {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCaseMovablesQuery__
 *
 * To run a query within a React component, call `useGetCaseMovablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseMovablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseMovablesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseMovablesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseMovablesQuery, GetCaseMovablesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseMovablesQuery, GetCaseMovablesQueryVariables>(GetCaseMovablesDocument, options);
}
export function useGetCaseMovablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseMovablesQuery, GetCaseMovablesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseMovablesQuery, GetCaseMovablesQueryVariables>(GetCaseMovablesDocument, options);
}
export function useGetCaseMovablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseMovablesQuery, GetCaseMovablesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseMovablesQuery, GetCaseMovablesQueryVariables>(GetCaseMovablesDocument, options);
}
export type GetCaseMovablesQueryHookResult = ReturnType<typeof useGetCaseMovablesQuery>;
export type GetCaseMovablesLazyQueryHookResult = ReturnType<typeof useGetCaseMovablesLazyQuery>;
export type GetCaseMovablesSuspenseQueryHookResult = ReturnType<typeof useGetCaseMovablesSuspenseQuery>;
export type GetCaseMovablesQueryResult = Apollo.QueryResult<GetCaseMovablesQuery, GetCaseMovablesQueryVariables>;
export function refetchGetCaseMovablesQuery(variables: GetCaseMovablesQueryVariables) {
  return { query: GetCaseMovablesDocument, variables: variables }
}
export const GetCaseUsageDocument = gql`
    query GetCaseUsage($erpNo: String!) {
  caseUsage(erpNo: $erpNo) {
    subcontracts {
      ...CaseUsageFragment
    }
    items {
      ...CaseUsageFragment
    }
    machines {
      ...CaseUsageFragment
    }
    movables {
      ...CaseUsageFragment
    }
    persons {
      ...CaseUsageFragment
    }
    trash {
      ...CaseUsageFragment
    }
    driving {
      ...CaseUsageFragment
    }
    substitute {
      ...CaseUsageFragment
    }
    vehicleExpenses {
      ...CaseUsageFragment
    }
  }
}
    ${CaseUsageFragmentFragmentDoc}`;

/**
 * __useGetCaseUsageQuery__
 *
 * To run a query within a React component, call `useGetCaseUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseUsageQuery({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *   },
 * });
 */
export function useGetCaseUsageQuery(baseOptions: Apollo.QueryHookOptions<GetCaseUsageQuery, GetCaseUsageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseUsageQuery, GetCaseUsageQueryVariables>(GetCaseUsageDocument, options);
}
export function useGetCaseUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseUsageQuery, GetCaseUsageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseUsageQuery, GetCaseUsageQueryVariables>(GetCaseUsageDocument, options);
}
export function useGetCaseUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseUsageQuery, GetCaseUsageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseUsageQuery, GetCaseUsageQueryVariables>(GetCaseUsageDocument, options);
}
export type GetCaseUsageQueryHookResult = ReturnType<typeof useGetCaseUsageQuery>;
export type GetCaseUsageLazyQueryHookResult = ReturnType<typeof useGetCaseUsageLazyQuery>;
export type GetCaseUsageSuspenseQueryHookResult = ReturnType<typeof useGetCaseUsageSuspenseQuery>;
export type GetCaseUsageQueryResult = Apollo.QueryResult<GetCaseUsageQuery, GetCaseUsageQueryVariables>;
export function refetchGetCaseUsageQuery(variables: GetCaseUsageQueryVariables) {
  return { query: GetCaseUsageDocument, variables: variables }
}
export const GetCaseUsageExcelOverviewDocument = gql`
    query GetCaseUsageExcelOverview($erpNo: String!) {
  caseUsageExcelOverview(erpNo: $erpNo)
}
    `;

/**
 * __useGetCaseUsageExcelOverviewQuery__
 *
 * To run a query within a React component, call `useGetCaseUsageExcelOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseUsageExcelOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseUsageExcelOverviewQuery({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *   },
 * });
 */
export function useGetCaseUsageExcelOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetCaseUsageExcelOverviewQuery, GetCaseUsageExcelOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseUsageExcelOverviewQuery, GetCaseUsageExcelOverviewQueryVariables>(GetCaseUsageExcelOverviewDocument, options);
}
export function useGetCaseUsageExcelOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseUsageExcelOverviewQuery, GetCaseUsageExcelOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseUsageExcelOverviewQuery, GetCaseUsageExcelOverviewQueryVariables>(GetCaseUsageExcelOverviewDocument, options);
}
export function useGetCaseUsageExcelOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseUsageExcelOverviewQuery, GetCaseUsageExcelOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseUsageExcelOverviewQuery, GetCaseUsageExcelOverviewQueryVariables>(GetCaseUsageExcelOverviewDocument, options);
}
export type GetCaseUsageExcelOverviewQueryHookResult = ReturnType<typeof useGetCaseUsageExcelOverviewQuery>;
export type GetCaseUsageExcelOverviewLazyQueryHookResult = ReturnType<typeof useGetCaseUsageExcelOverviewLazyQuery>;
export type GetCaseUsageExcelOverviewSuspenseQueryHookResult = ReturnType<typeof useGetCaseUsageExcelOverviewSuspenseQuery>;
export type GetCaseUsageExcelOverviewQueryResult = Apollo.QueryResult<GetCaseUsageExcelOverviewQuery, GetCaseUsageExcelOverviewQueryVariables>;
export function refetchGetCaseUsageExcelOverviewQuery(variables: GetCaseUsageExcelOverviewQueryVariables) {
  return { query: GetCaseUsageExcelOverviewDocument, variables: variables }
}
export const GetCasesForExportDocument = gql`
    query GetCasesForExport($address: AddressInput, $awaiting: Boolean, $damageServiceCompleted: Boolean, $calledBack: Boolean, $machinesOnCase: Boolean, $ownCases: Boolean, $favoriteCases: Boolean, $appliedClosed: Boolean, $closedCases: Boolean, $debitor: [String!], $postalCode: [String!], $track: [Int!], $department: [String!], $location: [String!], $damageCategory: [String!], $damageCause: [String!], $priority: [CasePriority!], $caseManager: [String!], $projectManager: [String!], $createdBy: [String!], $areaResponsible: [String!], $anyManager: String, $minDate: Date, $maxDate: Date, $erpReferenceNo: String, $erpReferenceNos: [String!], $favoriteColors: [String!], $includeEconomy: Boolean!, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  cases(
    address: $address
    awaiting: $awaiting
    damageServiceCompleted: $damageServiceCompleted
    calledBack: $calledBack
    machinesOnCase: $machinesOnCase
    ownCases: $ownCases
    favoriteCases: $favoriteCases
    appliedClosed: $appliedClosed
    closedCases: $closedCases
    debitor: $debitor
    postalCode: $postalCode
    track: $track
    department: $department
    location: $location
    damageCategory: $damageCategory
    damageCause: $damageCause
    priority: $priority
    caseManager: $caseManager
    projectManager: $projectManager
    createdBy: $createdBy
    areaResponsible: $areaResponsible
    anyManager: $anyManager
    minDate: $minDate
    maxDate: $maxDate
    erpReferenceNo: $erpReferenceNo
    erpReferenceNos: $erpReferenceNos
    favoriteColors: $favoriteColors
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    id
    status
    erpNo
    track
    debitor {
      company
      policeNumber
    }
    damage {
      businessArea {
        name
      }
      category {
        name
      }
      cause {
        name
      }
      contact {
        name
        phone
        email
        address {
          ...AddressFragment
        }
      }
    }
    projectManager {
      ...BaseUserFragment
    }
    caseManager {
      ...BaseUserFragment
    }
    areaResponsible {
      ...BaseUserFragment
    }
    ssgLocation {
      name
    }
    ssgDepartment {
      name
      departmentNumber
    }
    createdBy {
      ...BaseUserFragment
    }
    createdAt
    skafor
    visitation {
      priorities
    }
    caseEconomics(include: $includeEconomy) {
      salesTotal
      invoicedTotal
    }
    arrived
    arrivedDate
    visitation {
      calledBack {
        value
        comment
      }
      isMoistureReportRequired
      isSpPhaseOneReportCreated
      awaiting {
        value
        comment
      }
    }
    drivingSlipSeries {
      id
      drivingSlips {
        id
        createdAt
        status
        start
        driver {
          ...BaseUserFragment
        }
      }
    }
    activeRequisitions
    caseReports {
      inspectionReportFormData {
        __typename
      }
      indoorClimateReportFormData {
        __typename
      }
      moistureReportFormData {
        __typename
      }
      moistureTrygReportFormData {
        __typename
      }
    }
  }
}
    ${AddressFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}`;

/**
 * __useGetCasesForExportQuery__
 *
 * To run a query within a React component, call `useGetCasesForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesForExportQuery({
 *   variables: {
 *      address: // value for 'address'
 *      awaiting: // value for 'awaiting'
 *      damageServiceCompleted: // value for 'damageServiceCompleted'
 *      calledBack: // value for 'calledBack'
 *      machinesOnCase: // value for 'machinesOnCase'
 *      ownCases: // value for 'ownCases'
 *      favoriteCases: // value for 'favoriteCases'
 *      appliedClosed: // value for 'appliedClosed'
 *      closedCases: // value for 'closedCases'
 *      debitor: // value for 'debitor'
 *      postalCode: // value for 'postalCode'
 *      track: // value for 'track'
 *      department: // value for 'department'
 *      location: // value for 'location'
 *      damageCategory: // value for 'damageCategory'
 *      damageCause: // value for 'damageCause'
 *      priority: // value for 'priority'
 *      caseManager: // value for 'caseManager'
 *      projectManager: // value for 'projectManager'
 *      createdBy: // value for 'createdBy'
 *      areaResponsible: // value for 'areaResponsible'
 *      anyManager: // value for 'anyManager'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *      erpReferenceNos: // value for 'erpReferenceNos'
 *      favoriteColors: // value for 'favoriteColors'
 *      includeEconomy: // value for 'includeEconomy'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetCasesForExportQuery(baseOptions: Apollo.QueryHookOptions<GetCasesForExportQuery, GetCasesForExportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCasesForExportQuery, GetCasesForExportQueryVariables>(GetCasesForExportDocument, options);
}
export function useGetCasesForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesForExportQuery, GetCasesForExportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCasesForExportQuery, GetCasesForExportQueryVariables>(GetCasesForExportDocument, options);
}
export function useGetCasesForExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasesForExportQuery, GetCasesForExportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCasesForExportQuery, GetCasesForExportQueryVariables>(GetCasesForExportDocument, options);
}
export type GetCasesForExportQueryHookResult = ReturnType<typeof useGetCasesForExportQuery>;
export type GetCasesForExportLazyQueryHookResult = ReturnType<typeof useGetCasesForExportLazyQuery>;
export type GetCasesForExportSuspenseQueryHookResult = ReturnType<typeof useGetCasesForExportSuspenseQuery>;
export type GetCasesForExportQueryResult = Apollo.QueryResult<GetCasesForExportQuery, GetCasesForExportQueryVariables>;
export function refetchGetCasesForExportQuery(variables: GetCasesForExportQueryVariables) {
  return { query: GetCasesForExportDocument, variables: variables }
}
export const GetCasesWithChangesDocument = gql`
    query GetCasesWithChanges($address: AddressInput, $awaiting: Boolean, $damageServiceCompleted: Boolean, $calledBack: Boolean, $machinesOnCase: Boolean, $ownCases: Boolean, $appliedClosed: Boolean, $closedCases: Boolean, $debitor: [String!], $postalCode: [String!], $track: [Int!], $department: [String!], $location: [String!], $damageCategory: [String!], $damageCause: [String!], $priority: [CasePriority!], $caseManager: [String!], $projectManager: [String!], $anyManager: String, $minDate: Date, $maxDate: Date, $erpReferenceNo: String, $erpReferenceNos: [String!], $includeEconomy: Boolean!, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  cases(
    address: $address
    awaiting: $awaiting
    damageServiceCompleted: $damageServiceCompleted
    calledBack: $calledBack
    machinesOnCase: $machinesOnCase
    ownCases: $ownCases
    appliedClosed: $appliedClosed
    closedCases: $closedCases
    debitor: $debitor
    postalCode: $postalCode
    track: $track
    department: $department
    location: $location
    damageCategory: $damageCategory
    damageCause: $damageCause
    priority: $priority
    caseManager: $caseManager
    projectManager: $projectManager
    anyManager: $anyManager
    minDate: $minDate
    maxDate: $maxDate
    erpReferenceNo: $erpReferenceNo
    erpReferenceNos: $erpReferenceNos
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    ...BaseCaseFragment
    changes {
      after {
        status
      }
      timestamp
      user {
        id
        name
      }
    }
    caseEconomics(include: $includeEconomy) {
      jobNo
      costTotal
      salesTotal
      invoicedTotal
      quote
      screening
      profit
      deltaNotInvoiced
      coverageRatio
    }
  }
}
    ${BaseCaseFragmentFragmentDoc}`;

/**
 * __useGetCasesWithChangesQuery__
 *
 * To run a query within a React component, call `useGetCasesWithChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesWithChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesWithChangesQuery({
 *   variables: {
 *      address: // value for 'address'
 *      awaiting: // value for 'awaiting'
 *      damageServiceCompleted: // value for 'damageServiceCompleted'
 *      calledBack: // value for 'calledBack'
 *      machinesOnCase: // value for 'machinesOnCase'
 *      ownCases: // value for 'ownCases'
 *      appliedClosed: // value for 'appliedClosed'
 *      closedCases: // value for 'closedCases'
 *      debitor: // value for 'debitor'
 *      postalCode: // value for 'postalCode'
 *      track: // value for 'track'
 *      department: // value for 'department'
 *      location: // value for 'location'
 *      damageCategory: // value for 'damageCategory'
 *      damageCause: // value for 'damageCause'
 *      priority: // value for 'priority'
 *      caseManager: // value for 'caseManager'
 *      projectManager: // value for 'projectManager'
 *      anyManager: // value for 'anyManager'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *      erpReferenceNos: // value for 'erpReferenceNos'
 *      includeEconomy: // value for 'includeEconomy'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetCasesWithChangesQuery(baseOptions: Apollo.QueryHookOptions<GetCasesWithChangesQuery, GetCasesWithChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCasesWithChangesQuery, GetCasesWithChangesQueryVariables>(GetCasesWithChangesDocument, options);
}
export function useGetCasesWithChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesWithChangesQuery, GetCasesWithChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCasesWithChangesQuery, GetCasesWithChangesQueryVariables>(GetCasesWithChangesDocument, options);
}
export function useGetCasesWithChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasesWithChangesQuery, GetCasesWithChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCasesWithChangesQuery, GetCasesWithChangesQueryVariables>(GetCasesWithChangesDocument, options);
}
export type GetCasesWithChangesQueryHookResult = ReturnType<typeof useGetCasesWithChangesQuery>;
export type GetCasesWithChangesLazyQueryHookResult = ReturnType<typeof useGetCasesWithChangesLazyQuery>;
export type GetCasesWithChangesSuspenseQueryHookResult = ReturnType<typeof useGetCasesWithChangesSuspenseQuery>;
export type GetCasesWithChangesQueryResult = Apollo.QueryResult<GetCasesWithChangesQuery, GetCasesWithChangesQueryVariables>;
export function refetchGetCasesWithChangesQuery(variables: GetCasesWithChangesQueryVariables) {
  return { query: GetCasesWithChangesDocument, variables: variables }
}
export const GetDamageAdminDataDocument = gql`
    query GetDamageAdminData {
  damageCategories {
    ...BaseDamageCategoryFragment
  }
  damageCauses {
    ...BaseDamageCauseFragment
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}`;

/**
 * __useGetDamageAdminDataQuery__
 *
 * To run a query within a React component, call `useGetDamageAdminDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDamageAdminDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDamageAdminDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDamageAdminDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDamageAdminDataQuery, GetDamageAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDamageAdminDataQuery, GetDamageAdminDataQueryVariables>(GetDamageAdminDataDocument, options);
}
export function useGetDamageAdminDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDamageAdminDataQuery, GetDamageAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDamageAdminDataQuery, GetDamageAdminDataQueryVariables>(GetDamageAdminDataDocument, options);
}
export function useGetDamageAdminDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDamageAdminDataQuery, GetDamageAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDamageAdminDataQuery, GetDamageAdminDataQueryVariables>(GetDamageAdminDataDocument, options);
}
export type GetDamageAdminDataQueryHookResult = ReturnType<typeof useGetDamageAdminDataQuery>;
export type GetDamageAdminDataLazyQueryHookResult = ReturnType<typeof useGetDamageAdminDataLazyQuery>;
export type GetDamageAdminDataSuspenseQueryHookResult = ReturnType<typeof useGetDamageAdminDataSuspenseQuery>;
export type GetDamageAdminDataQueryResult = Apollo.QueryResult<GetDamageAdminDataQuery, GetDamageAdminDataQueryVariables>;
export function refetchGetDamageAdminDataQuery(variables?: GetDamageAdminDataQueryVariables) {
  return { query: GetDamageAdminDataDocument, variables: variables }
}
export const GetDuplicateCasesDocument = gql`
    query GetDuplicateCases($caseId: String!, $address: AddressInput!, $damageCategory: String!, $hasScalepointUrl: Boolean!) {
  duplicateCases(
    caseId: $caseId
    address: $address
    damageCategory: $damageCategory
    hasScalepointUrl: $hasScalepointUrl
  ) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;

/**
 * __useGetDuplicateCasesQuery__
 *
 * To run a query within a React component, call `useGetDuplicateCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateCasesQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      address: // value for 'address'
 *      damageCategory: // value for 'damageCategory'
 *      hasScalepointUrl: // value for 'hasScalepointUrl'
 *   },
 * });
 */
export function useGetDuplicateCasesQuery(baseOptions: Apollo.QueryHookOptions<GetDuplicateCasesQuery, GetDuplicateCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDuplicateCasesQuery, GetDuplicateCasesQueryVariables>(GetDuplicateCasesDocument, options);
}
export function useGetDuplicateCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDuplicateCasesQuery, GetDuplicateCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDuplicateCasesQuery, GetDuplicateCasesQueryVariables>(GetDuplicateCasesDocument, options);
}
export function useGetDuplicateCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDuplicateCasesQuery, GetDuplicateCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDuplicateCasesQuery, GetDuplicateCasesQueryVariables>(GetDuplicateCasesDocument, options);
}
export type GetDuplicateCasesQueryHookResult = ReturnType<typeof useGetDuplicateCasesQuery>;
export type GetDuplicateCasesLazyQueryHookResult = ReturnType<typeof useGetDuplicateCasesLazyQuery>;
export type GetDuplicateCasesSuspenseQueryHookResult = ReturnType<typeof useGetDuplicateCasesSuspenseQuery>;
export type GetDuplicateCasesQueryResult = Apollo.QueryResult<GetDuplicateCasesQuery, GetDuplicateCasesQueryVariables>;
export function refetchGetDuplicateCasesQuery(variables: GetDuplicateCasesQueryVariables) {
  return { query: GetDuplicateCasesDocument, variables: variables }
}
export const GetJobLedgerEntrySummaryDocument = gql`
    query GetJobLedgerEntrySummary($caseERPReferenceNo: String!) {
  getJobLedgerEntrySummary(caseERPReferenceNo: $caseERPReferenceNo) {
    jobNo
    invoicedAmount {
      actual
      indentation
      bold
    }
    igvaAmount {
      actual
      indentation
      bold
    }
    totalRevenue {
      actual
      expected
      indentation
      bold
    }
    material {
      actual
      indentation
      bold
    }
    personel {
      actual
      indentation
      bold
    }
    substitute {
      actual
      indentation
      bold
    }
    subcontractor {
      actual
      indentation
      bold
    }
    machine {
      actual
      indentation
      bold
    }
    vehicleExpenses {
      actual
      indentation
      bold
    }
    storageCosts {
      actual
      indentation
      bold
    }
    totalCost {
      actual
      expected
      indentation
      bold
    }
    grossProfit {
      actual
      expected
      indentation
      bold
    }
    grossProfitPct {
      actual
      expected
      indentation
      bold
    }
  }
}
    `;

/**
 * __useGetJobLedgerEntrySummaryQuery__
 *
 * To run a query within a React component, call `useGetJobLedgerEntrySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobLedgerEntrySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobLedgerEntrySummaryQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useGetJobLedgerEntrySummaryQuery(baseOptions: Apollo.QueryHookOptions<GetJobLedgerEntrySummaryQuery, GetJobLedgerEntrySummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobLedgerEntrySummaryQuery, GetJobLedgerEntrySummaryQueryVariables>(GetJobLedgerEntrySummaryDocument, options);
}
export function useGetJobLedgerEntrySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobLedgerEntrySummaryQuery, GetJobLedgerEntrySummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobLedgerEntrySummaryQuery, GetJobLedgerEntrySummaryQueryVariables>(GetJobLedgerEntrySummaryDocument, options);
}
export function useGetJobLedgerEntrySummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobLedgerEntrySummaryQuery, GetJobLedgerEntrySummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobLedgerEntrySummaryQuery, GetJobLedgerEntrySummaryQueryVariables>(GetJobLedgerEntrySummaryDocument, options);
}
export type GetJobLedgerEntrySummaryQueryHookResult = ReturnType<typeof useGetJobLedgerEntrySummaryQuery>;
export type GetJobLedgerEntrySummaryLazyQueryHookResult = ReturnType<typeof useGetJobLedgerEntrySummaryLazyQuery>;
export type GetJobLedgerEntrySummarySuspenseQueryHookResult = ReturnType<typeof useGetJobLedgerEntrySummarySuspenseQuery>;
export type GetJobLedgerEntrySummaryQueryResult = Apollo.QueryResult<GetJobLedgerEntrySummaryQuery, GetJobLedgerEntrySummaryQueryVariables>;
export function refetchGetJobLedgerEntrySummaryQuery(variables: GetJobLedgerEntrySummaryQueryVariables) {
  return { query: GetJobLedgerEntrySummaryDocument, variables: variables }
}
export const GetOperationManagerCaseDataDocument = gql`
    query GetOperationManagerCaseData($address: AddressInput, $awaiting: Boolean, $damageServiceCompleted: Boolean, $calledBack: Boolean, $machinesOnCase: Boolean, $ownCases: Boolean, $appliedClosed: Boolean, $closedCases: Boolean, $debitor: [String!], $postalCode: [String!], $track: [Int!], $department: [String!], $location: [String!], $damageCategory: [String!], $damageCause: [String!], $priority: [CasePriority!], $caseManager: [String!], $projectManager: [String!], $anyManager: String, $minDate: Date, $maxDate: Date, $erpReferenceNo: String, $erpReferenceNos: [String!], $includeEconomy: Boolean!, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  cases(
    address: $address
    awaiting: $awaiting
    damageServiceCompleted: $damageServiceCompleted
    calledBack: $calledBack
    machinesOnCase: $machinesOnCase
    ownCases: $ownCases
    appliedClosed: $appliedClosed
    closedCases: $closedCases
    debitor: $debitor
    postalCode: $postalCode
    track: $track
    department: $department
    location: $location
    damageCategory: $damageCategory
    damageCause: $damageCause
    priority: $priority
    caseManager: $caseManager
    projectManager: $projectManager
    anyManager: $anyManager
    minDate: $minDate
    maxDate: $maxDate
    erpReferenceNo: $erpReferenceNo
    erpReferenceNos: $erpReferenceNos
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    ...BaseCaseFragment
    changes {
      after {
        status
      }
      timestamp
      user {
        id
        name
      }
    }
    machineOnCase
    openMovables
    activeMovables
    openTimeRegistrations
    activeRequisitions
    activePurchaseDocuments
    activeInvoiceStatus
    caseEconomics(include: $includeEconomy) {
      jobNo
      costTotal
      salesTotal
      invoicedTotal
      quote
      screening
      profit
      deltaNotInvoiced
      coverageRatio
    }
  }
}
    ${BaseCaseFragmentFragmentDoc}`;

/**
 * __useGetOperationManagerCaseDataQuery__
 *
 * To run a query within a React component, call `useGetOperationManagerCaseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationManagerCaseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationManagerCaseDataQuery({
 *   variables: {
 *      address: // value for 'address'
 *      awaiting: // value for 'awaiting'
 *      damageServiceCompleted: // value for 'damageServiceCompleted'
 *      calledBack: // value for 'calledBack'
 *      machinesOnCase: // value for 'machinesOnCase'
 *      ownCases: // value for 'ownCases'
 *      appliedClosed: // value for 'appliedClosed'
 *      closedCases: // value for 'closedCases'
 *      debitor: // value for 'debitor'
 *      postalCode: // value for 'postalCode'
 *      track: // value for 'track'
 *      department: // value for 'department'
 *      location: // value for 'location'
 *      damageCategory: // value for 'damageCategory'
 *      damageCause: // value for 'damageCause'
 *      priority: // value for 'priority'
 *      caseManager: // value for 'caseManager'
 *      projectManager: // value for 'projectManager'
 *      anyManager: // value for 'anyManager'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *      erpReferenceNos: // value for 'erpReferenceNos'
 *      includeEconomy: // value for 'includeEconomy'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetOperationManagerCaseDataQuery(baseOptions: Apollo.QueryHookOptions<GetOperationManagerCaseDataQuery, GetOperationManagerCaseDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOperationManagerCaseDataQuery, GetOperationManagerCaseDataQueryVariables>(GetOperationManagerCaseDataDocument, options);
}
export function useGetOperationManagerCaseDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationManagerCaseDataQuery, GetOperationManagerCaseDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOperationManagerCaseDataQuery, GetOperationManagerCaseDataQueryVariables>(GetOperationManagerCaseDataDocument, options);
}
export function useGetOperationManagerCaseDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationManagerCaseDataQuery, GetOperationManagerCaseDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetOperationManagerCaseDataQuery, GetOperationManagerCaseDataQueryVariables>(GetOperationManagerCaseDataDocument, options);
}
export type GetOperationManagerCaseDataQueryHookResult = ReturnType<typeof useGetOperationManagerCaseDataQuery>;
export type GetOperationManagerCaseDataLazyQueryHookResult = ReturnType<typeof useGetOperationManagerCaseDataLazyQuery>;
export type GetOperationManagerCaseDataSuspenseQueryHookResult = ReturnType<typeof useGetOperationManagerCaseDataSuspenseQuery>;
export type GetOperationManagerCaseDataQueryResult = Apollo.QueryResult<GetOperationManagerCaseDataQuery, GetOperationManagerCaseDataQueryVariables>;
export function refetchGetOperationManagerCaseDataQuery(variables: GetOperationManagerCaseDataQueryVariables) {
  return { query: GetOperationManagerCaseDataDocument, variables: variables }
}
export const GetSsgInfoAdminDataDocument = gql`
    query GetSSGInfoAdminData {
  departments {
    ...BaseDepartmentFragment
  }
  locations {
    ...BaseLocationFragment
  }
}
    ${BaseDepartmentFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}`;

/**
 * __useGetSsgInfoAdminDataQuery__
 *
 * To run a query within a React component, call `useGetSsgInfoAdminDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsgInfoAdminDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsgInfoAdminDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSsgInfoAdminDataQuery(baseOptions?: Apollo.QueryHookOptions<GetSsgInfoAdminDataQuery, GetSsgInfoAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSsgInfoAdminDataQuery, GetSsgInfoAdminDataQueryVariables>(GetSsgInfoAdminDataDocument, options);
}
export function useGetSsgInfoAdminDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSsgInfoAdminDataQuery, GetSsgInfoAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSsgInfoAdminDataQuery, GetSsgInfoAdminDataQueryVariables>(GetSsgInfoAdminDataDocument, options);
}
export function useGetSsgInfoAdminDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSsgInfoAdminDataQuery, GetSsgInfoAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSsgInfoAdminDataQuery, GetSsgInfoAdminDataQueryVariables>(GetSsgInfoAdminDataDocument, options);
}
export type GetSsgInfoAdminDataQueryHookResult = ReturnType<typeof useGetSsgInfoAdminDataQuery>;
export type GetSsgInfoAdminDataLazyQueryHookResult = ReturnType<typeof useGetSsgInfoAdminDataLazyQuery>;
export type GetSsgInfoAdminDataSuspenseQueryHookResult = ReturnType<typeof useGetSsgInfoAdminDataSuspenseQuery>;
export type GetSsgInfoAdminDataQueryResult = Apollo.QueryResult<GetSsgInfoAdminDataQuery, GetSsgInfoAdminDataQueryVariables>;
export function refetchGetSsgInfoAdminDataQuery(variables?: GetSsgInfoAdminDataQueryVariables) {
  return { query: GetSsgInfoAdminDataDocument, variables: variables }
}
export const GetSingleCaseDocument = gql`
    query GetSingleCase($id: String!, $includeEconomy: Boolean!) {
  case(id: $id) {
    ...BaseCaseFragment
    delayScalepoint
    debitor {
      automaticTrackOneInvoicing
      allowInvoicingWithoutReqNo
      blocked
      actualKilometers
      supplyFeePercentage
      maxSupplyFeeAmount
      supplyFeeDateFrom
      supplyFeeDateTo
    }
    activeMovables
    machineOnCase
    scalePointUrl
    activeRequisitions
    activeInvoiceStatus
    activePurchaseDocuments
    invoices {
      erpReferenceNo
      status
      category
    }
    openMovables
    openTimeRegistrations
    version
    fixedPriceOnCase
    possibilityOfAsbestos
    projectManagerFavorite {
      user
      color
      active
    }
    caseManagerFavorite {
      user
      color
      active
    }
    changes {
      timestamp
      user {
        ...BaseUserFragment
      }
      before {
        ...CaseChangesFragment
      }
      after {
        ...CaseChangesFragment
      }
    }
    caseEconomics(include: $includeEconomy) {
      jobNo
      costTotal
      salesTotal
      invoicedTotal
      quote
      screening
      profit
      deltaNotInvoiced
      coverageRatio
    }
    caseReports {
      inspectionReportFormData {
        created
        __typename
      }
      indoorClimateReportFormData {
        created
        __typename
      }
      inspectionMovablesReportFormData {
        created
        __typename
      }
      moistureReportFormData {
        created
        __typename
      }
      moistureTrygReportFormData {
        created
        __typename
      }
    }
  }
}
    ${BaseCaseFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${CaseChangesFragmentFragmentDoc}`;

/**
 * __useGetSingleCaseQuery__
 *
 * To run a query within a React component, call `useGetSingleCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeEconomy: // value for 'includeEconomy'
 *   },
 * });
 */
export function useGetSingleCaseQuery(baseOptions: Apollo.QueryHookOptions<GetSingleCaseQuery, GetSingleCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSingleCaseQuery, GetSingleCaseQueryVariables>(GetSingleCaseDocument, options);
}
export function useGetSingleCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleCaseQuery, GetSingleCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSingleCaseQuery, GetSingleCaseQueryVariables>(GetSingleCaseDocument, options);
}
export function useGetSingleCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleCaseQuery, GetSingleCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSingleCaseQuery, GetSingleCaseQueryVariables>(GetSingleCaseDocument, options);
}
export type GetSingleCaseQueryHookResult = ReturnType<typeof useGetSingleCaseQuery>;
export type GetSingleCaseLazyQueryHookResult = ReturnType<typeof useGetSingleCaseLazyQuery>;
export type GetSingleCaseSuspenseQueryHookResult = ReturnType<typeof useGetSingleCaseSuspenseQuery>;
export type GetSingleCaseQueryResult = Apollo.QueryResult<GetSingleCaseQuery, GetSingleCaseQueryVariables>;
export function refetchGetSingleCaseQuery(variables: GetSingleCaseQueryVariables) {
  return { query: GetSingleCaseDocument, variables: variables }
}
export const GetWebCaseDocument = gql`
    query GetWebCase($id: String!) {
  case(id: $id) {
    ...BaseCaseFragment
    debitor {
      automaticTrackOneInvoicing
      allowInvoicingWithoutReqNo
    }
    activeMovables
    machineOnCase
    scalePointUrl
    activeRequisitions
    activeInvoiceStatus
    version
    projectManagerFavorite {
      user
      color
      active
    }
    caseManagerFavorite {
      user
      color
      active
    }
    changes {
      timestamp
      user {
        ...BaseUserFragment
      }
      before {
        ...CaseChangesFragment
      }
      after {
        ...CaseChangesFragment
      }
    }
    caseReports {
      inspectionReportFormData {
        __typename
      }
      indoorClimateReportFormData {
        __typename
      }
      moistureReportFormData {
        __typename
      }
      moistureTrygReportFormData {
        __typename
      }
    }
  }
}
    ${BaseCaseFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${CaseChangesFragmentFragmentDoc}`;

/**
 * __useGetWebCaseQuery__
 *
 * To run a query within a React component, call `useGetWebCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWebCaseQuery(baseOptions: Apollo.QueryHookOptions<GetWebCaseQuery, GetWebCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCaseQuery, GetWebCaseQueryVariables>(GetWebCaseDocument, options);
}
export function useGetWebCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCaseQuery, GetWebCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCaseQuery, GetWebCaseQueryVariables>(GetWebCaseDocument, options);
}
export function useGetWebCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCaseQuery, GetWebCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCaseQuery, GetWebCaseQueryVariables>(GetWebCaseDocument, options);
}
export type GetWebCaseQueryHookResult = ReturnType<typeof useGetWebCaseQuery>;
export type GetWebCaseLazyQueryHookResult = ReturnType<typeof useGetWebCaseLazyQuery>;
export type GetWebCaseSuspenseQueryHookResult = ReturnType<typeof useGetWebCaseSuspenseQuery>;
export type GetWebCaseQueryResult = Apollo.QueryResult<GetWebCaseQuery, GetWebCaseQueryVariables>;
export function refetchGetWebCaseQuery(variables: GetWebCaseQueryVariables) {
  return { query: GetWebCaseDocument, variables: variables }
}
export const GetWebCaseAdminDataDocument = gql`
    query GetWebCaseAdminData {
  damageCategories {
    ...BaseDamageCategoryFragment
  }
  damageCauses {
    ...BaseDamageCauseFragment
  }
  departments {
    ...BaseDepartmentFragment
  }
  locations {
    ...BaseLocationFragment
    attachedPostalCodesInputString
    attachedPostalCodes
  }
  drivingSlipCategories {
    code
    name
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}`;

/**
 * __useGetWebCaseAdminDataQuery__
 *
 * To run a query within a React component, call `useGetWebCaseAdminDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCaseAdminDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCaseAdminDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebCaseAdminDataQuery(baseOptions?: Apollo.QueryHookOptions<GetWebCaseAdminDataQuery, GetWebCaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCaseAdminDataQuery, GetWebCaseAdminDataQueryVariables>(GetWebCaseAdminDataDocument, options);
}
export function useGetWebCaseAdminDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCaseAdminDataQuery, GetWebCaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCaseAdminDataQuery, GetWebCaseAdminDataQueryVariables>(GetWebCaseAdminDataDocument, options);
}
export function useGetWebCaseAdminDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCaseAdminDataQuery, GetWebCaseAdminDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCaseAdminDataQuery, GetWebCaseAdminDataQueryVariables>(GetWebCaseAdminDataDocument, options);
}
export type GetWebCaseAdminDataQueryHookResult = ReturnType<typeof useGetWebCaseAdminDataQuery>;
export type GetWebCaseAdminDataLazyQueryHookResult = ReturnType<typeof useGetWebCaseAdminDataLazyQuery>;
export type GetWebCaseAdminDataSuspenseQueryHookResult = ReturnType<typeof useGetWebCaseAdminDataSuspenseQuery>;
export type GetWebCaseAdminDataQueryResult = Apollo.QueryResult<GetWebCaseAdminDataQuery, GetWebCaseAdminDataQueryVariables>;
export function refetchGetWebCaseAdminDataQuery(variables?: GetWebCaseAdminDataQueryVariables) {
  return { query: GetWebCaseAdminDataDocument, variables: variables }
}
export const GetWebCasesDocument = gql`
    query GetWebCases($address: AddressInput, $awaiting: Boolean, $damageServiceCompleted: Boolean, $calledBack: Boolean, $machinesOnCase: Boolean, $ownCases: Boolean, $favoriteCases: Boolean, $readyForInvoice: Boolean, $appliedClosed: Boolean, $closedCases: Boolean, $priorityCustomers: Boolean, $debitor: [String!], $postalCode: [String!], $track: [Int!], $department: [String!], $location: [String!], $damageCategory: [String!], $damageCause: [String!], $priority: [CasePriority!], $caseManager: [String!], $projectManager: [String!], $createdBy: [String!], $areaResponsible: [String!], $anyManager: String, $minDate: Date, $maxDate: Date, $erpReferenceNo: String, $erpReferenceNos: [String!], $favoriteColors: [String!], $includeEconomy: Boolean!, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  cases(
    address: $address
    awaiting: $awaiting
    damageServiceCompleted: $damageServiceCompleted
    calledBack: $calledBack
    machinesOnCase: $machinesOnCase
    ownCases: $ownCases
    favoriteCases: $favoriteCases
    readyForInvoice: $readyForInvoice
    appliedClosed: $appliedClosed
    closedCases: $closedCases
    priorityCustomers: $priorityCustomers
    debitor: $debitor
    postalCode: $postalCode
    track: $track
    department: $department
    location: $location
    damageCategory: $damageCategory
    damageCause: $damageCause
    priority: $priority
    caseManager: $caseManager
    projectManager: $projectManager
    createdBy: $createdBy
    areaResponsible: $areaResponsible
    anyManager: $anyManager
    minDate: $minDate
    maxDate: $maxDate
    erpReferenceNo: $erpReferenceNo
    erpReferenceNos: $erpReferenceNos
    favoriteColors: $favoriteColors
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    id
    status
    erpId
    erpNo
    track
    reportSent
    distance
    machineNotification
    timeRegistration
    debitor {
      ...BaseDebitorFragment
    }
    damage {
      ...DamageFragment
    }
    policyHolder {
      name
      phone
      email
      address {
        ...AddressFragment
      }
    }
    visitation {
      urgent
      priorities
      regress
      calledBack {
        timestamp
        value
        comment
      }
      awaiting {
        timestamp
        value
        comment
      }
      answers {
        question
        answer
      }
      isSpPhaseOneReportCreated
    }
    projectManager {
      ...BaseUserFragment
    }
    caseManager {
      ...BaseUserFragment
    }
    areaResponsible {
      ...BaseUserFragment
    }
    ssgLocation {
      ...BaseLocationFragment
    }
    ssgDepartment {
      ...BaseDepartmentFragment
    }
    billingReady
    workComplete
    userFavorite {
      user
      color
      active
    }
    projectManagerFavorite {
      user
      color
      active
    }
    caseManagerFavorite {
      user
      color
      active
    }
    createdBy {
      ...BaseUserFragment
    }
    createdAt
    skafor
    jobs {
      ...BaseJobFragment
    }
    drivingSlipSeries {
      id
      completed
      drivingSlips {
        id
        driver {
          name
        }
        start
        status
      }
    }
    caseReports {
      inspectionReportFormData {
        created
        __typename
      }
      indoorClimateReportFormData {
        created
        __typename
      }
      moistureReportFormData {
        created
        __typename
      }
      moistureTrygReportFormData {
        created
        __typename
      }
      inspectionMovablesReportFormData {
        created
        __typename
      }
    }
    activeMovables
    machineOnCase
    activeRequisitions
    activeInvoiceStatus
    invoices {
      erpReferenceNo
      status
      category
    }
    scalePointStatus
    scalePointErrorMessage
    caseEconomics(include: $includeEconomy) {
      jobNo
      costTotal
      salesTotal
      invoicedTotal
      quote
      screening
      profit
      deltaNotInvoiced
      coverageRatio
    }
    arrived
    arrivedDate
  }
}
    ${BaseDebitorFragmentFragmentDoc}
${DamageFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}
${BaseLocationFragmentFragmentDoc}
${BaseDepartmentFragmentFragmentDoc}
${BaseJobFragmentFragmentDoc}`;

/**
 * __useGetWebCasesQuery__
 *
 * To run a query within a React component, call `useGetWebCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCasesQuery({
 *   variables: {
 *      address: // value for 'address'
 *      awaiting: // value for 'awaiting'
 *      damageServiceCompleted: // value for 'damageServiceCompleted'
 *      calledBack: // value for 'calledBack'
 *      machinesOnCase: // value for 'machinesOnCase'
 *      ownCases: // value for 'ownCases'
 *      favoriteCases: // value for 'favoriteCases'
 *      readyForInvoice: // value for 'readyForInvoice'
 *      appliedClosed: // value for 'appliedClosed'
 *      closedCases: // value for 'closedCases'
 *      priorityCustomers: // value for 'priorityCustomers'
 *      debitor: // value for 'debitor'
 *      postalCode: // value for 'postalCode'
 *      track: // value for 'track'
 *      department: // value for 'department'
 *      location: // value for 'location'
 *      damageCategory: // value for 'damageCategory'
 *      damageCause: // value for 'damageCause'
 *      priority: // value for 'priority'
 *      caseManager: // value for 'caseManager'
 *      projectManager: // value for 'projectManager'
 *      createdBy: // value for 'createdBy'
 *      areaResponsible: // value for 'areaResponsible'
 *      anyManager: // value for 'anyManager'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *      erpReferenceNos: // value for 'erpReferenceNos'
 *      favoriteColors: // value for 'favoriteColors'
 *      includeEconomy: // value for 'includeEconomy'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetWebCasesQuery(baseOptions: Apollo.QueryHookOptions<GetWebCasesQuery, GetWebCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCasesQuery, GetWebCasesQueryVariables>(GetWebCasesDocument, options);
}
export function useGetWebCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCasesQuery, GetWebCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCasesQuery, GetWebCasesQueryVariables>(GetWebCasesDocument, options);
}
export function useGetWebCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCasesQuery, GetWebCasesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCasesQuery, GetWebCasesQueryVariables>(GetWebCasesDocument, options);
}
export type GetWebCasesQueryHookResult = ReturnType<typeof useGetWebCasesQuery>;
export type GetWebCasesLazyQueryHookResult = ReturnType<typeof useGetWebCasesLazyQuery>;
export type GetWebCasesSuspenseQueryHookResult = ReturnType<typeof useGetWebCasesSuspenseQuery>;
export type GetWebCasesQueryResult = Apollo.QueryResult<GetWebCasesQuery, GetWebCasesQueryVariables>;
export function refetchGetWebCasesQuery(variables: GetWebCasesQueryVariables) {
  return { query: GetWebCasesDocument, variables: variables }
}
export const GetWebCasesByErpNoDocument = gql`
    query GetWebCasesByErpNo($erpReferenceNo: String!, $closedCases: Boolean, $appliedClosed: Boolean, $searchString: String) {
  cases(
    erpReferenceNo: $erpReferenceNo
    closedCases: $closedCases
    appliedClosed: $appliedClosed
    searchString: $searchString
  ) {
    id
    erpNo
    status
    timeRegistration
    debitor {
      company
    }
    damage {
      category {
        name
      }
      cause {
        name
      }
      businessArea {
        name
      }
      date
      description
      contact {
        name
        phone
        email
        address {
          road
          houseNumber
          floor
          addressLineAlt
          postalCode
          city
          country
        }
      }
    }
    projectManager {
      id
      name
    }
    caseManager {
      id
      name
    }
  }
}
    `;

/**
 * __useGetWebCasesByErpNoQuery__
 *
 * To run a query within a React component, call `useGetWebCasesByErpNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCasesByErpNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCasesByErpNoQuery({
 *   variables: {
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *      closedCases: // value for 'closedCases'
 *      appliedClosed: // value for 'appliedClosed'
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGetWebCasesByErpNoQuery(baseOptions: Apollo.QueryHookOptions<GetWebCasesByErpNoQuery, GetWebCasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCasesByErpNoQuery, GetWebCasesByErpNoQueryVariables>(GetWebCasesByErpNoDocument, options);
}
export function useGetWebCasesByErpNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCasesByErpNoQuery, GetWebCasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCasesByErpNoQuery, GetWebCasesByErpNoQueryVariables>(GetWebCasesByErpNoDocument, options);
}
export function useGetWebCasesByErpNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCasesByErpNoQuery, GetWebCasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCasesByErpNoQuery, GetWebCasesByErpNoQueryVariables>(GetWebCasesByErpNoDocument, options);
}
export type GetWebCasesByErpNoQueryHookResult = ReturnType<typeof useGetWebCasesByErpNoQuery>;
export type GetWebCasesByErpNoLazyQueryHookResult = ReturnType<typeof useGetWebCasesByErpNoLazyQuery>;
export type GetWebCasesByErpNoSuspenseQueryHookResult = ReturnType<typeof useGetWebCasesByErpNoSuspenseQuery>;
export type GetWebCasesByErpNoQueryResult = Apollo.QueryResult<GetWebCasesByErpNoQuery, GetWebCasesByErpNoQueryVariables>;
export function refetchGetWebCasesByErpNoQuery(variables: GetWebCasesByErpNoQueryVariables) {
  return { query: GetWebCasesByErpNoDocument, variables: variables }
}
export const GetWebCasesForCatalogSuggestionsDocument = gql`
    query GetWebCasesForCatalogSuggestions($erpReferenceNo: String!) {
  cases(erpReferenceNo: $erpReferenceNo, closedCases: false, appliedClosed: false) {
    id
    erpNo
    debitor {
      id
      company
      unknown
    }
    damage {
      contact {
        name
        phone
        email
        address {
          road
          houseNumber
          floor
          addressLineAlt
          postalCode
          city
          country
        }
      }
    }
  }
}
    `;

/**
 * __useGetWebCasesForCatalogSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetWebCasesForCatalogSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCasesForCatalogSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCasesForCatalogSuggestionsQuery({
 *   variables: {
 *      erpReferenceNo: // value for 'erpReferenceNo'
 *   },
 * });
 */
export function useGetWebCasesForCatalogSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetWebCasesForCatalogSuggestionsQuery, GetWebCasesForCatalogSuggestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCasesForCatalogSuggestionsQuery, GetWebCasesForCatalogSuggestionsQueryVariables>(GetWebCasesForCatalogSuggestionsDocument, options);
}
export function useGetWebCasesForCatalogSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCasesForCatalogSuggestionsQuery, GetWebCasesForCatalogSuggestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCasesForCatalogSuggestionsQuery, GetWebCasesForCatalogSuggestionsQueryVariables>(GetWebCasesForCatalogSuggestionsDocument, options);
}
export function useGetWebCasesForCatalogSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCasesForCatalogSuggestionsQuery, GetWebCasesForCatalogSuggestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCasesForCatalogSuggestionsQuery, GetWebCasesForCatalogSuggestionsQueryVariables>(GetWebCasesForCatalogSuggestionsDocument, options);
}
export type GetWebCasesForCatalogSuggestionsQueryHookResult = ReturnType<typeof useGetWebCasesForCatalogSuggestionsQuery>;
export type GetWebCasesForCatalogSuggestionsLazyQueryHookResult = ReturnType<typeof useGetWebCasesForCatalogSuggestionsLazyQuery>;
export type GetWebCasesForCatalogSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetWebCasesForCatalogSuggestionsSuspenseQuery>;
export type GetWebCasesForCatalogSuggestionsQueryResult = Apollo.QueryResult<GetWebCasesForCatalogSuggestionsQuery, GetWebCasesForCatalogSuggestionsQueryVariables>;
export function refetchGetWebCasesForCatalogSuggestionsQuery(variables: GetWebCasesForCatalogSuggestionsQueryVariables) {
  return { query: GetWebCasesForCatalogSuggestionsDocument, variables: variables }
}
export const MergeCasesDocument = gql`
    mutation MergeCases($primaryCaseId: String!, $duplicateCaseId: String!, $shouldCloseDuplicateCase: Boolean!) {
  mergeCases(
    primaryCaseId: $primaryCaseId
    duplicateCaseId: $duplicateCaseId
    shouldCloseDuplicateCase: $shouldCloseDuplicateCase
  ) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type MergeCasesMutationFn = Apollo.MutationFunction<MergeCasesMutation, MergeCasesMutationVariables>;

/**
 * __useMergeCasesMutation__
 *
 * To run a mutation, you first call `useMergeCasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCasesMutation, { data, loading, error }] = useMergeCasesMutation({
 *   variables: {
 *      primaryCaseId: // value for 'primaryCaseId'
 *      duplicateCaseId: // value for 'duplicateCaseId'
 *      shouldCloseDuplicateCase: // value for 'shouldCloseDuplicateCase'
 *   },
 * });
 */
export function useMergeCasesMutation(baseOptions?: Apollo.MutationHookOptions<MergeCasesMutation, MergeCasesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MergeCasesMutation, MergeCasesMutationVariables>(MergeCasesDocument, options);
}
export type MergeCasesMutationHookResult = ReturnType<typeof useMergeCasesMutation>;
export type MergeCasesMutationResult = Apollo.MutationResult<MergeCasesMutation>;
export type MergeCasesMutationOptions = Apollo.BaseMutationOptions<MergeCasesMutation, MergeCasesMutationVariables>;
export const RejectCaseClosingDocument = gql`
    mutation RejectCaseClosing($id: String!, $email: String!, $rejectionComment: String!) {
  rejectCaseClosing(id: $id, email: $email, rejectionComment: $rejectionComment) {
    status
  }
}
    `;
export type RejectCaseClosingMutationFn = Apollo.MutationFunction<RejectCaseClosingMutation, RejectCaseClosingMutationVariables>;

/**
 * __useRejectCaseClosingMutation__
 *
 * To run a mutation, you first call `useRejectCaseClosingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCaseClosingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCaseClosingMutation, { data, loading, error }] = useRejectCaseClosingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      rejectionComment: // value for 'rejectionComment'
 *   },
 * });
 */
export function useRejectCaseClosingMutation(baseOptions?: Apollo.MutationHookOptions<RejectCaseClosingMutation, RejectCaseClosingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RejectCaseClosingMutation, RejectCaseClosingMutationVariables>(RejectCaseClosingDocument, options);
}
export type RejectCaseClosingMutationHookResult = ReturnType<typeof useRejectCaseClosingMutation>;
export type RejectCaseClosingMutationResult = Apollo.MutationResult<RejectCaseClosingMutation>;
export type RejectCaseClosingMutationOptions = Apollo.BaseMutationOptions<RejectCaseClosingMutation, RejectCaseClosingMutationVariables>;
export const ResetCaseFileCacheDocument = gql`
    mutation ResetCaseFileCache($caseNo: String!) {
  resetCaseFileCache(caseNo: $caseNo) {
    _
  }
}
    `;
export type ResetCaseFileCacheMutationFn = Apollo.MutationFunction<ResetCaseFileCacheMutation, ResetCaseFileCacheMutationVariables>;

/**
 * __useResetCaseFileCacheMutation__
 *
 * To run a mutation, you first call `useResetCaseFileCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCaseFileCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCaseFileCacheMutation, { data, loading, error }] = useResetCaseFileCacheMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *   },
 * });
 */
export function useResetCaseFileCacheMutation(baseOptions?: Apollo.MutationHookOptions<ResetCaseFileCacheMutation, ResetCaseFileCacheMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResetCaseFileCacheMutation, ResetCaseFileCacheMutationVariables>(ResetCaseFileCacheDocument, options);
}
export type ResetCaseFileCacheMutationHookResult = ReturnType<typeof useResetCaseFileCacheMutation>;
export type ResetCaseFileCacheMutationResult = Apollo.MutationResult<ResetCaseFileCacheMutation>;
export type ResetCaseFileCacheMutationOptions = Apollo.BaseMutationOptions<ResetCaseFileCacheMutation, ResetCaseFileCacheMutationVariables>;
export const SearchCasesByErpNoDocument = gql`
    query SearchCasesByERPNo($erpNo: String!) {
  searchCasesByERPNo(erpNo: $erpNo) {
    erpNo
    id
  }
}
    `;

/**
 * __useSearchCasesByErpNoQuery__
 *
 * To run a query within a React component, call `useSearchCasesByErpNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCasesByErpNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCasesByErpNoQuery({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *   },
 * });
 */
export function useSearchCasesByErpNoQuery(baseOptions: Apollo.QueryHookOptions<SearchCasesByErpNoQuery, SearchCasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchCasesByErpNoQuery, SearchCasesByErpNoQueryVariables>(SearchCasesByErpNoDocument, options);
}
export function useSearchCasesByErpNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCasesByErpNoQuery, SearchCasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchCasesByErpNoQuery, SearchCasesByErpNoQueryVariables>(SearchCasesByErpNoDocument, options);
}
export function useSearchCasesByErpNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCasesByErpNoQuery, SearchCasesByErpNoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchCasesByErpNoQuery, SearchCasesByErpNoQueryVariables>(SearchCasesByErpNoDocument, options);
}
export type SearchCasesByErpNoQueryHookResult = ReturnType<typeof useSearchCasesByErpNoQuery>;
export type SearchCasesByErpNoLazyQueryHookResult = ReturnType<typeof useSearchCasesByErpNoLazyQuery>;
export type SearchCasesByErpNoSuspenseQueryHookResult = ReturnType<typeof useSearchCasesByErpNoSuspenseQuery>;
export type SearchCasesByErpNoQueryResult = Apollo.QueryResult<SearchCasesByErpNoQuery, SearchCasesByErpNoQueryVariables>;
export function refetchSearchCasesByErpNoQuery(variables: SearchCasesByErpNoQueryVariables) {
  return { query: SearchCasesByErpNoDocument, variables: variables }
}
export const SetCostEstimateDocument = gql`
    mutation SetCostEstimate($erpNo: String!, $price: Decimal!) {
  setCostEstimate(erpNo: $erpNo, price: $price)
}
    `;
export type SetCostEstimateMutationFn = Apollo.MutationFunction<SetCostEstimateMutation, SetCostEstimateMutationVariables>;

/**
 * __useSetCostEstimateMutation__
 *
 * To run a mutation, you first call `useSetCostEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCostEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCostEstimateMutation, { data, loading, error }] = useSetCostEstimateMutation({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useSetCostEstimateMutation(baseOptions?: Apollo.MutationHookOptions<SetCostEstimateMutation, SetCostEstimateMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetCostEstimateMutation, SetCostEstimateMutationVariables>(SetCostEstimateDocument, options);
}
export type SetCostEstimateMutationHookResult = ReturnType<typeof useSetCostEstimateMutation>;
export type SetCostEstimateMutationResult = Apollo.MutationResult<SetCostEstimateMutation>;
export type SetCostEstimateMutationOptions = Apollo.BaseMutationOptions<SetCostEstimateMutation, SetCostEstimateMutationVariables>;
export const SetHoursAvailableDocument = gql`
    mutation SetHoursAvailable($erpNo: String!, $hoursAvailable: Decimal!) {
  setHoursAvailable(erpNo: $erpNo, hoursAvailable: $hoursAvailable)
}
    `;
export type SetHoursAvailableMutationFn = Apollo.MutationFunction<SetHoursAvailableMutation, SetHoursAvailableMutationVariables>;

/**
 * __useSetHoursAvailableMutation__
 *
 * To run a mutation, you first call `useSetHoursAvailableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHoursAvailableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHoursAvailableMutation, { data, loading, error }] = useSetHoursAvailableMutation({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *      hoursAvailable: // value for 'hoursAvailable'
 *   },
 * });
 */
export function useSetHoursAvailableMutation(baseOptions?: Apollo.MutationHookOptions<SetHoursAvailableMutation, SetHoursAvailableMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetHoursAvailableMutation, SetHoursAvailableMutationVariables>(SetHoursAvailableDocument, options);
}
export type SetHoursAvailableMutationHookResult = ReturnType<typeof useSetHoursAvailableMutation>;
export type SetHoursAvailableMutationResult = Apollo.MutationResult<SetHoursAvailableMutation>;
export type SetHoursAvailableMutationOptions = Apollo.BaseMutationOptions<SetHoursAvailableMutation, SetHoursAvailableMutationVariables>;
export const SetSsgPriceDocument = gql`
    mutation SetSSGPrice($erpNo: String!, $price: Decimal!) {
  setSSGPrice(erpNo: $erpNo, price: $price)
}
    `;
export type SetSsgPriceMutationFn = Apollo.MutationFunction<SetSsgPriceMutation, SetSsgPriceMutationVariables>;

/**
 * __useSetSsgPriceMutation__
 *
 * To run a mutation, you first call `useSetSsgPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSsgPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSsgPriceMutation, { data, loading, error }] = useSetSsgPriceMutation({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useSetSsgPriceMutation(baseOptions?: Apollo.MutationHookOptions<SetSsgPriceMutation, SetSsgPriceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetSsgPriceMutation, SetSsgPriceMutationVariables>(SetSsgPriceDocument, options);
}
export type SetSsgPriceMutationHookResult = ReturnType<typeof useSetSsgPriceMutation>;
export type SetSsgPriceMutationResult = Apollo.MutationResult<SetSsgPriceMutation>;
export type SetSsgPriceMutationOptions = Apollo.BaseMutationOptions<SetSsgPriceMutation, SetSsgPriceMutationVariables>;
export const UpdateCaseDocument = gql`
    mutation UpdateCase($id: String!, $status: CaseStatus, $damage: DamageInput, $policyHolder: ContactInput, $debitor: DebitorInput, $requisitioner: RequisitionerInput, $adviser: CompanyContactInput, $referrer: CompanyContactInput, $visitation: VisitationInput, $projectManager: String, $caseManager: String, $areaResponsible: String, $ssgLocation: String, $ssgDepartment: String, $billingReady: Boolean, $workComplete: Boolean, $importantInfo: String, $skafor: Boolean, $alternativeContact: PersonInput, $track: Int, $riskEvaluationAnswers: [RiskEvaluationAnswerInput!], $machineNotification: Boolean, $timeRegistration: Boolean, $fixedPriceOnCase: Decimal, $possibilityOfAsbestos: Boolean, $scalePointStatus: ScalePointStatus) {
  updateCase(
    id: $id
    status: $status
    damage: $damage
    policyHolder: $policyHolder
    debitor: $debitor
    requisitioner: $requisitioner
    adviser: $adviser
    referrer: $referrer
    projectManager: $projectManager
    caseManager: $caseManager
    areaResponsible: $areaResponsible
    ssgLocation: $ssgLocation
    ssgDepartment: $ssgDepartment
    billingReady: $billingReady
    workComplete: $workComplete
    visitation: $visitation
    importantInfo: $importantInfo
    skafor: $skafor
    alternativeContact: $alternativeContact
    track: $track
    riskEvaluationAnswers: $riskEvaluationAnswers
    machineNotification: $machineNotification
    timeRegistration: $timeRegistration
    fixedPriceOnCase: $fixedPriceOnCase
    possibilityOfAsbestos: $possibilityOfAsbestos
    scalePointStatus: $scalePointStatus
  ) {
    ...BaseCaseFragment
  }
}
    ${BaseCaseFragmentFragmentDoc}`;
export type UpdateCaseMutationFn = Apollo.MutationFunction<UpdateCaseMutation, UpdateCaseMutationVariables>;

/**
 * __useUpdateCaseMutation__
 *
 * To run a mutation, you first call `useUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseMutation, { data, loading, error }] = useUpdateCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      damage: // value for 'damage'
 *      policyHolder: // value for 'policyHolder'
 *      debitor: // value for 'debitor'
 *      requisitioner: // value for 'requisitioner'
 *      adviser: // value for 'adviser'
 *      referrer: // value for 'referrer'
 *      visitation: // value for 'visitation'
 *      projectManager: // value for 'projectManager'
 *      caseManager: // value for 'caseManager'
 *      areaResponsible: // value for 'areaResponsible'
 *      ssgLocation: // value for 'ssgLocation'
 *      ssgDepartment: // value for 'ssgDepartment'
 *      billingReady: // value for 'billingReady'
 *      workComplete: // value for 'workComplete'
 *      importantInfo: // value for 'importantInfo'
 *      skafor: // value for 'skafor'
 *      alternativeContact: // value for 'alternativeContact'
 *      track: // value for 'track'
 *      riskEvaluationAnswers: // value for 'riskEvaluationAnswers'
 *      machineNotification: // value for 'machineNotification'
 *      timeRegistration: // value for 'timeRegistration'
 *      fixedPriceOnCase: // value for 'fixedPriceOnCase'
 *      possibilityOfAsbestos: // value for 'possibilityOfAsbestos'
 *      scalePointStatus: // value for 'scalePointStatus'
 *   },
 * });
 */
export function useUpdateCaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseMutation, UpdateCaseMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCaseMutation, UpdateCaseMutationVariables>(UpdateCaseDocument, options);
}
export type UpdateCaseMutationHookResult = ReturnType<typeof useUpdateCaseMutation>;
export type UpdateCaseMutationResult = Apollo.MutationResult<UpdateCaseMutation>;
export type UpdateCaseMutationOptions = Apollo.BaseMutationOptions<UpdateCaseMutation, UpdateCaseMutationVariables>;
export const AddCatalogToContactDocument = gql`
    mutation AddCatalogToContact($contactId: String!, $catalogId: String!, $changedBy: String!) {
  addCatalogToContact(
    contactId: $contactId
    catalogId: $catalogId
    changedBy: $changedBy
  ) {
    ...BaseCatalogContactFragment
  }
}
    ${BaseCatalogContactFragmentFragmentDoc}`;
export type AddCatalogToContactMutationFn = Apollo.MutationFunction<AddCatalogToContactMutation, AddCatalogToContactMutationVariables>;

/**
 * __useAddCatalogToContactMutation__
 *
 * To run a mutation, you first call `useAddCatalogToContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCatalogToContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCatalogToContactMutation, { data, loading, error }] = useAddCatalogToContactMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      catalogId: // value for 'catalogId'
 *      changedBy: // value for 'changedBy'
 *   },
 * });
 */
export function useAddCatalogToContactMutation(baseOptions?: Apollo.MutationHookOptions<AddCatalogToContactMutation, AddCatalogToContactMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddCatalogToContactMutation, AddCatalogToContactMutationVariables>(AddCatalogToContactDocument, options);
}
export type AddCatalogToContactMutationHookResult = ReturnType<typeof useAddCatalogToContactMutation>;
export type AddCatalogToContactMutationResult = Apollo.MutationResult<AddCatalogToContactMutation>;
export type AddCatalogToContactMutationOptions = Apollo.BaseMutationOptions<AddCatalogToContactMutation, AddCatalogToContactMutationVariables>;
export const CreateCatalogContactDocument = gql`
    mutation CreateCatalogContact($catalogContact: CatalogContactInput!) {
  createCatalogContact(catalogContact: $catalogContact) {
    ...BaseCatalogContactFragment
    catalogs {
      id
      propertyNumber
      addresses {
        ...BaseCatalogAddressFragment
      }
    }
  }
}
    ${BaseCatalogContactFragmentFragmentDoc}
${BaseCatalogAddressFragmentFragmentDoc}`;
export type CreateCatalogContactMutationFn = Apollo.MutationFunction<CreateCatalogContactMutation, CreateCatalogContactMutationVariables>;

/**
 * __useCreateCatalogContactMutation__
 *
 * To run a mutation, you first call `useCreateCatalogContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCatalogContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCatalogContactMutation, { data, loading, error }] = useCreateCatalogContactMutation({
 *   variables: {
 *      catalogContact: // value for 'catalogContact'
 *   },
 * });
 */
export function useCreateCatalogContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateCatalogContactMutation, CreateCatalogContactMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCatalogContactMutation, CreateCatalogContactMutationVariables>(CreateCatalogContactDocument, options);
}
export type CreateCatalogContactMutationHookResult = ReturnType<typeof useCreateCatalogContactMutation>;
export type CreateCatalogContactMutationResult = Apollo.MutationResult<CreateCatalogContactMutation>;
export type CreateCatalogContactMutationOptions = Apollo.BaseMutationOptions<CreateCatalogContactMutation, CreateCatalogContactMutationVariables>;
export const DeleteCatalogContactDocument = gql`
    mutation DeleteCatalogContact($id: String!, $changedBy: String!) {
  deleteCatalogContact(id: $id, changedBy: $changedBy) {
    _
  }
}
    `;
export type DeleteCatalogContactMutationFn = Apollo.MutationFunction<DeleteCatalogContactMutation, DeleteCatalogContactMutationVariables>;

/**
 * __useDeleteCatalogContactMutation__
 *
 * To run a mutation, you first call `useDeleteCatalogContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCatalogContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCatalogContactMutation, { data, loading, error }] = useDeleteCatalogContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changedBy: // value for 'changedBy'
 *   },
 * });
 */
export function useDeleteCatalogContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCatalogContactMutation, DeleteCatalogContactMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCatalogContactMutation, DeleteCatalogContactMutationVariables>(DeleteCatalogContactDocument, options);
}
export type DeleteCatalogContactMutationHookResult = ReturnType<typeof useDeleteCatalogContactMutation>;
export type DeleteCatalogContactMutationResult = Apollo.MutationResult<DeleteCatalogContactMutation>;
export type DeleteCatalogContactMutationOptions = Apollo.BaseMutationOptions<DeleteCatalogContactMutation, DeleteCatalogContactMutationVariables>;
export const GetCatalogContactChangesDocument = gql`
    query GetCatalogContactChanges($id: String!) {
  catalogContact(id: $id) {
    id
    changes {
      timestamp
      user {
        ...BaseUserFragment
      }
      before {
        ...CatalogContactChangesFragment
      }
      after {
        ...CatalogContactChangesFragment
      }
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${CatalogContactChangesFragmentFragmentDoc}`;

/**
 * __useGetCatalogContactChangesQuery__
 *
 * To run a query within a React component, call `useGetCatalogContactChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogContactChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogContactChangesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatalogContactChangesQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogContactChangesQuery, GetCatalogContactChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogContactChangesQuery, GetCatalogContactChangesQueryVariables>(GetCatalogContactChangesDocument, options);
}
export function useGetCatalogContactChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogContactChangesQuery, GetCatalogContactChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogContactChangesQuery, GetCatalogContactChangesQueryVariables>(GetCatalogContactChangesDocument, options);
}
export function useGetCatalogContactChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogContactChangesQuery, GetCatalogContactChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogContactChangesQuery, GetCatalogContactChangesQueryVariables>(GetCatalogContactChangesDocument, options);
}
export type GetCatalogContactChangesQueryHookResult = ReturnType<typeof useGetCatalogContactChangesQuery>;
export type GetCatalogContactChangesLazyQueryHookResult = ReturnType<typeof useGetCatalogContactChangesLazyQuery>;
export type GetCatalogContactChangesSuspenseQueryHookResult = ReturnType<typeof useGetCatalogContactChangesSuspenseQuery>;
export type GetCatalogContactChangesQueryResult = Apollo.QueryResult<GetCatalogContactChangesQuery, GetCatalogContactChangesQueryVariables>;
export function refetchGetCatalogContactChangesQuery(variables: GetCatalogContactChangesQueryVariables) {
  return { query: GetCatalogContactChangesDocument, variables: variables }
}
export const GetCatalogContactForAddExcistingDocument = gql`
    query GetCatalogContactForAddExcisting($customerIds: [String!], $notGlobalOnly: Boolean) {
  catalogContacts(customerIds: $customerIds, notGlobalOnly: $notGlobalOnly) {
    id
    contactName
    type
    contactType
    email
    informations {
      phoneNumber
      remark
    }
  }
}
    `;

/**
 * __useGetCatalogContactForAddExcistingQuery__
 *
 * To run a query within a React component, call `useGetCatalogContactForAddExcistingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogContactForAddExcistingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogContactForAddExcistingQuery({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *      notGlobalOnly: // value for 'notGlobalOnly'
 *   },
 * });
 */
export function useGetCatalogContactForAddExcistingQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogContactForAddExcistingQuery, GetCatalogContactForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogContactForAddExcistingQuery, GetCatalogContactForAddExcistingQueryVariables>(GetCatalogContactForAddExcistingDocument, options);
}
export function useGetCatalogContactForAddExcistingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogContactForAddExcistingQuery, GetCatalogContactForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogContactForAddExcistingQuery, GetCatalogContactForAddExcistingQueryVariables>(GetCatalogContactForAddExcistingDocument, options);
}
export function useGetCatalogContactForAddExcistingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogContactForAddExcistingQuery, GetCatalogContactForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogContactForAddExcistingQuery, GetCatalogContactForAddExcistingQueryVariables>(GetCatalogContactForAddExcistingDocument, options);
}
export type GetCatalogContactForAddExcistingQueryHookResult = ReturnType<typeof useGetCatalogContactForAddExcistingQuery>;
export type GetCatalogContactForAddExcistingLazyQueryHookResult = ReturnType<typeof useGetCatalogContactForAddExcistingLazyQuery>;
export type GetCatalogContactForAddExcistingSuspenseQueryHookResult = ReturnType<typeof useGetCatalogContactForAddExcistingSuspenseQuery>;
export type GetCatalogContactForAddExcistingQueryResult = Apollo.QueryResult<GetCatalogContactForAddExcistingQuery, GetCatalogContactForAddExcistingQueryVariables>;
export function refetchGetCatalogContactForAddExcistingQuery(variables?: GetCatalogContactForAddExcistingQueryVariables) {
  return { query: GetCatalogContactForAddExcistingDocument, variables: variables }
}
export const GetCatalogContactsDocument = gql`
    query GetCatalogContacts($globalOnly: Boolean, $catalogId: String, $customerIds: [String!], $contactType: CatalogContacts, $thisCustomerOnly: Boolean, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  catalogContacts(
    globalOnly: $globalOnly
    catalogId: $catalogId
    customerIds: $customerIds
    contactType: $contactType
    thisCustomerOnly: $thisCustomerOnly
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    ...BaseCatalogContactFragment
    catalogs {
      id
      propertyNumber
      addresses {
        ...BaseCatalogAddressFragment
      }
    }
  }
}
    ${BaseCatalogContactFragmentFragmentDoc}
${BaseCatalogAddressFragmentFragmentDoc}`;

/**
 * __useGetCatalogContactsQuery__
 *
 * To run a query within a React component, call `useGetCatalogContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogContactsQuery({
 *   variables: {
 *      globalOnly: // value for 'globalOnly'
 *      catalogId: // value for 'catalogId'
 *      customerIds: // value for 'customerIds'
 *      contactType: // value for 'contactType'
 *      thisCustomerOnly: // value for 'thisCustomerOnly'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetCatalogContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogContactsQuery, GetCatalogContactsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogContactsQuery, GetCatalogContactsQueryVariables>(GetCatalogContactsDocument, options);
}
export function useGetCatalogContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogContactsQuery, GetCatalogContactsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogContactsQuery, GetCatalogContactsQueryVariables>(GetCatalogContactsDocument, options);
}
export function useGetCatalogContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogContactsQuery, GetCatalogContactsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogContactsQuery, GetCatalogContactsQueryVariables>(GetCatalogContactsDocument, options);
}
export type GetCatalogContactsQueryHookResult = ReturnType<typeof useGetCatalogContactsQuery>;
export type GetCatalogContactsLazyQueryHookResult = ReturnType<typeof useGetCatalogContactsLazyQuery>;
export type GetCatalogContactsSuspenseQueryHookResult = ReturnType<typeof useGetCatalogContactsSuspenseQuery>;
export type GetCatalogContactsQueryResult = Apollo.QueryResult<GetCatalogContactsQuery, GetCatalogContactsQueryVariables>;
export function refetchGetCatalogContactsQuery(variables?: GetCatalogContactsQueryVariables) {
  return { query: GetCatalogContactsDocument, variables: variables }
}
export const UpdateCatalogContactDocument = gql`
    mutation UpdateCatalogContact($id: String!, $customer: String!, $changedBy: String!, $contactName: String!, $email: String, $type: String, $contactType: CatalogContacts!, $globalType: CatalogGlobalType!, $informations: [CatalogPhoneInformationInput]!, $global: Boolean!, $active: Boolean!, $catalogs: [String!], $action: FileActionType!, $catalogsBefore: [String]) {
  updateCatalogContact(
    id: $id
    customer: $customer
    changedBy: $changedBy
    contactName: $contactName
    type: $type
    contactType: $contactType
    globalType: $globalType
    email: $email
    informations: $informations
    global: $global
    active: $active
    catalogs: $catalogs
    action: $action
    catalogsBefore: $catalogsBefore
  ) {
    ...BaseCatalogContactFragment
  }
}
    ${BaseCatalogContactFragmentFragmentDoc}`;
export type UpdateCatalogContactMutationFn = Apollo.MutationFunction<UpdateCatalogContactMutation, UpdateCatalogContactMutationVariables>;

/**
 * __useUpdateCatalogContactMutation__
 *
 * To run a mutation, you first call `useUpdateCatalogContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCatalogContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCatalogContactMutation, { data, loading, error }] = useUpdateCatalogContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customer: // value for 'customer'
 *      changedBy: // value for 'changedBy'
 *      contactName: // value for 'contactName'
 *      email: // value for 'email'
 *      type: // value for 'type'
 *      contactType: // value for 'contactType'
 *      globalType: // value for 'globalType'
 *      informations: // value for 'informations'
 *      global: // value for 'global'
 *      active: // value for 'active'
 *      catalogs: // value for 'catalogs'
 *      action: // value for 'action'
 *      catalogsBefore: // value for 'catalogsBefore'
 *   },
 * });
 */
export function useUpdateCatalogContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCatalogContactMutation, UpdateCatalogContactMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCatalogContactMutation, UpdateCatalogContactMutationVariables>(UpdateCatalogContactDocument, options);
}
export type UpdateCatalogContactMutationHookResult = ReturnType<typeof useUpdateCatalogContactMutation>;
export type UpdateCatalogContactMutationResult = Apollo.MutationResult<UpdateCatalogContactMutation>;
export type UpdateCatalogContactMutationOptions = Apollo.BaseMutationOptions<UpdateCatalogContactMutation, UpdateCatalogContactMutationVariables>;
export const AddCatalogToCraftsmanDocument = gql`
    mutation AddCatalogToCraftsman($craftsmanId: String!, $catalogId: String!, $changedBy: String!) {
  addCatalogToCraftsman(
    craftsmanId: $craftsmanId
    catalogId: $catalogId
    changedBy: $changedBy
  ) {
    ...BaseCatalogCraftsmanFragment
  }
}
    ${BaseCatalogCraftsmanFragmentFragmentDoc}`;
export type AddCatalogToCraftsmanMutationFn = Apollo.MutationFunction<AddCatalogToCraftsmanMutation, AddCatalogToCraftsmanMutationVariables>;

/**
 * __useAddCatalogToCraftsmanMutation__
 *
 * To run a mutation, you first call `useAddCatalogToCraftsmanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCatalogToCraftsmanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCatalogToCraftsmanMutation, { data, loading, error }] = useAddCatalogToCraftsmanMutation({
 *   variables: {
 *      craftsmanId: // value for 'craftsmanId'
 *      catalogId: // value for 'catalogId'
 *      changedBy: // value for 'changedBy'
 *   },
 * });
 */
export function useAddCatalogToCraftsmanMutation(baseOptions?: Apollo.MutationHookOptions<AddCatalogToCraftsmanMutation, AddCatalogToCraftsmanMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddCatalogToCraftsmanMutation, AddCatalogToCraftsmanMutationVariables>(AddCatalogToCraftsmanDocument, options);
}
export type AddCatalogToCraftsmanMutationHookResult = ReturnType<typeof useAddCatalogToCraftsmanMutation>;
export type AddCatalogToCraftsmanMutationResult = Apollo.MutationResult<AddCatalogToCraftsmanMutation>;
export type AddCatalogToCraftsmanMutationOptions = Apollo.BaseMutationOptions<AddCatalogToCraftsmanMutation, AddCatalogToCraftsmanMutationVariables>;
export const CreateCatalogCraftsmanDocument = gql`
    mutation CreateCatalogCraftsman($catalogCraftsman: CatalogCraftsmanInput!) {
  createCatalogCraftsman(catalogCraftsman: $catalogCraftsman) {
    ...BaseCatalogCraftsmanFragment
    catalogs {
      id
      propertyNumber
      addresses {
        ...BaseCatalogAddressFragment
      }
    }
  }
}
    ${BaseCatalogCraftsmanFragmentFragmentDoc}
${BaseCatalogAddressFragmentFragmentDoc}`;
export type CreateCatalogCraftsmanMutationFn = Apollo.MutationFunction<CreateCatalogCraftsmanMutation, CreateCatalogCraftsmanMutationVariables>;

/**
 * __useCreateCatalogCraftsmanMutation__
 *
 * To run a mutation, you first call `useCreateCatalogCraftsmanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCatalogCraftsmanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCatalogCraftsmanMutation, { data, loading, error }] = useCreateCatalogCraftsmanMutation({
 *   variables: {
 *      catalogCraftsman: // value for 'catalogCraftsman'
 *   },
 * });
 */
export function useCreateCatalogCraftsmanMutation(baseOptions?: Apollo.MutationHookOptions<CreateCatalogCraftsmanMutation, CreateCatalogCraftsmanMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCatalogCraftsmanMutation, CreateCatalogCraftsmanMutationVariables>(CreateCatalogCraftsmanDocument, options);
}
export type CreateCatalogCraftsmanMutationHookResult = ReturnType<typeof useCreateCatalogCraftsmanMutation>;
export type CreateCatalogCraftsmanMutationResult = Apollo.MutationResult<CreateCatalogCraftsmanMutation>;
export type CreateCatalogCraftsmanMutationOptions = Apollo.BaseMutationOptions<CreateCatalogCraftsmanMutation, CreateCatalogCraftsmanMutationVariables>;
export const DeleteCatalogCraftsmanDocument = gql`
    mutation DeleteCatalogCraftsman($id: String!, $changedBy: String!) {
  deleteCatalogCraftsman(id: $id, changedBy: $changedBy)
}
    `;
export type DeleteCatalogCraftsmanMutationFn = Apollo.MutationFunction<DeleteCatalogCraftsmanMutation, DeleteCatalogCraftsmanMutationVariables>;

/**
 * __useDeleteCatalogCraftsmanMutation__
 *
 * To run a mutation, you first call `useDeleteCatalogCraftsmanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCatalogCraftsmanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCatalogCraftsmanMutation, { data, loading, error }] = useDeleteCatalogCraftsmanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changedBy: // value for 'changedBy'
 *   },
 * });
 */
export function useDeleteCatalogCraftsmanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCatalogCraftsmanMutation, DeleteCatalogCraftsmanMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCatalogCraftsmanMutation, DeleteCatalogCraftsmanMutationVariables>(DeleteCatalogCraftsmanDocument, options);
}
export type DeleteCatalogCraftsmanMutationHookResult = ReturnType<typeof useDeleteCatalogCraftsmanMutation>;
export type DeleteCatalogCraftsmanMutationResult = Apollo.MutationResult<DeleteCatalogCraftsmanMutation>;
export type DeleteCatalogCraftsmanMutationOptions = Apollo.BaseMutationOptions<DeleteCatalogCraftsmanMutation, DeleteCatalogCraftsmanMutationVariables>;
export const GetCatalogCraftsmanChangesDocument = gql`
    query GetCatalogCraftsmanChanges($id: String!) {
  catalogCraftsman(id: $id) {
    id
    changes {
      timestamp
      user {
        ...BaseUserFragment
      }
      before {
        ...CatalogCraftsmanChangesFragment
      }
      after {
        ...CatalogCraftsmanChangesFragment
      }
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${CatalogCraftsmanChangesFragmentFragmentDoc}`;

/**
 * __useGetCatalogCraftsmanChangesQuery__
 *
 * To run a query within a React component, call `useGetCatalogCraftsmanChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogCraftsmanChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogCraftsmanChangesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatalogCraftsmanChangesQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogCraftsmanChangesQuery, GetCatalogCraftsmanChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogCraftsmanChangesQuery, GetCatalogCraftsmanChangesQueryVariables>(GetCatalogCraftsmanChangesDocument, options);
}
export function useGetCatalogCraftsmanChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogCraftsmanChangesQuery, GetCatalogCraftsmanChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogCraftsmanChangesQuery, GetCatalogCraftsmanChangesQueryVariables>(GetCatalogCraftsmanChangesDocument, options);
}
export function useGetCatalogCraftsmanChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogCraftsmanChangesQuery, GetCatalogCraftsmanChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogCraftsmanChangesQuery, GetCatalogCraftsmanChangesQueryVariables>(GetCatalogCraftsmanChangesDocument, options);
}
export type GetCatalogCraftsmanChangesQueryHookResult = ReturnType<typeof useGetCatalogCraftsmanChangesQuery>;
export type GetCatalogCraftsmanChangesLazyQueryHookResult = ReturnType<typeof useGetCatalogCraftsmanChangesLazyQuery>;
export type GetCatalogCraftsmanChangesSuspenseQueryHookResult = ReturnType<typeof useGetCatalogCraftsmanChangesSuspenseQuery>;
export type GetCatalogCraftsmanChangesQueryResult = Apollo.QueryResult<GetCatalogCraftsmanChangesQuery, GetCatalogCraftsmanChangesQueryVariables>;
export function refetchGetCatalogCraftsmanChangesQuery(variables: GetCatalogCraftsmanChangesQueryVariables) {
  return { query: GetCatalogCraftsmanChangesDocument, variables: variables }
}
export const GetCatalogCraftsmenDocument = gql`
    query GetCatalogCraftsmen($globalOnly: Boolean, $catalogId: String, $customerIds: [String!], $thisCustomerOnly: Boolean, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  catalogCraftsmen(
    globalOnly: $globalOnly
    catalogId: $catalogId
    customerIds: $customerIds
    thisCustomerOnly: $thisCustomerOnly
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    ...BaseCatalogCraftsmanFragment
    catalogs {
      id
      propertyNumber
      addresses {
        ...BaseCatalogAddressFragment
      }
    }
  }
}
    ${BaseCatalogCraftsmanFragmentFragmentDoc}
${BaseCatalogAddressFragmentFragmentDoc}`;

/**
 * __useGetCatalogCraftsmenQuery__
 *
 * To run a query within a React component, call `useGetCatalogCraftsmenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogCraftsmenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogCraftsmenQuery({
 *   variables: {
 *      globalOnly: // value for 'globalOnly'
 *      catalogId: // value for 'catalogId'
 *      customerIds: // value for 'customerIds'
 *      thisCustomerOnly: // value for 'thisCustomerOnly'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetCatalogCraftsmenQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogCraftsmenQuery, GetCatalogCraftsmenQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogCraftsmenQuery, GetCatalogCraftsmenQueryVariables>(GetCatalogCraftsmenDocument, options);
}
export function useGetCatalogCraftsmenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogCraftsmenQuery, GetCatalogCraftsmenQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogCraftsmenQuery, GetCatalogCraftsmenQueryVariables>(GetCatalogCraftsmenDocument, options);
}
export function useGetCatalogCraftsmenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogCraftsmenQuery, GetCatalogCraftsmenQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogCraftsmenQuery, GetCatalogCraftsmenQueryVariables>(GetCatalogCraftsmenDocument, options);
}
export type GetCatalogCraftsmenQueryHookResult = ReturnType<typeof useGetCatalogCraftsmenQuery>;
export type GetCatalogCraftsmenLazyQueryHookResult = ReturnType<typeof useGetCatalogCraftsmenLazyQuery>;
export type GetCatalogCraftsmenSuspenseQueryHookResult = ReturnType<typeof useGetCatalogCraftsmenSuspenseQuery>;
export type GetCatalogCraftsmenQueryResult = Apollo.QueryResult<GetCatalogCraftsmenQuery, GetCatalogCraftsmenQueryVariables>;
export function refetchGetCatalogCraftsmenQuery(variables?: GetCatalogCraftsmenQueryVariables) {
  return { query: GetCatalogCraftsmenDocument, variables: variables }
}
export const GetCatalogCraftsmenForAddExcistingDocument = gql`
    query GetCatalogCraftsmenForAddExcisting($customerIds: [String!], $notGlobalOnly: Boolean) {
  catalogCraftsmen(customerIds: $customerIds, notGlobalOnly: $notGlobalOnly) {
    id
    type
    contactName
    informations {
      phoneNumber
      remark
    }
    email
    priority
  }
}
    `;

/**
 * __useGetCatalogCraftsmenForAddExcistingQuery__
 *
 * To run a query within a React component, call `useGetCatalogCraftsmenForAddExcistingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogCraftsmenForAddExcistingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogCraftsmenForAddExcistingQuery({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *      notGlobalOnly: // value for 'notGlobalOnly'
 *   },
 * });
 */
export function useGetCatalogCraftsmenForAddExcistingQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogCraftsmenForAddExcistingQuery, GetCatalogCraftsmenForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogCraftsmenForAddExcistingQuery, GetCatalogCraftsmenForAddExcistingQueryVariables>(GetCatalogCraftsmenForAddExcistingDocument, options);
}
export function useGetCatalogCraftsmenForAddExcistingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogCraftsmenForAddExcistingQuery, GetCatalogCraftsmenForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogCraftsmenForAddExcistingQuery, GetCatalogCraftsmenForAddExcistingQueryVariables>(GetCatalogCraftsmenForAddExcistingDocument, options);
}
export function useGetCatalogCraftsmenForAddExcistingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogCraftsmenForAddExcistingQuery, GetCatalogCraftsmenForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogCraftsmenForAddExcistingQuery, GetCatalogCraftsmenForAddExcistingQueryVariables>(GetCatalogCraftsmenForAddExcistingDocument, options);
}
export type GetCatalogCraftsmenForAddExcistingQueryHookResult = ReturnType<typeof useGetCatalogCraftsmenForAddExcistingQuery>;
export type GetCatalogCraftsmenForAddExcistingLazyQueryHookResult = ReturnType<typeof useGetCatalogCraftsmenForAddExcistingLazyQuery>;
export type GetCatalogCraftsmenForAddExcistingSuspenseQueryHookResult = ReturnType<typeof useGetCatalogCraftsmenForAddExcistingSuspenseQuery>;
export type GetCatalogCraftsmenForAddExcistingQueryResult = Apollo.QueryResult<GetCatalogCraftsmenForAddExcistingQuery, GetCatalogCraftsmenForAddExcistingQueryVariables>;
export function refetchGetCatalogCraftsmenForAddExcistingQuery(variables?: GetCatalogCraftsmenForAddExcistingQueryVariables) {
  return { query: GetCatalogCraftsmenForAddExcistingDocument, variables: variables }
}
export const UpdateCatalogCraftsmanDocument = gql`
    mutation UpdateCatalogCraftsman($id: String!, $customer: String!, $changedBy: String!, $type: String!, $priority: String!, $contactName: String!, $globalType: CatalogGlobalType!, $email: String, $informations: [CatalogPhoneInformationInput]!, $global: Boolean!, $active: Boolean!, $catalogs: [String!], $action: FileActionType!, $catalogsBefore: [String]) {
  updateCatalogCraftsman(
    id: $id
    customer: $customer
    changedBy: $changedBy
    type: $type
    priority: $priority
    contactName: $contactName
    globalType: $globalType
    email: $email
    informations: $informations
    global: $global
    active: $active
    catalogs: $catalogs
    action: $action
    catalogsBefore: $catalogsBefore
  ) {
    ...BaseCatalogCraftsmanFragment
  }
}
    ${BaseCatalogCraftsmanFragmentFragmentDoc}`;
export type UpdateCatalogCraftsmanMutationFn = Apollo.MutationFunction<UpdateCatalogCraftsmanMutation, UpdateCatalogCraftsmanMutationVariables>;

/**
 * __useUpdateCatalogCraftsmanMutation__
 *
 * To run a mutation, you first call `useUpdateCatalogCraftsmanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCatalogCraftsmanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCatalogCraftsmanMutation, { data, loading, error }] = useUpdateCatalogCraftsmanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customer: // value for 'customer'
 *      changedBy: // value for 'changedBy'
 *      type: // value for 'type'
 *      priority: // value for 'priority'
 *      contactName: // value for 'contactName'
 *      globalType: // value for 'globalType'
 *      email: // value for 'email'
 *      informations: // value for 'informations'
 *      global: // value for 'global'
 *      active: // value for 'active'
 *      catalogs: // value for 'catalogs'
 *      action: // value for 'action'
 *      catalogsBefore: // value for 'catalogsBefore'
 *   },
 * });
 */
export function useUpdateCatalogCraftsmanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCatalogCraftsmanMutation, UpdateCatalogCraftsmanMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCatalogCraftsmanMutation, UpdateCatalogCraftsmanMutationVariables>(UpdateCatalogCraftsmanDocument, options);
}
export type UpdateCatalogCraftsmanMutationHookResult = ReturnType<typeof useUpdateCatalogCraftsmanMutation>;
export type UpdateCatalogCraftsmanMutationResult = Apollo.MutationResult<UpdateCatalogCraftsmanMutation>;
export type UpdateCatalogCraftsmanMutationOptions = Apollo.BaseMutationOptions<UpdateCatalogCraftsmanMutation, UpdateCatalogCraftsmanMutationVariables>;
export const GetCatalogCustomerByAdIdDocument = gql`
    query GetCatalogCustomerByAdId($id: String!) {
  catalogCustomerByAdId(id: $id) {
    ...BaseCatalogCustomerFragment
  }
}
    ${BaseCatalogCustomerFragmentFragmentDoc}`;

/**
 * __useGetCatalogCustomerByAdIdQuery__
 *
 * To run a query within a React component, call `useGetCatalogCustomerByAdIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogCustomerByAdIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogCustomerByAdIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatalogCustomerByAdIdQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogCustomerByAdIdQuery, GetCatalogCustomerByAdIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogCustomerByAdIdQuery, GetCatalogCustomerByAdIdQueryVariables>(GetCatalogCustomerByAdIdDocument, options);
}
export function useGetCatalogCustomerByAdIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogCustomerByAdIdQuery, GetCatalogCustomerByAdIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogCustomerByAdIdQuery, GetCatalogCustomerByAdIdQueryVariables>(GetCatalogCustomerByAdIdDocument, options);
}
export function useGetCatalogCustomerByAdIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogCustomerByAdIdQuery, GetCatalogCustomerByAdIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogCustomerByAdIdQuery, GetCatalogCustomerByAdIdQueryVariables>(GetCatalogCustomerByAdIdDocument, options);
}
export type GetCatalogCustomerByAdIdQueryHookResult = ReturnType<typeof useGetCatalogCustomerByAdIdQuery>;
export type GetCatalogCustomerByAdIdLazyQueryHookResult = ReturnType<typeof useGetCatalogCustomerByAdIdLazyQuery>;
export type GetCatalogCustomerByAdIdSuspenseQueryHookResult = ReturnType<typeof useGetCatalogCustomerByAdIdSuspenseQuery>;
export type GetCatalogCustomerByAdIdQueryResult = Apollo.QueryResult<GetCatalogCustomerByAdIdQuery, GetCatalogCustomerByAdIdQueryVariables>;
export function refetchGetCatalogCustomerByAdIdQuery(variables: GetCatalogCustomerByAdIdQueryVariables) {
  return { query: GetCatalogCustomerByAdIdDocument, variables: variables }
}
export const GetWebCatalogCustomersDocument = gql`
    query GetWebCatalogCustomers($ownCustomers: Boolean) {
  catalogCustomers(ownCustomers: $ownCustomers) {
    id
    name
  }
}
    `;

/**
 * __useGetWebCatalogCustomersQuery__
 *
 * To run a query within a React component, call `useGetWebCatalogCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCatalogCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCatalogCustomersQuery({
 *   variables: {
 *      ownCustomers: // value for 'ownCustomers'
 *   },
 * });
 */
export function useGetWebCatalogCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetWebCatalogCustomersQuery, GetWebCatalogCustomersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCatalogCustomersQuery, GetWebCatalogCustomersQueryVariables>(GetWebCatalogCustomersDocument, options);
}
export function useGetWebCatalogCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCatalogCustomersQuery, GetWebCatalogCustomersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCatalogCustomersQuery, GetWebCatalogCustomersQueryVariables>(GetWebCatalogCustomersDocument, options);
}
export function useGetWebCatalogCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCatalogCustomersQuery, GetWebCatalogCustomersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCatalogCustomersQuery, GetWebCatalogCustomersQueryVariables>(GetWebCatalogCustomersDocument, options);
}
export type GetWebCatalogCustomersQueryHookResult = ReturnType<typeof useGetWebCatalogCustomersQuery>;
export type GetWebCatalogCustomersLazyQueryHookResult = ReturnType<typeof useGetWebCatalogCustomersLazyQuery>;
export type GetWebCatalogCustomersSuspenseQueryHookResult = ReturnType<typeof useGetWebCatalogCustomersSuspenseQuery>;
export type GetWebCatalogCustomersQueryResult = Apollo.QueryResult<GetWebCatalogCustomersQuery, GetWebCatalogCustomersQueryVariables>;
export function refetchGetWebCatalogCustomersQuery(variables?: GetWebCatalogCustomersQueryVariables) {
  return { query: GetWebCatalogCustomersDocument, variables: variables }
}
export const CreateCatalogDocument = gql`
    mutation CreateCatalog($catalog: CatalogInput!) {
  createCatalog(catalog: $catalog) {
    ...CatalogFragment
  }
}
    ${CatalogFragmentFragmentDoc}`;
export type CreateCatalogMutationFn = Apollo.MutationFunction<CreateCatalogMutation, CreateCatalogMutationVariables>;

/**
 * __useCreateCatalogMutation__
 *
 * To run a mutation, you first call `useCreateCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCatalogMutation, { data, loading, error }] = useCreateCatalogMutation({
 *   variables: {
 *      catalog: // value for 'catalog'
 *   },
 * });
 */
export function useCreateCatalogMutation(baseOptions?: Apollo.MutationHookOptions<CreateCatalogMutation, CreateCatalogMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCatalogMutation, CreateCatalogMutationVariables>(CreateCatalogDocument, options);
}
export type CreateCatalogMutationHookResult = ReturnType<typeof useCreateCatalogMutation>;
export type CreateCatalogMutationResult = Apollo.MutationResult<CreateCatalogMutation>;
export type CreateCatalogMutationOptions = Apollo.BaseMutationOptions<CreateCatalogMutation, CreateCatalogMutationVariables>;
export const CreateCatalogsDocument = gql`
    mutation CreateCatalogs($catalogs: [CatalogInput!]!) {
  createCatalogs(catalogs: $catalogs) {
    ...CatalogFragment
  }
}
    ${CatalogFragmentFragmentDoc}`;
export type CreateCatalogsMutationFn = Apollo.MutationFunction<CreateCatalogsMutation, CreateCatalogsMutationVariables>;

/**
 * __useCreateCatalogsMutation__
 *
 * To run a mutation, you first call `useCreateCatalogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCatalogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCatalogsMutation, { data, loading, error }] = useCreateCatalogsMutation({
 *   variables: {
 *      catalogs: // value for 'catalogs'
 *   },
 * });
 */
export function useCreateCatalogsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCatalogsMutation, CreateCatalogsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCatalogsMutation, CreateCatalogsMutationVariables>(CreateCatalogsDocument, options);
}
export type CreateCatalogsMutationHookResult = ReturnType<typeof useCreateCatalogsMutation>;
export type CreateCatalogsMutationResult = Apollo.MutationResult<CreateCatalogsMutation>;
export type CreateCatalogsMutationOptions = Apollo.BaseMutationOptions<CreateCatalogsMutation, CreateCatalogsMutationVariables>;
export const DeleteCatalogDocument = gql`
    mutation DeleteCatalog($id: String!, $changedBy: String!) {
  deleteCatalog(id: $id, changedBy: $changedBy) {
    _
  }
}
    `;
export type DeleteCatalogMutationFn = Apollo.MutationFunction<DeleteCatalogMutation, DeleteCatalogMutationVariables>;

/**
 * __useDeleteCatalogMutation__
 *
 * To run a mutation, you first call `useDeleteCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCatalogMutation, { data, loading, error }] = useDeleteCatalogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changedBy: // value for 'changedBy'
 *   },
 * });
 */
export function useDeleteCatalogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCatalogMutation, DeleteCatalogMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCatalogMutation, DeleteCatalogMutationVariables>(DeleteCatalogDocument, options);
}
export type DeleteCatalogMutationHookResult = ReturnType<typeof useDeleteCatalogMutation>;
export type DeleteCatalogMutationResult = Apollo.MutationResult<DeleteCatalogMutation>;
export type DeleteCatalogMutationOptions = Apollo.BaseMutationOptions<DeleteCatalogMutation, DeleteCatalogMutationVariables>;
export const GetCatalogDocument = gql`
    query GetCatalog($id: String!) {
  catalog(id: $id) {
    ...CatalogFragment
  }
}
    ${CatalogFragmentFragmentDoc}`;

/**
 * __useGetCatalogQuery__
 *
 * To run a query within a React component, call `useGetCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatalogQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogQuery, GetCatalogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogQuery, GetCatalogQueryVariables>(GetCatalogDocument, options);
}
export function useGetCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogQuery, GetCatalogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogQuery, GetCatalogQueryVariables>(GetCatalogDocument, options);
}
export function useGetCatalogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogQuery, GetCatalogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogQuery, GetCatalogQueryVariables>(GetCatalogDocument, options);
}
export type GetCatalogQueryHookResult = ReturnType<typeof useGetCatalogQuery>;
export type GetCatalogLazyQueryHookResult = ReturnType<typeof useGetCatalogLazyQuery>;
export type GetCatalogSuspenseQueryHookResult = ReturnType<typeof useGetCatalogSuspenseQuery>;
export type GetCatalogQueryResult = Apollo.QueryResult<GetCatalogQuery, GetCatalogQueryVariables>;
export function refetchGetCatalogQuery(variables: GetCatalogQueryVariables) {
  return { query: GetCatalogDocument, variables: variables }
}
export const GetCatalogCaseCreationDocument = gql`
    query GetCatalogCaseCreation($id: String!) {
  catalog(id: $id) {
    id
    debitor {
      id
      debitorId
      company
    }
    addresses {
      addressLine
      zipCode
      city
      startNumber
    }
  }
}
    `;

/**
 * __useGetCatalogCaseCreationQuery__
 *
 * To run a query within a React component, call `useGetCatalogCaseCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogCaseCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogCaseCreationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatalogCaseCreationQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogCaseCreationQuery, GetCatalogCaseCreationQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogCaseCreationQuery, GetCatalogCaseCreationQueryVariables>(GetCatalogCaseCreationDocument, options);
}
export function useGetCatalogCaseCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogCaseCreationQuery, GetCatalogCaseCreationQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogCaseCreationQuery, GetCatalogCaseCreationQueryVariables>(GetCatalogCaseCreationDocument, options);
}
export function useGetCatalogCaseCreationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogCaseCreationQuery, GetCatalogCaseCreationQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogCaseCreationQuery, GetCatalogCaseCreationQueryVariables>(GetCatalogCaseCreationDocument, options);
}
export type GetCatalogCaseCreationQueryHookResult = ReturnType<typeof useGetCatalogCaseCreationQuery>;
export type GetCatalogCaseCreationLazyQueryHookResult = ReturnType<typeof useGetCatalogCaseCreationLazyQuery>;
export type GetCatalogCaseCreationSuspenseQueryHookResult = ReturnType<typeof useGetCatalogCaseCreationSuspenseQuery>;
export type GetCatalogCaseCreationQueryResult = Apollo.QueryResult<GetCatalogCaseCreationQuery, GetCatalogCaseCreationQueryVariables>;
export function refetchGetCatalogCaseCreationQuery(variables: GetCatalogCaseCreationQueryVariables) {
  return { query: GetCatalogCaseCreationDocument, variables: variables }
}
export const GetCatalogChangesDocument = gql`
    query GetCatalogChanges($id: String!) {
  catalog(id: $id) {
    version
    changes {
      timestamp
      user {
        ...BaseUserFragment
      }
      changedBy
      before {
        ...CatalogChangesFragment
      }
      after {
        ...CatalogChangesFragment
      }
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${CatalogChangesFragmentFragmentDoc}`;

/**
 * __useGetCatalogChangesQuery__
 *
 * To run a query within a React component, call `useGetCatalogChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogChangesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatalogChangesQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogChangesQuery, GetCatalogChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogChangesQuery, GetCatalogChangesQueryVariables>(GetCatalogChangesDocument, options);
}
export function useGetCatalogChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogChangesQuery, GetCatalogChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogChangesQuery, GetCatalogChangesQueryVariables>(GetCatalogChangesDocument, options);
}
export function useGetCatalogChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogChangesQuery, GetCatalogChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogChangesQuery, GetCatalogChangesQueryVariables>(GetCatalogChangesDocument, options);
}
export type GetCatalogChangesQueryHookResult = ReturnType<typeof useGetCatalogChangesQuery>;
export type GetCatalogChangesLazyQueryHookResult = ReturnType<typeof useGetCatalogChangesLazyQuery>;
export type GetCatalogChangesSuspenseQueryHookResult = ReturnType<typeof useGetCatalogChangesSuspenseQuery>;
export type GetCatalogChangesQueryResult = Apollo.QueryResult<GetCatalogChangesQuery, GetCatalogChangesQueryVariables>;
export function refetchGetCatalogChangesQuery(variables: GetCatalogChangesQueryVariables) {
  return { query: GetCatalogChangesDocument, variables: variables }
}
export const GetCatalogsForDropdownDocument = gql`
    query GetCatalogsForDropdown($thisCustomerOnly: Boolean, $customerIds: [String!]) {
  catalogs(thisCustomerOnly: $thisCustomerOnly, customerIds: $customerIds) {
    id
    propertyNumber
    customer {
      id
    }
  }
}
    `;

/**
 * __useGetCatalogsForDropdownQuery__
 *
 * To run a query within a React component, call `useGetCatalogsForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogsForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogsForDropdownQuery({
 *   variables: {
 *      thisCustomerOnly: // value for 'thisCustomerOnly'
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useGetCatalogsForDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogsForDropdownQuery, GetCatalogsForDropdownQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogsForDropdownQuery, GetCatalogsForDropdownQueryVariables>(GetCatalogsForDropdownDocument, options);
}
export function useGetCatalogsForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogsForDropdownQuery, GetCatalogsForDropdownQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogsForDropdownQuery, GetCatalogsForDropdownQueryVariables>(GetCatalogsForDropdownDocument, options);
}
export function useGetCatalogsForDropdownSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogsForDropdownQuery, GetCatalogsForDropdownQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogsForDropdownQuery, GetCatalogsForDropdownQueryVariables>(GetCatalogsForDropdownDocument, options);
}
export type GetCatalogsForDropdownQueryHookResult = ReturnType<typeof useGetCatalogsForDropdownQuery>;
export type GetCatalogsForDropdownLazyQueryHookResult = ReturnType<typeof useGetCatalogsForDropdownLazyQuery>;
export type GetCatalogsForDropdownSuspenseQueryHookResult = ReturnType<typeof useGetCatalogsForDropdownSuspenseQuery>;
export type GetCatalogsForDropdownQueryResult = Apollo.QueryResult<GetCatalogsForDropdownQuery, GetCatalogsForDropdownQueryVariables>;
export function refetchGetCatalogsForDropdownQuery(variables?: GetCatalogsForDropdownQueryVariables) {
  return { query: GetCatalogsForDropdownDocument, variables: variables }
}
export const GetLatestCatalogDocument = gql`
    query GetLatestCatalog($date: Date!) {
  latestCatalog(date: $date) {
    ...BaseCatalogFragment
  }
}
    ${BaseCatalogFragmentFragmentDoc}`;

/**
 * __useGetLatestCatalogQuery__
 *
 * To run a query within a React component, call `useGetLatestCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestCatalogQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetLatestCatalogQuery(baseOptions: Apollo.QueryHookOptions<GetLatestCatalogQuery, GetLatestCatalogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLatestCatalogQuery, GetLatestCatalogQueryVariables>(GetLatestCatalogDocument, options);
}
export function useGetLatestCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestCatalogQuery, GetLatestCatalogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetLatestCatalogQuery, GetLatestCatalogQueryVariables>(GetLatestCatalogDocument, options);
}
export function useGetLatestCatalogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestCatalogQuery, GetLatestCatalogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetLatestCatalogQuery, GetLatestCatalogQueryVariables>(GetLatestCatalogDocument, options);
}
export type GetLatestCatalogQueryHookResult = ReturnType<typeof useGetLatestCatalogQuery>;
export type GetLatestCatalogLazyQueryHookResult = ReturnType<typeof useGetLatestCatalogLazyQuery>;
export type GetLatestCatalogSuspenseQueryHookResult = ReturnType<typeof useGetLatestCatalogSuspenseQuery>;
export type GetLatestCatalogQueryResult = Apollo.QueryResult<GetLatestCatalogQuery, GetLatestCatalogQueryVariables>;
export function refetchGetLatestCatalogQuery(variables: GetLatestCatalogQueryVariables) {
  return { query: GetLatestCatalogDocument, variables: variables }
}
export const GetWebCatalogsDocument = gql`
    query GetWebCatalogs($debitors: [String!], $smsService: Boolean, $verified: Boolean, $debitorVerified: Boolean, $address: AddressInput, $noDebitor: Boolean, $thisCustomerOnly: Boolean, $offset: Int, $limit: Int, $searchString: String, $customerIds: [String!], $excludeTotalCount: Boolean) {
  catalogs(
    debitors: $debitors
    smsService: $smsService
    verified: $verified
    debitorVerified: $debitorVerified
    address: $address
    noDebitor: $noDebitor
    thisCustomerOnly: $thisCustomerOnly
    offset: $offset
    limit: $limit
    searchString: $searchString
    customerIds: $customerIds
    excludeTotalCount: $excludeTotalCount
  ) {
    ...BaseCatalogFragment
  }
}
    ${BaseCatalogFragmentFragmentDoc}`;

/**
 * __useGetWebCatalogsQuery__
 *
 * To run a query within a React component, call `useGetWebCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCatalogsQuery({
 *   variables: {
 *      debitors: // value for 'debitors'
 *      smsService: // value for 'smsService'
 *      verified: // value for 'verified'
 *      debitorVerified: // value for 'debitorVerified'
 *      address: // value for 'address'
 *      noDebitor: // value for 'noDebitor'
 *      thisCustomerOnly: // value for 'thisCustomerOnly'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      customerIds: // value for 'customerIds'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetWebCatalogsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebCatalogsQuery, GetWebCatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCatalogsQuery, GetWebCatalogsQueryVariables>(GetWebCatalogsDocument, options);
}
export function useGetWebCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCatalogsQuery, GetWebCatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCatalogsQuery, GetWebCatalogsQueryVariables>(GetWebCatalogsDocument, options);
}
export function useGetWebCatalogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCatalogsQuery, GetWebCatalogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCatalogsQuery, GetWebCatalogsQueryVariables>(GetWebCatalogsDocument, options);
}
export type GetWebCatalogsQueryHookResult = ReturnType<typeof useGetWebCatalogsQuery>;
export type GetWebCatalogsLazyQueryHookResult = ReturnType<typeof useGetWebCatalogsLazyQuery>;
export type GetWebCatalogsSuspenseQueryHookResult = ReturnType<typeof useGetWebCatalogsSuspenseQuery>;
export type GetWebCatalogsQueryResult = Apollo.QueryResult<GetWebCatalogsQuery, GetWebCatalogsQueryVariables>;
export function refetchGetWebCatalogsQuery(variables?: GetWebCatalogsQueryVariables) {
  return { query: GetWebCatalogsDocument, variables: variables }
}
export const UpdateCatalogDocument = gql`
    mutation UpdateCatalog($id: String!, $propertyNumber: String!, $customer: String!, $changedBy: String!, $description: String, $contactNumber: String, $contactHours: String, $addresses: [CatalogAddressInput!], $smsService: Boolean!, $debitor: String, $ssgAccountable: String, $verified: Boolean!, $debitorVerified: Boolean!) {
  updateCatalog(
    id: $id
    propertyNumber: $propertyNumber
    customer: $customer
    changedBy: $changedBy
    description: $description
    contactNumber: $contactNumber
    contactHours: $contactHours
    addresses: $addresses
    smsService: $smsService
    debitor: $debitor
    ssgAccountable: $ssgAccountable
    verified: $verified
    debitorVerified: $debitorVerified
  ) {
    ...CatalogFragment
  }
}
    ${CatalogFragmentFragmentDoc}`;
export type UpdateCatalogMutationFn = Apollo.MutationFunction<UpdateCatalogMutation, UpdateCatalogMutationVariables>;

/**
 * __useUpdateCatalogMutation__
 *
 * To run a mutation, you first call `useUpdateCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCatalogMutation, { data, loading, error }] = useUpdateCatalogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      propertyNumber: // value for 'propertyNumber'
 *      customer: // value for 'customer'
 *      changedBy: // value for 'changedBy'
 *      description: // value for 'description'
 *      contactNumber: // value for 'contactNumber'
 *      contactHours: // value for 'contactHours'
 *      addresses: // value for 'addresses'
 *      smsService: // value for 'smsService'
 *      debitor: // value for 'debitor'
 *      ssgAccountable: // value for 'ssgAccountable'
 *      verified: // value for 'verified'
 *      debitorVerified: // value for 'debitorVerified'
 *   },
 * });
 */
export function useUpdateCatalogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCatalogMutation, UpdateCatalogMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCatalogMutation, UpdateCatalogMutationVariables>(UpdateCatalogDocument, options);
}
export type UpdateCatalogMutationHookResult = ReturnType<typeof useUpdateCatalogMutation>;
export type UpdateCatalogMutationResult = Apollo.MutationResult<UpdateCatalogMutation>;
export type UpdateCatalogMutationOptions = Apollo.BaseMutationOptions<UpdateCatalogMutation, UpdateCatalogMutationVariables>;
export const UpdateCatalogsDocument = gql`
    mutation UpdateCatalogs($catalogs: [CatalogBatchInput]!) {
  updateCatalogs(catalogs: $catalogs) {
    ...CatalogFragment
  }
}
    ${CatalogFragmentFragmentDoc}`;
export type UpdateCatalogsMutationFn = Apollo.MutationFunction<UpdateCatalogsMutation, UpdateCatalogsMutationVariables>;

/**
 * __useUpdateCatalogsMutation__
 *
 * To run a mutation, you first call `useUpdateCatalogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCatalogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCatalogsMutation, { data, loading, error }] = useUpdateCatalogsMutation({
 *   variables: {
 *      catalogs: // value for 'catalogs'
 *   },
 * });
 */
export function useUpdateCatalogsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCatalogsMutation, UpdateCatalogsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCatalogsMutation, UpdateCatalogsMutationVariables>(UpdateCatalogsDocument, options);
}
export type UpdateCatalogsMutationHookResult = ReturnType<typeof useUpdateCatalogsMutation>;
export type UpdateCatalogsMutationResult = Apollo.MutationResult<UpdateCatalogsMutation>;
export type UpdateCatalogsMutationOptions = Apollo.BaseMutationOptions<UpdateCatalogsMutation, UpdateCatalogsMutationVariables>;
export const GetWebDamageCategoriesDocument = gql`
    query GetWebDamageCategories {
  damageCategories {
    ...BaseDamageCategoryFragment
  }
}
    ${BaseDamageCategoryFragmentFragmentDoc}`;

/**
 * __useGetWebDamageCategoriesQuery__
 *
 * To run a query within a React component, call `useGetWebDamageCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebDamageCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebDamageCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebDamageCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetWebDamageCategoriesQuery, GetWebDamageCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebDamageCategoriesQuery, GetWebDamageCategoriesQueryVariables>(GetWebDamageCategoriesDocument, options);
}
export function useGetWebDamageCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebDamageCategoriesQuery, GetWebDamageCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebDamageCategoriesQuery, GetWebDamageCategoriesQueryVariables>(GetWebDamageCategoriesDocument, options);
}
export function useGetWebDamageCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebDamageCategoriesQuery, GetWebDamageCategoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebDamageCategoriesQuery, GetWebDamageCategoriesQueryVariables>(GetWebDamageCategoriesDocument, options);
}
export type GetWebDamageCategoriesQueryHookResult = ReturnType<typeof useGetWebDamageCategoriesQuery>;
export type GetWebDamageCategoriesLazyQueryHookResult = ReturnType<typeof useGetWebDamageCategoriesLazyQuery>;
export type GetWebDamageCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetWebDamageCategoriesSuspenseQuery>;
export type GetWebDamageCategoriesQueryResult = Apollo.QueryResult<GetWebDamageCategoriesQuery, GetWebDamageCategoriesQueryVariables>;
export function refetchGetWebDamageCategoriesQuery(variables?: GetWebDamageCategoriesQueryVariables) {
  return { query: GetWebDamageCategoriesDocument, variables: variables }
}
export const GetWebDamageCausesDocument = gql`
    query GetWebDamageCauses {
  damageCauses {
    ...BaseDamageCauseFragment
  }
}
    ${BaseDamageCauseFragmentFragmentDoc}`;

/**
 * __useGetWebDamageCausesQuery__
 *
 * To run a query within a React component, call `useGetWebDamageCausesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebDamageCausesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebDamageCausesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebDamageCausesQuery(baseOptions?: Apollo.QueryHookOptions<GetWebDamageCausesQuery, GetWebDamageCausesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebDamageCausesQuery, GetWebDamageCausesQueryVariables>(GetWebDamageCausesDocument, options);
}
export function useGetWebDamageCausesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebDamageCausesQuery, GetWebDamageCausesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebDamageCausesQuery, GetWebDamageCausesQueryVariables>(GetWebDamageCausesDocument, options);
}
export function useGetWebDamageCausesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebDamageCausesQuery, GetWebDamageCausesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebDamageCausesQuery, GetWebDamageCausesQueryVariables>(GetWebDamageCausesDocument, options);
}
export type GetWebDamageCausesQueryHookResult = ReturnType<typeof useGetWebDamageCausesQuery>;
export type GetWebDamageCausesLazyQueryHookResult = ReturnType<typeof useGetWebDamageCausesLazyQuery>;
export type GetWebDamageCausesSuspenseQueryHookResult = ReturnType<typeof useGetWebDamageCausesSuspenseQuery>;
export type GetWebDamageCausesQueryResult = Apollo.QueryResult<GetWebDamageCausesQuery, GetWebDamageCausesQueryVariables>;
export function refetchGetWebDamageCausesQuery(variables?: GetWebDamageCausesQueryVariables) {
  return { query: GetWebDamageCausesDocument, variables: variables }
}
export const GetDebitorDocument = gql`
    query GetDebitor($id: String!) {
  debitor(id: $id) {
    debitorId
    type
    gln
    phone
    email
    address {
      addressLine
      addressLineAlt
      postalCode
      city
    }
    company
    createInECB
    callCenterActive
    assortmentCode
    environmentFeePercentage
    maxEnvironmentFeeAmount
    supplyFeePercentage
    maxSupplyFeeAmount
    priorityCustomer
  }
}
    `;

/**
 * __useGetDebitorQuery__
 *
 * To run a query within a React component, call `useGetDebitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDebitorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDebitorQuery(baseOptions: Apollo.QueryHookOptions<GetDebitorQuery, GetDebitorQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDebitorQuery, GetDebitorQueryVariables>(GetDebitorDocument, options);
}
export function useGetDebitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDebitorQuery, GetDebitorQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDebitorQuery, GetDebitorQueryVariables>(GetDebitorDocument, options);
}
export function useGetDebitorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDebitorQuery, GetDebitorQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDebitorQuery, GetDebitorQueryVariables>(GetDebitorDocument, options);
}
export type GetDebitorQueryHookResult = ReturnType<typeof useGetDebitorQuery>;
export type GetDebitorLazyQueryHookResult = ReturnType<typeof useGetDebitorLazyQuery>;
export type GetDebitorSuspenseQueryHookResult = ReturnType<typeof useGetDebitorSuspenseQuery>;
export type GetDebitorQueryResult = Apollo.QueryResult<GetDebitorQuery, GetDebitorQueryVariables>;
export function refetchGetDebitorQuery(variables: GetDebitorQueryVariables) {
  return { query: GetDebitorDocument, variables: variables }
}
export const GetDebitorDelayScalepointConnectionDocument = gql`
    query GetDebitorDelayScalepointConnection($debitorId: String!, $damageCauseId: String!) {
  debitorDelayScalepointConnection(
    debitorId: $debitorId
    damageCauseId: $damageCauseId
  ) {
    id
  }
}
    `;

/**
 * __useGetDebitorDelayScalepointConnectionQuery__
 *
 * To run a query within a React component, call `useGetDebitorDelayScalepointConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitorDelayScalepointConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDebitorDelayScalepointConnectionQuery({
 *   variables: {
 *      debitorId: // value for 'debitorId'
 *      damageCauseId: // value for 'damageCauseId'
 *   },
 * });
 */
export function useGetDebitorDelayScalepointConnectionQuery(baseOptions: Apollo.QueryHookOptions<GetDebitorDelayScalepointConnectionQuery, GetDebitorDelayScalepointConnectionQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDebitorDelayScalepointConnectionQuery, GetDebitorDelayScalepointConnectionQueryVariables>(GetDebitorDelayScalepointConnectionDocument, options);
}
export function useGetDebitorDelayScalepointConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDebitorDelayScalepointConnectionQuery, GetDebitorDelayScalepointConnectionQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDebitorDelayScalepointConnectionQuery, GetDebitorDelayScalepointConnectionQueryVariables>(GetDebitorDelayScalepointConnectionDocument, options);
}
export function useGetDebitorDelayScalepointConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDebitorDelayScalepointConnectionQuery, GetDebitorDelayScalepointConnectionQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDebitorDelayScalepointConnectionQuery, GetDebitorDelayScalepointConnectionQueryVariables>(GetDebitorDelayScalepointConnectionDocument, options);
}
export type GetDebitorDelayScalepointConnectionQueryHookResult = ReturnType<typeof useGetDebitorDelayScalepointConnectionQuery>;
export type GetDebitorDelayScalepointConnectionLazyQueryHookResult = ReturnType<typeof useGetDebitorDelayScalepointConnectionLazyQuery>;
export type GetDebitorDelayScalepointConnectionSuspenseQueryHookResult = ReturnType<typeof useGetDebitorDelayScalepointConnectionSuspenseQuery>;
export type GetDebitorDelayScalepointConnectionQueryResult = Apollo.QueryResult<GetDebitorDelayScalepointConnectionQuery, GetDebitorDelayScalepointConnectionQueryVariables>;
export function refetchGetDebitorDelayScalepointConnectionQuery(variables: GetDebitorDelayScalepointConnectionQueryVariables) {
  return { query: GetDebitorDelayScalepointConnectionDocument, variables: variables }
}
export const GetDebitorShipmentAddressesDocument = gql`
    query GetDebitorShipmentAddresses($id: String!) {
  debitorShipmentAddresses(id: $id) {
    id
    gln
    name
    address {
      addressLine
      addressLineAlt
      postalCode
      city
    }
  }
}
    `;

/**
 * __useGetDebitorShipmentAddressesQuery__
 *
 * To run a query within a React component, call `useGetDebitorShipmentAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitorShipmentAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDebitorShipmentAddressesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDebitorShipmentAddressesQuery(baseOptions: Apollo.QueryHookOptions<GetDebitorShipmentAddressesQuery, GetDebitorShipmentAddressesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDebitorShipmentAddressesQuery, GetDebitorShipmentAddressesQueryVariables>(GetDebitorShipmentAddressesDocument, options);
}
export function useGetDebitorShipmentAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDebitorShipmentAddressesQuery, GetDebitorShipmentAddressesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDebitorShipmentAddressesQuery, GetDebitorShipmentAddressesQueryVariables>(GetDebitorShipmentAddressesDocument, options);
}
export function useGetDebitorShipmentAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDebitorShipmentAddressesQuery, GetDebitorShipmentAddressesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDebitorShipmentAddressesQuery, GetDebitorShipmentAddressesQueryVariables>(GetDebitorShipmentAddressesDocument, options);
}
export type GetDebitorShipmentAddressesQueryHookResult = ReturnType<typeof useGetDebitorShipmentAddressesQuery>;
export type GetDebitorShipmentAddressesLazyQueryHookResult = ReturnType<typeof useGetDebitorShipmentAddressesLazyQuery>;
export type GetDebitorShipmentAddressesSuspenseQueryHookResult = ReturnType<typeof useGetDebitorShipmentAddressesSuspenseQuery>;
export type GetDebitorShipmentAddressesQueryResult = Apollo.QueryResult<GetDebitorShipmentAddressesQuery, GetDebitorShipmentAddressesQueryVariables>;
export function refetchGetDebitorShipmentAddressesQuery(variables: GetDebitorShipmentAddressesQueryVariables) {
  return { query: GetDebitorShipmentAddressesDocument, variables: variables }
}
export const GetWebDebitorsDocument = gql`
    query GetWebDebitors($searchText: String!, $catalogUser: String) {
  debitors(searchText: $searchText, catalogUser: $catalogUser) {
    debitorId
    type
    gln
    phone
    email
    address {
      addressLine
      addressLineAlt
      postalCode
      city
    }
    company
    createInECB
    callCenterActive
  }
}
    `;

/**
 * __useGetWebDebitorsQuery__
 *
 * To run a query within a React component, call `useGetWebDebitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebDebitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebDebitorsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      catalogUser: // value for 'catalogUser'
 *   },
 * });
 */
export function useGetWebDebitorsQuery(baseOptions: Apollo.QueryHookOptions<GetWebDebitorsQuery, GetWebDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebDebitorsQuery, GetWebDebitorsQueryVariables>(GetWebDebitorsDocument, options);
}
export function useGetWebDebitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebDebitorsQuery, GetWebDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebDebitorsQuery, GetWebDebitorsQueryVariables>(GetWebDebitorsDocument, options);
}
export function useGetWebDebitorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebDebitorsQuery, GetWebDebitorsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebDebitorsQuery, GetWebDebitorsQueryVariables>(GetWebDebitorsDocument, options);
}
export type GetWebDebitorsQueryHookResult = ReturnType<typeof useGetWebDebitorsQuery>;
export type GetWebDebitorsLazyQueryHookResult = ReturnType<typeof useGetWebDebitorsLazyQuery>;
export type GetWebDebitorsSuspenseQueryHookResult = ReturnType<typeof useGetWebDebitorsSuspenseQuery>;
export type GetWebDebitorsQueryResult = Apollo.QueryResult<GetWebDebitorsQuery, GetWebDebitorsQueryVariables>;
export function refetchGetWebDebitorsQuery(variables: GetWebDebitorsQueryVariables) {
  return { query: GetWebDebitorsDocument, variables: variables }
}
export const UpdateDebitorDocument = gql`
    mutation UpdateDebitor($no: String!, $company: String, $addressLine: String, $addressLineAlt: String, $postalCode: String, $city: String, $country: String) {
  updateDebitor(
    no: $no
    company: $company
    addressLine: $addressLine
    addressLineAlt: $addressLineAlt
    postalCode: $postalCode
    city: $city
    country: $country
  )
}
    `;
export type UpdateDebitorMutationFn = Apollo.MutationFunction<UpdateDebitorMutation, UpdateDebitorMutationVariables>;

/**
 * __useUpdateDebitorMutation__
 *
 * To run a mutation, you first call `useUpdateDebitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDebitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDebitorMutation, { data, loading, error }] = useUpdateDebitorMutation({
 *   variables: {
 *      no: // value for 'no'
 *      company: // value for 'company'
 *      addressLine: // value for 'addressLine'
 *      addressLineAlt: // value for 'addressLineAlt'
 *      postalCode: // value for 'postalCode'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useUpdateDebitorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDebitorMutation, UpdateDebitorMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateDebitorMutation, UpdateDebitorMutationVariables>(UpdateDebitorDocument, options);
}
export type UpdateDebitorMutationHookResult = ReturnType<typeof useUpdateDebitorMutation>;
export type UpdateDebitorMutationResult = Apollo.MutationResult<UpdateDebitorMutation>;
export type UpdateDebitorMutationOptions = Apollo.BaseMutationOptions<UpdateDebitorMutation, UpdateDebitorMutationVariables>;
export const GetRequisitionDepartmentsDocument = gql`
    query GetRequisitionDepartments {
  departmentsRequisition {
    ...BaseDepartmentFragment
  }
}
    ${BaseDepartmentFragmentFragmentDoc}`;

/**
 * __useGetRequisitionDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetRequisitionDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequisitionDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetRequisitionDepartmentsQuery, GetRequisitionDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionDepartmentsQuery, GetRequisitionDepartmentsQueryVariables>(GetRequisitionDepartmentsDocument, options);
}
export function useGetRequisitionDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionDepartmentsQuery, GetRequisitionDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionDepartmentsQuery, GetRequisitionDepartmentsQueryVariables>(GetRequisitionDepartmentsDocument, options);
}
export function useGetRequisitionDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionDepartmentsQuery, GetRequisitionDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionDepartmentsQuery, GetRequisitionDepartmentsQueryVariables>(GetRequisitionDepartmentsDocument, options);
}
export type GetRequisitionDepartmentsQueryHookResult = ReturnType<typeof useGetRequisitionDepartmentsQuery>;
export type GetRequisitionDepartmentsLazyQueryHookResult = ReturnType<typeof useGetRequisitionDepartmentsLazyQuery>;
export type GetRequisitionDepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionDepartmentsSuspenseQuery>;
export type GetRequisitionDepartmentsQueryResult = Apollo.QueryResult<GetRequisitionDepartmentsQuery, GetRequisitionDepartmentsQueryVariables>;
export function refetchGetRequisitionDepartmentsQuery(variables?: GetRequisitionDepartmentsQueryVariables) {
  return { query: GetRequisitionDepartmentsDocument, variables: variables }
}
export const GetWebDepartmentsDocument = gql`
    query GetWebDepartments($operationManager: String) {
  departments(operationManager: $operationManager) {
    ...BaseDepartmentFragment
  }
}
    ${BaseDepartmentFragmentFragmentDoc}`;

/**
 * __useGetWebDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetWebDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebDepartmentsQuery({
 *   variables: {
 *      operationManager: // value for 'operationManager'
 *   },
 * });
 */
export function useGetWebDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebDepartmentsQuery, GetWebDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebDepartmentsQuery, GetWebDepartmentsQueryVariables>(GetWebDepartmentsDocument, options);
}
export function useGetWebDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebDepartmentsQuery, GetWebDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebDepartmentsQuery, GetWebDepartmentsQueryVariables>(GetWebDepartmentsDocument, options);
}
export function useGetWebDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebDepartmentsQuery, GetWebDepartmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebDepartmentsQuery, GetWebDepartmentsQueryVariables>(GetWebDepartmentsDocument, options);
}
export type GetWebDepartmentsQueryHookResult = ReturnType<typeof useGetWebDepartmentsQuery>;
export type GetWebDepartmentsLazyQueryHookResult = ReturnType<typeof useGetWebDepartmentsLazyQuery>;
export type GetWebDepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetWebDepartmentsSuspenseQuery>;
export type GetWebDepartmentsQueryResult = Apollo.QueryResult<GetWebDepartmentsQuery, GetWebDepartmentsQueryVariables>;
export function refetchGetWebDepartmentsQuery(variables?: GetWebDepartmentsQueryVariables) {
  return { query: GetWebDepartmentsDocument, variables: variables }
}
export const CompleteDrivingSlipsDocument = gql`
    mutation CompleteDrivingSlips($ids: [String!]!) {
  completeDrivingSlips(ids: $ids) {
    id
    status
  }
}
    `;
export type CompleteDrivingSlipsMutationFn = Apollo.MutationFunction<CompleteDrivingSlipsMutation, CompleteDrivingSlipsMutationVariables>;

/**
 * __useCompleteDrivingSlipsMutation__
 *
 * To run a mutation, you first call `useCompleteDrivingSlipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteDrivingSlipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeDrivingSlipsMutation, { data, loading, error }] = useCompleteDrivingSlipsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCompleteDrivingSlipsMutation(baseOptions?: Apollo.MutationHookOptions<CompleteDrivingSlipsMutation, CompleteDrivingSlipsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CompleteDrivingSlipsMutation, CompleteDrivingSlipsMutationVariables>(CompleteDrivingSlipsDocument, options);
}
export type CompleteDrivingSlipsMutationHookResult = ReturnType<typeof useCompleteDrivingSlipsMutation>;
export type CompleteDrivingSlipsMutationResult = Apollo.MutationResult<CompleteDrivingSlipsMutation>;
export type CompleteDrivingSlipsMutationOptions = Apollo.BaseMutationOptions<CompleteDrivingSlipsMutation, CompleteDrivingSlipsMutationVariables>;
export const CreateDrivingSlipDocument = gql`
    mutation CreateDrivingSlip($drivingSlip: DrivingSlipHelperInput!, $caseId: String!, $includeCase: Boolean = false) {
  createDrivingSlip(drivingSlip: $drivingSlip, caseId: $caseId) {
    ...BaseDrivingSlipFragment
    case @include(if: $includeCase) {
      id
      erpNo
      damage {
        contact {
          name
          phone
          email
          address {
            ...AddressFragment
          }
        }
        category {
          ...BaseDamageCategoryFragment
        }
        cause {
          ...BaseDamageCauseFragment
        }
      }
      projectManager {
        ...BaseUserFragment
      }
    }
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}
${BaseUserFragmentFragmentDoc}`;
export type CreateDrivingSlipMutationFn = Apollo.MutationFunction<CreateDrivingSlipMutation, CreateDrivingSlipMutationVariables>;

/**
 * __useCreateDrivingSlipMutation__
 *
 * To run a mutation, you first call `useCreateDrivingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrivingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrivingSlipMutation, { data, loading, error }] = useCreateDrivingSlipMutation({
 *   variables: {
 *      drivingSlip: // value for 'drivingSlip'
 *      caseId: // value for 'caseId'
 *      includeCase: // value for 'includeCase'
 *   },
 * });
 */
export function useCreateDrivingSlipMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrivingSlipMutation, CreateDrivingSlipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDrivingSlipMutation, CreateDrivingSlipMutationVariables>(CreateDrivingSlipDocument, options);
}
export type CreateDrivingSlipMutationHookResult = ReturnType<typeof useCreateDrivingSlipMutation>;
export type CreateDrivingSlipMutationResult = Apollo.MutationResult<CreateDrivingSlipMutation>;
export type CreateDrivingSlipMutationOptions = Apollo.BaseMutationOptions<CreateDrivingSlipMutation, CreateDrivingSlipMutationVariables>;
export const DeleteDrivingSlipDocument = gql`
    mutation DeleteDrivingSlip($id: String!, $caseId: String!) {
  deleteDrivingSlip(id: $id, caseId: $caseId) {
    _
  }
}
    `;
export type DeleteDrivingSlipMutationFn = Apollo.MutationFunction<DeleteDrivingSlipMutation, DeleteDrivingSlipMutationVariables>;

/**
 * __useDeleteDrivingSlipMutation__
 *
 * To run a mutation, you first call `useDeleteDrivingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDrivingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDrivingSlipMutation, { data, loading, error }] = useDeleteDrivingSlipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useDeleteDrivingSlipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDrivingSlipMutation, DeleteDrivingSlipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDrivingSlipMutation, DeleteDrivingSlipMutationVariables>(DeleteDrivingSlipDocument, options);
}
export type DeleteDrivingSlipMutationHookResult = ReturnType<typeof useDeleteDrivingSlipMutation>;
export type DeleteDrivingSlipMutationResult = Apollo.MutationResult<DeleteDrivingSlipMutation>;
export type DeleteDrivingSlipMutationOptions = Apollo.BaseMutationOptions<DeleteDrivingSlipMutation, DeleteDrivingSlipMutationVariables>;
export const GetDistanceDocument = gql`
    query GetDistance($fromAddress: AddressInput!, $toAddress: AddressInput!) {
  getDistance(fromAddress: $fromAddress, toAddress: $toAddress) {
    distance
    duration
  }
}
    `;

/**
 * __useGetDistanceQuery__
 *
 * To run a query within a React component, call `useGetDistanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistanceQuery({
 *   variables: {
 *      fromAddress: // value for 'fromAddress'
 *      toAddress: // value for 'toAddress'
 *   },
 * });
 */
export function useGetDistanceQuery(baseOptions: Apollo.QueryHookOptions<GetDistanceQuery, GetDistanceQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDistanceQuery, GetDistanceQueryVariables>(GetDistanceDocument, options);
}
export function useGetDistanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistanceQuery, GetDistanceQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDistanceQuery, GetDistanceQueryVariables>(GetDistanceDocument, options);
}
export function useGetDistanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDistanceQuery, GetDistanceQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDistanceQuery, GetDistanceQueryVariables>(GetDistanceDocument, options);
}
export type GetDistanceQueryHookResult = ReturnType<typeof useGetDistanceQuery>;
export type GetDistanceLazyQueryHookResult = ReturnType<typeof useGetDistanceLazyQuery>;
export type GetDistanceSuspenseQueryHookResult = ReturnType<typeof useGetDistanceSuspenseQuery>;
export type GetDistanceQueryResult = Apollo.QueryResult<GetDistanceQuery, GetDistanceQueryVariables>;
export function refetchGetDistanceQuery(variables: GetDistanceQueryVariables) {
  return { query: GetDistanceDocument, variables: variables }
}
export const GetDrivingSlipsExcelDocument = gql`
    query GetDrivingSlipsExcel($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $debitor: [String!], $priorityCustomers: Boolean, $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $case: String, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  exportDrivingSlipsToExcel(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    debitor: $debitor
    priorityCustomers: $priorityCustomers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    case: $case
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  )
}
    `;

/**
 * __useGetDrivingSlipsExcelQuery__
 *
 * To run a query within a React component, call `useGetDrivingSlipsExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingSlipsExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingSlipsExcelQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      debitor: // value for 'debitor'
 *      priorityCustomers: // value for 'priorityCustomers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      case: // value for 'case'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetDrivingSlipsExcelQuery(baseOptions?: Apollo.QueryHookOptions<GetDrivingSlipsExcelQuery, GetDrivingSlipsExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrivingSlipsExcelQuery, GetDrivingSlipsExcelQueryVariables>(GetDrivingSlipsExcelDocument, options);
}
export function useGetDrivingSlipsExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrivingSlipsExcelQuery, GetDrivingSlipsExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrivingSlipsExcelQuery, GetDrivingSlipsExcelQueryVariables>(GetDrivingSlipsExcelDocument, options);
}
export function useGetDrivingSlipsExcelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrivingSlipsExcelQuery, GetDrivingSlipsExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDrivingSlipsExcelQuery, GetDrivingSlipsExcelQueryVariables>(GetDrivingSlipsExcelDocument, options);
}
export type GetDrivingSlipsExcelQueryHookResult = ReturnType<typeof useGetDrivingSlipsExcelQuery>;
export type GetDrivingSlipsExcelLazyQueryHookResult = ReturnType<typeof useGetDrivingSlipsExcelLazyQuery>;
export type GetDrivingSlipsExcelSuspenseQueryHookResult = ReturnType<typeof useGetDrivingSlipsExcelSuspenseQuery>;
export type GetDrivingSlipsExcelQueryResult = Apollo.QueryResult<GetDrivingSlipsExcelQuery, GetDrivingSlipsExcelQueryVariables>;
export function refetchGetDrivingSlipsExcelQuery(variables?: GetDrivingSlipsExcelQueryVariables) {
  return { query: GetDrivingSlipsExcelDocument, variables: variables }
}
export const GetDrivingSlipIDsDocument = gql`
    query GetDrivingSlipIDs($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $case: String, $searchString: String, $excludeTotalCount: Boolean) {
  drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    case: $case
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    id
  }
}
    `;

/**
 * __useGetDrivingSlipIDsQuery__
 *
 * To run a query within a React component, call `useGetDrivingSlipIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingSlipIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingSlipIDsQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      case: // value for 'case'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetDrivingSlipIDsQuery(baseOptions?: Apollo.QueryHookOptions<GetDrivingSlipIDsQuery, GetDrivingSlipIDsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrivingSlipIDsQuery, GetDrivingSlipIDsQueryVariables>(GetDrivingSlipIDsDocument, options);
}
export function useGetDrivingSlipIDsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrivingSlipIDsQuery, GetDrivingSlipIDsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrivingSlipIDsQuery, GetDrivingSlipIDsQueryVariables>(GetDrivingSlipIDsDocument, options);
}
export function useGetDrivingSlipIDsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrivingSlipIDsQuery, GetDrivingSlipIDsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDrivingSlipIDsQuery, GetDrivingSlipIDsQueryVariables>(GetDrivingSlipIDsDocument, options);
}
export type GetDrivingSlipIDsQueryHookResult = ReturnType<typeof useGetDrivingSlipIDsQuery>;
export type GetDrivingSlipIDsLazyQueryHookResult = ReturnType<typeof useGetDrivingSlipIDsLazyQuery>;
export type GetDrivingSlipIDsSuspenseQueryHookResult = ReturnType<typeof useGetDrivingSlipIDsSuspenseQuery>;
export type GetDrivingSlipIDsQueryResult = Apollo.QueryResult<GetDrivingSlipIDsQuery, GetDrivingSlipIDsQueryVariables>;
export function refetchGetDrivingSlipIDsQuery(variables?: GetDrivingSlipIDsQueryVariables) {
  return { query: GetDrivingSlipIDsDocument, variables: variables }
}
export const GetDrivingSlipsOverviewDocument = gql`
    query GetDrivingSlipsOverview($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $debitor: [String!], $priorityCustomers: Boolean, $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $case: String, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    debitor: $debitor
    priorityCustomers: $priorityCustomers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    case: $case
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    id
    series
    locked
    status
    urgent
    series
    driver {
      id
      name
      email
      phone
      department
      jobFunction
    }
    start
    end
    deadline
    updatedAt
    createdAt
    version
    comment
    changes {
      timestamp
      user {
        ...BaseUserFragment
      }
      before {
        ...DrivingSlipChangesFragment
      }
      after {
        ...DrivingSlipChangesFragment
      }
    }
    location {
      id
      name
    }
    department {
      id
      name
      departmentNumber
    }
    category
    drivingStarted
    eventReferenceId
    case {
      id
      erpNo
      track
      createdAt
      debitor {
        ...BaseDebitorFragment
      }
      damage {
        contact {
          address {
            ...AddressFragment
          }
        }
        category {
          ...BaseDamageCategoryFragment
        }
        cause {
          ...BaseDamageCauseFragment
        }
      }
      visitation {
        urgent
        priorities
        regress
        calledBack {
          timestamp
          value
          comment
        }
        awaiting {
          timestamp
          value
          comment
        }
        answers {
          question
          answer
        }
        isSpPhaseOneReportCreated
      }
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${DrivingSlipChangesFragmentFragmentDoc}
${BaseDebitorFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${BaseDamageCategoryFragmentFragmentDoc}
${BaseDamageCauseFragmentFragmentDoc}`;

/**
 * __useGetDrivingSlipsOverviewQuery__
 *
 * To run a query within a React component, call `useGetDrivingSlipsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingSlipsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingSlipsOverviewQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      debitor: // value for 'debitor'
 *      priorityCustomers: // value for 'priorityCustomers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      case: // value for 'case'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetDrivingSlipsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetDrivingSlipsOverviewQuery, GetDrivingSlipsOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrivingSlipsOverviewQuery, GetDrivingSlipsOverviewQueryVariables>(GetDrivingSlipsOverviewDocument, options);
}
export function useGetDrivingSlipsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrivingSlipsOverviewQuery, GetDrivingSlipsOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrivingSlipsOverviewQuery, GetDrivingSlipsOverviewQueryVariables>(GetDrivingSlipsOverviewDocument, options);
}
export function useGetDrivingSlipsOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrivingSlipsOverviewQuery, GetDrivingSlipsOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDrivingSlipsOverviewQuery, GetDrivingSlipsOverviewQueryVariables>(GetDrivingSlipsOverviewDocument, options);
}
export type GetDrivingSlipsOverviewQueryHookResult = ReturnType<typeof useGetDrivingSlipsOverviewQuery>;
export type GetDrivingSlipsOverviewLazyQueryHookResult = ReturnType<typeof useGetDrivingSlipsOverviewLazyQuery>;
export type GetDrivingSlipsOverviewSuspenseQueryHookResult = ReturnType<typeof useGetDrivingSlipsOverviewSuspenseQuery>;
export type GetDrivingSlipsOverviewQueryResult = Apollo.QueryResult<GetDrivingSlipsOverviewQuery, GetDrivingSlipsOverviewQueryVariables>;
export function refetchGetDrivingSlipsOverviewQuery(variables?: GetDrivingSlipsOverviewQueryVariables) {
  return { query: GetDrivingSlipsOverviewDocument, variables: variables }
}
export const GetDrivingSlipsPlannerDocument = gql`
    query GetDrivingSlipsPlanner($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $case: String, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    case: $case
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    id
    series
    locked
    status
    urgent
    series
    driver {
      ...BaseUserFragment
    }
    estimatedHours
    start
    end
    deadline
    comment
    location {
      id
      name
    }
    department {
      id
      name
      departmentNumber
    }
    category
    riskEvaluationStatus
    createdAt
    version
    plannerMessage
    case {
      id
      status
      erpId
      erpNo
      track
      debitor {
        ...BaseDebitorFragment
      }
      damage {
        ...DamageFragment
      }
      visitation {
        urgent
        priorities
        regress
        calledBack {
          timestamp
          comment
        }
        answers {
          question
          answer
        }
      }
      projectManager {
        ...BaseUserFragment
      }
      caseManager {
        ...BaseUserFragment
      }
      createdBy {
        ...BaseUserFragment
      }
      skafor
      policyHolder {
        name
        phone
        email
        address {
          ...AddressFragment
        }
      }
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${BaseDebitorFragmentFragmentDoc}
${DamageFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useGetDrivingSlipsPlannerQuery__
 *
 * To run a query within a React component, call `useGetDrivingSlipsPlannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingSlipsPlannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingSlipsPlannerQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      case: // value for 'case'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetDrivingSlipsPlannerQuery(baseOptions?: Apollo.QueryHookOptions<GetDrivingSlipsPlannerQuery, GetDrivingSlipsPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrivingSlipsPlannerQuery, GetDrivingSlipsPlannerQueryVariables>(GetDrivingSlipsPlannerDocument, options);
}
export function useGetDrivingSlipsPlannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrivingSlipsPlannerQuery, GetDrivingSlipsPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrivingSlipsPlannerQuery, GetDrivingSlipsPlannerQueryVariables>(GetDrivingSlipsPlannerDocument, options);
}
export function useGetDrivingSlipsPlannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrivingSlipsPlannerQuery, GetDrivingSlipsPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDrivingSlipsPlannerQuery, GetDrivingSlipsPlannerQueryVariables>(GetDrivingSlipsPlannerDocument, options);
}
export type GetDrivingSlipsPlannerQueryHookResult = ReturnType<typeof useGetDrivingSlipsPlannerQuery>;
export type GetDrivingSlipsPlannerLazyQueryHookResult = ReturnType<typeof useGetDrivingSlipsPlannerLazyQuery>;
export type GetDrivingSlipsPlannerSuspenseQueryHookResult = ReturnType<typeof useGetDrivingSlipsPlannerSuspenseQuery>;
export type GetDrivingSlipsPlannerQueryResult = Apollo.QueryResult<GetDrivingSlipsPlannerQuery, GetDrivingSlipsPlannerQueryVariables>;
export function refetchGetDrivingSlipsPlannerQuery(variables?: GetDrivingSlipsPlannerQueryVariables) {
  return { query: GetDrivingSlipsPlannerDocument, variables: variables }
}
export const GetWebDrivingSlipDocument = gql`
    query GetWebDrivingSlip($id: String!) {
  drivingSlip(id: $id) {
    ...BaseDrivingSlipFragment
    case {
      ...BaseDrivingSlipCaseFragment
    }
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}
${BaseDrivingSlipCaseFragmentFragmentDoc}`;

/**
 * __useGetWebDrivingSlipQuery__
 *
 * To run a query within a React component, call `useGetWebDrivingSlipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebDrivingSlipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebDrivingSlipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWebDrivingSlipQuery(baseOptions: Apollo.QueryHookOptions<GetWebDrivingSlipQuery, GetWebDrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebDrivingSlipQuery, GetWebDrivingSlipQueryVariables>(GetWebDrivingSlipDocument, options);
}
export function useGetWebDrivingSlipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebDrivingSlipQuery, GetWebDrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebDrivingSlipQuery, GetWebDrivingSlipQueryVariables>(GetWebDrivingSlipDocument, options);
}
export function useGetWebDrivingSlipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebDrivingSlipQuery, GetWebDrivingSlipQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebDrivingSlipQuery, GetWebDrivingSlipQueryVariables>(GetWebDrivingSlipDocument, options);
}
export type GetWebDrivingSlipQueryHookResult = ReturnType<typeof useGetWebDrivingSlipQuery>;
export type GetWebDrivingSlipLazyQueryHookResult = ReturnType<typeof useGetWebDrivingSlipLazyQuery>;
export type GetWebDrivingSlipSuspenseQueryHookResult = ReturnType<typeof useGetWebDrivingSlipSuspenseQuery>;
export type GetWebDrivingSlipQueryResult = Apollo.QueryResult<GetWebDrivingSlipQuery, GetWebDrivingSlipQueryVariables>;
export function refetchGetWebDrivingSlipQuery(variables: GetWebDrivingSlipQueryVariables) {
  return { query: GetWebDrivingSlipDocument, variables: variables }
}
export const GetWebDrivingSlipsDocument = gql`
    query GetWebDrivingSlips($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $case: String, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    case: $case
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    ...BaseDrivingSlipFragment
    case {
      ...BaseDrivingSlipCaseFragment
    }
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}
${BaseDrivingSlipCaseFragmentFragmentDoc}`;

/**
 * __useGetWebDrivingSlipsQuery__
 *
 * To run a query within a React component, call `useGetWebDrivingSlipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebDrivingSlipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebDrivingSlipsQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      case: // value for 'case'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetWebDrivingSlipsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebDrivingSlipsQuery, GetWebDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebDrivingSlipsQuery, GetWebDrivingSlipsQueryVariables>(GetWebDrivingSlipsDocument, options);
}
export function useGetWebDrivingSlipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebDrivingSlipsQuery, GetWebDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebDrivingSlipsQuery, GetWebDrivingSlipsQueryVariables>(GetWebDrivingSlipsDocument, options);
}
export function useGetWebDrivingSlipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebDrivingSlipsQuery, GetWebDrivingSlipsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebDrivingSlipsQuery, GetWebDrivingSlipsQueryVariables>(GetWebDrivingSlipsDocument, options);
}
export type GetWebDrivingSlipsQueryHookResult = ReturnType<typeof useGetWebDrivingSlipsQuery>;
export type GetWebDrivingSlipsLazyQueryHookResult = ReturnType<typeof useGetWebDrivingSlipsLazyQuery>;
export type GetWebDrivingSlipsSuspenseQueryHookResult = ReturnType<typeof useGetWebDrivingSlipsSuspenseQuery>;
export type GetWebDrivingSlipsQueryResult = Apollo.QueryResult<GetWebDrivingSlipsQuery, GetWebDrivingSlipsQueryVariables>;
export function refetchGetWebDrivingSlipsQuery(variables?: GetWebDrivingSlipsQueryVariables) {
  return { query: GetWebDrivingSlipsDocument, variables: variables }
}
export const GetWebDrivingSlipsNoCaseDocument = gql`
    query GetWebDrivingSlipsNoCase($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivers: [String!], $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $case: String) {
  drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivers: $drivers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    case: $case
  ) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;

/**
 * __useGetWebDrivingSlipsNoCaseQuery__
 *
 * To run a query within a React component, call `useGetWebDrivingSlipsNoCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebDrivingSlipsNoCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebDrivingSlipsNoCaseQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivers: // value for 'drivers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      case: // value for 'case'
 *   },
 * });
 */
export function useGetWebDrivingSlipsNoCaseQuery(baseOptions?: Apollo.QueryHookOptions<GetWebDrivingSlipsNoCaseQuery, GetWebDrivingSlipsNoCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebDrivingSlipsNoCaseQuery, GetWebDrivingSlipsNoCaseQueryVariables>(GetWebDrivingSlipsNoCaseDocument, options);
}
export function useGetWebDrivingSlipsNoCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebDrivingSlipsNoCaseQuery, GetWebDrivingSlipsNoCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebDrivingSlipsNoCaseQuery, GetWebDrivingSlipsNoCaseQueryVariables>(GetWebDrivingSlipsNoCaseDocument, options);
}
export function useGetWebDrivingSlipsNoCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebDrivingSlipsNoCaseQuery, GetWebDrivingSlipsNoCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebDrivingSlipsNoCaseQuery, GetWebDrivingSlipsNoCaseQueryVariables>(GetWebDrivingSlipsNoCaseDocument, options);
}
export type GetWebDrivingSlipsNoCaseQueryHookResult = ReturnType<typeof useGetWebDrivingSlipsNoCaseQuery>;
export type GetWebDrivingSlipsNoCaseLazyQueryHookResult = ReturnType<typeof useGetWebDrivingSlipsNoCaseLazyQuery>;
export type GetWebDrivingSlipsNoCaseSuspenseQueryHookResult = ReturnType<typeof useGetWebDrivingSlipsNoCaseSuspenseQuery>;
export type GetWebDrivingSlipsNoCaseQueryResult = Apollo.QueryResult<GetWebDrivingSlipsNoCaseQuery, GetWebDrivingSlipsNoCaseQueryVariables>;
export function refetchGetWebDrivingSlipsNoCaseQuery(variables?: GetWebDrivingSlipsNoCaseQueryVariables) {
  return { query: GetWebDrivingSlipsNoCaseDocument, variables: variables }
}
export const SetWebDrivingSlipStatusDocument = gql`
    mutation SetWebDrivingSlipStatus($id: String!, $status: DrivingSlipStatus!) {
  setDrivingSlipStatus(id: $id, status: $status) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type SetWebDrivingSlipStatusMutationFn = Apollo.MutationFunction<SetWebDrivingSlipStatusMutation, SetWebDrivingSlipStatusMutationVariables>;

/**
 * __useSetWebDrivingSlipStatusMutation__
 *
 * To run a mutation, you first call `useSetWebDrivingSlipStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWebDrivingSlipStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWebDrivingSlipStatusMutation, { data, loading, error }] = useSetWebDrivingSlipStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetWebDrivingSlipStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetWebDrivingSlipStatusMutation, SetWebDrivingSlipStatusMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetWebDrivingSlipStatusMutation, SetWebDrivingSlipStatusMutationVariables>(SetWebDrivingSlipStatusDocument, options);
}
export type SetWebDrivingSlipStatusMutationHookResult = ReturnType<typeof useSetWebDrivingSlipStatusMutation>;
export type SetWebDrivingSlipStatusMutationResult = Apollo.MutationResult<SetWebDrivingSlipStatusMutation>;
export type SetWebDrivingSlipStatusMutationOptions = Apollo.BaseMutationOptions<SetWebDrivingSlipStatusMutation, SetWebDrivingSlipStatusMutationVariables>;
export const UpdateWebDrivingSlipDocument = gql`
    mutation UpdateWebDrivingSlip($id: String!, $urgent: Boolean, $driver: String, $estimatedHours: Decimal, $start: DateTime, $end: DateTime, $comment: String, $deadline: DateTime, $car: String, $materials: [String!], $eventId: String, $additionalDays: [AdditionalDayInput!], $additionalDrivers: [String!], $driverCarList: [DriverCarInput!], $location: String!, $department: String!, $category: String, $immediatelyPlan: Boolean, $plannerMessage: String, $halfDay: Boolean) {
  updateDrivingSlip(
    id: $id
    urgent: $urgent
    driver: $driver
    estimatedHours: $estimatedHours
    start: $start
    end: $end
    comment: $comment
    deadline: $deadline
    eventId: $eventId
    car: $car
    additionalDays: $additionalDays
    additionalDrivers: $additionalDrivers
    location: $location
    department: $department
    category: $category
    immediatelyPlan: $immediatelyPlan
    plannerMessage: $plannerMessage
    driverCarList: $driverCarList
    materials: $materials
    halfDay: $halfDay
  ) {
    ...BaseDrivingSlipFragment
    case {
      ...BaseDrivingSlipCaseFragment
    }
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}
${BaseDrivingSlipCaseFragmentFragmentDoc}`;
export type UpdateWebDrivingSlipMutationFn = Apollo.MutationFunction<UpdateWebDrivingSlipMutation, UpdateWebDrivingSlipMutationVariables>;

/**
 * __useUpdateWebDrivingSlipMutation__
 *
 * To run a mutation, you first call `useUpdateWebDrivingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebDrivingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebDrivingSlipMutation, { data, loading, error }] = useUpdateWebDrivingSlipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      urgent: // value for 'urgent'
 *      driver: // value for 'driver'
 *      estimatedHours: // value for 'estimatedHours'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      comment: // value for 'comment'
 *      deadline: // value for 'deadline'
 *      car: // value for 'car'
 *      materials: // value for 'materials'
 *      eventId: // value for 'eventId'
 *      additionalDays: // value for 'additionalDays'
 *      additionalDrivers: // value for 'additionalDrivers'
 *      driverCarList: // value for 'driverCarList'
 *      location: // value for 'location'
 *      department: // value for 'department'
 *      category: // value for 'category'
 *      immediatelyPlan: // value for 'immediatelyPlan'
 *      plannerMessage: // value for 'plannerMessage'
 *      halfDay: // value for 'halfDay'
 *   },
 * });
 */
export function useUpdateWebDrivingSlipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebDrivingSlipMutation, UpdateWebDrivingSlipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateWebDrivingSlipMutation, UpdateWebDrivingSlipMutationVariables>(UpdateWebDrivingSlipDocument, options);
}
export type UpdateWebDrivingSlipMutationHookResult = ReturnType<typeof useUpdateWebDrivingSlipMutation>;
export type UpdateWebDrivingSlipMutationResult = Apollo.MutationResult<UpdateWebDrivingSlipMutation>;
export type UpdateWebDrivingSlipMutationOptions = Apollo.BaseMutationOptions<UpdateWebDrivingSlipMutation, UpdateWebDrivingSlipMutationVariables>;
export const AddCaseFileToDrivingSlipDocument = gql`
    mutation AddCaseFileToDrivingSlip($fileName: String!, $caseFolder: String!, $seriesFolder: String!) {
  addCaseFileToDrivingSlip(
    fileName: $fileName
    caseFolder: $caseFolder
    seriesFolder: $seriesFolder
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type AddCaseFileToDrivingSlipMutationFn = Apollo.MutationFunction<AddCaseFileToDrivingSlipMutation, AddCaseFileToDrivingSlipMutationVariables>;

/**
 * __useAddCaseFileToDrivingSlipMutation__
 *
 * To run a mutation, you first call `useAddCaseFileToDrivingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaseFileToDrivingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaseFileToDrivingSlipMutation, { data, loading, error }] = useAddCaseFileToDrivingSlipMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      caseFolder: // value for 'caseFolder'
 *      seriesFolder: // value for 'seriesFolder'
 *   },
 * });
 */
export function useAddCaseFileToDrivingSlipMutation(baseOptions?: Apollo.MutationHookOptions<AddCaseFileToDrivingSlipMutation, AddCaseFileToDrivingSlipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddCaseFileToDrivingSlipMutation, AddCaseFileToDrivingSlipMutationVariables>(AddCaseFileToDrivingSlipDocument, options);
}
export type AddCaseFileToDrivingSlipMutationHookResult = ReturnType<typeof useAddCaseFileToDrivingSlipMutation>;
export type AddCaseFileToDrivingSlipMutationResult = Apollo.MutationResult<AddCaseFileToDrivingSlipMutation>;
export type AddCaseFileToDrivingSlipMutationOptions = Apollo.BaseMutationOptions<AddCaseFileToDrivingSlipMutation, AddCaseFileToDrivingSlipMutationVariables>;
export const AddCaseFilesToDrivingSlipDocument = gql`
    mutation AddCaseFilesToDrivingSlip($filenames: [String!]!, $caseFolder: String!, $seriesFolder: String!) {
  addCaseFilesToDrivingSlip(
    filenames: $filenames
    caseFolder: $caseFolder
    seriesFolder: $seriesFolder
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type AddCaseFilesToDrivingSlipMutationFn = Apollo.MutationFunction<AddCaseFilesToDrivingSlipMutation, AddCaseFilesToDrivingSlipMutationVariables>;

/**
 * __useAddCaseFilesToDrivingSlipMutation__
 *
 * To run a mutation, you first call `useAddCaseFilesToDrivingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaseFilesToDrivingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaseFilesToDrivingSlipMutation, { data, loading, error }] = useAddCaseFilesToDrivingSlipMutation({
 *   variables: {
 *      filenames: // value for 'filenames'
 *      caseFolder: // value for 'caseFolder'
 *      seriesFolder: // value for 'seriesFolder'
 *   },
 * });
 */
export function useAddCaseFilesToDrivingSlipMutation(baseOptions?: Apollo.MutationHookOptions<AddCaseFilesToDrivingSlipMutation, AddCaseFilesToDrivingSlipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddCaseFilesToDrivingSlipMutation, AddCaseFilesToDrivingSlipMutationVariables>(AddCaseFilesToDrivingSlipDocument, options);
}
export type AddCaseFilesToDrivingSlipMutationHookResult = ReturnType<typeof useAddCaseFilesToDrivingSlipMutation>;
export type AddCaseFilesToDrivingSlipMutationResult = Apollo.MutationResult<AddCaseFilesToDrivingSlipMutation>;
export type AddCaseFilesToDrivingSlipMutationOptions = Apollo.BaseMutationOptions<AddCaseFilesToDrivingSlipMutation, AddCaseFilesToDrivingSlipMutationVariables>;
export const DeleteCaseFileDocument = gql`
    mutation DeleteCaseFile($fileName: String!, $folder: String!) {
  deleteCaseFile(fileName: $fileName, folder: $folder) {
    _
  }
}
    `;
export type DeleteCaseFileMutationFn = Apollo.MutationFunction<DeleteCaseFileMutation, DeleteCaseFileMutationVariables>;

/**
 * __useDeleteCaseFileMutation__
 *
 * To run a mutation, you first call `useDeleteCaseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseFileMutation, { data, loading, error }] = useDeleteCaseFileMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useDeleteCaseFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseFileMutation, DeleteCaseFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCaseFileMutation, DeleteCaseFileMutationVariables>(DeleteCaseFileDocument, options);
}
export type DeleteCaseFileMutationHookResult = ReturnType<typeof useDeleteCaseFileMutation>;
export type DeleteCaseFileMutationResult = Apollo.MutationResult<DeleteCaseFileMutation>;
export type DeleteCaseFileMutationOptions = Apollo.BaseMutationOptions<DeleteCaseFileMutation, DeleteCaseFileMutationVariables>;
export const DeleteCatalogFileDocument = gql`
    mutation DeleteCatalogFile($fileName: String!, $folder: String) {
  deleteCatalogFile(fileName: $fileName, folder: $folder) {
    _
  }
}
    `;
export type DeleteCatalogFileMutationFn = Apollo.MutationFunction<DeleteCatalogFileMutation, DeleteCatalogFileMutationVariables>;

/**
 * __useDeleteCatalogFileMutation__
 *
 * To run a mutation, you first call `useDeleteCatalogFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCatalogFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCatalogFileMutation, { data, loading, error }] = useDeleteCatalogFileMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useDeleteCatalogFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCatalogFileMutation, DeleteCatalogFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCatalogFileMutation, DeleteCatalogFileMutationVariables>(DeleteCatalogFileDocument, options);
}
export type DeleteCatalogFileMutationHookResult = ReturnType<typeof useDeleteCatalogFileMutation>;
export type DeleteCatalogFileMutationResult = Apollo.MutationResult<DeleteCatalogFileMutation>;
export type DeleteCatalogFileMutationOptions = Apollo.BaseMutationOptions<DeleteCatalogFileMutation, DeleteCatalogFileMutationVariables>;
export const DeleteInvoiceFileDocument = gql`
    mutation DeleteInvoiceFile($caseNo: String!, $invoiceNo: String!, $fileName: String!) {
  deleteInvoiceFile(caseNo: $caseNo, invoiceNo: $invoiceNo, fileName: $fileName) {
    _
  }
}
    `;
export type DeleteInvoiceFileMutationFn = Apollo.MutationFunction<DeleteInvoiceFileMutation, DeleteInvoiceFileMutationVariables>;

/**
 * __useDeleteInvoiceFileMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceFileMutation, { data, loading, error }] = useDeleteInvoiceFileMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      invoiceNo: // value for 'invoiceNo'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useDeleteInvoiceFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceFileMutation, DeleteInvoiceFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteInvoiceFileMutation, DeleteInvoiceFileMutationVariables>(DeleteInvoiceFileDocument, options);
}
export type DeleteInvoiceFileMutationHookResult = ReturnType<typeof useDeleteInvoiceFileMutation>;
export type DeleteInvoiceFileMutationResult = Apollo.MutationResult<DeleteInvoiceFileMutation>;
export type DeleteInvoiceFileMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceFileMutation, DeleteInvoiceFileMutationVariables>;
export const GetCatalogFileDocument = gql`
    query GetCatalogFile($fileName: String!, $folder: String) {
  catalogFile(fileName: $fileName, folder: $folder) {
    fileData
    filename
  }
}
    `;

/**
 * __useGetCatalogFileQuery__
 *
 * To run a query within a React component, call `useGetCatalogFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogFileQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useGetCatalogFileQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogFileQuery, GetCatalogFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCatalogFileQuery, GetCatalogFileQueryVariables>(GetCatalogFileDocument, options);
}
export function useGetCatalogFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogFileQuery, GetCatalogFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCatalogFileQuery, GetCatalogFileQueryVariables>(GetCatalogFileDocument, options);
}
export function useGetCatalogFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogFileQuery, GetCatalogFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCatalogFileQuery, GetCatalogFileQueryVariables>(GetCatalogFileDocument, options);
}
export type GetCatalogFileQueryHookResult = ReturnType<typeof useGetCatalogFileQuery>;
export type GetCatalogFileLazyQueryHookResult = ReturnType<typeof useGetCatalogFileLazyQuery>;
export type GetCatalogFileSuspenseQueryHookResult = ReturnType<typeof useGetCatalogFileSuspenseQuery>;
export type GetCatalogFileQueryResult = Apollo.QueryResult<GetCatalogFileQuery, GetCatalogFileQueryVariables>;
export function refetchGetCatalogFileQuery(variables: GetCatalogFileQueryVariables) {
  return { query: GetCatalogFileDocument, variables: variables }
}
export const GetGlobalCatalogEsdhFilesDocument = gql`
    query GetGlobalCatalogESDHFiles($thisCustomerOnly: Boolean, $offset: Int, $limit: Int, $searchString: String, $customerIds: [String!]) {
  globalCatalogFiles(
    thisCustomerOnly: $thisCustomerOnly
    offset: $offset
    limit: $limit
    searchString: $searchString
    customerIds: $customerIds
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;

/**
 * __useGetGlobalCatalogEsdhFilesQuery__
 *
 * To run a query within a React component, call `useGetGlobalCatalogEsdhFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalCatalogEsdhFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalCatalogEsdhFilesQuery({
 *   variables: {
 *      thisCustomerOnly: // value for 'thisCustomerOnly'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useGetGlobalCatalogEsdhFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalCatalogEsdhFilesQuery, GetGlobalCatalogEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetGlobalCatalogEsdhFilesQuery, GetGlobalCatalogEsdhFilesQueryVariables>(GetGlobalCatalogEsdhFilesDocument, options);
}
export function useGetGlobalCatalogEsdhFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalCatalogEsdhFilesQuery, GetGlobalCatalogEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetGlobalCatalogEsdhFilesQuery, GetGlobalCatalogEsdhFilesQueryVariables>(GetGlobalCatalogEsdhFilesDocument, options);
}
export function useGetGlobalCatalogEsdhFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGlobalCatalogEsdhFilesQuery, GetGlobalCatalogEsdhFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetGlobalCatalogEsdhFilesQuery, GetGlobalCatalogEsdhFilesQueryVariables>(GetGlobalCatalogEsdhFilesDocument, options);
}
export type GetGlobalCatalogEsdhFilesQueryHookResult = ReturnType<typeof useGetGlobalCatalogEsdhFilesQuery>;
export type GetGlobalCatalogEsdhFilesLazyQueryHookResult = ReturnType<typeof useGetGlobalCatalogEsdhFilesLazyQuery>;
export type GetGlobalCatalogEsdhFilesSuspenseQueryHookResult = ReturnType<typeof useGetGlobalCatalogEsdhFilesSuspenseQuery>;
export type GetGlobalCatalogEsdhFilesQueryResult = Apollo.QueryResult<GetGlobalCatalogEsdhFilesQuery, GetGlobalCatalogEsdhFilesQueryVariables>;
export function refetchGetGlobalCatalogEsdhFilesQuery(variables?: GetGlobalCatalogEsdhFilesQueryVariables) {
  return { query: GetGlobalCatalogEsdhFilesDocument, variables: variables }
}
export const GetWebCaseFileDocument = gql`
    query GetWebCaseFile($fileName: String!, $folder: String) {
  caseFile(fileName: $fileName, folder: $folder) {
    fileData
    filename
  }
}
    `;

/**
 * __useGetWebCaseFileQuery__
 *
 * To run a query within a React component, call `useGetWebCaseFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCaseFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCaseFileQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useGetWebCaseFileQuery(baseOptions: Apollo.QueryHookOptions<GetWebCaseFileQuery, GetWebCaseFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCaseFileQuery, GetWebCaseFileQueryVariables>(GetWebCaseFileDocument, options);
}
export function useGetWebCaseFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCaseFileQuery, GetWebCaseFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCaseFileQuery, GetWebCaseFileQueryVariables>(GetWebCaseFileDocument, options);
}
export function useGetWebCaseFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCaseFileQuery, GetWebCaseFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCaseFileQuery, GetWebCaseFileQueryVariables>(GetWebCaseFileDocument, options);
}
export type GetWebCaseFileQueryHookResult = ReturnType<typeof useGetWebCaseFileQuery>;
export type GetWebCaseFileLazyQueryHookResult = ReturnType<typeof useGetWebCaseFileLazyQuery>;
export type GetWebCaseFileSuspenseQueryHookResult = ReturnType<typeof useGetWebCaseFileSuspenseQuery>;
export type GetWebCaseFileQueryResult = Apollo.QueryResult<GetWebCaseFileQuery, GetWebCaseFileQueryVariables>;
export function refetchGetWebCaseFileQuery(variables: GetWebCaseFileQueryVariables) {
  return { query: GetWebCaseFileDocument, variables: variables }
}
export const GetWebDrivingSlipFileDocument = gql`
    query GetWebDrivingSlipFile($caseNo: String!, $drivingSlipId: String!, $fileName: String!) {
  drivingSlipFile(
    caseNo: $caseNo
    drivingSlipId: $drivingSlipId
    fileName: $fileName
  ) {
    fileData
    filename
  }
}
    `;

/**
 * __useGetWebDrivingSlipFileQuery__
 *
 * To run a query within a React component, call `useGetWebDrivingSlipFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebDrivingSlipFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebDrivingSlipFileQuery({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      drivingSlipId: // value for 'drivingSlipId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetWebDrivingSlipFileQuery(baseOptions: Apollo.QueryHookOptions<GetWebDrivingSlipFileQuery, GetWebDrivingSlipFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebDrivingSlipFileQuery, GetWebDrivingSlipFileQueryVariables>(GetWebDrivingSlipFileDocument, options);
}
export function useGetWebDrivingSlipFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebDrivingSlipFileQuery, GetWebDrivingSlipFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebDrivingSlipFileQuery, GetWebDrivingSlipFileQueryVariables>(GetWebDrivingSlipFileDocument, options);
}
export function useGetWebDrivingSlipFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebDrivingSlipFileQuery, GetWebDrivingSlipFileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebDrivingSlipFileQuery, GetWebDrivingSlipFileQueryVariables>(GetWebDrivingSlipFileDocument, options);
}
export type GetWebDrivingSlipFileQueryHookResult = ReturnType<typeof useGetWebDrivingSlipFileQuery>;
export type GetWebDrivingSlipFileLazyQueryHookResult = ReturnType<typeof useGetWebDrivingSlipFileLazyQuery>;
export type GetWebDrivingSlipFileSuspenseQueryHookResult = ReturnType<typeof useGetWebDrivingSlipFileSuspenseQuery>;
export type GetWebDrivingSlipFileQueryResult = Apollo.QueryResult<GetWebDrivingSlipFileQuery, GetWebDrivingSlipFileQueryVariables>;
export function refetchGetWebDrivingSlipFileQuery(variables: GetWebDrivingSlipFileQueryVariables) {
  return { query: GetWebDrivingSlipFileDocument, variables: variables }
}
export const LogCaseFileChangeDocument = gql`
    mutation LogCaseFileChange($case: String!, $action: FileActionType!, $filename: String!) {
  logCaseFileChange(case: $case, action: $action, filename: $filename) {
    _
  }
}
    `;
export type LogCaseFileChangeMutationFn = Apollo.MutationFunction<LogCaseFileChangeMutation, LogCaseFileChangeMutationVariables>;

/**
 * __useLogCaseFileChangeMutation__
 *
 * To run a mutation, you first call `useLogCaseFileChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogCaseFileChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logCaseFileChangeMutation, { data, loading, error }] = useLogCaseFileChangeMutation({
 *   variables: {
 *      case: // value for 'case'
 *      action: // value for 'action'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useLogCaseFileChangeMutation(baseOptions?: Apollo.MutationHookOptions<LogCaseFileChangeMutation, LogCaseFileChangeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LogCaseFileChangeMutation, LogCaseFileChangeMutationVariables>(LogCaseFileChangeDocument, options);
}
export type LogCaseFileChangeMutationHookResult = ReturnType<typeof useLogCaseFileChangeMutation>;
export type LogCaseFileChangeMutationResult = Apollo.MutationResult<LogCaseFileChangeMutation>;
export type LogCaseFileChangeMutationOptions = Apollo.BaseMutationOptions<LogCaseFileChangeMutation, LogCaseFileChangeMutationVariables>;
export const LogCatalogFileChangeDocument = gql`
    mutation LogCatalogFileChange($catalogId: String, $customerId: String!, $changedBy: String!, $action: FileActionType!, $globalFile: Boolean!, $filename: String!) {
  logCatalogFileChange(
    catalogId: $catalogId
    customerId: $customerId
    changedBy: $changedBy
    action: $action
    globalFile: $globalFile
    filename: $filename
  ) {
    _
  }
}
    `;
export type LogCatalogFileChangeMutationFn = Apollo.MutationFunction<LogCatalogFileChangeMutation, LogCatalogFileChangeMutationVariables>;

/**
 * __useLogCatalogFileChangeMutation__
 *
 * To run a mutation, you first call `useLogCatalogFileChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogCatalogFileChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logCatalogFileChangeMutation, { data, loading, error }] = useLogCatalogFileChangeMutation({
 *   variables: {
 *      catalogId: // value for 'catalogId'
 *      customerId: // value for 'customerId'
 *      changedBy: // value for 'changedBy'
 *      action: // value for 'action'
 *      globalFile: // value for 'globalFile'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useLogCatalogFileChangeMutation(baseOptions?: Apollo.MutationHookOptions<LogCatalogFileChangeMutation, LogCatalogFileChangeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LogCatalogFileChangeMutation, LogCatalogFileChangeMutationVariables>(LogCatalogFileChangeDocument, options);
}
export type LogCatalogFileChangeMutationHookResult = ReturnType<typeof useLogCatalogFileChangeMutation>;
export type LogCatalogFileChangeMutationResult = Apollo.MutationResult<LogCatalogFileChangeMutation>;
export type LogCatalogFileChangeMutationOptions = Apollo.BaseMutationOptions<LogCatalogFileChangeMutation, LogCatalogFileChangeMutationVariables>;
export const LogDrivingSlipFileChangeDocument = gql`
    mutation LogDrivingSlipFileChange($series: String!, $action: FileActionType!, $filename: String!) {
  logDrivingSlipFileChange(series: $series, action: $action, filename: $filename) {
    _
  }
}
    `;
export type LogDrivingSlipFileChangeMutationFn = Apollo.MutationFunction<LogDrivingSlipFileChangeMutation, LogDrivingSlipFileChangeMutationVariables>;

/**
 * __useLogDrivingSlipFileChangeMutation__
 *
 * To run a mutation, you first call `useLogDrivingSlipFileChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogDrivingSlipFileChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logDrivingSlipFileChangeMutation, { data, loading, error }] = useLogDrivingSlipFileChangeMutation({
 *   variables: {
 *      series: // value for 'series'
 *      action: // value for 'action'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useLogDrivingSlipFileChangeMutation(baseOptions?: Apollo.MutationHookOptions<LogDrivingSlipFileChangeMutation, LogDrivingSlipFileChangeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LogDrivingSlipFileChangeMutation, LogDrivingSlipFileChangeMutationVariables>(LogDrivingSlipFileChangeDocument, options);
}
export type LogDrivingSlipFileChangeMutationHookResult = ReturnType<typeof useLogDrivingSlipFileChangeMutation>;
export type LogDrivingSlipFileChangeMutationResult = Apollo.MutationResult<LogDrivingSlipFileChangeMutation>;
export type LogDrivingSlipFileChangeMutationOptions = Apollo.BaseMutationOptions<LogDrivingSlipFileChangeMutation, LogDrivingSlipFileChangeMutationVariables>;
export const UploadCaseFileDocument = gql`
    mutation UploadCaseFile($fileName: String!, $folder: String!, $file: [Byte!]!) {
  uploadCaseFile(fileName: $fileName, folder: $folder, file: $file) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type UploadCaseFileMutationFn = Apollo.MutationFunction<UploadCaseFileMutation, UploadCaseFileMutationVariables>;

/**
 * __useUploadCaseFileMutation__
 *
 * To run a mutation, you first call `useUploadCaseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCaseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCaseFileMutation, { data, loading, error }] = useUploadCaseFileMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folder: // value for 'folder'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadCaseFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadCaseFileMutation, UploadCaseFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadCaseFileMutation, UploadCaseFileMutationVariables>(UploadCaseFileDocument, options);
}
export type UploadCaseFileMutationHookResult = ReturnType<typeof useUploadCaseFileMutation>;
export type UploadCaseFileMutationResult = Apollo.MutationResult<UploadCaseFileMutation>;
export type UploadCaseFileMutationOptions = Apollo.BaseMutationOptions<UploadCaseFileMutation, UploadCaseFileMutationVariables>;
export const UploadCaseFilesDocument = gql`
    mutation UploadCaseFiles($folder: String!, $files: [FileInput!]!) {
  uploadCaseFiles(folder: $folder, files: $files) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type UploadCaseFilesMutationFn = Apollo.MutationFunction<UploadCaseFilesMutation, UploadCaseFilesMutationVariables>;

/**
 * __useUploadCaseFilesMutation__
 *
 * To run a mutation, you first call `useUploadCaseFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCaseFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCaseFilesMutation, { data, loading, error }] = useUploadCaseFilesMutation({
 *   variables: {
 *      folder: // value for 'folder'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadCaseFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadCaseFilesMutation, UploadCaseFilesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadCaseFilesMutation, UploadCaseFilesMutationVariables>(UploadCaseFilesDocument, options);
}
export type UploadCaseFilesMutationHookResult = ReturnType<typeof useUploadCaseFilesMutation>;
export type UploadCaseFilesMutationResult = Apollo.MutationResult<UploadCaseFilesMutation>;
export type UploadCaseFilesMutationOptions = Apollo.BaseMutationOptions<UploadCaseFilesMutation, UploadCaseFilesMutationVariables>;
export const UploadCatalogFileDocument = gql`
    mutation UploadCatalogFile($fileName: String!, $folder: String, $customerId: String!, $file: [Byte!]!) {
  uploadCatalogFile(
    fileName: $fileName
    folder: $folder
    file: $file
    customerId: $customerId
  ) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type UploadCatalogFileMutationFn = Apollo.MutationFunction<UploadCatalogFileMutation, UploadCatalogFileMutationVariables>;

/**
 * __useUploadCatalogFileMutation__
 *
 * To run a mutation, you first call `useUploadCatalogFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCatalogFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCatalogFileMutation, { data, loading, error }] = useUploadCatalogFileMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folder: // value for 'folder'
 *      customerId: // value for 'customerId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadCatalogFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadCatalogFileMutation, UploadCatalogFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadCatalogFileMutation, UploadCatalogFileMutationVariables>(UploadCatalogFileDocument, options);
}
export type UploadCatalogFileMutationHookResult = ReturnType<typeof useUploadCatalogFileMutation>;
export type UploadCatalogFileMutationResult = Apollo.MutationResult<UploadCatalogFileMutation>;
export type UploadCatalogFileMutationOptions = Apollo.BaseMutationOptions<UploadCatalogFileMutation, UploadCatalogFileMutationVariables>;
export const UploadCatalogFilesDocument = gql`
    mutation UploadCatalogFiles($folder: String, $customerId: String!, $files: [FileInput!]!) {
  uploadCatalogFiles(folder: $folder, files: $files, customerId: $customerId) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type UploadCatalogFilesMutationFn = Apollo.MutationFunction<UploadCatalogFilesMutation, UploadCatalogFilesMutationVariables>;

/**
 * __useUploadCatalogFilesMutation__
 *
 * To run a mutation, you first call `useUploadCatalogFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCatalogFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCatalogFilesMutation, { data, loading, error }] = useUploadCatalogFilesMutation({
 *   variables: {
 *      folder: // value for 'folder'
 *      customerId: // value for 'customerId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadCatalogFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadCatalogFilesMutation, UploadCatalogFilesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadCatalogFilesMutation, UploadCatalogFilesMutationVariables>(UploadCatalogFilesDocument, options);
}
export type UploadCatalogFilesMutationHookResult = ReturnType<typeof useUploadCatalogFilesMutation>;
export type UploadCatalogFilesMutationResult = Apollo.MutationResult<UploadCatalogFilesMutation>;
export type UploadCatalogFilesMutationOptions = Apollo.BaseMutationOptions<UploadCatalogFilesMutation, UploadCatalogFilesMutationVariables>;
export const UploadInvoiceFilesDocument = gql`
    mutation UploadInvoiceFiles($caseNo: String!, $invoiceNo: String!, $files: [FileInput!]!) {
  uploadInvoiceFiles(caseNo: $caseNo, invoiceNo: $invoiceNo, files: $files) {
    ...ESDHFileFragment
  }
}
    ${EsdhFileFragmentFragmentDoc}`;
export type UploadInvoiceFilesMutationFn = Apollo.MutationFunction<UploadInvoiceFilesMutation, UploadInvoiceFilesMutationVariables>;

/**
 * __useUploadInvoiceFilesMutation__
 *
 * To run a mutation, you first call `useUploadInvoiceFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoiceFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoiceFilesMutation, { data, loading, error }] = useUploadInvoiceFilesMutation({
 *   variables: {
 *      caseNo: // value for 'caseNo'
 *      invoiceNo: // value for 'invoiceNo'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadInvoiceFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadInvoiceFilesMutation, UploadInvoiceFilesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadInvoiceFilesMutation, UploadInvoiceFilesMutationVariables>(UploadInvoiceFilesDocument, options);
}
export type UploadInvoiceFilesMutationHookResult = ReturnType<typeof useUploadInvoiceFilesMutation>;
export type UploadInvoiceFilesMutationResult = Apollo.MutationResult<UploadInvoiceFilesMutation>;
export type UploadInvoiceFilesMutationOptions = Apollo.BaseMutationOptions<UploadInvoiceFilesMutation, UploadInvoiceFilesMutationVariables>;
export const CreateGdprAcceptDocument = gql`
    mutation CreateGDPRAccept($gdpr: GDPRInputType!) {
  createGDPRAccept(gdpr: $gdpr) {
    ...BaseGDPRFragment
  }
}
    ${BaseGdprFragmentFragmentDoc}`;
export type CreateGdprAcceptMutationFn = Apollo.MutationFunction<CreateGdprAcceptMutation, CreateGdprAcceptMutationVariables>;

/**
 * __useCreateGdprAcceptMutation__
 *
 * To run a mutation, you first call `useCreateGdprAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGdprAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGdprAcceptMutation, { data, loading, error }] = useCreateGdprAcceptMutation({
 *   variables: {
 *      gdpr: // value for 'gdpr'
 *   },
 * });
 */
export function useCreateGdprAcceptMutation(baseOptions?: Apollo.MutationHookOptions<CreateGdprAcceptMutation, CreateGdprAcceptMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateGdprAcceptMutation, CreateGdprAcceptMutationVariables>(CreateGdprAcceptDocument, options);
}
export type CreateGdprAcceptMutationHookResult = ReturnType<typeof useCreateGdprAcceptMutation>;
export type CreateGdprAcceptMutationResult = Apollo.MutationResult<CreateGdprAcceptMutation>;
export type CreateGdprAcceptMutationOptions = Apollo.BaseMutationOptions<CreateGdprAcceptMutation, CreateGdprAcceptMutationVariables>;
export const DeleteGdprAcceptDocument = gql`
    mutation DeleteGDPRAccept($id: String!) {
  deleteGDPRAccept(id: $id) {
    _
  }
}
    `;
export type DeleteGdprAcceptMutationFn = Apollo.MutationFunction<DeleteGdprAcceptMutation, DeleteGdprAcceptMutationVariables>;

/**
 * __useDeleteGdprAcceptMutation__
 *
 * To run a mutation, you first call `useDeleteGdprAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGdprAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGdprAcceptMutation, { data, loading, error }] = useDeleteGdprAcceptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGdprAcceptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGdprAcceptMutation, DeleteGdprAcceptMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteGdprAcceptMutation, DeleteGdprAcceptMutationVariables>(DeleteGdprAcceptDocument, options);
}
export type DeleteGdprAcceptMutationHookResult = ReturnType<typeof useDeleteGdprAcceptMutation>;
export type DeleteGdprAcceptMutationResult = Apollo.MutationResult<DeleteGdprAcceptMutation>;
export type DeleteGdprAcceptMutationOptions = Apollo.BaseMutationOptions<DeleteGdprAcceptMutation, DeleteGdprAcceptMutationVariables>;
export const GetGdprAcceptDocument = gql`
    query GetGDPRAccept($userId: String!) {
  gdprAccept(userId: $userId) {
    ...BaseGDPRFragment
  }
}
    ${BaseGdprFragmentFragmentDoc}`;

/**
 * __useGetGdprAcceptQuery__
 *
 * To run a query within a React component, call `useGetGdprAcceptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGdprAcceptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGdprAcceptQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGdprAcceptQuery(baseOptions: Apollo.QueryHookOptions<GetGdprAcceptQuery, GetGdprAcceptQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetGdprAcceptQuery, GetGdprAcceptQueryVariables>(GetGdprAcceptDocument, options);
}
export function useGetGdprAcceptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGdprAcceptQuery, GetGdprAcceptQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetGdprAcceptQuery, GetGdprAcceptQueryVariables>(GetGdprAcceptDocument, options);
}
export function useGetGdprAcceptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGdprAcceptQuery, GetGdprAcceptQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetGdprAcceptQuery, GetGdprAcceptQueryVariables>(GetGdprAcceptDocument, options);
}
export type GetGdprAcceptQueryHookResult = ReturnType<typeof useGetGdprAcceptQuery>;
export type GetGdprAcceptLazyQueryHookResult = ReturnType<typeof useGetGdprAcceptLazyQuery>;
export type GetGdprAcceptSuspenseQueryHookResult = ReturnType<typeof useGetGdprAcceptSuspenseQuery>;
export type GetGdprAcceptQueryResult = Apollo.QueryResult<GetGdprAcceptQuery, GetGdprAcceptQueryVariables>;
export function refetchGetGdprAcceptQuery(variables: GetGdprAcceptQueryVariables) {
  return { query: GetGdprAcceptDocument, variables: variables }
}
export const UpdateGdprAcceptDocument = gql`
    mutation UpdateGDPRAccept($id: String!, $timestamp: DateTime!) {
  updateGDPRAccept(id: $id, timestamp: $timestamp) {
    ...BaseGDPRFragment
  }
}
    ${BaseGdprFragmentFragmentDoc}`;
export type UpdateGdprAcceptMutationFn = Apollo.MutationFunction<UpdateGdprAcceptMutation, UpdateGdprAcceptMutationVariables>;

/**
 * __useUpdateGdprAcceptMutation__
 *
 * To run a mutation, you first call `useUpdateGdprAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGdprAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGdprAcceptMutation, { data, loading, error }] = useUpdateGdprAcceptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useUpdateGdprAcceptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGdprAcceptMutation, UpdateGdprAcceptMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateGdprAcceptMutation, UpdateGdprAcceptMutationVariables>(UpdateGdprAcceptDocument, options);
}
export type UpdateGdprAcceptMutationHookResult = ReturnType<typeof useUpdateGdprAcceptMutation>;
export type UpdateGdprAcceptMutationResult = Apollo.MutationResult<UpdateGdprAcceptMutation>;
export type UpdateGdprAcceptMutationOptions = Apollo.BaseMutationOptions<UpdateGdprAcceptMutation, UpdateGdprAcceptMutationVariables>;
export const GetSsgSettingsDocument = gql`
    query GetSsgSettings {
  ssgSetup {
    primaryKey
    environmentFeeRessourceNo
    supplyFeeResourceNo
    supplyFeeDateFrom
    supplyFeeDateTo
  }
}
    `;

/**
 * __useGetSsgSettingsQuery__
 *
 * To run a query within a React component, call `useGetSsgSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsgSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsgSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSsgSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSsgSettingsQuery, GetSsgSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSsgSettingsQuery, GetSsgSettingsQueryVariables>(GetSsgSettingsDocument, options);
}
export function useGetSsgSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSsgSettingsQuery, GetSsgSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSsgSettingsQuery, GetSsgSettingsQueryVariables>(GetSsgSettingsDocument, options);
}
export function useGetSsgSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSsgSettingsQuery, GetSsgSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSsgSettingsQuery, GetSsgSettingsQueryVariables>(GetSsgSettingsDocument, options);
}
export type GetSsgSettingsQueryHookResult = ReturnType<typeof useGetSsgSettingsQuery>;
export type GetSsgSettingsLazyQueryHookResult = ReturnType<typeof useGetSsgSettingsLazyQuery>;
export type GetSsgSettingsSuspenseQueryHookResult = ReturnType<typeof useGetSsgSettingsSuspenseQuery>;
export type GetSsgSettingsQueryResult = Apollo.QueryResult<GetSsgSettingsQuery, GetSsgSettingsQueryVariables>;
export function refetchGetSsgSettingsQuery(variables?: GetSsgSettingsQueryVariables) {
  return { query: GetSsgSettingsDocument, variables: variables }
}
export const UpdateWebInputFieldDocument = gql`
    mutation UpdateWebInputField($key: String!, $permissionsList: [Permissions!]!) {
  updateInputField(key: $key, permissionsList: $permissionsList) {
    key
    permissions
  }
}
    `;
export type UpdateWebInputFieldMutationFn = Apollo.MutationFunction<UpdateWebInputFieldMutation, UpdateWebInputFieldMutationVariables>;

/**
 * __useUpdateWebInputFieldMutation__
 *
 * To run a mutation, you first call `useUpdateWebInputFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebInputFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebInputFieldMutation, { data, loading, error }] = useUpdateWebInputFieldMutation({
 *   variables: {
 *      key: // value for 'key'
 *      permissionsList: // value for 'permissionsList'
 *   },
 * });
 */
export function useUpdateWebInputFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebInputFieldMutation, UpdateWebInputFieldMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateWebInputFieldMutation, UpdateWebInputFieldMutationVariables>(UpdateWebInputFieldDocument, options);
}
export type UpdateWebInputFieldMutationHookResult = ReturnType<typeof useUpdateWebInputFieldMutation>;
export type UpdateWebInputFieldMutationResult = Apollo.MutationResult<UpdateWebInputFieldMutation>;
export type UpdateWebInputFieldMutationOptions = Apollo.BaseMutationOptions<UpdateWebInputFieldMutation, UpdateWebInputFieldMutationVariables>;
export const ApproveInvoiceDocument = gql`
    mutation ApproveInvoice($caseId: String!, $invoiceERPReference: String!) {
  approveInvoice(caseId: $caseId, invoiceERPReference: $invoiceERPReference) {
    ...DraftInvoiceFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}`;
export type ApproveInvoiceMutationFn = Apollo.MutationFunction<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>;

/**
 * __useApproveInvoiceMutation__
 *
 * To run a mutation, you first call `useApproveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInvoiceMutation, { data, loading, error }] = useApproveInvoiceMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *   },
 * });
 */
export function useApproveInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>(ApproveInvoiceDocument, options);
}
export type ApproveInvoiceMutationHookResult = ReturnType<typeof useApproveInvoiceMutation>;
export type ApproveInvoiceMutationResult = Apollo.MutationResult<ApproveInvoiceMutation>;
export type ApproveInvoiceMutationOptions = Apollo.BaseMutationOptions<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>;
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($caseId: String!, $category: InvoiceCategory!) {
  createInvoice(caseId: $caseId, category: $category) {
    ...DraftInvoiceFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}`;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
}
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($caseId: String!, $invoiceERPReference: String!) {
  deleteInvoice(caseId: $caseId, invoiceERPReference: $invoiceERPReference) {
    _
  }
}
    `;
export type DeleteInvoiceMutationFn = Apollo.MutationFunction<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
}
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<DeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const AllAssortmentsDocument = gql`
    query AllAssortments($assortmentCode: String!) {
  allAssortments(assortmentCode: $assortmentCode) {
    no
    type
    description
    uom
  }
}
    `;

/**
 * __useAllAssortmentsQuery__
 *
 * To run a query within a React component, call `useAllAssortmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssortmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssortmentsQuery({
 *   variables: {
 *      assortmentCode: // value for 'assortmentCode'
 *   },
 * });
 */
export function useAllAssortmentsQuery(baseOptions: Apollo.QueryHookOptions<AllAssortmentsQuery, AllAssortmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AllAssortmentsQuery, AllAssortmentsQueryVariables>(AllAssortmentsDocument, options);
}
export function useAllAssortmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAssortmentsQuery, AllAssortmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AllAssortmentsQuery, AllAssortmentsQueryVariables>(AllAssortmentsDocument, options);
}
export function useAllAssortmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllAssortmentsQuery, AllAssortmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AllAssortmentsQuery, AllAssortmentsQueryVariables>(AllAssortmentsDocument, options);
}
export type AllAssortmentsQueryHookResult = ReturnType<typeof useAllAssortmentsQuery>;
export type AllAssortmentsLazyQueryHookResult = ReturnType<typeof useAllAssortmentsLazyQuery>;
export type AllAssortmentsSuspenseQueryHookResult = ReturnType<typeof useAllAssortmentsSuspenseQuery>;
export type AllAssortmentsQueryResult = Apollo.QueryResult<AllAssortmentsQuery, AllAssortmentsQueryVariables>;
export function refetchAllAssortmentsQuery(variables: AllAssortmentsQueryVariables) {
  return { query: AllAssortmentsDocument, variables: variables }
}
export const GetDraftInvoiceLineTypesDocument = gql`
    query GetDraftInvoiceLineTypes {
  draftInvoiceLineTypes {
    id
    name
  }
}
    `;

/**
 * __useGetDraftInvoiceLineTypesQuery__
 *
 * To run a query within a React component, call `useGetDraftInvoiceLineTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftInvoiceLineTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftInvoiceLineTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDraftInvoiceLineTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetDraftInvoiceLineTypesQuery, GetDraftInvoiceLineTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDraftInvoiceLineTypesQuery, GetDraftInvoiceLineTypesQueryVariables>(GetDraftInvoiceLineTypesDocument, options);
}
export function useGetDraftInvoiceLineTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftInvoiceLineTypesQuery, GetDraftInvoiceLineTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDraftInvoiceLineTypesQuery, GetDraftInvoiceLineTypesQueryVariables>(GetDraftInvoiceLineTypesDocument, options);
}
export function useGetDraftInvoiceLineTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDraftInvoiceLineTypesQuery, GetDraftInvoiceLineTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDraftInvoiceLineTypesQuery, GetDraftInvoiceLineTypesQueryVariables>(GetDraftInvoiceLineTypesDocument, options);
}
export type GetDraftInvoiceLineTypesQueryHookResult = ReturnType<typeof useGetDraftInvoiceLineTypesQuery>;
export type GetDraftInvoiceLineTypesLazyQueryHookResult = ReturnType<typeof useGetDraftInvoiceLineTypesLazyQuery>;
export type GetDraftInvoiceLineTypesSuspenseQueryHookResult = ReturnType<typeof useGetDraftInvoiceLineTypesSuspenseQuery>;
export type GetDraftInvoiceLineTypesQueryResult = Apollo.QueryResult<GetDraftInvoiceLineTypesQuery, GetDraftInvoiceLineTypesQueryVariables>;
export function refetchGetDraftInvoiceLineTypesQuery(variables?: GetDraftInvoiceLineTypesQueryVariables) {
  return { query: GetDraftInvoiceLineTypesDocument, variables: variables }
}
export const GetInvoiceApprovalDocument = gql`
    query GetInvoiceApproval($caseId: String!) {
  case(id: $caseId) {
    id
    erpNo
    createdAt
    projectManager {
      name
    }
    debitor {
      company
      maxEnvironmentFeeAmount
      environmentFeePercentage
      supplyFeePercentage
      maxSupplyFeeAmount
      supplyFeeDateFrom
      supplyFeeDateTo
      assortmentCode
    }
    ssgDepartment {
      name
      departmentNumber
    }
    invoices {
      createdBy {
        name
      }
      ...DraftInvoiceFragment
    }
    screenings {
      lines {
        erpReferenceId
        uom
      }
    }
  }
  invoiceReasonCodes {
    ...InvoiceReasonCodeFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}
${InvoiceReasonCodeFragmentFragmentDoc}`;

/**
 * __useGetInvoiceApprovalQuery__
 *
 * To run a query within a React component, call `useGetInvoiceApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceApprovalQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetInvoiceApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceApprovalQuery, GetInvoiceApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInvoiceApprovalQuery, GetInvoiceApprovalQueryVariables>(GetInvoiceApprovalDocument, options);
}
export function useGetInvoiceApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceApprovalQuery, GetInvoiceApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInvoiceApprovalQuery, GetInvoiceApprovalQueryVariables>(GetInvoiceApprovalDocument, options);
}
export function useGetInvoiceApprovalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceApprovalQuery, GetInvoiceApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInvoiceApprovalQuery, GetInvoiceApprovalQueryVariables>(GetInvoiceApprovalDocument, options);
}
export type GetInvoiceApprovalQueryHookResult = ReturnType<typeof useGetInvoiceApprovalQuery>;
export type GetInvoiceApprovalLazyQueryHookResult = ReturnType<typeof useGetInvoiceApprovalLazyQuery>;
export type GetInvoiceApprovalSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceApprovalSuspenseQuery>;
export type GetInvoiceApprovalQueryResult = Apollo.QueryResult<GetInvoiceApprovalQuery, GetInvoiceApprovalQueryVariables>;
export function refetchGetInvoiceApprovalQuery(variables: GetInvoiceApprovalQueryVariables) {
  return { query: GetInvoiceApprovalDocument, variables: variables }
}
export const GetInvoiceAttachmentsDocument = gql`
    query GetInvoiceAttachments($caseId: String!, $invoiceNo: String!) {
  invoice(caseId: $caseId, invoiceNo: $invoiceNo) {
    attachments {
      name
      url
      fileId
    }
  }
}
    `;

/**
 * __useGetInvoiceAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetInvoiceAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceAttachmentsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceNo: // value for 'invoiceNo'
 *   },
 * });
 */
export function useGetInvoiceAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceAttachmentsQuery, GetInvoiceAttachmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInvoiceAttachmentsQuery, GetInvoiceAttachmentsQueryVariables>(GetInvoiceAttachmentsDocument, options);
}
export function useGetInvoiceAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceAttachmentsQuery, GetInvoiceAttachmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInvoiceAttachmentsQuery, GetInvoiceAttachmentsQueryVariables>(GetInvoiceAttachmentsDocument, options);
}
export function useGetInvoiceAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceAttachmentsQuery, GetInvoiceAttachmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInvoiceAttachmentsQuery, GetInvoiceAttachmentsQueryVariables>(GetInvoiceAttachmentsDocument, options);
}
export type GetInvoiceAttachmentsQueryHookResult = ReturnType<typeof useGetInvoiceAttachmentsQuery>;
export type GetInvoiceAttachmentsLazyQueryHookResult = ReturnType<typeof useGetInvoiceAttachmentsLazyQuery>;
export type GetInvoiceAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceAttachmentsSuspenseQuery>;
export type GetInvoiceAttachmentsQueryResult = Apollo.QueryResult<GetInvoiceAttachmentsQuery, GetInvoiceAttachmentsQueryVariables>;
export function refetchGetInvoiceAttachmentsQuery(variables: GetInvoiceAttachmentsQueryVariables) {
  return { query: GetInvoiceAttachmentsDocument, variables: variables }
}
export const GetInvoiceHeaderDocument = gql`
    query GetInvoiceHeader($caseERPReferenceNo: String!) {
  invoiceHeaders(caseERPReferenceNo: $caseERPReferenceNo) {
    no
    orderNo
    salesPerson
    customerNo
    paymentTerms
    jobNo
  }
}
    `;

/**
 * __useGetInvoiceHeaderQuery__
 *
 * To run a query within a React component, call `useGetInvoiceHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceHeaderQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useGetInvoiceHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceHeaderQuery, GetInvoiceHeaderQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInvoiceHeaderQuery, GetInvoiceHeaderQueryVariables>(GetInvoiceHeaderDocument, options);
}
export function useGetInvoiceHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceHeaderQuery, GetInvoiceHeaderQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInvoiceHeaderQuery, GetInvoiceHeaderQueryVariables>(GetInvoiceHeaderDocument, options);
}
export function useGetInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceHeaderQuery, GetInvoiceHeaderQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInvoiceHeaderQuery, GetInvoiceHeaderQueryVariables>(GetInvoiceHeaderDocument, options);
}
export type GetInvoiceHeaderQueryHookResult = ReturnType<typeof useGetInvoiceHeaderQuery>;
export type GetInvoiceHeaderLazyQueryHookResult = ReturnType<typeof useGetInvoiceHeaderLazyQuery>;
export type GetInvoiceHeaderSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceHeaderSuspenseQuery>;
export type GetInvoiceHeaderQueryResult = Apollo.QueryResult<GetInvoiceHeaderQuery, GetInvoiceHeaderQueryVariables>;
export function refetchGetInvoiceHeaderQuery(variables: GetInvoiceHeaderQueryVariables) {
  return { query: GetInvoiceHeaderDocument, variables: variables }
}
export const GetInvoicePredictionsDocument = gql`
    query GetInvoicePredictions($invoicePredictionInput: AIInvoicePredictionInputType!) {
  invoicePredictions(invoicePredictionInput: $invoicePredictionInput) {
    jobTaskDescriptions
    lineSuggestions {
      systemId
      no
      erpReferenceTask
      lineAmount
      lineType
      type
      attachDocument
      allowAttachDocument
      description
      quoteLineId
      screeningTitle
      screeningLine
      screeningLineId
      screeningLinePosition
      quantity
      unitPrice
      unitCost
      newUnitPrice
      workTypeCode
      screeningLinePositionText
    }
  }
}
    `;

/**
 * __useGetInvoicePredictionsQuery__
 *
 * To run a query within a React component, call `useGetInvoicePredictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePredictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePredictionsQuery({
 *   variables: {
 *      invoicePredictionInput: // value for 'invoicePredictionInput'
 *   },
 * });
 */
export function useGetInvoicePredictionsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePredictionsQuery, GetInvoicePredictionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInvoicePredictionsQuery, GetInvoicePredictionsQueryVariables>(GetInvoicePredictionsDocument, options);
}
export function useGetInvoicePredictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePredictionsQuery, GetInvoicePredictionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInvoicePredictionsQuery, GetInvoicePredictionsQueryVariables>(GetInvoicePredictionsDocument, options);
}
export function useGetInvoicePredictionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoicePredictionsQuery, GetInvoicePredictionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInvoicePredictionsQuery, GetInvoicePredictionsQueryVariables>(GetInvoicePredictionsDocument, options);
}
export type GetInvoicePredictionsQueryHookResult = ReturnType<typeof useGetInvoicePredictionsQuery>;
export type GetInvoicePredictionsLazyQueryHookResult = ReturnType<typeof useGetInvoicePredictionsLazyQuery>;
export type GetInvoicePredictionsSuspenseQueryHookResult = ReturnType<typeof useGetInvoicePredictionsSuspenseQuery>;
export type GetInvoicePredictionsQueryResult = Apollo.QueryResult<GetInvoicePredictionsQuery, GetInvoicePredictionsQueryVariables>;
export function refetchGetInvoicePredictionsQuery(variables: GetInvoicePredictionsQueryVariables) {
  return { query: GetInvoicePredictionsDocument, variables: variables }
}
export const InvoiceResourcesDocument = gql`
    query InvoiceResources {
  invoiceResources {
    ...BaseOfferResourceFragment
  }
}
    ${BaseOfferResourceFragmentFragmentDoc}`;

/**
 * __useInvoiceResourcesQuery__
 *
 * To run a query within a React component, call `useInvoiceResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoiceResourcesQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceResourcesQuery, InvoiceResourcesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InvoiceResourcesQuery, InvoiceResourcesQueryVariables>(InvoiceResourcesDocument, options);
}
export function useInvoiceResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceResourcesQuery, InvoiceResourcesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InvoiceResourcesQuery, InvoiceResourcesQueryVariables>(InvoiceResourcesDocument, options);
}
export function useInvoiceResourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceResourcesQuery, InvoiceResourcesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<InvoiceResourcesQuery, InvoiceResourcesQueryVariables>(InvoiceResourcesDocument, options);
}
export type InvoiceResourcesQueryHookResult = ReturnType<typeof useInvoiceResourcesQuery>;
export type InvoiceResourcesLazyQueryHookResult = ReturnType<typeof useInvoiceResourcesLazyQuery>;
export type InvoiceResourcesSuspenseQueryHookResult = ReturnType<typeof useInvoiceResourcesSuspenseQuery>;
export type InvoiceResourcesQueryResult = Apollo.QueryResult<InvoiceResourcesQuery, InvoiceResourcesQueryVariables>;
export function refetchInvoiceResourcesQuery(variables?: InvoiceResourcesQueryVariables) {
  return { query: InvoiceResourcesDocument, variables: variables }
}
export const GetInvoicesDocument = gql`
    query GetInvoices($caseId: String!) {
  invoices(caseId: $caseId) {
    ...DraftInvoiceFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
}
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
}
export function useGetInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
}
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesSuspenseQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export function refetchGetInvoicesQuery(variables: GetInvoicesQueryVariables) {
  return { query: GetInvoicesDocument, variables: variables }
}
export const GetInvoicesForUsersApprovalDocument = gql`
    query GetInvoicesForUsersApproval($department: [String!]) {
  invoicesForUsersApproval(department: $department) {
    case {
      id
      erpNo
      debitor {
        company
        environmentFeePercentage
        maxEnvironmentFeeAmount
        supplyFeePercentage
        maxSupplyFeeAmount
        supplyFeeDateFrom
        supplyFeeDateTo
      }
      projectManager {
        name
      }
      ssgDepartment {
        name
        departmentNumber
      }
      caseEconomics(include: true) {
        costTotal
      }
    }
    invoiceToApprove {
      erpReferenceNo
      category
      lines {
        quantity
        unitPrice
        unitCost
        no
        newUnitPrice
      }
      createdBy {
        name
      }
    }
  }
}
    `;

/**
 * __useGetInvoicesForUsersApprovalQuery__
 *
 * To run a query within a React component, call `useGetInvoicesForUsersApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesForUsersApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesForUsersApprovalQuery({
 *   variables: {
 *      department: // value for 'department'
 *   },
 * });
 */
export function useGetInvoicesForUsersApprovalQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesForUsersApprovalQuery, GetInvoicesForUsersApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInvoicesForUsersApprovalQuery, GetInvoicesForUsersApprovalQueryVariables>(GetInvoicesForUsersApprovalDocument, options);
}
export function useGetInvoicesForUsersApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesForUsersApprovalQuery, GetInvoicesForUsersApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInvoicesForUsersApprovalQuery, GetInvoicesForUsersApprovalQueryVariables>(GetInvoicesForUsersApprovalDocument, options);
}
export function useGetInvoicesForUsersApprovalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoicesForUsersApprovalQuery, GetInvoicesForUsersApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInvoicesForUsersApprovalQuery, GetInvoicesForUsersApprovalQueryVariables>(GetInvoicesForUsersApprovalDocument, options);
}
export type GetInvoicesForUsersApprovalQueryHookResult = ReturnType<typeof useGetInvoicesForUsersApprovalQuery>;
export type GetInvoicesForUsersApprovalLazyQueryHookResult = ReturnType<typeof useGetInvoicesForUsersApprovalLazyQuery>;
export type GetInvoicesForUsersApprovalSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesForUsersApprovalSuspenseQuery>;
export type GetInvoicesForUsersApprovalQueryResult = Apollo.QueryResult<GetInvoicesForUsersApprovalQuery, GetInvoicesForUsersApprovalQueryVariables>;
export function refetchGetInvoicesForUsersApprovalQuery(variables?: GetInvoicesForUsersApprovalQueryVariables) {
  return { query: GetInvoicesForUsersApprovalDocument, variables: variables }
}
export const GetSalesInvoiceLinesDocument = gql`
    query GetSalesInvoiceLines($offerERPReferenceNo: String!) {
  salesInvoiceLines(offerERPReferenceNo: $offerERPReferenceNo) {
    ...SalesInvoiceLineFragment
  }
}
    ${SalesInvoiceLineFragmentFragmentDoc}`;

/**
 * __useGetSalesInvoiceLinesQuery__
 *
 * To run a query within a React component, call `useGetSalesInvoiceLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesInvoiceLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesInvoiceLinesQuery({
 *   variables: {
 *      offerERPReferenceNo: // value for 'offerERPReferenceNo'
 *   },
 * });
 */
export function useGetSalesInvoiceLinesQuery(baseOptions: Apollo.QueryHookOptions<GetSalesInvoiceLinesQuery, GetSalesInvoiceLinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSalesInvoiceLinesQuery, GetSalesInvoiceLinesQueryVariables>(GetSalesInvoiceLinesDocument, options);
}
export function useGetSalesInvoiceLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesInvoiceLinesQuery, GetSalesInvoiceLinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSalesInvoiceLinesQuery, GetSalesInvoiceLinesQueryVariables>(GetSalesInvoiceLinesDocument, options);
}
export function useGetSalesInvoiceLinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSalesInvoiceLinesQuery, GetSalesInvoiceLinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSalesInvoiceLinesQuery, GetSalesInvoiceLinesQueryVariables>(GetSalesInvoiceLinesDocument, options);
}
export type GetSalesInvoiceLinesQueryHookResult = ReturnType<typeof useGetSalesInvoiceLinesQuery>;
export type GetSalesInvoiceLinesLazyQueryHookResult = ReturnType<typeof useGetSalesInvoiceLinesLazyQuery>;
export type GetSalesInvoiceLinesSuspenseQueryHookResult = ReturnType<typeof useGetSalesInvoiceLinesSuspenseQuery>;
export type GetSalesInvoiceLinesQueryResult = Apollo.QueryResult<GetSalesInvoiceLinesQuery, GetSalesInvoiceLinesQueryVariables>;
export function refetchGetSalesInvoiceLinesQuery(variables: GetSalesInvoiceLinesQueryVariables) {
  return { query: GetSalesInvoiceLinesDocument, variables: variables }
}
export const GetSamplePriceForInvoiceLineDocument = gql`
    mutation GetSamplePriceForInvoiceLine($invoiceLine: DraftInvoiceLineInputType!) {
  samplePriceForInvoiceLine(invoiceLine: $invoiceLine) {
    totalCost
    lineAmount
  }
}
    `;
export type GetSamplePriceForInvoiceLineMutationFn = Apollo.MutationFunction<GetSamplePriceForInvoiceLineMutation, GetSamplePriceForInvoiceLineMutationVariables>;

/**
 * __useGetSamplePriceForInvoiceLineMutation__
 *
 * To run a mutation, you first call `useGetSamplePriceForInvoiceLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSamplePriceForInvoiceLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSamplePriceForInvoiceLineMutation, { data, loading, error }] = useGetSamplePriceForInvoiceLineMutation({
 *   variables: {
 *      invoiceLine: // value for 'invoiceLine'
 *   },
 * });
 */
export function useGetSamplePriceForInvoiceLineMutation(baseOptions?: Apollo.MutationHookOptions<GetSamplePriceForInvoiceLineMutation, GetSamplePriceForInvoiceLineMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GetSamplePriceForInvoiceLineMutation, GetSamplePriceForInvoiceLineMutationVariables>(GetSamplePriceForInvoiceLineDocument, options);
}
export type GetSamplePriceForInvoiceLineMutationHookResult = ReturnType<typeof useGetSamplePriceForInvoiceLineMutation>;
export type GetSamplePriceForInvoiceLineMutationResult = Apollo.MutationResult<GetSamplePriceForInvoiceLineMutation>;
export type GetSamplePriceForInvoiceLineMutationOptions = Apollo.BaseMutationOptions<GetSamplePriceForInvoiceLineMutation, GetSamplePriceForInvoiceLineMutationVariables>;
export const OpenInvoiceForEditingDocument = gql`
    mutation OpenInvoiceForEditing($caseId: String!, $invoiceERPReference: String!) {
  openInvoiceForEditing(
    caseId: $caseId
    invoiceERPReference: $invoiceERPReference
  ) {
    erpReferenceNo
  }
}
    `;
export type OpenInvoiceForEditingMutationFn = Apollo.MutationFunction<OpenInvoiceForEditingMutation, OpenInvoiceForEditingMutationVariables>;

/**
 * __useOpenInvoiceForEditingMutation__
 *
 * To run a mutation, you first call `useOpenInvoiceForEditingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenInvoiceForEditingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openInvoiceForEditingMutation, { data, loading, error }] = useOpenInvoiceForEditingMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *   },
 * });
 */
export function useOpenInvoiceForEditingMutation(baseOptions?: Apollo.MutationHookOptions<OpenInvoiceForEditingMutation, OpenInvoiceForEditingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OpenInvoiceForEditingMutation, OpenInvoiceForEditingMutationVariables>(OpenInvoiceForEditingDocument, options);
}
export type OpenInvoiceForEditingMutationHookResult = ReturnType<typeof useOpenInvoiceForEditingMutation>;
export type OpenInvoiceForEditingMutationResult = Apollo.MutationResult<OpenInvoiceForEditingMutation>;
export type OpenInvoiceForEditingMutationOptions = Apollo.BaseMutationOptions<OpenInvoiceForEditingMutation, OpenInvoiceForEditingMutationVariables>;
export const OverrideInvoiceDatesDocument = gql`
    mutation OverrideInvoiceDates($caseId: String!, $invoiceERPReference: String!, $documentDate: Date!, $fromDate: Date!, $toDate: Date!) {
  overrideInvoiceDates(
    caseId: $caseId
    invoiceERPReference: $invoiceERPReference
    documentDate: $documentDate
    fromDate: $fromDate
    toDate: $toDate
  ) {
    _
  }
}
    `;
export type OverrideInvoiceDatesMutationFn = Apollo.MutationFunction<OverrideInvoiceDatesMutation, OverrideInvoiceDatesMutationVariables>;

/**
 * __useOverrideInvoiceDatesMutation__
 *
 * To run a mutation, you first call `useOverrideInvoiceDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideInvoiceDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideInvoiceDatesMutation, { data, loading, error }] = useOverrideInvoiceDatesMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *      documentDate: // value for 'documentDate'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useOverrideInvoiceDatesMutation(baseOptions?: Apollo.MutationHookOptions<OverrideInvoiceDatesMutation, OverrideInvoiceDatesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OverrideInvoiceDatesMutation, OverrideInvoiceDatesMutationVariables>(OverrideInvoiceDatesDocument, options);
}
export type OverrideInvoiceDatesMutationHookResult = ReturnType<typeof useOverrideInvoiceDatesMutation>;
export type OverrideInvoiceDatesMutationResult = Apollo.MutationResult<OverrideInvoiceDatesMutation>;
export type OverrideInvoiceDatesMutationOptions = Apollo.BaseMutationOptions<OverrideInvoiceDatesMutation, OverrideInvoiceDatesMutationVariables>;
export const RejectInvoiceDocument = gql`
    mutation RejectInvoice($caseId: String!, $invoiceERPReference: String!, $rejectionReason: String) {
  rejectInvoice(
    caseId: $caseId
    invoiceERPReference: $invoiceERPReference
    rejectionReason: $rejectionReason
  ) {
    ...DraftInvoiceFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}`;
export type RejectInvoiceMutationFn = Apollo.MutationFunction<RejectInvoiceMutation, RejectInvoiceMutationVariables>;

/**
 * __useRejectInvoiceMutation__
 *
 * To run a mutation, you first call `useRejectInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInvoiceMutation, { data, loading, error }] = useRejectInvoiceMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useRejectInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<RejectInvoiceMutation, RejectInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RejectInvoiceMutation, RejectInvoiceMutationVariables>(RejectInvoiceDocument, options);
}
export type RejectInvoiceMutationHookResult = ReturnType<typeof useRejectInvoiceMutation>;
export type RejectInvoiceMutationResult = Apollo.MutationResult<RejectInvoiceMutation>;
export type RejectInvoiceMutationOptions = Apollo.BaseMutationOptions<RejectInvoiceMutation, RejectInvoiceMutationVariables>;
export const RequestInvoiceApprovalDocument = gql`
    mutation RequestInvoiceApproval($caseId: String!, $invoiceERPReference: String!) {
  requestInvoiceApproval(
    caseId: $caseId
    invoiceERPReference: $invoiceERPReference
  ) {
    ...DraftInvoiceFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}`;
export type RequestInvoiceApprovalMutationFn = Apollo.MutationFunction<RequestInvoiceApprovalMutation, RequestInvoiceApprovalMutationVariables>;

/**
 * __useRequestInvoiceApprovalMutation__
 *
 * To run a mutation, you first call `useRequestInvoiceApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestInvoiceApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestInvoiceApprovalMutation, { data, loading, error }] = useRequestInvoiceApprovalMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *   },
 * });
 */
export function useRequestInvoiceApprovalMutation(baseOptions?: Apollo.MutationHookOptions<RequestInvoiceApprovalMutation, RequestInvoiceApprovalMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RequestInvoiceApprovalMutation, RequestInvoiceApprovalMutationVariables>(RequestInvoiceApprovalDocument, options);
}
export type RequestInvoiceApprovalMutationHookResult = ReturnType<typeof useRequestInvoiceApprovalMutation>;
export type RequestInvoiceApprovalMutationResult = Apollo.MutationResult<RequestInvoiceApprovalMutation>;
export type RequestInvoiceApprovalMutationOptions = Apollo.BaseMutationOptions<RequestInvoiceApprovalMutation, RequestInvoiceApprovalMutationVariables>;
export const SetInvoiceReasonCodesDocument = gql`
    mutation SetInvoiceReasonCodes($caseId: String!, $invoiceERPReference: String!, $validationRuleBypasses: [ValidationRuleBypassInput!]!) {
  setInvoiceReasonCodes(
    caseId: $caseId
    invoiceERPReference: $invoiceERPReference
    validationRuleBypasses: $validationRuleBypasses
  ) {
    ...DraftInvoiceFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}`;
export type SetInvoiceReasonCodesMutationFn = Apollo.MutationFunction<SetInvoiceReasonCodesMutation, SetInvoiceReasonCodesMutationVariables>;

/**
 * __useSetInvoiceReasonCodesMutation__
 *
 * To run a mutation, you first call `useSetInvoiceReasonCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInvoiceReasonCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInvoiceReasonCodesMutation, { data, loading, error }] = useSetInvoiceReasonCodesMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *      validationRuleBypasses: // value for 'validationRuleBypasses'
 *   },
 * });
 */
export function useSetInvoiceReasonCodesMutation(baseOptions?: Apollo.MutationHookOptions<SetInvoiceReasonCodesMutation, SetInvoiceReasonCodesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetInvoiceReasonCodesMutation, SetInvoiceReasonCodesMutationVariables>(SetInvoiceReasonCodesDocument, options);
}
export type SetInvoiceReasonCodesMutationHookResult = ReturnType<typeof useSetInvoiceReasonCodesMutation>;
export type SetInvoiceReasonCodesMutationResult = Apollo.MutationResult<SetInvoiceReasonCodesMutation>;
export type SetInvoiceReasonCodesMutationOptions = Apollo.BaseMutationOptions<SetInvoiceReasonCodesMutation, SetInvoiceReasonCodesMutationVariables>;
export const SuggestInvoiceLinesDocument = gql`
    mutation SuggestInvoiceLines($caseId: String!, $invoiceERPReference: String!, $includePreviousLines: Boolean) {
  suggestInvoiceLines(
    caseId: $caseId
    invoiceERPReference: $invoiceERPReference
    includePreviousLines: $includePreviousLines
  ) {
    ...DraftInvoiceLineFragment
  }
}
    ${DraftInvoiceLineFragmentFragmentDoc}`;
export type SuggestInvoiceLinesMutationFn = Apollo.MutationFunction<SuggestInvoiceLinesMutation, SuggestInvoiceLinesMutationVariables>;

/**
 * __useSuggestInvoiceLinesMutation__
 *
 * To run a mutation, you first call `useSuggestInvoiceLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestInvoiceLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestInvoiceLinesMutation, { data, loading, error }] = useSuggestInvoiceLinesMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *      includePreviousLines: // value for 'includePreviousLines'
 *   },
 * });
 */
export function useSuggestInvoiceLinesMutation(baseOptions?: Apollo.MutationHookOptions<SuggestInvoiceLinesMutation, SuggestInvoiceLinesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SuggestInvoiceLinesMutation, SuggestInvoiceLinesMutationVariables>(SuggestInvoiceLinesDocument, options);
}
export type SuggestInvoiceLinesMutationHookResult = ReturnType<typeof useSuggestInvoiceLinesMutation>;
export type SuggestInvoiceLinesMutationResult = Apollo.MutationResult<SuggestInvoiceLinesMutation>;
export type SuggestInvoiceLinesMutationOptions = Apollo.BaseMutationOptions<SuggestInvoiceLinesMutation, SuggestInvoiceLinesMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($caseId: String!, $invoiceERPReference: String!, $lines: [DraftInvoiceLineInputType!]!, $invoiceDescription: String!) {
  updateInvoice(
    caseId: $caseId
    invoiceERPReference: $invoiceERPReference
    lines: $lines
    invoiceDescription: $invoiceDescription
  ) {
    ...DraftInvoiceFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}`;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *      lines: // value for 'lines'
 *      invoiceDescription: // value for 'invoiceDescription'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
}
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const UpdateScreeningInvoiceDocument = gql`
    mutation UpdateScreeningInvoice($caseId: String!, $invoiceERPReference: String!, $invoiceDescription: String!, $lines: [DraftInvoiceLineInputType!]!) {
  updateScreeningInvoice(
    caseId: $caseId
    invoiceERPReference: $invoiceERPReference
    invoiceDescription: $invoiceDescription
    lines: $lines
  ) {
    ...DraftInvoiceFragment
  }
}
    ${DraftInvoiceFragmentFragmentDoc}`;
export type UpdateScreeningInvoiceMutationFn = Apollo.MutationFunction<UpdateScreeningInvoiceMutation, UpdateScreeningInvoiceMutationVariables>;

/**
 * __useUpdateScreeningInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateScreeningInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreeningInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreeningInvoiceMutation, { data, loading, error }] = useUpdateScreeningInvoiceMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *      invoiceDescription: // value for 'invoiceDescription'
 *      lines: // value for 'lines'
 *   },
 * });
 */
export function useUpdateScreeningInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScreeningInvoiceMutation, UpdateScreeningInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScreeningInvoiceMutation, UpdateScreeningInvoiceMutationVariables>(UpdateScreeningInvoiceDocument, options);
}
export type UpdateScreeningInvoiceMutationHookResult = ReturnType<typeof useUpdateScreeningInvoiceMutation>;
export type UpdateScreeningInvoiceMutationResult = Apollo.MutationResult<UpdateScreeningInvoiceMutation>;
export type UpdateScreeningInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateScreeningInvoiceMutation, UpdateScreeningInvoiceMutationVariables>;
export const ValidateInvoiceDocument = gql`
    mutation ValidateInvoice($caseId: String!, $invoiceERPReference: String!) {
  validateInvoice(caseId: $caseId, invoiceERPReference: $invoiceERPReference) {
    key
    value {
      valid
      bypassAllowed
      expectedResult
      actualResult
    }
  }
}
    `;
export type ValidateInvoiceMutationFn = Apollo.MutationFunction<ValidateInvoiceMutation, ValidateInvoiceMutationVariables>;

/**
 * __useValidateInvoiceMutation__
 *
 * To run a mutation, you first call `useValidateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateInvoiceMutation, { data, loading, error }] = useValidateInvoiceMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      invoiceERPReference: // value for 'invoiceERPReference'
 *   },
 * });
 */
export function useValidateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ValidateInvoiceMutation, ValidateInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ValidateInvoiceMutation, ValidateInvoiceMutationVariables>(ValidateInvoiceDocument, options);
}
export type ValidateInvoiceMutationHookResult = ReturnType<typeof useValidateInvoiceMutation>;
export type ValidateInvoiceMutationResult = Apollo.MutationResult<ValidateInvoiceMutation>;
export type ValidateInvoiceMutationOptions = Apollo.BaseMutationOptions<ValidateInvoiceMutation, ValidateInvoiceMutationVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($job: JobInput!) {
  createJob(job: $job) {
    ...BaseJobFragment
  }
}
    ${BaseJobFragmentFragmentDoc}`;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      job: // value for 'job'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
}
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const GetJobsDocument = gql`
    query GetJobs($type: JobType, $personalOnly: Boolean, $case: String, $location: String, $completed: Boolean, $assignedTo: String, $proxyFor: [String!]) {
  jobs(
    type: $type
    personalOnly: $personalOnly
    case: $case
    location: $location
    completed: $completed
    assignedTo: $assignedTo
    proxyFor: $proxyFor
  ) {
    ...BaseJobFragment
  }
}
    ${BaseJobFragmentFragmentDoc}`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      personalOnly: // value for 'personalOnly'
 *      case: // value for 'case'
 *      location: // value for 'location'
 *      completed: // value for 'completed'
 *      assignedTo: // value for 'assignedTo'
 *      proxyFor: // value for 'proxyFor'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsSuspenseQueryHookResult = ReturnType<typeof useGetJobsSuspenseQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export function refetchGetJobsQuery(variables?: GetJobsQueryVariables) {
  return { query: GetJobsDocument, variables: variables }
}
export const UpdateJobDocument = gql`
    mutation UpdateJob($id: String!, $description: String, $deadline: DateTime, $assignedTo: String, $completed: Boolean) {
  updateJob(
    id: $id
    description: $description
    deadline: $deadline
    assignedTo: $assignedTo
    completed: $completed
  ) {
    ...BaseJobFragment
  }
}
    ${BaseJobFragmentFragmentDoc}`;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      deadline: // value for 'deadline'
 *      assignedTo: // value for 'assignedTo'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
}
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const GetWebLocationsDocument = gql`
    query GetWebLocations($movableLocationsOnly: Boolean) {
  locations(movableLocationsOnly: $movableLocationsOnly) {
    ...BaseLocationFragment
  }
}
    ${BaseLocationFragmentFragmentDoc}`;

/**
 * __useGetWebLocationsQuery__
 *
 * To run a query within a React component, call `useGetWebLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebLocationsQuery({
 *   variables: {
 *      movableLocationsOnly: // value for 'movableLocationsOnly'
 *   },
 * });
 */
export function useGetWebLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebLocationsQuery, GetWebLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebLocationsQuery, GetWebLocationsQueryVariables>(GetWebLocationsDocument, options);
}
export function useGetWebLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebLocationsQuery, GetWebLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebLocationsQuery, GetWebLocationsQueryVariables>(GetWebLocationsDocument, options);
}
export function useGetWebLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebLocationsQuery, GetWebLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebLocationsQuery, GetWebLocationsQueryVariables>(GetWebLocationsDocument, options);
}
export type GetWebLocationsQueryHookResult = ReturnType<typeof useGetWebLocationsQuery>;
export type GetWebLocationsLazyQueryHookResult = ReturnType<typeof useGetWebLocationsLazyQuery>;
export type GetWebLocationsSuspenseQueryHookResult = ReturnType<typeof useGetWebLocationsSuspenseQuery>;
export type GetWebLocationsQueryResult = Apollo.QueryResult<GetWebLocationsQuery, GetWebLocationsQueryVariables>;
export function refetchGetWebLocationsQuery(variables?: GetWebLocationsQueryVariables) {
  return { query: GetWebLocationsDocument, variables: variables }
}
export const GetMachineCaseOverviewDocument = gql`
    query GetMachineCaseOverview($caseERPReferenceNo: String!) {
  machineCaseOverview(caseERPReferenceNo: $caseERPReferenceNo) {
    machine
    dateStart
    daysActive
    usage
  }
}
    `;

/**
 * __useGetMachineCaseOverviewQuery__
 *
 * To run a query within a React component, call `useGetMachineCaseOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineCaseOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineCaseOverviewQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useGetMachineCaseOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetMachineCaseOverviewQuery, GetMachineCaseOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMachineCaseOverviewQuery, GetMachineCaseOverviewQueryVariables>(GetMachineCaseOverviewDocument, options);
}
export function useGetMachineCaseOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineCaseOverviewQuery, GetMachineCaseOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMachineCaseOverviewQuery, GetMachineCaseOverviewQueryVariables>(GetMachineCaseOverviewDocument, options);
}
export function useGetMachineCaseOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMachineCaseOverviewQuery, GetMachineCaseOverviewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMachineCaseOverviewQuery, GetMachineCaseOverviewQueryVariables>(GetMachineCaseOverviewDocument, options);
}
export type GetMachineCaseOverviewQueryHookResult = ReturnType<typeof useGetMachineCaseOverviewQuery>;
export type GetMachineCaseOverviewLazyQueryHookResult = ReturnType<typeof useGetMachineCaseOverviewLazyQuery>;
export type GetMachineCaseOverviewSuspenseQueryHookResult = ReturnType<typeof useGetMachineCaseOverviewSuspenseQuery>;
export type GetMachineCaseOverviewQueryResult = Apollo.QueryResult<GetMachineCaseOverviewQuery, GetMachineCaseOverviewQueryVariables>;
export function refetchGetMachineCaseOverviewQuery(variables: GetMachineCaseOverviewQueryVariables) {
  return { query: GetMachineCaseOverviewDocument, variables: variables }
}
export const GetMachineHistoryDocument = gql`
    query GetMachineHistory($machineERPReferenceNo: String!, $minDate: Date, $maxDate: Date) {
  machineHistory(
    machineERPReferenceNo: $machineERPReferenceNo
    minDate: $minDate
    maxDate: $maxDate
  ) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;

/**
 * __useGetMachineHistoryQuery__
 *
 * To run a query within a React component, call `useGetMachineHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineHistoryQuery({
 *   variables: {
 *      machineERPReferenceNo: // value for 'machineERPReferenceNo'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetMachineHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>(GetMachineHistoryDocument, options);
}
export function useGetMachineHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>(GetMachineHistoryDocument, options);
}
export function useGetMachineHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>(GetMachineHistoryDocument, options);
}
export type GetMachineHistoryQueryHookResult = ReturnType<typeof useGetMachineHistoryQuery>;
export type GetMachineHistoryLazyQueryHookResult = ReturnType<typeof useGetMachineHistoryLazyQuery>;
export type GetMachineHistorySuspenseQueryHookResult = ReturnType<typeof useGetMachineHistorySuspenseQuery>;
export type GetMachineHistoryQueryResult = Apollo.QueryResult<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>;
export function refetchGetMachineHistoryQuery(variables: GetMachineHistoryQueryVariables) {
  return { query: GetMachineHistoryDocument, variables: variables }
}
export const GetMachineTypesDocument = gql`
    query GetMachineTypes {
  machineTypes
}
    `;

/**
 * __useGetMachineTypesQuery__
 *
 * To run a query within a React component, call `useGetMachineTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMachineTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetMachineTypesQuery, GetMachineTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMachineTypesQuery, GetMachineTypesQueryVariables>(GetMachineTypesDocument, options);
}
export function useGetMachineTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineTypesQuery, GetMachineTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMachineTypesQuery, GetMachineTypesQueryVariables>(GetMachineTypesDocument, options);
}
export function useGetMachineTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMachineTypesQuery, GetMachineTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMachineTypesQuery, GetMachineTypesQueryVariables>(GetMachineTypesDocument, options);
}
export type GetMachineTypesQueryHookResult = ReturnType<typeof useGetMachineTypesQuery>;
export type GetMachineTypesLazyQueryHookResult = ReturnType<typeof useGetMachineTypesLazyQuery>;
export type GetMachineTypesSuspenseQueryHookResult = ReturnType<typeof useGetMachineTypesSuspenseQuery>;
export type GetMachineTypesQueryResult = Apollo.QueryResult<GetMachineTypesQuery, GetMachineTypesQueryVariables>;
export function refetchGetMachineTypesQuery(variables?: GetMachineTypesQueryVariables) {
  return { query: GetMachineTypesDocument, variables: variables }
}
export const GetMachinesPreviouslyOnCaseDocument = gql`
    query GetMachinesPreviouslyOnCase($erpNo: String!) {
  machinesPreviouslyOnCase(erpNo: $erpNo) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;

/**
 * __useGetMachinesPreviouslyOnCaseQuery__
 *
 * To run a query within a React component, call `useGetMachinesPreviouslyOnCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesPreviouslyOnCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesPreviouslyOnCaseQuery({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *   },
 * });
 */
export function useGetMachinesPreviouslyOnCaseQuery(baseOptions: Apollo.QueryHookOptions<GetMachinesPreviouslyOnCaseQuery, GetMachinesPreviouslyOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMachinesPreviouslyOnCaseQuery, GetMachinesPreviouslyOnCaseQueryVariables>(GetMachinesPreviouslyOnCaseDocument, options);
}
export function useGetMachinesPreviouslyOnCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachinesPreviouslyOnCaseQuery, GetMachinesPreviouslyOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMachinesPreviouslyOnCaseQuery, GetMachinesPreviouslyOnCaseQueryVariables>(GetMachinesPreviouslyOnCaseDocument, options);
}
export function useGetMachinesPreviouslyOnCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMachinesPreviouslyOnCaseQuery, GetMachinesPreviouslyOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMachinesPreviouslyOnCaseQuery, GetMachinesPreviouslyOnCaseQueryVariables>(GetMachinesPreviouslyOnCaseDocument, options);
}
export type GetMachinesPreviouslyOnCaseQueryHookResult = ReturnType<typeof useGetMachinesPreviouslyOnCaseQuery>;
export type GetMachinesPreviouslyOnCaseLazyQueryHookResult = ReturnType<typeof useGetMachinesPreviouslyOnCaseLazyQuery>;
export type GetMachinesPreviouslyOnCaseSuspenseQueryHookResult = ReturnType<typeof useGetMachinesPreviouslyOnCaseSuspenseQuery>;
export type GetMachinesPreviouslyOnCaseQueryResult = Apollo.QueryResult<GetMachinesPreviouslyOnCaseQuery, GetMachinesPreviouslyOnCaseQueryVariables>;
export function refetchGetMachinesPreviouslyOnCaseQuery(variables: GetMachinesPreviouslyOnCaseQueryVariables) {
  return { query: GetMachinesPreviouslyOnCaseDocument, variables: variables }
}
export const GetWebMachineDocument = gql`
    query GetWebMachine($machineERPReferenceNo: String!) {
  machine(machineERPReferenceNo: $machineERPReferenceNo) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;

/**
 * __useGetWebMachineQuery__
 *
 * To run a query within a React component, call `useGetWebMachineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebMachineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebMachineQuery({
 *   variables: {
 *      machineERPReferenceNo: // value for 'machineERPReferenceNo'
 *   },
 * });
 */
export function useGetWebMachineQuery(baseOptions: Apollo.QueryHookOptions<GetWebMachineQuery, GetWebMachineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebMachineQuery, GetWebMachineQueryVariables>(GetWebMachineDocument, options);
}
export function useGetWebMachineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebMachineQuery, GetWebMachineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebMachineQuery, GetWebMachineQueryVariables>(GetWebMachineDocument, options);
}
export function useGetWebMachineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebMachineQuery, GetWebMachineQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebMachineQuery, GetWebMachineQueryVariables>(GetWebMachineDocument, options);
}
export type GetWebMachineQueryHookResult = ReturnType<typeof useGetWebMachineQuery>;
export type GetWebMachineLazyQueryHookResult = ReturnType<typeof useGetWebMachineLazyQuery>;
export type GetWebMachineSuspenseQueryHookResult = ReturnType<typeof useGetWebMachineSuspenseQuery>;
export type GetWebMachineQueryResult = Apollo.QueryResult<GetWebMachineQuery, GetWebMachineQueryVariables>;
export function refetchGetWebMachineQuery(variables: GetWebMachineQueryVariables) {
  return { query: GetWebMachineDocument, variables: variables }
}
export const GetWebMachineGuideFilesDocument = gql`
    query GetWebMachineGuideFiles($filter: FileFilterInput) {
  machineGuideFiles(filter: $filter) {
    name
    thumbnail
    metadata {
      key
      value
    }
    url
  }
}
    `;

/**
 * __useGetWebMachineGuideFilesQuery__
 *
 * To run a query within a React component, call `useGetWebMachineGuideFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebMachineGuideFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebMachineGuideFilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetWebMachineGuideFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetWebMachineGuideFilesQuery, GetWebMachineGuideFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebMachineGuideFilesQuery, GetWebMachineGuideFilesQueryVariables>(GetWebMachineGuideFilesDocument, options);
}
export function useGetWebMachineGuideFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebMachineGuideFilesQuery, GetWebMachineGuideFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebMachineGuideFilesQuery, GetWebMachineGuideFilesQueryVariables>(GetWebMachineGuideFilesDocument, options);
}
export function useGetWebMachineGuideFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebMachineGuideFilesQuery, GetWebMachineGuideFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebMachineGuideFilesQuery, GetWebMachineGuideFilesQueryVariables>(GetWebMachineGuideFilesDocument, options);
}
export type GetWebMachineGuideFilesQueryHookResult = ReturnType<typeof useGetWebMachineGuideFilesQuery>;
export type GetWebMachineGuideFilesLazyQueryHookResult = ReturnType<typeof useGetWebMachineGuideFilesLazyQuery>;
export type GetWebMachineGuideFilesSuspenseQueryHookResult = ReturnType<typeof useGetWebMachineGuideFilesSuspenseQuery>;
export type GetWebMachineGuideFilesQueryResult = Apollo.QueryResult<GetWebMachineGuideFilesQuery, GetWebMachineGuideFilesQueryVariables>;
export function refetchGetWebMachineGuideFilesQuery(variables?: GetWebMachineGuideFilesQueryVariables) {
  return { query: GetWebMachineGuideFilesDocument, variables: variables }
}
export const GetWebMachineLocationsDocument = gql`
    query GetWebMachineLocations {
  machineLocations {
    ...BaseMachineLocationFragment
  }
}
    ${BaseMachineLocationFragmentFragmentDoc}`;

/**
 * __useGetWebMachineLocationsQuery__
 *
 * To run a query within a React component, call `useGetWebMachineLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebMachineLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebMachineLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebMachineLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebMachineLocationsQuery, GetWebMachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebMachineLocationsQuery, GetWebMachineLocationsQueryVariables>(GetWebMachineLocationsDocument, options);
}
export function useGetWebMachineLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebMachineLocationsQuery, GetWebMachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebMachineLocationsQuery, GetWebMachineLocationsQueryVariables>(GetWebMachineLocationsDocument, options);
}
export function useGetWebMachineLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebMachineLocationsQuery, GetWebMachineLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebMachineLocationsQuery, GetWebMachineLocationsQueryVariables>(GetWebMachineLocationsDocument, options);
}
export type GetWebMachineLocationsQueryHookResult = ReturnType<typeof useGetWebMachineLocationsQuery>;
export type GetWebMachineLocationsLazyQueryHookResult = ReturnType<typeof useGetWebMachineLocationsLazyQuery>;
export type GetWebMachineLocationsSuspenseQueryHookResult = ReturnType<typeof useGetWebMachineLocationsSuspenseQuery>;
export type GetWebMachineLocationsQueryResult = Apollo.QueryResult<GetWebMachineLocationsQuery, GetWebMachineLocationsQueryVariables>;
export function refetchGetWebMachineLocationsQuery(variables?: GetWebMachineLocationsQueryVariables) {
  return { query: GetWebMachineLocationsDocument, variables: variables }
}
export const GetWebMachinesDocument = gql`
    query GetWebMachines($status: MachineStatus, $cases: [String!], $locations: [String!], $types: [String!], $unavailable: Boolean, $hibernation: Boolean, $reservationByRessource: String, $discontinued: Boolean, $offset: Int, $limit: Int, $searchString: String) {
  machines(
    status: $status
    cases: $cases
    locations: $locations
    types: $types
    unavailable: $unavailable
    hibernation: $hibernation
    reservationByRessource: $reservationByRessource
    discontinued: $discontinued
    offset: $offset
    limit: $limit
    searchString: $searchString
  ) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;

/**
 * __useGetWebMachinesQuery__
 *
 * To run a query within a React component, call `useGetWebMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebMachinesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      cases: // value for 'cases'
 *      locations: // value for 'locations'
 *      types: // value for 'types'
 *      unavailable: // value for 'unavailable'
 *      hibernation: // value for 'hibernation'
 *      reservationByRessource: // value for 'reservationByRessource'
 *      discontinued: // value for 'discontinued'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGetWebMachinesQuery(baseOptions?: Apollo.QueryHookOptions<GetWebMachinesQuery, GetWebMachinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebMachinesQuery, GetWebMachinesQueryVariables>(GetWebMachinesDocument, options);
}
export function useGetWebMachinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebMachinesQuery, GetWebMachinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebMachinesQuery, GetWebMachinesQueryVariables>(GetWebMachinesDocument, options);
}
export function useGetWebMachinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebMachinesQuery, GetWebMachinesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebMachinesQuery, GetWebMachinesQueryVariables>(GetWebMachinesDocument, options);
}
export type GetWebMachinesQueryHookResult = ReturnType<typeof useGetWebMachinesQuery>;
export type GetWebMachinesLazyQueryHookResult = ReturnType<typeof useGetWebMachinesLazyQuery>;
export type GetWebMachinesSuspenseQueryHookResult = ReturnType<typeof useGetWebMachinesSuspenseQuery>;
export type GetWebMachinesQueryResult = Apollo.QueryResult<GetWebMachinesQuery, GetWebMachinesQueryVariables>;
export function refetchGetWebMachinesQuery(variables?: GetWebMachinesQueryVariables) {
  return { query: GetWebMachinesDocument, variables: variables }
}
export const GetWebMachinesOnCaseDocument = gql`
    query GetWebMachinesOnCase($erpNo: String!) {
  machinesOnCase(erpNo: $erpNo) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;

/**
 * __useGetWebMachinesOnCaseQuery__
 *
 * To run a query within a React component, call `useGetWebMachinesOnCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebMachinesOnCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebMachinesOnCaseQuery({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *   },
 * });
 */
export function useGetWebMachinesOnCaseQuery(baseOptions: Apollo.QueryHookOptions<GetWebMachinesOnCaseQuery, GetWebMachinesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebMachinesOnCaseQuery, GetWebMachinesOnCaseQueryVariables>(GetWebMachinesOnCaseDocument, options);
}
export function useGetWebMachinesOnCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebMachinesOnCaseQuery, GetWebMachinesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebMachinesOnCaseQuery, GetWebMachinesOnCaseQueryVariables>(GetWebMachinesOnCaseDocument, options);
}
export function useGetWebMachinesOnCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebMachinesOnCaseQuery, GetWebMachinesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebMachinesOnCaseQuery, GetWebMachinesOnCaseQueryVariables>(GetWebMachinesOnCaseDocument, options);
}
export type GetWebMachinesOnCaseQueryHookResult = ReturnType<typeof useGetWebMachinesOnCaseQuery>;
export type GetWebMachinesOnCaseLazyQueryHookResult = ReturnType<typeof useGetWebMachinesOnCaseLazyQuery>;
export type GetWebMachinesOnCaseSuspenseQueryHookResult = ReturnType<typeof useGetWebMachinesOnCaseSuspenseQuery>;
export type GetWebMachinesOnCaseQueryResult = Apollo.QueryResult<GetWebMachinesOnCaseQuery, GetWebMachinesOnCaseQueryVariables>;
export function refetchGetWebMachinesOnCaseQuery(variables: GetWebMachinesOnCaseQueryVariables) {
  return { query: GetWebMachinesOnCaseDocument, variables: variables }
}
export const MachineReserveDocument = gql`
    mutation MachineReserve($machineInput: MachineInput!) {
  machineReserve(machineInput: $machineInput) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;
export type MachineReserveMutationFn = Apollo.MutationFunction<MachineReserveMutation, MachineReserveMutationVariables>;

/**
 * __useMachineReserveMutation__
 *
 * To run a mutation, you first call `useMachineReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMachineReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [machineReserveMutation, { data, loading, error }] = useMachineReserveMutation({
 *   variables: {
 *      machineInput: // value for 'machineInput'
 *   },
 * });
 */
export function useMachineReserveMutation(baseOptions?: Apollo.MutationHookOptions<MachineReserveMutation, MachineReserveMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MachineReserveMutation, MachineReserveMutationVariables>(MachineReserveDocument, options);
}
export type MachineReserveMutationHookResult = ReturnType<typeof useMachineReserveMutation>;
export type MachineReserveMutationResult = Apollo.MutationResult<MachineReserveMutation>;
export type MachineReserveMutationOptions = Apollo.BaseMutationOptions<MachineReserveMutation, MachineReserveMutationVariables>;
export const MoveWebMachinesDocument = gql`
    mutation MoveWebMachines($erpReferenceNumbers: [String!]!, $erpCaseReference: String!, $erpLocationReference: String!) {
  moveMachines(
    erpReferenceNumbers: $erpReferenceNumbers
    erpCaseReference: $erpCaseReference
    erpLocationReference: $erpLocationReference
  ) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;
export type MoveWebMachinesMutationFn = Apollo.MutationFunction<MoveWebMachinesMutation, MoveWebMachinesMutationVariables>;

/**
 * __useMoveWebMachinesMutation__
 *
 * To run a mutation, you first call `useMoveWebMachinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveWebMachinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveWebMachinesMutation, { data, loading, error }] = useMoveWebMachinesMutation({
 *   variables: {
 *      erpReferenceNumbers: // value for 'erpReferenceNumbers'
 *      erpCaseReference: // value for 'erpCaseReference'
 *      erpLocationReference: // value for 'erpLocationReference'
 *   },
 * });
 */
export function useMoveWebMachinesMutation(baseOptions?: Apollo.MutationHookOptions<MoveWebMachinesMutation, MoveWebMachinesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MoveWebMachinesMutation, MoveWebMachinesMutationVariables>(MoveWebMachinesDocument, options);
}
export type MoveWebMachinesMutationHookResult = ReturnType<typeof useMoveWebMachinesMutation>;
export type MoveWebMachinesMutationResult = Apollo.MutationResult<MoveWebMachinesMutation>;
export type MoveWebMachinesMutationOptions = Apollo.BaseMutationOptions<MoveWebMachinesMutation, MoveWebMachinesMutationVariables>;
export const MoveWebMachineDocument = gql`
    mutation MoveWebMachine($machineInput: MachineInput!, $caseERPreferenceNo: String!) {
  moveMachine(
    machineInput: $machineInput
    caseERPreferenceNo: $caseERPreferenceNo
  ) {
    ...BaseMachineFragment
  }
}
    ${BaseMachineFragmentFragmentDoc}`;
export type MoveWebMachineMutationFn = Apollo.MutationFunction<MoveWebMachineMutation, MoveWebMachineMutationVariables>;

/**
 * __useMoveWebMachineMutation__
 *
 * To run a mutation, you first call `useMoveWebMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveWebMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveWebMachineMutation, { data, loading, error }] = useMoveWebMachineMutation({
 *   variables: {
 *      machineInput: // value for 'machineInput'
 *      caseERPreferenceNo: // value for 'caseERPreferenceNo'
 *   },
 * });
 */
export function useMoveWebMachineMutation(baseOptions?: Apollo.MutationHookOptions<MoveWebMachineMutation, MoveWebMachineMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MoveWebMachineMutation, MoveWebMachineMutationVariables>(MoveWebMachineDocument, options);
}
export type MoveWebMachineMutationHookResult = ReturnType<typeof useMoveWebMachineMutation>;
export type MoveWebMachineMutationResult = Apollo.MutationResult<MoveWebMachineMutation>;
export type MoveWebMachineMutationOptions = Apollo.BaseMutationOptions<MoveWebMachineMutation, MoveWebMachineMutationVariables>;
export const GetWorkEnvRegulationsManagerListDocument = gql`
    query GetWorkEnvRegulationsManagerList {
  workEnvRegulationsManagerList {
    user {
      id
      name
      jobFunction
      employeeId
    }
    hours48Over4Months
    hoursCurrentDay
    elevenHourRest
    eightHourRest
    daysSinceRestDay
    lastWorkTime
    availableAgainTime
    currentTask
    startedTask
  }
}
    `;

/**
 * __useGetWorkEnvRegulationsManagerListQuery__
 *
 * To run a query within a React component, call `useGetWorkEnvRegulationsManagerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkEnvRegulationsManagerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkEnvRegulationsManagerListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkEnvRegulationsManagerListQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkEnvRegulationsManagerListQuery, GetWorkEnvRegulationsManagerListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWorkEnvRegulationsManagerListQuery, GetWorkEnvRegulationsManagerListQueryVariables>(GetWorkEnvRegulationsManagerListDocument, options);
}
export function useGetWorkEnvRegulationsManagerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkEnvRegulationsManagerListQuery, GetWorkEnvRegulationsManagerListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWorkEnvRegulationsManagerListQuery, GetWorkEnvRegulationsManagerListQueryVariables>(GetWorkEnvRegulationsManagerListDocument, options);
}
export function useGetWorkEnvRegulationsManagerListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkEnvRegulationsManagerListQuery, GetWorkEnvRegulationsManagerListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWorkEnvRegulationsManagerListQuery, GetWorkEnvRegulationsManagerListQueryVariables>(GetWorkEnvRegulationsManagerListDocument, options);
}
export type GetWorkEnvRegulationsManagerListQueryHookResult = ReturnType<typeof useGetWorkEnvRegulationsManagerListQuery>;
export type GetWorkEnvRegulationsManagerListLazyQueryHookResult = ReturnType<typeof useGetWorkEnvRegulationsManagerListLazyQuery>;
export type GetWorkEnvRegulationsManagerListSuspenseQueryHookResult = ReturnType<typeof useGetWorkEnvRegulationsManagerListSuspenseQuery>;
export type GetWorkEnvRegulationsManagerListQueryResult = Apollo.QueryResult<GetWorkEnvRegulationsManagerListQuery, GetWorkEnvRegulationsManagerListQueryVariables>;
export function refetchGetWorkEnvRegulationsManagerListQuery(variables?: GetWorkEnvRegulationsManagerListQueryVariables) {
  return { query: GetWorkEnvRegulationsManagerListDocument, variables: variables }
}
export const ChangeLabelAndStatusMovableDocument = gql`
    mutation ChangeLabelAndStatusMovable($oldMovableId: String!, $newMovableId: String!, $newStatus: String!) {
  changeLabelAndStatusMovable(
    oldMovableId: $oldMovableId
    newMovableId: $newMovableId
    newStatus: $newStatus
  ) {
    ...BaseMovableFragment
    case {
      id
      erpNo
      debitor {
        debitorId
        company
      }
      damage {
        contact {
          address {
            ...AddressFragment
          }
        }
      }
    }
  }
}
    ${BaseMovableFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export type ChangeLabelAndStatusMovableMutationFn = Apollo.MutationFunction<ChangeLabelAndStatusMovableMutation, ChangeLabelAndStatusMovableMutationVariables>;

/**
 * __useChangeLabelAndStatusMovableMutation__
 *
 * To run a mutation, you first call `useChangeLabelAndStatusMovableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLabelAndStatusMovableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLabelAndStatusMovableMutation, { data, loading, error }] = useChangeLabelAndStatusMovableMutation({
 *   variables: {
 *      oldMovableId: // value for 'oldMovableId'
 *      newMovableId: // value for 'newMovableId'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useChangeLabelAndStatusMovableMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLabelAndStatusMovableMutation, ChangeLabelAndStatusMovableMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ChangeLabelAndStatusMovableMutation, ChangeLabelAndStatusMovableMutationVariables>(ChangeLabelAndStatusMovableDocument, options);
}
export type ChangeLabelAndStatusMovableMutationHookResult = ReturnType<typeof useChangeLabelAndStatusMovableMutation>;
export type ChangeLabelAndStatusMovableMutationResult = Apollo.MutationResult<ChangeLabelAndStatusMovableMutation>;
export type ChangeLabelAndStatusMovableMutationOptions = Apollo.BaseMutationOptions<ChangeLabelAndStatusMovableMutation, ChangeLabelAndStatusMovableMutationVariables>;
export const CheckMovableDocument = gql`
    mutation CheckMovable($id: String!) {
  checkMovable(id: $id) {
    id
    completed
    status
  }
}
    `;
export type CheckMovableMutationFn = Apollo.MutationFunction<CheckMovableMutation, CheckMovableMutationVariables>;

/**
 * __useCheckMovableMutation__
 *
 * To run a mutation, you first call `useCheckMovableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckMovableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkMovableMutation, { data, loading, error }] = useCheckMovableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckMovableMutation(baseOptions?: Apollo.MutationHookOptions<CheckMovableMutation, CheckMovableMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CheckMovableMutation, CheckMovableMutationVariables>(CheckMovableDocument, options);
}
export type CheckMovableMutationHookResult = ReturnType<typeof useCheckMovableMutation>;
export type CheckMovableMutationResult = Apollo.MutationResult<CheckMovableMutation>;
export type CheckMovableMutationOptions = Apollo.BaseMutationOptions<CheckMovableMutation, CheckMovableMutationVariables>;
export const CheckOpenMovableDocument = gql`
    query CheckOpenMovable($caseERPReferenceNo: String!) {
  checkOpenMovable(caseERPReferenceNo: $caseERPReferenceNo)
}
    `;

/**
 * __useCheckOpenMovableQuery__
 *
 * To run a query within a React component, call `useCheckOpenMovableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOpenMovableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOpenMovableQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useCheckOpenMovableQuery(baseOptions: Apollo.QueryHookOptions<CheckOpenMovableQuery, CheckOpenMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CheckOpenMovableQuery, CheckOpenMovableQueryVariables>(CheckOpenMovableDocument, options);
}
export function useCheckOpenMovableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckOpenMovableQuery, CheckOpenMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CheckOpenMovableQuery, CheckOpenMovableQueryVariables>(CheckOpenMovableDocument, options);
}
export function useCheckOpenMovableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckOpenMovableQuery, CheckOpenMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CheckOpenMovableQuery, CheckOpenMovableQueryVariables>(CheckOpenMovableDocument, options);
}
export type CheckOpenMovableQueryHookResult = ReturnType<typeof useCheckOpenMovableQuery>;
export type CheckOpenMovableLazyQueryHookResult = ReturnType<typeof useCheckOpenMovableLazyQuery>;
export type CheckOpenMovableSuspenseQueryHookResult = ReturnType<typeof useCheckOpenMovableSuspenseQuery>;
export type CheckOpenMovableQueryResult = Apollo.QueryResult<CheckOpenMovableQuery, CheckOpenMovableQueryVariables>;
export function refetchCheckOpenMovableQuery(variables: CheckOpenMovableQueryVariables) {
  return { query: CheckOpenMovableDocument, variables: variables }
}
export const CheckOpenMovablesOnCaseDocument = gql`
    query CheckOpenMovablesOnCase($caseERPReferenceNo: String!) {
  checkOpenMovable(caseERPReferenceNo: $caseERPReferenceNo)
}
    `;

/**
 * __useCheckOpenMovablesOnCaseQuery__
 *
 * To run a query within a React component, call `useCheckOpenMovablesOnCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOpenMovablesOnCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOpenMovablesOnCaseQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useCheckOpenMovablesOnCaseQuery(baseOptions: Apollo.QueryHookOptions<CheckOpenMovablesOnCaseQuery, CheckOpenMovablesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CheckOpenMovablesOnCaseQuery, CheckOpenMovablesOnCaseQueryVariables>(CheckOpenMovablesOnCaseDocument, options);
}
export function useCheckOpenMovablesOnCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckOpenMovablesOnCaseQuery, CheckOpenMovablesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CheckOpenMovablesOnCaseQuery, CheckOpenMovablesOnCaseQueryVariables>(CheckOpenMovablesOnCaseDocument, options);
}
export function useCheckOpenMovablesOnCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckOpenMovablesOnCaseQuery, CheckOpenMovablesOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CheckOpenMovablesOnCaseQuery, CheckOpenMovablesOnCaseQueryVariables>(CheckOpenMovablesOnCaseDocument, options);
}
export type CheckOpenMovablesOnCaseQueryHookResult = ReturnType<typeof useCheckOpenMovablesOnCaseQuery>;
export type CheckOpenMovablesOnCaseLazyQueryHookResult = ReturnType<typeof useCheckOpenMovablesOnCaseLazyQuery>;
export type CheckOpenMovablesOnCaseSuspenseQueryHookResult = ReturnType<typeof useCheckOpenMovablesOnCaseSuspenseQuery>;
export type CheckOpenMovablesOnCaseQueryResult = Apollo.QueryResult<CheckOpenMovablesOnCaseQuery, CheckOpenMovablesOnCaseQueryVariables>;
export function refetchCheckOpenMovablesOnCaseQuery(variables: CheckOpenMovablesOnCaseQueryVariables) {
  return { query: CheckOpenMovablesOnCaseDocument, variables: variables }
}
export const CreateMovableDocument = gql`
    mutation CreateMovable($movable: MovableInput!) {
  createMovable(movable: $movable) {
    ...BaseMovableFragment
    case {
      id
      erpNo
      debitor {
        debitorId
        company
      }
      damage {
        contact {
          address {
            ...AddressFragment
          }
        }
      }
    }
  }
}
    ${BaseMovableFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export type CreateMovableMutationFn = Apollo.MutationFunction<CreateMovableMutation, CreateMovableMutationVariables>;

/**
 * __useCreateMovableMutation__
 *
 * To run a mutation, you first call `useCreateMovableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMovableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMovableMutation, { data, loading, error }] = useCreateMovableMutation({
 *   variables: {
 *      movable: // value for 'movable'
 *   },
 * });
 */
export function useCreateMovableMutation(baseOptions?: Apollo.MutationHookOptions<CreateMovableMutation, CreateMovableMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMovableMutation, CreateMovableMutationVariables>(CreateMovableDocument, options);
}
export type CreateMovableMutationHookResult = ReturnType<typeof useCreateMovableMutation>;
export type CreateMovableMutationResult = Apollo.MutationResult<CreateMovableMutation>;
export type CreateMovableMutationOptions = Apollo.BaseMutationOptions<CreateMovableMutation, CreateMovableMutationVariables>;
export const ExportMovableToExcelDocument = gql`
    query ExportMovableToExcel($filters: MovableSearchFiltersInputType!) {
  exportMovableToExcel(filters: $filters)
}
    `;

/**
 * __useExportMovableToExcelQuery__
 *
 * To run a query within a React component, call `useExportMovableToExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMovableToExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportMovableToExcelQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportMovableToExcelQuery(baseOptions: Apollo.QueryHookOptions<ExportMovableToExcelQuery, ExportMovableToExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ExportMovableToExcelQuery, ExportMovableToExcelQueryVariables>(ExportMovableToExcelDocument, options);
}
export function useExportMovableToExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportMovableToExcelQuery, ExportMovableToExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ExportMovableToExcelQuery, ExportMovableToExcelQueryVariables>(ExportMovableToExcelDocument, options);
}
export function useExportMovableToExcelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportMovableToExcelQuery, ExportMovableToExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ExportMovableToExcelQuery, ExportMovableToExcelQueryVariables>(ExportMovableToExcelDocument, options);
}
export type ExportMovableToExcelQueryHookResult = ReturnType<typeof useExportMovableToExcelQuery>;
export type ExportMovableToExcelLazyQueryHookResult = ReturnType<typeof useExportMovableToExcelLazyQuery>;
export type ExportMovableToExcelSuspenseQueryHookResult = ReturnType<typeof useExportMovableToExcelSuspenseQuery>;
export type ExportMovableToExcelQueryResult = Apollo.QueryResult<ExportMovableToExcelQuery, ExportMovableToExcelQueryVariables>;
export function refetchExportMovableToExcelQuery(variables: ExportMovableToExcelQueryVariables) {
  return { query: ExportMovableToExcelDocument, variables: variables }
}
export const GenerateMovableIdListDocument = gql`
    mutation GenerateMovableIdList($count: Int!) {
  generateMovableIdList(count: $count)
}
    `;
export type GenerateMovableIdListMutationFn = Apollo.MutationFunction<GenerateMovableIdListMutation, GenerateMovableIdListMutationVariables>;

/**
 * __useGenerateMovableIdListMutation__
 *
 * To run a mutation, you first call `useGenerateMovableIdListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMovableIdListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMovableIdListMutation, { data, loading, error }] = useGenerateMovableIdListMutation({
 *   variables: {
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGenerateMovableIdListMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMovableIdListMutation, GenerateMovableIdListMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GenerateMovableIdListMutation, GenerateMovableIdListMutationVariables>(GenerateMovableIdListDocument, options);
}
export type GenerateMovableIdListMutationHookResult = ReturnType<typeof useGenerateMovableIdListMutation>;
export type GenerateMovableIdListMutationResult = Apollo.MutationResult<GenerateMovableIdListMutation>;
export type GenerateMovableIdListMutationOptions = Apollo.BaseMutationOptions<GenerateMovableIdListMutation, GenerateMovableIdListMutationVariables>;
export const GetMovableDocument = gql`
    query GetMovable($id: String!) {
  movable(id: $id) {
    ...BaseMovableFragment
    case {
      id
      erpNo
      debitor {
        debitorId
        company
      }
      damage {
        contact {
          address {
            ...AddressFragment
          }
        }
      }
    }
  }
}
    ${BaseMovableFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useGetMovableQuery__
 *
 * To run a query within a React component, call `useGetMovableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovableQuery(baseOptions: Apollo.QueryHookOptions<GetMovableQuery, GetMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMovableQuery, GetMovableQueryVariables>(GetMovableDocument, options);
}
export function useGetMovableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovableQuery, GetMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMovableQuery, GetMovableQueryVariables>(GetMovableDocument, options);
}
export function useGetMovableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovableQuery, GetMovableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMovableQuery, GetMovableQueryVariables>(GetMovableDocument, options);
}
export type GetMovableQueryHookResult = ReturnType<typeof useGetMovableQuery>;
export type GetMovableLazyQueryHookResult = ReturnType<typeof useGetMovableLazyQuery>;
export type GetMovableSuspenseQueryHookResult = ReturnType<typeof useGetMovableSuspenseQuery>;
export type GetMovableQueryResult = Apollo.QueryResult<GetMovableQuery, GetMovableQueryVariables>;
export function refetchGetMovableQuery(variables: GetMovableQueryVariables) {
  return { query: GetMovableDocument, variables: variables }
}
export const GetMovableInvoiceableStatusOptionsDocument = gql`
    query GetMovableInvoiceableStatusOptions($erpNo: String!) {
  movableInvoiceableStatusOptions(erpNo: $erpNo) {
    key
    value
  }
}
    `;

/**
 * __useGetMovableInvoiceableStatusOptionsQuery__
 *
 * To run a query within a React component, call `useGetMovableInvoiceableStatusOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovableInvoiceableStatusOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovableInvoiceableStatusOptionsQuery({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *   },
 * });
 */
export function useGetMovableInvoiceableStatusOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetMovableInvoiceableStatusOptionsQuery, GetMovableInvoiceableStatusOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMovableInvoiceableStatusOptionsQuery, GetMovableInvoiceableStatusOptionsQueryVariables>(GetMovableInvoiceableStatusOptionsDocument, options);
}
export function useGetMovableInvoiceableStatusOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovableInvoiceableStatusOptionsQuery, GetMovableInvoiceableStatusOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMovableInvoiceableStatusOptionsQuery, GetMovableInvoiceableStatusOptionsQueryVariables>(GetMovableInvoiceableStatusOptionsDocument, options);
}
export function useGetMovableInvoiceableStatusOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovableInvoiceableStatusOptionsQuery, GetMovableInvoiceableStatusOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMovableInvoiceableStatusOptionsQuery, GetMovableInvoiceableStatusOptionsQueryVariables>(GetMovableInvoiceableStatusOptionsDocument, options);
}
export type GetMovableInvoiceableStatusOptionsQueryHookResult = ReturnType<typeof useGetMovableInvoiceableStatusOptionsQuery>;
export type GetMovableInvoiceableStatusOptionsLazyQueryHookResult = ReturnType<typeof useGetMovableInvoiceableStatusOptionsLazyQuery>;
export type GetMovableInvoiceableStatusOptionsSuspenseQueryHookResult = ReturnType<typeof useGetMovableInvoiceableStatusOptionsSuspenseQuery>;
export type GetMovableInvoiceableStatusOptionsQueryResult = Apollo.QueryResult<GetMovableInvoiceableStatusOptionsQuery, GetMovableInvoiceableStatusOptionsQueryVariables>;
export function refetchGetMovableInvoiceableStatusOptionsQuery(variables: GetMovableInvoiceableStatusOptionsQueryVariables) {
  return { query: GetMovableInvoiceableStatusOptionsDocument, variables: variables }
}
export const GetMovableLocationsDocument = gql`
    query GetMovableLocations($location: String) {
  movablesLocations(location: $location) {
    ...BaseMovablesLocationFragment
    accVolume
  }
}
    ${BaseMovablesLocationFragmentFragmentDoc}`;

/**
 * __useGetMovableLocationsQuery__
 *
 * To run a query within a React component, call `useGetMovableLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovableLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovableLocationsQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetMovableLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMovableLocationsQuery, GetMovableLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMovableLocationsQuery, GetMovableLocationsQueryVariables>(GetMovableLocationsDocument, options);
}
export function useGetMovableLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovableLocationsQuery, GetMovableLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMovableLocationsQuery, GetMovableLocationsQueryVariables>(GetMovableLocationsDocument, options);
}
export function useGetMovableLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovableLocationsQuery, GetMovableLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMovableLocationsQuery, GetMovableLocationsQueryVariables>(GetMovableLocationsDocument, options);
}
export type GetMovableLocationsQueryHookResult = ReturnType<typeof useGetMovableLocationsQuery>;
export type GetMovableLocationsLazyQueryHookResult = ReturnType<typeof useGetMovableLocationsLazyQuery>;
export type GetMovableLocationsSuspenseQueryHookResult = ReturnType<typeof useGetMovableLocationsSuspenseQuery>;
export type GetMovableLocationsQueryResult = Apollo.QueryResult<GetMovableLocationsQuery, GetMovableLocationsQueryVariables>;
export function refetchGetMovableLocationsQuery(variables?: GetMovableLocationsQueryVariables) {
  return { query: GetMovableLocationsDocument, variables: variables }
}
export const GetMovableStatusOptionsDocument = gql`
    query GetMovableStatusOptions {
  movableStatusOptions
}
    `;

/**
 * __useGetMovableStatusOptionsQuery__
 *
 * To run a query within a React component, call `useGetMovableStatusOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovableStatusOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovableStatusOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMovableStatusOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMovableStatusOptionsQuery, GetMovableStatusOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMovableStatusOptionsQuery, GetMovableStatusOptionsQueryVariables>(GetMovableStatusOptionsDocument, options);
}
export function useGetMovableStatusOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovableStatusOptionsQuery, GetMovableStatusOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMovableStatusOptionsQuery, GetMovableStatusOptionsQueryVariables>(GetMovableStatusOptionsDocument, options);
}
export function useGetMovableStatusOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovableStatusOptionsQuery, GetMovableStatusOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMovableStatusOptionsQuery, GetMovableStatusOptionsQueryVariables>(GetMovableStatusOptionsDocument, options);
}
export type GetMovableStatusOptionsQueryHookResult = ReturnType<typeof useGetMovableStatusOptionsQuery>;
export type GetMovableStatusOptionsLazyQueryHookResult = ReturnType<typeof useGetMovableStatusOptionsLazyQuery>;
export type GetMovableStatusOptionsSuspenseQueryHookResult = ReturnType<typeof useGetMovableStatusOptionsSuspenseQuery>;
export type GetMovableStatusOptionsQueryResult = Apollo.QueryResult<GetMovableStatusOptionsQuery, GetMovableStatusOptionsQueryVariables>;
export function refetchGetMovableStatusOptionsQuery(variables?: GetMovableStatusOptionsQueryVariables) {
  return { query: GetMovableStatusOptionsDocument, variables: variables }
}
export const GetMovablesDocument = gql`
    query GetMovables($case: String, $placement: String, $status: String, $location: String, $debitors: [String!], $onlyCompleted: Boolean, $fromDate: Date, $toDate: Date, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  movables(
    case: $case
    placement: $placement
    status: $status
    location: $location
    debitors: $debitors
    onlyCompleted: $onlyCompleted
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    ...BaseMovableFragment
    case {
      id
      erpNo
      debitor {
        debitorId
        company
      }
      damage {
        contact {
          address {
            ...AddressFragment
          }
        }
      }
    }
  }
}
    ${BaseMovableFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useGetMovablesQuery__
 *
 * To run a query within a React component, call `useGetMovablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovablesQuery({
 *   variables: {
 *      case: // value for 'case'
 *      placement: // value for 'placement'
 *      status: // value for 'status'
 *      location: // value for 'location'
 *      debitors: // value for 'debitors'
 *      onlyCompleted: // value for 'onlyCompleted'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetMovablesQuery(baseOptions?: Apollo.QueryHookOptions<GetMovablesQuery, GetMovablesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMovablesQuery, GetMovablesQueryVariables>(GetMovablesDocument, options);
}
export function useGetMovablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovablesQuery, GetMovablesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMovablesQuery, GetMovablesQueryVariables>(GetMovablesDocument, options);
}
export function useGetMovablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovablesQuery, GetMovablesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMovablesQuery, GetMovablesQueryVariables>(GetMovablesDocument, options);
}
export type GetMovablesQueryHookResult = ReturnType<typeof useGetMovablesQuery>;
export type GetMovablesLazyQueryHookResult = ReturnType<typeof useGetMovablesLazyQuery>;
export type GetMovablesSuspenseQueryHookResult = ReturnType<typeof useGetMovablesSuspenseQuery>;
export type GetMovablesQueryResult = Apollo.QueryResult<GetMovablesQuery, GetMovablesQueryVariables>;
export function refetchGetMovablesQuery(variables?: GetMovablesQueryVariables) {
  return { query: GetMovablesDocument, variables: variables }
}
export const GetMovablesOverviewExcelDocument = gql`
    query GetMovablesOverviewExcel($caseId: String!, $includeCompleted: Boolean) {
  movableExcelOverview(caseId: $caseId, includeCompleted: $includeCompleted)
}
    `;

/**
 * __useGetMovablesOverviewExcelQuery__
 *
 * To run a query within a React component, call `useGetMovablesOverviewExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovablesOverviewExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovablesOverviewExcelQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      includeCompleted: // value for 'includeCompleted'
 *   },
 * });
 */
export function useGetMovablesOverviewExcelQuery(baseOptions: Apollo.QueryHookOptions<GetMovablesOverviewExcelQuery, GetMovablesOverviewExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMovablesOverviewExcelQuery, GetMovablesOverviewExcelQueryVariables>(GetMovablesOverviewExcelDocument, options);
}
export function useGetMovablesOverviewExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovablesOverviewExcelQuery, GetMovablesOverviewExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMovablesOverviewExcelQuery, GetMovablesOverviewExcelQueryVariables>(GetMovablesOverviewExcelDocument, options);
}
export function useGetMovablesOverviewExcelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovablesOverviewExcelQuery, GetMovablesOverviewExcelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMovablesOverviewExcelQuery, GetMovablesOverviewExcelQueryVariables>(GetMovablesOverviewExcelDocument, options);
}
export type GetMovablesOverviewExcelQueryHookResult = ReturnType<typeof useGetMovablesOverviewExcelQuery>;
export type GetMovablesOverviewExcelLazyQueryHookResult = ReturnType<typeof useGetMovablesOverviewExcelLazyQuery>;
export type GetMovablesOverviewExcelSuspenseQueryHookResult = ReturnType<typeof useGetMovablesOverviewExcelSuspenseQuery>;
export type GetMovablesOverviewExcelQueryResult = Apollo.QueryResult<GetMovablesOverviewExcelQuery, GetMovablesOverviewExcelQueryVariables>;
export function refetchGetMovablesOverviewExcelQuery(variables: GetMovablesOverviewExcelQueryVariables) {
  return { query: GetMovablesOverviewExcelDocument, variables: variables }
}
export const UpdateMovableDocument = gql`
    mutation UpdateMovable($id: String!, $description: String, $completed: Boolean, $status: String, $placement: String, $volume: Decimal) {
  updateMovable(
    id: $id
    description: $description
    completed: $completed
    status: $status
    placement: $placement
    volume: $volume
  ) {
    ...BaseMovableFragment
  }
}
    ${BaseMovableFragmentFragmentDoc}`;
export type UpdateMovableMutationFn = Apollo.MutationFunction<UpdateMovableMutation, UpdateMovableMutationVariables>;

/**
 * __useUpdateMovableMutation__
 *
 * To run a mutation, you first call `useUpdateMovableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovableMutation, { data, loading, error }] = useUpdateMovableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      completed: // value for 'completed'
 *      status: // value for 'status'
 *      placement: // value for 'placement'
 *      volume: // value for 'volume'
 *   },
 * });
 */
export function useUpdateMovableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMovableMutation, UpdateMovableMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateMovableMutation, UpdateMovableMutationVariables>(UpdateMovableDocument, options);
}
export type UpdateMovableMutationHookResult = ReturnType<typeof useUpdateMovableMutation>;
export type UpdateMovableMutationResult = Apollo.MutationResult<UpdateMovableMutation>;
export type UpdateMovableMutationOptions = Apollo.BaseMutationOptions<UpdateMovableMutation, UpdateMovableMutationVariables>;
export const ItemsDocument = gql`
    query Items {
  items {
    ...BaseOfferItemFragment
  }
}
    ${BaseOfferItemFragmentFragmentDoc}`;

/**
 * __useItemsQuery__
 *
 * To run a query within a React component, call `useItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemsQuery(baseOptions?: Apollo.QueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
}
export function useItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
}
export function useItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
}
export type ItemsQueryHookResult = ReturnType<typeof useItemsQuery>;
export type ItemsLazyQueryHookResult = ReturnType<typeof useItemsLazyQuery>;
export type ItemsSuspenseQueryHookResult = ReturnType<typeof useItemsSuspenseQuery>;
export type ItemsQueryResult = Apollo.QueryResult<ItemsQuery, ItemsQueryVariables>;
export function refetchItemsQuery(variables?: ItemsQueryVariables) {
  return { query: ItemsDocument, variables: variables }
}
export const ResourcesDocument = gql`
    query Resources($ressourceType: String!) {
  resources(ressourceType: $ressourceType) {
    ...BaseOfferResourceFragment
  }
}
    ${BaseOfferResourceFragmentFragmentDoc}`;

/**
 * __useResourcesQuery__
 *
 * To run a query within a React component, call `useResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesQuery({
 *   variables: {
 *      ressourceType: // value for 'ressourceType'
 *   },
 * });
 */
export function useResourcesQuery(baseOptions: Apollo.QueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
}
export function useResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
}
export function useResourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
}
export type ResourcesQueryHookResult = ReturnType<typeof useResourcesQuery>;
export type ResourcesLazyQueryHookResult = ReturnType<typeof useResourcesLazyQuery>;
export type ResourcesSuspenseQueryHookResult = ReturnType<typeof useResourcesSuspenseQuery>;
export type ResourcesQueryResult = Apollo.QueryResult<ResourcesQuery, ResourcesQueryVariables>;
export function refetchResourcesQuery(variables: ResourcesQueryVariables) {
  return { query: ResourcesDocument, variables: variables }
}
export const GetSamplePriceForOfferDocument = gql`
    query GetSamplePriceForOffer($offer: OfferInput!) {
  samplePriceForOffer(offer: $offer) {
    totalCost
    lineAmount
  }
}
    `;

/**
 * __useGetSamplePriceForOfferQuery__
 *
 * To run a query within a React component, call `useGetSamplePriceForOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSamplePriceForOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSamplePriceForOfferQuery({
 *   variables: {
 *      offer: // value for 'offer'
 *   },
 * });
 */
export function useGetSamplePriceForOfferQuery(baseOptions: Apollo.QueryHookOptions<GetSamplePriceForOfferQuery, GetSamplePriceForOfferQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSamplePriceForOfferQuery, GetSamplePriceForOfferQueryVariables>(GetSamplePriceForOfferDocument, options);
}
export function useGetSamplePriceForOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSamplePriceForOfferQuery, GetSamplePriceForOfferQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSamplePriceForOfferQuery, GetSamplePriceForOfferQueryVariables>(GetSamplePriceForOfferDocument, options);
}
export function useGetSamplePriceForOfferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSamplePriceForOfferQuery, GetSamplePriceForOfferQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSamplePriceForOfferQuery, GetSamplePriceForOfferQueryVariables>(GetSamplePriceForOfferDocument, options);
}
export type GetSamplePriceForOfferQueryHookResult = ReturnType<typeof useGetSamplePriceForOfferQuery>;
export type GetSamplePriceForOfferLazyQueryHookResult = ReturnType<typeof useGetSamplePriceForOfferLazyQuery>;
export type GetSamplePriceForOfferSuspenseQueryHookResult = ReturnType<typeof useGetSamplePriceForOfferSuspenseQuery>;
export type GetSamplePriceForOfferQueryResult = Apollo.QueryResult<GetSamplePriceForOfferQuery, GetSamplePriceForOfferQueryVariables>;
export function refetchGetSamplePriceForOfferQuery(variables: GetSamplePriceForOfferQueryVariables) {
  return { query: GetSamplePriceForOfferDocument, variables: variables }
}
export const WorkTypesDocument = gql`
    query WorkTypes {
  workTypes {
    systemId
    description
    code
    uOM
  }
}
    `;

/**
 * __useWorkTypesQuery__
 *
 * To run a query within a React component, call `useWorkTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkTypesQuery(baseOptions?: Apollo.QueryHookOptions<WorkTypesQuery, WorkTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WorkTypesQuery, WorkTypesQueryVariables>(WorkTypesDocument, options);
}
export function useWorkTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTypesQuery, WorkTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<WorkTypesQuery, WorkTypesQueryVariables>(WorkTypesDocument, options);
}
export function useWorkTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkTypesQuery, WorkTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<WorkTypesQuery, WorkTypesQueryVariables>(WorkTypesDocument, options);
}
export type WorkTypesQueryHookResult = ReturnType<typeof useWorkTypesQuery>;
export type WorkTypesLazyQueryHookResult = ReturnType<typeof useWorkTypesLazyQuery>;
export type WorkTypesSuspenseQueryHookResult = ReturnType<typeof useWorkTypesSuspenseQuery>;
export type WorkTypesQueryResult = Apollo.QueryResult<WorkTypesQuery, WorkTypesQueryVariables>;
export function refetchWorkTypesQuery(variables?: WorkTypesQueryVariables) {
  return { query: WorkTypesDocument, variables: variables }
}
export const ChangeCarOnCalendarEventDocument = gql`
    mutation ChangeCarOnCalendarEvent($carId: String!, $event: CalendarEventInput!, $originalEventId: String!, $originalCarId: String!) {
  changeCarOnCalendarEvent(
    carId: $carId
    event: $event
    originalEventId: $originalEventId
    originalCarId: $originalCarId
  ) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentFragmentDoc}`;
export type ChangeCarOnCalendarEventMutationFn = Apollo.MutationFunction<ChangeCarOnCalendarEventMutation, ChangeCarOnCalendarEventMutationVariables>;

/**
 * __useChangeCarOnCalendarEventMutation__
 *
 * To run a mutation, you first call `useChangeCarOnCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCarOnCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCarOnCalendarEventMutation, { data, loading, error }] = useChangeCarOnCalendarEventMutation({
 *   variables: {
 *      carId: // value for 'carId'
 *      event: // value for 'event'
 *      originalEventId: // value for 'originalEventId'
 *      originalCarId: // value for 'originalCarId'
 *   },
 * });
 */
export function useChangeCarOnCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCarOnCalendarEventMutation, ChangeCarOnCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ChangeCarOnCalendarEventMutation, ChangeCarOnCalendarEventMutationVariables>(ChangeCarOnCalendarEventDocument, options);
}
export type ChangeCarOnCalendarEventMutationHookResult = ReturnType<typeof useChangeCarOnCalendarEventMutation>;
export type ChangeCarOnCalendarEventMutationResult = Apollo.MutationResult<ChangeCarOnCalendarEventMutation>;
export type ChangeCarOnCalendarEventMutationOptions = Apollo.BaseMutationOptions<ChangeCarOnCalendarEventMutation, ChangeCarOnCalendarEventMutationVariables>;
export const ChangeUserOnCalendarEventDocument = gql`
    mutation ChangeUserOnCalendarEvent($userId: String!, $event: CalendarEventInput!, $originalEventId: String!, $originalUserId: String!) {
  changeUserOnCalendarEvent(
    userId: $userId
    event: $event
    originalEventId: $originalEventId
    originalUserId: $originalUserId
  ) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentFragmentDoc}`;
export type ChangeUserOnCalendarEventMutationFn = Apollo.MutationFunction<ChangeUserOnCalendarEventMutation, ChangeUserOnCalendarEventMutationVariables>;

/**
 * __useChangeUserOnCalendarEventMutation__
 *
 * To run a mutation, you first call `useChangeUserOnCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserOnCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserOnCalendarEventMutation, { data, loading, error }] = useChangeUserOnCalendarEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      event: // value for 'event'
 *      originalEventId: // value for 'originalEventId'
 *      originalUserId: // value for 'originalUserId'
 *   },
 * });
 */
export function useChangeUserOnCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserOnCalendarEventMutation, ChangeUserOnCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ChangeUserOnCalendarEventMutation, ChangeUserOnCalendarEventMutationVariables>(ChangeUserOnCalendarEventDocument, options);
}
export type ChangeUserOnCalendarEventMutationHookResult = ReturnType<typeof useChangeUserOnCalendarEventMutation>;
export type ChangeUserOnCalendarEventMutationResult = Apollo.MutationResult<ChangeUserOnCalendarEventMutation>;
export type ChangeUserOnCalendarEventMutationOptions = Apollo.BaseMutationOptions<ChangeUserOnCalendarEventMutation, ChangeUserOnCalendarEventMutationVariables>;
export const CreateCarCalendarEventDocument = gql`
    mutation CreateCarCalendarEvent($carId: String!, $event: CalendarEventInput!) {
  createCarCalendarEvent(carId: $carId, event: $event) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentFragmentDoc}`;
export type CreateCarCalendarEventMutationFn = Apollo.MutationFunction<CreateCarCalendarEventMutation, CreateCarCalendarEventMutationVariables>;

/**
 * __useCreateCarCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateCarCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarCalendarEventMutation, { data, loading, error }] = useCreateCarCalendarEventMutation({
 *   variables: {
 *      carId: // value for 'carId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateCarCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarCalendarEventMutation, CreateCarCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCarCalendarEventMutation, CreateCarCalendarEventMutationVariables>(CreateCarCalendarEventDocument, options);
}
export type CreateCarCalendarEventMutationHookResult = ReturnType<typeof useCreateCarCalendarEventMutation>;
export type CreateCarCalendarEventMutationResult = Apollo.MutationResult<CreateCarCalendarEventMutation>;
export type CreateCarCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateCarCalendarEventMutation, CreateCarCalendarEventMutationVariables>;
export const CreateUserCalendarEventDocument = gql`
    mutation CreateUserCalendarEvent($userId: String!, $event: CalendarEventInput!) {
  createUserCalendarEvent(userId: $userId, event: $event) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentFragmentDoc}`;
export type CreateUserCalendarEventMutationFn = Apollo.MutationFunction<CreateUserCalendarEventMutation, CreateUserCalendarEventMutationVariables>;

/**
 * __useCreateUserCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateUserCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserCalendarEventMutation, { data, loading, error }] = useCreateUserCalendarEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateUserCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserCalendarEventMutation, CreateUserCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateUserCalendarEventMutation, CreateUserCalendarEventMutationVariables>(CreateUserCalendarEventDocument, options);
}
export type CreateUserCalendarEventMutationHookResult = ReturnType<typeof useCreateUserCalendarEventMutation>;
export type CreateUserCalendarEventMutationResult = Apollo.MutationResult<CreateUserCalendarEventMutation>;
export type CreateUserCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateUserCalendarEventMutation, CreateUserCalendarEventMutationVariables>;
export const DeleteCarCalendarEventDocument = gql`
    mutation DeleteCarCalendarEvent($carId: String!, $eventId: String!, $drivingSlipId: String) {
  deleteCarCalendarEvent(
    carId: $carId
    eventId: $eventId
    drivingSlipId: $drivingSlipId
  ) {
    ...BaseDrivingSlipFragment
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}`;
export type DeleteCarCalendarEventMutationFn = Apollo.MutationFunction<DeleteCarCalendarEventMutation, DeleteCarCalendarEventMutationVariables>;

/**
 * __useDeleteCarCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteCarCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarCalendarEventMutation, { data, loading, error }] = useDeleteCarCalendarEventMutation({
 *   variables: {
 *      carId: // value for 'carId'
 *      eventId: // value for 'eventId'
 *      drivingSlipId: // value for 'drivingSlipId'
 *   },
 * });
 */
export function useDeleteCarCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarCalendarEventMutation, DeleteCarCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCarCalendarEventMutation, DeleteCarCalendarEventMutationVariables>(DeleteCarCalendarEventDocument, options);
}
export type DeleteCarCalendarEventMutationHookResult = ReturnType<typeof useDeleteCarCalendarEventMutation>;
export type DeleteCarCalendarEventMutationResult = Apollo.MutationResult<DeleteCarCalendarEventMutation>;
export type DeleteCarCalendarEventMutationOptions = Apollo.BaseMutationOptions<DeleteCarCalendarEventMutation, DeleteCarCalendarEventMutationVariables>;
export const DeleteUserCalendarEventDocument = gql`
    mutation DeleteUserCalendarEvent($userId: String!, $eventId: String!, $drivingSlipId: String) {
  deleteUserCalendarEvent(
    userId: $userId
    eventId: $eventId
    drivingSlipId: $drivingSlipId
  ) {
    ...BaseDrivingSlipFragment
    case {
      ...BaseDrivingSlipCaseFragment
    }
  }
}
    ${BaseDrivingSlipFragmentFragmentDoc}
${BaseDrivingSlipCaseFragmentFragmentDoc}`;
export type DeleteUserCalendarEventMutationFn = Apollo.MutationFunction<DeleteUserCalendarEventMutation, DeleteUserCalendarEventMutationVariables>;

/**
 * __useDeleteUserCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteUserCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserCalendarEventMutation, { data, loading, error }] = useDeleteUserCalendarEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *      drivingSlipId: // value for 'drivingSlipId'
 *   },
 * });
 */
export function useDeleteUserCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserCalendarEventMutation, DeleteUserCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteUserCalendarEventMutation, DeleteUserCalendarEventMutationVariables>(DeleteUserCalendarEventDocument, options);
}
export type DeleteUserCalendarEventMutationHookResult = ReturnType<typeof useDeleteUserCalendarEventMutation>;
export type DeleteUserCalendarEventMutationResult = Apollo.MutationResult<DeleteUserCalendarEventMutation>;
export type DeleteUserCalendarEventMutationOptions = Apollo.BaseMutationOptions<DeleteUserCalendarEventMutation, DeleteUserCalendarEventMutationVariables>;
export const GetCarCalendarsDocument = gql`
    query GetCarCalendars($carIdList: [String!]!, $dateRange: DateRangeInput!) {
  carCalendars(carIdList: $carIdList, dateRange: $dateRange) {
    car {
      ...BaseCarFragment
    }
    events {
      ...CalendarEventFragment
    }
  }
}
    ${BaseCarFragmentFragmentDoc}
${CalendarEventFragmentFragmentDoc}`;

/**
 * __useGetCarCalendarsQuery__
 *
 * To run a query within a React component, call `useGetCarCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarCalendarsQuery({
 *   variables: {
 *      carIdList: // value for 'carIdList'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetCarCalendarsQuery(baseOptions: Apollo.QueryHookOptions<GetCarCalendarsQuery, GetCarCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCarCalendarsQuery, GetCarCalendarsQueryVariables>(GetCarCalendarsDocument, options);
}
export function useGetCarCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarCalendarsQuery, GetCarCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCarCalendarsQuery, GetCarCalendarsQueryVariables>(GetCarCalendarsDocument, options);
}
export function useGetCarCalendarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCarCalendarsQuery, GetCarCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCarCalendarsQuery, GetCarCalendarsQueryVariables>(GetCarCalendarsDocument, options);
}
export type GetCarCalendarsQueryHookResult = ReturnType<typeof useGetCarCalendarsQuery>;
export type GetCarCalendarsLazyQueryHookResult = ReturnType<typeof useGetCarCalendarsLazyQuery>;
export type GetCarCalendarsSuspenseQueryHookResult = ReturnType<typeof useGetCarCalendarsSuspenseQuery>;
export type GetCarCalendarsQueryResult = Apollo.QueryResult<GetCarCalendarsQuery, GetCarCalendarsQueryVariables>;
export function refetchGetCarCalendarsQuery(variables: GetCarCalendarsQueryVariables) {
  return { query: GetCarCalendarsDocument, variables: variables }
}
export const GetCarsWithCalendarsDocument = gql`
    query GetCarsWithCalendars {
  carsWithCalendars {
    ...BaseCarFragment
  }
}
    ${BaseCarFragmentFragmentDoc}`;

/**
 * __useGetCarsWithCalendarsQuery__
 *
 * To run a query within a React component, call `useGetCarsWithCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarsWithCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarsWithCalendarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCarsWithCalendarsQuery(baseOptions?: Apollo.QueryHookOptions<GetCarsWithCalendarsQuery, GetCarsWithCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCarsWithCalendarsQuery, GetCarsWithCalendarsQueryVariables>(GetCarsWithCalendarsDocument, options);
}
export function useGetCarsWithCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarsWithCalendarsQuery, GetCarsWithCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCarsWithCalendarsQuery, GetCarsWithCalendarsQueryVariables>(GetCarsWithCalendarsDocument, options);
}
export function useGetCarsWithCalendarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCarsWithCalendarsQuery, GetCarsWithCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCarsWithCalendarsQuery, GetCarsWithCalendarsQueryVariables>(GetCarsWithCalendarsDocument, options);
}
export type GetCarsWithCalendarsQueryHookResult = ReturnType<typeof useGetCarsWithCalendarsQuery>;
export type GetCarsWithCalendarsLazyQueryHookResult = ReturnType<typeof useGetCarsWithCalendarsLazyQuery>;
export type GetCarsWithCalendarsSuspenseQueryHookResult = ReturnType<typeof useGetCarsWithCalendarsSuspenseQuery>;
export type GetCarsWithCalendarsQueryResult = Apollo.QueryResult<GetCarsWithCalendarsQuery, GetCarsWithCalendarsQueryVariables>;
export function refetchGetCarsWithCalendarsQuery(variables?: GetCarsWithCalendarsQueryVariables) {
  return { query: GetCarsWithCalendarsDocument, variables: variables }
}
export const GetUserCalendarsDocument = gql`
    query GetUserCalendars($userIdList: [String!]!, $dateRange: DateRangeInput!) {
  userCalendars(userIdList: $userIdList, dateRange: $dateRange) {
    user {
      ...BaseUserFragment
      plannerHelpText
      plannerHelpTextUpdatedAt
    }
    events {
      ...CalendarEventFragment
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${CalendarEventFragmentFragmentDoc}`;

/**
 * __useGetUserCalendarsQuery__
 *
 * To run a query within a React component, call `useGetUserCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCalendarsQuery({
 *   variables: {
 *      userIdList: // value for 'userIdList'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetUserCalendarsQuery(baseOptions: Apollo.QueryHookOptions<GetUserCalendarsQuery, GetUserCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserCalendarsQuery, GetUserCalendarsQueryVariables>(GetUserCalendarsDocument, options);
}
export function useGetUserCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCalendarsQuery, GetUserCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserCalendarsQuery, GetUserCalendarsQueryVariables>(GetUserCalendarsDocument, options);
}
export function useGetUserCalendarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserCalendarsQuery, GetUserCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUserCalendarsQuery, GetUserCalendarsQueryVariables>(GetUserCalendarsDocument, options);
}
export type GetUserCalendarsQueryHookResult = ReturnType<typeof useGetUserCalendarsQuery>;
export type GetUserCalendarsLazyQueryHookResult = ReturnType<typeof useGetUserCalendarsLazyQuery>;
export type GetUserCalendarsSuspenseQueryHookResult = ReturnType<typeof useGetUserCalendarsSuspenseQuery>;
export type GetUserCalendarsQueryResult = Apollo.QueryResult<GetUserCalendarsQuery, GetUserCalendarsQueryVariables>;
export function refetchGetUserCalendarsQuery(variables: GetUserCalendarsQueryVariables) {
  return { query: GetUserCalendarsDocument, variables: variables }
}
export const GetUsersWithCalendarsDocument = gql`
    query GetUsersWithCalendars {
  usersWithCalendars {
    ...BaseUserFragment
    plannerHelpText
    plannerHelpTextUpdatedAt
  }
}
    ${BaseUserFragmentFragmentDoc}`;

/**
 * __useGetUsersWithCalendarsQuery__
 *
 * To run a query within a React component, call `useGetUsersWithCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWithCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWithCalendarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersWithCalendarsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersWithCalendarsQuery, GetUsersWithCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUsersWithCalendarsQuery, GetUsersWithCalendarsQueryVariables>(GetUsersWithCalendarsDocument, options);
}
export function useGetUsersWithCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWithCalendarsQuery, GetUsersWithCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUsersWithCalendarsQuery, GetUsersWithCalendarsQueryVariables>(GetUsersWithCalendarsDocument, options);
}
export function useGetUsersWithCalendarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersWithCalendarsQuery, GetUsersWithCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUsersWithCalendarsQuery, GetUsersWithCalendarsQueryVariables>(GetUsersWithCalendarsDocument, options);
}
export type GetUsersWithCalendarsQueryHookResult = ReturnType<typeof useGetUsersWithCalendarsQuery>;
export type GetUsersWithCalendarsLazyQueryHookResult = ReturnType<typeof useGetUsersWithCalendarsLazyQuery>;
export type GetUsersWithCalendarsSuspenseQueryHookResult = ReturnType<typeof useGetUsersWithCalendarsSuspenseQuery>;
export type GetUsersWithCalendarsQueryResult = Apollo.QueryResult<GetUsersWithCalendarsQuery, GetUsersWithCalendarsQueryVariables>;
export function refetchGetUsersWithCalendarsQuery(variables?: GetUsersWithCalendarsQueryVariables) {
  return { query: GetUsersWithCalendarsDocument, variables: variables }
}
export const UpdateCarCalendarEventDocument = gql`
    mutation UpdateCarCalendarEvent($carId: String!, $eventId: String!, $event: CalendarEventInput!) {
  updateCarCalendarEvent(carId: $carId, event: $event, eventId: $eventId) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentFragmentDoc}`;
export type UpdateCarCalendarEventMutationFn = Apollo.MutationFunction<UpdateCarCalendarEventMutation, UpdateCarCalendarEventMutationVariables>;

/**
 * __useUpdateCarCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateCarCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarCalendarEventMutation, { data, loading, error }] = useUpdateCarCalendarEventMutation({
 *   variables: {
 *      carId: // value for 'carId'
 *      eventId: // value for 'eventId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpdateCarCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarCalendarEventMutation, UpdateCarCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCarCalendarEventMutation, UpdateCarCalendarEventMutationVariables>(UpdateCarCalendarEventDocument, options);
}
export type UpdateCarCalendarEventMutationHookResult = ReturnType<typeof useUpdateCarCalendarEventMutation>;
export type UpdateCarCalendarEventMutationResult = Apollo.MutationResult<UpdateCarCalendarEventMutation>;
export type UpdateCarCalendarEventMutationOptions = Apollo.BaseMutationOptions<UpdateCarCalendarEventMutation, UpdateCarCalendarEventMutationVariables>;
export const UpdateUserCalendarEventDocument = gql`
    mutation UpdateUserCalendarEvent($userId: String!, $eventId: String!, $event: CalendarEventInput!) {
  updateUserCalendarEvent(userId: $userId, event: $event, eventId: $eventId) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentFragmentDoc}`;
export type UpdateUserCalendarEventMutationFn = Apollo.MutationFunction<UpdateUserCalendarEventMutation, UpdateUserCalendarEventMutationVariables>;

/**
 * __useUpdateUserCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateUserCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCalendarEventMutation, { data, loading, error }] = useUpdateUserCalendarEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpdateUserCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCalendarEventMutation, UpdateUserCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserCalendarEventMutation, UpdateUserCalendarEventMutationVariables>(UpdateUserCalendarEventDocument, options);
}
export type UpdateUserCalendarEventMutationHookResult = ReturnType<typeof useUpdateUserCalendarEventMutation>;
export type UpdateUserCalendarEventMutationResult = Apollo.MutationResult<UpdateUserCalendarEventMutation>;
export type UpdateUserCalendarEventMutationOptions = Apollo.BaseMutationOptions<UpdateUserCalendarEventMutation, UpdateUserCalendarEventMutationVariables>;
export const AddCarOrMaterialsDocument = gql`
    mutation AddCarOrMaterials($id: String!, $car: String, $material: String) {
  addCarOrMaterials(id: $id, car: $car, material: $material) {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;
export type AddCarOrMaterialsMutationFn = Apollo.MutationFunction<AddCarOrMaterialsMutation, AddCarOrMaterialsMutationVariables>;

/**
 * __useAddCarOrMaterialsMutation__
 *
 * To run a mutation, you first call `useAddCarOrMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarOrMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarOrMaterialsMutation, { data, loading, error }] = useAddCarOrMaterialsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      car: // value for 'car'
 *      material: // value for 'material'
 *   },
 * });
 */
export function useAddCarOrMaterialsMutation(baseOptions?: Apollo.MutationHookOptions<AddCarOrMaterialsMutation, AddCarOrMaterialsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddCarOrMaterialsMutation, AddCarOrMaterialsMutationVariables>(AddCarOrMaterialsDocument, options);
}
export type AddCarOrMaterialsMutationHookResult = ReturnType<typeof useAddCarOrMaterialsMutation>;
export type AddCarOrMaterialsMutationResult = Apollo.MutationResult<AddCarOrMaterialsMutation>;
export type AddCarOrMaterialsMutationOptions = Apollo.BaseMutationOptions<AddCarOrMaterialsMutation, AddCarOrMaterialsMutationVariables>;
export const ChangeUserOnEventDocument = gql`
    mutation ChangeUserOnEvent($userId: String!, $event: CalendarEventInput!, $originalEventId: String!, $originalUserId: String!) {
  changeUserOnCalendarEvent(
    userId: $userId
    event: $event
    originalEventId: $originalEventId
    originalUserId: $originalUserId
  ) {
    ...Event
  }
}
    ${EventFragmentDoc}`;
export type ChangeUserOnEventMutationFn = Apollo.MutationFunction<ChangeUserOnEventMutation, ChangeUserOnEventMutationVariables>;

/**
 * __useChangeUserOnEventMutation__
 *
 * To run a mutation, you first call `useChangeUserOnEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserOnEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserOnEventMutation, { data, loading, error }] = useChangeUserOnEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      event: // value for 'event'
 *      originalEventId: // value for 'originalEventId'
 *      originalUserId: // value for 'originalUserId'
 *   },
 * });
 */
export function useChangeUserOnEventMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserOnEventMutation, ChangeUserOnEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ChangeUserOnEventMutation, ChangeUserOnEventMutationVariables>(ChangeUserOnEventDocument, options);
}
export type ChangeUserOnEventMutationHookResult = ReturnType<typeof useChangeUserOnEventMutation>;
export type ChangeUserOnEventMutationResult = Apollo.MutationResult<ChangeUserOnEventMutation>;
export type ChangeUserOnEventMutationOptions = Apollo.BaseMutationOptions<ChangeUserOnEventMutation, ChangeUserOnEventMutationVariables>;
export const CreateCalendarEventDocument = gql`
    mutation CreateCalendarEvent($userId: String!, $event: CalendarEventInput!) {
  createUserCalendarEvent(userId: $userId, event: $event) {
    ...Event
  }
}
    ${EventFragmentDoc}`;
export type CreateCalendarEventMutationFn = Apollo.MutationFunction<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;

/**
 * __useCreateCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarEventMutation, { data, loading, error }] = useCreateCalendarEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>(CreateCalendarEventDocument, options);
}
export type CreateCalendarEventMutationHookResult = ReturnType<typeof useCreateCalendarEventMutation>;
export type CreateCalendarEventMutationResult = Apollo.MutationResult<CreateCalendarEventMutation>;
export type CreateCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;
export const CreateDrivingSlipNewPlannerDocument = gql`
    mutation CreateDrivingSlipNewPlanner($drivingSlip: DrivingSlipHelperInput!, $caseId: String!) {
  createDrivingSlip(drivingSlip: $drivingSlip, caseId: $caseId) {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;
export type CreateDrivingSlipNewPlannerMutationFn = Apollo.MutationFunction<CreateDrivingSlipNewPlannerMutation, CreateDrivingSlipNewPlannerMutationVariables>;

/**
 * __useCreateDrivingSlipNewPlannerMutation__
 *
 * To run a mutation, you first call `useCreateDrivingSlipNewPlannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrivingSlipNewPlannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrivingSlipNewPlannerMutation, { data, loading, error }] = useCreateDrivingSlipNewPlannerMutation({
 *   variables: {
 *      drivingSlip: // value for 'drivingSlip'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useCreateDrivingSlipNewPlannerMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrivingSlipNewPlannerMutation, CreateDrivingSlipNewPlannerMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDrivingSlipNewPlannerMutation, CreateDrivingSlipNewPlannerMutationVariables>(CreateDrivingSlipNewPlannerDocument, options);
}
export type CreateDrivingSlipNewPlannerMutationHookResult = ReturnType<typeof useCreateDrivingSlipNewPlannerMutation>;
export type CreateDrivingSlipNewPlannerMutationResult = Apollo.MutationResult<CreateDrivingSlipNewPlannerMutation>;
export type CreateDrivingSlipNewPlannerMutationOptions = Apollo.BaseMutationOptions<CreateDrivingSlipNewPlannerMutation, CreateDrivingSlipNewPlannerMutationVariables>;
export const DeleteCalendarEventDocument = gql`
    mutation DeleteCalendarEvent($userId: String!, $eventId: String!, $drivingSlipId: String) {
  deleteUserCalendarEvent(
    userId: $userId
    eventId: $eventId
    drivingSlipId: $drivingSlipId
  ) {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;
export type DeleteCalendarEventMutationFn = Apollo.MutationFunction<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;

/**
 * __useDeleteCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarEventMutation, { data, loading, error }] = useDeleteCalendarEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *      drivingSlipId: // value for 'drivingSlipId'
 *   },
 * });
 */
export function useDeleteCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>(DeleteCalendarEventDocument, options);
}
export type DeleteCalendarEventMutationHookResult = ReturnType<typeof useDeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationResult = Apollo.MutationResult<DeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationOptions = Apollo.BaseMutationOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;
export const GetCalendarsDocument = gql`
    query GetCalendars($userIdList: [String!]!, $dateRange: DateRangeInput!) {
  userCalendars(userIdList: $userIdList, dateRange: $dateRange) {
    user {
      ...BaseUserFragment
      plannerHelpText
      plannerHelpTextUpdatedAt
    }
    events {
      ...Event
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${EventFragmentDoc}`;

/**
 * __useGetCalendarsQuery__
 *
 * To run a query within a React component, call `useGetCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarsQuery({
 *   variables: {
 *      userIdList: // value for 'userIdList'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetCalendarsQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarsQuery, GetCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCalendarsQuery, GetCalendarsQueryVariables>(GetCalendarsDocument, options);
}
export function useGetCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarsQuery, GetCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCalendarsQuery, GetCalendarsQueryVariables>(GetCalendarsDocument, options);
}
export function useGetCalendarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalendarsQuery, GetCalendarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCalendarsQuery, GetCalendarsQueryVariables>(GetCalendarsDocument, options);
}
export type GetCalendarsQueryHookResult = ReturnType<typeof useGetCalendarsQuery>;
export type GetCalendarsLazyQueryHookResult = ReturnType<typeof useGetCalendarsLazyQuery>;
export type GetCalendarsSuspenseQueryHookResult = ReturnType<typeof useGetCalendarsSuspenseQuery>;
export type GetCalendarsQueryResult = Apollo.QueryResult<GetCalendarsQuery, GetCalendarsQueryVariables>;
export function refetchGetCalendarsQuery(variables: GetCalendarsQueryVariables) {
  return { query: GetCalendarsDocument, variables: variables }
}
export const GetDrivingSlipsNewPlannerDocument = gql`
    query GetDrivingSlipsNewPlanner($personalOnly: Boolean, $dateRange: DateRangeInput, $status: DrivingSlipStatus, $urgent: Boolean, $exceeded: Boolean, $departments: [String!], $locations: [String!], $damageCauses: [String!], $damageCategories: [String!], $drivingSlipCategories: [String!], $drivers: [String!], $minStartDate: Date, $maxStartDate: Date, $minEndDate: Date, $maxEndDate: Date, $noDriver: Boolean, $case: String, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  plannerDrivingSlips: drivingSlips(
    personalOnly: $personalOnly
    dateRange: $dateRange
    status: $status
    urgent: $urgent
    exceeded: $exceeded
    departments: $departments
    locations: $locations
    damageCauses: $damageCauses
    damageCategories: $damageCategories
    drivingSlipCategories: $drivingSlipCategories
    drivers: $drivers
    minStartDate: $minStartDate
    maxStartDate: $maxStartDate
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    noDriver: $noDriver
    case: $case
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;

/**
 * __useGetDrivingSlipsNewPlannerQuery__
 *
 * To run a query within a React component, call `useGetDrivingSlipsNewPlannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingSlipsNewPlannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingSlipsNewPlannerQuery({
 *   variables: {
 *      personalOnly: // value for 'personalOnly'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      urgent: // value for 'urgent'
 *      exceeded: // value for 'exceeded'
 *      departments: // value for 'departments'
 *      locations: // value for 'locations'
 *      damageCauses: // value for 'damageCauses'
 *      damageCategories: // value for 'damageCategories'
 *      drivingSlipCategories: // value for 'drivingSlipCategories'
 *      drivers: // value for 'drivers'
 *      minStartDate: // value for 'minStartDate'
 *      maxStartDate: // value for 'maxStartDate'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      noDriver: // value for 'noDriver'
 *      case: // value for 'case'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetDrivingSlipsNewPlannerQuery(baseOptions?: Apollo.QueryHookOptions<GetDrivingSlipsNewPlannerQuery, GetDrivingSlipsNewPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrivingSlipsNewPlannerQuery, GetDrivingSlipsNewPlannerQueryVariables>(GetDrivingSlipsNewPlannerDocument, options);
}
export function useGetDrivingSlipsNewPlannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrivingSlipsNewPlannerQuery, GetDrivingSlipsNewPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrivingSlipsNewPlannerQuery, GetDrivingSlipsNewPlannerQueryVariables>(GetDrivingSlipsNewPlannerDocument, options);
}
export function useGetDrivingSlipsNewPlannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrivingSlipsNewPlannerQuery, GetDrivingSlipsNewPlannerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDrivingSlipsNewPlannerQuery, GetDrivingSlipsNewPlannerQueryVariables>(GetDrivingSlipsNewPlannerDocument, options);
}
export type GetDrivingSlipsNewPlannerQueryHookResult = ReturnType<typeof useGetDrivingSlipsNewPlannerQuery>;
export type GetDrivingSlipsNewPlannerLazyQueryHookResult = ReturnType<typeof useGetDrivingSlipsNewPlannerLazyQuery>;
export type GetDrivingSlipsNewPlannerSuspenseQueryHookResult = ReturnType<typeof useGetDrivingSlipsNewPlannerSuspenseQuery>;
export type GetDrivingSlipsNewPlannerQueryResult = Apollo.QueryResult<GetDrivingSlipsNewPlannerQuery, GetDrivingSlipsNewPlannerQueryVariables>;
export function refetchGetDrivingSlipsNewPlannerQuery(variables?: GetDrivingSlipsNewPlannerQueryVariables) {
  return { query: GetDrivingSlipsNewPlannerDocument, variables: variables }
}
export const RemoveCarFromDrivingSlipDocument = gql`
    mutation RemoveCarFromDrivingSlip($id: String!) {
  removeCar(id: $id) {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;
export type RemoveCarFromDrivingSlipMutationFn = Apollo.MutationFunction<RemoveCarFromDrivingSlipMutation, RemoveCarFromDrivingSlipMutationVariables>;

/**
 * __useRemoveCarFromDrivingSlipMutation__
 *
 * To run a mutation, you first call `useRemoveCarFromDrivingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCarFromDrivingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCarFromDrivingSlipMutation, { data, loading, error }] = useRemoveCarFromDrivingSlipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCarFromDrivingSlipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCarFromDrivingSlipMutation, RemoveCarFromDrivingSlipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveCarFromDrivingSlipMutation, RemoveCarFromDrivingSlipMutationVariables>(RemoveCarFromDrivingSlipDocument, options);
}
export type RemoveCarFromDrivingSlipMutationHookResult = ReturnType<typeof useRemoveCarFromDrivingSlipMutation>;
export type RemoveCarFromDrivingSlipMutationResult = Apollo.MutationResult<RemoveCarFromDrivingSlipMutation>;
export type RemoveCarFromDrivingSlipMutationOptions = Apollo.BaseMutationOptions<RemoveCarFromDrivingSlipMutation, RemoveCarFromDrivingSlipMutationVariables>;
export const RemoveMaterialFromDrivingSlipDocument = gql`
    mutation RemoveMaterialFromDrivingSlip($id: String!, $material: String!) {
  removeMaterial(id: $id, material: $material) {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;
export type RemoveMaterialFromDrivingSlipMutationFn = Apollo.MutationFunction<RemoveMaterialFromDrivingSlipMutation, RemoveMaterialFromDrivingSlipMutationVariables>;

/**
 * __useRemoveMaterialFromDrivingSlipMutation__
 *
 * To run a mutation, you first call `useRemoveMaterialFromDrivingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMaterialFromDrivingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMaterialFromDrivingSlipMutation, { data, loading, error }] = useRemoveMaterialFromDrivingSlipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      material: // value for 'material'
 *   },
 * });
 */
export function useRemoveMaterialFromDrivingSlipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMaterialFromDrivingSlipMutation, RemoveMaterialFromDrivingSlipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveMaterialFromDrivingSlipMutation, RemoveMaterialFromDrivingSlipMutationVariables>(RemoveMaterialFromDrivingSlipDocument, options);
}
export type RemoveMaterialFromDrivingSlipMutationHookResult = ReturnType<typeof useRemoveMaterialFromDrivingSlipMutation>;
export type RemoveMaterialFromDrivingSlipMutationResult = Apollo.MutationResult<RemoveMaterialFromDrivingSlipMutation>;
export type RemoveMaterialFromDrivingSlipMutationOptions = Apollo.BaseMutationOptions<RemoveMaterialFromDrivingSlipMutation, RemoveMaterialFromDrivingSlipMutationVariables>;
export const SetDrivingSlipStatusNewPlannerDocument = gql`
    mutation SetDrivingSlipStatusNewPlanner($id: String!, $status: DrivingSlipStatus!) {
  setDrivingSlipStatus(id: $id, status: $status) {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;
export type SetDrivingSlipStatusNewPlannerMutationFn = Apollo.MutationFunction<SetDrivingSlipStatusNewPlannerMutation, SetDrivingSlipStatusNewPlannerMutationVariables>;

/**
 * __useSetDrivingSlipStatusNewPlannerMutation__
 *
 * To run a mutation, you first call `useSetDrivingSlipStatusNewPlannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDrivingSlipStatusNewPlannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDrivingSlipStatusNewPlannerMutation, { data, loading, error }] = useSetDrivingSlipStatusNewPlannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetDrivingSlipStatusNewPlannerMutation(baseOptions?: Apollo.MutationHookOptions<SetDrivingSlipStatusNewPlannerMutation, SetDrivingSlipStatusNewPlannerMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetDrivingSlipStatusNewPlannerMutation, SetDrivingSlipStatusNewPlannerMutationVariables>(SetDrivingSlipStatusNewPlannerDocument, options);
}
export type SetDrivingSlipStatusNewPlannerMutationHookResult = ReturnType<typeof useSetDrivingSlipStatusNewPlannerMutation>;
export type SetDrivingSlipStatusNewPlannerMutationResult = Apollo.MutationResult<SetDrivingSlipStatusNewPlannerMutation>;
export type SetDrivingSlipStatusNewPlannerMutationOptions = Apollo.BaseMutationOptions<SetDrivingSlipStatusNewPlannerMutation, SetDrivingSlipStatusNewPlannerMutationVariables>;
export const UpdateCalendarEventDocument = gql`
    mutation UpdateCalendarEvent($userId: String!, $eventId: String!, $event: CalendarEventInput!) {
  updateUserCalendarEvent(userId: $userId, event: $event, eventId: $eventId) {
    ...Event
  }
}
    ${EventFragmentDoc}`;
export type UpdateCalendarEventMutationFn = Apollo.MutationFunction<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;

/**
 * __useUpdateCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarEventMutation, { data, loading, error }] = useUpdateCalendarEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpdateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>(UpdateCalendarEventDocument, options);
}
export type UpdateCalendarEventMutationHookResult = ReturnType<typeof useUpdateCalendarEventMutation>;
export type UpdateCalendarEventMutationResult = Apollo.MutationResult<UpdateCalendarEventMutation>;
export type UpdateCalendarEventMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;
export const UpdateWebDrivingSlipNewPlannerDocument = gql`
    mutation UpdateWebDrivingSlipNewPlanner($id: String!, $urgent: Boolean, $driver: String, $estimatedHours: Decimal, $start: DateTime, $end: DateTime, $comment: String, $deadline: DateTime, $eventId: String, $additionalDays: [AdditionalDayInput!], $additionalDrivers: [String!], $location: String!, $department: String!, $driverCarList: [DriverCarInput!], $category: String, $immediatelyPlan: Boolean, $plannerMessage: String, $car: String, $materials: [String!], $halfDay: Boolean) {
  updateDrivingSlip(
    id: $id
    urgent: $urgent
    driver: $driver
    estimatedHours: $estimatedHours
    start: $start
    end: $end
    comment: $comment
    deadline: $deadline
    eventId: $eventId
    additionalDays: $additionalDays
    additionalDrivers: $additionalDrivers
    location: $location
    department: $department
    category: $category
    immediatelyPlan: $immediatelyPlan
    plannerMessage: $plannerMessage
    car: $car
    materials: $materials
    driverCarList: $driverCarList
    halfDay: $halfDay
  ) {
    ...DrivingSlipNewPlanner
  }
}
    ${DrivingSlipNewPlannerFragmentDoc}`;
export type UpdateWebDrivingSlipNewPlannerMutationFn = Apollo.MutationFunction<UpdateWebDrivingSlipNewPlannerMutation, UpdateWebDrivingSlipNewPlannerMutationVariables>;

/**
 * __useUpdateWebDrivingSlipNewPlannerMutation__
 *
 * To run a mutation, you first call `useUpdateWebDrivingSlipNewPlannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebDrivingSlipNewPlannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebDrivingSlipNewPlannerMutation, { data, loading, error }] = useUpdateWebDrivingSlipNewPlannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      urgent: // value for 'urgent'
 *      driver: // value for 'driver'
 *      estimatedHours: // value for 'estimatedHours'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      comment: // value for 'comment'
 *      deadline: // value for 'deadline'
 *      eventId: // value for 'eventId'
 *      additionalDays: // value for 'additionalDays'
 *      additionalDrivers: // value for 'additionalDrivers'
 *      location: // value for 'location'
 *      department: // value for 'department'
 *      driverCarList: // value for 'driverCarList'
 *      category: // value for 'category'
 *      immediatelyPlan: // value for 'immediatelyPlan'
 *      plannerMessage: // value for 'plannerMessage'
 *      car: // value for 'car'
 *      materials: // value for 'materials'
 *      halfDay: // value for 'halfDay'
 *   },
 * });
 */
export function useUpdateWebDrivingSlipNewPlannerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebDrivingSlipNewPlannerMutation, UpdateWebDrivingSlipNewPlannerMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateWebDrivingSlipNewPlannerMutation, UpdateWebDrivingSlipNewPlannerMutationVariables>(UpdateWebDrivingSlipNewPlannerDocument, options);
}
export type UpdateWebDrivingSlipNewPlannerMutationHookResult = ReturnType<typeof useUpdateWebDrivingSlipNewPlannerMutation>;
export type UpdateWebDrivingSlipNewPlannerMutationResult = Apollo.MutationResult<UpdateWebDrivingSlipNewPlannerMutation>;
export type UpdateWebDrivingSlipNewPlannerMutationOptions = Apollo.BaseMutationOptions<UpdateWebDrivingSlipNewPlannerMutation, UpdateWebDrivingSlipNewPlannerMutationVariables>;
export const CreateCaseOrganizationReportDocument = gql`
    mutation CreateCaseOrganizationReport($caseId: String!, $formData: CaseOrganizationFormDataInput!, $onlySave: Boolean!) {
  createCaseOrganizationReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateCaseOrganizationReportMutationFn = Apollo.MutationFunction<CreateCaseOrganizationReportMutation, CreateCaseOrganizationReportMutationVariables>;

/**
 * __useCreateCaseOrganizationReportMutation__
 *
 * To run a mutation, you first call `useCreateCaseOrganizationReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseOrganizationReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseOrganizationReportMutation, { data, loading, error }] = useCreateCaseOrganizationReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateCaseOrganizationReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseOrganizationReportMutation, CreateCaseOrganizationReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCaseOrganizationReportMutation, CreateCaseOrganizationReportMutationVariables>(CreateCaseOrganizationReportDocument, options);
}
export type CreateCaseOrganizationReportMutationHookResult = ReturnType<typeof useCreateCaseOrganizationReportMutation>;
export type CreateCaseOrganizationReportMutationResult = Apollo.MutationResult<CreateCaseOrganizationReportMutation>;
export type CreateCaseOrganizationReportMutationOptions = Apollo.BaseMutationOptions<CreateCaseOrganizationReportMutation, CreateCaseOrganizationReportMutationVariables>;
export const CreateDeviationReportDocument = gql`
    mutation CreateDeviationReport($caseId: String!, $formData: DeviationReportFormDataInput!, $onlySave: Boolean!) {
  createDeviationReport(caseId: $caseId, formData: $formData, onlySave: $onlySave) {
    name
    fileId
  }
}
    `;
export type CreateDeviationReportMutationFn = Apollo.MutationFunction<CreateDeviationReportMutation, CreateDeviationReportMutationVariables>;

/**
 * __useCreateDeviationReportMutation__
 *
 * To run a mutation, you first call `useCreateDeviationReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviationReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviationReportMutation, { data, loading, error }] = useCreateDeviationReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateDeviationReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviationReportMutation, CreateDeviationReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDeviationReportMutation, CreateDeviationReportMutationVariables>(CreateDeviationReportDocument, options);
}
export type CreateDeviationReportMutationHookResult = ReturnType<typeof useCreateDeviationReportMutation>;
export type CreateDeviationReportMutationResult = Apollo.MutationResult<CreateDeviationReportMutation>;
export type CreateDeviationReportMutationOptions = Apollo.BaseMutationOptions<CreateDeviationReportMutation, CreateDeviationReportMutationVariables>;
export const CreateEndevaluationReportDocument = gql`
    mutation CreateEndevaluationReport($caseId: String!, $formData: EndevaluationReportFormDataInput!, $onlySave: Boolean!) {
  createEndevaluationReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateEndevaluationReportMutationFn = Apollo.MutationFunction<CreateEndevaluationReportMutation, CreateEndevaluationReportMutationVariables>;

/**
 * __useCreateEndevaluationReportMutation__
 *
 * To run a mutation, you first call `useCreateEndevaluationReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEndevaluationReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEndevaluationReportMutation, { data, loading, error }] = useCreateEndevaluationReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateEndevaluationReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateEndevaluationReportMutation, CreateEndevaluationReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateEndevaluationReportMutation, CreateEndevaluationReportMutationVariables>(CreateEndevaluationReportDocument, options);
}
export type CreateEndevaluationReportMutationHookResult = ReturnType<typeof useCreateEndevaluationReportMutation>;
export type CreateEndevaluationReportMutationResult = Apollo.MutationResult<CreateEndevaluationReportMutation>;
export type CreateEndevaluationReportMutationOptions = Apollo.BaseMutationOptions<CreateEndevaluationReportMutation, CreateEndevaluationReportMutationVariables>;
export const CreateInspectionAssesmentReportDocument = gql`
    mutation CreateInspectionAssesmentReport($caseId: String!, $formData: InspectionAssesmentFormDataInput!, $onlySave: Boolean!) {
  createInspectionAssesmentReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateInspectionAssesmentReportMutationFn = Apollo.MutationFunction<CreateInspectionAssesmentReportMutation, CreateInspectionAssesmentReportMutationVariables>;

/**
 * __useCreateInspectionAssesmentReportMutation__
 *
 * To run a mutation, you first call `useCreateInspectionAssesmentReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInspectionAssesmentReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInspectionAssesmentReportMutation, { data, loading, error }] = useCreateInspectionAssesmentReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateInspectionAssesmentReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateInspectionAssesmentReportMutation, CreateInspectionAssesmentReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateInspectionAssesmentReportMutation, CreateInspectionAssesmentReportMutationVariables>(CreateInspectionAssesmentReportDocument, options);
}
export type CreateInspectionAssesmentReportMutationHookResult = ReturnType<typeof useCreateInspectionAssesmentReportMutation>;
export type CreateInspectionAssesmentReportMutationResult = Apollo.MutationResult<CreateInspectionAssesmentReportMutation>;
export type CreateInspectionAssesmentReportMutationOptions = Apollo.BaseMutationOptions<CreateInspectionAssesmentReportMutation, CreateInspectionAssesmentReportMutationVariables>;
export const CreateNoticeOfConstructionwasteReportDocument = gql`
    mutation CreateNoticeOfConstructionwasteReport($caseId: String!, $formData: NoticeOfConstructionwasteFormDataInput!, $onlySave: Boolean!) {
  createNoticeOfConstructionwasteReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateNoticeOfConstructionwasteReportMutationFn = Apollo.MutationFunction<CreateNoticeOfConstructionwasteReportMutation, CreateNoticeOfConstructionwasteReportMutationVariables>;

/**
 * __useCreateNoticeOfConstructionwasteReportMutation__
 *
 * To run a mutation, you first call `useCreateNoticeOfConstructionwasteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoticeOfConstructionwasteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoticeOfConstructionwasteReportMutation, { data, loading, error }] = useCreateNoticeOfConstructionwasteReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateNoticeOfConstructionwasteReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoticeOfConstructionwasteReportMutation, CreateNoticeOfConstructionwasteReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateNoticeOfConstructionwasteReportMutation, CreateNoticeOfConstructionwasteReportMutationVariables>(CreateNoticeOfConstructionwasteReportDocument, options);
}
export type CreateNoticeOfConstructionwasteReportMutationHookResult = ReturnType<typeof useCreateNoticeOfConstructionwasteReportMutation>;
export type CreateNoticeOfConstructionwasteReportMutationResult = Apollo.MutationResult<CreateNoticeOfConstructionwasteReportMutation>;
export type CreateNoticeOfConstructionwasteReportMutationOptions = Apollo.BaseMutationOptions<CreateNoticeOfConstructionwasteReportMutation, CreateNoticeOfConstructionwasteReportMutationVariables>;
export const CreateWebDamageReportDocument = gql`
    mutation CreateWebDamageReport($id: String!) {
  createDamageReport(caseId: $id) {
    name
    url
    fileId
  }
}
    `;
export type CreateWebDamageReportMutationFn = Apollo.MutationFunction<CreateWebDamageReportMutation, CreateWebDamageReportMutationVariables>;

/**
 * __useCreateWebDamageReportMutation__
 *
 * To run a mutation, you first call `useCreateWebDamageReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebDamageReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebDamageReportMutation, { data, loading, error }] = useCreateWebDamageReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateWebDamageReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebDamageReportMutation, CreateWebDamageReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateWebDamageReportMutation, CreateWebDamageReportMutationVariables>(CreateWebDamageReportDocument, options);
}
export type CreateWebDamageReportMutationHookResult = ReturnType<typeof useCreateWebDamageReportMutation>;
export type CreateWebDamageReportMutationResult = Apollo.MutationResult<CreateWebDamageReportMutation>;
export type CreateWebDamageReportMutationOptions = Apollo.BaseMutationOptions<CreateWebDamageReportMutation, CreateWebDamageReportMutationVariables>;
export const CreateWebInspectionMovablesReportDocument = gql`
    mutation CreateWebInspectionMovablesReport($caseId: String!, $formData: InspectionReportFormDataInput!, $onlySave: Boolean!) {
  createInspectionMovablesReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateWebInspectionMovablesReportMutationFn = Apollo.MutationFunction<CreateWebInspectionMovablesReportMutation, CreateWebInspectionMovablesReportMutationVariables>;

/**
 * __useCreateWebInspectionMovablesReportMutation__
 *
 * To run a mutation, you first call `useCreateWebInspectionMovablesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebInspectionMovablesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebInspectionMovablesReportMutation, { data, loading, error }] = useCreateWebInspectionMovablesReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateWebInspectionMovablesReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebInspectionMovablesReportMutation, CreateWebInspectionMovablesReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateWebInspectionMovablesReportMutation, CreateWebInspectionMovablesReportMutationVariables>(CreateWebInspectionMovablesReportDocument, options);
}
export type CreateWebInspectionMovablesReportMutationHookResult = ReturnType<typeof useCreateWebInspectionMovablesReportMutation>;
export type CreateWebInspectionMovablesReportMutationResult = Apollo.MutationResult<CreateWebInspectionMovablesReportMutation>;
export type CreateWebInspectionMovablesReportMutationOptions = Apollo.BaseMutationOptions<CreateWebInspectionMovablesReportMutation, CreateWebInspectionMovablesReportMutationVariables>;
export const CreateWebInspectionReportDocument = gql`
    mutation CreateWebInspectionReport($caseId: String!, $formData: InspectionReportFormDataInput!, $onlySave: Boolean!) {
  createInspectionReport(
    caseId: $caseId
    formData: $formData
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateWebInspectionReportMutationFn = Apollo.MutationFunction<CreateWebInspectionReportMutation, CreateWebInspectionReportMutationVariables>;

/**
 * __useCreateWebInspectionReportMutation__
 *
 * To run a mutation, you first call `useCreateWebInspectionReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebInspectionReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebInspectionReportMutation, { data, loading, error }] = useCreateWebInspectionReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateWebInspectionReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebInspectionReportMutation, CreateWebInspectionReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateWebInspectionReportMutation, CreateWebInspectionReportMutationVariables>(CreateWebInspectionReportDocument, options);
}
export type CreateWebInspectionReportMutationHookResult = ReturnType<typeof useCreateWebInspectionReportMutation>;
export type CreateWebInspectionReportMutationResult = Apollo.MutationResult<CreateWebInspectionReportMutation>;
export type CreateWebInspectionReportMutationOptions = Apollo.BaseMutationOptions<CreateWebInspectionReportMutation, CreateWebInspectionReportMutationVariables>;
export const CreateWebMoistureReportDocument = gql`
    mutation CreateWebMoistureReport($caseId: String!, $formData: MoistureReportFormDataInput!, $reportFormat: ReportFormatType!, $floorsToInclude: [String!], $onlySave: Boolean!) {
  createMoistureReport(
    caseId: $caseId
    formData: $formData
    reportFormat: $reportFormat
    floorsToInclude: $floorsToInclude
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateWebMoistureReportMutationFn = Apollo.MutationFunction<CreateWebMoistureReportMutation, CreateWebMoistureReportMutationVariables>;

/**
 * __useCreateWebMoistureReportMutation__
 *
 * To run a mutation, you first call `useCreateWebMoistureReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebMoistureReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebMoistureReportMutation, { data, loading, error }] = useCreateWebMoistureReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      reportFormat: // value for 'reportFormat'
 *      floorsToInclude: // value for 'floorsToInclude'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateWebMoistureReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebMoistureReportMutation, CreateWebMoistureReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateWebMoistureReportMutation, CreateWebMoistureReportMutationVariables>(CreateWebMoistureReportDocument, options);
}
export type CreateWebMoistureReportMutationHookResult = ReturnType<typeof useCreateWebMoistureReportMutation>;
export type CreateWebMoistureReportMutationResult = Apollo.MutationResult<CreateWebMoistureReportMutation>;
export type CreateWebMoistureReportMutationOptions = Apollo.BaseMutationOptions<CreateWebMoistureReportMutation, CreateWebMoistureReportMutationVariables>;
export const CreateWebMoistureTrygReportDocument = gql`
    mutation CreateWebMoistureTrygReport($caseId: String!, $formData: MoistureTrygReportFormDataInput!, $reportFormat: ReportFormatType!, $floorsToInclude: [String!], $onlySave: Boolean!) {
  createMoistureTrygReport(
    caseId: $caseId
    formData: $formData
    reportFormat: $reportFormat
    floorsToInclude: $floorsToInclude
    onlySave: $onlySave
  ) {
    name
    fileId
  }
}
    `;
export type CreateWebMoistureTrygReportMutationFn = Apollo.MutationFunction<CreateWebMoistureTrygReportMutation, CreateWebMoistureTrygReportMutationVariables>;

/**
 * __useCreateWebMoistureTrygReportMutation__
 *
 * To run a mutation, you first call `useCreateWebMoistureTrygReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebMoistureTrygReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebMoistureTrygReportMutation, { data, loading, error }] = useCreateWebMoistureTrygReportMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      formData: // value for 'formData'
 *      reportFormat: // value for 'reportFormat'
 *      floorsToInclude: // value for 'floorsToInclude'
 *      onlySave: // value for 'onlySave'
 *   },
 * });
 */
export function useCreateWebMoistureTrygReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebMoistureTrygReportMutation, CreateWebMoistureTrygReportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateWebMoistureTrygReportMutation, CreateWebMoistureTrygReportMutationVariables>(CreateWebMoistureTrygReportDocument, options);
}
export type CreateWebMoistureTrygReportMutationHookResult = ReturnType<typeof useCreateWebMoistureTrygReportMutation>;
export type CreateWebMoistureTrygReportMutationResult = Apollo.MutationResult<CreateWebMoistureTrygReportMutation>;
export type CreateWebMoistureTrygReportMutationOptions = Apollo.BaseMutationOptions<CreateWebMoistureTrygReportMutation, CreateWebMoistureTrygReportMutationVariables>;
export const GetCaseAsbestosReportsAndDocumentsDocument = gql`
    query GetCaseAsbestosReportsAndDocuments($id: String!) {
  case(id: $id) {
    id
    erpNo
    documents {
      ...ESDHFileFragment
    }
    caseAsbestosReports {
      noticeOfConstructionWasteFormData {
        ...NoticeOfConstructionwasteFormDataFragment
      }
      inspectionAssesmentFormData {
        ...InspectionAssesmentFormDataFragment
      }
      caseOrganizationFormData {
        ...CaseOrganizationFormDataFragment
      }
      endevaluationReportFormData {
        ...EndevaluationFormDataFragment
      }
      deviationReportFormData {
        ...DeviationReportFormDataFragment
      }
    }
  }
}
    ${EsdhFileFragmentFragmentDoc}
${NoticeOfConstructionwasteFormDataFragmentFragmentDoc}
${InspectionAssesmentFormDataFragmentFragmentDoc}
${CaseOrganizationFormDataFragmentFragmentDoc}
${EndevaluationFormDataFragmentFragmentDoc}
${DeviationReportFormDataFragmentFragmentDoc}`;

/**
 * __useGetCaseAsbestosReportsAndDocumentsQuery__
 *
 * To run a query within a React component, call `useGetCaseAsbestosReportsAndDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseAsbestosReportsAndDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseAsbestosReportsAndDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseAsbestosReportsAndDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseAsbestosReportsAndDocumentsQuery, GetCaseAsbestosReportsAndDocumentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCaseAsbestosReportsAndDocumentsQuery, GetCaseAsbestosReportsAndDocumentsQueryVariables>(GetCaseAsbestosReportsAndDocumentsDocument, options);
}
export function useGetCaseAsbestosReportsAndDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseAsbestosReportsAndDocumentsQuery, GetCaseAsbestosReportsAndDocumentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCaseAsbestosReportsAndDocumentsQuery, GetCaseAsbestosReportsAndDocumentsQueryVariables>(GetCaseAsbestosReportsAndDocumentsDocument, options);
}
export function useGetCaseAsbestosReportsAndDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseAsbestosReportsAndDocumentsQuery, GetCaseAsbestosReportsAndDocumentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCaseAsbestosReportsAndDocumentsQuery, GetCaseAsbestosReportsAndDocumentsQueryVariables>(GetCaseAsbestosReportsAndDocumentsDocument, options);
}
export type GetCaseAsbestosReportsAndDocumentsQueryHookResult = ReturnType<typeof useGetCaseAsbestosReportsAndDocumentsQuery>;
export type GetCaseAsbestosReportsAndDocumentsLazyQueryHookResult = ReturnType<typeof useGetCaseAsbestosReportsAndDocumentsLazyQuery>;
export type GetCaseAsbestosReportsAndDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetCaseAsbestosReportsAndDocumentsSuspenseQuery>;
export type GetCaseAsbestosReportsAndDocumentsQueryResult = Apollo.QueryResult<GetCaseAsbestosReportsAndDocumentsQuery, GetCaseAsbestosReportsAndDocumentsQueryVariables>;
export function refetchGetCaseAsbestosReportsAndDocumentsQuery(variables: GetCaseAsbestosReportsAndDocumentsQueryVariables) {
  return { query: GetCaseAsbestosReportsAndDocumentsDocument, variables: variables }
}
export const CreateDrivingSlipRequisitionDocument = gql`
    mutation CreateDrivingSlipRequisition($drivingSlipId: String!, $requisition: RequisitionInput!, $shouldSendEmail: Boolean!) {
  createDrivingSlipRequisition(
    drivingSlipId: $drivingSlipId
    requisition: $requisition
    shouldSendEmail: $shouldSendEmail
  ) {
    ...RequisitionFragment
  }
}
    ${RequisitionFragmentFragmentDoc}`;
export type CreateDrivingSlipRequisitionMutationFn = Apollo.MutationFunction<CreateDrivingSlipRequisitionMutation, CreateDrivingSlipRequisitionMutationVariables>;

/**
 * __useCreateDrivingSlipRequisitionMutation__
 *
 * To run a mutation, you first call `useCreateDrivingSlipRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrivingSlipRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrivingSlipRequisitionMutation, { data, loading, error }] = useCreateDrivingSlipRequisitionMutation({
 *   variables: {
 *      drivingSlipId: // value for 'drivingSlipId'
 *      requisition: // value for 'requisition'
 *      shouldSendEmail: // value for 'shouldSendEmail'
 *   },
 * });
 */
export function useCreateDrivingSlipRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrivingSlipRequisitionMutation, CreateDrivingSlipRequisitionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDrivingSlipRequisitionMutation, CreateDrivingSlipRequisitionMutationVariables>(CreateDrivingSlipRequisitionDocument, options);
}
export type CreateDrivingSlipRequisitionMutationHookResult = ReturnType<typeof useCreateDrivingSlipRequisitionMutation>;
export type CreateDrivingSlipRequisitionMutationResult = Apollo.MutationResult<CreateDrivingSlipRequisitionMutation>;
export type CreateDrivingSlipRequisitionMutationOptions = Apollo.BaseMutationOptions<CreateDrivingSlipRequisitionMutation, CreateDrivingSlipRequisitionMutationVariables>;
export const GetWebRequisitionsDocument = gql`
    query GetWebRequisitions($myRequisitionsOnly: Boolean, $caseId: String, $departments: [String!], $vendor: String, $type: RequisitionType, $damageCategories: [String!], $damageCauses: [String!], $fromDate: Date, $toDate: Date, $offset: Int, $limit: Int, $searchString: String, $excludeTotalCount: Boolean) {
  requisitions(
    myRequisitionsOnly: $myRequisitionsOnly
    caseId: $caseId
    departments: $departments
    vendor: $vendor
    type: $type
    damageCategories: $damageCategories
    damageCauses: $damageCauses
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    limit: $limit
    searchString: $searchString
    excludeTotalCount: $excludeTotalCount
  ) {
    ...RequisitionFragment
  }
}
    ${RequisitionFragmentFragmentDoc}`;

/**
 * __useGetWebRequisitionsQuery__
 *
 * To run a query within a React component, call `useGetWebRequisitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebRequisitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebRequisitionsQuery({
 *   variables: {
 *      myRequisitionsOnly: // value for 'myRequisitionsOnly'
 *      caseId: // value for 'caseId'
 *      departments: // value for 'departments'
 *      vendor: // value for 'vendor'
 *      type: // value for 'type'
 *      damageCategories: // value for 'damageCategories'
 *      damageCauses: // value for 'damageCauses'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      excludeTotalCount: // value for 'excludeTotalCount'
 *   },
 * });
 */
export function useGetWebRequisitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebRequisitionsQuery, GetWebRequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebRequisitionsQuery, GetWebRequisitionsQueryVariables>(GetWebRequisitionsDocument, options);
}
export function useGetWebRequisitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebRequisitionsQuery, GetWebRequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebRequisitionsQuery, GetWebRequisitionsQueryVariables>(GetWebRequisitionsDocument, options);
}
export function useGetWebRequisitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebRequisitionsQuery, GetWebRequisitionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebRequisitionsQuery, GetWebRequisitionsQueryVariables>(GetWebRequisitionsDocument, options);
}
export type GetWebRequisitionsQueryHookResult = ReturnType<typeof useGetWebRequisitionsQuery>;
export type GetWebRequisitionsLazyQueryHookResult = ReturnType<typeof useGetWebRequisitionsLazyQuery>;
export type GetWebRequisitionsSuspenseQueryHookResult = ReturnType<typeof useGetWebRequisitionsSuspenseQuery>;
export type GetWebRequisitionsQueryResult = Apollo.QueryResult<GetWebRequisitionsQuery, GetWebRequisitionsQueryVariables>;
export function refetchGetWebRequisitionsQuery(variables?: GetWebRequisitionsQueryVariables) {
  return { query: GetWebRequisitionsDocument, variables: variables }
}
export const GetRiskEvalutaionAnswersDocument = gql`
    query GetRiskEvalutaionAnswers($id: String!) {
  case(id: $id) {
    id
    riskEvaluationAnswers {
      question {
        id
        question
      }
      answer
    }
  }
}
    `;

/**
 * __useGetRiskEvalutaionAnswersQuery__
 *
 * To run a query within a React component, call `useGetRiskEvalutaionAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskEvalutaionAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskEvalutaionAnswersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRiskEvalutaionAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetRiskEvalutaionAnswersQuery, GetRiskEvalutaionAnswersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRiskEvalutaionAnswersQuery, GetRiskEvalutaionAnswersQueryVariables>(GetRiskEvalutaionAnswersDocument, options);
}
export function useGetRiskEvalutaionAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskEvalutaionAnswersQuery, GetRiskEvalutaionAnswersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRiskEvalutaionAnswersQuery, GetRiskEvalutaionAnswersQueryVariables>(GetRiskEvalutaionAnswersDocument, options);
}
export function useGetRiskEvalutaionAnswersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRiskEvalutaionAnswersQuery, GetRiskEvalutaionAnswersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRiskEvalutaionAnswersQuery, GetRiskEvalutaionAnswersQueryVariables>(GetRiskEvalutaionAnswersDocument, options);
}
export type GetRiskEvalutaionAnswersQueryHookResult = ReturnType<typeof useGetRiskEvalutaionAnswersQuery>;
export type GetRiskEvalutaionAnswersLazyQueryHookResult = ReturnType<typeof useGetRiskEvalutaionAnswersLazyQuery>;
export type GetRiskEvalutaionAnswersSuspenseQueryHookResult = ReturnType<typeof useGetRiskEvalutaionAnswersSuspenseQuery>;
export type GetRiskEvalutaionAnswersQueryResult = Apollo.QueryResult<GetRiskEvalutaionAnswersQuery, GetRiskEvalutaionAnswersQueryVariables>;
export function refetchGetRiskEvalutaionAnswersQuery(variables: GetRiskEvalutaionAnswersQueryVariables) {
  return { query: GetRiskEvalutaionAnswersDocument, variables: variables }
}
export const CreateScreeningDocument = gql`
    mutation CreateScreening($caseId: String!, $template: String!, $name: String!, $lines: [ScreeningLineInputType!]!, $wipAmount: Decimal!) {
  createScreening(
    caseId: $caseId
    template: $template
    name: $name
    lines: $lines
    wipAmount: $wipAmount
  ) {
    _
  }
}
    `;
export type CreateScreeningMutationFn = Apollo.MutationFunction<CreateScreeningMutation, CreateScreeningMutationVariables>;

/**
 * __useCreateScreeningMutation__
 *
 * To run a mutation, you first call `useCreateScreeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScreeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScreeningMutation, { data, loading, error }] = useCreateScreeningMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      template: // value for 'template'
 *      name: // value for 'name'
 *      lines: // value for 'lines'
 *      wipAmount: // value for 'wipAmount'
 *   },
 * });
 */
export function useCreateScreeningMutation(baseOptions?: Apollo.MutationHookOptions<CreateScreeningMutation, CreateScreeningMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateScreeningMutation, CreateScreeningMutationVariables>(CreateScreeningDocument, options);
}
export type CreateScreeningMutationHookResult = ReturnType<typeof useCreateScreeningMutation>;
export type CreateScreeningMutationResult = Apollo.MutationResult<CreateScreeningMutation>;
export type CreateScreeningMutationOptions = Apollo.BaseMutationOptions<CreateScreeningMutation, CreateScreeningMutationVariables>;
export const DeleteScreeningDocument = gql`
    mutation DeleteScreening($caseId: String!, $screeningERPReferenceNo: String!, $wipAmount: Decimal!) {
  deleteScreening(
    caseId: $caseId
    screeningERPReferenceNo: $screeningERPReferenceNo
    wipAmount: $wipAmount
  ) {
    _
  }
}
    `;
export type DeleteScreeningMutationFn = Apollo.MutationFunction<DeleteScreeningMutation, DeleteScreeningMutationVariables>;

/**
 * __useDeleteScreeningMutation__
 *
 * To run a mutation, you first call `useDeleteScreeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScreeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScreeningMutation, { data, loading, error }] = useDeleteScreeningMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      screeningERPReferenceNo: // value for 'screeningERPReferenceNo'
 *      wipAmount: // value for 'wipAmount'
 *   },
 * });
 */
export function useDeleteScreeningMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScreeningMutation, DeleteScreeningMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteScreeningMutation, DeleteScreeningMutationVariables>(DeleteScreeningDocument, options);
}
export type DeleteScreeningMutationHookResult = ReturnType<typeof useDeleteScreeningMutation>;
export type DeleteScreeningMutationResult = Apollo.MutationResult<DeleteScreeningMutation>;
export type DeleteScreeningMutationOptions = Apollo.BaseMutationOptions<DeleteScreeningMutation, DeleteScreeningMutationVariables>;
export const GetScreeningsDocument = gql`
    query GetScreenings($id: String!) {
  case(id: $id) {
    id
    createdAt
    caseDefaultScreeningTemplate
    screenings {
      erpReferenceId
      erpReferenceNo
      templateId
      templateCode
      templateName
      description
      lines {
        erpReferenceId
        id
        parentId
        position
        type
        index
        title
        allowCustomTitle
        showCalendar
        uom
        price
        linePremiumPercentage
        linePremiumFixedAmount
        linePremiumId
        value
        customTitle
        movableVolume
        movableDays
        movableDateFrom
        movableDateTo
        excludeFromEnvFee
        excludeFromSupplyFee
      }
      markedForInvoice
      reopenAllowed
    }
  }
}
    `;

/**
 * __useGetScreeningsQuery__
 *
 * To run a query within a React component, call `useGetScreeningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreeningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreeningsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScreeningsQuery(baseOptions: Apollo.QueryHookOptions<GetScreeningsQuery, GetScreeningsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetScreeningsQuery, GetScreeningsQueryVariables>(GetScreeningsDocument, options);
}
export function useGetScreeningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScreeningsQuery, GetScreeningsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetScreeningsQuery, GetScreeningsQueryVariables>(GetScreeningsDocument, options);
}
export function useGetScreeningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScreeningsQuery, GetScreeningsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetScreeningsQuery, GetScreeningsQueryVariables>(GetScreeningsDocument, options);
}
export type GetScreeningsQueryHookResult = ReturnType<typeof useGetScreeningsQuery>;
export type GetScreeningsLazyQueryHookResult = ReturnType<typeof useGetScreeningsLazyQuery>;
export type GetScreeningsSuspenseQueryHookResult = ReturnType<typeof useGetScreeningsSuspenseQuery>;
export type GetScreeningsQueryResult = Apollo.QueryResult<GetScreeningsQuery, GetScreeningsQueryVariables>;
export function refetchGetScreeningsQuery(variables: GetScreeningsQueryVariables) {
  return { query: GetScreeningsDocument, variables: variables }
}
export const GetWebScreeningPositionTextsDocument = gql`
    query GetWebScreeningPositionTexts($positions: [String!]!) {
  screeningPositionTexts(positions: $positions) {
    id
    position
    text
  }
}
    `;

/**
 * __useGetWebScreeningPositionTextsQuery__
 *
 * To run a query within a React component, call `useGetWebScreeningPositionTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebScreeningPositionTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebScreeningPositionTextsQuery({
 *   variables: {
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useGetWebScreeningPositionTextsQuery(baseOptions: Apollo.QueryHookOptions<GetWebScreeningPositionTextsQuery, GetWebScreeningPositionTextsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebScreeningPositionTextsQuery, GetWebScreeningPositionTextsQueryVariables>(GetWebScreeningPositionTextsDocument, options);
}
export function useGetWebScreeningPositionTextsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebScreeningPositionTextsQuery, GetWebScreeningPositionTextsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebScreeningPositionTextsQuery, GetWebScreeningPositionTextsQueryVariables>(GetWebScreeningPositionTextsDocument, options);
}
export function useGetWebScreeningPositionTextsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebScreeningPositionTextsQuery, GetWebScreeningPositionTextsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebScreeningPositionTextsQuery, GetWebScreeningPositionTextsQueryVariables>(GetWebScreeningPositionTextsDocument, options);
}
export type GetWebScreeningPositionTextsQueryHookResult = ReturnType<typeof useGetWebScreeningPositionTextsQuery>;
export type GetWebScreeningPositionTextsLazyQueryHookResult = ReturnType<typeof useGetWebScreeningPositionTextsLazyQuery>;
export type GetWebScreeningPositionTextsSuspenseQueryHookResult = ReturnType<typeof useGetWebScreeningPositionTextsSuspenseQuery>;
export type GetWebScreeningPositionTextsQueryResult = Apollo.QueryResult<GetWebScreeningPositionTextsQuery, GetWebScreeningPositionTextsQueryVariables>;
export function refetchGetWebScreeningPositionTextsQuery(variables: GetWebScreeningPositionTextsQueryVariables) {
  return { query: GetWebScreeningPositionTextsDocument, variables: variables }
}
export const GetWebScreeningTemplatesDocument = gql`
    query GetWebScreeningTemplates {
  screeningTemplates {
    erpReferenceId
    templateCode
    templateName
    lines {
      erpReferenceId
      id
      parentId
      position
      erpReferenceTask
      erpReferenceAccount
      required
      type
      index
      title
      allowCustomTitle
      uom
      price
      linePremiumPercentage
      linePremiumFixedAmount
      linePremiumId
      showCalendar
      excludeFromEnvFee
      excludeFromSupplyFee
    }
  }
}
    `;

/**
 * __useGetWebScreeningTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWebScreeningTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebScreeningTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebScreeningTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebScreeningTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetWebScreeningTemplatesQuery, GetWebScreeningTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebScreeningTemplatesQuery, GetWebScreeningTemplatesQueryVariables>(GetWebScreeningTemplatesDocument, options);
}
export function useGetWebScreeningTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebScreeningTemplatesQuery, GetWebScreeningTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebScreeningTemplatesQuery, GetWebScreeningTemplatesQueryVariables>(GetWebScreeningTemplatesDocument, options);
}
export function useGetWebScreeningTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebScreeningTemplatesQuery, GetWebScreeningTemplatesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebScreeningTemplatesQuery, GetWebScreeningTemplatesQueryVariables>(GetWebScreeningTemplatesDocument, options);
}
export type GetWebScreeningTemplatesQueryHookResult = ReturnType<typeof useGetWebScreeningTemplatesQuery>;
export type GetWebScreeningTemplatesLazyQueryHookResult = ReturnType<typeof useGetWebScreeningTemplatesLazyQuery>;
export type GetWebScreeningTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetWebScreeningTemplatesSuspenseQuery>;
export type GetWebScreeningTemplatesQueryResult = Apollo.QueryResult<GetWebScreeningTemplatesQuery, GetWebScreeningTemplatesQueryVariables>;
export function refetchGetWebScreeningTemplatesQuery(variables?: GetWebScreeningTemplatesQueryVariables) {
  return { query: GetWebScreeningTemplatesDocument, variables: variables }
}
export const UnlockScreeningDocument = gql`
    mutation UnlockScreening($caseId: String!, $screeningERPReferenceNo: String!) {
  unlockScreening(
    caseId: $caseId
    screeningERPReferenceNo: $screeningERPReferenceNo
  ) {
    _
  }
}
    `;
export type UnlockScreeningMutationFn = Apollo.MutationFunction<UnlockScreeningMutation, UnlockScreeningMutationVariables>;

/**
 * __useUnlockScreeningMutation__
 *
 * To run a mutation, you first call `useUnlockScreeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockScreeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockScreeningMutation, { data, loading, error }] = useUnlockScreeningMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      screeningERPReferenceNo: // value for 'screeningERPReferenceNo'
 *   },
 * });
 */
export function useUnlockScreeningMutation(baseOptions?: Apollo.MutationHookOptions<UnlockScreeningMutation, UnlockScreeningMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UnlockScreeningMutation, UnlockScreeningMutationVariables>(UnlockScreeningDocument, options);
}
export type UnlockScreeningMutationHookResult = ReturnType<typeof useUnlockScreeningMutation>;
export type UnlockScreeningMutationResult = Apollo.MutationResult<UnlockScreeningMutation>;
export type UnlockScreeningMutationOptions = Apollo.BaseMutationOptions<UnlockScreeningMutation, UnlockScreeningMutationVariables>;
export const UpdateScreeningDocument = gql`
    mutation UpdateScreening($caseId: String!, $screeningERPReferenceNo: String!, $name: String!, $lines: [ScreeningLineInputType!]!, $wipAmount: Decimal!) {
  updateScreening(
    caseId: $caseId
    screeningERPReferenceNo: $screeningERPReferenceNo
    name: $name
    lines: $lines
    wipAmount: $wipAmount
  ) {
    _
  }
}
    `;
export type UpdateScreeningMutationFn = Apollo.MutationFunction<UpdateScreeningMutation, UpdateScreeningMutationVariables>;

/**
 * __useUpdateScreeningMutation__
 *
 * To run a mutation, you first call `useUpdateScreeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreeningMutation, { data, loading, error }] = useUpdateScreeningMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      screeningERPReferenceNo: // value for 'screeningERPReferenceNo'
 *      name: // value for 'name'
 *      lines: // value for 'lines'
 *      wipAmount: // value for 'wipAmount'
 *   },
 * });
 */
export function useUpdateScreeningMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScreeningMutation, UpdateScreeningMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScreeningMutation, UpdateScreeningMutationVariables>(UpdateScreeningDocument, options);
}
export type UpdateScreeningMutationHookResult = ReturnType<typeof useUpdateScreeningMutation>;
export type UpdateScreeningMutationResult = Apollo.MutationResult<UpdateScreeningMutation>;
export type UpdateScreeningMutationOptions = Apollo.BaseMutationOptions<UpdateScreeningMutation, UpdateScreeningMutationVariables>;
export const GetAdminSettingsDocument = gql`
    query GetAdminSettings($type: String!) {
  setting(type: $type) {
    ... on DrivingSlipCategoryMappingSettings {
      id
      type
      drivingSlipCategoryMappings {
        drivingSlipCategory
        damageCategoryId
        damageCauseId
      }
    }
    ... on InvoiceSettings {
      id
      minHourlyRate
    }
  }
}
    `;

/**
 * __useGetAdminSettingsQuery__
 *
 * To run a query within a React component, call `useGetAdminSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminSettingsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAdminSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminSettingsQuery, GetAdminSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdminSettingsQuery, GetAdminSettingsQueryVariables>(GetAdminSettingsDocument, options);
}
export function useGetAdminSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminSettingsQuery, GetAdminSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdminSettingsQuery, GetAdminSettingsQueryVariables>(GetAdminSettingsDocument, options);
}
export function useGetAdminSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminSettingsQuery, GetAdminSettingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAdminSettingsQuery, GetAdminSettingsQueryVariables>(GetAdminSettingsDocument, options);
}
export type GetAdminSettingsQueryHookResult = ReturnType<typeof useGetAdminSettingsQuery>;
export type GetAdminSettingsLazyQueryHookResult = ReturnType<typeof useGetAdminSettingsLazyQuery>;
export type GetAdminSettingsSuspenseQueryHookResult = ReturnType<typeof useGetAdminSettingsSuspenseQuery>;
export type GetAdminSettingsQueryResult = Apollo.QueryResult<GetAdminSettingsQuery, GetAdminSettingsQueryVariables>;
export function refetchGetAdminSettingsQuery(variables: GetAdminSettingsQueryVariables) {
  return { query: GetAdminSettingsDocument, variables: variables }
}
export const GetManagerClosedDayUserListDocument = gql`
    query GetManagerClosedDayUserList {
  closedDayManagerList {
    user {
      id
      name
      email
      phone
    }
    date
  }
}
    `;

/**
 * __useGetManagerClosedDayUserListQuery__
 *
 * To run a query within a React component, call `useGetManagerClosedDayUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerClosedDayUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerClosedDayUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagerClosedDayUserListQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerClosedDayUserListQuery, GetManagerClosedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetManagerClosedDayUserListQuery, GetManagerClosedDayUserListQueryVariables>(GetManagerClosedDayUserListDocument, options);
}
export function useGetManagerClosedDayUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerClosedDayUserListQuery, GetManagerClosedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetManagerClosedDayUserListQuery, GetManagerClosedDayUserListQueryVariables>(GetManagerClosedDayUserListDocument, options);
}
export function useGetManagerClosedDayUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagerClosedDayUserListQuery, GetManagerClosedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetManagerClosedDayUserListQuery, GetManagerClosedDayUserListQueryVariables>(GetManagerClosedDayUserListDocument, options);
}
export type GetManagerClosedDayUserListQueryHookResult = ReturnType<typeof useGetManagerClosedDayUserListQuery>;
export type GetManagerClosedDayUserListLazyQueryHookResult = ReturnType<typeof useGetManagerClosedDayUserListLazyQuery>;
export type GetManagerClosedDayUserListSuspenseQueryHookResult = ReturnType<typeof useGetManagerClosedDayUserListSuspenseQuery>;
export type GetManagerClosedDayUserListQueryResult = Apollo.QueryResult<GetManagerClosedDayUserListQuery, GetManagerClosedDayUserListQueryVariables>;
export function refetchGetManagerClosedDayUserListQuery(variables?: GetManagerClosedDayUserListQueryVariables) {
  return { query: GetManagerClosedDayUserListDocument, variables: variables }
}
export const GetManagerFlexTimeListDocument = gql`
    query GetManagerFlexTimeList {
  flexTimeManagerList {
    user {
      id
      name
      email
      phone
    }
    flexTime
  }
}
    `;

/**
 * __useGetManagerFlexTimeListQuery__
 *
 * To run a query within a React component, call `useGetManagerFlexTimeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerFlexTimeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerFlexTimeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagerFlexTimeListQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerFlexTimeListQuery, GetManagerFlexTimeListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetManagerFlexTimeListQuery, GetManagerFlexTimeListQueryVariables>(GetManagerFlexTimeListDocument, options);
}
export function useGetManagerFlexTimeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerFlexTimeListQuery, GetManagerFlexTimeListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetManagerFlexTimeListQuery, GetManagerFlexTimeListQueryVariables>(GetManagerFlexTimeListDocument, options);
}
export function useGetManagerFlexTimeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagerFlexTimeListQuery, GetManagerFlexTimeListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetManagerFlexTimeListQuery, GetManagerFlexTimeListQueryVariables>(GetManagerFlexTimeListDocument, options);
}
export type GetManagerFlexTimeListQueryHookResult = ReturnType<typeof useGetManagerFlexTimeListQuery>;
export type GetManagerFlexTimeListLazyQueryHookResult = ReturnType<typeof useGetManagerFlexTimeListLazyQuery>;
export type GetManagerFlexTimeListSuspenseQueryHookResult = ReturnType<typeof useGetManagerFlexTimeListSuspenseQuery>;
export type GetManagerFlexTimeListQueryResult = Apollo.QueryResult<GetManagerFlexTimeListQuery, GetManagerFlexTimeListQueryVariables>;
export function refetchGetManagerFlexTimeListQuery(variables?: GetManagerFlexTimeListQueryVariables) {
  return { query: GetManagerFlexTimeListDocument, variables: variables }
}
export const GetWebCasesForTimeTrackingDocument = gql`
    query GetWebCasesForTimeTracking($erpReferenceNos: [String!], $appliedClosed: Boolean, $closedCases: Boolean, $includeEconomy: Boolean!) {
  cases(
    erpReferenceNos: $erpReferenceNos
    appliedClosed: $appliedClosed
    closedCases: $closedCases
  ) {
    id
    erpNo
    track
    timeRegistration
    debitor {
      ...BaseDebitorFragment
    }
    damage {
      ...DamageFragment
    }
    caseEconomics(include: $includeEconomy) {
      jobNo
      costTotal
      salesTotal
      invoicedTotal
      quote
      screening
      profit
      deltaNotInvoiced
      coverageRatio
    }
  }
}
    ${BaseDebitorFragmentFragmentDoc}
${DamageFragmentFragmentDoc}`;

/**
 * __useGetWebCasesForTimeTrackingQuery__
 *
 * To run a query within a React component, call `useGetWebCasesForTimeTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCasesForTimeTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCasesForTimeTrackingQuery({
 *   variables: {
 *      erpReferenceNos: // value for 'erpReferenceNos'
 *      appliedClosed: // value for 'appliedClosed'
 *      closedCases: // value for 'closedCases'
 *      includeEconomy: // value for 'includeEconomy'
 *   },
 * });
 */
export function useGetWebCasesForTimeTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetWebCasesForTimeTrackingQuery, GetWebCasesForTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCasesForTimeTrackingQuery, GetWebCasesForTimeTrackingQueryVariables>(GetWebCasesForTimeTrackingDocument, options);
}
export function useGetWebCasesForTimeTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCasesForTimeTrackingQuery, GetWebCasesForTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCasesForTimeTrackingQuery, GetWebCasesForTimeTrackingQueryVariables>(GetWebCasesForTimeTrackingDocument, options);
}
export function useGetWebCasesForTimeTrackingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCasesForTimeTrackingQuery, GetWebCasesForTimeTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCasesForTimeTrackingQuery, GetWebCasesForTimeTrackingQueryVariables>(GetWebCasesForTimeTrackingDocument, options);
}
export type GetWebCasesForTimeTrackingQueryHookResult = ReturnType<typeof useGetWebCasesForTimeTrackingQuery>;
export type GetWebCasesForTimeTrackingLazyQueryHookResult = ReturnType<typeof useGetWebCasesForTimeTrackingLazyQuery>;
export type GetWebCasesForTimeTrackingSuspenseQueryHookResult = ReturnType<typeof useGetWebCasesForTimeTrackingSuspenseQuery>;
export type GetWebCasesForTimeTrackingQueryResult = Apollo.QueryResult<GetWebCasesForTimeTrackingQuery, GetWebCasesForTimeTrackingQueryVariables>;
export function refetchGetWebCasesForTimeTrackingQuery(variables: GetWebCasesForTimeTrackingQueryVariables) {
  return { query: GetWebCasesForTimeTrackingDocument, variables: variables }
}
export const OpenRejectedDayDocument = gql`
    mutation OpenRejectedDay($userEmail: String!, $date: Date!) {
  openRejectedDay(userEmail: $userEmail, date: $date) {
    ...BaseTimeTrackingFragment
  }
}
    ${BaseTimeTrackingFragmentFragmentDoc}`;
export type OpenRejectedDayMutationFn = Apollo.MutationFunction<OpenRejectedDayMutation, OpenRejectedDayMutationVariables>;

/**
 * __useOpenRejectedDayMutation__
 *
 * To run a mutation, you first call `useOpenRejectedDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenRejectedDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openRejectedDayMutation, { data, loading, error }] = useOpenRejectedDayMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOpenRejectedDayMutation(baseOptions?: Apollo.MutationHookOptions<OpenRejectedDayMutation, OpenRejectedDayMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OpenRejectedDayMutation, OpenRejectedDayMutationVariables>(OpenRejectedDayDocument, options);
}
export type OpenRejectedDayMutationHookResult = ReturnType<typeof useOpenRejectedDayMutation>;
export type OpenRejectedDayMutationResult = Apollo.MutationResult<OpenRejectedDayMutation>;
export type OpenRejectedDayMutationOptions = Apollo.BaseMutationOptions<OpenRejectedDayMutation, OpenRejectedDayMutationVariables>;
export const OpenTimeRegistrationsOnCaseDocument = gql`
    query OpenTimeRegistrationsOnCase($caseERPReferenceNo: String!) {
  openTimeRegistrationsOnCase(caseERPReferenceNo: $caseERPReferenceNo)
}
    `;

/**
 * __useOpenTimeRegistrationsOnCaseQuery__
 *
 * To run a query within a React component, call `useOpenTimeRegistrationsOnCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenTimeRegistrationsOnCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenTimeRegistrationsOnCaseQuery({
 *   variables: {
 *      caseERPReferenceNo: // value for 'caseERPReferenceNo'
 *   },
 * });
 */
export function useOpenTimeRegistrationsOnCaseQuery(baseOptions: Apollo.QueryHookOptions<OpenTimeRegistrationsOnCaseQuery, OpenTimeRegistrationsOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OpenTimeRegistrationsOnCaseQuery, OpenTimeRegistrationsOnCaseQueryVariables>(OpenTimeRegistrationsOnCaseDocument, options);
}
export function useOpenTimeRegistrationsOnCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenTimeRegistrationsOnCaseQuery, OpenTimeRegistrationsOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OpenTimeRegistrationsOnCaseQuery, OpenTimeRegistrationsOnCaseQueryVariables>(OpenTimeRegistrationsOnCaseDocument, options);
}
export function useOpenTimeRegistrationsOnCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpenTimeRegistrationsOnCaseQuery, OpenTimeRegistrationsOnCaseQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<OpenTimeRegistrationsOnCaseQuery, OpenTimeRegistrationsOnCaseQueryVariables>(OpenTimeRegistrationsOnCaseDocument, options);
}
export type OpenTimeRegistrationsOnCaseQueryHookResult = ReturnType<typeof useOpenTimeRegistrationsOnCaseQuery>;
export type OpenTimeRegistrationsOnCaseLazyQueryHookResult = ReturnType<typeof useOpenTimeRegistrationsOnCaseLazyQuery>;
export type OpenTimeRegistrationsOnCaseSuspenseQueryHookResult = ReturnType<typeof useOpenTimeRegistrationsOnCaseSuspenseQuery>;
export type OpenTimeRegistrationsOnCaseQueryResult = Apollo.QueryResult<OpenTimeRegistrationsOnCaseQuery, OpenTimeRegistrationsOnCaseQueryVariables>;
export function refetchOpenTimeRegistrationsOnCaseQuery(variables: OpenTimeRegistrationsOnCaseQueryVariables) {
  return { query: OpenTimeRegistrationsOnCaseDocument, variables: variables }
}
export const AppendTimeTrackingSupplementDocument = gql`
    mutation AppendTimeTrackingSupplement($timeTrackingDayId: String!, $timeTrackingEntryId: String!, $timeTrackingSupplement: TimeTrackingSupplementUpdateInputType!) {
  appendTimeTrackingSupplement(
    timeTrackingDayId: $timeTrackingDayId
    timeTrackingEntryId: $timeTrackingEntryId
    timeTrackingSupplement: $timeTrackingSupplement
  ) {
    ...TimeTrackingDay
  }
}
    ${TimeTrackingDayFragmentDoc}`;
export type AppendTimeTrackingSupplementMutationFn = Apollo.MutationFunction<AppendTimeTrackingSupplementMutation, AppendTimeTrackingSupplementMutationVariables>;

/**
 * __useAppendTimeTrackingSupplementMutation__
 *
 * To run a mutation, you first call `useAppendTimeTrackingSupplementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendTimeTrackingSupplementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendTimeTrackingSupplementMutation, { data, loading, error }] = useAppendTimeTrackingSupplementMutation({
 *   variables: {
 *      timeTrackingDayId: // value for 'timeTrackingDayId'
 *      timeTrackingEntryId: // value for 'timeTrackingEntryId'
 *      timeTrackingSupplement: // value for 'timeTrackingSupplement'
 *   },
 * });
 */
export function useAppendTimeTrackingSupplementMutation(baseOptions?: Apollo.MutationHookOptions<AppendTimeTrackingSupplementMutation, AppendTimeTrackingSupplementMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AppendTimeTrackingSupplementMutation, AppendTimeTrackingSupplementMutationVariables>(AppendTimeTrackingSupplementDocument, options);
}
export type AppendTimeTrackingSupplementMutationHookResult = ReturnType<typeof useAppendTimeTrackingSupplementMutation>;
export type AppendTimeTrackingSupplementMutationResult = Apollo.MutationResult<AppendTimeTrackingSupplementMutation>;
export type AppendTimeTrackingSupplementMutationOptions = Apollo.BaseMutationOptions<AppendTimeTrackingSupplementMutation, AppendTimeTrackingSupplementMutationVariables>;
export const CreateTimeTrackingDayDocument = gql`
    mutation CreateTimeTrackingDay($timeTrackingDay: TimeTrackingDayInputType!, $timeTrackingEntry: TimeTrackingEntryInputType!) {
  createTimeTrackingDay(
    timeTrackingDay: $timeTrackingDay
    timeTrackingEntry: $timeTrackingEntry
  ) {
    id
    createdAt
    timeTrackingDayStatus
    user {
      id
      name
      employeeId
    }
    userId
    date
    totalHours
    overtimeHours
    isPartOfRange
    rangeStartDate
    rangeEndDate
    timeTrackingEntries {
      id
      createdAt
      user {
        id
        name
      }
      userId
      startDate
      endDate
      startTime
      endTime
      hours
      case {
        id
        erpId
        erpNo
        debitor {
          id
          company
        }
        damage {
          category {
            id
            name
          }
          cause {
            id
            name
          }
          contact {
            address {
              road
              houseNumber
              postalCode
              city
            }
          }
        }
      }
      drivingSlip {
        id
      }
      jobNo
      remark
      jobTaskNo
      onCall
      onCallback
      includesLunch
      task
      jobTaskName
      workTypeCode
      timeTrackingStatus
      bcStatus
      rejectMessage
      pieceworkAmount
      supplementType
      paymentSupplementCode
      paymentSupplementName
      supplementUom
      lastModifiedAt
      lastModifiedBy {
        id
        name
      }
      addonLines {
        ...BaseSupplement
      }
    }
  }
}
    ${BaseSupplementFragmentDoc}`;
export type CreateTimeTrackingDayMutationFn = Apollo.MutationFunction<CreateTimeTrackingDayMutation, CreateTimeTrackingDayMutationVariables>;

/**
 * __useCreateTimeTrackingDayMutation__
 *
 * To run a mutation, you first call `useCreateTimeTrackingDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeTrackingDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeTrackingDayMutation, { data, loading, error }] = useCreateTimeTrackingDayMutation({
 *   variables: {
 *      timeTrackingDay: // value for 'timeTrackingDay'
 *      timeTrackingEntry: // value for 'timeTrackingEntry'
 *   },
 * });
 */
export function useCreateTimeTrackingDayMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeTrackingDayMutation, CreateTimeTrackingDayMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTimeTrackingDayMutation, CreateTimeTrackingDayMutationVariables>(CreateTimeTrackingDayDocument, options);
}
export type CreateTimeTrackingDayMutationHookResult = ReturnType<typeof useCreateTimeTrackingDayMutation>;
export type CreateTimeTrackingDayMutationResult = Apollo.MutationResult<CreateTimeTrackingDayMutation>;
export type CreateTimeTrackingDayMutationOptions = Apollo.BaseMutationOptions<CreateTimeTrackingDayMutation, CreateTimeTrackingDayMutationVariables>;
export const DeleteTimeTrackingDayDocument = gql`
    mutation DeleteTimeTrackingDay($dayId: String!) {
  deleteTimeTrackingDay(dayId: $dayId)
}
    `;
export type DeleteTimeTrackingDayMutationFn = Apollo.MutationFunction<DeleteTimeTrackingDayMutation, DeleteTimeTrackingDayMutationVariables>;

/**
 * __useDeleteTimeTrackingDayMutation__
 *
 * To run a mutation, you first call `useDeleteTimeTrackingDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeTrackingDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeTrackingDayMutation, { data, loading, error }] = useDeleteTimeTrackingDayMutation({
 *   variables: {
 *      dayId: // value for 'dayId'
 *   },
 * });
 */
export function useDeleteTimeTrackingDayMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeTrackingDayMutation, DeleteTimeTrackingDayMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTimeTrackingDayMutation, DeleteTimeTrackingDayMutationVariables>(DeleteTimeTrackingDayDocument, options);
}
export type DeleteTimeTrackingDayMutationHookResult = ReturnType<typeof useDeleteTimeTrackingDayMutation>;
export type DeleteTimeTrackingDayMutationResult = Apollo.MutationResult<DeleteTimeTrackingDayMutation>;
export type DeleteTimeTrackingDayMutationOptions = Apollo.BaseMutationOptions<DeleteTimeTrackingDayMutation, DeleteTimeTrackingDayMutationVariables>;
export const DeleteTimeTrackingDayEntryDocument = gql`
    mutation DeleteTimeTrackingDayEntry($dayId: String!, $entryId: String!) {
  deleteTimeTrackingDayEntry(dayId: $dayId, entryId: $entryId) {
    ...TimeTrackingDay
  }
}
    ${TimeTrackingDayFragmentDoc}`;
export type DeleteTimeTrackingDayEntryMutationFn = Apollo.MutationFunction<DeleteTimeTrackingDayEntryMutation, DeleteTimeTrackingDayEntryMutationVariables>;

/**
 * __useDeleteTimeTrackingDayEntryMutation__
 *
 * To run a mutation, you first call `useDeleteTimeTrackingDayEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeTrackingDayEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeTrackingDayEntryMutation, { data, loading, error }] = useDeleteTimeTrackingDayEntryMutation({
 *   variables: {
 *      dayId: // value for 'dayId'
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useDeleteTimeTrackingDayEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeTrackingDayEntryMutation, DeleteTimeTrackingDayEntryMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTimeTrackingDayEntryMutation, DeleteTimeTrackingDayEntryMutationVariables>(DeleteTimeTrackingDayEntryDocument, options);
}
export type DeleteTimeTrackingDayEntryMutationHookResult = ReturnType<typeof useDeleteTimeTrackingDayEntryMutation>;
export type DeleteTimeTrackingDayEntryMutationResult = Apollo.MutationResult<DeleteTimeTrackingDayEntryMutation>;
export type DeleteTimeTrackingDayEntryMutationOptions = Apollo.BaseMutationOptions<DeleteTimeTrackingDayEntryMutation, DeleteTimeTrackingDayEntryMutationVariables>;
export const DeleteTimeTrackingEntrySupplementDocument = gql`
    mutation DeleteTimeTrackingEntrySupplement($dayId: String!, $entryId: String!, $supplementId: String!) {
  deleteTimeTrackingEntrySupplement(
    dayId: $dayId
    entryId: $entryId
    supplementId: $supplementId
  ) {
    ...TimeTrackingDay
  }
}
    ${TimeTrackingDayFragmentDoc}`;
export type DeleteTimeTrackingEntrySupplementMutationFn = Apollo.MutationFunction<DeleteTimeTrackingEntrySupplementMutation, DeleteTimeTrackingEntrySupplementMutationVariables>;

/**
 * __useDeleteTimeTrackingEntrySupplementMutation__
 *
 * To run a mutation, you first call `useDeleteTimeTrackingEntrySupplementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeTrackingEntrySupplementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeTrackingEntrySupplementMutation, { data, loading, error }] = useDeleteTimeTrackingEntrySupplementMutation({
 *   variables: {
 *      dayId: // value for 'dayId'
 *      entryId: // value for 'entryId'
 *      supplementId: // value for 'supplementId'
 *   },
 * });
 */
export function useDeleteTimeTrackingEntrySupplementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeTrackingEntrySupplementMutation, DeleteTimeTrackingEntrySupplementMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTimeTrackingEntrySupplementMutation, DeleteTimeTrackingEntrySupplementMutationVariables>(DeleteTimeTrackingEntrySupplementDocument, options);
}
export type DeleteTimeTrackingEntrySupplementMutationHookResult = ReturnType<typeof useDeleteTimeTrackingEntrySupplementMutation>;
export type DeleteTimeTrackingEntrySupplementMutationResult = Apollo.MutationResult<DeleteTimeTrackingEntrySupplementMutation>;
export type DeleteTimeTrackingEntrySupplementMutationOptions = Apollo.BaseMutationOptions<DeleteTimeTrackingEntrySupplementMutation, DeleteTimeTrackingEntrySupplementMutationVariables>;
export const GetTimeTrackingDayLatestByUserDocument = gql`
    query GetTimeTrackingDayLatestByUser($user: String!) {
  timeTrackingDayLatestByUser(user: $user) {
    id
    timeTrackingDayStatus
    date
  }
}
    `;

/**
 * __useGetTimeTrackingDayLatestByUserQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingDayLatestByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingDayLatestByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingDayLatestByUserQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetTimeTrackingDayLatestByUserQuery(baseOptions: Apollo.QueryHookOptions<GetTimeTrackingDayLatestByUserQuery, GetTimeTrackingDayLatestByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingDayLatestByUserQuery, GetTimeTrackingDayLatestByUserQueryVariables>(GetTimeTrackingDayLatestByUserDocument, options);
}
export function useGetTimeTrackingDayLatestByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingDayLatestByUserQuery, GetTimeTrackingDayLatestByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingDayLatestByUserQuery, GetTimeTrackingDayLatestByUserQueryVariables>(GetTimeTrackingDayLatestByUserDocument, options);
}
export function useGetTimeTrackingDayLatestByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingDayLatestByUserQuery, GetTimeTrackingDayLatestByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingDayLatestByUserQuery, GetTimeTrackingDayLatestByUserQueryVariables>(GetTimeTrackingDayLatestByUserDocument, options);
}
export type GetTimeTrackingDayLatestByUserQueryHookResult = ReturnType<typeof useGetTimeTrackingDayLatestByUserQuery>;
export type GetTimeTrackingDayLatestByUserLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingDayLatestByUserLazyQuery>;
export type GetTimeTrackingDayLatestByUserSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingDayLatestByUserSuspenseQuery>;
export type GetTimeTrackingDayLatestByUserQueryResult = Apollo.QueryResult<GetTimeTrackingDayLatestByUserQuery, GetTimeTrackingDayLatestByUserQueryVariables>;
export function refetchGetTimeTrackingDayLatestByUserQuery(variables: GetTimeTrackingDayLatestByUserQueryVariables) {
  return { query: GetTimeTrackingDayLatestByUserDocument, variables: variables }
}
export const GetManagerTimeTrackingClosedDayUserListDocument = gql`
    query GetManagerTimeTrackingClosedDayUserList {
  timeTrackingClosedDayManagerList {
    user {
      id
      name
      email
      phone
    }
    date
  }
}
    `;

/**
 * __useGetManagerTimeTrackingClosedDayUserListQuery__
 *
 * To run a query within a React component, call `useGetManagerTimeTrackingClosedDayUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerTimeTrackingClosedDayUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerTimeTrackingClosedDayUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagerTimeTrackingClosedDayUserListQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerTimeTrackingClosedDayUserListQuery, GetManagerTimeTrackingClosedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetManagerTimeTrackingClosedDayUserListQuery, GetManagerTimeTrackingClosedDayUserListQueryVariables>(GetManagerTimeTrackingClosedDayUserListDocument, options);
}
export function useGetManagerTimeTrackingClosedDayUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerTimeTrackingClosedDayUserListQuery, GetManagerTimeTrackingClosedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetManagerTimeTrackingClosedDayUserListQuery, GetManagerTimeTrackingClosedDayUserListQueryVariables>(GetManagerTimeTrackingClosedDayUserListDocument, options);
}
export function useGetManagerTimeTrackingClosedDayUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagerTimeTrackingClosedDayUserListQuery, GetManagerTimeTrackingClosedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetManagerTimeTrackingClosedDayUserListQuery, GetManagerTimeTrackingClosedDayUserListQueryVariables>(GetManagerTimeTrackingClosedDayUserListDocument, options);
}
export type GetManagerTimeTrackingClosedDayUserListQueryHookResult = ReturnType<typeof useGetManagerTimeTrackingClosedDayUserListQuery>;
export type GetManagerTimeTrackingClosedDayUserListLazyQueryHookResult = ReturnType<typeof useGetManagerTimeTrackingClosedDayUserListLazyQuery>;
export type GetManagerTimeTrackingClosedDayUserListSuspenseQueryHookResult = ReturnType<typeof useGetManagerTimeTrackingClosedDayUserListSuspenseQuery>;
export type GetManagerTimeTrackingClosedDayUserListQueryResult = Apollo.QueryResult<GetManagerTimeTrackingClosedDayUserListQuery, GetManagerTimeTrackingClosedDayUserListQueryVariables>;
export function refetchGetManagerTimeTrackingClosedDayUserListQuery(variables?: GetManagerTimeTrackingClosedDayUserListQueryVariables) {
  return { query: GetManagerTimeTrackingClosedDayUserListDocument, variables: variables }
}
export const GetManagerTimeTrackingRejectedDayUserListDocument = gql`
    query GetManagerTimeTrackingRejectedDayUserList {
  timeTrackingRejectedDaysManagerList {
    user {
      id
      name
      email
      phone
    }
    date
  }
}
    `;

/**
 * __useGetManagerTimeTrackingRejectedDayUserListQuery__
 *
 * To run a query within a React component, call `useGetManagerTimeTrackingRejectedDayUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerTimeTrackingRejectedDayUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerTimeTrackingRejectedDayUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagerTimeTrackingRejectedDayUserListQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerTimeTrackingRejectedDayUserListQuery, GetManagerTimeTrackingRejectedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetManagerTimeTrackingRejectedDayUserListQuery, GetManagerTimeTrackingRejectedDayUserListQueryVariables>(GetManagerTimeTrackingRejectedDayUserListDocument, options);
}
export function useGetManagerTimeTrackingRejectedDayUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerTimeTrackingRejectedDayUserListQuery, GetManagerTimeTrackingRejectedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetManagerTimeTrackingRejectedDayUserListQuery, GetManagerTimeTrackingRejectedDayUserListQueryVariables>(GetManagerTimeTrackingRejectedDayUserListDocument, options);
}
export function useGetManagerTimeTrackingRejectedDayUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagerTimeTrackingRejectedDayUserListQuery, GetManagerTimeTrackingRejectedDayUserListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetManagerTimeTrackingRejectedDayUserListQuery, GetManagerTimeTrackingRejectedDayUserListQueryVariables>(GetManagerTimeTrackingRejectedDayUserListDocument, options);
}
export type GetManagerTimeTrackingRejectedDayUserListQueryHookResult = ReturnType<typeof useGetManagerTimeTrackingRejectedDayUserListQuery>;
export type GetManagerTimeTrackingRejectedDayUserListLazyQueryHookResult = ReturnType<typeof useGetManagerTimeTrackingRejectedDayUserListLazyQuery>;
export type GetManagerTimeTrackingRejectedDayUserListSuspenseQueryHookResult = ReturnType<typeof useGetManagerTimeTrackingRejectedDayUserListSuspenseQuery>;
export type GetManagerTimeTrackingRejectedDayUserListQueryResult = Apollo.QueryResult<GetManagerTimeTrackingRejectedDayUserListQuery, GetManagerTimeTrackingRejectedDayUserListQueryVariables>;
export function refetchGetManagerTimeTrackingRejectedDayUserListQuery(variables?: GetManagerTimeTrackingRejectedDayUserListQueryVariables) {
  return { query: GetManagerTimeTrackingRejectedDayUserListDocument, variables: variables }
}
export const GetTimeTrackingDayClosedByUserDocument = gql`
    query GetTimeTrackingDayClosedByUser($user: String!) {
  timeTrackingDayClosedByUser(user: $user) {
    id
    user {
      id
    }
    timeTrackingDayStatus
    date
  }
}
    `;

/**
 * __useGetTimeTrackingDayClosedByUserQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingDayClosedByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingDayClosedByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingDayClosedByUserQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetTimeTrackingDayClosedByUserQuery(baseOptions: Apollo.QueryHookOptions<GetTimeTrackingDayClosedByUserQuery, GetTimeTrackingDayClosedByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingDayClosedByUserQuery, GetTimeTrackingDayClosedByUserQueryVariables>(GetTimeTrackingDayClosedByUserDocument, options);
}
export function useGetTimeTrackingDayClosedByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingDayClosedByUserQuery, GetTimeTrackingDayClosedByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingDayClosedByUserQuery, GetTimeTrackingDayClosedByUserQueryVariables>(GetTimeTrackingDayClosedByUserDocument, options);
}
export function useGetTimeTrackingDayClosedByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingDayClosedByUserQuery, GetTimeTrackingDayClosedByUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingDayClosedByUserQuery, GetTimeTrackingDayClosedByUserQueryVariables>(GetTimeTrackingDayClosedByUserDocument, options);
}
export type GetTimeTrackingDayClosedByUserQueryHookResult = ReturnType<typeof useGetTimeTrackingDayClosedByUserQuery>;
export type GetTimeTrackingDayClosedByUserLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingDayClosedByUserLazyQuery>;
export type GetTimeTrackingDayClosedByUserSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingDayClosedByUserSuspenseQuery>;
export type GetTimeTrackingDayClosedByUserQueryResult = Apollo.QueryResult<GetTimeTrackingDayClosedByUserQuery, GetTimeTrackingDayClosedByUserQueryVariables>;
export function refetchGetTimeTrackingDayClosedByUserQuery(variables: GetTimeTrackingDayClosedByUserQueryVariables) {
  return { query: GetTimeTrackingDayClosedByUserDocument, variables: variables }
}
export const GetTimeTrackingDaysDocument = gql`
    query GetTimeTrackingDays($timeTrackingDayStatus: TimeTrackingDayStatus, $minDate: Date!, $maxDate: Date!, $users: [String!]) {
  timeTrackingDays(
    timeTrackingDayStatus: $timeTrackingDayStatus
    minDate: $minDate
    maxDate: $maxDate
    users: $users
  ) {
    ...TimeTrackingDay
  }
}
    ${TimeTrackingDayFragmentDoc}`;

/**
 * __useGetTimeTrackingDaysQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingDaysQuery({
 *   variables: {
 *      timeTrackingDayStatus: // value for 'timeTrackingDayStatus'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      users: // value for 'users'
 *   },
 * });
 */
export function useGetTimeTrackingDaysQuery(baseOptions: Apollo.QueryHookOptions<GetTimeTrackingDaysQuery, GetTimeTrackingDaysQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingDaysQuery, GetTimeTrackingDaysQueryVariables>(GetTimeTrackingDaysDocument, options);
}
export function useGetTimeTrackingDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingDaysQuery, GetTimeTrackingDaysQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingDaysQuery, GetTimeTrackingDaysQueryVariables>(GetTimeTrackingDaysDocument, options);
}
export function useGetTimeTrackingDaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingDaysQuery, GetTimeTrackingDaysQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingDaysQuery, GetTimeTrackingDaysQueryVariables>(GetTimeTrackingDaysDocument, options);
}
export type GetTimeTrackingDaysQueryHookResult = ReturnType<typeof useGetTimeTrackingDaysQuery>;
export type GetTimeTrackingDaysLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingDaysLazyQuery>;
export type GetTimeTrackingDaysSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingDaysSuspenseQuery>;
export type GetTimeTrackingDaysQueryResult = Apollo.QueryResult<GetTimeTrackingDaysQuery, GetTimeTrackingDaysQueryVariables>;
export function refetchGetTimeTrackingDaysQuery(variables: GetTimeTrackingDaysQueryVariables) {
  return { query: GetTimeTrackingDaysDocument, variables: variables }
}
export const GetTimeTrackingEntryLogDocument = gql`
    query GetTimeTrackingEntryLog($id: String!) {
  timeTrackingEntryLog(id: $id) {
    ...BaseTimeTrackingEntry
  }
}
    ${BaseTimeTrackingEntryFragmentDoc}`;

/**
 * __useGetTimeTrackingEntryLogQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingEntryLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingEntryLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingEntryLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTimeTrackingEntryLogQuery(baseOptions: Apollo.QueryHookOptions<GetTimeTrackingEntryLogQuery, GetTimeTrackingEntryLogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingEntryLogQuery, GetTimeTrackingEntryLogQueryVariables>(GetTimeTrackingEntryLogDocument, options);
}
export function useGetTimeTrackingEntryLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingEntryLogQuery, GetTimeTrackingEntryLogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingEntryLogQuery, GetTimeTrackingEntryLogQueryVariables>(GetTimeTrackingEntryLogDocument, options);
}
export function useGetTimeTrackingEntryLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingEntryLogQuery, GetTimeTrackingEntryLogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingEntryLogQuery, GetTimeTrackingEntryLogQueryVariables>(GetTimeTrackingEntryLogDocument, options);
}
export type GetTimeTrackingEntryLogQueryHookResult = ReturnType<typeof useGetTimeTrackingEntryLogQuery>;
export type GetTimeTrackingEntryLogLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingEntryLogLazyQuery>;
export type GetTimeTrackingEntryLogSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingEntryLogSuspenseQuery>;
export type GetTimeTrackingEntryLogQueryResult = Apollo.QueryResult<GetTimeTrackingEntryLogQuery, GetTimeTrackingEntryLogQueryVariables>;
export function refetchGetTimeTrackingEntryLogQuery(variables: GetTimeTrackingEntryLogQueryVariables) {
  return { query: GetTimeTrackingEntryLogDocument, variables: variables }
}
export const GetTimeTrackingsDayForUserDocument = gql`
    query GetTimeTrackingsDayForUser($user: String!, $minDate: Date, $maxDate: Date) {
  timeTrackingsDayForUser(user: $user, minDate: $minDate, maxDate: $maxDate) {
    id
    createdAt
    timeTrackingDayStatus
    user {
      id
      name
      employeeId
    }
    userId
    date
    totalHours
    overtimeHours
    isPartOfRange
    rangeStartDate
    rangeEndDate
    timeTrackingEntries {
      id
      createdAt
      user {
        id
        name
      }
      userId
      startDate
      endDate
      startTime
      endTime
      hours
      case {
        id
        erpId
        erpNo
        debitor {
          id
          company
        }
        damage {
          category {
            id
            name
          }
          cause {
            id
            name
          }
          contact {
            address {
              road
              houseNumber
              postalCode
              city
            }
          }
        }
      }
      drivingSlip {
        id
      }
      jobNo
      remark
      jobTaskNo
      onCall
      onCallback
      includesLunch
      task
      jobTaskName
      workTypeCode
      timeTrackingStatus
      bcStatus
      rejectMessage
      pieceworkAmount
      supplementType
      paymentSupplementCode
      paymentSupplementName
      supplementUom
      lastModifiedAt
      lastModifiedBy {
        id
        name
      }
      addonLines {
        ...BaseSupplement
      }
    }
  }
}
    ${BaseSupplementFragmentDoc}`;

/**
 * __useGetTimeTrackingsDayForUserQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingsDayForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingsDayForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingsDayForUserQuery({
 *   variables: {
 *      user: // value for 'user'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetTimeTrackingsDayForUserQuery(baseOptions: Apollo.QueryHookOptions<GetTimeTrackingsDayForUserQuery, GetTimeTrackingsDayForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingsDayForUserQuery, GetTimeTrackingsDayForUserQueryVariables>(GetTimeTrackingsDayForUserDocument, options);
}
export function useGetTimeTrackingsDayForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingsDayForUserQuery, GetTimeTrackingsDayForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingsDayForUserQuery, GetTimeTrackingsDayForUserQueryVariables>(GetTimeTrackingsDayForUserDocument, options);
}
export function useGetTimeTrackingsDayForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingsDayForUserQuery, GetTimeTrackingsDayForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingsDayForUserQuery, GetTimeTrackingsDayForUserQueryVariables>(GetTimeTrackingsDayForUserDocument, options);
}
export type GetTimeTrackingsDayForUserQueryHookResult = ReturnType<typeof useGetTimeTrackingsDayForUserQuery>;
export type GetTimeTrackingsDayForUserLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingsDayForUserLazyQuery>;
export type GetTimeTrackingsDayForUserSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingsDayForUserSuspenseQuery>;
export type GetTimeTrackingsDayForUserQueryResult = Apollo.QueryResult<GetTimeTrackingsDayForUserQuery, GetTimeTrackingsDayForUserQueryVariables>;
export function refetchGetTimeTrackingsDayForUserQuery(variables: GetTimeTrackingsDayForUserQueryVariables) {
  return { query: GetTimeTrackingsDayForUserDocument, variables: variables }
}
export const GetTimeTrackingsInBcWithoutApprovalDocument = gql`
    query GetTimeTrackingsInBcWithoutApproval($erpNo: String!) {
  timeTrackingsInBcWithoutApproval(erpNo: $erpNo) {
    id
    user {
      name
    }
    startDate
    hours
    jobTaskName
    startTime
    endTime
    emploeeResponsible
    projectApprovalStatus
  }
}
    `;

/**
 * __useGetTimeTrackingsInBcWithoutApprovalQuery__
 *
 * To run a query within a React component, call `useGetTimeTrackingsInBcWithoutApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeTrackingsInBcWithoutApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeTrackingsInBcWithoutApprovalQuery({
 *   variables: {
 *      erpNo: // value for 'erpNo'
 *   },
 * });
 */
export function useGetTimeTrackingsInBcWithoutApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetTimeTrackingsInBcWithoutApprovalQuery, GetTimeTrackingsInBcWithoutApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimeTrackingsInBcWithoutApprovalQuery, GetTimeTrackingsInBcWithoutApprovalQueryVariables>(GetTimeTrackingsInBcWithoutApprovalDocument, options);
}
export function useGetTimeTrackingsInBcWithoutApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeTrackingsInBcWithoutApprovalQuery, GetTimeTrackingsInBcWithoutApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimeTrackingsInBcWithoutApprovalQuery, GetTimeTrackingsInBcWithoutApprovalQueryVariables>(GetTimeTrackingsInBcWithoutApprovalDocument, options);
}
export function useGetTimeTrackingsInBcWithoutApprovalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeTrackingsInBcWithoutApprovalQuery, GetTimeTrackingsInBcWithoutApprovalQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimeTrackingsInBcWithoutApprovalQuery, GetTimeTrackingsInBcWithoutApprovalQueryVariables>(GetTimeTrackingsInBcWithoutApprovalDocument, options);
}
export type GetTimeTrackingsInBcWithoutApprovalQueryHookResult = ReturnType<typeof useGetTimeTrackingsInBcWithoutApprovalQuery>;
export type GetTimeTrackingsInBcWithoutApprovalLazyQueryHookResult = ReturnType<typeof useGetTimeTrackingsInBcWithoutApprovalLazyQuery>;
export type GetTimeTrackingsInBcWithoutApprovalSuspenseQueryHookResult = ReturnType<typeof useGetTimeTrackingsInBcWithoutApprovalSuspenseQuery>;
export type GetTimeTrackingsInBcWithoutApprovalQueryResult = Apollo.QueryResult<GetTimeTrackingsInBcWithoutApprovalQuery, GetTimeTrackingsInBcWithoutApprovalQueryVariables>;
export function refetchGetTimeTrackingsInBcWithoutApprovalQuery(variables: GetTimeTrackingsInBcWithoutApprovalQueryVariables) {
  return { query: GetTimeTrackingsInBcWithoutApprovalDocument, variables: variables }
}
export const GetflexTimeManagerListDocument = gql`
    query GetflexTimeManagerList {
  flexTimeManagerList {
    user {
      id
      name
      email
      phone
    }
    flexTime
  }
}
    `;

/**
 * __useGetflexTimeManagerListQuery__
 *
 * To run a query within a React component, call `useGetflexTimeManagerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetflexTimeManagerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetflexTimeManagerListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetflexTimeManagerListQuery(baseOptions?: Apollo.QueryHookOptions<GetflexTimeManagerListQuery, GetflexTimeManagerListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetflexTimeManagerListQuery, GetflexTimeManagerListQueryVariables>(GetflexTimeManagerListDocument, options);
}
export function useGetflexTimeManagerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetflexTimeManagerListQuery, GetflexTimeManagerListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetflexTimeManagerListQuery, GetflexTimeManagerListQueryVariables>(GetflexTimeManagerListDocument, options);
}
export function useGetflexTimeManagerListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetflexTimeManagerListQuery, GetflexTimeManagerListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetflexTimeManagerListQuery, GetflexTimeManagerListQueryVariables>(GetflexTimeManagerListDocument, options);
}
export type GetflexTimeManagerListQueryHookResult = ReturnType<typeof useGetflexTimeManagerListQuery>;
export type GetflexTimeManagerListLazyQueryHookResult = ReturnType<typeof useGetflexTimeManagerListLazyQuery>;
export type GetflexTimeManagerListSuspenseQueryHookResult = ReturnType<typeof useGetflexTimeManagerListSuspenseQuery>;
export type GetflexTimeManagerListQueryResult = Apollo.QueryResult<GetflexTimeManagerListQuery, GetflexTimeManagerListQueryVariables>;
export function refetchGetflexTimeManagerListQuery(variables?: GetflexTimeManagerListQueryVariables) {
  return { query: GetflexTimeManagerListDocument, variables: variables }
}
export const GetrejectedTimeTrackingsDayForUserDocument = gql`
    query GetrejectedTimeTrackingsDayForUser($user: String!) {
  rejectedTimeTrackingsDayForUser(user: $user) {
    id
    createdAt
    timeTrackingDayStatus
    user {
      id
      name
      employeeId
    }
    userId
    date
    totalHours
    overtimeHours
    isPartOfRange
    rangeStartDate
    rangeEndDate
    timeTrackingEntries {
      id
      createdAt
      user {
        id
        name
      }
      userId
      startDate
      endDate
      startTime
      endTime
      hours
      case {
        id
        erpId
        erpNo
        debitor {
          id
          company
        }
        damage {
          category {
            id
            name
          }
          cause {
            id
            name
          }
          contact {
            address {
              road
              houseNumber
              postalCode
              city
            }
          }
        }
      }
      drivingSlip {
        id
      }
      jobNo
      remark
      jobTaskNo
      onCall
      onCallback
      includesLunch
      task
      jobTaskName
      workTypeCode
      timeTrackingStatus
      bcStatus
      rejectMessage
      pieceworkAmount
      supplementType
      paymentSupplementCode
      paymentSupplementName
      supplementUom
      lastModifiedAt
      lastModifiedBy {
        id
        name
      }
      addonLines {
        ...BaseSupplement
      }
    }
  }
}
    ${BaseSupplementFragmentDoc}`;

/**
 * __useGetrejectedTimeTrackingsDayForUserQuery__
 *
 * To run a query within a React component, call `useGetrejectedTimeTrackingsDayForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetrejectedTimeTrackingsDayForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetrejectedTimeTrackingsDayForUserQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetrejectedTimeTrackingsDayForUserQuery(baseOptions: Apollo.QueryHookOptions<GetrejectedTimeTrackingsDayForUserQuery, GetrejectedTimeTrackingsDayForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetrejectedTimeTrackingsDayForUserQuery, GetrejectedTimeTrackingsDayForUserQueryVariables>(GetrejectedTimeTrackingsDayForUserDocument, options);
}
export function useGetrejectedTimeTrackingsDayForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetrejectedTimeTrackingsDayForUserQuery, GetrejectedTimeTrackingsDayForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetrejectedTimeTrackingsDayForUserQuery, GetrejectedTimeTrackingsDayForUserQueryVariables>(GetrejectedTimeTrackingsDayForUserDocument, options);
}
export function useGetrejectedTimeTrackingsDayForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetrejectedTimeTrackingsDayForUserQuery, GetrejectedTimeTrackingsDayForUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetrejectedTimeTrackingsDayForUserQuery, GetrejectedTimeTrackingsDayForUserQueryVariables>(GetrejectedTimeTrackingsDayForUserDocument, options);
}
export type GetrejectedTimeTrackingsDayForUserQueryHookResult = ReturnType<typeof useGetrejectedTimeTrackingsDayForUserQuery>;
export type GetrejectedTimeTrackingsDayForUserLazyQueryHookResult = ReturnType<typeof useGetrejectedTimeTrackingsDayForUserLazyQuery>;
export type GetrejectedTimeTrackingsDayForUserSuspenseQueryHookResult = ReturnType<typeof useGetrejectedTimeTrackingsDayForUserSuspenseQuery>;
export type GetrejectedTimeTrackingsDayForUserQueryResult = Apollo.QueryResult<GetrejectedTimeTrackingsDayForUserQuery, GetrejectedTimeTrackingsDayForUserQueryVariables>;
export function refetchGetrejectedTimeTrackingsDayForUserQuery(variables: GetrejectedTimeTrackingsDayForUserQueryVariables) {
  return { query: GetrejectedTimeTrackingsDayForUserDocument, variables: variables }
}
export const OpenRejectedTimeTrackingDayDocument = gql`
    mutation OpenRejectedTimeTrackingDay($userEmail: String!, $date: Date!, $dayId: String!) {
  openRejectedTimeTrackingDay(userEmail: $userEmail, date: $date, dayId: $dayId) {
    ...TimeTrackingDay
  }
}
    ${TimeTrackingDayFragmentDoc}`;
export type OpenRejectedTimeTrackingDayMutationFn = Apollo.MutationFunction<OpenRejectedTimeTrackingDayMutation, OpenRejectedTimeTrackingDayMutationVariables>;

/**
 * __useOpenRejectedTimeTrackingDayMutation__
 *
 * To run a mutation, you first call `useOpenRejectedTimeTrackingDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenRejectedTimeTrackingDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openRejectedTimeTrackingDayMutation, { data, loading, error }] = useOpenRejectedTimeTrackingDayMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *      date: // value for 'date'
 *      dayId: // value for 'dayId'
 *   },
 * });
 */
export function useOpenRejectedTimeTrackingDayMutation(baseOptions?: Apollo.MutationHookOptions<OpenRejectedTimeTrackingDayMutation, OpenRejectedTimeTrackingDayMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OpenRejectedTimeTrackingDayMutation, OpenRejectedTimeTrackingDayMutationVariables>(OpenRejectedTimeTrackingDayDocument, options);
}
export type OpenRejectedTimeTrackingDayMutationHookResult = ReturnType<typeof useOpenRejectedTimeTrackingDayMutation>;
export type OpenRejectedTimeTrackingDayMutationResult = Apollo.MutationResult<OpenRejectedTimeTrackingDayMutation>;
export type OpenRejectedTimeTrackingDayMutationOptions = Apollo.BaseMutationOptions<OpenRejectedTimeTrackingDayMutation, OpenRejectedTimeTrackingDayMutationVariables>;
export const ReopenTimeTrackingDayDocument = gql`
    mutation ReopenTimeTrackingDay($timeTrackingDay: TimeTrackingDayInputType!) {
  reopenTimeTrackingDay(timeTrackingDay: $timeTrackingDay) {
    ...TimeTrackingDay
  }
}
    ${TimeTrackingDayFragmentDoc}`;
export type ReopenTimeTrackingDayMutationFn = Apollo.MutationFunction<ReopenTimeTrackingDayMutation, ReopenTimeTrackingDayMutationVariables>;

/**
 * __useReopenTimeTrackingDayMutation__
 *
 * To run a mutation, you first call `useReopenTimeTrackingDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenTimeTrackingDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenTimeTrackingDayMutation, { data, loading, error }] = useReopenTimeTrackingDayMutation({
 *   variables: {
 *      timeTrackingDay: // value for 'timeTrackingDay'
 *   },
 * });
 */
export function useReopenTimeTrackingDayMutation(baseOptions?: Apollo.MutationHookOptions<ReopenTimeTrackingDayMutation, ReopenTimeTrackingDayMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReopenTimeTrackingDayMutation, ReopenTimeTrackingDayMutationVariables>(ReopenTimeTrackingDayDocument, options);
}
export type ReopenTimeTrackingDayMutationHookResult = ReturnType<typeof useReopenTimeTrackingDayMutation>;
export type ReopenTimeTrackingDayMutationResult = Apollo.MutationResult<ReopenTimeTrackingDayMutation>;
export type ReopenTimeTrackingDayMutationOptions = Apollo.BaseMutationOptions<ReopenTimeTrackingDayMutation, ReopenTimeTrackingDayMutationVariables>;
export const SubmitTimeTrackingDayDocument = gql`
    mutation SubmitTimeTrackingDay($timeTrackingDay: TimeTrackingDayInputType!) {
  submitTimeTrackingDay(timeTrackingDay: $timeTrackingDay) {
    ...TimeTrackingDay
  }
}
    ${TimeTrackingDayFragmentDoc}`;
export type SubmitTimeTrackingDayMutationFn = Apollo.MutationFunction<SubmitTimeTrackingDayMutation, SubmitTimeTrackingDayMutationVariables>;

/**
 * __useSubmitTimeTrackingDayMutation__
 *
 * To run a mutation, you first call `useSubmitTimeTrackingDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTimeTrackingDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTimeTrackingDayMutation, { data, loading, error }] = useSubmitTimeTrackingDayMutation({
 *   variables: {
 *      timeTrackingDay: // value for 'timeTrackingDay'
 *   },
 * });
 */
export function useSubmitTimeTrackingDayMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTimeTrackingDayMutation, SubmitTimeTrackingDayMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SubmitTimeTrackingDayMutation, SubmitTimeTrackingDayMutationVariables>(SubmitTimeTrackingDayDocument, options);
}
export type SubmitTimeTrackingDayMutationHookResult = ReturnType<typeof useSubmitTimeTrackingDayMutation>;
export type SubmitTimeTrackingDayMutationResult = Apollo.MutationResult<SubmitTimeTrackingDayMutation>;
export type SubmitTimeTrackingDayMutationOptions = Apollo.BaseMutationOptions<SubmitTimeTrackingDayMutation, SubmitTimeTrackingDayMutationVariables>;
export const UpdateTimeTrackingDayEntryDocument = gql`
    mutation UpdateTimeTrackingDayEntry($timeTrackingDayId: String!, $timeTrackingEntry: TimeTrackingEntryUpdateInputType!) {
  updateTimeTrackingDayEntry(
    timeTrackingDayId: $timeTrackingDayId
    timeTrackingEntry: $timeTrackingEntry
  ) {
    id
    createdAt
    timeTrackingDayStatus
    user {
      id
      name
      employeeId
    }
    userId
    date
    totalHours
    overtimeHours
    isPartOfRange
    rangeStartDate
    rangeEndDate
    timeTrackingEntries {
      id
      createdAt
      user {
        id
        name
      }
      userId
      startDate
      endDate
      startTime
      endTime
      hours
      case {
        id
        erpId
        erpNo
        debitor {
          id
          company
        }
        damage {
          category {
            id
            name
          }
          cause {
            id
            name
          }
          contact {
            address {
              road
              houseNumber
              postalCode
              city
            }
          }
        }
      }
      drivingSlip {
        id
      }
      jobNo
      remark
      jobTaskNo
      onCall
      onCallback
      includesLunch
      task
      jobTaskName
      workTypeCode
      timeTrackingStatus
      bcStatus
      rejectMessage
      pieceworkAmount
      supplementType
      paymentSupplementCode
      paymentSupplementName
      supplementUom
      lastModifiedAt
      lastModifiedBy {
        id
        name
      }
      addonLines {
        ...BaseSupplement
      }
    }
  }
}
    ${BaseSupplementFragmentDoc}`;
export type UpdateTimeTrackingDayEntryMutationFn = Apollo.MutationFunction<UpdateTimeTrackingDayEntryMutation, UpdateTimeTrackingDayEntryMutationVariables>;

/**
 * __useUpdateTimeTrackingDayEntryMutation__
 *
 * To run a mutation, you first call `useUpdateTimeTrackingDayEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeTrackingDayEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeTrackingDayEntryMutation, { data, loading, error }] = useUpdateTimeTrackingDayEntryMutation({
 *   variables: {
 *      timeTrackingDayId: // value for 'timeTrackingDayId'
 *      timeTrackingEntry: // value for 'timeTrackingEntry'
 *   },
 * });
 */
export function useUpdateTimeTrackingDayEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeTrackingDayEntryMutation, UpdateTimeTrackingDayEntryMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTimeTrackingDayEntryMutation, UpdateTimeTrackingDayEntryMutationVariables>(UpdateTimeTrackingDayEntryDocument, options);
}
export type UpdateTimeTrackingDayEntryMutationHookResult = ReturnType<typeof useUpdateTimeTrackingDayEntryMutation>;
export type UpdateTimeTrackingDayEntryMutationResult = Apollo.MutationResult<UpdateTimeTrackingDayEntryMutation>;
export type UpdateTimeTrackingDayEntryMutationOptions = Apollo.BaseMutationOptions<UpdateTimeTrackingDayEntryMutation, UpdateTimeTrackingDayEntryMutationVariables>;
export const AddCatalogToTimedMessageDocument = gql`
    mutation AddCatalogToTimedMessage($timedMessageId: String!, $catalogId: String!, $changedBy: String!) {
  addCatalogToTimedMessage(
    timedMessageId: $timedMessageId
    catalogId: $catalogId
    changedBy: $changedBy
  ) {
    ...BaseTimedMessageFragment
  }
}
    ${BaseTimedMessageFragmentFragmentDoc}`;
export type AddCatalogToTimedMessageMutationFn = Apollo.MutationFunction<AddCatalogToTimedMessageMutation, AddCatalogToTimedMessageMutationVariables>;

/**
 * __useAddCatalogToTimedMessageMutation__
 *
 * To run a mutation, you first call `useAddCatalogToTimedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCatalogToTimedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCatalogToTimedMessageMutation, { data, loading, error }] = useAddCatalogToTimedMessageMutation({
 *   variables: {
 *      timedMessageId: // value for 'timedMessageId'
 *      catalogId: // value for 'catalogId'
 *      changedBy: // value for 'changedBy'
 *   },
 * });
 */
export function useAddCatalogToTimedMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddCatalogToTimedMessageMutation, AddCatalogToTimedMessageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddCatalogToTimedMessageMutation, AddCatalogToTimedMessageMutationVariables>(AddCatalogToTimedMessageDocument, options);
}
export type AddCatalogToTimedMessageMutationHookResult = ReturnType<typeof useAddCatalogToTimedMessageMutation>;
export type AddCatalogToTimedMessageMutationResult = Apollo.MutationResult<AddCatalogToTimedMessageMutation>;
export type AddCatalogToTimedMessageMutationOptions = Apollo.BaseMutationOptions<AddCatalogToTimedMessageMutation, AddCatalogToTimedMessageMutationVariables>;
export const CreateTimedMessageDocument = gql`
    mutation CreateTimedMessage($timedMessage: TimedMessageInput!) {
  createTimedMessage(timedMessage: $timedMessage) {
    ...BaseTimedMessageFragment
    catalogs {
      id
      propertyNumber
      addresses {
        ...BaseCatalogAddressFragment
      }
    }
  }
}
    ${BaseTimedMessageFragmentFragmentDoc}
${BaseCatalogAddressFragmentFragmentDoc}`;
export type CreateTimedMessageMutationFn = Apollo.MutationFunction<CreateTimedMessageMutation, CreateTimedMessageMutationVariables>;

/**
 * __useCreateTimedMessageMutation__
 *
 * To run a mutation, you first call `useCreateTimedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimedMessageMutation, { data, loading, error }] = useCreateTimedMessageMutation({
 *   variables: {
 *      timedMessage: // value for 'timedMessage'
 *   },
 * });
 */
export function useCreateTimedMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimedMessageMutation, CreateTimedMessageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTimedMessageMutation, CreateTimedMessageMutationVariables>(CreateTimedMessageDocument, options);
}
export type CreateTimedMessageMutationHookResult = ReturnType<typeof useCreateTimedMessageMutation>;
export type CreateTimedMessageMutationResult = Apollo.MutationResult<CreateTimedMessageMutation>;
export type CreateTimedMessageMutationOptions = Apollo.BaseMutationOptions<CreateTimedMessageMutation, CreateTimedMessageMutationVariables>;
export const DeleteTimedMessageDocument = gql`
    mutation DeleteTimedMessage($id: String!, $changedBy: String!) {
  deleteTimedMessage(id: $id, changedBy: $changedBy)
}
    `;
export type DeleteTimedMessageMutationFn = Apollo.MutationFunction<DeleteTimedMessageMutation, DeleteTimedMessageMutationVariables>;

/**
 * __useDeleteTimedMessageMutation__
 *
 * To run a mutation, you first call `useDeleteTimedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimedMessageMutation, { data, loading, error }] = useDeleteTimedMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changedBy: // value for 'changedBy'
 *   },
 * });
 */
export function useDeleteTimedMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimedMessageMutation, DeleteTimedMessageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTimedMessageMutation, DeleteTimedMessageMutationVariables>(DeleteTimedMessageDocument, options);
}
export type DeleteTimedMessageMutationHookResult = ReturnType<typeof useDeleteTimedMessageMutation>;
export type DeleteTimedMessageMutationResult = Apollo.MutationResult<DeleteTimedMessageMutation>;
export type DeleteTimedMessageMutationOptions = Apollo.BaseMutationOptions<DeleteTimedMessageMutation, DeleteTimedMessageMutationVariables>;
export const GetTimedMessageChangesDocument = gql`
    query GetTimedMessageChanges($id: String!) {
  timedMessage(id: $id) {
    id
    changes {
      timestamp
      user {
        ...BaseUserFragment
      }
      before {
        ...TimedMessageChangesFragment
      }
      after {
        ...TimedMessageChangesFragment
      }
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${TimedMessageChangesFragmentFragmentDoc}`;

/**
 * __useGetTimedMessageChangesQuery__
 *
 * To run a query within a React component, call `useGetTimedMessageChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimedMessageChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimedMessageChangesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTimedMessageChangesQuery(baseOptions: Apollo.QueryHookOptions<GetTimedMessageChangesQuery, GetTimedMessageChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimedMessageChangesQuery, GetTimedMessageChangesQueryVariables>(GetTimedMessageChangesDocument, options);
}
export function useGetTimedMessageChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimedMessageChangesQuery, GetTimedMessageChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimedMessageChangesQuery, GetTimedMessageChangesQueryVariables>(GetTimedMessageChangesDocument, options);
}
export function useGetTimedMessageChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimedMessageChangesQuery, GetTimedMessageChangesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimedMessageChangesQuery, GetTimedMessageChangesQueryVariables>(GetTimedMessageChangesDocument, options);
}
export type GetTimedMessageChangesQueryHookResult = ReturnType<typeof useGetTimedMessageChangesQuery>;
export type GetTimedMessageChangesLazyQueryHookResult = ReturnType<typeof useGetTimedMessageChangesLazyQuery>;
export type GetTimedMessageChangesSuspenseQueryHookResult = ReturnType<typeof useGetTimedMessageChangesSuspenseQuery>;
export type GetTimedMessageChangesQueryResult = Apollo.QueryResult<GetTimedMessageChangesQuery, GetTimedMessageChangesQueryVariables>;
export function refetchGetTimedMessageChangesQuery(variables: GetTimedMessageChangesQueryVariables) {
  return { query: GetTimedMessageChangesDocument, variables: variables }
}
export const GetTimedMessagesDocument = gql`
    query GetTimedMessages($globalOnly: Boolean, $fromDate: Date, $toDate: Date, $catalogId: String, $customerIds: [String!], $thisCustomerOnly: Boolean) {
  timedMessages(
    globalOnly: $globalOnly
    fromDate: $fromDate
    toDate: $toDate
    catalogId: $catalogId
    customerIds: $customerIds
    thisCustomerOnly: $thisCustomerOnly
  ) {
    ...BaseTimedMessageFragment
    catalogs {
      id
      propertyNumber
      addresses {
        ...BaseCatalogAddressFragment
      }
    }
  }
}
    ${BaseTimedMessageFragmentFragmentDoc}
${BaseCatalogAddressFragmentFragmentDoc}`;

/**
 * __useGetTimedMessagesQuery__
 *
 * To run a query within a React component, call `useGetTimedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimedMessagesQuery({
 *   variables: {
 *      globalOnly: // value for 'globalOnly'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      catalogId: // value for 'catalogId'
 *      customerIds: // value for 'customerIds'
 *      thisCustomerOnly: // value for 'thisCustomerOnly'
 *   },
 * });
 */
export function useGetTimedMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetTimedMessagesQuery, GetTimedMessagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimedMessagesQuery, GetTimedMessagesQueryVariables>(GetTimedMessagesDocument, options);
}
export function useGetTimedMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimedMessagesQuery, GetTimedMessagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimedMessagesQuery, GetTimedMessagesQueryVariables>(GetTimedMessagesDocument, options);
}
export function useGetTimedMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimedMessagesQuery, GetTimedMessagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimedMessagesQuery, GetTimedMessagesQueryVariables>(GetTimedMessagesDocument, options);
}
export type GetTimedMessagesQueryHookResult = ReturnType<typeof useGetTimedMessagesQuery>;
export type GetTimedMessagesLazyQueryHookResult = ReturnType<typeof useGetTimedMessagesLazyQuery>;
export type GetTimedMessagesSuspenseQueryHookResult = ReturnType<typeof useGetTimedMessagesSuspenseQuery>;
export type GetTimedMessagesQueryResult = Apollo.QueryResult<GetTimedMessagesQuery, GetTimedMessagesQueryVariables>;
export function refetchGetTimedMessagesQuery(variables?: GetTimedMessagesQueryVariables) {
  return { query: GetTimedMessagesDocument, variables: variables }
}
export const GetTimedMessagesForAddExcistingDocument = gql`
    query GetTimedMessagesForAddExcisting($customerIds: [String!], $notGlobalOnly: Boolean) {
  timedMessages(customerIds: $customerIds, notGlobalOnly: $notGlobalOnly) {
    id
    startTime
    endTime
    message
  }
}
    `;

/**
 * __useGetTimedMessagesForAddExcistingQuery__
 *
 * To run a query within a React component, call `useGetTimedMessagesForAddExcistingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimedMessagesForAddExcistingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimedMessagesForAddExcistingQuery({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *      notGlobalOnly: // value for 'notGlobalOnly'
 *   },
 * });
 */
export function useGetTimedMessagesForAddExcistingQuery(baseOptions?: Apollo.QueryHookOptions<GetTimedMessagesForAddExcistingQuery, GetTimedMessagesForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTimedMessagesForAddExcistingQuery, GetTimedMessagesForAddExcistingQueryVariables>(GetTimedMessagesForAddExcistingDocument, options);
}
export function useGetTimedMessagesForAddExcistingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimedMessagesForAddExcistingQuery, GetTimedMessagesForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTimedMessagesForAddExcistingQuery, GetTimedMessagesForAddExcistingQueryVariables>(GetTimedMessagesForAddExcistingDocument, options);
}
export function useGetTimedMessagesForAddExcistingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimedMessagesForAddExcistingQuery, GetTimedMessagesForAddExcistingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTimedMessagesForAddExcistingQuery, GetTimedMessagesForAddExcistingQueryVariables>(GetTimedMessagesForAddExcistingDocument, options);
}
export type GetTimedMessagesForAddExcistingQueryHookResult = ReturnType<typeof useGetTimedMessagesForAddExcistingQuery>;
export type GetTimedMessagesForAddExcistingLazyQueryHookResult = ReturnType<typeof useGetTimedMessagesForAddExcistingLazyQuery>;
export type GetTimedMessagesForAddExcistingSuspenseQueryHookResult = ReturnType<typeof useGetTimedMessagesForAddExcistingSuspenseQuery>;
export type GetTimedMessagesForAddExcistingQueryResult = Apollo.QueryResult<GetTimedMessagesForAddExcistingQuery, GetTimedMessagesForAddExcistingQueryVariables>;
export function refetchGetTimedMessagesForAddExcistingQuery(variables?: GetTimedMessagesForAddExcistingQueryVariables) {
  return { query: GetTimedMessagesForAddExcistingDocument, variables: variables }
}
export const UpdateTimedMessageDocument = gql`
    mutation UpdateTimedMessage($id: String!, $customer: String!, $changedBy: String!, $startTime: DateTime!, $endTime: DateTime!, $message: String!, $global: Boolean!, $active: Boolean!, $globalType: CatalogGlobalType!, $catalogs: [String!]!, $action: FileActionType!, $catalogsBefore: [String]) {
  updateTimedMessage(
    id: $id
    customer: $customer
    changedBy: $changedBy
    startTime: $startTime
    endTime: $endTime
    message: $message
    global: $global
    active: $active
    globalType: $globalType
    catalogs: $catalogs
    action: $action
    catalogsBefore: $catalogsBefore
  ) {
    ...BaseTimedMessageFragment
  }
}
    ${BaseTimedMessageFragmentFragmentDoc}`;
export type UpdateTimedMessageMutationFn = Apollo.MutationFunction<UpdateTimedMessageMutation, UpdateTimedMessageMutationVariables>;

/**
 * __useUpdateTimedMessageMutation__
 *
 * To run a mutation, you first call `useUpdateTimedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimedMessageMutation, { data, loading, error }] = useUpdateTimedMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customer: // value for 'customer'
 *      changedBy: // value for 'changedBy'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      message: // value for 'message'
 *      global: // value for 'global'
 *      active: // value for 'active'
 *      globalType: // value for 'globalType'
 *      catalogs: // value for 'catalogs'
 *      action: // value for 'action'
 *      catalogsBefore: // value for 'catalogsBefore'
 *   },
 * });
 */
export function useUpdateTimedMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimedMessageMutation, UpdateTimedMessageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTimedMessageMutation, UpdateTimedMessageMutationVariables>(UpdateTimedMessageDocument, options);
}
export type UpdateTimedMessageMutationHookResult = ReturnType<typeof useUpdateTimedMessageMutation>;
export type UpdateTimedMessageMutationResult = Apollo.MutationResult<UpdateTimedMessageMutation>;
export type UpdateTimedMessageMutationOptions = Apollo.BaseMutationOptions<UpdateTimedMessageMutation, UpdateTimedMessageMutationVariables>;
export const GetUserFlexTimeDocument = gql`
    query GetUserFlexTime($user: String!) {
  userFlexTime(user: $user)
}
    `;

/**
 * __useGetUserFlexTimeQuery__
 *
 * To run a query within a React component, call `useGetUserFlexTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFlexTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFlexTimeQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetUserFlexTimeQuery(baseOptions: Apollo.QueryHookOptions<GetUserFlexTimeQuery, GetUserFlexTimeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserFlexTimeQuery, GetUserFlexTimeQueryVariables>(GetUserFlexTimeDocument, options);
}
export function useGetUserFlexTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFlexTimeQuery, GetUserFlexTimeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserFlexTimeQuery, GetUserFlexTimeQueryVariables>(GetUserFlexTimeDocument, options);
}
export function useGetUserFlexTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserFlexTimeQuery, GetUserFlexTimeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUserFlexTimeQuery, GetUserFlexTimeQueryVariables>(GetUserFlexTimeDocument, options);
}
export type GetUserFlexTimeQueryHookResult = ReturnType<typeof useGetUserFlexTimeQuery>;
export type GetUserFlexTimeLazyQueryHookResult = ReturnType<typeof useGetUserFlexTimeLazyQuery>;
export type GetUserFlexTimeSuspenseQueryHookResult = ReturnType<typeof useGetUserFlexTimeSuspenseQuery>;
export type GetUserFlexTimeQueryResult = Apollo.QueryResult<GetUserFlexTimeQuery, GetUserFlexTimeQueryVariables>;
export function refetchGetUserFlexTimeQuery(variables: GetUserFlexTimeQueryVariables) {
  return { query: GetUserFlexTimeDocument, variables: variables }
}
export const GetWebCurrentUserDocument = gql`
    query GetWebCurrentUser {
  currentUser {
    ...BaseUserFragment
    gdpr {
      ...BaseGDPRFragment
    }
    defaultLanguage
    permissions
    external
    caseFilters {
      key
      name
      view
      awaiting
      damageServiceCompleted
      calledBack
      machinesOnCase
      showEconomyField
      showBusinessAreaField
      showAppliedClosedCases
      showClosedCases
      debitors
      postalCodeText
      postalCodes
      track
      departments
      locations
      damageCategories
      damageCauses
      priority
      caseManagers
      projectManagers
      areaResponsibles
      createdBy
    }
    drivingSlipFilters {
      key
      name
      debitors
      postalCodeText
      postalCodes
      departments
      locations
      damageCategories
      damageCauses
      erpNos
      projectManagers
      drivingSlipCategories
    }
    drivingSlipOverviewFilters {
      key
      name
      status
      urgent
      exceeded
      departments
      locations
      damageCauses
      damageCategories
      drivers
      noDriver
    }
    sanitizerFilters {
      key
      name
      departments
      locations
      jobFunctions
      sanitizers
    }
    carFilters {
      key
      name
      locations
      cars
      departments
    }
    materialFilters {
      key
      name
      locations
      cars
      departments
    }
    movableFilters {
      key
      name
      erpNo
      location
      status
      includeCompleted
      debitors
    }
    jobFilters {
      key
      name
      location
      personalOnly
    }
    machineFilters {
      name
      key
      status
      cases
      locations
      types
      unavailable
      hibernation
    }
    employeeHireStartDate
    employeeSalaryType
    managerFor
    proxy {
      id
      name
      email
    }
    proxyFor {
      id
      name
      email
    }
  }
}
    ${BaseUserFragmentFragmentDoc}
${BaseGdprFragmentFragmentDoc}`;

/**
 * __useGetWebCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetWebCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetWebCurrentUserQuery, GetWebCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWebCurrentUserQuery, GetWebCurrentUserQueryVariables>(GetWebCurrentUserDocument, options);
}
export function useGetWebCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebCurrentUserQuery, GetWebCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWebCurrentUserQuery, GetWebCurrentUserQueryVariables>(GetWebCurrentUserDocument, options);
}
export function useGetWebCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebCurrentUserQuery, GetWebCurrentUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetWebCurrentUserQuery, GetWebCurrentUserQueryVariables>(GetWebCurrentUserDocument, options);
}
export type GetWebCurrentUserQueryHookResult = ReturnType<typeof useGetWebCurrentUserQuery>;
export type GetWebCurrentUserLazyQueryHookResult = ReturnType<typeof useGetWebCurrentUserLazyQuery>;
export type GetWebCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetWebCurrentUserSuspenseQuery>;
export type GetWebCurrentUserQueryResult = Apollo.QueryResult<GetWebCurrentUserQuery, GetWebCurrentUserQueryVariables>;
export function refetchGetWebCurrentUserQuery(variables?: GetWebCurrentUserQueryVariables) {
  return { query: GetWebCurrentUserDocument, variables: variables }
}
export const RemoveUserCarFilterDocument = gql`
    mutation RemoveUserCarFilter($filterKey: String!) {
  removeUserVehicleFilter(filterKey: $filterKey) {
    id
    name
    email
    carFilters {
      key
      name
    }
  }
}
    `;
export type RemoveUserCarFilterMutationFn = Apollo.MutationFunction<RemoveUserCarFilterMutation, RemoveUserCarFilterMutationVariables>;

/**
 * __useRemoveUserCarFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserCarFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserCarFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserCarFilterMutation, { data, loading, error }] = useRemoveUserCarFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserCarFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserCarFilterMutation, RemoveUserCarFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserCarFilterMutation, RemoveUserCarFilterMutationVariables>(RemoveUserCarFilterDocument, options);
}
export type RemoveUserCarFilterMutationHookResult = ReturnType<typeof useRemoveUserCarFilterMutation>;
export type RemoveUserCarFilterMutationResult = Apollo.MutationResult<RemoveUserCarFilterMutation>;
export type RemoveUserCarFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserCarFilterMutation, RemoveUserCarFilterMutationVariables>;
export const RemoveUserCaseFilterDocument = gql`
    mutation RemoveUserCaseFilter($filterKey: String!) {
  removeUserCaseFilter(filterKey: $filterKey) {
    id
    name
    email
    caseFilters {
      key
      name
    }
  }
}
    `;
export type RemoveUserCaseFilterMutationFn = Apollo.MutationFunction<RemoveUserCaseFilterMutation, RemoveUserCaseFilterMutationVariables>;

/**
 * __useRemoveUserCaseFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserCaseFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserCaseFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserCaseFilterMutation, { data, loading, error }] = useRemoveUserCaseFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserCaseFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserCaseFilterMutation, RemoveUserCaseFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserCaseFilterMutation, RemoveUserCaseFilterMutationVariables>(RemoveUserCaseFilterDocument, options);
}
export type RemoveUserCaseFilterMutationHookResult = ReturnType<typeof useRemoveUserCaseFilterMutation>;
export type RemoveUserCaseFilterMutationResult = Apollo.MutationResult<RemoveUserCaseFilterMutation>;
export type RemoveUserCaseFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserCaseFilterMutation, RemoveUserCaseFilterMutationVariables>;
export const RemoveUserDrivingSlipFilterDocument = gql`
    mutation RemoveUserDrivingSlipFilter($filterKey: String!) {
  removeUserDrivingSlipFilter(filterKey: $filterKey) {
    id
    name
    email
    drivingSlipFilters {
      key
      name
    }
  }
}
    `;
export type RemoveUserDrivingSlipFilterMutationFn = Apollo.MutationFunction<RemoveUserDrivingSlipFilterMutation, RemoveUserDrivingSlipFilterMutationVariables>;

/**
 * __useRemoveUserDrivingSlipFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserDrivingSlipFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserDrivingSlipFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserDrivingSlipFilterMutation, { data, loading, error }] = useRemoveUserDrivingSlipFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserDrivingSlipFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserDrivingSlipFilterMutation, RemoveUserDrivingSlipFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserDrivingSlipFilterMutation, RemoveUserDrivingSlipFilterMutationVariables>(RemoveUserDrivingSlipFilterDocument, options);
}
export type RemoveUserDrivingSlipFilterMutationHookResult = ReturnType<typeof useRemoveUserDrivingSlipFilterMutation>;
export type RemoveUserDrivingSlipFilterMutationResult = Apollo.MutationResult<RemoveUserDrivingSlipFilterMutation>;
export type RemoveUserDrivingSlipFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserDrivingSlipFilterMutation, RemoveUserDrivingSlipFilterMutationVariables>;
export const RemoveUserDrivingSlipOverviewFilterDocument = gql`
    mutation RemoveUserDrivingSlipOverviewFilter($filterKey: String!) {
  removeUserDrivingSlipOverviewFilter(filterKey: $filterKey) {
    id
    name
    email
    drivingSlipOverviewFilters {
      key
      name
    }
  }
}
    `;
export type RemoveUserDrivingSlipOverviewFilterMutationFn = Apollo.MutationFunction<RemoveUserDrivingSlipOverviewFilterMutation, RemoveUserDrivingSlipOverviewFilterMutationVariables>;

/**
 * __useRemoveUserDrivingSlipOverviewFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserDrivingSlipOverviewFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserDrivingSlipOverviewFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserDrivingSlipOverviewFilterMutation, { data, loading, error }] = useRemoveUserDrivingSlipOverviewFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserDrivingSlipOverviewFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserDrivingSlipOverviewFilterMutation, RemoveUserDrivingSlipOverviewFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserDrivingSlipOverviewFilterMutation, RemoveUserDrivingSlipOverviewFilterMutationVariables>(RemoveUserDrivingSlipOverviewFilterDocument, options);
}
export type RemoveUserDrivingSlipOverviewFilterMutationHookResult = ReturnType<typeof useRemoveUserDrivingSlipOverviewFilterMutation>;
export type RemoveUserDrivingSlipOverviewFilterMutationResult = Apollo.MutationResult<RemoveUserDrivingSlipOverviewFilterMutation>;
export type RemoveUserDrivingSlipOverviewFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserDrivingSlipOverviewFilterMutation, RemoveUserDrivingSlipOverviewFilterMutationVariables>;
export const RemoveUserJobFilterDocument = gql`
    mutation RemoveUserJobFilter($filterKey: String!) {
  removeUserJobFilter(filterKey: $filterKey) {
    id
    name
    email
    jobFilters {
      key
      name
    }
  }
}
    `;
export type RemoveUserJobFilterMutationFn = Apollo.MutationFunction<RemoveUserJobFilterMutation, RemoveUserJobFilterMutationVariables>;

/**
 * __useRemoveUserJobFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserJobFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserJobFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserJobFilterMutation, { data, loading, error }] = useRemoveUserJobFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserJobFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserJobFilterMutation, RemoveUserJobFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserJobFilterMutation, RemoveUserJobFilterMutationVariables>(RemoveUserJobFilterDocument, options);
}
export type RemoveUserJobFilterMutationHookResult = ReturnType<typeof useRemoveUserJobFilterMutation>;
export type RemoveUserJobFilterMutationResult = Apollo.MutationResult<RemoveUserJobFilterMutation>;
export type RemoveUserJobFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserJobFilterMutation, RemoveUserJobFilterMutationVariables>;
export const RemoveUserMachineFilterDocument = gql`
    mutation RemoveUserMachineFilter($filterKey: String!) {
  removeUserMachineFilter(filterKey: $filterKey) {
    id
    name
    email
    machineFilters {
      key
      name
    }
  }
}
    `;
export type RemoveUserMachineFilterMutationFn = Apollo.MutationFunction<RemoveUserMachineFilterMutation, RemoveUserMachineFilterMutationVariables>;

/**
 * __useRemoveUserMachineFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserMachineFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMachineFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMachineFilterMutation, { data, loading, error }] = useRemoveUserMachineFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserMachineFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMachineFilterMutation, RemoveUserMachineFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserMachineFilterMutation, RemoveUserMachineFilterMutationVariables>(RemoveUserMachineFilterDocument, options);
}
export type RemoveUserMachineFilterMutationHookResult = ReturnType<typeof useRemoveUserMachineFilterMutation>;
export type RemoveUserMachineFilterMutationResult = Apollo.MutationResult<RemoveUserMachineFilterMutation>;
export type RemoveUserMachineFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserMachineFilterMutation, RemoveUserMachineFilterMutationVariables>;
export const RemoveUserMaterialFilterDocument = gql`
    mutation RemoveUserMaterialFilter($filterKey: String!) {
  removeUserMaterialFilter(filterKey: $filterKey) {
    id
    name
    email
    materialFilters {
      key
      name
    }
  }
}
    `;
export type RemoveUserMaterialFilterMutationFn = Apollo.MutationFunction<RemoveUserMaterialFilterMutation, RemoveUserMaterialFilterMutationVariables>;

/**
 * __useRemoveUserMaterialFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserMaterialFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMaterialFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMaterialFilterMutation, { data, loading, error }] = useRemoveUserMaterialFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserMaterialFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMaterialFilterMutation, RemoveUserMaterialFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserMaterialFilterMutation, RemoveUserMaterialFilterMutationVariables>(RemoveUserMaterialFilterDocument, options);
}
export type RemoveUserMaterialFilterMutationHookResult = ReturnType<typeof useRemoveUserMaterialFilterMutation>;
export type RemoveUserMaterialFilterMutationResult = Apollo.MutationResult<RemoveUserMaterialFilterMutation>;
export type RemoveUserMaterialFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserMaterialFilterMutation, RemoveUserMaterialFilterMutationVariables>;
export const RemoveUserMovableFilterDocument = gql`
    mutation RemoveUserMovableFilter($filterKey: String!) {
  removeUserMovableFilter(filterKey: $filterKey) {
    id
    name
    email
    movableFilters {
      key
      name
    }
  }
}
    `;
export type RemoveUserMovableFilterMutationFn = Apollo.MutationFunction<RemoveUserMovableFilterMutation, RemoveUserMovableFilterMutationVariables>;

/**
 * __useRemoveUserMovableFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserMovableFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMovableFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMovableFilterMutation, { data, loading, error }] = useRemoveUserMovableFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserMovableFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMovableFilterMutation, RemoveUserMovableFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserMovableFilterMutation, RemoveUserMovableFilterMutationVariables>(RemoveUserMovableFilterDocument, options);
}
export type RemoveUserMovableFilterMutationHookResult = ReturnType<typeof useRemoveUserMovableFilterMutation>;
export type RemoveUserMovableFilterMutationResult = Apollo.MutationResult<RemoveUserMovableFilterMutation>;
export type RemoveUserMovableFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserMovableFilterMutation, RemoveUserMovableFilterMutationVariables>;
export const RemoveUserSanitizerFilterDocument = gql`
    mutation RemoveUserSanitizerFilter($filterKey: String!) {
  removeUserSanitizerFilter(filterKey: $filterKey) {
    id
    name
    sanitizerFilters {
      key
      name
      departments
      locations
      jobFunctions
      sanitizers
    }
  }
}
    `;
export type RemoveUserSanitizerFilterMutationFn = Apollo.MutationFunction<RemoveUserSanitizerFilterMutation, RemoveUserSanitizerFilterMutationVariables>;

/**
 * __useRemoveUserSanitizerFilterMutation__
 *
 * To run a mutation, you first call `useRemoveUserSanitizerFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserSanitizerFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserSanitizerFilterMutation, { data, loading, error }] = useRemoveUserSanitizerFilterMutation({
 *   variables: {
 *      filterKey: // value for 'filterKey'
 *   },
 * });
 */
export function useRemoveUserSanitizerFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserSanitizerFilterMutation, RemoveUserSanitizerFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveUserSanitizerFilterMutation, RemoveUserSanitizerFilterMutationVariables>(RemoveUserSanitizerFilterDocument, options);
}
export type RemoveUserSanitizerFilterMutationHookResult = ReturnType<typeof useRemoveUserSanitizerFilterMutation>;
export type RemoveUserSanitizerFilterMutationResult = Apollo.MutationResult<RemoveUserSanitizerFilterMutation>;
export type RemoveUserSanitizerFilterMutationOptions = Apollo.BaseMutationOptions<RemoveUserSanitizerFilterMutation, RemoveUserSanitizerFilterMutationVariables>;
export const SearchWebUsersDocument = gql`
    query SearchWebUsers($searchText: String!, $onlyEmployees: Boolean, $checkInBc: Boolean) {
  searchUsers(
    searchText: $searchText
    onlyEmployees: $onlyEmployees
    checkInBc: $checkInBc
  ) {
    ...BaseUserFragment
    employeeHireStartDate
    employeeSalaryType
  }
}
    ${BaseUserFragmentFragmentDoc}`;

/**
 * __useSearchWebUsersQuery__
 *
 * To run a query within a React component, call `useSearchWebUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWebUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWebUsersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      onlyEmployees: // value for 'onlyEmployees'
 *      checkInBc: // value for 'checkInBc'
 *   },
 * });
 */
export function useSearchWebUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchWebUsersQuery, SearchWebUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchWebUsersQuery, SearchWebUsersQueryVariables>(SearchWebUsersDocument, options);
}
export function useSearchWebUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchWebUsersQuery, SearchWebUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchWebUsersQuery, SearchWebUsersQueryVariables>(SearchWebUsersDocument, options);
}
export function useSearchWebUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchWebUsersQuery, SearchWebUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchWebUsersQuery, SearchWebUsersQueryVariables>(SearchWebUsersDocument, options);
}
export type SearchWebUsersQueryHookResult = ReturnType<typeof useSearchWebUsersQuery>;
export type SearchWebUsersLazyQueryHookResult = ReturnType<typeof useSearchWebUsersLazyQuery>;
export type SearchWebUsersSuspenseQueryHookResult = ReturnType<typeof useSearchWebUsersSuspenseQuery>;
export type SearchWebUsersQueryResult = Apollo.QueryResult<SearchWebUsersQuery, SearchWebUsersQueryVariables>;
export function refetchSearchWebUsersQuery(variables: SearchWebUsersQueryVariables) {
  return { query: SearchWebUsersDocument, variables: variables }
}
export const SetUserCarFilterDocument = gql`
    mutation SetUserCarFilter($filter: UserVehicleFilterInput!) {
  setUserVehicleFilter(filter: $filter) {
    id
    name
    carFilters {
      key
      name
      locations
      cars
    }
  }
}
    `;
export type SetUserCarFilterMutationFn = Apollo.MutationFunction<SetUserCarFilterMutation, SetUserCarFilterMutationVariables>;

/**
 * __useSetUserCarFilterMutation__
 *
 * To run a mutation, you first call `useSetUserCarFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserCarFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserCarFilterMutation, { data, loading, error }] = useSetUserCarFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserCarFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserCarFilterMutation, SetUserCarFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserCarFilterMutation, SetUserCarFilterMutationVariables>(SetUserCarFilterDocument, options);
}
export type SetUserCarFilterMutationHookResult = ReturnType<typeof useSetUserCarFilterMutation>;
export type SetUserCarFilterMutationResult = Apollo.MutationResult<SetUserCarFilterMutation>;
export type SetUserCarFilterMutationOptions = Apollo.BaseMutationOptions<SetUserCarFilterMutation, SetUserCarFilterMutationVariables>;
export const SetUserCaseFilterDocument = gql`
    mutation SetUserCaseFilter($filter: UserCaseFilterInput!) {
  setUserCaseFilter(filter: $filter) {
    id
    name
    caseFilters {
      key
      name
      view
      awaiting
      damageServiceCompleted
      calledBack
      machinesOnCase
      showEconomyField
      showBusinessAreaField
      showAppliedClosedCases
      showClosedCases
      debitors
      postalCodeText
      postalCodes
      track
      departments
      locations
      damageCategories
      damageCauses
      priority
      caseManagers
      projectManagers
      areaResponsibles
      createdBy
    }
  }
}
    `;
export type SetUserCaseFilterMutationFn = Apollo.MutationFunction<SetUserCaseFilterMutation, SetUserCaseFilterMutationVariables>;

/**
 * __useSetUserCaseFilterMutation__
 *
 * To run a mutation, you first call `useSetUserCaseFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserCaseFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserCaseFilterMutation, { data, loading, error }] = useSetUserCaseFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserCaseFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserCaseFilterMutation, SetUserCaseFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserCaseFilterMutation, SetUserCaseFilterMutationVariables>(SetUserCaseFilterDocument, options);
}
export type SetUserCaseFilterMutationHookResult = ReturnType<typeof useSetUserCaseFilterMutation>;
export type SetUserCaseFilterMutationResult = Apollo.MutationResult<SetUserCaseFilterMutation>;
export type SetUserCaseFilterMutationOptions = Apollo.BaseMutationOptions<SetUserCaseFilterMutation, SetUserCaseFilterMutationVariables>;
export const SetUserDrivingSlipFilterDocument = gql`
    mutation SetUserDrivingSlipFilter($filter: UserDrivingSlipFilterInput!) {
  setUserDrivingSlipFilter(filter: $filter) {
    id
    name
    drivingSlipFilters {
      key
      name
      debitors
      postalCodeText
      postalCodes
      departments
      locations
      damageCategories
      damageCauses
      erpNos
      projectManagers
      drivingSlipCategories
    }
  }
}
    `;
export type SetUserDrivingSlipFilterMutationFn = Apollo.MutationFunction<SetUserDrivingSlipFilterMutation, SetUserDrivingSlipFilterMutationVariables>;

/**
 * __useSetUserDrivingSlipFilterMutation__
 *
 * To run a mutation, you first call `useSetUserDrivingSlipFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserDrivingSlipFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserDrivingSlipFilterMutation, { data, loading, error }] = useSetUserDrivingSlipFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserDrivingSlipFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserDrivingSlipFilterMutation, SetUserDrivingSlipFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserDrivingSlipFilterMutation, SetUserDrivingSlipFilterMutationVariables>(SetUserDrivingSlipFilterDocument, options);
}
export type SetUserDrivingSlipFilterMutationHookResult = ReturnType<typeof useSetUserDrivingSlipFilterMutation>;
export type SetUserDrivingSlipFilterMutationResult = Apollo.MutationResult<SetUserDrivingSlipFilterMutation>;
export type SetUserDrivingSlipFilterMutationOptions = Apollo.BaseMutationOptions<SetUserDrivingSlipFilterMutation, SetUserDrivingSlipFilterMutationVariables>;
export const SetUserDrivingSlipOverviewFilterDocument = gql`
    mutation SetUserDrivingSlipOverviewFilter($filter: UserDrivingSlipOverviewFilterInput!) {
  setUserDrivingSlipOverviewFilter(filter: $filter) {
    id
    name
    drivingSlipOverviewFilters {
      key
      name
      status
      urgent
      exceeded
      departments
      locations
      damageCauses
      damageCategories
      drivers
      noDriver
    }
  }
}
    `;
export type SetUserDrivingSlipOverviewFilterMutationFn = Apollo.MutationFunction<SetUserDrivingSlipOverviewFilterMutation, SetUserDrivingSlipOverviewFilterMutationVariables>;

/**
 * __useSetUserDrivingSlipOverviewFilterMutation__
 *
 * To run a mutation, you first call `useSetUserDrivingSlipOverviewFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserDrivingSlipOverviewFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserDrivingSlipOverviewFilterMutation, { data, loading, error }] = useSetUserDrivingSlipOverviewFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserDrivingSlipOverviewFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserDrivingSlipOverviewFilterMutation, SetUserDrivingSlipOverviewFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserDrivingSlipOverviewFilterMutation, SetUserDrivingSlipOverviewFilterMutationVariables>(SetUserDrivingSlipOverviewFilterDocument, options);
}
export type SetUserDrivingSlipOverviewFilterMutationHookResult = ReturnType<typeof useSetUserDrivingSlipOverviewFilterMutation>;
export type SetUserDrivingSlipOverviewFilterMutationResult = Apollo.MutationResult<SetUserDrivingSlipOverviewFilterMutation>;
export type SetUserDrivingSlipOverviewFilterMutationOptions = Apollo.BaseMutationOptions<SetUserDrivingSlipOverviewFilterMutation, SetUserDrivingSlipOverviewFilterMutationVariables>;
export const SetUserJobFilterDocument = gql`
    mutation SetUserJobFilter($filter: UserJobFilterInput!) {
  setUserJobFilter(filter: $filter) {
    id
    name
    jobFilters {
      key
      name
      location
      personalOnly
    }
  }
}
    `;
export type SetUserJobFilterMutationFn = Apollo.MutationFunction<SetUserJobFilterMutation, SetUserJobFilterMutationVariables>;

/**
 * __useSetUserJobFilterMutation__
 *
 * To run a mutation, you first call `useSetUserJobFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserJobFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserJobFilterMutation, { data, loading, error }] = useSetUserJobFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserJobFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserJobFilterMutation, SetUserJobFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserJobFilterMutation, SetUserJobFilterMutationVariables>(SetUserJobFilterDocument, options);
}
export type SetUserJobFilterMutationHookResult = ReturnType<typeof useSetUserJobFilterMutation>;
export type SetUserJobFilterMutationResult = Apollo.MutationResult<SetUserJobFilterMutation>;
export type SetUserJobFilterMutationOptions = Apollo.BaseMutationOptions<SetUserJobFilterMutation, SetUserJobFilterMutationVariables>;
export const SetUserMachineFilterDocument = gql`
    mutation SetUserMachineFilter($filter: UserMachineFilterInput!) {
  setUserMachineFilter(filter: $filter) {
    id
    name
    machineFilters {
      key
      name
      status
      cases
      locations
      types
      unavailable
      hibernation
    }
  }
}
    `;
export type SetUserMachineFilterMutationFn = Apollo.MutationFunction<SetUserMachineFilterMutation, SetUserMachineFilterMutationVariables>;

/**
 * __useSetUserMachineFilterMutation__
 *
 * To run a mutation, you first call `useSetUserMachineFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserMachineFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserMachineFilterMutation, { data, loading, error }] = useSetUserMachineFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserMachineFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserMachineFilterMutation, SetUserMachineFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserMachineFilterMutation, SetUserMachineFilterMutationVariables>(SetUserMachineFilterDocument, options);
}
export type SetUserMachineFilterMutationHookResult = ReturnType<typeof useSetUserMachineFilterMutation>;
export type SetUserMachineFilterMutationResult = Apollo.MutationResult<SetUserMachineFilterMutation>;
export type SetUserMachineFilterMutationOptions = Apollo.BaseMutationOptions<SetUserMachineFilterMutation, SetUserMachineFilterMutationVariables>;
export const SetUserMaterialFilterDocument = gql`
    mutation SetUserMaterialFilter($filter: UserVehicleFilterInput!) {
  setUserMaterialFilter(filter: $filter) {
    id
    name
    materialFilters {
      key
      name
      locations
      cars
    }
  }
}
    `;
export type SetUserMaterialFilterMutationFn = Apollo.MutationFunction<SetUserMaterialFilterMutation, SetUserMaterialFilterMutationVariables>;

/**
 * __useSetUserMaterialFilterMutation__
 *
 * To run a mutation, you first call `useSetUserMaterialFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserMaterialFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserMaterialFilterMutation, { data, loading, error }] = useSetUserMaterialFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserMaterialFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserMaterialFilterMutation, SetUserMaterialFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserMaterialFilterMutation, SetUserMaterialFilterMutationVariables>(SetUserMaterialFilterDocument, options);
}
export type SetUserMaterialFilterMutationHookResult = ReturnType<typeof useSetUserMaterialFilterMutation>;
export type SetUserMaterialFilterMutationResult = Apollo.MutationResult<SetUserMaterialFilterMutation>;
export type SetUserMaterialFilterMutationOptions = Apollo.BaseMutationOptions<SetUserMaterialFilterMutation, SetUserMaterialFilterMutationVariables>;
export const SetUserMovableFilterDocument = gql`
    mutation SetUserMovableFilter($filter: UserMovableFilterInput!) {
  setUserMovableFilter(filter: $filter) {
    id
    name
    movableFilters {
      key
      name
      erpNo
      location
      status
      includeCompleted
      debitors
    }
  }
}
    `;
export type SetUserMovableFilterMutationFn = Apollo.MutationFunction<SetUserMovableFilterMutation, SetUserMovableFilterMutationVariables>;

/**
 * __useSetUserMovableFilterMutation__
 *
 * To run a mutation, you first call `useSetUserMovableFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserMovableFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserMovableFilterMutation, { data, loading, error }] = useSetUserMovableFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserMovableFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserMovableFilterMutation, SetUserMovableFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserMovableFilterMutation, SetUserMovableFilterMutationVariables>(SetUserMovableFilterDocument, options);
}
export type SetUserMovableFilterMutationHookResult = ReturnType<typeof useSetUserMovableFilterMutation>;
export type SetUserMovableFilterMutationResult = Apollo.MutationResult<SetUserMovableFilterMutation>;
export type SetUserMovableFilterMutationOptions = Apollo.BaseMutationOptions<SetUserMovableFilterMutation, SetUserMovableFilterMutationVariables>;
export const SetUserPlannerHelpTextDocument = gql`
    mutation SetUserPlannerHelpText($id: String!, $helpText: String!) {
  setUserPlannerHelpText(id: $id, helpText: $helpText) {
    id
    plannerHelpText
  }
}
    `;
export type SetUserPlannerHelpTextMutationFn = Apollo.MutationFunction<SetUserPlannerHelpTextMutation, SetUserPlannerHelpTextMutationVariables>;

/**
 * __useSetUserPlannerHelpTextMutation__
 *
 * To run a mutation, you first call `useSetUserPlannerHelpTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPlannerHelpTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPlannerHelpTextMutation, { data, loading, error }] = useSetUserPlannerHelpTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *      helpText: // value for 'helpText'
 *   },
 * });
 */
export function useSetUserPlannerHelpTextMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPlannerHelpTextMutation, SetUserPlannerHelpTextMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserPlannerHelpTextMutation, SetUserPlannerHelpTextMutationVariables>(SetUserPlannerHelpTextDocument, options);
}
export type SetUserPlannerHelpTextMutationHookResult = ReturnType<typeof useSetUserPlannerHelpTextMutation>;
export type SetUserPlannerHelpTextMutationResult = Apollo.MutationResult<SetUserPlannerHelpTextMutation>;
export type SetUserPlannerHelpTextMutationOptions = Apollo.BaseMutationOptions<SetUserPlannerHelpTextMutation, SetUserPlannerHelpTextMutationVariables>;
export const SetUserSanitizerFilterDocument = gql`
    mutation SetUserSanitizerFilter($filter: UserSanitizerFilterInput!) {
  setUserSanitizerFilter(filter: $filter) {
    id
    name
    sanitizerFilters {
      key
      name
      departments
      locations
      jobFunctions
      sanitizers
    }
  }
}
    `;
export type SetUserSanitizerFilterMutationFn = Apollo.MutationFunction<SetUserSanitizerFilterMutation, SetUserSanitizerFilterMutationVariables>;

/**
 * __useSetUserSanitizerFilterMutation__
 *
 * To run a mutation, you first call `useSetUserSanitizerFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserSanitizerFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserSanitizerFilterMutation, { data, loading, error }] = useSetUserSanitizerFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSetUserSanitizerFilterMutation(baseOptions?: Apollo.MutationHookOptions<SetUserSanitizerFilterMutation, SetUserSanitizerFilterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetUserSanitizerFilterMutation, SetUserSanitizerFilterMutationVariables>(SetUserSanitizerFilterDocument, options);
}
export type SetUserSanitizerFilterMutationHookResult = ReturnType<typeof useSetUserSanitizerFilterMutation>;
export type SetUserSanitizerFilterMutationResult = Apollo.MutationResult<SetUserSanitizerFilterMutation>;
export type SetUserSanitizerFilterMutationOptions = Apollo.BaseMutationOptions<SetUserSanitizerFilterMutation, SetUserSanitizerFilterMutationVariables>;
export const GetCauseQuestionsDocument = gql`
    query GetCauseQuestions($damageCause: String!) {
  causeQuestions(damageCause: $damageCause) {
    ...BaseVisitationQuestionFragment
  }
}
    ${BaseVisitationQuestionFragmentFragmentDoc}`;

/**
 * __useGetCauseQuestionsQuery__
 *
 * To run a query within a React component, call `useGetCauseQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCauseQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCauseQuestionsQuery({
 *   variables: {
 *      damageCause: // value for 'damageCause'
 *   },
 * });
 */
export function useGetCauseQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetCauseQuestionsQuery, GetCauseQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCauseQuestionsQuery, GetCauseQuestionsQueryVariables>(GetCauseQuestionsDocument, options);
}
export function useGetCauseQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCauseQuestionsQuery, GetCauseQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCauseQuestionsQuery, GetCauseQuestionsQueryVariables>(GetCauseQuestionsDocument, options);
}
export function useGetCauseQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCauseQuestionsQuery, GetCauseQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCauseQuestionsQuery, GetCauseQuestionsQueryVariables>(GetCauseQuestionsDocument, options);
}
export type GetCauseQuestionsQueryHookResult = ReturnType<typeof useGetCauseQuestionsQuery>;
export type GetCauseQuestionsLazyQueryHookResult = ReturnType<typeof useGetCauseQuestionsLazyQuery>;
export type GetCauseQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetCauseQuestionsSuspenseQuery>;
export type GetCauseQuestionsQueryResult = Apollo.QueryResult<GetCauseQuestionsQuery, GetCauseQuestionsQueryVariables>;
export function refetchGetCauseQuestionsQuery(variables: GetCauseQuestionsQueryVariables) {
  return { query: GetCauseQuestionsDocument, variables: variables }
}